var AC = Object.defineProperty;
var OC = (t, e, n) => e in t ? AC(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var pa = (t, e, n) => (OC(t, typeof e != "symbol" ? e + "" : e, n), n);
import * as T from "react";
import he, { useRef as vt, useCallback as Oe, useEffect as ce, useMemo as Yt, useDebugValue as DC, createContext as ui, useLayoutEffect as Ds, useContext as Ii, cloneElement as Wo, isValidElement as di, createElement as ko, Fragment as X2, forwardRef as ze, useState as Dt, Children as zn, useReducer as PC, memo as RC } from "react";
import * as LC from "react-dom";
import $C, { createPortal as Wg, flushSync as J2 } from "react-dom";
function Da(t, e) {
  setTimeout(() => {
    var i;
    const n = t.workspaces[e.workspaceId].composers[e.threadId][e.eventId], { editor: r } = n;
    r || console.warn("[CollabKit] no editor to focus"), (i = r == null ? void 0 : r._rootElement) == null || i.focus();
  }, 100);
}
function Bl(t, e) {
  t.viewingId = e.target;
}
function Z2(t, e) {
  var v, b;
  const { appId: n } = t.config, { userId: r } = t;
  if (!r)
    throw new Error("CollabKit: no userId set");
  const { x: i, y: o, objectId: a } = e, { composerId: s } = t;
  if (!s)
    throw new Error("CollabKit: no composerId set");
  const { type: l, ...f } = s, { threadId: c, workspaceId: u, eventId: d } = f, h = t.sync.nextPinId({ appId: n, ...f, objectId: a }), p = t.workspaces[u].composers[c][d], m = {
    type: "pin",
    x: i,
    y: o,
    objectId: a,
    meta: ((b = (v = t.callbacks) == null ? void 0 : v.onPinAttach) == null ? void 0 : b.call(v, { objectId: a, userId: r, threadId: c, workspaceId: u })) ?? null,
    pending: !0
  };
  return p.attachments[h] = m, t.uiState = "idle", t.composerId ? Da(t, t.composerId) : console.warn("no composer to focus"), setTimeout(() => {
    Bl(t, {
      target: { type: "pin", objectId: a, id: h, threadId: c, workspaceId: u, eventId: d }
    });
  }, 100), h;
}
const Ug = "delete-";
function ec(t) {
  const e = /* @__PURE__ */ new Set();
  for (const n of Object.keys(t)) {
    const r = t[n];
    r.type === "delete" && r.parentId && e.add(r.parentId);
  }
  return e;
}
function eb(t) {
  const n = Object.keys(t).map((a) => ({
    ...t[a],
    id: a
  })), r = ec(t), i = n.filter(
    (a) => !r.has(a.id) && a.type === "message"
  );
  let o = -1;
  return i.forEach((a, s) => {
    const l = i[o];
    o = s, l && l.createdById === a.createdById && typeof l.createdAt == "number" && typeof a.createdAt == "number" && l.createdAt + 1e3 * 60 * 5 > a.createdAt || (a.showHeader = !0);
  }), i;
}
function FC(t) {
  return Object.keys(t).map((i) => ({
    ...t[i],
    id: i
  })).filter((i) => i.type === "reaction").reduce((i, o) => {
    const { parentId: a, body: s, createdById: l } = o;
    if (!a || o.type !== "reaction")
      return i;
    i[a] || (i[a] = {});
    const f = s.startsWith(Ug), c = f ? o.body.split(Ug)[1] : o.body, u = i[a];
    if (u[c] || (u[c] = { count: 0, userIds: [] }), f) {
      u[c].count--;
      const d = u[c].userIds.findIndex((h) => h === l);
      u[c].userIds.splice(d, 1);
    } else
      u[c].count++, u[c].userIds.push(l);
    return u[c].count <= 0 && delete u[c], i;
  }, {});
}
function jC(t) {
  const e = t ? Object.keys(t).filter(
    (n) => t[n].type === "system" && t[n].system === "resolve" || t[n].system === "reopen"
  ) : [];
  return !!(t && e.length > 0 && t[e[e.length - 1]].system === "resolve");
}
function zC(t) {
  if (!t)
    return 0;
  const e = Object.keys(t), n = ec(t);
  return e.filter(
    (o) => !n.has(o) && t[o].type === "message"
  ).length - 1;
}
function BC(t, e) {
  if (!t[e])
    return null;
  const r = Object.keys(t).reverse();
  for (const i of r) {
    const o = t[i];
    if (o.type === "edit" && o.parentId === e)
      return o;
  }
  return null;
}
function ln(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function lt(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function at(t) {
  lt(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}
function WC(t, e) {
  lt(2, arguments);
  var n = at(t).getTime(), r = ln(e);
  return new Date(n + r);
}
function Id(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
function UC(t, e) {
  lt(2, arguments);
  var n = at(t), r = at(e), i = n.getTime() - r.getTime();
  return i < 0 ? -1 : i > 0 ? 1 : i;
}
function HC(t) {
  return lt(1, arguments), t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function VC(t) {
  if (lt(1, arguments), !HC(t) && typeof t != "number")
    return !1;
  var e = at(t);
  return !isNaN(Number(e));
}
var KC = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, YC = function(t, e, n) {
  var r, i = KC[t];
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : r = i.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
const qC = YC;
function _u(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var GC = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, QC = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, XC = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, JC = {
  date: _u({
    formats: GC,
    defaultWidth: "full"
  }),
  time: _u({
    formats: QC,
    defaultWidth: "full"
  }),
  dateTime: _u({
    formats: XC,
    defaultWidth: "full"
  })
};
const ZC = JC;
var ex = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, tx = function(t, e, n, r) {
  return ex[t];
};
const nx = tx;
function ma(t) {
  return function(e, n) {
    var r = n || {}, i = r.context ? String(r.context) : "standalone", o;
    if (i === "formatting" && t.formattingValues) {
      var a = t.defaultFormattingWidth || t.defaultWidth, s = r.width ? String(r.width) : a;
      o = t.formattingValues[s] || t.formattingValues[a];
    } else {
      var l = t.defaultWidth, f = r.width ? String(r.width) : t.defaultWidth;
      o = t.values[f] || t.values[l];
    }
    var c = t.argumentCallback ? t.argumentCallback(e) : e;
    return o[c];
  };
}
var rx = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, ix = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ox = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, ax = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, sx = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, lx = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, fx = function(t, e) {
  var n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, cx = {
  ordinalNumber: fx,
  era: ma({
    values: rx,
    defaultWidth: "wide"
  }),
  quarter: ma({
    values: ix,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: ma({
    values: ox,
    defaultWidth: "wide"
  }),
  day: ma({
    values: ax,
    defaultWidth: "wide"
  }),
  dayPeriod: ma({
    values: sx,
    defaultWidth: "wide",
    formattingValues: lx,
    defaultFormattingWidth: "wide"
  })
};
const ux = cx;
function va(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], o = e.match(i);
    if (!o)
      return null;
    var a = o[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? hx(s, function(u) {
      return u.test(a);
    }) : dx(s, function(u) {
      return u.test(a);
    }), f;
    f = t.valueCallback ? t.valueCallback(l) : l, f = n.valueCallback ? n.valueCallback(f) : f;
    var c = e.slice(a.length);
    return {
      value: f,
      rest: c
    };
  };
}
function dx(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function hx(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function gx(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r)
      return null;
    var i = r[0], o = e.match(t.parsePattern);
    if (!o)
      return null;
    var a = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    var s = e.slice(i.length);
    return {
      value: a,
      rest: s
    };
  };
}
var px = /^(\d+)(th|st|nd|rd)?/i, mx = /\d+/i, vx = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, bx = {
  any: [/^b/i, /^(a|c)/i]
}, yx = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, _x = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wx = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, kx = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Cx = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, xx = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ex = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Tx = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Sx = {
  ordinalNumber: gx({
    matchPattern: px,
    parsePattern: mx,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: va({
    matchPatterns: vx,
    defaultMatchWidth: "wide",
    parsePatterns: bx,
    defaultParseWidth: "any"
  }),
  quarter: va({
    matchPatterns: yx,
    defaultMatchWidth: "wide",
    parsePatterns: _x,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: va({
    matchPatterns: wx,
    defaultMatchWidth: "wide",
    parsePatterns: kx,
    defaultParseWidth: "any"
  }),
  day: va({
    matchPatterns: Cx,
    defaultMatchWidth: "wide",
    parsePatterns: xx,
    defaultParseWidth: "any"
  }),
  dayPeriod: va({
    matchPatterns: Ex,
    defaultMatchWidth: "any",
    parsePatterns: Tx,
    defaultParseWidth: "any"
  })
};
const Ix = Sx;
var Nx = {
  code: "en-US",
  formatDistance: qC,
  formatLong: ZC,
  formatRelative: nx,
  localize: ux,
  match: Ix,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Wl = Nx;
function Mx(t, e) {
  lt(2, arguments);
  var n = ln(e);
  return WC(t, -n);
}
var Ax = 864e5;
function Ox(t) {
  lt(1, arguments);
  var e = at(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), i = n - r;
  return Math.floor(i / Ax) + 1;
}
function Ul(t) {
  lt(1, arguments);
  var e = 1, n = at(t), r = n.getUTCDay(), i = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function tb(t) {
  lt(1, arguments);
  var e = at(t), n = e.getUTCFullYear(), r = new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = Ul(r), o = new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var a = Ul(o);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= a.getTime() ? n : n - 1;
}
function Dx(t) {
  lt(1, arguments);
  var e = tb(t), n = new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Ul(n);
  return r;
}
var Px = 6048e5;
function Rx(t) {
  lt(1, arguments);
  var e = at(t), n = Ul(e).getTime() - Dx(e).getTime();
  return Math.round(n / Px) + 1;
}
function Hl(t, e) {
  lt(1, arguments);
  var n = e || {}, r = n.locale, i = r && r.options && r.options.weekStartsOn, o = i == null ? 0 : ln(i), a = n.weekStartsOn == null ? o : ln(n.weekStartsOn);
  if (!(a >= 0 && a <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = at(t), l = s.getUTCDay(), f = (l < a ? 7 : 0) + l - a;
  return s.setUTCDate(s.getUTCDate() - f), s.setUTCHours(0, 0, 0, 0), s;
}
function nb(t, e) {
  lt(1, arguments);
  var n = at(t), r = n.getUTCFullYear(), i = e || {}, o = i.locale, a = o && o.options && o.options.firstWeekContainsDate, s = a == null ? 1 : ln(a), l = i.firstWeekContainsDate == null ? s : ln(i.firstWeekContainsDate);
  if (!(l >= 1 && l <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var f = new Date(0);
  f.setUTCFullYear(r + 1, 0, l), f.setUTCHours(0, 0, 0, 0);
  var c = Hl(f, e), u = new Date(0);
  u.setUTCFullYear(r, 0, l), u.setUTCHours(0, 0, 0, 0);
  var d = Hl(u, e);
  return n.getTime() >= c.getTime() ? r + 1 : n.getTime() >= d.getTime() ? r : r - 1;
}
function Lx(t, e) {
  lt(1, arguments);
  var n = e || {}, r = n.locale, i = r && r.options && r.options.firstWeekContainsDate, o = i == null ? 1 : ln(i), a = n.firstWeekContainsDate == null ? o : ln(n.firstWeekContainsDate), s = nb(t, e), l = new Date(0);
  l.setUTCFullYear(s, 0, a), l.setUTCHours(0, 0, 0, 0);
  var f = Hl(l, e);
  return f;
}
var $x = 6048e5;
function Fx(t, e) {
  lt(1, arguments);
  var n = at(t), r = Hl(n, e).getTime() - Lx(n, e).getTime();
  return Math.round(r / $x) + 1;
}
function be(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var jx = {
  // Year
  y: function(t, e) {
    var n = t.getUTCFullYear(), r = n > 0 ? n : 1 - n;
    return be(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M: function(t, e) {
    var n = t.getUTCMonth();
    return e === "M" ? String(n + 1) : be(n + 1, 2);
  },
  // Day of the month
  d: function(t, e) {
    return be(t.getUTCDate(), e.length);
  },
  // AM or PM
  a: function(t, e) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, e) {
    return be(t.getUTCHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H: function(t, e) {
    return be(t.getUTCHours(), e.length);
  },
  // Minute
  m: function(t, e) {
    return be(t.getUTCMinutes(), e.length);
  },
  // Second
  s: function(t, e) {
    return be(t.getUTCSeconds(), e.length);
  },
  // Fraction of second
  S: function(t, e) {
    var n = e.length, r = t.getUTCMilliseconds(), i = Math.floor(r * Math.pow(10, n - 3));
    return be(i, e.length);
  }
};
const vr = jx;
var eo = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, zx = {
  // Era
  G: function(t, e, n) {
    var r = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(r, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(r, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      var r = t.getUTCFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, {
        unit: "year"
      });
    }
    return vr.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    var i = nb(t, r), o = i > 0 ? i : 1 - i;
    if (e === "YY") {
      var a = o % 100;
      return be(a, 2);
    }
    return e === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : be(o, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    var n = tb(t);
    return be(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    var n = t.getUTCFullYear();
    return be(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    var r = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(r);
      case "QQ":
        return be(r, 2);
      case "Qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    var r = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(r);
      case "qq":
        return be(r, 2);
      case "qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    var r = t.getUTCMonth();
    switch (e) {
      case "M":
      case "MM":
        return vr.M(t, e);
      case "Mo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    var r = t.getUTCMonth();
    switch (e) {
      case "L":
        return String(r + 1);
      case "LL":
        return be(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    var i = Fx(t, r);
    return e === "wo" ? n.ordinalNumber(i, {
      unit: "week"
    }) : be(i, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    var r = Rx(t);
    return e === "Io" ? n.ordinalNumber(r, {
      unit: "week"
    }) : be(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : vr.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    var r = Ox(t);
    return e === "Do" ? n.ordinalNumber(r, {
      unit: "dayOfYear"
    }) : be(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    var r = t.getUTCDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    var i = t.getUTCDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(o);
      case "ee":
        return be(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    var i = t.getUTCDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(o);
      case "cc":
        return be(o, e.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    var r = t.getUTCDay(), i = r === 0 ? 7 : r;
    switch (e) {
      case "i":
        return String(i);
      case "ii":
        return be(i, e.length);
      case "io":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    var r = t.getUTCHours(), i = r / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    var r = t.getUTCHours(), i;
    switch (r === 12 ? i = eo.noon : r === 0 ? i = eo.midnight : i = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    var r = t.getUTCHours(), i;
    switch (r >= 17 ? i = eo.evening : r >= 12 ? i = eo.afternoon : r >= 4 ? i = eo.morning : i = eo.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      var r = t.getUTCHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, {
        unit: "hour"
      });
    }
    return vr.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : vr.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    var r = t.getUTCHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, {
      unit: "hour"
    }) : be(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    var r = t.getUTCHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, {
      unit: "hour"
    }) : be(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : vr.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : vr.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return vr.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (e) {
      case "X":
        return Vg(o);
      case "XXXX":
      case "XX":
        return qr(o);
      case "XXXXX":
      case "XXX":
      default:
        return qr(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    switch (e) {
      case "x":
        return Vg(o);
      case "xxxx":
      case "xx":
        return qr(o);
      case "xxxxx":
      case "xxx":
      default:
        return qr(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Hg(o, ":");
      case "OOOO":
      default:
        return "GMT" + qr(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Hg(o, ":");
      case "zzzz":
      default:
        return "GMT" + qr(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n, r) {
    var i = r._originalDate || t, o = Math.floor(i.getTime() / 1e3);
    return be(o, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n, r) {
    var i = r._originalDate || t, o = i.getTime();
    return be(o, e.length);
  }
};
function Hg(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), i = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return n + String(i);
  var a = e || "";
  return n + String(i) + a + be(o, 2);
}
function Vg(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + be(Math.abs(t) / 60, 2);
  }
  return qr(t, e);
}
function qr(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", i = Math.abs(t), o = be(Math.floor(i / 60), 2), a = be(i % 60, 2);
  return r + o + n + a;
}
const Bx = zx;
function Kg(t, e) {
  switch (t) {
    case "P":
      return e.date({
        width: "short"
      });
    case "PP":
      return e.date({
        width: "medium"
      });
    case "PPP":
      return e.date({
        width: "long"
      });
    case "PPPP":
    default:
      return e.date({
        width: "full"
      });
  }
}
function rb(t, e) {
  switch (t) {
    case "p":
      return e.time({
        width: "short"
      });
    case "pp":
      return e.time({
        width: "medium"
      });
    case "ppp":
      return e.time({
        width: "long"
      });
    case "pppp":
    default:
      return e.time({
        width: "full"
      });
  }
}
function Wx(t, e) {
  var n = t.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return Kg(t, e);
  var o;
  switch (r) {
    case "P":
      o = e.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = e.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = e.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = e.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Kg(r, e)).replace("{{time}}", rb(i, e));
}
var Ux = {
  p: rb,
  P: Wx
};
const Hx = Ux;
var Vx = ["D", "DD"], Kx = ["YY", "YYYY"];
function Yx(t) {
  return Vx.indexOf(t) !== -1;
}
function qx(t) {
  return Kx.indexOf(t) !== -1;
}
function Yg(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://git.io/fxCyr"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://git.io/fxCyr"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://git.io/fxCyr"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://git.io/fxCyr"));
}
var Gx = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Qx = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Xx = /^'([^]*?)'?$/, Jx = /''/g, Zx = /[a-zA-Z]/;
function qg(t, e, n) {
  lt(2, arguments);
  var r = String(e), i = n || {}, o = i.locale || Wl, a = o.options && o.options.firstWeekContainsDate, s = a == null ? 1 : ln(a), l = i.firstWeekContainsDate == null ? s : ln(i.firstWeekContainsDate);
  if (!(l >= 1 && l <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var f = o.options && o.options.weekStartsOn, c = f == null ? 0 : ln(f), u = i.weekStartsOn == null ? c : ln(i.weekStartsOn);
  if (!(u >= 0 && u <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!o.localize)
    throw new RangeError("locale must contain localize property");
  if (!o.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var d = at(t);
  if (!VC(d))
    throw new RangeError("Invalid time value");
  var h = Id(d), p = Mx(d, h), m = {
    firstWeekContainsDate: l,
    weekStartsOn: u,
    locale: o,
    _originalDate: d
  }, v = r.match(Qx).map(function(b) {
    var k = b[0];
    if (k === "p" || k === "P") {
      var _ = Hx[k];
      return _(b, o.formatLong, m);
    }
    return b;
  }).join("").match(Gx).map(function(b) {
    if (b === "''")
      return "'";
    var k = b[0];
    if (k === "'")
      return eE(b);
    var _ = Bx[k];
    if (_)
      return !i.useAdditionalWeekYearTokens && qx(b) && Yg(b, e, t), !i.useAdditionalDayOfYearTokens && Yx(b) && Yg(b, e, t), _(p, b, o.localize, m);
    if (k.match(Zx))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + k + "`");
    return b;
  }).join("");
  return v;
}
function eE(t) {
  return t.match(Xx)[1].replace(Jx, "'");
}
function tE(t, e) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  e = e || {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t;
}
function nE(t) {
  return tE({}, t);
}
var Gg = 1e3 * 60, Vl = 60 * 24, Qg = Vl * 30, Xg = Vl * 365;
function rE(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  lt(2, arguments);
  var r = n.locale || Wl;
  if (!r.formatDistance)
    throw new RangeError("locale must contain localize.formatDistance property");
  var i = UC(t, e);
  if (isNaN(i))
    throw new RangeError("Invalid time value");
  var o = nE(n);
  o.addSuffix = Boolean(n.addSuffix), o.comparison = i;
  var a, s;
  i > 0 ? (a = at(e), s = at(t)) : (a = at(t), s = at(e));
  var l = n.roundingMethod == null ? "round" : String(n.roundingMethod), f;
  if (l === "floor")
    f = Math.floor;
  else if (l === "ceil")
    f = Math.ceil;
  else if (l === "round")
    f = Math.round;
  else
    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
  var c = s.getTime() - a.getTime(), u = c / Gg, d = Id(s) - Id(a), h = (c - d) / Gg, p;
  if (n.unit == null ? u < 1 ? p = "second" : u < 60 ? p = "minute" : u < Vl ? p = "hour" : h < Qg ? p = "day" : h < Xg ? p = "month" : p = "year" : p = String(n.unit), p === "second") {
    var m = f(c / 1e3);
    return r.formatDistance("xSeconds", m, o);
  } else if (p === "minute") {
    var v = f(u);
    return r.formatDistance("xMinutes", v, o);
  } else if (p === "hour") {
    var b = f(u / 60);
    return r.formatDistance("xHours", b, o);
  } else if (p === "day") {
    var k = f(h / Vl);
    return r.formatDistance("xDays", k, o);
  } else if (p === "month") {
    var _ = f(h / Qg);
    return _ === 12 && n.unit !== "month" ? r.formatDistance("xYears", 1, o) : r.formatDistance("xMonths", _, o);
  } else if (p === "year") {
    var E = f(h / Xg);
    return r.formatDistance("xYears", E, o);
  }
  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}
function iE(t, e) {
  lt(1, arguments);
  var n = at(t);
  if (isNaN(n.getTime()))
    throw new RangeError("Invalid time value");
  var r = e != null && e.format ? String(e.format) : "extended", i = e != null && e.representation ? String(e.representation) : "complete";
  if (r !== "extended" && r !== "basic")
    throw new RangeError("format must be 'extended' or 'basic'");
  if (i !== "date" && i !== "time" && i !== "complete")
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  var o = "", a = "", s = r === "extended" ? "-" : "", l = r === "extended" ? ":" : "";
  if (i !== "time") {
    var f = be(n.getDate(), 2), c = be(n.getMonth() + 1, 2), u = be(n.getFullYear(), 4);
    o = "".concat(u).concat(s).concat(c).concat(s).concat(f);
  }
  if (i !== "date") {
    var d = n.getTimezoneOffset();
    if (d !== 0) {
      var h = Math.abs(d), p = be(Math.floor(h / 60), 2), m = be(h % 60, 2), v = d < 0 ? "+" : "-";
      a = "".concat(v).concat(p, ":").concat(m);
    } else
      a = "Z";
    var b = be(n.getHours(), 2), k = be(n.getMinutes(), 2), _ = be(n.getSeconds(), 2), E = o === "" ? "" : "T", S = [b, k, _].join(l);
    o = "".concat(o).concat(E).concat(S).concat(a);
  }
  return o;
}
function oE(t, e) {
  lt(2, arguments);
  var n = at(t), r = at(e);
  return n.getFullYear() === r.getFullYear();
}
const aE = 864e5, sE = {
  ...Wl,
  formatDistance: (t, e, n) => t === "xSeconds" ? "now" : t === "xMinutes" ? `${e}m` : t === "xHours" ? `${e}h` : Wl.formatDistance(t, e, n)
};
function lE(t, e) {
  return Math.abs(t - e) < aE ? rE(t, e, { locale: sE, roundingMethod: "floor" }) : oE(t, e) ? qg(t, "MMM d") : qg(t, "MMM d, yyyy");
}
function gh(t) {
  return encodeURIComponent(t).replace(/\./g, "%2E");
}
function gt(t) {
  return decodeURIComponent(t);
}
function Uo(t, e, n = !1) {
  if (t === null || e === null)
    return t === e;
  let r = t, i = e;
  if (n || (t instanceof Array && (r = t.sort()), e instanceof Array && (i = e.sort())), typeof r != "object" || typeof i != "object")
    return r === i;
  const o = Object.getOwnPropertyNames(r), a = Object.getOwnPropertyNames(i);
  if (o.length !== a.length)
    return !1;
  for (const s of o) {
    const l = t[s], f = e[s];
    if (typeof l == "object" && typeof f == "object") {
      if (Uo(l, f, n))
        continue;
      return !1;
    }
    if (l !== f)
      return !1;
  }
  return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ib = {
  /**
   * @define {boolean} Whether this is the client Node.js SDK.
   */
  NODE_CLIENT: !1,
  /**
   * @define {boolean} Whether this is the Admin Node.js SDK.
   */
  NODE_ADMIN: !1,
  /**
   * Firebase SDK Version
   */
  SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const V = function(t, e) {
  if (!t)
    throw Ho(e);
}, Ho = function(t) {
  return new Error("Firebase Database (" + ib.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + t);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ob = function(t) {
  const e = [];
  let n = 0;
  for (let r = 0; r < t.length; r++) {
    let i = t.charCodeAt(r);
    i < 128 ? e[n++] = i : i < 2048 ? (e[n++] = i >> 6 | 192, e[n++] = i & 63 | 128) : (i & 64512) === 55296 && r + 1 < t.length && (t.charCodeAt(r + 1) & 64512) === 56320 ? (i = 65536 + ((i & 1023) << 10) + (t.charCodeAt(++r) & 1023), e[n++] = i >> 18 | 240, e[n++] = i >> 12 & 63 | 128, e[n++] = i >> 6 & 63 | 128, e[n++] = i & 63 | 128) : (e[n++] = i >> 12 | 224, e[n++] = i >> 6 & 63 | 128, e[n++] = i & 63 | 128);
  }
  return e;
}, fE = function(t) {
  const e = [];
  let n = 0, r = 0;
  for (; n < t.length; ) {
    const i = t[n++];
    if (i < 128)
      e[r++] = String.fromCharCode(i);
    else if (i > 191 && i < 224) {
      const o = t[n++];
      e[r++] = String.fromCharCode((i & 31) << 6 | o & 63);
    } else if (i > 239 && i < 365) {
      const o = t[n++], a = t[n++], s = t[n++], l = ((i & 7) << 18 | (o & 63) << 12 | (a & 63) << 6 | s & 63) - 65536;
      e[r++] = String.fromCharCode(55296 + (l >> 10)), e[r++] = String.fromCharCode(56320 + (l & 1023));
    } else {
      const o = t[n++], a = t[n++];
      e[r++] = String.fromCharCode((i & 15) << 12 | (o & 63) << 6 | a & 63);
    }
  }
  return e.join("");
}, ph = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob == "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(t, e) {
    if (!Array.isArray(t))
      throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    const n = e ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, r = [];
    for (let i = 0; i < t.length; i += 3) {
      const o = t[i], a = i + 1 < t.length, s = a ? t[i + 1] : 0, l = i + 2 < t.length, f = l ? t[i + 2] : 0, c = o >> 2, u = (o & 3) << 4 | s >> 4;
      let d = (s & 15) << 2 | f >> 6, h = f & 63;
      l || (h = 64, a || (d = 64)), r.push(n[c], n[u], n[d], n[h]);
    }
    return r.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? btoa(t) : this.encodeByteArray(ob(t), e);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? atob(t) : fE(this.decodeStringToByteArray(t, e));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(t, e) {
    this.init_();
    const n = e ? this.charToByteMapWebSafe_ : this.charToByteMap_, r = [];
    for (let i = 0; i < t.length; ) {
      const o = n[t.charAt(i++)], s = i < t.length ? n[t.charAt(i)] : 0;
      ++i;
      const f = i < t.length ? n[t.charAt(i)] : 64;
      ++i;
      const u = i < t.length ? n[t.charAt(i)] : 64;
      if (++i, o == null || s == null || f == null || u == null)
        throw Error();
      const d = o << 2 | s >> 4;
      if (r.push(d), f !== 64) {
        const h = s << 4 & 240 | f >> 2;
        if (r.push(h), u !== 64) {
          const p = f << 6 & 192 | u;
          r.push(p);
        }
      }
    }
    return r;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
      for (let t = 0; t < this.ENCODED_VALS.length; t++)
        this.byteToCharMap_[t] = this.ENCODED_VALS.charAt(t), this.charToByteMap_[this.byteToCharMap_[t]] = t, this.byteToCharMapWebSafe_[t] = this.ENCODED_VALS_WEBSAFE.charAt(t), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[t]] = t, t >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(t)] = t, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(t)] = t);
    }
  }
}, ab = function(t) {
  const e = ob(t);
  return ph.encodeByteArray(e, !0);
}, sb = function(t) {
  return ab(t).replace(/\./g, "");
}, Nd = function(t) {
  try {
    return ph.decodeString(t, !0);
  } catch (e) {
    console.error("base64Decode failed: ", e);
  }
  return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function cE(t) {
  return lb(void 0, t);
}
function lb(t, e) {
  if (!(e instanceof Object))
    return e;
  switch (e.constructor) {
    case Date:
      const n = e;
      return new Date(n.getTime());
    case Object:
      t === void 0 && (t = {});
      break;
    case Array:
      t = [];
      break;
    default:
      return e;
  }
  for (const n in e)
    !e.hasOwnProperty(n) || !uE(n) || (t[n] = lb(t[n], e[n]));
  return t;
}
function uE(t) {
  return t !== "__proto__";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Fn {
  constructor() {
    this.reject = () => {
    }, this.resolve = () => {
    }, this.promise = new Promise((e, n) => {
      this.resolve = e, this.reject = n;
    });
  }
  /**
   * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(e) {
    return (n, r) => {
      n ? this.reject(n) : this.resolve(r), typeof e == "function" && (this.promise.catch(() => {
      }), e.length === 1 ? e(n) : e(n, r));
    };
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Hn() {
  return typeof navigator < "u" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
}
function mh() {
  return typeof window < "u" && // @ts-ignore Setting up an broadly applicable index signature for Window
  // just to deal with this case would probably be a bad idea.
  !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(Hn());
}
function dE() {
  const t = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
  return typeof t == "object" && t.id !== void 0;
}
function fb() {
  return typeof navigator == "object" && navigator.product === "ReactNative";
}
function cb() {
  return ib.NODE_ADMIN === !0;
}
function hE() {
  return typeof indexedDB == "object";
}
function gE() {
  return new Promise((t, e) => {
    try {
      let n = !0;
      const r = "validate-browser-context-for-indexeddb-analytics-module", i = self.indexedDB.open(r);
      i.onsuccess = () => {
        i.result.close(), n || self.indexedDB.deleteDatabase(r), t(!0);
      }, i.onupgradeneeded = () => {
        n = !1;
      }, i.onerror = () => {
        var o;
        e(((o = i.error) === null || o === void 0 ? void 0 : o.message) || "");
      };
    } catch (n) {
      e(n);
    }
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const pE = "FirebaseError";
class Ps extends Error {
  constructor(e, n, r) {
    super(n), this.code = e, this.customData = r, this.name = pE, Object.setPrototypeOf(this, Ps.prototype), Error.captureStackTrace && Error.captureStackTrace(this, Rs.prototype.create);
  }
}
class Rs {
  constructor(e, n, r) {
    this.service = e, this.serviceName = n, this.errors = r;
  }
  create(e, ...n) {
    const r = n[0] || {}, i = `${this.service}/${e}`, o = this.errors[e], a = o ? mE(o, r) : "Error", s = `${this.serviceName}: ${a} (${i}).`;
    return new Ps(i, s, r);
  }
}
function mE(t, e) {
  return t.replace(vE, (n, r) => {
    const i = e[r];
    return i != null ? String(i) : `<${r}?>`;
  });
}
const vE = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function rs(t) {
  return JSON.parse(t);
}
function rt(t) {
  return JSON.stringify(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ub = function(t) {
  let e = {}, n = {}, r = {}, i = "";
  try {
    const o = t.split(".");
    e = rs(Nd(o[0]) || ""), n = rs(Nd(o[1]) || ""), i = o[2], r = n.d || {}, delete n.d;
  } catch {
  }
  return {
    header: e,
    claims: n,
    data: r,
    signature: i
  };
}, bE = function(t) {
  const e = ub(t), n = e.claims;
  return !!n && typeof n == "object" && n.hasOwnProperty("iat");
}, yE = function(t) {
  const e = ub(t).claims;
  return typeof e == "object" && e.admin === !0;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function qn(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function Co(t, e) {
  if (Object.prototype.hasOwnProperty.call(t, e))
    return t[e];
}
function Md(t) {
  for (const e in t)
    if (Object.prototype.hasOwnProperty.call(t, e))
      return !1;
  return !0;
}
function Kl(t, e, n) {
  const r = {};
  for (const i in t)
    Object.prototype.hasOwnProperty.call(t, i) && (r[i] = e.call(n, t[i], i, t));
  return r;
}
function Yl(t, e) {
  if (t === e)
    return !0;
  const n = Object.keys(t), r = Object.keys(e);
  for (const i of n) {
    if (!r.includes(i))
      return !1;
    const o = t[i], a = e[i];
    if (Jg(o) && Jg(a)) {
      if (!Yl(o, a))
        return !1;
    } else if (o !== a)
      return !1;
  }
  for (const i of r)
    if (!n.includes(i))
      return !1;
  return !0;
}
function Jg(t) {
  return t !== null && typeof t == "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function vh(t) {
  const e = [];
  for (const [n, r] of Object.entries(t))
    Array.isArray(r) ? r.forEach((i) => {
      e.push(encodeURIComponent(n) + "=" + encodeURIComponent(i));
    }) : e.push(encodeURIComponent(n) + "=" + encodeURIComponent(r));
  return e.length ? "&" + e.join("&") : "";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class _E {
  constructor() {
    this.chain_ = [], this.buf_ = [], this.W_ = [], this.pad_ = [], this.inbuf_ = 0, this.total_ = 0, this.blockSize = 512 / 8, this.pad_[0] = 128;
    for (let e = 1; e < this.blockSize; ++e)
      this.pad_[e] = 0;
    this.reset();
  }
  reset() {
    this.chain_[0] = 1732584193, this.chain_[1] = 4023233417, this.chain_[2] = 2562383102, this.chain_[3] = 271733878, this.chain_[4] = 3285377520, this.inbuf_ = 0, this.total_ = 0;
  }
  /**
   * Internal compress helper function.
   * @param buf Block to compress.
   * @param offset Offset of the block in the buffer.
   * @private
   */
  compress_(e, n) {
    n || (n = 0);
    const r = this.W_;
    if (typeof e == "string")
      for (let u = 0; u < 16; u++)
        r[u] = e.charCodeAt(n) << 24 | e.charCodeAt(n + 1) << 16 | e.charCodeAt(n + 2) << 8 | e.charCodeAt(n + 3), n += 4;
    else
      for (let u = 0; u < 16; u++)
        r[u] = e[n] << 24 | e[n + 1] << 16 | e[n + 2] << 8 | e[n + 3], n += 4;
    for (let u = 16; u < 80; u++) {
      const d = r[u - 3] ^ r[u - 8] ^ r[u - 14] ^ r[u - 16];
      r[u] = (d << 1 | d >>> 31) & 4294967295;
    }
    let i = this.chain_[0], o = this.chain_[1], a = this.chain_[2], s = this.chain_[3], l = this.chain_[4], f, c;
    for (let u = 0; u < 80; u++) {
      u < 40 ? u < 20 ? (f = s ^ o & (a ^ s), c = 1518500249) : (f = o ^ a ^ s, c = 1859775393) : u < 60 ? (f = o & a | s & (o | a), c = 2400959708) : (f = o ^ a ^ s, c = 3395469782);
      const d = (i << 5 | i >>> 27) + f + l + c + r[u] & 4294967295;
      l = s, s = a, a = (o << 30 | o >>> 2) & 4294967295, o = i, i = d;
    }
    this.chain_[0] = this.chain_[0] + i & 4294967295, this.chain_[1] = this.chain_[1] + o & 4294967295, this.chain_[2] = this.chain_[2] + a & 4294967295, this.chain_[3] = this.chain_[3] + s & 4294967295, this.chain_[4] = this.chain_[4] + l & 4294967295;
  }
  update(e, n) {
    if (e == null)
      return;
    n === void 0 && (n = e.length);
    const r = n - this.blockSize;
    let i = 0;
    const o = this.buf_;
    let a = this.inbuf_;
    for (; i < n; ) {
      if (a === 0)
        for (; i <= r; )
          this.compress_(e, i), i += this.blockSize;
      if (typeof e == "string") {
        for (; i < n; )
          if (o[a] = e.charCodeAt(i), ++a, ++i, a === this.blockSize) {
            this.compress_(o), a = 0;
            break;
          }
      } else
        for (; i < n; )
          if (o[a] = e[i], ++a, ++i, a === this.blockSize) {
            this.compress_(o), a = 0;
            break;
          }
    }
    this.inbuf_ = a, this.total_ += n;
  }
  /** @override */
  digest() {
    const e = [];
    let n = this.total_ * 8;
    this.inbuf_ < 56 ? this.update(this.pad_, 56 - this.inbuf_) : this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
    for (let i = this.blockSize - 1; i >= 56; i--)
      this.buf_[i] = n & 255, n /= 256;
    this.compress_(this.buf_);
    let r = 0;
    for (let i = 0; i < 5; i++)
      for (let o = 24; o >= 0; o -= 8)
        e[r] = this.chain_[i] >> o & 255, ++r;
    return e;
  }
}
function wE(t, e) {
  const n = new kE(t, e);
  return n.subscribe.bind(n);
}
class kE {
  /**
   * @param executor Function which can make calls to a single Observer
   *     as a proxy.
   * @param onNoObservers Callback when count of Observers goes to zero.
   */
  constructor(e, n) {
    this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = n, this.task.then(() => {
      e(this);
    }).catch((r) => {
      this.error(r);
    });
  }
  next(e) {
    this.forEachObserver((n) => {
      n.next(e);
    });
  }
  error(e) {
    this.forEachObserver((n) => {
      n.error(e);
    }), this.close(e);
  }
  complete() {
    this.forEachObserver((e) => {
      e.complete();
    }), this.close();
  }
  /**
   * Subscribe function that can be used to add an Observer to the fan-out list.
   *
   * - We require that no event is sent to a subscriber sychronously to their
   *   call to subscribe().
   */
  subscribe(e, n, r) {
    let i;
    if (e === void 0 && n === void 0 && r === void 0)
      throw new Error("Missing Observer.");
    CE(e, [
      "next",
      "error",
      "complete"
    ]) ? i = e : i = {
      next: e,
      error: n,
      complete: r
    }, i.next === void 0 && (i.next = wu), i.error === void 0 && (i.error = wu), i.complete === void 0 && (i.complete = wu);
    const o = this.unsubscribeOne.bind(this, this.observers.length);
    return this.finalized && this.task.then(() => {
      try {
        this.finalError ? i.error(this.finalError) : i.complete();
      } catch {
      }
    }), this.observers.push(i), o;
  }
  // Unsubscribe is synchronous - we guarantee that no events are sent to
  // any unsubscribed Observer.
  unsubscribeOne(e) {
    this.observers === void 0 || this.observers[e] === void 0 || (delete this.observers[e], this.observerCount -= 1, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
  }
  forEachObserver(e) {
    if (!this.finalized)
      for (let n = 0; n < this.observers.length; n++)
        this.sendOne(n, e);
  }
  // Call the Observer via one of it's callback function. We are careful to
  // confirm that the observe has not been unsubscribed since this asynchronous
  // function had been queued.
  sendOne(e, n) {
    this.task.then(() => {
      if (this.observers !== void 0 && this.observers[e] !== void 0)
        try {
          n(this.observers[e]);
        } catch (r) {
          typeof console < "u" && console.error && console.error(r);
        }
    });
  }
  close(e) {
    this.finalized || (this.finalized = !0, e !== void 0 && (this.finalError = e), this.task.then(() => {
      this.observers = void 0, this.onNoObservers = void 0;
    }));
  }
}
function CE(t, e) {
  if (typeof t != "object" || t === null)
    return !1;
  for (const n of e)
    if (n in t && typeof t[n] == "function")
      return !0;
  return !1;
}
function wu() {
}
function hi(t, e) {
  return `${t} failed: ${e} argument `;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const xE = function(t) {
  const e = [];
  let n = 0;
  for (let r = 0; r < t.length; r++) {
    let i = t.charCodeAt(r);
    if (i >= 55296 && i <= 56319) {
      const o = i - 55296;
      r++, V(r < t.length, "Surrogate pair missing trail surrogate.");
      const a = t.charCodeAt(r) - 56320;
      i = 65536 + (o << 10) + a;
    }
    i < 128 ? e[n++] = i : i < 2048 ? (e[n++] = i >> 6 | 192, e[n++] = i & 63 | 128) : i < 65536 ? (e[n++] = i >> 12 | 224, e[n++] = i >> 6 & 63 | 128, e[n++] = i & 63 | 128) : (e[n++] = i >> 18 | 240, e[n++] = i >> 12 & 63 | 128, e[n++] = i >> 6 & 63 | 128, e[n++] = i & 63 | 128);
  }
  return e;
}, tc = function(t) {
  let e = 0;
  for (let n = 0; n < t.length; n++) {
    const r = t.charCodeAt(n);
    r < 128 ? e++ : r < 2048 ? e += 2 : r >= 55296 && r <= 56319 ? (e += 4, n++) : e += 3;
  }
  return e;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function gn(t) {
  return t && t._delegate ? t._delegate : t;
}
class gi {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(e, n, r) {
    this.name = e, this.instanceFactory = n, this.type = r, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(e) {
    return this.instantiationMode = e, this;
  }
  setMultipleInstances(e) {
    return this.multipleInstances = e, this;
  }
  setServiceProps(e) {
    return this.serviceProps = e, this;
  }
  setInstanceCreatedCallback(e) {
    return this.onInstanceCreated = e, this;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Gr = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let EE = class {
  constructor(e, n) {
    this.name = e, this.container = n, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide mulitple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(e) {
    const n = this.normalizeInstanceIdentifier(e);
    if (!this.instancesDeferred.has(n)) {
      const r = new Fn();
      if (this.instancesDeferred.set(n, r), this.isInitialized(n) || this.shouldAutoInitialize())
        try {
          const i = this.getOrInitializeService({
            instanceIdentifier: n
          });
          i && r.resolve(i);
        } catch {
        }
    }
    return this.instancesDeferred.get(n).promise;
  }
  getImmediate(e) {
    var n;
    const r = this.normalizeInstanceIdentifier(e == null ? void 0 : e.identifier), i = (n = e == null ? void 0 : e.optional) !== null && n !== void 0 ? n : !1;
    if (this.isInitialized(r) || this.shouldAutoInitialize())
      try {
        return this.getOrInitializeService({
          instanceIdentifier: r
        });
      } catch (o) {
        if (i)
          return null;
        throw o;
      }
    else {
      if (i)
        return null;
      throw Error(`Service ${this.name} is not available`);
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(e) {
    if (e.name !== this.name)
      throw Error(`Mismatching Component ${e.name} for Provider ${this.name}.`);
    if (this.component)
      throw Error(`Component for ${this.name} has already been provided`);
    if (this.component = e, !!this.shouldAutoInitialize()) {
      if (SE(e))
        try {
          this.getOrInitializeService({ instanceIdentifier: Gr });
        } catch {
        }
      for (const [n, r] of this.instancesDeferred.entries()) {
        const i = this.normalizeInstanceIdentifier(n);
        try {
          const o = this.getOrInitializeService({
            instanceIdentifier: i
          });
          r.resolve(o);
        } catch {
        }
      }
    }
  }
  clearInstance(e = Gr) {
    this.instancesDeferred.delete(e), this.instancesOptions.delete(e), this.instances.delete(e);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const e = Array.from(this.instances.values());
    await Promise.all([
      ...e.filter((n) => "INTERNAL" in n).map((n) => n.INTERNAL.delete()),
      ...e.filter((n) => "_delete" in n).map((n) => n._delete())
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(e = Gr) {
    return this.instances.has(e);
  }
  getOptions(e = Gr) {
    return this.instancesOptions.get(e) || {};
  }
  initialize(e = {}) {
    const { options: n = {} } = e, r = this.normalizeInstanceIdentifier(e.instanceIdentifier);
    if (this.isInitialized(r))
      throw Error(`${this.name}(${r}) has already been initialized`);
    if (!this.isComponentSet())
      throw Error(`Component ${this.name} has not been registered yet`);
    const i = this.getOrInitializeService({
      instanceIdentifier: r,
      options: n
    });
    for (const [o, a] of this.instancesDeferred.entries()) {
      const s = this.normalizeInstanceIdentifier(o);
      r === s && a.resolve(i);
    }
    return i;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(e, n) {
    var r;
    const i = this.normalizeInstanceIdentifier(n), o = (r = this.onInitCallbacks.get(i)) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set();
    o.add(e), this.onInitCallbacks.set(i, o);
    const a = this.instances.get(i);
    return a && e(a, i), () => {
      o.delete(e);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(e, n) {
    const r = this.onInitCallbacks.get(n);
    if (r)
      for (const i of r)
        try {
          i(e, n);
        } catch {
        }
  }
  getOrInitializeService({ instanceIdentifier: e, options: n = {} }) {
    let r = this.instances.get(e);
    if (!r && this.component && (r = this.component.instanceFactory(this.container, {
      instanceIdentifier: TE(e),
      options: n
    }), this.instances.set(e, r), this.instancesOptions.set(e, n), this.invokeOnInitCallbacks(r, e), this.component.onInstanceCreated))
      try {
        this.component.onInstanceCreated(this.container, e, r);
      } catch {
      }
    return r || null;
  }
  normalizeInstanceIdentifier(e = Gr) {
    return this.component ? this.component.multipleInstances ? e : Gr : e;
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
};
function TE(t) {
  return t === Gr ? void 0 : t;
}
function SE(t) {
  return t.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IE {
  constructor(e) {
    this.name = e, this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(e) {
    const n = this.getProvider(e.name);
    if (n.isComponentSet())
      throw new Error(`Component ${e.name} has already been registered with ${this.name}`);
    n.setComponent(e);
  }
  addOrOverwriteComponent(e) {
    this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(e) {
    if (this.providers.has(e))
      return this.providers.get(e);
    const n = new EE(e, this);
    return this.providers.set(e, n), n;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Pe;
(function(t) {
  t[t.DEBUG = 0] = "DEBUG", t[t.VERBOSE = 1] = "VERBOSE", t[t.INFO = 2] = "INFO", t[t.WARN = 3] = "WARN", t[t.ERROR = 4] = "ERROR", t[t.SILENT = 5] = "SILENT";
})(Pe || (Pe = {}));
const NE = {
  debug: Pe.DEBUG,
  verbose: Pe.VERBOSE,
  info: Pe.INFO,
  warn: Pe.WARN,
  error: Pe.ERROR,
  silent: Pe.SILENT
}, ME = Pe.INFO, AE = {
  [Pe.DEBUG]: "log",
  [Pe.VERBOSE]: "log",
  [Pe.INFO]: "info",
  [Pe.WARN]: "warn",
  [Pe.ERROR]: "error"
}, OE = (t, e, ...n) => {
  if (e < t.logLevel)
    return;
  const r = new Date().toISOString(), i = AE[e];
  if (i)
    console[i](`[${r}]  ${t.name}:`, ...n);
  else
    throw new Error(`Attempted to log a message with an invalid logType (value: ${e})`);
};
class bh {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(e) {
    this.name = e, this._logLevel = ME, this._logHandler = OE, this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(e) {
    if (!(e in Pe))
      throw new TypeError(`Invalid value "${e}" assigned to \`logLevel\``);
    this._logLevel = e;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(e) {
    this._logLevel = typeof e == "string" ? NE[e] : e;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(e) {
    if (typeof e != "function")
      throw new TypeError("Value assigned to `logHandler` must be a function");
    this._logHandler = e;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(e) {
    this._userLogHandler = e;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...e) {
    this._userLogHandler && this._userLogHandler(this, Pe.DEBUG, ...e), this._logHandler(this, Pe.DEBUG, ...e);
  }
  log(...e) {
    this._userLogHandler && this._userLogHandler(this, Pe.VERBOSE, ...e), this._logHandler(this, Pe.VERBOSE, ...e);
  }
  info(...e) {
    this._userLogHandler && this._userLogHandler(this, Pe.INFO, ...e), this._logHandler(this, Pe.INFO, ...e);
  }
  warn(...e) {
    this._userLogHandler && this._userLogHandler(this, Pe.WARN, ...e), this._logHandler(this, Pe.WARN, ...e);
  }
  error(...e) {
    this._userLogHandler && this._userLogHandler(this, Pe.ERROR, ...e), this._logHandler(this, Pe.ERROR, ...e);
  }
}
const DE = (t, e) => e.some((n) => t instanceof n);
let Zg, ep;
function PE() {
  return Zg || (Zg = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function RE() {
  return ep || (ep = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const db = /* @__PURE__ */ new WeakMap(), Ad = /* @__PURE__ */ new WeakMap(), hb = /* @__PURE__ */ new WeakMap(), ku = /* @__PURE__ */ new WeakMap(), yh = /* @__PURE__ */ new WeakMap();
function LE(t) {
  const e = new Promise((n, r) => {
    const i = () => {
      t.removeEventListener("success", o), t.removeEventListener("error", a);
    }, o = () => {
      n(Er(t.result)), i();
    }, a = () => {
      r(t.error), i();
    };
    t.addEventListener("success", o), t.addEventListener("error", a);
  });
  return e.then((n) => {
    n instanceof IDBCursor && db.set(n, t);
  }).catch(() => {
  }), yh.set(e, t), e;
}
function $E(t) {
  if (Ad.has(t))
    return;
  const e = new Promise((n, r) => {
    const i = () => {
      t.removeEventListener("complete", o), t.removeEventListener("error", a), t.removeEventListener("abort", a);
    }, o = () => {
      n(), i();
    }, a = () => {
      r(t.error || new DOMException("AbortError", "AbortError")), i();
    };
    t.addEventListener("complete", o), t.addEventListener("error", a), t.addEventListener("abort", a);
  });
  Ad.set(t, e);
}
let Od = {
  get(t, e, n) {
    if (t instanceof IDBTransaction) {
      if (e === "done")
        return Ad.get(t);
      if (e === "objectStoreNames")
        return t.objectStoreNames || hb.get(t);
      if (e === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return Er(t[e]);
  },
  set(t, e, n) {
    return t[e] = n, !0;
  },
  has(t, e) {
    return t instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in t;
  }
};
function FE(t) {
  Od = t(Od);
}
function jE(t) {
  return t === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(e, ...n) {
    const r = t.call(Cu(this), e, ...n);
    return hb.set(r, e.sort ? e.sort() : [e]), Er(r);
  } : RE().includes(t) ? function(...e) {
    return t.apply(Cu(this), e), Er(db.get(this));
  } : function(...e) {
    return Er(t.apply(Cu(this), e));
  };
}
function zE(t) {
  return typeof t == "function" ? jE(t) : (t instanceof IDBTransaction && $E(t), DE(t, PE()) ? new Proxy(t, Od) : t);
}
function Er(t) {
  if (t instanceof IDBRequest)
    return LE(t);
  if (ku.has(t))
    return ku.get(t);
  const e = zE(t);
  return e !== t && (ku.set(t, e), yh.set(e, t)), e;
}
const Cu = (t) => yh.get(t);
function BE(t, e, { blocked: n, upgrade: r, blocking: i, terminated: o } = {}) {
  const a = indexedDB.open(t, e), s = Er(a);
  return r && a.addEventListener("upgradeneeded", (l) => {
    r(Er(a.result), l.oldVersion, l.newVersion, Er(a.transaction));
  }), n && a.addEventListener("blocked", () => n()), s.then((l) => {
    o && l.addEventListener("close", () => o()), i && l.addEventListener("versionchange", () => i());
  }).catch(() => {
  }), s;
}
const WE = ["get", "getKey", "getAll", "getAllKeys", "count"], UE = ["put", "add", "delete", "clear"], xu = /* @__PURE__ */ new Map();
function tp(t, e) {
  if (!(t instanceof IDBDatabase && !(e in t) && typeof e == "string"))
    return;
  if (xu.get(e))
    return xu.get(e);
  const n = e.replace(/FromIndex$/, ""), r = e !== n, i = UE.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(i || WE.includes(n))
  )
    return;
  const o = async function(a, ...s) {
    const l = this.transaction(a, i ? "readwrite" : "readonly");
    let f = l.store;
    return r && (f = f.index(s.shift())), (await Promise.all([
      f[n](...s),
      i && l.done
    ]))[0];
  };
  return xu.set(e, o), o;
}
FE((t) => ({
  ...t,
  get: (e, n, r) => tp(e, n) || t.get(e, n, r),
  has: (e, n) => !!tp(e, n) || t.has(e, n)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class HE {
  constructor(e) {
    this.container = e;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    return this.container.getProviders().map((n) => {
      if (VE(n)) {
        const r = n.getImmediate();
        return `${r.library}/${r.version}`;
      } else
        return null;
    }).filter((n) => n).join(" ");
  }
}
function VE(t) {
  const e = t.getComponent();
  return (e == null ? void 0 : e.type) === "VERSION";
}
const Dd = "@firebase/app", np = "0.7.29";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _h = new bh("@firebase/app"), KE = "@firebase/app-compat", YE = "@firebase/analytics-compat", qE = "@firebase/analytics", GE = "@firebase/app-check-compat", QE = "@firebase/app-check", XE = "@firebase/auth", JE = "@firebase/auth-compat", ZE = "@firebase/database", eT = "@firebase/database-compat", tT = "@firebase/functions", nT = "@firebase/functions-compat", rT = "@firebase/installations", iT = "@firebase/installations-compat", oT = "@firebase/messaging", aT = "@firebase/messaging-compat", sT = "@firebase/performance", lT = "@firebase/performance-compat", fT = "@firebase/remote-config", cT = "@firebase/remote-config-compat", uT = "@firebase/storage", dT = "@firebase/storage-compat", hT = "@firebase/firestore", gT = "@firebase/firestore-compat", pT = "firebase", mT = "9.9.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const gb = "[DEFAULT]", vT = {
  [Dd]: "fire-core",
  [KE]: "fire-core-compat",
  [qE]: "fire-analytics",
  [YE]: "fire-analytics-compat",
  [QE]: "fire-app-check",
  [GE]: "fire-app-check-compat",
  [XE]: "fire-auth",
  [JE]: "fire-auth-compat",
  [ZE]: "fire-rtdb",
  [eT]: "fire-rtdb-compat",
  [tT]: "fire-fn",
  [nT]: "fire-fn-compat",
  [rT]: "fire-iid",
  [iT]: "fire-iid-compat",
  [oT]: "fire-fcm",
  [aT]: "fire-fcm-compat",
  [sT]: "fire-perf",
  [lT]: "fire-perf-compat",
  [fT]: "fire-rc",
  [cT]: "fire-rc-compat",
  [uT]: "fire-gcs",
  [dT]: "fire-gcs-compat",
  [hT]: "fire-fst",
  [gT]: "fire-fst-compat",
  "fire-js": "fire-js",
  [pT]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ql = /* @__PURE__ */ new Map(), Pd = /* @__PURE__ */ new Map();
function bT(t, e) {
  try {
    t.container.addComponent(e);
  } catch (n) {
    _h.debug(`Component ${e.name} failed to register with FirebaseApp ${t.name}`, n);
  }
}
function xo(t) {
  const e = t.name;
  if (Pd.has(e))
    return _h.debug(`There were multiple attempts to register component ${e}.`), !1;
  Pd.set(e, t);
  for (const n of ql.values())
    bT(n, t);
  return !0;
}
function pb(t, e) {
  const n = t.container.getProvider("heartbeat").getImmediate({ optional: !0 });
  return n && n.triggerHeartbeat(), t.container.getProvider(e);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const yT = {
  [
    "no-app"
    /* NO_APP */
  ]: "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()",
  [
    "bad-app-name"
    /* BAD_APP_NAME */
  ]: "Illegal App name: '{$appName}",
  [
    "duplicate-app"
    /* DUPLICATE_APP */
  ]: "Firebase App named '{$appName}' already exists with different options or config",
  [
    "app-deleted"
    /* APP_DELETED */
  ]: "Firebase App named '{$appName}' already deleted",
  [
    "invalid-app-argument"
    /* INVALID_APP_ARGUMENT */
  ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  [
    "invalid-log-argument"
    /* INVALID_LOG_ARGUMENT */
  ]: "First argument to `onLog` must be null or a function.",
  [
    "storage-open"
    /* STORAGE_OPEN */
  ]: "Error thrown when opening storage. Original error: {$originalErrorMessage}.",
  [
    "storage-get"
    /* STORAGE_GET */
  ]: "Error thrown when reading from storage. Original error: {$originalErrorMessage}.",
  [
    "storage-set"
    /* STORAGE_WRITE */
  ]: "Error thrown when writing to storage. Original error: {$originalErrorMessage}.",
  [
    "storage-delete"
    /* STORAGE_DELETE */
  ]: "Error thrown when deleting from storage. Original error: {$originalErrorMessage}."
}, pi = new Rs("app", "Firebase", yT);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class _T {
  constructor(e, n, r) {
    this._isDeleted = !1, this._options = Object.assign({}, e), this._config = Object.assign({}, n), this._name = n.name, this._automaticDataCollectionEnabled = n.automaticDataCollectionEnabled, this._container = r, this.container.addComponent(new gi(
      "app",
      () => this,
      "PUBLIC"
      /* PUBLIC */
    ));
  }
  get automaticDataCollectionEnabled() {
    return this.checkDestroyed(), this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(e) {
    this.checkDestroyed(), this._automaticDataCollectionEnabled = e;
  }
  get name() {
    return this.checkDestroyed(), this._name;
  }
  get options() {
    return this.checkDestroyed(), this._options;
  }
  get config() {
    return this.checkDestroyed(), this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(e) {
    this._isDeleted = e;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted)
      throw pi.create("app-deleted", { appName: this._name });
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const wh = mT;
function wT(t, e = {}) {
  typeof e != "object" && (e = { name: e });
  const n = Object.assign({ name: gb, automaticDataCollectionEnabled: !1 }, e), r = n.name;
  if (typeof r != "string" || !r)
    throw pi.create("bad-app-name", {
      appName: String(r)
    });
  const i = ql.get(r);
  if (i) {
    if (Yl(t, i.options) && Yl(n, i.config))
      return i;
    throw pi.create("duplicate-app", { appName: r });
  }
  const o = new IE(r);
  for (const s of Pd.values())
    o.addComponent(s);
  const a = new _T(t, n, o);
  return ql.set(r, a), a;
}
function kh(t = gb) {
  const e = ql.get(t);
  if (!e)
    throw pi.create("no-app", { appName: t });
  return e;
}
function Tr(t, e, n) {
  var r;
  let i = (r = vT[t]) !== null && r !== void 0 ? r : t;
  n && (i += `-${n}`);
  const o = i.match(/\s|\//), a = e.match(/\s|\//);
  if (o || a) {
    const s = [
      `Unable to register library "${i}" with version "${e}":`
    ];
    o && s.push(`library name "${i}" contains illegal characters (whitespace or "/")`), o && a && s.push("and"), a && s.push(`version name "${e}" contains illegal characters (whitespace or "/")`), _h.warn(s.join(" "));
    return;
  }
  xo(new gi(
    `${i}-version`,
    () => ({ library: i, version: e }),
    "VERSION"
    /* VERSION */
  ));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const kT = "firebase-heartbeat-database", CT = 1, is = "firebase-heartbeat-store";
let Eu = null;
function mb() {
  return Eu || (Eu = BE(kT, CT, {
    upgrade: (t, e) => {
      switch (e) {
        case 0:
          t.createObjectStore(is);
      }
    }
  }).catch((t) => {
    throw pi.create("storage-open", {
      originalErrorMessage: t.message
    });
  })), Eu;
}
async function xT(t) {
  var e;
  try {
    return (await mb()).transaction(is).objectStore(is).get(vb(t));
  } catch (n) {
    throw pi.create("storage-get", {
      originalErrorMessage: (e = n) === null || e === void 0 ? void 0 : e.message
    });
  }
}
async function rp(t, e) {
  var n;
  try {
    const i = (await mb()).transaction(is, "readwrite");
    return await i.objectStore(is).put(e, vb(t)), i.done;
  } catch (r) {
    throw pi.create("storage-set", {
      originalErrorMessage: (n = r) === null || n === void 0 ? void 0 : n.message
    });
  }
}
function vb(t) {
  return `${t.name}!${t.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ET = 1024, TT = 30 * 24 * 60 * 60 * 1e3;
class ST {
  constructor(e) {
    this.container = e, this._heartbeatsCache = null;
    const n = this.container.getProvider("app").getImmediate();
    this._storage = new NT(n), this._heartbeatsCachePromise = this._storage.read().then((r) => (this._heartbeatsCache = r, r));
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    const n = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), r = ip();
    if (this._heartbeatsCache === null && (this._heartbeatsCache = await this._heartbeatsCachePromise), !(this._heartbeatsCache.lastSentHeartbeatDate === r || this._heartbeatsCache.heartbeats.some((i) => i.date === r)))
      return this._heartbeatsCache.heartbeats.push({ date: r, agent: n }), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((i) => {
        const o = new Date(i.date).valueOf();
        return Date.now() - o <= TT;
      }), this._storage.overwrite(this._heartbeatsCache);
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0)
      return "";
    const e = ip(), { heartbeatsToSend: n, unsentEntries: r } = IT(this._heartbeatsCache.heartbeats), i = sb(JSON.stringify({ version: 2, heartbeats: n }));
    return this._heartbeatsCache.lastSentHeartbeatDate = e, r.length > 0 ? (this._heartbeatsCache.heartbeats = r, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), i;
  }
}
function ip() {
  return new Date().toISOString().substring(0, 10);
}
function IT(t, e = ET) {
  const n = [];
  let r = t.slice();
  for (const i of t) {
    const o = n.find((a) => a.agent === i.agent);
    if (o) {
      if (o.dates.push(i.date), op(n) > e) {
        o.dates.pop();
        break;
      }
    } else if (n.push({
      agent: i.agent,
      dates: [i.date]
    }), op(n) > e) {
      n.pop();
      break;
    }
    r = r.slice(1);
  }
  return {
    heartbeatsToSend: n,
    unsentEntries: r
  };
}
class NT {
  constructor(e) {
    this.app = e, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    return hE() ? gE().then(() => !0).catch(() => !1) : !1;
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    return await this._canUseIndexedDBPromise ? await xT(this.app) || { heartbeats: [] } : { heartbeats: [] };
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(e) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return rp(this.app, {
        lastSentHeartbeatDate: (n = e.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: e.heartbeats
      });
    } else
      return;
  }
  // add heartbeats
  async add(e) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return rp(this.app, {
        lastSentHeartbeatDate: (n = e.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: [
          ...i.heartbeats,
          ...e.heartbeats
        ]
      });
    } else
      return;
  }
}
function op(t) {
  return sb(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: t })
  ).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function MT(t) {
  xo(new gi(
    "platform-logger",
    (e) => new HE(e),
    "PRIVATE"
    /* PRIVATE */
  )), xo(new gi(
    "heartbeat",
    (e) => new ST(e),
    "PRIVATE"
    /* PRIVATE */
  )), Tr(Dd, np, t), Tr(Dd, np, "esm2017"), Tr("fire-js", "");
}
MT("");
function bb(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function yb() {
  return {
    [
      "dependent-sdk-initialized-before-auth"
      /* DEPENDENT_SDK_INIT_BEFORE_AUTH */
    ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
  };
}
const AT = yb, _b = new Rs("auth", "Firebase", yb());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ap = new bh("@firebase/auth");
function El(t, ...e) {
  ap.logLevel <= Pe.ERROR && ap.error(`Auth (${wh}): ${t}`, ...e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Gl(t, ...e) {
  throw Ch(t, ...e);
}
function wb(t, ...e) {
  return Ch(t, ...e);
}
function OT(t, e, n) {
  const r = Object.assign(Object.assign({}, AT()), { [e]: n });
  return new Rs("auth", "Firebase", r).create(e, {
    appName: t.name
  });
}
function Ch(t, ...e) {
  if (typeof t != "string") {
    const n = e[0], r = [...e.slice(1)];
    return r[0] && (r[0].appName = t.name), t._errorFactory.create(n, ...r);
  }
  return _b.create(t, ...e);
}
function Ie(t, e, ...n) {
  if (!t)
    throw Ch(e, ...n);
}
function Pa(t) {
  const e = "INTERNAL ASSERTION FAILED: " + t;
  throw El(e), new Error(e);
}
function Ql(t, e) {
  t || Pa(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const sp = /* @__PURE__ */ new Map();
function ei(t) {
  Ql(t instanceof Function, "Expected a class definition");
  let e = sp.get(t);
  return e ? (Ql(e instanceof t, "Instance stored in cache mismatched with class"), e) : (e = new t(), sp.set(t, e), e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function DT(t, e) {
  const n = pb(t, "auth");
  if (n.isInitialized()) {
    const i = n.getImmediate(), o = n.getOptions();
    if (Yl(o, e ?? {}))
      return i;
    Gl(
      i,
      "already-initialized"
      /* ALREADY_INITIALIZED */
    );
  }
  return n.initialize({ options: e });
}
function PT(t, e) {
  const n = (e == null ? void 0 : e.persistence) || [], r = (Array.isArray(n) ? n : [n]).map(ei);
  e != null && e.errorMap && t._updateErrorMap(e.errorMap), t._initializeWithPersistence(r, e == null ? void 0 : e.popupRedirectResolver);
}
function RT() {
  return lp() === "http:" || lp() === "https:";
}
function lp() {
  var t;
  return typeof self < "u" && ((t = self.location) === null || t === void 0 ? void 0 : t.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function LT() {
  return typeof navigator < "u" && navigator && "onLine" in navigator && typeof navigator.onLine == "boolean" && // Apply only for traditional web apps and Chrome extensions.
  // This is especially true for Cordova apps which have unreliable
  // navigator.onLine behavior unless cordova-plugin-network-information is
  // installed which overwrites the native navigator.onLine value and
  // defines navigator.connection.
  (RT() || dE() || "connection" in navigator) ? navigator.onLine : !0;
}
function $T() {
  if (typeof navigator > "u")
    return null;
  const t = navigator;
  return (
    // Most reliable, but only supported in Chrome/Firefox.
    t.languages && t.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    t.language || // Couldn't determine language.
    null
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ls {
  constructor(e, n) {
    this.shortDelay = e, this.longDelay = n, Ql(n > e, "Short delay should be less than long delay!"), this.isMobile = mh() || fb();
  }
  get() {
    return LT() ? this.isMobile ? this.longDelay : this.shortDelay : Math.min(5e3, this.shortDelay);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function FT(t, e) {
  Ql(t.emulator, "Emulator should always be set here");
  const { url: n } = t.emulator;
  return e ? `${n}${e.startsWith("/") ? e.slice(1) : e}` : n;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kb {
  static initialize(e, n, r) {
    this.fetchImpl = e, n && (this.headersImpl = n), r && (this.responseImpl = r);
  }
  static fetch() {
    if (this.fetchImpl)
      return this.fetchImpl;
    if (typeof self < "u" && "fetch" in self)
      return self.fetch;
    Pa("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static headers() {
    if (this.headersImpl)
      return this.headersImpl;
    if (typeof self < "u" && "Headers" in self)
      return self.Headers;
    Pa("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static response() {
    if (this.responseImpl)
      return this.responseImpl;
    if (typeof self < "u" && "Response" in self)
      return self.Response;
    Pa("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const jT = {
  // Custom token errors.
  CREDENTIAL_MISMATCH: "custom-token-mismatch",
  // This can only happen if the SDK sends a bad request.
  MISSING_CUSTOM_TOKEN: "internal-error",
  // Create Auth URI errors.
  INVALID_IDENTIFIER: "invalid-email",
  // This can only happen if the SDK sends a bad request.
  MISSING_CONTINUE_URI: "internal-error",
  // Sign in with email and password errors (some apply to sign up too).
  INVALID_PASSWORD: "wrong-password",
  // This can only happen if the SDK sends a bad request.
  MISSING_PASSWORD: "internal-error",
  // Sign up with email and password errors.
  EMAIL_EXISTS: "email-already-in-use",
  PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
  // Verify assertion for sign in with credential errors:
  INVALID_IDP_RESPONSE: "invalid-credential",
  INVALID_PENDING_TOKEN: "invalid-credential",
  FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
  // This can only happen if the SDK sends a bad request.
  MISSING_REQ_TYPE: "internal-error",
  // Send Password reset email errors:
  EMAIL_NOT_FOUND: "user-not-found",
  RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
  EXPIRED_OOB_CODE: "expired-action-code",
  INVALID_OOB_CODE: "invalid-action-code",
  // This can only happen if the SDK sends a bad request.
  MISSING_OOB_CODE: "internal-error",
  // Operations that require ID token in request:
  CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
  INVALID_ID_TOKEN: "invalid-user-token",
  TOKEN_EXPIRED: "user-token-expired",
  USER_NOT_FOUND: "user-token-expired",
  // Other errors.
  TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
  // Phone Auth related errors.
  INVALID_CODE: "invalid-verification-code",
  INVALID_SESSION_INFO: "invalid-verification-id",
  INVALID_TEMPORARY_PROOF: "invalid-credential",
  MISSING_SESSION_INFO: "missing-verification-id",
  SESSION_EXPIRED: "code-expired",
  // Other action code errors when additional settings passed.
  // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
  // This is OK as this error will be caught by client side validation.
  MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
  UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
  // getProjectConfig errors when clientId is passed.
  INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
  // User actions (sign-up or deletion) disabled errors.
  ADMIN_ONLY_OPERATION: "admin-restricted-operation",
  // Multi factor related errors.
  INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
  MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
  MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
  MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
  SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
  SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
  // Blocking functions related errors.
  BLOCKING_FUNCTION_ERROR_RESPONSE: "internal-error"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const zT = new Ls(3e4, 6e4);
function BT(t, e) {
  return t.tenantId && !e.tenantId ? Object.assign(Object.assign({}, e), { tenantId: t.tenantId }) : e;
}
async function xh(t, e, n, r, i = {}) {
  return Cb(t, i, async () => {
    let o = {}, a = {};
    r && (e === "GET" ? a = r : o = {
      body: JSON.stringify(r)
    });
    const s = vh(Object.assign({ key: t.config.apiKey }, a)).slice(1), l = await t._getAdditionalHeaders();
    return l[
      "Content-Type"
      /* CONTENT_TYPE */
    ] = "application/json", t.languageCode && (l[
      "X-Firebase-Locale"
      /* X_FIREBASE_LOCALE */
    ] = t.languageCode), kb.fetch()(xb(t, t.config.apiHost, n, s), Object.assign({
      method: e,
      headers: l,
      referrerPolicy: "no-referrer"
    }, o));
  });
}
async function Cb(t, e, n) {
  t._canInitEmulator = !1;
  const r = Object.assign(Object.assign({}, jT), e);
  try {
    const i = new UT(t), o = await Promise.race([
      n(),
      i.promise
    ]);
    i.clearNetworkTimeout();
    const a = await o.json();
    if ("needConfirmation" in a)
      throw il(t, "account-exists-with-different-credential", a);
    if (o.ok && !("errorMessage" in a))
      return a;
    {
      const s = o.ok ? a.errorMessage : a.error.message, [l, f] = s.split(" : ");
      if (l === "FEDERATED_USER_ID_ALREADY_LINKED")
        throw il(t, "credential-already-in-use", a);
      if (l === "EMAIL_EXISTS")
        throw il(t, "email-already-in-use", a);
      if (l === "USER_DISABLED")
        throw il(t, "user-disabled", a);
      const c = r[l] || l.toLowerCase().replace(/[_\s]+/g, "-");
      if (f)
        throw OT(t, c, f);
      Gl(t, c);
    }
  } catch (i) {
    if (i instanceof Ps)
      throw i;
    Gl(
      t,
      "network-request-failed"
      /* NETWORK_REQUEST_FAILED */
    );
  }
}
async function WT(t, e, n, r, i = {}) {
  const o = await xh(t, e, n, r, i);
  return "mfaPendingCredential" in o && Gl(t, "multi-factor-auth-required", {
    _serverResponse: o
  }), o;
}
function xb(t, e, n, r) {
  const i = `${e}${n}?${r}`;
  return t.config.emulator ? FT(t.config, i) : `${t.config.apiScheme}://${i}`;
}
class UT {
  constructor(e) {
    this.auth = e, this.timer = null, this.promise = new Promise((n, r) => {
      this.timer = setTimeout(() => r(wb(
        this.auth,
        "network-request-failed"
        /* NETWORK_REQUEST_FAILED */
      )), zT.get());
    });
  }
  clearNetworkTimeout() {
    clearTimeout(this.timer);
  }
}
function il(t, e, n) {
  const r = {
    appName: t.name
  };
  n.email && (r.email = n.email), n.phoneNumber && (r.phoneNumber = n.phoneNumber);
  const i = wb(t, e, r);
  return i.customData._tokenResponse = n, i;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function HT(t, e) {
  return xh(t, "POST", "/v1/accounts:delete", e);
}
async function VT(t, e) {
  return xh(t, "POST", "/v1/accounts:lookup", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ra(t) {
  if (t)
    try {
      const e = new Date(Number(t));
      if (!isNaN(e.getTime()))
        return e.toUTCString();
    } catch {
    }
}
async function KT(t, e = !1) {
  const n = gn(t), r = await n.getIdToken(e), i = Eb(r);
  Ie(
    i && i.exp && i.auth_time && i.iat,
    n.auth,
    "internal-error"
    /* INTERNAL_ERROR */
  );
  const o = typeof i.firebase == "object" ? i.firebase : void 0, a = o == null ? void 0 : o.sign_in_provider;
  return {
    claims: i,
    token: r,
    authTime: Ra(Tu(i.auth_time)),
    issuedAtTime: Ra(Tu(i.iat)),
    expirationTime: Ra(Tu(i.exp)),
    signInProvider: a || null,
    signInSecondFactor: (o == null ? void 0 : o.sign_in_second_factor) || null
  };
}
function Tu(t) {
  return Number(t) * 1e3;
}
function Eb(t) {
  var e;
  const [n, r, i] = t.split(".");
  if (n === void 0 || r === void 0 || i === void 0)
    return El("JWT malformed, contained fewer than 3 sections"), null;
  try {
    const o = Nd(r);
    return o ? JSON.parse(o) : (El("Failed to decode base64 JWT payload"), null);
  } catch (o) {
    return El("Caught error parsing JWT payload as JSON", (e = o) === null || e === void 0 ? void 0 : e.toString()), null;
  }
}
function YT(t) {
  const e = Eb(t);
  return Ie(
    e,
    "internal-error"
    /* INTERNAL_ERROR */
  ), Ie(
    typeof e.exp < "u",
    "internal-error"
    /* INTERNAL_ERROR */
  ), Ie(
    typeof e.iat < "u",
    "internal-error"
    /* INTERNAL_ERROR */
  ), Number(e.exp) - Number(e.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Rd(t, e, n = !1) {
  if (n)
    return e;
  try {
    return await e;
  } catch (r) {
    throw r instanceof Ps && qT(r) && t.auth.currentUser === t && await t.auth.signOut(), r;
  }
}
function qT({ code: t }) {
  return t === "auth/user-disabled" || t === "auth/user-token-expired";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class GT {
  constructor(e) {
    this.user = e, this.isRunning = !1, this.timerId = null, this.errorBackoff = 3e4;
  }
  _start() {
    this.isRunning || (this.isRunning = !0, this.schedule());
  }
  _stop() {
    this.isRunning && (this.isRunning = !1, this.timerId !== null && clearTimeout(this.timerId));
  }
  getInterval(e) {
    var n;
    if (e) {
      const r = this.errorBackoff;
      return this.errorBackoff = Math.min(
        this.errorBackoff * 2,
        96e4
        /* RETRY_BACKOFF_MAX */
      ), r;
    } else {
      this.errorBackoff = 3e4;
      const i = ((n = this.user.stsTokenManager.expirationTime) !== null && n !== void 0 ? n : 0) - Date.now() - 3e5;
      return Math.max(0, i);
    }
  }
  schedule(e = !1) {
    if (!this.isRunning)
      return;
    const n = this.getInterval(e);
    this.timerId = setTimeout(async () => {
      await this.iteration();
    }, n);
  }
  async iteration() {
    var e;
    try {
      await this.user.getIdToken(!0);
    } catch (n) {
      ((e = n) === null || e === void 0 ? void 0 : e.code) === "auth/network-request-failed" && this.schedule(
        /* wasError */
        !0
      );
      return;
    }
    this.schedule();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Tb {
  constructor(e, n) {
    this.createdAt = e, this.lastLoginAt = n, this._initializeTime();
  }
  _initializeTime() {
    this.lastSignInTime = Ra(this.lastLoginAt), this.creationTime = Ra(this.createdAt);
  }
  _copy(e) {
    this.createdAt = e.createdAt, this.lastLoginAt = e.lastLoginAt, this._initializeTime();
  }
  toJSON() {
    return {
      createdAt: this.createdAt,
      lastLoginAt: this.lastLoginAt
    };
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Xl(t) {
  var e;
  const n = t.auth, r = await t.getIdToken(), i = await Rd(t, VT(n, { idToken: r }));
  Ie(
    i == null ? void 0 : i.users.length,
    n,
    "internal-error"
    /* INTERNAL_ERROR */
  );
  const o = i.users[0];
  t._notifyReloadListener(o);
  const a = !((e = o.providerUserInfo) === null || e === void 0) && e.length ? JT(o.providerUserInfo) : [], s = XT(t.providerData, a), l = t.isAnonymous, f = !(t.email && o.passwordHash) && !(s != null && s.length), c = l ? f : !1, u = {
    uid: o.localId,
    displayName: o.displayName || null,
    photoURL: o.photoUrl || null,
    email: o.email || null,
    emailVerified: o.emailVerified || !1,
    phoneNumber: o.phoneNumber || null,
    tenantId: o.tenantId || null,
    providerData: s,
    metadata: new Tb(o.createdAt, o.lastLoginAt),
    isAnonymous: c
  };
  Object.assign(t, u);
}
async function QT(t) {
  const e = gn(t);
  await Xl(e), await e.auth._persistUserIfCurrent(e), e.auth._notifyListenersIfCurrent(e);
}
function XT(t, e) {
  return [...t.filter((r) => !e.some((i) => i.providerId === r.providerId)), ...e];
}
function JT(t) {
  return t.map((e) => {
    var { providerId: n } = e, r = bb(e, ["providerId"]);
    return {
      providerId: n,
      uid: r.rawId || "",
      displayName: r.displayName || null,
      email: r.email || null,
      phoneNumber: r.phoneNumber || null,
      photoURL: r.photoUrl || null
    };
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ZT(t, e) {
  const n = await Cb(t, {}, async () => {
    const r = vh({
      grant_type: "refresh_token",
      refresh_token: e
    }).slice(1), { tokenApiHost: i, apiKey: o } = t.config, a = xb(t, i, "/v1/token", `key=${o}`), s = await t._getAdditionalHeaders();
    return s[
      "Content-Type"
      /* CONTENT_TYPE */
    ] = "application/x-www-form-urlencoded", kb.fetch()(a, {
      method: "POST",
      headers: s,
      body: r
    });
  });
  return {
    accessToken: n.access_token,
    expiresIn: n.expires_in,
    refreshToken: n.refresh_token
  };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class os {
  constructor() {
    this.refreshToken = null, this.accessToken = null, this.expirationTime = null;
  }
  get isExpired() {
    return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
  }
  updateFromServerResponse(e) {
    Ie(
      e.idToken,
      "internal-error"
      /* INTERNAL_ERROR */
    ), Ie(
      typeof e.idToken < "u",
      "internal-error"
      /* INTERNAL_ERROR */
    ), Ie(
      typeof e.refreshToken < "u",
      "internal-error"
      /* INTERNAL_ERROR */
    );
    const n = "expiresIn" in e && typeof e.expiresIn < "u" ? Number(e.expiresIn) : YT(e.idToken);
    this.updateTokensAndExpiration(e.idToken, e.refreshToken, n);
  }
  async getToken(e, n = !1) {
    return Ie(
      !this.accessToken || this.refreshToken,
      e,
      "user-token-expired"
      /* TOKEN_EXPIRED */
    ), !n && this.accessToken && !this.isExpired ? this.accessToken : this.refreshToken ? (await this.refresh(e, this.refreshToken), this.accessToken) : null;
  }
  clearRefreshToken() {
    this.refreshToken = null;
  }
  async refresh(e, n) {
    const { accessToken: r, refreshToken: i, expiresIn: o } = await ZT(e, n);
    this.updateTokensAndExpiration(r, i, Number(o));
  }
  updateTokensAndExpiration(e, n, r) {
    this.refreshToken = n || null, this.accessToken = e || null, this.expirationTime = Date.now() + r * 1e3;
  }
  static fromJSON(e, n) {
    const { refreshToken: r, accessToken: i, expirationTime: o } = n, a = new os();
    return r && (Ie(typeof r == "string", "internal-error", {
      appName: e
    }), a.refreshToken = r), i && (Ie(typeof i == "string", "internal-error", {
      appName: e
    }), a.accessToken = i), o && (Ie(typeof o == "number", "internal-error", {
      appName: e
    }), a.expirationTime = o), a;
  }
  toJSON() {
    return {
      refreshToken: this.refreshToken,
      accessToken: this.accessToken,
      expirationTime: this.expirationTime
    };
  }
  _assign(e) {
    this.accessToken = e.accessToken, this.refreshToken = e.refreshToken, this.expirationTime = e.expirationTime;
  }
  _clone() {
    return Object.assign(new os(), this.toJSON());
  }
  _performRefresh() {
    return Pa("not implemented");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function br(t, e) {
  Ie(typeof t == "string" || typeof t > "u", "internal-error", { appName: e });
}
class ri {
  constructor(e) {
    var { uid: n, auth: r, stsTokenManager: i } = e, o = bb(e, ["uid", "auth", "stsTokenManager"]);
    this.providerId = "firebase", this.proactiveRefresh = new GT(this), this.reloadUserInfo = null, this.reloadListener = null, this.uid = n, this.auth = r, this.stsTokenManager = i, this.accessToken = i.accessToken, this.displayName = o.displayName || null, this.email = o.email || null, this.emailVerified = o.emailVerified || !1, this.phoneNumber = o.phoneNumber || null, this.photoURL = o.photoURL || null, this.isAnonymous = o.isAnonymous || !1, this.tenantId = o.tenantId || null, this.providerData = o.providerData ? [...o.providerData] : [], this.metadata = new Tb(o.createdAt || void 0, o.lastLoginAt || void 0);
  }
  async getIdToken(e) {
    const n = await Rd(this, this.stsTokenManager.getToken(this.auth, e));
    return Ie(
      n,
      this.auth,
      "internal-error"
      /* INTERNAL_ERROR */
    ), this.accessToken !== n && (this.accessToken = n, await this.auth._persistUserIfCurrent(this), this.auth._notifyListenersIfCurrent(this)), n;
  }
  getIdTokenResult(e) {
    return KT(this, e);
  }
  reload() {
    return QT(this);
  }
  _assign(e) {
    this !== e && (Ie(
      this.uid === e.uid,
      this.auth,
      "internal-error"
      /* INTERNAL_ERROR */
    ), this.displayName = e.displayName, this.photoURL = e.photoURL, this.email = e.email, this.emailVerified = e.emailVerified, this.phoneNumber = e.phoneNumber, this.isAnonymous = e.isAnonymous, this.tenantId = e.tenantId, this.providerData = e.providerData.map((n) => Object.assign({}, n)), this.metadata._copy(e.metadata), this.stsTokenManager._assign(e.stsTokenManager));
  }
  _clone(e) {
    return new ri(Object.assign(Object.assign({}, this), { auth: e, stsTokenManager: this.stsTokenManager._clone() }));
  }
  _onReload(e) {
    Ie(
      !this.reloadListener,
      this.auth,
      "internal-error"
      /* INTERNAL_ERROR */
    ), this.reloadListener = e, this.reloadUserInfo && (this._notifyReloadListener(this.reloadUserInfo), this.reloadUserInfo = null);
  }
  _notifyReloadListener(e) {
    this.reloadListener ? this.reloadListener(e) : this.reloadUserInfo = e;
  }
  _startProactiveRefresh() {
    this.proactiveRefresh._start();
  }
  _stopProactiveRefresh() {
    this.proactiveRefresh._stop();
  }
  async _updateTokensIfNecessary(e, n = !1) {
    let r = !1;
    e.idToken && e.idToken !== this.stsTokenManager.accessToken && (this.stsTokenManager.updateFromServerResponse(e), r = !0), n && await Xl(this), await this.auth._persistUserIfCurrent(this), r && this.auth._notifyListenersIfCurrent(this);
  }
  async delete() {
    const e = await this.getIdToken();
    return await Rd(this, HT(this.auth, { idToken: e })), this.stsTokenManager.clearRefreshToken(), this.auth.signOut();
  }
  toJSON() {
    return Object.assign(Object.assign({
      uid: this.uid,
      email: this.email || void 0,
      emailVerified: this.emailVerified,
      displayName: this.displayName || void 0,
      isAnonymous: this.isAnonymous,
      photoURL: this.photoURL || void 0,
      phoneNumber: this.phoneNumber || void 0,
      tenantId: this.tenantId || void 0,
      providerData: this.providerData.map((e) => Object.assign({}, e)),
      stsTokenManager: this.stsTokenManager.toJSON(),
      // Redirect event ID must be maintained in case there is a pending
      // redirect event.
      _redirectEventId: this._redirectEventId
    }, this.metadata.toJSON()), {
      // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
      apiKey: this.auth.config.apiKey,
      appName: this.auth.name
    });
  }
  get refreshToken() {
    return this.stsTokenManager.refreshToken || "";
  }
  static _fromJSON(e, n) {
    var r, i, o, a, s, l, f, c;
    const u = (r = n.displayName) !== null && r !== void 0 ? r : void 0, d = (i = n.email) !== null && i !== void 0 ? i : void 0, h = (o = n.phoneNumber) !== null && o !== void 0 ? o : void 0, p = (a = n.photoURL) !== null && a !== void 0 ? a : void 0, m = (s = n.tenantId) !== null && s !== void 0 ? s : void 0, v = (l = n._redirectEventId) !== null && l !== void 0 ? l : void 0, b = (f = n.createdAt) !== null && f !== void 0 ? f : void 0, k = (c = n.lastLoginAt) !== null && c !== void 0 ? c : void 0, { uid: _, emailVerified: E, isAnonymous: S, providerData: C, stsTokenManager: N } = n;
    Ie(
      _ && N,
      e,
      "internal-error"
      /* INTERNAL_ERROR */
    );
    const $ = os.fromJSON(this.name, N);
    Ie(
      typeof _ == "string",
      e,
      "internal-error"
      /* INTERNAL_ERROR */
    ), br(u, e.name), br(d, e.name), Ie(
      typeof E == "boolean",
      e,
      "internal-error"
      /* INTERNAL_ERROR */
    ), Ie(
      typeof S == "boolean",
      e,
      "internal-error"
      /* INTERNAL_ERROR */
    ), br(h, e.name), br(p, e.name), br(m, e.name), br(v, e.name), br(b, e.name), br(k, e.name);
    const I = new ri({
      uid: _,
      auth: e,
      email: d,
      emailVerified: E,
      displayName: u,
      isAnonymous: S,
      photoURL: p,
      phoneNumber: h,
      tenantId: m,
      stsTokenManager: $,
      createdAt: b,
      lastLoginAt: k
    });
    return C && Array.isArray(C) && (I.providerData = C.map((O) => Object.assign({}, O))), v && (I._redirectEventId = v), I;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromIdTokenResponse(e, n, r = !1) {
    const i = new os();
    i.updateFromServerResponse(n);
    const o = new ri({
      uid: n.localId,
      auth: e,
      stsTokenManager: i,
      isAnonymous: r
    });
    return await Xl(o), o;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Sb {
  constructor() {
    this.type = "NONE", this.storage = {};
  }
  async _isAvailable() {
    return !0;
  }
  async _set(e, n) {
    this.storage[e] = n;
  }
  async _get(e) {
    const n = this.storage[e];
    return n === void 0 ? null : n;
  }
  async _remove(e) {
    delete this.storage[e];
  }
  _addListener(e, n) {
  }
  _removeListener(e, n) {
  }
}
Sb.type = "NONE";
const Ld = Sb;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Su(t, e, n) {
  return `firebase:${t}:${e}:${n}`;
}
class go {
  constructor(e, n, r) {
    this.persistence = e, this.auth = n, this.userKey = r;
    const { config: i, name: o } = this.auth;
    this.fullUserKey = Su(this.userKey, i.apiKey, o), this.fullPersistenceKey = Su("persistence", i.apiKey, o), this.boundEventHandler = n._onStorageEvent.bind(n), this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
  }
  setCurrentUser(e) {
    return this.persistence._set(this.fullUserKey, e.toJSON());
  }
  async getCurrentUser() {
    const e = await this.persistence._get(this.fullUserKey);
    return e ? ri._fromJSON(this.auth, e) : null;
  }
  removeCurrentUser() {
    return this.persistence._remove(this.fullUserKey);
  }
  savePersistenceForRedirect() {
    return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
  }
  async setPersistence(e) {
    if (this.persistence === e)
      return;
    const n = await this.getCurrentUser();
    if (await this.removeCurrentUser(), this.persistence = e, n)
      return this.setCurrentUser(n);
  }
  delete() {
    this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
  }
  static async create(e, n, r = "authUser") {
    if (!n.length)
      return new go(ei(Ld), e, r);
    const i = (await Promise.all(n.map(async (f) => {
      if (await f._isAvailable())
        return f;
    }))).filter((f) => f);
    let o = i[0] || ei(Ld);
    const a = Su(r, e.config.apiKey, e.name);
    let s = null;
    for (const f of n)
      try {
        const c = await f._get(a);
        if (c) {
          const u = ri._fromJSON(e, c);
          f !== o && (s = u), o = f;
          break;
        }
      } catch {
      }
    const l = i.filter((f) => f._shouldAllowMigration);
    return !o._shouldAllowMigration || !l.length ? new go(o, e, r) : (o = l[0], s && await o._set(a, s.toJSON()), await Promise.all(n.map(async (f) => {
      if (f !== o)
        try {
          await f._remove(a);
        } catch {
        }
    })), new go(o, e, r));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function fp(t) {
  const e = t.toLowerCase();
  if (e.includes("opera/") || e.includes("opr/") || e.includes("opios/"))
    return "Opera";
  if (rS(e))
    return "IEMobile";
  if (e.includes("msie") || e.includes("trident/"))
    return "IE";
  if (e.includes("edge/"))
    return "Edge";
  if (eS(e))
    return "Firefox";
  if (e.includes("silk/"))
    return "Silk";
  if (oS(e))
    return "Blackberry";
  if (aS(e))
    return "Webos";
  if (tS(e))
    return "Safari";
  if ((e.includes("chrome/") || nS(e)) && !e.includes("edge/"))
    return "Chrome";
  if (iS(e))
    return "Android";
  {
    const n = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/, r = t.match(n);
    if ((r == null ? void 0 : r.length) === 2)
      return r[1];
  }
  return "Other";
}
function eS(t = Hn()) {
  return /firefox\//i.test(t);
}
function tS(t = Hn()) {
  const e = t.toLowerCase();
  return e.includes("safari/") && !e.includes("chrome/") && !e.includes("crios/") && !e.includes("android");
}
function nS(t = Hn()) {
  return /crios\//i.test(t);
}
function rS(t = Hn()) {
  return /iemobile/i.test(t);
}
function iS(t = Hn()) {
  return /android/i.test(t);
}
function oS(t = Hn()) {
  return /blackberry/i.test(t);
}
function aS(t = Hn()) {
  return /webos/i.test(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ib(t, e = []) {
  let n;
  switch (t) {
    case "Browser":
      n = fp(Hn());
      break;
    case "Worker":
      n = `${fp(Hn())}-${t}`;
      break;
    default:
      n = t;
  }
  const r = e.length ? e.join(",") : "FirebaseCore-web";
  return `${n}/JsCore/${wh}/${r}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class sS {
  constructor(e) {
    this.auth = e, this.queue = [];
  }
  pushCallback(e, n) {
    const r = (o) => new Promise((a, s) => {
      try {
        const l = e(o);
        a(l);
      } catch (l) {
        s(l);
      }
    });
    r.onAbort = n, this.queue.push(r);
    const i = this.queue.length - 1;
    return () => {
      this.queue[i] = () => Promise.resolve();
    };
  }
  async runMiddleware(e) {
    var n;
    if (this.auth.currentUser === e)
      return;
    const r = [];
    try {
      for (const i of this.queue)
        await i(e), i.onAbort && r.push(i.onAbort);
    } catch (i) {
      r.reverse();
      for (const o of r)
        try {
          o();
        } catch {
        }
      throw this.auth._errorFactory.create("login-blocked", { originalMessage: (n = i) === null || n === void 0 ? void 0 : n.message });
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class lS {
  constructor(e, n, r) {
    this.app = e, this.heartbeatServiceProvider = n, this.config = r, this.currentUser = null, this.emulatorConfig = null, this.operations = Promise.resolve(), this.authStateSubscription = new cp(this), this.idTokenSubscription = new cp(this), this.beforeStateQueue = new sS(this), this.redirectUser = null, this.isProactiveRefreshEnabled = !1, this._canInitEmulator = !0, this._isInitialized = !1, this._deleted = !1, this._initializationPromise = null, this._popupRedirectResolver = null, this._errorFactory = _b, this.lastNotifiedUid = void 0, this.languageCode = null, this.tenantId = null, this.settings = { appVerificationDisabledForTesting: !1 }, this.frameworks = [], this.name = e.name, this.clientVersion = r.sdkClientVersion;
  }
  _initializeWithPersistence(e, n) {
    return n && (this._popupRedirectResolver = ei(n)), this._initializationPromise = this.queue(async () => {
      var r, i;
      if (!this._deleted && (this.persistenceManager = await go.create(this, e), !this._deleted)) {
        if (!((r = this._popupRedirectResolver) === null || r === void 0) && r._shouldInitProactively)
          try {
            await this._popupRedirectResolver._initialize(this);
          } catch {
          }
        await this.initializeCurrentUser(n), this.lastNotifiedUid = ((i = this.currentUser) === null || i === void 0 ? void 0 : i.uid) || null, !this._deleted && (this._isInitialized = !0);
      }
    }), this._initializationPromise;
  }
  /**
   * If the persistence is changed in another window, the user manager will let us know
   */
  async _onStorageEvent() {
    if (this._deleted)
      return;
    const e = await this.assertedPersistence.getCurrentUser();
    if (!(!this.currentUser && !e)) {
      if (this.currentUser && e && this.currentUser.uid === e.uid) {
        this._currentUser._assign(e), await this.currentUser.getIdToken();
        return;
      }
      await this._updateCurrentUser(
        e,
        /* skipBeforeStateCallbacks */
        !0
      );
    }
  }
  async initializeCurrentUser(e) {
    var n;
    const r = await this.assertedPersistence.getCurrentUser();
    let i = r, o = !1;
    if (e && this.config.authDomain) {
      await this.getOrInitRedirectPersistenceManager();
      const a = (n = this.redirectUser) === null || n === void 0 ? void 0 : n._redirectEventId, s = i == null ? void 0 : i._redirectEventId, l = await this.tryRedirectSignIn(e);
      (!a || a === s) && (l != null && l.user) && (i = l.user, o = !0);
    }
    if (!i)
      return this.directlySetCurrentUser(null);
    if (!i._redirectEventId) {
      if (o)
        try {
          await this.beforeStateQueue.runMiddleware(i);
        } catch (a) {
          i = r, this._popupRedirectResolver._overrideRedirectResult(this, () => Promise.reject(a));
        }
      return i ? this.reloadAndSetCurrentUserOrClear(i) : this.directlySetCurrentUser(null);
    }
    return Ie(
      this._popupRedirectResolver,
      this,
      "argument-error"
      /* ARGUMENT_ERROR */
    ), await this.getOrInitRedirectPersistenceManager(), this.redirectUser && this.redirectUser._redirectEventId === i._redirectEventId ? this.directlySetCurrentUser(i) : this.reloadAndSetCurrentUserOrClear(i);
  }
  async tryRedirectSignIn(e) {
    let n = null;
    try {
      n = await this._popupRedirectResolver._completeRedirectFn(this, e, !0);
    } catch {
      await this._setRedirectUser(null);
    }
    return n;
  }
  async reloadAndSetCurrentUserOrClear(e) {
    var n;
    try {
      await Xl(e);
    } catch (r) {
      if (((n = r) === null || n === void 0 ? void 0 : n.code) !== "auth/network-request-failed")
        return this.directlySetCurrentUser(null);
    }
    return this.directlySetCurrentUser(e);
  }
  useDeviceLanguage() {
    this.languageCode = $T();
  }
  async _delete() {
    this._deleted = !0;
  }
  async updateCurrentUser(e) {
    const n = e ? gn(e) : null;
    return n && Ie(
      n.auth.config.apiKey === this.config.apiKey,
      this,
      "invalid-user-token"
      /* INVALID_AUTH */
    ), this._updateCurrentUser(n && n._clone(this));
  }
  async _updateCurrentUser(e, n = !1) {
    if (!this._deleted)
      return e && Ie(
        this.tenantId === e.tenantId,
        this,
        "tenant-id-mismatch"
        /* TENANT_ID_MISMATCH */
      ), n || await this.beforeStateQueue.runMiddleware(e), this.queue(async () => {
        await this.directlySetCurrentUser(e), this.notifyAuthListeners();
      });
  }
  async signOut() {
    return await this.beforeStateQueue.runMiddleware(null), (this.redirectPersistenceManager || this._popupRedirectResolver) && await this._setRedirectUser(null), this._updateCurrentUser(
      null,
      /* skipBeforeStateCallbacks */
      !0
    );
  }
  setPersistence(e) {
    return this.queue(async () => {
      await this.assertedPersistence.setPersistence(ei(e));
    });
  }
  _getPersistence() {
    return this.assertedPersistence.persistence.type;
  }
  _updateErrorMap(e) {
    this._errorFactory = new Rs("auth", "Firebase", e());
  }
  onAuthStateChanged(e, n, r) {
    return this.registerStateListener(this.authStateSubscription, e, n, r);
  }
  beforeAuthStateChanged(e, n) {
    return this.beforeStateQueue.pushCallback(e, n);
  }
  onIdTokenChanged(e, n, r) {
    return this.registerStateListener(this.idTokenSubscription, e, n, r);
  }
  toJSON() {
    var e;
    return {
      apiKey: this.config.apiKey,
      authDomain: this.config.authDomain,
      appName: this.name,
      currentUser: (e = this._currentUser) === null || e === void 0 ? void 0 : e.toJSON()
    };
  }
  async _setRedirectUser(e, n) {
    const r = await this.getOrInitRedirectPersistenceManager(n);
    return e === null ? r.removeCurrentUser() : r.setCurrentUser(e);
  }
  async getOrInitRedirectPersistenceManager(e) {
    if (!this.redirectPersistenceManager) {
      const n = e && ei(e) || this._popupRedirectResolver;
      Ie(
        n,
        this,
        "argument-error"
        /* ARGUMENT_ERROR */
      ), this.redirectPersistenceManager = await go.create(
        this,
        [ei(n._redirectPersistence)],
        "redirectUser"
        /* REDIRECT_USER */
      ), this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
    }
    return this.redirectPersistenceManager;
  }
  async _redirectUserForId(e) {
    var n, r;
    return this._isInitialized && await this.queue(async () => {
    }), ((n = this._currentUser) === null || n === void 0 ? void 0 : n._redirectEventId) === e ? this._currentUser : ((r = this.redirectUser) === null || r === void 0 ? void 0 : r._redirectEventId) === e ? this.redirectUser : null;
  }
  async _persistUserIfCurrent(e) {
    if (e === this.currentUser)
      return this.queue(async () => this.directlySetCurrentUser(e));
  }
  /** Notifies listeners only if the user is current */
  _notifyListenersIfCurrent(e) {
    e === this.currentUser && this.notifyAuthListeners();
  }
  _key() {
    return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
  }
  _startProactiveRefresh() {
    this.isProactiveRefreshEnabled = !0, this.currentUser && this._currentUser._startProactiveRefresh();
  }
  _stopProactiveRefresh() {
    this.isProactiveRefreshEnabled = !1, this.currentUser && this._currentUser._stopProactiveRefresh();
  }
  /** Returns the current user cast as the internal type */
  get _currentUser() {
    return this.currentUser;
  }
  notifyAuthListeners() {
    var e, n;
    if (!this._isInitialized)
      return;
    this.idTokenSubscription.next(this.currentUser);
    const r = (n = (e = this.currentUser) === null || e === void 0 ? void 0 : e.uid) !== null && n !== void 0 ? n : null;
    this.lastNotifiedUid !== r && (this.lastNotifiedUid = r, this.authStateSubscription.next(this.currentUser));
  }
  registerStateListener(e, n, r, i) {
    if (this._deleted)
      return () => {
      };
    const o = typeof n == "function" ? n : n.next.bind(n), a = this._isInitialized ? Promise.resolve() : this._initializationPromise;
    return Ie(
      a,
      this,
      "internal-error"
      /* INTERNAL_ERROR */
    ), a.then(() => o(this.currentUser)), typeof n == "function" ? e.addObserver(n, r, i) : e.addObserver(n);
  }
  /**
   * Unprotected (from race conditions) method to set the current user. This
   * should only be called from within a queued callback. This is necessary
   * because the queue shouldn't rely on another queued callback.
   */
  async directlySetCurrentUser(e) {
    this.currentUser && this.currentUser !== e && (this._currentUser._stopProactiveRefresh(), e && this.isProactiveRefreshEnabled && e._startProactiveRefresh()), this.currentUser = e, e ? await this.assertedPersistence.setCurrentUser(e) : await this.assertedPersistence.removeCurrentUser();
  }
  queue(e) {
    return this.operations = this.operations.then(e, e), this.operations;
  }
  get assertedPersistence() {
    return Ie(
      this.persistenceManager,
      this,
      "internal-error"
      /* INTERNAL_ERROR */
    ), this.persistenceManager;
  }
  _logFramework(e) {
    !e || this.frameworks.includes(e) || (this.frameworks.push(e), this.frameworks.sort(), this.clientVersion = Ib(this.config.clientPlatform, this._getFrameworks()));
  }
  _getFrameworks() {
    return this.frameworks;
  }
  async _getAdditionalHeaders() {
    var e;
    const n = {
      [
        "X-Client-Version"
        /* X_CLIENT_VERSION */
      ]: this.clientVersion
    };
    this.app.options.appId && (n[
      "X-Firebase-gmpid"
      /* X_FIREBASE_GMPID */
    ] = this.app.options.appId);
    const r = await ((e = this.heartbeatServiceProvider.getImmediate({
      optional: !0
    })) === null || e === void 0 ? void 0 : e.getHeartbeatsHeader());
    return r && (n[
      "X-Firebase-Client"
      /* X_FIREBASE_CLIENT */
    ] = r), n;
  }
}
function Nb(t) {
  return gn(t);
}
class cp {
  constructor(e) {
    this.auth = e, this.observer = null, this.addObserver = wE((n) => this.observer = n);
  }
  get next() {
    return Ie(
      this.observer,
      this.auth,
      "internal-error"
      /* INTERNAL_ERROR */
    ), this.observer.next.bind(this.observer);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Jl {
  constructor(e) {
    this.user = e.user, this.providerId = e.providerId, this._tokenResponse = e._tokenResponse, this.operationType = e.operationType;
  }
  static async _fromIdTokenResponse(e, n, r, i = !1) {
    const o = await ri._fromIdTokenResponse(e, r, i), a = up(r);
    return new Jl({
      user: o,
      providerId: a,
      _tokenResponse: r,
      operationType: n
    });
  }
  static async _forOperation(e, n, r) {
    await e._updateTokensIfNecessary(
      r,
      /* reload */
      !0
    );
    const i = up(r);
    return new Jl({
      user: e,
      providerId: i,
      _tokenResponse: r,
      operationType: n
    });
  }
}
function up(t) {
  return t.providerId ? t.providerId : "phoneNumber" in t ? "phone" : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function fS(t, e) {
  return WT(t, "POST", "/v1/accounts:signInWithCustomToken", BT(t, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function dp(t, e) {
  const n = Nb(t), r = await fS(n, {
    token: e,
    returnSecureToken: !0
  }), i = await Jl._fromIdTokenResponse(n, "signIn", r);
  return await n._updateCurrentUser(i.user), i;
}
new Ls(3e4, 6e4);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
new Ls(2e3, 1e4);
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
new Ls(3e4, 6e4);
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
new Ls(5e3, 15e3);
var hp = "@firebase/auth", gp = "0.20.5";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class cS {
  constructor(e) {
    this.auth = e, this.internalListeners = /* @__PURE__ */ new Map();
  }
  getUid() {
    var e;
    return this.assertAuthConfigured(), ((e = this.auth.currentUser) === null || e === void 0 ? void 0 : e.uid) || null;
  }
  async getToken(e) {
    return this.assertAuthConfigured(), await this.auth._initializationPromise, this.auth.currentUser ? { accessToken: await this.auth.currentUser.getIdToken(e) } : null;
  }
  addAuthTokenListener(e) {
    if (this.assertAuthConfigured(), this.internalListeners.has(e))
      return;
    const n = this.auth.onIdTokenChanged((r) => {
      var i;
      e(((i = r) === null || i === void 0 ? void 0 : i.stsTokenManager.accessToken) || null);
    });
    this.internalListeners.set(e, n), this.updateProactiveRefresh();
  }
  removeAuthTokenListener(e) {
    this.assertAuthConfigured();
    const n = this.internalListeners.get(e);
    n && (this.internalListeners.delete(e), n(), this.updateProactiveRefresh());
  }
  assertAuthConfigured() {
    Ie(
      this.auth._initializationPromise,
      "dependent-sdk-initialized-before-auth"
      /* DEPENDENT_SDK_INIT_BEFORE_AUTH */
    );
  }
  updateProactiveRefresh() {
    this.internalListeners.size > 0 ? this.auth._startProactiveRefresh() : this.auth._stopProactiveRefresh();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function uS(t) {
  switch (t) {
    case "Node":
      return "node";
    case "ReactNative":
      return "rn";
    case "Worker":
      return "webworker";
    case "Cordova":
      return "cordova";
    default:
      return;
  }
}
function dS(t) {
  xo(new gi(
    "auth",
    (e, { options: n }) => {
      const r = e.getProvider("app").getImmediate(), i = e.getProvider("heartbeat"), { apiKey: o, authDomain: a } = r.options;
      return ((s, l) => {
        Ie(o && !o.includes(":"), "invalid-api-key", { appName: s.name }), Ie(!(a != null && a.includes(":")), "argument-error", {
          appName: s.name
        });
        const f = {
          apiKey: o,
          authDomain: a,
          clientPlatform: t,
          apiHost: "identitytoolkit.googleapis.com",
          tokenApiHost: "securetoken.googleapis.com",
          apiScheme: "https",
          sdkClientVersion: Ib(t)
        }, c = new lS(s, l, f);
        return PT(c, n), c;
      })(r, i);
    },
    "PUBLIC"
    /* PUBLIC */
  ).setInstantiationMode(
    "EXPLICIT"
    /* EXPLICIT */
  ).setInstanceCreatedCallback((e, n, r) => {
    e.getProvider(
      "auth-internal"
      /* AUTH_INTERNAL */
    ).initialize();
  })), xo(new gi(
    "auth-internal",
    (e) => {
      const n = Nb(e.getProvider(
        "auth"
        /* AUTH */
      ).getImmediate());
      return ((r) => new cS(r))(n);
    },
    "PRIVATE"
    /* PRIVATE */
  ).setInstantiationMode(
    "EXPLICIT"
    /* EXPLICIT */
  )), Tr(hp, gp, uS(t)), Tr(hp, gp, "esm2017");
}
dS(
  "Browser"
  /* BROWSER */
);
var hS = "firebase", gS = "9.9.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Tr(hS, gS, "app");
const pS = Symbol(), Eh = Symbol(), ba = "a", La = "w";
let mS = (t, e) => new Proxy(t, e);
const $d = Object.getPrototypeOf, Fd = /* @__PURE__ */ new WeakMap(), Mb = (t) => t && (Fd.has(t) ? Fd.get(t) : $d(t) === Object.prototype || $d(t) === Array.prototype), Zl = (t) => typeof t == "object" && t !== null, vS = (t) => {
  if (Array.isArray(t))
    return Array.from(t);
  const e = Object.getOwnPropertyDescriptors(t);
  return Object.values(e).forEach((n) => {
    n.configurable = !0;
  }), Object.create($d(t), e);
}, Th = (t) => t[Eh] || t, Ab = (t, e, n, r) => {
  if (!Mb(t))
    return t;
  let i = r && r.get(t);
  if (!i) {
    const l = Th(t);
    i = ((f) => Object.values(Object.getOwnPropertyDescriptors(f)).some((c) => !c.configurable && !c.writable))(l) ? [l, vS(l)] : [l], r == null || r.set(t, i);
  }
  const [o, a] = i;
  let s = n && n.get(o);
  return s && s[1].f === !!a || (s = ((l, f) => {
    const c = { f };
    let u = !1;
    const d = (p, m) => {
      if (!u) {
        let v = c[ba].get(l);
        if (v || (v = {}, c[ba].set(l, v)), p === La)
          v[La] = !0;
        else {
          let b = v[p];
          b || (b = /* @__PURE__ */ new Set(), v[p] = b), b.add(m);
        }
      }
    }, h = { get: (p, m) => m === Eh ? l : (d("k", m), Ab(Reflect.get(p, m), c[ba], c.c)), has: (p, m) => m === pS ? (u = !0, c[ba].delete(l), !0) : (d("h", m), Reflect.has(p, m)), getOwnPropertyDescriptor: (p, m) => (d("o", m), Reflect.getOwnPropertyDescriptor(p, m)), ownKeys: (p) => (d(La), Reflect.ownKeys(p)) };
    return f && (h.set = h.deleteProperty = () => !1), [h, c];
  })(o, !!a), s[1].p = mS(a || o, s[0]), n && n.set(o, s)), s[1][ba] = e, s[1].c = n, s[1].p;
}, Ob = (t, e, n, r) => {
  if (Object.is(t, e))
    return !1;
  if (!Zl(t) || !Zl(e))
    return !0;
  const i = n.get(Th(t));
  if (!i)
    return !0;
  if (r) {
    const a = r.get(t);
    if (a && a.n === e)
      return a.g;
    r.set(t, { n: e, g: !1 });
  }
  let o = null;
  try {
    for (const a of i.h || [])
      if (o = Reflect.has(t, a) !== Reflect.has(e, a), o)
        return o;
    if (i[La] === !0) {
      if (o = ((a, s) => {
        const l = Reflect.ownKeys(a), f = Reflect.ownKeys(s);
        return l.length !== f.length || l.some((c, u) => c !== f[u]);
      })(t, e), o)
        return o;
    } else
      for (const a of i.o || [])
        if (o = !!Reflect.getOwnPropertyDescriptor(t, a) != !!Reflect.getOwnPropertyDescriptor(e, a), o)
          return o;
    for (const a of i.k || [])
      if (o = Ob(t[a], e[a], n, r), o)
        return o;
    return o === null && (o = !0), o;
  } finally {
    r && r.set(t, { n: e, g: o });
  }
}, bS = (t) => Mb(t) && t[Eh] || null, pp = (t, e = !0) => {
  Fd.set(t, e);
}, yS = (t, e, n) => {
  const r = [], i = /* @__PURE__ */ new WeakSet(), o = (a, s) => {
    if (i.has(a))
      return;
    Zl(a) && i.add(a);
    const l = Zl(a) && e.get(Th(a));
    if (l) {
      var f, c;
      if ((f = l.h) == null || f.forEach((d) => {
        const h = `:has(${String(d)})`;
        r.push(s ? [...s, h] : [h]);
      }), l[La] === !0) {
        const d = ":ownKeys";
        r.push(s ? [...s, d] : [d]);
      } else {
        var u;
        (u = l.o) == null || u.forEach((d) => {
          const h = `:hasOwn(${String(d)})`;
          r.push(s ? [...s, h] : [h]);
        });
      }
      (c = l.k) == null || c.forEach((d) => {
        n && !("value" in (Object.getOwnPropertyDescriptor(a, d) || {})) || o(a[d], s ? [...s, d] : [d]);
      });
    } else
      s && r.push(s);
  };
  return o(t), r;
}, Iu = (t) => typeof t == "object" && t !== null, or = /* @__PURE__ */ new WeakMap(), Ta = /* @__PURE__ */ new WeakSet(), _S = (t = Object.is, e = (f, c) => new Proxy(f, c), n = (f) => Iu(f) && !Ta.has(f) && (Array.isArray(f) || !(Symbol.iterator in f)) && !(f instanceof WeakMap) && !(f instanceof WeakSet) && !(f instanceof Error) && !(f instanceof Number) && !(f instanceof Date) && !(f instanceof String) && !(f instanceof RegExp) && !(f instanceof ArrayBuffer), r = (f) => {
  switch (f.status) {
    case "fulfilled":
      return f.value;
    case "rejected":
      throw f.reason;
    default:
      throw f;
  }
}, i = /* @__PURE__ */ new WeakMap(), o = (f, c, u = r) => {
  const d = i.get(f);
  if ((d == null ? void 0 : d[0]) === c)
    return d[1];
  const h = Array.isArray(f) ? [] : Object.create(Object.getPrototypeOf(f));
  return pp(h, !0), i.set(f, [c, h]), Reflect.ownKeys(f).forEach((p) => {
    if (Object.getOwnPropertyDescriptor(h, p))
      return;
    const m = Reflect.get(f, p), v = {
      value: m,
      enumerable: !0,
      // This is intentional to avoid copying with proxy-compare.
      // It's still non-writable, so it avoids assigning a value.
      configurable: !0
    };
    if (Ta.has(m))
      pp(m, !1);
    else if (m instanceof Promise)
      delete v.value, v.get = () => u(m);
    else if (or.has(m)) {
      const [b, k] = or.get(
        m
      );
      v.value = o(
        b,
        k(),
        u
      );
    }
    Object.defineProperty(h, p, v);
  }), h;
}, a = /* @__PURE__ */ new WeakMap(), s = [1, 1], l = (f) => {
  if (!Iu(f))
    throw new Error("object required");
  const c = a.get(f);
  if (c)
    return c;
  let u = s[0];
  const d = /* @__PURE__ */ new Set(), h = (I, O = ++s[0]) => {
    u !== O && (u = O, d.forEach((y) => y(I, O)));
  };
  let p = s[1];
  const m = (I = ++s[1]) => (p !== I && !d.size && (p = I, b.forEach(([O]) => {
    const y = O[1](I);
    y > u && (u = y);
  })), u), v = (I) => (O, y) => {
    const A = [...O];
    A[1] = [I, ...A[1]], h(A, y);
  }, b = /* @__PURE__ */ new Map(), k = (I, O) => {
    if (({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 } && "production") !== "production" && b.has(I))
      throw new Error("prop listener already exists");
    if (d.size) {
      const y = O[3](v(I));
      b.set(I, [O, y]);
    } else
      b.set(I, [O]);
  }, _ = (I) => {
    var O;
    const y = b.get(I);
    y && (b.delete(I), (O = y[1]) == null || O.call(y));
  }, E = (I) => (d.add(I), d.size === 1 && b.forEach(([y, A], z) => {
    if (({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 } && "production") !== "production" && A)
      throw new Error("remove already exists");
    const F = y[3](v(z));
    b.set(z, [y, F]);
  }), () => {
    d.delete(I), d.size === 0 && b.forEach(([y, A], z) => {
      A && (A(), b.set(z, [y]));
    });
  }), S = Array.isArray(f) ? [] : Object.create(Object.getPrototypeOf(f)), N = e(S, {
    deleteProperty(I, O) {
      const y = Reflect.get(I, O);
      _(O);
      const A = Reflect.deleteProperty(I, O);
      return A && h(["delete", [O], y]), A;
    },
    set(I, O, y, A) {
      const z = Reflect.has(I, O), F = Reflect.get(I, O, A);
      if (z && (t(F, y) || a.has(y) && t(F, a.get(y))))
        return !0;
      _(O), Iu(y) && (y = bS(y) || y);
      let P = y;
      if (y instanceof Promise)
        y.then((L) => {
          y.status = "fulfilled", y.value = L, h(["resolve", [O], L]);
        }).catch((L) => {
          y.status = "rejected", y.reason = L, h(["reject", [O], L]);
        });
      else {
        !or.has(y) && n(y) && (P = l(y));
        const L = !Ta.has(P) && or.get(P);
        L && k(O, L);
      }
      return Reflect.set(I, O, P, A), h(["set", [O], y, F]), !0;
    }
  });
  a.set(f, N);
  const $ = [
    S,
    m,
    o,
    E
  ];
  return or.set(N, $), Reflect.ownKeys(f).forEach((I) => {
    const O = Object.getOwnPropertyDescriptor(
      f,
      I
    );
    "value" in O && (N[I] = f[I], delete O.value, delete O.writable), Object.defineProperty(S, I, O);
  }), N;
}) => [
  // public functions
  l,
  // shared state
  or,
  Ta,
  // internal things
  t,
  e,
  n,
  r,
  i,
  o,
  a,
  s
], [wS] = _S();
function Db(t = {}) {
  return wS(t);
}
function jd(t) {
  const e = or.get(t);
  return e == null ? void 0 : e[1]();
}
function Sh(t, e, n) {
  const r = or.get(t);
  ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 } && "production") !== "production" && !r && console.warn("Please use proxy object");
  let i;
  const o = [], a = r[3];
  let s = !1;
  const f = a((c) => {
    if (o.push(c), n) {
      e(o.splice(0));
      return;
    }
    i || (i = Promise.resolve().then(() => {
      i = void 0, s && e(o.splice(0));
    }));
  });
  return s = !0, () => {
    s = !1, f();
  };
}
function Eo(t, e) {
  const n = or.get(t);
  ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 } && "production") !== "production" && !n && console.warn("Please use proxy object");
  const [r, i, o] = n;
  return o(r, i(), e);
}
function Pb(t) {
  return Ta.add(t), t;
}
function kS(t, e, n, r) {
  let i = t[e];
  return Sh(
    t,
    () => {
      const o = t[e];
      Object.is(i, o) || n(i = o);
    },
    r
  );
}
const mi = /* @__PURE__ */ new WeakMap(), ef = /* @__PURE__ */ new WeakMap(), Rb = (t, e) => {
  const n = mi.get(t);
  n && (n[0].forEach((r) => {
    const { d: i } = r;
    t !== i && Rb(i);
  }), ++n[2], e && n[3].add(e));
}, CS = (t, e) => {
  const n = mi.get(t);
  return n != null && n[2] ? (n[3].add(e), !0) : !1;
}, zd = (t) => {
  const e = mi.get(t);
  e && (--e[2], e[2] || (e[3].forEach((n) => n()), e[3].clear()), e[0].forEach((n) => {
    const { d: r } = n;
    t !== r && zd(r);
  }));
}, xS = (t) => {
  const { s: e, d: n } = t;
  let r = ef.get(n);
  r || (r = [/* @__PURE__ */ new Set()], ef.set(t.d, r)), r[0].add(t);
  let i = mi.get(e);
  if (!i) {
    const o = /* @__PURE__ */ new Set(), a = Sh(
      e,
      (s) => {
        o.forEach((l) => {
          const {
            d: f,
            c,
            n: u,
            i: d
          } = l;
          e === f && s.every(
            (h) => h[1].length === 1 && d.includes(h[1][0])
          ) || l.p || (Rb(e, c), u ? zd(e) : l.p = Promise.resolve().then(() => {
            delete l.p, zd(e);
          }));
        });
      },
      !0
    );
    i = [o, a, 0, /* @__PURE__ */ new Set()], mi.set(e, i);
  }
  i[0].add(t);
}, ES = (t) => {
  const { s: e, d: n } = t, r = ef.get(n);
  r == null || r[0].delete(t), (r == null ? void 0 : r[0].size) === 0 && ef.delete(n);
  const i = mi.get(e);
  if (i) {
    const [o, a] = i;
    o.delete(t), o.size || (a(), mi.delete(e));
  }
};
function Lb(t, e) {
  const n = (e == null ? void 0 : e.proxy) || Db({}), r = !!(e != null && e.sync), i = Object.keys(t);
  return i.forEach((o) => {
    if (Object.getOwnPropertyDescriptor(n, o))
      throw new Error("object property already defined");
    const a = t[o];
    let s = null;
    const l = () => {
      if (s && (Array.from(s).map(([h]) => CS(h, l)).some((h) => h) || Array.from(s).every(
        ([h, p]) => jd(h) === p.v
      )))
        return;
      const f = /* @__PURE__ */ new Map(), u = a((h) => (f.set(h, { v: jd(h) }), h)), d = () => {
        f.forEach((h, p) => {
          var m;
          const v = (m = s == null ? void 0 : s.get(p)) == null ? void 0 : m.s;
          if (v)
            h.s = v;
          else {
            const b = {
              s: p,
              // sourceObject
              d: n,
              // derivedObject
              k: o,
              // derived key
              c: l,
              // callback
              n: r,
              i
              // ignoringKeys
            };
            xS(b), h.s = b;
          }
        }), s == null || s.forEach((h, p) => {
          !f.has(p) && h.s && ES(h.s);
        }), s = f;
      };
      u instanceof Promise ? u.finally(d) : d(), n[o] = u;
    };
    l();
  }), n;
}
var Bt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function TS(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function SS(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      if (this instanceof r) {
        var i = [null];
        i.push.apply(i, arguments);
        var o = Function.bind.apply(e, i);
        return new o();
      }
      return e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var Bd = {}, IS = {
  get exports() {
    return Bd;
  },
  set exports(t) {
    Bd = t;
  }
}, $b = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var To = he;
function NS(t, e) {
  return t === e && (t !== 0 || 1 / t === 1 / e) || t !== t && e !== e;
}
var MS = typeof Object.is == "function" ? Object.is : NS, AS = To.useState, OS = To.useEffect, DS = To.useLayoutEffect, PS = To.useDebugValue;
function RS(t, e) {
  var n = e(), r = AS({ inst: { value: n, getSnapshot: e } }), i = r[0].inst, o = r[1];
  return DS(function() {
    i.value = n, i.getSnapshot = e, Nu(i) && o({ inst: i });
  }, [t, n, e]), OS(function() {
    return Nu(i) && o({ inst: i }), t(function() {
      Nu(i) && o({ inst: i });
    });
  }, [t]), PS(n), n;
}
function Nu(t) {
  var e = t.getSnapshot;
  t = t.value;
  try {
    var n = e();
    return !MS(t, n);
  } catch {
    return !0;
  }
}
function LS(t, e) {
  return e();
}
var $S = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? LS : RS;
$b.useSyncExternalStore = To.useSyncExternalStore !== void 0 ? To.useSyncExternalStore : $S;
(function(t) {
  t.exports = $b;
})(IS);
const FS = /* @__PURE__ */ TS(Bd), { use: mp } = he, { useSyncExternalStore: jS } = FS, zS = (t, e) => {
  const n = vt();
  ce(() => {
    n.current = yS(t, e, !0);
  }), DC(n.current);
}, BS = /* @__PURE__ */ new WeakMap();
function ie(t, e) {
  const n = e == null ? void 0 : e.sync, r = vt(), i = vt();
  let o = !0;
  const a = jS(
    Oe(
      (f) => {
        const c = Sh(t, f, n);
        return f(), c;
      },
      [t, n]
    ),
    () => {
      const f = Eo(t, mp);
      try {
        if (!o && r.current && i.current && !Ob(
          r.current,
          f,
          i.current,
          /* @__PURE__ */ new WeakMap()
        ))
          return r.current;
      } catch {
      }
      return f;
    },
    () => Eo(t, mp)
  );
  o = !1;
  const s = /* @__PURE__ */ new WeakMap();
  ce(() => {
    r.current = a, i.current = s;
  }), ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 } && "production") !== "production" && zS(a, s);
  const l = Yt(() => /* @__PURE__ */ new WeakMap(), []);
  return Ab(
    a,
    s,
    l,
    BS
  );
}
const vp = "@firebase/database", bp = "0.13.3";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Fb = "";
function WS(t) {
  Fb = t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class US {
  /**
   * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
   */
  constructor(e) {
    this.domStorage_ = e, this.prefix_ = "firebase:";
  }
  /**
   * @param key - The key to save the value under
   * @param value - The value being stored, or null to remove the key.
   */
  set(e, n) {
    n == null ? this.domStorage_.removeItem(this.prefixedName_(e)) : this.domStorage_.setItem(this.prefixedName_(e), rt(n));
  }
  /**
   * @returns The value that was stored under this key, or null
   */
  get(e) {
    const n = this.domStorage_.getItem(this.prefixedName_(e));
    return n == null ? null : rs(n);
  }
  remove(e) {
    this.domStorage_.removeItem(this.prefixedName_(e));
  }
  prefixedName_(e) {
    return this.prefix_ + e;
  }
  toString() {
    return this.domStorage_.toString();
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class HS {
  constructor() {
    this.cache_ = {}, this.isInMemoryStorage = !0;
  }
  set(e, n) {
    n == null ? delete this.cache_[e] : this.cache_[e] = n;
  }
  get(e) {
    return qn(this.cache_, e) ? this.cache_[e] : null;
  }
  remove(e) {
    delete this.cache_[e];
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const jb = function(t) {
  try {
    if (typeof window < "u" && typeof window[t] < "u") {
      const e = window[t];
      return e.setItem("firebase:sentinel", "cache"), e.removeItem("firebase:sentinel"), new US(e);
    }
  } catch {
  }
  return new HS();
}, ti = jb("localStorage"), Wd = jb("sessionStorage");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const po = new bh("@firebase/database"), VS = function() {
  let t = 1;
  return function() {
    return t++;
  };
}(), zb = function(t) {
  const e = xE(t), n = new _E();
  n.update(e);
  const r = n.digest();
  return ph.encodeByteArray(r);
}, $s = function(...t) {
  let e = "";
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    Array.isArray(r) || r && typeof r == "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof r.length == "number" ? e += $s.apply(null, r) : typeof r == "object" ? e += rt(r) : e += r, e += " ";
  }
  return e;
};
let ii = null, yp = !0;
const KS = function(t, e) {
  V(!e || t === !0 || t === !1, "Can't turn on custom loggers persistently."), t === !0 ? (po.logLevel = Pe.VERBOSE, ii = po.log.bind(po), e && Wd.set("logging_enabled", !0)) : typeof t == "function" ? ii = t : (ii = null, Wd.remove("logging_enabled"));
}, ht = function(...t) {
  if (yp === !0 && (yp = !1, ii === null && Wd.get("logging_enabled") === !0 && KS(!0)), ii) {
    const e = $s.apply(null, t);
    ii(e);
  }
}, Fs = function(t) {
  return function(...e) {
    ht(t, ...e);
  };
}, Ud = function(...t) {
  const e = "FIREBASE INTERNAL ERROR: " + $s(...t);
  po.error(e);
}, vi = function(...t) {
  const e = `FIREBASE FATAL ERROR: ${$s(...t)}`;
  throw po.error(e), new Error(e);
}, Pt = function(...t) {
  const e = "FIREBASE WARNING: " + $s(...t);
  po.warn(e);
}, YS = function() {
  typeof window < "u" && window.location && window.location.protocol && window.location.protocol.indexOf("https:") !== -1 && Pt("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
}, nc = function(t) {
  return typeof t == "number" && (t !== t || // NaN
  t === Number.POSITIVE_INFINITY || t === Number.NEGATIVE_INFINITY);
}, qS = function(t) {
  if (document.readyState === "complete")
    t();
  else {
    let e = !1;
    const n = function() {
      if (!document.body) {
        setTimeout(n, Math.floor(10));
        return;
      }
      e || (e = !0, t());
    };
    document.addEventListener ? (document.addEventListener("DOMContentLoaded", n, !1), window.addEventListener("load", n, !1)) : document.attachEvent && (document.attachEvent("onreadystatechange", () => {
      document.readyState === "complete" && n();
    }), window.attachEvent("onload", n));
  }
}, bi = "[MIN_NAME]", Vn = "[MAX_NAME]", Ni = function(t, e) {
  if (t === e)
    return 0;
  if (t === bi || e === Vn)
    return -1;
  if (e === bi || t === Vn)
    return 1;
  {
    const n = Hd(t), r = Hd(e);
    return n !== null ? r !== null ? n - r === 0 ? t.length - e.length : n - r : -1 : r !== null ? 1 : t < e ? -1 : 1;
  }
}, GS = function(t, e) {
  return t === e ? 0 : t < e ? -1 : 1;
}, ya = function(t, e) {
  if (e && t in e)
    return e[t];
  throw new Error("Missing required key (" + t + ") in object: " + rt(e));
}, Ih = function(t) {
  if (typeof t != "object" || t === null)
    return rt(t);
  const e = [];
  for (const r in t)
    e.push(r);
  e.sort();
  let n = "{";
  for (let r = 0; r < e.length; r++)
    r !== 0 && (n += ","), n += rt(e[r]), n += ":", n += Ih(t[e[r]]);
  return n += "}", n;
}, Bb = function(t, e) {
  const n = t.length;
  if (n <= e)
    return [t];
  const r = [];
  for (let i = 0; i < n; i += e)
    i + e > n ? r.push(t.substring(i, n)) : r.push(t.substring(i, i + e));
  return r;
};
function bt(t, e) {
  for (const n in t)
    t.hasOwnProperty(n) && e(n, t[n]);
}
const Wb = function(t) {
  V(!nc(t), "Invalid JSON number");
  const e = 11, n = 52, r = (1 << e - 1) - 1;
  let i, o, a, s, l;
  t === 0 ? (o = 0, a = 0, i = 1 / t === -1 / 0 ? 1 : 0) : (i = t < 0, t = Math.abs(t), t >= Math.pow(2, 1 - r) ? (s = Math.min(Math.floor(Math.log(t) / Math.LN2), r), o = s + r, a = Math.round(t * Math.pow(2, n - s) - Math.pow(2, n))) : (o = 0, a = Math.round(t / Math.pow(2, 1 - r - n))));
  const f = [];
  for (l = n; l; l -= 1)
    f.push(a % 2 ? 1 : 0), a = Math.floor(a / 2);
  for (l = e; l; l -= 1)
    f.push(o % 2 ? 1 : 0), o = Math.floor(o / 2);
  f.push(i ? 1 : 0), f.reverse();
  const c = f.join("");
  let u = "";
  for (l = 0; l < 64; l += 8) {
    let d = parseInt(c.substr(l, 8), 2).toString(16);
    d.length === 1 && (d = "0" + d), u = u + d;
  }
  return u.toLowerCase();
}, QS = function() {
  return !!(typeof window == "object" && window.chrome && window.chrome.extension && !/^chrome/.test(window.location.href));
}, XS = function() {
  return typeof Windows == "object" && typeof Windows.UI == "object";
};
function JS(t, e) {
  let n = "Unknown Error";
  t === "too_big" ? n = "The data requested exceeds the maximum size that can be accessed with a single request." : t === "permission_denied" ? n = "Client doesn't have permission to access the desired data." : t === "unavailable" && (n = "The service is unavailable");
  const r = new Error(t + " at " + e._path.toString() + ": " + n);
  return r.code = t.toUpperCase(), r;
}
const ZS = new RegExp("^-?(0*)\\d{1,10}$"), eI = -2147483648, Ub = 2147483647, Hd = function(t) {
  if (ZS.test(t)) {
    const e = Number(t);
    if (e >= eI && e <= Ub)
      return e;
  }
  return null;
}, Vo = function(t) {
  try {
    t();
  } catch (e) {
    setTimeout(() => {
      const n = e.stack || "";
      throw Pt("Exception was thrown by user callback.", n), e;
    }, Math.floor(0));
  }
}, tI = function() {
  return (typeof window == "object" && window.navigator && window.navigator.userAgent || "").search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
}, $a = function(t, e) {
  const n = setTimeout(t, e);
  return typeof n == "object" && n.unref && n.unref(), n;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class nI {
  constructor(e, n) {
    this.appName_ = e, this.appCheckProvider = n, this.appCheck = n == null ? void 0 : n.getImmediate({ optional: !0 }), this.appCheck || n == null || n.get().then((r) => this.appCheck = r);
  }
  getToken(e) {
    return this.appCheck ? this.appCheck.getToken(e) : new Promise((n, r) => {
      setTimeout(() => {
        this.appCheck ? this.getToken(e).then(n, r) : n(null);
      }, 0);
    });
  }
  addTokenChangeListener(e) {
    var n;
    (n = this.appCheckProvider) === null || n === void 0 || n.get().then((r) => r.addTokenListener(e));
  }
  notifyForInvalidToken() {
    Pt(`Provided AppCheck credentials for the app named "${this.appName_}" are invalid. This usually indicates your app was not initialized correctly.`);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class rI {
  constructor(e, n, r) {
    this.appName_ = e, this.firebaseOptions_ = n, this.authProvider_ = r, this.auth_ = null, this.auth_ = r.getImmediate({ optional: !0 }), this.auth_ || r.onInit((i) => this.auth_ = i);
  }
  getToken(e) {
    return this.auth_ ? this.auth_.getToken(e).catch((n) => n && n.code === "auth/token-not-initialized" ? (ht("Got auth/token-not-initialized error.  Treating as null token."), null) : Promise.reject(n)) : new Promise((n, r) => {
      setTimeout(() => {
        this.auth_ ? this.getToken(e).then(n, r) : n(null);
      }, 0);
    });
  }
  addTokenChangeListener(e) {
    this.auth_ ? this.auth_.addAuthTokenListener(e) : this.authProvider_.get().then((n) => n.addAuthTokenListener(e));
  }
  removeTokenChangeListener(e) {
    this.authProvider_.get().then((n) => n.removeAuthTokenListener(e));
  }
  notifyForInvalidToken() {
    let e = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not initialized correctly. ';
    "credential" in this.firebaseOptions_ ? e += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.' : "serviceAccount" in this.firebaseOptions_ ? e += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.' : e += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.', Pt(e);
  }
}
class Vd {
  constructor(e) {
    this.accessToken = e;
  }
  getToken(e) {
    return Promise.resolve({
      accessToken: this.accessToken
    });
  }
  addTokenChangeListener(e) {
    e(this.accessToken);
  }
  removeTokenChangeListener(e) {
  }
  notifyForInvalidToken() {
  }
}
Vd.OWNER = "owner";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Nh = "5", Hb = "v", Vb = "s", Kb = "r", Yb = "f", qb = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/, Gb = "ls", Qb = "p", Kd = "ac", Xb = "websocket", Jb = "long_polling";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class iI {
  /**
   * @param host - Hostname portion of the url for the repo
   * @param secure - Whether or not this repo is accessed over ssl
   * @param namespace - The namespace represented by the repo
   * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
   * @param nodeAdmin - Whether this instance uses Admin SDK credentials
   * @param persistenceKey - Override the default session persistence storage key
   */
  constructor(e, n, r, i, o = !1, a = "", s = !1) {
    this.secure = n, this.namespace = r, this.webSocketOnly = i, this.nodeAdmin = o, this.persistenceKey = a, this.includeNamespaceInQueryParams = s, this._host = e.toLowerCase(), this._domain = this._host.substr(this._host.indexOf(".") + 1), this.internalHost = ti.get("host:" + e) || this._host;
  }
  isCacheableHost() {
    return this.internalHost.substr(0, 2) === "s-";
  }
  isCustomHost() {
    return this._domain !== "firebaseio.com" && this._domain !== "firebaseio-demo.com";
  }
  get host() {
    return this._host;
  }
  set host(e) {
    e !== this.internalHost && (this.internalHost = e, this.isCacheableHost() && ti.set("host:" + this._host, this.internalHost));
  }
  toString() {
    let e = this.toURLString();
    return this.persistenceKey && (e += "<" + this.persistenceKey + ">"), e;
  }
  toURLString() {
    const e = this.secure ? "https://" : "http://", n = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : "";
    return `${e}${this.host}/${n}`;
  }
}
function oI(t) {
  return t.host !== t.internalHost || t.isCustomHost() || t.includeNamespaceInQueryParams;
}
function Zb(t, e, n) {
  V(typeof e == "string", "typeof type must == string"), V(typeof n == "object", "typeof params must == object");
  let r;
  if (e === Xb)
    r = (t.secure ? "wss://" : "ws://") + t.internalHost + "/.ws?";
  else if (e === Jb)
    r = (t.secure ? "https://" : "http://") + t.internalHost + "/.lp?";
  else
    throw new Error("Unknown connection type: " + e);
  oI(t) && (n.ns = t.namespace);
  const i = [];
  return bt(n, (o, a) => {
    i.push(o + "=" + a);
  }), r + i.join("&");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class aI {
  constructor() {
    this.counters_ = {};
  }
  incrementCounter(e, n = 1) {
    qn(this.counters_, e) || (this.counters_[e] = 0), this.counters_[e] += n;
  }
  get() {
    return cE(this.counters_);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Mu = {}, Au = {};
function Mh(t) {
  const e = t.toString();
  return Mu[e] || (Mu[e] = new aI()), Mu[e];
}
function sI(t, e) {
  const n = t.toString();
  return Au[n] || (Au[n] = e()), Au[n];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class lI {
  /**
   * @param onMessage_
   */
  constructor(e) {
    this.onMessage_ = e, this.pendingResponses = [], this.currentResponseNum = 0, this.closeAfterResponse = -1, this.onClose = null;
  }
  closeAfter(e, n) {
    this.closeAfterResponse = e, this.onClose = n, this.closeAfterResponse < this.currentResponseNum && (this.onClose(), this.onClose = null);
  }
  /**
   * Each message from the server comes with a response number, and an array of data. The responseNumber
   * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
   * browsers will respond in the same order as the requests we sent
   */
  handleResponse(e, n) {
    for (this.pendingResponses[e] = n; this.pendingResponses[this.currentResponseNum]; ) {
      const r = this.pendingResponses[this.currentResponseNum];
      delete this.pendingResponses[this.currentResponseNum];
      for (let i = 0; i < r.length; ++i)
        r[i] && Vo(() => {
          this.onMessage_(r[i]);
        });
      if (this.currentResponseNum === this.closeAfterResponse) {
        this.onClose && (this.onClose(), this.onClose = null);
        break;
      }
      this.currentResponseNum++;
    }
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _p = "start", fI = "close", cI = "pLPCommand", uI = "pRTLPCB", ey = "id", ty = "pw", ny = "ser", dI = "cb", hI = "seg", gI = "ts", pI = "d", mI = "dframe", ry = 1870, iy = 30, vI = ry - iy, bI = 25e3, yI = 3e4;
class lo {
  /**
   * @param connId An identifier for this connection, used for logging
   * @param repoInfo The info for the endpoint to send data to.
   * @param applicationId The Firebase App ID for this project.
   * @param appCheckToken The AppCheck token for this client.
   * @param authToken The AuthToken to use for this connection.
   * @param transportSessionId Optional transportSessionid if we are
   * reconnecting for an existing transport session
   * @param lastSessionId Optional lastSessionId if the PersistentConnection has
   * already created a connection previously
   */
  constructor(e, n, r, i, o, a, s) {
    this.connId = e, this.repoInfo = n, this.applicationId = r, this.appCheckToken = i, this.authToken = o, this.transportSessionId = a, this.lastSessionId = s, this.bytesSent = 0, this.bytesReceived = 0, this.everConnected_ = !1, this.log_ = Fs(e), this.stats_ = Mh(n), this.urlFn = (l) => (this.appCheckToken && (l[Kd] = this.appCheckToken), Zb(n, Jb, l));
  }
  /**
   * @param onMessage - Callback when messages arrive
   * @param onDisconnect - Callback with connection lost.
   */
  open(e, n) {
    this.curSegmentNum = 0, this.onDisconnect_ = n, this.myPacketOrderer = new lI(e), this.isClosed_ = !1, this.connectTimeoutTimer_ = setTimeout(() => {
      this.log_("Timed out trying to connect."), this.onClosed_(), this.connectTimeoutTimer_ = null;
    }, Math.floor(yI)), qS(() => {
      if (this.isClosed_)
        return;
      this.scriptTagHolder = new Ah((...o) => {
        const [a, s, l, f, c] = o;
        if (this.incrementIncomingBytes_(o), !!this.scriptTagHolder)
          if (this.connectTimeoutTimer_ && (clearTimeout(this.connectTimeoutTimer_), this.connectTimeoutTimer_ = null), this.everConnected_ = !0, a === _p)
            this.id = s, this.password = l;
          else if (a === fI)
            s ? (this.scriptTagHolder.sendNewPolls = !1, this.myPacketOrderer.closeAfter(s, () => {
              this.onClosed_();
            })) : this.onClosed_();
          else
            throw new Error("Unrecognized command received: " + a);
      }, (...o) => {
        const [a, s] = o;
        this.incrementIncomingBytes_(o), this.myPacketOrderer.handleResponse(a, s);
      }, () => {
        this.onClosed_();
      }, this.urlFn);
      const r = {};
      r[_p] = "t", r[ny] = Math.floor(Math.random() * 1e8), this.scriptTagHolder.uniqueCallbackIdentifier && (r[dI] = this.scriptTagHolder.uniqueCallbackIdentifier), r[Hb] = Nh, this.transportSessionId && (r[Vb] = this.transportSessionId), this.lastSessionId && (r[Gb] = this.lastSessionId), this.applicationId && (r[Qb] = this.applicationId), this.appCheckToken && (r[Kd] = this.appCheckToken), typeof location < "u" && location.hostname && qb.test(location.hostname) && (r[Kb] = Yb);
      const i = this.urlFn(r);
      this.log_("Connecting via long-poll to " + i), this.scriptTagHolder.addTag(i, () => {
      });
    });
  }
  /**
   * Call this when a handshake has completed successfully and we want to consider the connection established
   */
  start() {
    this.scriptTagHolder.startLongPoll(this.id, this.password), this.addDisconnectPingFrame(this.id, this.password);
  }
  /**
   * Forces long polling to be considered as a potential transport
   */
  static forceAllow() {
    lo.forceAllow_ = !0;
  }
  /**
   * Forces longpolling to not be considered as a potential transport
   */
  static forceDisallow() {
    lo.forceDisallow_ = !0;
  }
  // Static method, use string literal so it can be accessed in a generic way
  static isAvailable() {
    return lo.forceAllow_ ? !0 : !lo.forceDisallow_ && typeof document < "u" && document.createElement != null && !QS() && !XS();
  }
  /**
   * No-op for polling
   */
  markConnectionHealthy() {
  }
  /**
   * Stops polling and cleans up the iframe
   */
  shutdown_() {
    this.isClosed_ = !0, this.scriptTagHolder && (this.scriptTagHolder.close(), this.scriptTagHolder = null), this.myDisconnFrame && (document.body.removeChild(this.myDisconnFrame), this.myDisconnFrame = null), this.connectTimeoutTimer_ && (clearTimeout(this.connectTimeoutTimer_), this.connectTimeoutTimer_ = null);
  }
  /**
   * Triggered when this transport is closed
   */
  onClosed_() {
    this.isClosed_ || (this.log_("Longpoll is closing itself"), this.shutdown_(), this.onDisconnect_ && (this.onDisconnect_(this.everConnected_), this.onDisconnect_ = null));
  }
  /**
   * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
   * that we've left.
   */
  close() {
    this.isClosed_ || (this.log_("Longpoll is being closed."), this.shutdown_());
  }
  /**
   * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
   * broken into chunks (since URLs have a small maximum length).
   * @param data - The JSON data to transmit.
   */
  send(e) {
    const n = rt(e);
    this.bytesSent += n.length, this.stats_.incrementCounter("bytes_sent", n.length);
    const r = ab(n), i = Bb(r, vI);
    for (let o = 0; o < i.length; o++)
      this.scriptTagHolder.enqueueSegment(this.curSegmentNum, i.length, i[o]), this.curSegmentNum++;
  }
  /**
   * This is how we notify the server that we're leaving.
   * We aren't able to send requests with DHTML on a window close event, but we can
   * trigger XHR requests in some browsers (everything but Opera basically).
   */
  addDisconnectPingFrame(e, n) {
    this.myDisconnFrame = document.createElement("iframe");
    const r = {};
    r[mI] = "t", r[ey] = e, r[ty] = n, this.myDisconnFrame.src = this.urlFn(r), this.myDisconnFrame.style.display = "none", document.body.appendChild(this.myDisconnFrame);
  }
  /**
   * Used to track the bytes received by this client
   */
  incrementIncomingBytes_(e) {
    const n = rt(e).length;
    this.bytesReceived += n, this.stats_.incrementCounter("bytes_received", n);
  }
}
class Ah {
  /**
   * @param commandCB - The callback to be called when control commands are recevied from the server.
   * @param onMessageCB - The callback to be triggered when responses arrive from the server.
   * @param onDisconnect - The callback to be triggered when this tag holder is closed
   * @param urlFn - A function that provides the URL of the endpoint to send data to.
   */
  constructor(e, n, r, i) {
    this.onDisconnect = r, this.urlFn = i, this.outstandingRequests = /* @__PURE__ */ new Set(), this.pendingSegs = [], this.currentSerial = Math.floor(Math.random() * 1e8), this.sendNewPolls = !0;
    {
      this.uniqueCallbackIdentifier = VS(), window[cI + this.uniqueCallbackIdentifier] = e, window[uI + this.uniqueCallbackIdentifier] = n, this.myIFrame = Ah.createIFrame_();
      let o = "";
      this.myIFrame.src && this.myIFrame.src.substr(0, 11) === "javascript:" && (o = '<script>document.domain="' + document.domain + '";<\/script>');
      const a = "<html><body>" + o + "</body></html>";
      try {
        this.myIFrame.doc.open(), this.myIFrame.doc.write(a), this.myIFrame.doc.close();
      } catch (s) {
        ht("frame writing exception"), s.stack && ht(s.stack), ht(s);
      }
    }
  }
  /**
   * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
   * actually use.
   */
  static createIFrame_() {
    const e = document.createElement("iframe");
    if (e.style.display = "none", document.body) {
      document.body.appendChild(e);
      try {
        e.contentWindow.document || ht("No IE domain setting required");
      } catch {
        const r = document.domain;
        e.src = "javascript:void((function(){document.open();document.domain='" + r + "';document.close();})())";
      }
    } else
      throw "Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
    return e.contentDocument ? e.doc = e.contentDocument : e.contentWindow ? e.doc = e.contentWindow.document : e.document && (e.doc = e.document), e;
  }
  /**
   * Cancel all outstanding queries and remove the frame.
   */
  close() {
    this.alive = !1, this.myIFrame && (this.myIFrame.doc.body.innerHTML = "", setTimeout(() => {
      this.myIFrame !== null && (document.body.removeChild(this.myIFrame), this.myIFrame = null);
    }, Math.floor(0)));
    const e = this.onDisconnect;
    e && (this.onDisconnect = null, e());
  }
  /**
   * Actually start the long-polling session by adding the first script tag(s) to the iframe.
   * @param id - The ID of this connection
   * @param pw - The password for this connection
   */
  startLongPoll(e, n) {
    for (this.myID = e, this.myPW = n, this.alive = !0; this.newRequest_(); )
      ;
  }
  /**
   * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
   * too many outstanding requests and we are still alive.
   *
   * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
   * needed.
   */
  newRequest_() {
    if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
      this.currentSerial++;
      const e = {};
      e[ey] = this.myID, e[ty] = this.myPW, e[ny] = this.currentSerial;
      let n = this.urlFn(e), r = "", i = 0;
      for (; this.pendingSegs.length > 0 && this.pendingSegs[0].d.length + iy + r.length <= ry; ) {
        const a = this.pendingSegs.shift();
        r = r + "&" + hI + i + "=" + a.seg + "&" + gI + i + "=" + a.ts + "&" + pI + i + "=" + a.d, i++;
      }
      return n = n + r, this.addLongPollTag_(n, this.currentSerial), !0;
    } else
      return !1;
  }
  /**
   * Queue a packet for transmission to the server.
   * @param segnum - A sequential id for this packet segment used for reassembly
   * @param totalsegs - The total number of segments in this packet
   * @param data - The data for this segment.
   */
  enqueueSegment(e, n, r) {
    this.pendingSegs.push({ seg: e, ts: n, d: r }), this.alive && this.newRequest_();
  }
  /**
   * Add a script tag for a regular long-poll request.
   * @param url - The URL of the script tag.
   * @param serial - The serial number of the request.
   */
  addLongPollTag_(e, n) {
    this.outstandingRequests.add(n);
    const r = () => {
      this.outstandingRequests.delete(n), this.newRequest_();
    }, i = setTimeout(r, Math.floor(bI)), o = () => {
      clearTimeout(i), r();
    };
    this.addTag(e, o);
  }
  /**
   * Add an arbitrary script tag to the iframe.
   * @param url - The URL for the script tag source.
   * @param loadCB - A callback to be triggered once the script has loaded.
   */
  addTag(e, n) {
    setTimeout(() => {
      try {
        if (!this.sendNewPolls)
          return;
        const r = this.myIFrame.doc.createElement("script");
        r.type = "text/javascript", r.async = !0, r.src = e, r.onload = r.onreadystatechange = function() {
          const i = r.readyState;
          (!i || i === "loaded" || i === "complete") && (r.onload = r.onreadystatechange = null, r.parentNode && r.parentNode.removeChild(r), n());
        }, r.onerror = () => {
          ht("Long-poll script failed to load: " + e), this.sendNewPolls = !1, this.close();
        }, this.myIFrame.doc.body.appendChild(r);
      } catch {
      }
    }, Math.floor(1));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _I = 16384, wI = 45e3;
let tf = null;
typeof MozWebSocket < "u" ? tf = MozWebSocket : typeof WebSocket < "u" && (tf = WebSocket);
class Tn {
  /**
   * @param connId identifier for this transport
   * @param repoInfo The info for the websocket endpoint.
   * @param applicationId The Firebase App ID for this project.
   * @param appCheckToken The App Check Token for this client.
   * @param authToken The Auth Token for this client.
   * @param transportSessionId Optional transportSessionId if this is connecting
   * to an existing transport session
   * @param lastSessionId Optional lastSessionId if there was a previous
   * connection
   */
  constructor(e, n, r, i, o, a, s) {
    this.connId = e, this.applicationId = r, this.appCheckToken = i, this.authToken = o, this.keepaliveTimer = null, this.frames = null, this.totalFrames = 0, this.bytesSent = 0, this.bytesReceived = 0, this.log_ = Fs(this.connId), this.stats_ = Mh(n), this.connURL = Tn.connectionURL_(n, a, s, i, r), this.nodeAdmin = n.nodeAdmin;
  }
  /**
   * @param repoInfo - The info for the websocket endpoint.
   * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
   *                                         session
   * @param lastSessionId - Optional lastSessionId if there was a previous connection
   * @returns connection url
   */
  static connectionURL_(e, n, r, i, o) {
    const a = {};
    return a[Hb] = Nh, typeof location < "u" && location.hostname && qb.test(location.hostname) && (a[Kb] = Yb), n && (a[Vb] = n), r && (a[Gb] = r), i && (a[Kd] = i), o && (a[Qb] = o), Zb(e, Xb, a);
  }
  /**
   * @param onMessage - Callback when messages arrive
   * @param onDisconnect - Callback with connection lost.
   */
  open(e, n) {
    this.onDisconnect = n, this.onMessage = e, this.log_("Websocket connecting to " + this.connURL), this.everConnected_ = !1, ti.set("previous_websocket_failure", !0);
    try {
      let r;
      cb(), this.mySock = new tf(this.connURL, [], r);
    } catch (r) {
      this.log_("Error instantiating WebSocket.");
      const i = r.message || r.data;
      i && this.log_(i), this.onClosed_();
      return;
    }
    this.mySock.onopen = () => {
      this.log_("Websocket connected."), this.everConnected_ = !0;
    }, this.mySock.onclose = () => {
      this.log_("Websocket connection was disconnected."), this.mySock = null, this.onClosed_();
    }, this.mySock.onmessage = (r) => {
      this.handleIncomingFrame(r);
    }, this.mySock.onerror = (r) => {
      this.log_("WebSocket error.  Closing connection.");
      const i = r.message || r.data;
      i && this.log_(i), this.onClosed_();
    };
  }
  /**
   * No-op for websockets, we don't need to do anything once the connection is confirmed as open
   */
  start() {
  }
  static forceDisallow() {
    Tn.forceDisallow_ = !0;
  }
  static isAvailable() {
    let e = !1;
    if (typeof navigator < "u" && navigator.userAgent) {
      const n = /Android ([0-9]{0,}\.[0-9]{0,})/, r = navigator.userAgent.match(n);
      r && r.length > 1 && parseFloat(r[1]) < 4.4 && (e = !0);
    }
    return !e && tf !== null && !Tn.forceDisallow_;
  }
  /**
   * Returns true if we previously failed to connect with this transport.
   */
  static previouslyFailed() {
    return ti.isInMemoryStorage || ti.get("previous_websocket_failure") === !0;
  }
  markConnectionHealthy() {
    ti.remove("previous_websocket_failure");
  }
  appendFrame_(e) {
    if (this.frames.push(e), this.frames.length === this.totalFrames) {
      const n = this.frames.join("");
      this.frames = null;
      const r = rs(n);
      this.onMessage(r);
    }
  }
  /**
   * @param frameCount - The number of frames we are expecting from the server
   */
  handleNewFrameCount_(e) {
    this.totalFrames = e, this.frames = [];
  }
  /**
   * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
   * @returns Any remaining data to be process, or null if there is none
   */
  extractFrameCount_(e) {
    if (V(this.frames === null, "We already have a frame buffer"), e.length <= 6) {
      const n = Number(e);
      if (!isNaN(n))
        return this.handleNewFrameCount_(n), null;
    }
    return this.handleNewFrameCount_(1), e;
  }
  /**
   * Process a websocket frame that has arrived from the server.
   * @param mess - The frame data
   */
  handleIncomingFrame(e) {
    if (this.mySock === null)
      return;
    const n = e.data;
    if (this.bytesReceived += n.length, this.stats_.incrementCounter("bytes_received", n.length), this.resetKeepAlive(), this.frames !== null)
      this.appendFrame_(n);
    else {
      const r = this.extractFrameCount_(n);
      r !== null && this.appendFrame_(r);
    }
  }
  /**
   * Send a message to the server
   * @param data - The JSON object to transmit
   */
  send(e) {
    this.resetKeepAlive();
    const n = rt(e);
    this.bytesSent += n.length, this.stats_.incrementCounter("bytes_sent", n.length);
    const r = Bb(n, _I);
    r.length > 1 && this.sendString_(String(r.length));
    for (let i = 0; i < r.length; i++)
      this.sendString_(r[i]);
  }
  shutdown_() {
    this.isClosed_ = !0, this.keepaliveTimer && (clearInterval(this.keepaliveTimer), this.keepaliveTimer = null), this.mySock && (this.mySock.close(), this.mySock = null);
  }
  onClosed_() {
    this.isClosed_ || (this.log_("WebSocket is closing itself"), this.shutdown_(), this.onDisconnect && (this.onDisconnect(this.everConnected_), this.onDisconnect = null));
  }
  /**
   * External-facing close handler.
   * Close the websocket and kill the connection.
   */
  close() {
    this.isClosed_ || (this.log_("WebSocket is being closed"), this.shutdown_());
  }
  /**
   * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
   * the last activity.
   */
  resetKeepAlive() {
    clearInterval(this.keepaliveTimer), this.keepaliveTimer = setInterval(() => {
      this.mySock && this.sendString_("0"), this.resetKeepAlive();
    }, Math.floor(wI));
  }
  /**
   * Send a string over the websocket.
   *
   * @param str - String to send.
   */
  sendString_(e) {
    try {
      this.mySock.send(e);
    } catch (n) {
      this.log_("Exception thrown from WebSocket.send():", n.message || n.data, "Closing connection."), setTimeout(this.onClosed_.bind(this), 0);
    }
  }
}
Tn.responsesRequiredToBeHealthy = 2;
Tn.healthyTimeout = 3e4;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class as {
  /**
   * @param repoInfo - Metadata around the namespace we're connecting to
   */
  constructor(e) {
    this.initTransports_(e);
  }
  static get ALL_TRANSPORTS() {
    return [lo, Tn];
  }
  /**
   * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
   * TransportManager has already set up transports_
   */
  static get IS_TRANSPORT_INITIALIZED() {
    return this.globalTransportInitialized_;
  }
  initTransports_(e) {
    const n = Tn && Tn.isAvailable();
    let r = n && !Tn.previouslyFailed();
    if (e.webSocketOnly && (n || Pt("wss:// URL used, but browser isn't known to support websockets.  Trying anyway."), r = !0), r)
      this.transports_ = [Tn];
    else {
      const i = this.transports_ = [];
      for (const o of as.ALL_TRANSPORTS)
        o && o.isAvailable() && i.push(o);
      as.globalTransportInitialized_ = !0;
    }
  }
  /**
   * @returns The constructor for the initial transport to use
   */
  initialTransport() {
    if (this.transports_.length > 0)
      return this.transports_[0];
    throw new Error("No transports available");
  }
  /**
   * @returns The constructor for the next transport, or null
   */
  upgradeTransport() {
    return this.transports_.length > 1 ? this.transports_[1] : null;
  }
}
as.globalTransportInitialized_ = !1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const kI = 6e4, CI = 5e3, xI = 10 * 1024, EI = 100 * 1024, Ou = "t", wp = "d", TI = "s", kp = "r", SI = "e", Cp = "o", xp = "a", Ep = "n", Tp = "p", II = "h";
class NI {
  /**
   * @param id - an id for this connection
   * @param repoInfo_ - the info for the endpoint to connect to
   * @param applicationId_ - the Firebase App ID for this project
   * @param appCheckToken_ - The App Check Token for this device.
   * @param authToken_ - The auth token for this session.
   * @param onMessage_ - the callback to be triggered when a server-push message arrives
   * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
   * @param onDisconnect_ - the callback to be triggered when a connection was lost
   * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
   * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
   */
  constructor(e, n, r, i, o, a, s, l, f, c) {
    this.id = e, this.repoInfo_ = n, this.applicationId_ = r, this.appCheckToken_ = i, this.authToken_ = o, this.onMessage_ = a, this.onReady_ = s, this.onDisconnect_ = l, this.onKill_ = f, this.lastSessionId = c, this.connectionCount = 0, this.pendingDataMessages = [], this.state_ = 0, this.log_ = Fs("c:" + this.id + ":"), this.transportManager_ = new as(n), this.log_("Connection created"), this.start_();
  }
  /**
   * Starts a connection attempt
   */
  start_() {
    const e = this.transportManager_.initialTransport();
    this.conn_ = new e(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId), this.primaryResponsesRequired_ = e.responsesRequiredToBeHealthy || 0;
    const n = this.connReceiver_(this.conn_), r = this.disconnReceiver_(this.conn_);
    this.tx_ = this.conn_, this.rx_ = this.conn_, this.secondaryConn_ = null, this.isHealthy_ = !1, setTimeout(() => {
      this.conn_ && this.conn_.open(n, r);
    }, Math.floor(0));
    const i = e.healthyTimeout || 0;
    i > 0 && (this.healthyTimeout_ = $a(() => {
      this.healthyTimeout_ = null, this.isHealthy_ || (this.conn_ && this.conn_.bytesReceived > EI ? (this.log_("Connection exceeded healthy timeout but has received " + this.conn_.bytesReceived + " bytes.  Marking connection healthy."), this.isHealthy_ = !0, this.conn_.markConnectionHealthy()) : this.conn_ && this.conn_.bytesSent > xI ? this.log_("Connection exceeded healthy timeout but has sent " + this.conn_.bytesSent + " bytes.  Leaving connection alive.") : (this.log_("Closing unhealthy connection after timeout."), this.close()));
    }, Math.floor(i)));
  }
  nextTransportId_() {
    return "c:" + this.id + ":" + this.connectionCount++;
  }
  disconnReceiver_(e) {
    return (n) => {
      e === this.conn_ ? this.onConnectionLost_(n) : e === this.secondaryConn_ ? (this.log_("Secondary connection lost."), this.onSecondaryConnectionLost_()) : this.log_("closing an old connection");
    };
  }
  connReceiver_(e) {
    return (n) => {
      this.state_ !== 2 && (e === this.rx_ ? this.onPrimaryMessageReceived_(n) : e === this.secondaryConn_ ? this.onSecondaryMessageReceived_(n) : this.log_("message on old connection"));
    };
  }
  /**
   * @param dataMsg - An arbitrary data message to be sent to the server
   */
  sendRequest(e) {
    const n = { t: "d", d: e };
    this.sendData_(n);
  }
  tryCleanupConnection() {
    this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_ && (this.log_("cleaning up and promoting a connection: " + this.secondaryConn_.connId), this.conn_ = this.secondaryConn_, this.secondaryConn_ = null);
  }
  onSecondaryControl_(e) {
    if (Ou in e) {
      const n = e[Ou];
      n === xp ? this.upgradeIfSecondaryHealthy_() : n === kp ? (this.log_("Got a reset on secondary, closing it"), this.secondaryConn_.close(), (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) && this.close()) : n === Cp && (this.log_("got pong on secondary."), this.secondaryResponsesRequired_--, this.upgradeIfSecondaryHealthy_());
    }
  }
  onSecondaryMessageReceived_(e) {
    const n = ya("t", e), r = ya("d", e);
    if (n === "c")
      this.onSecondaryControl_(r);
    else if (n === "d")
      this.pendingDataMessages.push(r);
    else
      throw new Error("Unknown protocol layer: " + n);
  }
  upgradeIfSecondaryHealthy_() {
    this.secondaryResponsesRequired_ <= 0 ? (this.log_("Secondary connection is healthy."), this.isHealthy_ = !0, this.secondaryConn_.markConnectionHealthy(), this.proceedWithUpgrade_()) : (this.log_("sending ping on secondary."), this.secondaryConn_.send({ t: "c", d: { t: Tp, d: {} } }));
  }
  proceedWithUpgrade_() {
    this.secondaryConn_.start(), this.log_("sending client ack on secondary"), this.secondaryConn_.send({ t: "c", d: { t: xp, d: {} } }), this.log_("Ending transmission on primary"), this.conn_.send({ t: "c", d: { t: Ep, d: {} } }), this.tx_ = this.secondaryConn_, this.tryCleanupConnection();
  }
  onPrimaryMessageReceived_(e) {
    const n = ya("t", e), r = ya("d", e);
    n === "c" ? this.onControl_(r) : n === "d" && this.onDataMessage_(r);
  }
  onDataMessage_(e) {
    this.onPrimaryResponse_(), this.onMessage_(e);
  }
  onPrimaryResponse_() {
    this.isHealthy_ || (this.primaryResponsesRequired_--, this.primaryResponsesRequired_ <= 0 && (this.log_("Primary connection is healthy."), this.isHealthy_ = !0, this.conn_.markConnectionHealthy()));
  }
  onControl_(e) {
    const n = ya(Ou, e);
    if (wp in e) {
      const r = e[wp];
      if (n === II)
        this.onHandshake_(r);
      else if (n === Ep) {
        this.log_("recvd end transmission on primary"), this.rx_ = this.secondaryConn_;
        for (let i = 0; i < this.pendingDataMessages.length; ++i)
          this.onDataMessage_(this.pendingDataMessages[i]);
        this.pendingDataMessages = [], this.tryCleanupConnection();
      } else
        n === TI ? this.onConnectionShutdown_(r) : n === kp ? this.onReset_(r) : n === SI ? Ud("Server Error: " + r) : n === Cp ? (this.log_("got pong on primary."), this.onPrimaryResponse_(), this.sendPingOnPrimaryIfNecessary_()) : Ud("Unknown control packet command: " + n);
    }
  }
  /**
   * @param handshake - The handshake data returned from the server
   */
  onHandshake_(e) {
    const n = e.ts, r = e.v, i = e.h;
    this.sessionId = e.s, this.repoInfo_.host = i, this.state_ === 0 && (this.conn_.start(), this.onConnectionEstablished_(this.conn_, n), Nh !== r && Pt("Protocol version mismatch detected"), this.tryStartUpgrade_());
  }
  tryStartUpgrade_() {
    const e = this.transportManager_.upgradeTransport();
    e && this.startUpgrade_(e);
  }
  startUpgrade_(e) {
    this.secondaryConn_ = new e(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId), this.secondaryResponsesRequired_ = e.responsesRequiredToBeHealthy || 0;
    const n = this.connReceiver_(this.secondaryConn_), r = this.disconnReceiver_(this.secondaryConn_);
    this.secondaryConn_.open(n, r), $a(() => {
      this.secondaryConn_ && (this.log_("Timed out trying to upgrade."), this.secondaryConn_.close());
    }, Math.floor(kI));
  }
  onReset_(e) {
    this.log_("Reset packet received.  New host: " + e), this.repoInfo_.host = e, this.state_ === 1 ? this.close() : (this.closeConnections_(), this.start_());
  }
  onConnectionEstablished_(e, n) {
    this.log_("Realtime connection established."), this.conn_ = e, this.state_ = 1, this.onReady_ && (this.onReady_(n, this.sessionId), this.onReady_ = null), this.primaryResponsesRequired_ === 0 ? (this.log_("Primary connection is healthy."), this.isHealthy_ = !0) : $a(() => {
      this.sendPingOnPrimaryIfNecessary_();
    }, Math.floor(CI));
  }
  sendPingOnPrimaryIfNecessary_() {
    !this.isHealthy_ && this.state_ === 1 && (this.log_("sending ping on primary."), this.sendData_({ t: "c", d: { t: Tp, d: {} } }));
  }
  onSecondaryConnectionLost_() {
    const e = this.secondaryConn_;
    this.secondaryConn_ = null, (this.tx_ === e || this.rx_ === e) && this.close();
  }
  /**
   * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
   * we should flush the host cache
   */
  onConnectionLost_(e) {
    this.conn_ = null, !e && this.state_ === 0 ? (this.log_("Realtime connection failed."), this.repoInfo_.isCacheableHost() && (ti.remove("host:" + this.repoInfo_.host), this.repoInfo_.internalHost = this.repoInfo_.host)) : this.state_ === 1 && this.log_("Realtime connection lost."), this.close();
  }
  onConnectionShutdown_(e) {
    this.log_("Connection shutdown command received. Shutting down..."), this.onKill_ && (this.onKill_(e), this.onKill_ = null), this.onDisconnect_ = null, this.close();
  }
  sendData_(e) {
    if (this.state_ !== 1)
      throw "Connection is not connected";
    this.tx_.send(e);
  }
  /**
   * Cleans up this connection, calling the appropriate callbacks
   */
  close() {
    this.state_ !== 2 && (this.log_("Closing realtime connection."), this.state_ = 2, this.closeConnections_(), this.onDisconnect_ && (this.onDisconnect_(), this.onDisconnect_ = null));
  }
  closeConnections_() {
    this.log_("Shutting down all connections"), this.conn_ && (this.conn_.close(), this.conn_ = null), this.secondaryConn_ && (this.secondaryConn_.close(), this.secondaryConn_ = null), this.healthyTimeout_ && (clearTimeout(this.healthyTimeout_), this.healthyTimeout_ = null);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class oy {
  put(e, n, r, i) {
  }
  merge(e, n, r, i) {
  }
  /**
   * Refreshes the auth token for the current connection.
   * @param token - The authentication token
   */
  refreshAuthToken(e) {
  }
  /**
   * Refreshes the app check token for the current connection.
   * @param token The app check token
   */
  refreshAppCheckToken(e) {
  }
  onDisconnectPut(e, n, r) {
  }
  onDisconnectMerge(e, n, r) {
  }
  onDisconnectCancel(e, n) {
  }
  reportStats(e) {
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ay {
  constructor(e) {
    this.allowedEvents_ = e, this.listeners_ = {}, V(Array.isArray(e) && e.length > 0, "Requires a non-empty array");
  }
  /**
   * To be called by derived classes to trigger events.
   */
  trigger(e, ...n) {
    if (Array.isArray(this.listeners_[e])) {
      const r = [...this.listeners_[e]];
      for (let i = 0; i < r.length; i++)
        r[i].callback.apply(r[i].context, n);
    }
  }
  on(e, n, r) {
    this.validateEventType_(e), this.listeners_[e] = this.listeners_[e] || [], this.listeners_[e].push({ callback: n, context: r });
    const i = this.getInitialEvent(e);
    i && n.apply(r, i);
  }
  off(e, n, r) {
    this.validateEventType_(e);
    const i = this.listeners_[e] || [];
    for (let o = 0; o < i.length; o++)
      if (i[o].callback === n && (!r || r === i[o].context)) {
        i.splice(o, 1);
        return;
      }
  }
  validateEventType_(e) {
    V(this.allowedEvents_.find((n) => n === e), "Unknown event: " + e);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class nf extends ay {
  constructor() {
    super(["online"]), this.online_ = !0, typeof window < "u" && typeof window.addEventListener < "u" && !mh() && (window.addEventListener("online", () => {
      this.online_ || (this.online_ = !0, this.trigger("online", !0));
    }, !1), window.addEventListener("offline", () => {
      this.online_ && (this.online_ = !1, this.trigger("online", !1));
    }, !1));
  }
  static getInstance() {
    return new nf();
  }
  getInitialEvent(e) {
    return V(e === "online", "Unknown event type: " + e), [this.online_];
  }
  currentlyOnline() {
    return this.online_;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Sp = 32, Ip = 768;
class Ne {
  /**
   * @param pathOrString - Path string to parse, or another path, or the raw
   * tokens array
   */
  constructor(e, n) {
    if (n === void 0) {
      this.pieces_ = e.split("/");
      let r = 0;
      for (let i = 0; i < this.pieces_.length; i++)
        this.pieces_[i].length > 0 && (this.pieces_[r] = this.pieces_[i], r++);
      this.pieces_.length = r, this.pieceNum_ = 0;
    } else
      this.pieces_ = e, this.pieceNum_ = n;
  }
  toString() {
    let e = "";
    for (let n = this.pieceNum_; n < this.pieces_.length; n++)
      this.pieces_[n] !== "" && (e += "/" + this.pieces_[n]);
    return e || "/";
  }
}
function Te() {
  return new Ne("");
}
function pe(t) {
  return t.pieceNum_ >= t.pieces_.length ? null : t.pieces_[t.pieceNum_];
}
function Pr(t) {
  return t.pieces_.length - t.pieceNum_;
}
function Re(t) {
  let e = t.pieceNum_;
  return e < t.pieces_.length && e++, new Ne(t.pieces_, e);
}
function Oh(t) {
  return t.pieceNum_ < t.pieces_.length ? t.pieces_[t.pieces_.length - 1] : null;
}
function MI(t) {
  let e = "";
  for (let n = t.pieceNum_; n < t.pieces_.length; n++)
    t.pieces_[n] !== "" && (e += "/" + encodeURIComponent(String(t.pieces_[n])));
  return e || "/";
}
function ss(t, e = 0) {
  return t.pieces_.slice(t.pieceNum_ + e);
}
function sy(t) {
  if (t.pieceNum_ >= t.pieces_.length)
    return null;
  const e = [];
  for (let n = t.pieceNum_; n < t.pieces_.length - 1; n++)
    e.push(t.pieces_[n]);
  return new Ne(e, 0);
}
function Ge(t, e) {
  const n = [];
  for (let r = t.pieceNum_; r < t.pieces_.length; r++)
    n.push(t.pieces_[r]);
  if (e instanceof Ne)
    for (let r = e.pieceNum_; r < e.pieces_.length; r++)
      n.push(e.pieces_[r]);
  else {
    const r = e.split("/");
    for (let i = 0; i < r.length; i++)
      r[i].length > 0 && n.push(r[i]);
  }
  return new Ne(n, 0);
}
function me(t) {
  return t.pieceNum_ >= t.pieces_.length;
}
function Ot(t, e) {
  const n = pe(t), r = pe(e);
  if (n === null)
    return e;
  if (n === r)
    return Ot(Re(t), Re(e));
  throw new Error("INTERNAL ERROR: innerPath (" + e + ") is not within outerPath (" + t + ")");
}
function AI(t, e) {
  const n = ss(t, 0), r = ss(e, 0);
  for (let i = 0; i < n.length && i < r.length; i++) {
    const o = Ni(n[i], r[i]);
    if (o !== 0)
      return o;
  }
  return n.length === r.length ? 0 : n.length < r.length ? -1 : 1;
}
function Dh(t, e) {
  if (Pr(t) !== Pr(e))
    return !1;
  for (let n = t.pieceNum_, r = e.pieceNum_; n <= t.pieces_.length; n++, r++)
    if (t.pieces_[n] !== e.pieces_[r])
      return !1;
  return !0;
}
function fn(t, e) {
  let n = t.pieceNum_, r = e.pieceNum_;
  if (Pr(t) > Pr(e))
    return !1;
  for (; n < t.pieces_.length; ) {
    if (t.pieces_[n] !== e.pieces_[r])
      return !1;
    ++n, ++r;
  }
  return !0;
}
class OI {
  /**
   * @param path - Initial Path.
   * @param errorPrefix_ - Prefix for any error messages.
   */
  constructor(e, n) {
    this.errorPrefix_ = n, this.parts_ = ss(e, 0), this.byteLength_ = Math.max(1, this.parts_.length);
    for (let r = 0; r < this.parts_.length; r++)
      this.byteLength_ += tc(this.parts_[r]);
    ly(this);
  }
}
function DI(t, e) {
  t.parts_.length > 0 && (t.byteLength_ += 1), t.parts_.push(e), t.byteLength_ += tc(e), ly(t);
}
function PI(t) {
  const e = t.parts_.pop();
  t.byteLength_ -= tc(e), t.parts_.length > 0 && (t.byteLength_ -= 1);
}
function ly(t) {
  if (t.byteLength_ > Ip)
    throw new Error(t.errorPrefix_ + "has a key path longer than " + Ip + " bytes (" + t.byteLength_ + ").");
  if (t.parts_.length > Sp)
    throw new Error(t.errorPrefix_ + "path specified exceeds the maximum depth that can be written (" + Sp + ") or object contains a cycle " + Qr(t));
}
function Qr(t) {
  return t.parts_.length === 0 ? "" : "in property '" + t.parts_.join(".") + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ph extends ay {
  constructor() {
    super(["visible"]);
    let e, n;
    typeof document < "u" && typeof document.addEventListener < "u" && (typeof document.hidden < "u" ? (n = "visibilitychange", e = "hidden") : typeof document.mozHidden < "u" ? (n = "mozvisibilitychange", e = "mozHidden") : typeof document.msHidden < "u" ? (n = "msvisibilitychange", e = "msHidden") : typeof document.webkitHidden < "u" && (n = "webkitvisibilitychange", e = "webkitHidden")), this.visible_ = !0, n && document.addEventListener(n, () => {
      const r = !document[e];
      r !== this.visible_ && (this.visible_ = r, this.trigger("visible", r));
    }, !1);
  }
  static getInstance() {
    return new Ph();
  }
  getInitialEvent(e) {
    return V(e === "visible", "Unknown event type: " + e), [this.visible_];
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _a = 1e3, RI = 60 * 5 * 1e3, Np = 30 * 1e3, LI = 1.3, $I = 3e4, FI = "server_kill", Mp = 3;
class ur extends oy {
  /**
   * @param repoInfo_ - Data about the namespace we are connecting to
   * @param applicationId_ - The Firebase App ID for this project
   * @param onDataUpdate_ - A callback for new data from the server
   */
  constructor(e, n, r, i, o, a, s, l) {
    if (super(), this.repoInfo_ = e, this.applicationId_ = n, this.onDataUpdate_ = r, this.onConnectStatus_ = i, this.onServerInfoUpdate_ = o, this.authTokenProvider_ = a, this.appCheckTokenProvider_ = s, this.authOverride_ = l, this.id = ur.nextPersistentConnectionId_++, this.log_ = Fs("p:" + this.id + ":"), this.interruptReasons_ = {}, this.listens = /* @__PURE__ */ new Map(), this.outstandingPuts_ = [], this.outstandingGets_ = [], this.outstandingPutCount_ = 0, this.outstandingGetCount_ = 0, this.onDisconnectRequestQueue_ = [], this.connected_ = !1, this.reconnectDelay_ = _a, this.maxReconnectDelay_ = RI, this.securityDebugCallback_ = null, this.lastSessionId = null, this.establishConnectionTimer_ = null, this.visible_ = !1, this.requestCBHash_ = {}, this.requestNumber_ = 0, this.realtime_ = null, this.authToken_ = null, this.appCheckToken_ = null, this.forceTokenRefresh_ = !1, this.invalidAuthTokenCount_ = 0, this.invalidAppCheckTokenCount_ = 0, this.firstConnection_ = !0, this.lastConnectionAttemptTime_ = null, this.lastConnectionEstablishedTime_ = null, l && !cb())
      throw new Error("Auth override specified in options, but not supported on non Node.js platforms");
    Ph.getInstance().on("visible", this.onVisible_, this), e.host.indexOf("fblocal") === -1 && nf.getInstance().on("online", this.onOnline_, this);
  }
  sendRequest(e, n, r) {
    const i = ++this.requestNumber_, o = { r: i, a: e, b: n };
    this.log_(rt(o)), V(this.connected_, "sendRequest call when we're not connected not allowed."), this.realtime_.sendRequest(o), r && (this.requestCBHash_[i] = r);
  }
  get(e) {
    this.initConnection_();
    const n = new Fn(), i = {
      action: "g",
      request: {
        p: e._path.toString(),
        q: e._queryObject
      },
      onComplete: (a) => {
        const s = a.d;
        a.s === "ok" ? n.resolve(s) : n.reject(s);
      }
    };
    this.outstandingGets_.push(i), this.outstandingGetCount_++;
    const o = this.outstandingGets_.length - 1;
    return this.connected_ && this.sendGet_(o), n.promise;
  }
  listen(e, n, r, i) {
    this.initConnection_();
    const o = e._queryIdentifier, a = e._path.toString();
    this.log_("Listen called for " + a + " " + o), this.listens.has(a) || this.listens.set(a, /* @__PURE__ */ new Map()), V(e._queryParams.isDefault() || !e._queryParams.loadsAllData(), "listen() called for non-default but complete query"), V(!this.listens.get(a).has(o), "listen() called twice for same path/queryId.");
    const s = {
      onComplete: i,
      hashFn: n,
      query: e,
      tag: r
    };
    this.listens.get(a).set(o, s), this.connected_ && this.sendListen_(s);
  }
  sendGet_(e) {
    const n = this.outstandingGets_[e];
    this.sendRequest("g", n.request, (r) => {
      delete this.outstandingGets_[e], this.outstandingGetCount_--, this.outstandingGetCount_ === 0 && (this.outstandingGets_ = []), n.onComplete && n.onComplete(r);
    });
  }
  sendListen_(e) {
    const n = e.query, r = n._path.toString(), i = n._queryIdentifier;
    this.log_("Listen on " + r + " for " + i);
    const o = {
      /*path*/
      p: r
    }, a = "q";
    e.tag && (o.q = n._queryObject, o.t = e.tag), o.h = e.hashFn(), this.sendRequest(a, o, (s) => {
      const l = s.d, f = s.s;
      ur.warnOnListenWarnings_(l, n), (this.listens.get(r) && this.listens.get(r).get(i)) === e && (this.log_("listen response", s), f !== "ok" && this.removeListen_(r, i), e.onComplete && e.onComplete(f, l));
    });
  }
  static warnOnListenWarnings_(e, n) {
    if (e && typeof e == "object" && qn(e, "w")) {
      const r = Co(e, "w");
      if (Array.isArray(r) && ~r.indexOf("no_index")) {
        const i = '".indexOn": "' + n._queryParams.getIndex().toString() + '"', o = n._path.toString();
        Pt(`Using an unspecified index. Your data will be downloaded and filtered on the client. Consider adding ${i} at ${o} to your security rules for better performance.`);
      }
    }
  }
  refreshAuthToken(e) {
    this.authToken_ = e, this.log_("Auth token refreshed"), this.authToken_ ? this.tryAuth() : this.connected_ && this.sendRequest("unauth", {}, () => {
    }), this.reduceReconnectDelayIfAdminCredential_(e);
  }
  reduceReconnectDelayIfAdminCredential_(e) {
    (e && e.length === 40 || yE(e)) && (this.log_("Admin auth credential detected.  Reducing max reconnect time."), this.maxReconnectDelay_ = Np);
  }
  refreshAppCheckToken(e) {
    this.appCheckToken_ = e, this.log_("App check token refreshed"), this.appCheckToken_ ? this.tryAppCheck() : this.connected_ && this.sendRequest("unappeck", {}, () => {
    });
  }
  /**
   * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
   * a auth revoked (the connection is closed).
   */
  tryAuth() {
    if (this.connected_ && this.authToken_) {
      const e = this.authToken_, n = bE(e) ? "auth" : "gauth", r = { cred: e };
      this.authOverride_ === null ? r.noauth = !0 : typeof this.authOverride_ == "object" && (r.authvar = this.authOverride_), this.sendRequest(n, r, (i) => {
        const o = i.s, a = i.d || "error";
        this.authToken_ === e && (o === "ok" ? this.invalidAuthTokenCount_ = 0 : this.onAuthRevoked_(o, a));
      });
    }
  }
  /**
   * Attempts to authenticate with the given token. If the authentication
   * attempt fails, it's triggered like the token was revoked (the connection is
   * closed).
   */
  tryAppCheck() {
    this.connected_ && this.appCheckToken_ && this.sendRequest("appcheck", { token: this.appCheckToken_ }, (e) => {
      const n = e.s, r = e.d || "error";
      n === "ok" ? this.invalidAppCheckTokenCount_ = 0 : this.onAppCheckRevoked_(n, r);
    });
  }
  /**
   * @inheritDoc
   */
  unlisten(e, n) {
    const r = e._path.toString(), i = e._queryIdentifier;
    this.log_("Unlisten called for " + r + " " + i), V(e._queryParams.isDefault() || !e._queryParams.loadsAllData(), "unlisten() called for non-default but complete query"), this.removeListen_(r, i) && this.connected_ && this.sendUnlisten_(r, i, e._queryObject, n);
  }
  sendUnlisten_(e, n, r, i) {
    this.log_("Unlisten on " + e + " for " + n);
    const o = {
      /*path*/
      p: e
    }, a = "n";
    i && (o.q = r, o.t = i), this.sendRequest(a, o);
  }
  onDisconnectPut(e, n, r) {
    this.initConnection_(), this.connected_ ? this.sendOnDisconnect_("o", e, n, r) : this.onDisconnectRequestQueue_.push({
      pathString: e,
      action: "o",
      data: n,
      onComplete: r
    });
  }
  onDisconnectMerge(e, n, r) {
    this.initConnection_(), this.connected_ ? this.sendOnDisconnect_("om", e, n, r) : this.onDisconnectRequestQueue_.push({
      pathString: e,
      action: "om",
      data: n,
      onComplete: r
    });
  }
  onDisconnectCancel(e, n) {
    this.initConnection_(), this.connected_ ? this.sendOnDisconnect_("oc", e, null, n) : this.onDisconnectRequestQueue_.push({
      pathString: e,
      action: "oc",
      data: null,
      onComplete: n
    });
  }
  sendOnDisconnect_(e, n, r, i) {
    const o = {
      /*path*/
      p: n,
      /*data*/
      d: r
    };
    this.log_("onDisconnect " + e, o), this.sendRequest(e, o, (a) => {
      i && setTimeout(() => {
        i(a.s, a.d);
      }, Math.floor(0));
    });
  }
  put(e, n, r, i) {
    this.putInternal("p", e, n, r, i);
  }
  merge(e, n, r, i) {
    this.putInternal("m", e, n, r, i);
  }
  putInternal(e, n, r, i, o) {
    this.initConnection_();
    const a = {
      /*path*/
      p: n,
      /*data*/
      d: r
    };
    o !== void 0 && (a.h = o), this.outstandingPuts_.push({
      action: e,
      request: a,
      onComplete: i
    }), this.outstandingPutCount_++;
    const s = this.outstandingPuts_.length - 1;
    this.connected_ ? this.sendPut_(s) : this.log_("Buffering put: " + n);
  }
  sendPut_(e) {
    const n = this.outstandingPuts_[e].action, r = this.outstandingPuts_[e].request, i = this.outstandingPuts_[e].onComplete;
    this.outstandingPuts_[e].queued = this.connected_, this.sendRequest(n, r, (o) => {
      this.log_(n + " response", o), delete this.outstandingPuts_[e], this.outstandingPutCount_--, this.outstandingPutCount_ === 0 && (this.outstandingPuts_ = []), i && i(o.s, o.d);
    });
  }
  reportStats(e) {
    if (this.connected_) {
      const n = {
        /*counters*/
        c: e
      };
      this.log_("reportStats", n), this.sendRequest(
        /*stats*/
        "s",
        n,
        (r) => {
          if (r.s !== "ok") {
            const o = r.d;
            this.log_("reportStats", "Error sending stats: " + o);
          }
        }
      );
    }
  }
  onDataMessage_(e) {
    if ("r" in e) {
      this.log_("from server: " + rt(e));
      const n = e.r, r = this.requestCBHash_[n];
      r && (delete this.requestCBHash_[n], r(e.b));
    } else {
      if ("error" in e)
        throw "A server-side error has occurred: " + e.error;
      "a" in e && this.onDataPush_(e.a, e.b);
    }
  }
  onDataPush_(e, n) {
    this.log_("handleServerMessage", e, n), e === "d" ? this.onDataUpdate_(
      n.p,
      n.d,
      /*isMerge*/
      !1,
      n.t
    ) : e === "m" ? this.onDataUpdate_(
      n.p,
      n.d,
      /*isMerge=*/
      !0,
      n.t
    ) : e === "c" ? this.onListenRevoked_(n.p, n.q) : e === "ac" ? this.onAuthRevoked_(n.s, n.d) : e === "apc" ? this.onAppCheckRevoked_(n.s, n.d) : e === "sd" ? this.onSecurityDebugPacket_(n) : Ud("Unrecognized action received from server: " + rt(e) + `
Are you using the latest client?`);
  }
  onReady_(e, n) {
    this.log_("connection ready"), this.connected_ = !0, this.lastConnectionEstablishedTime_ = new Date().getTime(), this.handleTimestamp_(e), this.lastSessionId = n, this.firstConnection_ && this.sendConnectStats_(), this.restoreState_(), this.firstConnection_ = !1, this.onConnectStatus_(!0);
  }
  scheduleConnect_(e) {
    V(!this.realtime_, "Scheduling a connect when we're already connected/ing?"), this.establishConnectionTimer_ && clearTimeout(this.establishConnectionTimer_), this.establishConnectionTimer_ = setTimeout(() => {
      this.establishConnectionTimer_ = null, this.establishConnection_();
    }, Math.floor(e));
  }
  initConnection_() {
    !this.realtime_ && this.firstConnection_ && this.scheduleConnect_(0);
  }
  onVisible_(e) {
    e && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_ && (this.log_("Window became visible.  Reducing delay."), this.reconnectDelay_ = _a, this.realtime_ || this.scheduleConnect_(0)), this.visible_ = e;
  }
  onOnline_(e) {
    e ? (this.log_("Browser went online."), this.reconnectDelay_ = _a, this.realtime_ || this.scheduleConnect_(0)) : (this.log_("Browser went offline.  Killing connection."), this.realtime_ && this.realtime_.close());
  }
  onRealtimeDisconnect_() {
    if (this.log_("data client disconnected"), this.connected_ = !1, this.realtime_ = null, this.cancelSentTransactions_(), this.requestCBHash_ = {}, this.shouldReconnect_()) {
      this.visible_ ? this.lastConnectionEstablishedTime_ && (new Date().getTime() - this.lastConnectionEstablishedTime_ > $I && (this.reconnectDelay_ = _a), this.lastConnectionEstablishedTime_ = null) : (this.log_("Window isn't visible.  Delaying reconnect."), this.reconnectDelay_ = this.maxReconnectDelay_, this.lastConnectionAttemptTime_ = new Date().getTime());
      const e = new Date().getTime() - this.lastConnectionAttemptTime_;
      let n = Math.max(0, this.reconnectDelay_ - e);
      n = Math.random() * n, this.log_("Trying to reconnect in " + n + "ms"), this.scheduleConnect_(n), this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * LI);
    }
    this.onConnectStatus_(!1);
  }
  async establishConnection_() {
    if (this.shouldReconnect_()) {
      this.log_("Making a connection attempt"), this.lastConnectionAttemptTime_ = new Date().getTime(), this.lastConnectionEstablishedTime_ = null;
      const e = this.onDataMessage_.bind(this), n = this.onReady_.bind(this), r = this.onRealtimeDisconnect_.bind(this), i = this.id + ":" + ur.nextConnectionId_++, o = this.lastSessionId;
      let a = !1, s = null;
      const l = function() {
        s ? s.close() : (a = !0, r());
      }, f = function(u) {
        V(s, "sendRequest call when we're not connected not allowed."), s.sendRequest(u);
      };
      this.realtime_ = {
        close: l,
        sendRequest: f
      };
      const c = this.forceTokenRefresh_;
      this.forceTokenRefresh_ = !1;
      try {
        const [u, d] = await Promise.all([
          this.authTokenProvider_.getToken(c),
          this.appCheckTokenProvider_.getToken(c)
        ]);
        a ? ht("getToken() completed but was canceled") : (ht("getToken() completed. Creating connection."), this.authToken_ = u && u.accessToken, this.appCheckToken_ = d && d.token, s = new NI(
          i,
          this.repoInfo_,
          this.applicationId_,
          this.appCheckToken_,
          this.authToken_,
          e,
          n,
          r,
          /* onKill= */
          (h) => {
            Pt(h + " (" + this.repoInfo_.toString() + ")"), this.interrupt(FI);
          },
          o
        ));
      } catch (u) {
        this.log_("Failed to get token: " + u), a || (this.repoInfo_.nodeAdmin && Pt(u), l());
      }
    }
  }
  interrupt(e) {
    ht("Interrupting connection for reason: " + e), this.interruptReasons_[e] = !0, this.realtime_ ? this.realtime_.close() : (this.establishConnectionTimer_ && (clearTimeout(this.establishConnectionTimer_), this.establishConnectionTimer_ = null), this.connected_ && this.onRealtimeDisconnect_());
  }
  resume(e) {
    ht("Resuming connection for reason: " + e), delete this.interruptReasons_[e], Md(this.interruptReasons_) && (this.reconnectDelay_ = _a, this.realtime_ || this.scheduleConnect_(0));
  }
  handleTimestamp_(e) {
    const n = e - new Date().getTime();
    this.onServerInfoUpdate_({ serverTimeOffset: n });
  }
  cancelSentTransactions_() {
    for (let e = 0; e < this.outstandingPuts_.length; e++) {
      const n = this.outstandingPuts_[e];
      n && /*hash*/
      "h" in n.request && n.queued && (n.onComplete && n.onComplete("disconnect"), delete this.outstandingPuts_[e], this.outstandingPutCount_--);
    }
    this.outstandingPutCount_ === 0 && (this.outstandingPuts_ = []);
  }
  onListenRevoked_(e, n) {
    let r;
    n ? r = n.map((o) => Ih(o)).join("$") : r = "default";
    const i = this.removeListen_(e, r);
    i && i.onComplete && i.onComplete("permission_denied");
  }
  removeListen_(e, n) {
    const r = new Ne(e).toString();
    let i;
    if (this.listens.has(r)) {
      const o = this.listens.get(r);
      i = o.get(n), o.delete(n), o.size === 0 && this.listens.delete(r);
    } else
      i = void 0;
    return i;
  }
  onAuthRevoked_(e, n) {
    ht("Auth token revoked: " + e + "/" + n), this.authToken_ = null, this.forceTokenRefresh_ = !0, this.realtime_.close(), (e === "invalid_token" || e === "permission_denied") && (this.invalidAuthTokenCount_++, this.invalidAuthTokenCount_ >= Mp && (this.reconnectDelay_ = Np, this.authTokenProvider_.notifyForInvalidToken()));
  }
  onAppCheckRevoked_(e, n) {
    ht("App check token revoked: " + e + "/" + n), this.appCheckToken_ = null, this.forceTokenRefresh_ = !0, (e === "invalid_token" || e === "permission_denied") && (this.invalidAppCheckTokenCount_++, this.invalidAppCheckTokenCount_ >= Mp && this.appCheckTokenProvider_.notifyForInvalidToken());
  }
  onSecurityDebugPacket_(e) {
    this.securityDebugCallback_ ? this.securityDebugCallback_(e) : "msg" in e && console.log("FIREBASE: " + e.msg.replace(`
`, `
FIREBASE: `));
  }
  restoreState_() {
    this.tryAuth(), this.tryAppCheck();
    for (const e of this.listens.values())
      for (const n of e.values())
        this.sendListen_(n);
    for (let e = 0; e < this.outstandingPuts_.length; e++)
      this.outstandingPuts_[e] && this.sendPut_(e);
    for (; this.onDisconnectRequestQueue_.length; ) {
      const e = this.onDisconnectRequestQueue_.shift();
      this.sendOnDisconnect_(e.action, e.pathString, e.data, e.onComplete);
    }
    for (let e = 0; e < this.outstandingGets_.length; e++)
      this.outstandingGets_[e] && this.sendGet_(e);
  }
  /**
   * Sends client stats for first connection
   */
  sendConnectStats_() {
    const e = {};
    let n = "js";
    e["sdk." + n + "." + Fb.replace(/\./g, "-")] = 1, mh() ? e["framework.cordova"] = 1 : fb() && (e["framework.reactnative"] = 1), this.reportStats(e);
  }
  shouldReconnect_() {
    const e = nf.getInstance().currentlyOnline();
    return Md(this.interruptReasons_) && e;
  }
}
ur.nextPersistentConnectionId_ = 0;
ur.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ve {
  constructor(e, n) {
    this.name = e, this.node = n;
  }
  static Wrap(e, n) {
    return new ve(e, n);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class rc {
  /**
   * @returns A standalone comparison function for
   * this index
   */
  getCompare() {
    return this.compare.bind(this);
  }
  /**
   * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
   * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
   *
   *
   * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
   */
  indexedValueChanged(e, n) {
    const r = new ve(bi, e), i = new ve(bi, n);
    return this.compare(r, i) !== 0;
  }
  /**
   * @returns a node wrapper that will sort equal to or less than
   * any other node wrapper, using this index
   */
  minPost() {
    return ve.MIN;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let ol;
class fy extends rc {
  static get __EMPTY_NODE() {
    return ol;
  }
  static set __EMPTY_NODE(e) {
    ol = e;
  }
  compare(e, n) {
    return Ni(e.name, n.name);
  }
  isDefinedOn(e) {
    throw Ho("KeyIndex.isDefinedOn not expected to be called.");
  }
  indexedValueChanged(e, n) {
    return !1;
  }
  minPost() {
    return ve.MIN;
  }
  maxPost() {
    return new ve(Vn, ol);
  }
  makePost(e, n) {
    return V(typeof e == "string", "KeyIndex indexValue must always be a string."), new ve(e, ol);
  }
  /**
   * @returns String representation for inclusion in a query spec
   */
  toString() {
    return ".key";
  }
}
const dr = new fy();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class al {
  /**
   * @param node - Node to iterate.
   * @param isReverse_ - Whether or not to iterate in reverse
   */
  constructor(e, n, r, i, o = null) {
    this.isReverse_ = i, this.resultGenerator_ = o, this.nodeStack_ = [];
    let a = 1;
    for (; !e.isEmpty(); )
      if (e = e, a = n ? r(e.key, n) : 1, i && (a *= -1), a < 0)
        this.isReverse_ ? e = e.left : e = e.right;
      else if (a === 0) {
        this.nodeStack_.push(e);
        break;
      } else
        this.nodeStack_.push(e), this.isReverse_ ? e = e.right : e = e.left;
  }
  getNext() {
    if (this.nodeStack_.length === 0)
      return null;
    let e = this.nodeStack_.pop(), n;
    if (this.resultGenerator_ ? n = this.resultGenerator_(e.key, e.value) : n = { key: e.key, value: e.value }, this.isReverse_)
      for (e = e.left; !e.isEmpty(); )
        this.nodeStack_.push(e), e = e.right;
    else
      for (e = e.right; !e.isEmpty(); )
        this.nodeStack_.push(e), e = e.left;
    return n;
  }
  hasNext() {
    return this.nodeStack_.length > 0;
  }
  peek() {
    if (this.nodeStack_.length === 0)
      return null;
    const e = this.nodeStack_[this.nodeStack_.length - 1];
    return this.resultGenerator_ ? this.resultGenerator_(e.key, e.value) : { key: e.key, value: e.value };
  }
}
class ut {
  /**
   * @param key - Key associated with this node.
   * @param value - Value associated with this node.
   * @param color - Whether this node is red.
   * @param left - Left child.
   * @param right - Right child.
   */
  constructor(e, n, r, i, o) {
    this.key = e, this.value = n, this.color = r ?? ut.RED, this.left = i ?? Ut.EMPTY_NODE, this.right = o ?? Ut.EMPTY_NODE;
  }
  /**
   * Returns a copy of the current node, optionally replacing pieces of it.
   *
   * @param key - New key for the node, or null.
   * @param value - New value for the node, or null.
   * @param color - New color for the node, or null.
   * @param left - New left child for the node, or null.
   * @param right - New right child for the node, or null.
   * @returns The node copy.
   */
  copy(e, n, r, i, o) {
    return new ut(e ?? this.key, n ?? this.value, r ?? this.color, i ?? this.left, o ?? this.right);
  }
  /**
   * @returns The total number of nodes in the tree.
   */
  count() {
    return this.left.count() + 1 + this.right.count();
  }
  /**
   * @returns True if the tree is empty.
   */
  isEmpty() {
    return !1;
  }
  /**
   * Traverses the tree in key order and calls the specified action function
   * for each node.
   *
   * @param action - Callback function to be called for each
   *   node.  If it returns true, traversal is aborted.
   * @returns The first truthy value returned by action, or the last falsey
   *   value returned by action
   */
  inorderTraversal(e) {
    return this.left.inorderTraversal(e) || !!e(this.key, this.value) || this.right.inorderTraversal(e);
  }
  /**
   * Traverses the tree in reverse key order and calls the specified action function
   * for each node.
   *
   * @param action - Callback function to be called for each
   * node.  If it returns true, traversal is aborted.
   * @returns True if traversal was aborted.
   */
  reverseTraversal(e) {
    return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
  }
  /**
   * @returns The minimum node in the tree.
   */
  min_() {
    return this.left.isEmpty() ? this : this.left.min_();
  }
  /**
   * @returns The maximum key in the tree.
   */
  minKey() {
    return this.min_().key;
  }
  /**
   * @returns The maximum key in the tree.
   */
  maxKey() {
    return this.right.isEmpty() ? this.key : this.right.maxKey();
  }
  /**
   * @param key - Key to insert.
   * @param value - Value to insert.
   * @param comparator - Comparator.
   * @returns New tree, with the key/value added.
   */
  insert(e, n, r) {
    let i = this;
    const o = r(e, i.key);
    return o < 0 ? i = i.copy(null, null, null, i.left.insert(e, n, r), null) : o === 0 ? i = i.copy(null, n, null, null, null) : i = i.copy(null, null, null, null, i.right.insert(e, n, r)), i.fixUp_();
  }
  /**
   * @returns New tree, with the minimum key removed.
   */
  removeMin_() {
    if (this.left.isEmpty())
      return Ut.EMPTY_NODE;
    let e = this;
    return !e.left.isRed_() && !e.left.left.isRed_() && (e = e.moveRedLeft_()), e = e.copy(null, null, null, e.left.removeMin_(), null), e.fixUp_();
  }
  /**
   * @param key - The key of the item to remove.
   * @param comparator - Comparator.
   * @returns New tree, with the specified item removed.
   */
  remove(e, n) {
    let r, i;
    if (r = this, n(e, r.key) < 0)
      !r.left.isEmpty() && !r.left.isRed_() && !r.left.left.isRed_() && (r = r.moveRedLeft_()), r = r.copy(null, null, null, r.left.remove(e, n), null);
    else {
      if (r.left.isRed_() && (r = r.rotateRight_()), !r.right.isEmpty() && !r.right.isRed_() && !r.right.left.isRed_() && (r = r.moveRedRight_()), n(e, r.key) === 0) {
        if (r.right.isEmpty())
          return Ut.EMPTY_NODE;
        i = r.right.min_(), r = r.copy(i.key, i.value, null, null, r.right.removeMin_());
      }
      r = r.copy(null, null, null, null, r.right.remove(e, n));
    }
    return r.fixUp_();
  }
  /**
   * @returns Whether this is a RED node.
   */
  isRed_() {
    return this.color;
  }
  /**
   * @returns New tree after performing any needed rotations.
   */
  fixUp_() {
    let e = this;
    return e.right.isRed_() && !e.left.isRed_() && (e = e.rotateLeft_()), e.left.isRed_() && e.left.left.isRed_() && (e = e.rotateRight_()), e.left.isRed_() && e.right.isRed_() && (e = e.colorFlip_()), e;
  }
  /**
   * @returns New tree, after moveRedLeft.
   */
  moveRedLeft_() {
    let e = this.colorFlip_();
    return e.right.left.isRed_() && (e = e.copy(null, null, null, null, e.right.rotateRight_()), e = e.rotateLeft_(), e = e.colorFlip_()), e;
  }
  /**
   * @returns New tree, after moveRedRight.
   */
  moveRedRight_() {
    let e = this.colorFlip_();
    return e.left.left.isRed_() && (e = e.rotateRight_(), e = e.colorFlip_()), e;
  }
  /**
   * @returns New tree, after rotateLeft.
   */
  rotateLeft_() {
    const e = this.copy(null, null, ut.RED, null, this.right.left);
    return this.right.copy(null, null, this.color, e, null);
  }
  /**
   * @returns New tree, after rotateRight.
   */
  rotateRight_() {
    const e = this.copy(null, null, ut.RED, this.left.right, null);
    return this.left.copy(null, null, this.color, null, e);
  }
  /**
   * @returns Newt ree, after colorFlip.
   */
  colorFlip_() {
    const e = this.left.copy(null, null, !this.left.color, null, null), n = this.right.copy(null, null, !this.right.color, null, null);
    return this.copy(null, null, !this.color, e, n);
  }
  /**
   * For testing.
   *
   * @returns True if all is well.
   */
  checkMaxDepth_() {
    const e = this.check_();
    return Math.pow(2, e) <= this.count() + 1;
  }
  check_() {
    if (this.isRed_() && this.left.isRed_())
      throw new Error("Red node has red child(" + this.key + "," + this.value + ")");
    if (this.right.isRed_())
      throw new Error("Right child of (" + this.key + "," + this.value + ") is red");
    const e = this.left.check_();
    if (e !== this.right.check_())
      throw new Error("Black depths differ");
    return e + (this.isRed_() ? 0 : 1);
  }
}
ut.RED = !0;
ut.BLACK = !1;
class jI {
  /**
   * Returns a copy of the current node.
   *
   * @returns The node copy.
   */
  copy(e, n, r, i, o) {
    return this;
  }
  /**
   * Returns a copy of the tree, with the specified key/value added.
   *
   * @param key - Key to be added.
   * @param value - Value to be added.
   * @param comparator - Comparator.
   * @returns New tree, with item added.
   */
  insert(e, n, r) {
    return new ut(e, n, null);
  }
  /**
   * Returns a copy of the tree, with the specified key removed.
   *
   * @param key - The key to remove.
   * @param comparator - Comparator.
   * @returns New tree, with item removed.
   */
  remove(e, n) {
    return this;
  }
  /**
   * @returns The total number of nodes in the tree.
   */
  count() {
    return 0;
  }
  /**
   * @returns True if the tree is empty.
   */
  isEmpty() {
    return !0;
  }
  /**
   * Traverses the tree in key order and calls the specified action function
   * for each node.
   *
   * @param action - Callback function to be called for each
   * node.  If it returns true, traversal is aborted.
   * @returns True if traversal was aborted.
   */
  inorderTraversal(e) {
    return !1;
  }
  /**
   * Traverses the tree in reverse key order and calls the specified action function
   * for each node.
   *
   * @param action - Callback function to be called for each
   * node.  If it returns true, traversal is aborted.
   * @returns True if traversal was aborted.
   */
  reverseTraversal(e) {
    return !1;
  }
  minKey() {
    return null;
  }
  maxKey() {
    return null;
  }
  check_() {
    return 0;
  }
  /**
   * @returns Whether this node is red.
   */
  isRed_() {
    return !1;
  }
}
class Ut {
  /**
   * @param comparator_ - Key comparator.
   * @param root_ - Optional root node for the map.
   */
  constructor(e, n = Ut.EMPTY_NODE) {
    this.comparator_ = e, this.root_ = n;
  }
  /**
   * Returns a copy of the map, with the specified key/value added or replaced.
   * (TODO: We should perhaps rename this method to 'put')
   *
   * @param key - Key to be added.
   * @param value - Value to be added.
   * @returns New map, with item added.
   */
  insert(e, n) {
    return new Ut(this.comparator_, this.root_.insert(e, n, this.comparator_).copy(null, null, ut.BLACK, null, null));
  }
  /**
   * Returns a copy of the map, with the specified key removed.
   *
   * @param key - The key to remove.
   * @returns New map, with item removed.
   */
  remove(e) {
    return new Ut(this.comparator_, this.root_.remove(e, this.comparator_).copy(null, null, ut.BLACK, null, null));
  }
  /**
   * Returns the value of the node with the given key, or null.
   *
   * @param key - The key to look up.
   * @returns The value of the node with the given key, or null if the
   * key doesn't exist.
   */
  get(e) {
    let n, r = this.root_;
    for (; !r.isEmpty(); ) {
      if (n = this.comparator_(e, r.key), n === 0)
        return r.value;
      n < 0 ? r = r.left : n > 0 && (r = r.right);
    }
    return null;
  }
  /**
   * Returns the key of the item *before* the specified key, or null if key is the first item.
   * @param key - The key to find the predecessor of
   * @returns The predecessor key.
   */
  getPredecessorKey(e) {
    let n, r = this.root_, i = null;
    for (; !r.isEmpty(); )
      if (n = this.comparator_(e, r.key), n === 0) {
        if (r.left.isEmpty())
          return i ? i.key : null;
        for (r = r.left; !r.right.isEmpty(); )
          r = r.right;
        return r.key;
      } else
        n < 0 ? r = r.left : n > 0 && (i = r, r = r.right);
    throw new Error("Attempted to find predecessor key for a nonexistent key.  What gives?");
  }
  /**
   * @returns True if the map is empty.
   */
  isEmpty() {
    return this.root_.isEmpty();
  }
  /**
   * @returns The total number of nodes in the map.
   */
  count() {
    return this.root_.count();
  }
  /**
   * @returns The minimum key in the map.
   */
  minKey() {
    return this.root_.minKey();
  }
  /**
   * @returns The maximum key in the map.
   */
  maxKey() {
    return this.root_.maxKey();
  }
  /**
   * Traverses the map in key order and calls the specified action function
   * for each key/value pair.
   *
   * @param action - Callback function to be called
   * for each key/value pair.  If action returns true, traversal is aborted.
   * @returns The first truthy value returned by action, or the last falsey
   *   value returned by action
   */
  inorderTraversal(e) {
    return this.root_.inorderTraversal(e);
  }
  /**
   * Traverses the map in reverse key order and calls the specified action function
   * for each key/value pair.
   *
   * @param action - Callback function to be called
   * for each key/value pair.  If action returns true, traversal is aborted.
   * @returns True if the traversal was aborted.
   */
  reverseTraversal(e) {
    return this.root_.reverseTraversal(e);
  }
  /**
   * Returns an iterator over the SortedMap.
   * @returns The iterator.
   */
  getIterator(e) {
    return new al(this.root_, null, this.comparator_, !1, e);
  }
  getIteratorFrom(e, n) {
    return new al(this.root_, e, this.comparator_, !1, n);
  }
  getReverseIteratorFrom(e, n) {
    return new al(this.root_, e, this.comparator_, !0, n);
  }
  getReverseIterator(e) {
    return new al(this.root_, null, this.comparator_, !0, e);
  }
}
Ut.EMPTY_NODE = new jI();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function zI(t, e) {
  return Ni(t.name, e.name);
}
function Rh(t, e) {
  return Ni(t, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Yd;
function BI(t) {
  Yd = t;
}
const cy = function(t) {
  return typeof t == "number" ? "number:" + Wb(t) : "string:" + t;
}, uy = function(t) {
  if (t.isLeafNode()) {
    const e = t.val();
    V(typeof e == "string" || typeof e == "number" || typeof e == "object" && qn(e, ".sv"), "Priority must be a string or number.");
  } else
    V(t === Yd || t.isEmpty(), "priority of unexpected type.");
  V(t === Yd || t.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Ap;
class ft {
  /**
   * @param value_ - The value to store in this leaf node. The object type is
   * possible in the event of a deferred value
   * @param priorityNode_ - The priority of this node.
   */
  constructor(e, n = ft.__childrenNodeConstructor.EMPTY_NODE) {
    this.value_ = e, this.priorityNode_ = n, this.lazyHash_ = null, V(this.value_ !== void 0 && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value."), uy(this.priorityNode_);
  }
  static set __childrenNodeConstructor(e) {
    Ap = e;
  }
  static get __childrenNodeConstructor() {
    return Ap;
  }
  /** @inheritDoc */
  isLeafNode() {
    return !0;
  }
  /** @inheritDoc */
  getPriority() {
    return this.priorityNode_;
  }
  /** @inheritDoc */
  updatePriority(e) {
    return new ft(this.value_, e);
  }
  /** @inheritDoc */
  getImmediateChild(e) {
    return e === ".priority" ? this.priorityNode_ : ft.__childrenNodeConstructor.EMPTY_NODE;
  }
  /** @inheritDoc */
  getChild(e) {
    return me(e) ? this : pe(e) === ".priority" ? this.priorityNode_ : ft.__childrenNodeConstructor.EMPTY_NODE;
  }
  hasChild() {
    return !1;
  }
  /** @inheritDoc */
  getPredecessorChildName(e, n) {
    return null;
  }
  /** @inheritDoc */
  updateImmediateChild(e, n) {
    return e === ".priority" ? this.updatePriority(n) : n.isEmpty() && e !== ".priority" ? this : ft.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(e, n).updatePriority(this.priorityNode_);
  }
  /** @inheritDoc */
  updateChild(e, n) {
    const r = pe(e);
    return r === null ? n : n.isEmpty() && r !== ".priority" ? this : (V(r !== ".priority" || Pr(e) === 1, ".priority must be the last token in a path"), this.updateImmediateChild(r, ft.__childrenNodeConstructor.EMPTY_NODE.updateChild(Re(e), n)));
  }
  /** @inheritDoc */
  isEmpty() {
    return !1;
  }
  /** @inheritDoc */
  numChildren() {
    return 0;
  }
  /** @inheritDoc */
  forEachChild(e, n) {
    return !1;
  }
  val(e) {
    return e && !this.getPriority().isEmpty() ? {
      ".value": this.getValue(),
      ".priority": this.getPriority().val()
    } : this.getValue();
  }
  /** @inheritDoc */
  hash() {
    if (this.lazyHash_ === null) {
      let e = "";
      this.priorityNode_.isEmpty() || (e += "priority:" + cy(this.priorityNode_.val()) + ":");
      const n = typeof this.value_;
      e += n + ":", n === "number" ? e += Wb(this.value_) : e += this.value_, this.lazyHash_ = zb(e);
    }
    return this.lazyHash_;
  }
  /**
   * Returns the value of the leaf node.
   * @returns The value of the node.
   */
  getValue() {
    return this.value_;
  }
  compareTo(e) {
    return e === ft.__childrenNodeConstructor.EMPTY_NODE ? 1 : e instanceof ft.__childrenNodeConstructor ? -1 : (V(e.isLeafNode(), "Unknown node type"), this.compareToLeafNode_(e));
  }
  /**
   * Comparison specifically for two leaf nodes
   */
  compareToLeafNode_(e) {
    const n = typeof e.value_, r = typeof this.value_, i = ft.VALUE_TYPE_ORDER.indexOf(n), o = ft.VALUE_TYPE_ORDER.indexOf(r);
    return V(i >= 0, "Unknown leaf type: " + n), V(o >= 0, "Unknown leaf type: " + r), i === o ? r === "object" ? 0 : this.value_ < e.value_ ? -1 : this.value_ === e.value_ ? 0 : 1 : o - i;
  }
  withIndex() {
    return this;
  }
  isIndexed() {
    return !0;
  }
  equals(e) {
    if (e === this)
      return !0;
    if (e.isLeafNode()) {
      const n = e;
      return this.value_ === n.value_ && this.priorityNode_.equals(n.priorityNode_);
    } else
      return !1;
  }
}
ft.VALUE_TYPE_ORDER = ["object", "boolean", "number", "string"];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let dy, hy;
function WI(t) {
  dy = t;
}
function UI(t) {
  hy = t;
}
class HI extends rc {
  compare(e, n) {
    const r = e.node.getPriority(), i = n.node.getPriority(), o = r.compareTo(i);
    return o === 0 ? Ni(e.name, n.name) : o;
  }
  isDefinedOn(e) {
    return !e.getPriority().isEmpty();
  }
  indexedValueChanged(e, n) {
    return !e.getPriority().equals(n.getPriority());
  }
  minPost() {
    return ve.MIN;
  }
  maxPost() {
    return new ve(Vn, new ft("[PRIORITY-POST]", hy));
  }
  makePost(e, n) {
    const r = dy(e);
    return new ve(n, new ft("[PRIORITY-POST]", r));
  }
  /**
   * @returns String representation for inclusion in a query spec
   */
  toString() {
    return ".priority";
  }
}
const qe = new HI();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const VI = Math.log(2);
class KI {
  constructor(e) {
    const n = (o) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parseInt(Math.log(o) / VI, 10)
    ), r = (o) => parseInt(Array(o + 1).join("1"), 2);
    this.count = n(e + 1), this.current_ = this.count - 1;
    const i = r(this.count);
    this.bits_ = e + 1 & i;
  }
  nextBitIsOne() {
    const e = !(this.bits_ & 1 << this.current_);
    return this.current_--, e;
  }
}
const rf = function(t, e, n, r) {
  t.sort(e);
  const i = function(l, f) {
    const c = f - l;
    let u, d;
    if (c === 0)
      return null;
    if (c === 1)
      return u = t[l], d = n ? n(u) : u, new ut(d, u.node, ut.BLACK, null, null);
    {
      const h = parseInt(c / 2, 10) + l, p = i(l, h), m = i(h + 1, f);
      return u = t[h], d = n ? n(u) : u, new ut(d, u.node, ut.BLACK, p, m);
    }
  }, o = function(l) {
    let f = null, c = null, u = t.length;
    const d = function(p, m) {
      const v = u - p, b = u;
      u -= p;
      const k = i(v + 1, b), _ = t[v], E = n ? n(_) : _;
      h(new ut(E, _.node, m, null, k));
    }, h = function(p) {
      f ? (f.left = p, f = p) : (c = p, f = p);
    };
    for (let p = 0; p < l.count; ++p) {
      const m = l.nextBitIsOne(), v = Math.pow(2, l.count - (p + 1));
      m ? d(v, ut.BLACK) : (d(v, ut.BLACK), d(v, ut.RED));
    }
    return c;
  }, a = new KI(t.length), s = o(a);
  return new Ut(r || e, s);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Du;
const to = {};
class fr {
  constructor(e, n) {
    this.indexes_ = e, this.indexSet_ = n;
  }
  /**
   * The default IndexMap for nodes without a priority
   */
  static get Default() {
    return V(to && qe, "ChildrenNode.ts has not been loaded"), Du = Du || new fr({ ".priority": to }, { ".priority": qe }), Du;
  }
  get(e) {
    const n = Co(this.indexes_, e);
    if (!n)
      throw new Error("No index defined for " + e);
    return n instanceof Ut ? n : null;
  }
  hasIndex(e) {
    return qn(this.indexSet_, e.toString());
  }
  addIndex(e, n) {
    V(e !== dr, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
    const r = [];
    let i = !1;
    const o = n.getIterator(ve.Wrap);
    let a = o.getNext();
    for (; a; )
      i = i || e.isDefinedOn(a.node), r.push(a), a = o.getNext();
    let s;
    i ? s = rf(r, e.getCompare()) : s = to;
    const l = e.toString(), f = Object.assign({}, this.indexSet_);
    f[l] = e;
    const c = Object.assign({}, this.indexes_);
    return c[l] = s, new fr(c, f);
  }
  /**
   * Ensure that this node is properly tracked in any indexes that we're maintaining
   */
  addToIndexes(e, n) {
    const r = Kl(this.indexes_, (i, o) => {
      const a = Co(this.indexSet_, o);
      if (V(a, "Missing index implementation for " + o), i === to)
        if (a.isDefinedOn(e.node)) {
          const s = [], l = n.getIterator(ve.Wrap);
          let f = l.getNext();
          for (; f; )
            f.name !== e.name && s.push(f), f = l.getNext();
          return s.push(e), rf(s, a.getCompare());
        } else
          return to;
      else {
        const s = n.get(e.name);
        let l = i;
        return s && (l = l.remove(new ve(e.name, s))), l.insert(e, e.node);
      }
    });
    return new fr(r, this.indexSet_);
  }
  /**
   * Create a new IndexMap instance with the given value removed
   */
  removeFromIndexes(e, n) {
    const r = Kl(this.indexes_, (i) => {
      if (i === to)
        return i;
      {
        const o = n.get(e.name);
        return o ? i.remove(new ve(e.name, o)) : i;
      }
    });
    return new fr(r, this.indexSet_);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let wa;
class re {
  /**
   * @param children_ - List of children of this node..
   * @param priorityNode_ - The priority of this node (as a snapshot node).
   */
  constructor(e, n, r) {
    this.children_ = e, this.priorityNode_ = n, this.indexMap_ = r, this.lazyHash_ = null, this.priorityNode_ && uy(this.priorityNode_), this.children_.isEmpty() && V(!this.priorityNode_ || this.priorityNode_.isEmpty(), "An empty node cannot have a priority");
  }
  static get EMPTY_NODE() {
    return wa || (wa = new re(new Ut(Rh), null, fr.Default));
  }
  /** @inheritDoc */
  isLeafNode() {
    return !1;
  }
  /** @inheritDoc */
  getPriority() {
    return this.priorityNode_ || wa;
  }
  /** @inheritDoc */
  updatePriority(e) {
    return this.children_.isEmpty() ? this : new re(this.children_, e, this.indexMap_);
  }
  /** @inheritDoc */
  getImmediateChild(e) {
    if (e === ".priority")
      return this.getPriority();
    {
      const n = this.children_.get(e);
      return n === null ? wa : n;
    }
  }
  /** @inheritDoc */
  getChild(e) {
    const n = pe(e);
    return n === null ? this : this.getImmediateChild(n).getChild(Re(e));
  }
  /** @inheritDoc */
  hasChild(e) {
    return this.children_.get(e) !== null;
  }
  /** @inheritDoc */
  updateImmediateChild(e, n) {
    if (V(n, "We should always be passing snapshot nodes"), e === ".priority")
      return this.updatePriority(n);
    {
      const r = new ve(e, n);
      let i, o;
      n.isEmpty() ? (i = this.children_.remove(e), o = this.indexMap_.removeFromIndexes(r, this.children_)) : (i = this.children_.insert(e, n), o = this.indexMap_.addToIndexes(r, this.children_));
      const a = i.isEmpty() ? wa : this.priorityNode_;
      return new re(i, a, o);
    }
  }
  /** @inheritDoc */
  updateChild(e, n) {
    const r = pe(e);
    if (r === null)
      return n;
    {
      V(pe(e) !== ".priority" || Pr(e) === 1, ".priority must be the last token in a path");
      const i = this.getImmediateChild(r).updateChild(Re(e), n);
      return this.updateImmediateChild(r, i);
    }
  }
  /** @inheritDoc */
  isEmpty() {
    return this.children_.isEmpty();
  }
  /** @inheritDoc */
  numChildren() {
    return this.children_.count();
  }
  /** @inheritDoc */
  val(e) {
    if (this.isEmpty())
      return null;
    const n = {};
    let r = 0, i = 0, o = !0;
    if (this.forEachChild(qe, (a, s) => {
      n[a] = s.val(e), r++, o && re.INTEGER_REGEXP_.test(a) ? i = Math.max(i, Number(a)) : o = !1;
    }), !e && o && i < 2 * r) {
      const a = [];
      for (const s in n)
        a[s] = n[s];
      return a;
    } else
      return e && !this.getPriority().isEmpty() && (n[".priority"] = this.getPriority().val()), n;
  }
  /** @inheritDoc */
  hash() {
    if (this.lazyHash_ === null) {
      let e = "";
      this.getPriority().isEmpty() || (e += "priority:" + cy(this.getPriority().val()) + ":"), this.forEachChild(qe, (n, r) => {
        const i = r.hash();
        i !== "" && (e += ":" + n + ":" + i);
      }), this.lazyHash_ = e === "" ? "" : zb(e);
    }
    return this.lazyHash_;
  }
  /** @inheritDoc */
  getPredecessorChildName(e, n, r) {
    const i = this.resolveIndex_(r);
    if (i) {
      const o = i.getPredecessorKey(new ve(e, n));
      return o ? o.name : null;
    } else
      return this.children_.getPredecessorKey(e);
  }
  getFirstChildName(e) {
    const n = this.resolveIndex_(e);
    if (n) {
      const r = n.minKey();
      return r && r.name;
    } else
      return this.children_.minKey();
  }
  getFirstChild(e) {
    const n = this.getFirstChildName(e);
    return n ? new ve(n, this.children_.get(n)) : null;
  }
  /**
   * Given an index, return the key name of the largest value we have, according to that index
   */
  getLastChildName(e) {
    const n = this.resolveIndex_(e);
    if (n) {
      const r = n.maxKey();
      return r && r.name;
    } else
      return this.children_.maxKey();
  }
  getLastChild(e) {
    const n = this.getLastChildName(e);
    return n ? new ve(n, this.children_.get(n)) : null;
  }
  forEachChild(e, n) {
    const r = this.resolveIndex_(e);
    return r ? r.inorderTraversal((i) => n(i.name, i.node)) : this.children_.inorderTraversal(n);
  }
  getIterator(e) {
    return this.getIteratorFrom(e.minPost(), e);
  }
  getIteratorFrom(e, n) {
    const r = this.resolveIndex_(n);
    if (r)
      return r.getIteratorFrom(e, (i) => i);
    {
      const i = this.children_.getIteratorFrom(e.name, ve.Wrap);
      let o = i.peek();
      for (; o != null && n.compare(o, e) < 0; )
        i.getNext(), o = i.peek();
      return i;
    }
  }
  getReverseIterator(e) {
    return this.getReverseIteratorFrom(e.maxPost(), e);
  }
  getReverseIteratorFrom(e, n) {
    const r = this.resolveIndex_(n);
    if (r)
      return r.getReverseIteratorFrom(e, (i) => i);
    {
      const i = this.children_.getReverseIteratorFrom(e.name, ve.Wrap);
      let o = i.peek();
      for (; o != null && n.compare(o, e) > 0; )
        i.getNext(), o = i.peek();
      return i;
    }
  }
  compareTo(e) {
    return this.isEmpty() ? e.isEmpty() ? 0 : -1 : e.isLeafNode() || e.isEmpty() ? 1 : e === js ? -1 : 0;
  }
  withIndex(e) {
    if (e === dr || this.indexMap_.hasIndex(e))
      return this;
    {
      const n = this.indexMap_.addIndex(e, this.children_);
      return new re(this.children_, this.priorityNode_, n);
    }
  }
  isIndexed(e) {
    return e === dr || this.indexMap_.hasIndex(e);
  }
  equals(e) {
    if (e === this)
      return !0;
    if (e.isLeafNode())
      return !1;
    {
      const n = e;
      if (this.getPriority().equals(n.getPriority()))
        if (this.children_.count() === n.children_.count()) {
          const r = this.getIterator(qe), i = n.getIterator(qe);
          let o = r.getNext(), a = i.getNext();
          for (; o && a; ) {
            if (o.name !== a.name || !o.node.equals(a.node))
              return !1;
            o = r.getNext(), a = i.getNext();
          }
          return o === null && a === null;
        } else
          return !1;
      else
        return !1;
    }
  }
  /**
   * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
   * instead.
   *
   */
  resolveIndex_(e) {
    return e === dr ? null : this.indexMap_.get(e.toString());
  }
}
re.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class YI extends re {
  constructor() {
    super(new Ut(Rh), re.EMPTY_NODE, fr.Default);
  }
  compareTo(e) {
    return e === this ? 0 : 1;
  }
  equals(e) {
    return e === this;
  }
  getPriority() {
    return this;
  }
  getImmediateChild(e) {
    return re.EMPTY_NODE;
  }
  isEmpty() {
    return !1;
  }
}
const js = new YI();
Object.defineProperties(ve, {
  MIN: {
    value: new ve(bi, re.EMPTY_NODE)
  },
  MAX: {
    value: new ve(Vn, js)
  }
});
fy.__EMPTY_NODE = re.EMPTY_NODE;
ft.__childrenNodeConstructor = re;
BI(js);
UI(js);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const qI = !0;
function Je(t, e = null) {
  if (t === null)
    return re.EMPTY_NODE;
  if (typeof t == "object" && ".priority" in t && (e = t[".priority"]), V(e === null || typeof e == "string" || typeof e == "number" || typeof e == "object" && ".sv" in e, "Invalid priority type found: " + typeof e), typeof t == "object" && ".value" in t && t[".value"] !== null && (t = t[".value"]), typeof t != "object" || ".sv" in t) {
    const n = t;
    return new ft(n, Je(e));
  }
  if (!(t instanceof Array) && qI) {
    const n = [];
    let r = !1;
    if (bt(t, (a, s) => {
      if (a.substring(0, 1) !== ".") {
        const l = Je(s);
        l.isEmpty() || (r = r || !l.getPriority().isEmpty(), n.push(new ve(a, l)));
      }
    }), n.length === 0)
      return re.EMPTY_NODE;
    const o = rf(n, zI, (a) => a.name, Rh);
    if (r) {
      const a = rf(n, qe.getCompare());
      return new re(o, Je(e), new fr({ ".priority": a }, { ".priority": qe }));
    } else
      return new re(o, Je(e), fr.Default);
  } else {
    let n = re.EMPTY_NODE;
    return bt(t, (r, i) => {
      if (qn(t, r) && r.substring(0, 1) !== ".") {
        const o = Je(i);
        (o.isLeafNode() || !o.isEmpty()) && (n = n.updateImmediateChild(r, o));
      }
    }), n.updatePriority(Je(e));
  }
}
WI(Je);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Lh extends rc {
  constructor(e) {
    super(), this.indexPath_ = e, V(!me(e) && pe(e) !== ".priority", "Can't create PathIndex with empty path or .priority key");
  }
  extractChild(e) {
    return e.getChild(this.indexPath_);
  }
  isDefinedOn(e) {
    return !e.getChild(this.indexPath_).isEmpty();
  }
  compare(e, n) {
    const r = this.extractChild(e.node), i = this.extractChild(n.node), o = r.compareTo(i);
    return o === 0 ? Ni(e.name, n.name) : o;
  }
  makePost(e, n) {
    const r = Je(e), i = re.EMPTY_NODE.updateChild(this.indexPath_, r);
    return new ve(n, i);
  }
  maxPost() {
    const e = re.EMPTY_NODE.updateChild(this.indexPath_, js);
    return new ve(Vn, e);
  }
  toString() {
    return ss(this.indexPath_, 0).join("/");
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class GI extends rc {
  compare(e, n) {
    const r = e.node.compareTo(n.node);
    return r === 0 ? Ni(e.name, n.name) : r;
  }
  isDefinedOn(e) {
    return !0;
  }
  indexedValueChanged(e, n) {
    return !e.equals(n);
  }
  minPost() {
    return ve.MIN;
  }
  maxPost() {
    return ve.MAX;
  }
  makePost(e, n) {
    const r = Je(e);
    return new ve(n, r);
  }
  /**
   * @returns String representation for inclusion in a query spec
   */
  toString() {
    return ".value";
  }
}
const gy = new GI();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const of = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz", Op = "-", QI = "z", XI = 786, JI = function() {
  let t = 0;
  const e = [];
  return function(n) {
    const r = n === t;
    t = n;
    let i;
    const o = new Array(8);
    for (i = 7; i >= 0; i--)
      o[i] = of.charAt(n % 64), n = Math.floor(n / 64);
    V(n === 0, "Cannot push at time == 0");
    let a = o.join("");
    if (r) {
      for (i = 11; i >= 0 && e[i] === 63; i--)
        e[i] = 0;
      e[i]++;
    } else
      for (i = 0; i < 12; i++)
        e[i] = Math.floor(Math.random() * 64);
    for (i = 0; i < 12; i++)
      a += of.charAt(e[i]);
    return V(a.length === 20, "nextPushId: Length should be 20."), a;
  };
}(), Dp = function(t) {
  if (t === "" + Ub)
    return Op;
  const e = Hd(t);
  if (e != null)
    return "" + (e + 1);
  const n = new Array(t.length);
  for (let a = 0; a < n.length; a++)
    n[a] = t.charAt(a);
  if (n.length < XI)
    return n.push(Op), n.join("");
  let r = n.length - 1;
  for (; r >= 0 && n[r] === QI; )
    r--;
  if (r === -1)
    return Vn;
  const i = n[r], o = of.charAt(of.indexOf(i) + 1);
  return n[r] = o, n.slice(0, r + 1).join("");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function py(t) {
  return { type: "value", snapshotNode: t };
}
function So(t, e) {
  return { type: "child_added", snapshotNode: e, childName: t };
}
function ls(t, e) {
  return { type: "child_removed", snapshotNode: e, childName: t };
}
function fs(t, e, n) {
  return {
    type: "child_changed",
    snapshotNode: e,
    childName: t,
    oldSnap: n
  };
}
function ZI(t, e) {
  return { type: "child_moved", snapshotNode: e, childName: t };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class $h {
  constructor(e) {
    this.index_ = e;
  }
  updateChild(e, n, r, i, o, a) {
    V(e.isIndexed(this.index_), "A node must be indexed if only a child is updated");
    const s = e.getImmediateChild(n);
    return s.getChild(i).equals(r.getChild(i)) && s.isEmpty() === r.isEmpty() || (a != null && (r.isEmpty() ? e.hasChild(n) ? a.trackChildChange(ls(n, s)) : V(e.isLeafNode(), "A child remove without an old child only makes sense on a leaf node") : s.isEmpty() ? a.trackChildChange(So(n, r)) : a.trackChildChange(fs(n, r, s))), e.isLeafNode() && r.isEmpty()) ? e : e.updateImmediateChild(n, r).withIndex(this.index_);
  }
  updateFullNode(e, n, r) {
    return r != null && (e.isLeafNode() || e.forEachChild(qe, (i, o) => {
      n.hasChild(i) || r.trackChildChange(ls(i, o));
    }), n.isLeafNode() || n.forEachChild(qe, (i, o) => {
      if (e.hasChild(i)) {
        const a = e.getImmediateChild(i);
        a.equals(o) || r.trackChildChange(fs(i, o, a));
      } else
        r.trackChildChange(So(i, o));
    })), n.withIndex(this.index_);
  }
  updatePriority(e, n) {
    return e.isEmpty() ? re.EMPTY_NODE : e.updatePriority(n);
  }
  filtersNodes() {
    return !1;
  }
  getIndexedFilter() {
    return this;
  }
  getIndex() {
    return this.index_;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class cs {
  constructor(e) {
    this.indexedFilter_ = new $h(e.getIndex()), this.index_ = e.getIndex(), this.startPost_ = cs.getStartPost_(e), this.endPost_ = cs.getEndPost_(e);
  }
  getStartPost() {
    return this.startPost_;
  }
  getEndPost() {
    return this.endPost_;
  }
  matches(e) {
    return this.index_.compare(this.getStartPost(), e) <= 0 && this.index_.compare(e, this.getEndPost()) <= 0;
  }
  updateChild(e, n, r, i, o, a) {
    return this.matches(new ve(n, r)) || (r = re.EMPTY_NODE), this.indexedFilter_.updateChild(e, n, r, i, o, a);
  }
  updateFullNode(e, n, r) {
    n.isLeafNode() && (n = re.EMPTY_NODE);
    let i = n.withIndex(this.index_);
    i = i.updatePriority(re.EMPTY_NODE);
    const o = this;
    return n.forEachChild(qe, (a, s) => {
      o.matches(new ve(a, s)) || (i = i.updateImmediateChild(a, re.EMPTY_NODE));
    }), this.indexedFilter_.updateFullNode(e, i, r);
  }
  updatePriority(e, n) {
    return e;
  }
  filtersNodes() {
    return !0;
  }
  getIndexedFilter() {
    return this.indexedFilter_;
  }
  getIndex() {
    return this.index_;
  }
  static getStartPost_(e) {
    if (e.hasStart()) {
      const n = e.getIndexStartName();
      return e.getIndex().makePost(e.getIndexStartValue(), n);
    } else
      return e.getIndex().minPost();
  }
  static getEndPost_(e) {
    if (e.hasEnd()) {
      const n = e.getIndexEndName();
      return e.getIndex().makePost(e.getIndexEndValue(), n);
    } else
      return e.getIndex().maxPost();
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class e9 {
  constructor(e) {
    this.rangedFilter_ = new cs(e), this.index_ = e.getIndex(), this.limit_ = e.getLimit(), this.reverse_ = !e.isViewFromLeft();
  }
  updateChild(e, n, r, i, o, a) {
    return this.rangedFilter_.matches(new ve(n, r)) || (r = re.EMPTY_NODE), e.getImmediateChild(n).equals(r) ? e : e.numChildren() < this.limit_ ? this.rangedFilter_.getIndexedFilter().updateChild(e, n, r, i, o, a) : this.fullLimitUpdateChild_(e, n, r, o, a);
  }
  updateFullNode(e, n, r) {
    let i;
    if (n.isLeafNode() || n.isEmpty())
      i = re.EMPTY_NODE.withIndex(this.index_);
    else if (this.limit_ * 2 < n.numChildren() && n.isIndexed(this.index_)) {
      i = re.EMPTY_NODE.withIndex(this.index_);
      let o;
      this.reverse_ ? o = n.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_) : o = n.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
      let a = 0;
      for (; o.hasNext() && a < this.limit_; ) {
        const s = o.getNext();
        let l;
        if (this.reverse_ ? l = this.index_.compare(this.rangedFilter_.getStartPost(), s) <= 0 : l = this.index_.compare(s, this.rangedFilter_.getEndPost()) <= 0, l)
          i = i.updateImmediateChild(s.name, s.node), a++;
        else
          break;
      }
    } else {
      i = n.withIndex(this.index_), i = i.updatePriority(re.EMPTY_NODE);
      let o, a, s, l;
      if (this.reverse_) {
        l = i.getReverseIterator(this.index_), o = this.rangedFilter_.getEndPost(), a = this.rangedFilter_.getStartPost();
        const u = this.index_.getCompare();
        s = (d, h) => u(h, d);
      } else
        l = i.getIterator(this.index_), o = this.rangedFilter_.getStartPost(), a = this.rangedFilter_.getEndPost(), s = this.index_.getCompare();
      let f = 0, c = !1;
      for (; l.hasNext(); ) {
        const u = l.getNext();
        !c && s(o, u) <= 0 && (c = !0), c && f < this.limit_ && s(u, a) <= 0 ? f++ : i = i.updateImmediateChild(u.name, re.EMPTY_NODE);
      }
    }
    return this.rangedFilter_.getIndexedFilter().updateFullNode(e, i, r);
  }
  updatePriority(e, n) {
    return e;
  }
  filtersNodes() {
    return !0;
  }
  getIndexedFilter() {
    return this.rangedFilter_.getIndexedFilter();
  }
  getIndex() {
    return this.index_;
  }
  fullLimitUpdateChild_(e, n, r, i, o) {
    let a;
    if (this.reverse_) {
      const u = this.index_.getCompare();
      a = (d, h) => u(h, d);
    } else
      a = this.index_.getCompare();
    const s = e;
    V(s.numChildren() === this.limit_, "");
    const l = new ve(n, r), f = this.reverse_ ? s.getFirstChild(this.index_) : s.getLastChild(this.index_), c = this.rangedFilter_.matches(l);
    if (s.hasChild(n)) {
      const u = s.getImmediateChild(n);
      let d = i.getChildAfterChild(this.index_, f, this.reverse_);
      for (; d != null && (d.name === n || s.hasChild(d.name)); )
        d = i.getChildAfterChild(this.index_, d, this.reverse_);
      const h = d == null ? 1 : a(d, l);
      if (c && !r.isEmpty() && h >= 0)
        return o != null && o.trackChildChange(fs(n, r, u)), s.updateImmediateChild(n, r);
      {
        o != null && o.trackChildChange(ls(n, u));
        const m = s.updateImmediateChild(n, re.EMPTY_NODE);
        return d != null && this.rangedFilter_.matches(d) ? (o != null && o.trackChildChange(So(d.name, d.node)), m.updateImmediateChild(d.name, d.node)) : m;
      }
    } else
      return r.isEmpty() ? e : c && a(f, l) >= 0 ? (o != null && (o.trackChildChange(ls(f.name, f.node)), o.trackChildChange(So(n, r))), s.updateImmediateChild(n, r).updateImmediateChild(f.name, re.EMPTY_NODE)) : e;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Fh {
  constructor() {
    this.limitSet_ = !1, this.startSet_ = !1, this.startNameSet_ = !1, this.startAfterSet_ = !1, this.endSet_ = !1, this.endNameSet_ = !1, this.endBeforeSet_ = !1, this.limit_ = 0, this.viewFrom_ = "", this.indexStartValue_ = null, this.indexStartName_ = "", this.indexEndValue_ = null, this.indexEndName_ = "", this.index_ = qe;
  }
  hasStart() {
    return this.startSet_;
  }
  hasStartAfter() {
    return this.startAfterSet_;
  }
  hasEndBefore() {
    return this.endBeforeSet_;
  }
  /**
   * @returns True if it would return from left.
   */
  isViewFromLeft() {
    return this.viewFrom_ === "" ? this.startSet_ : this.viewFrom_ === "l";
  }
  /**
   * Only valid to call if hasStart() returns true
   */
  getIndexStartValue() {
    return V(this.startSet_, "Only valid if start has been set"), this.indexStartValue_;
  }
  /**
   * Only valid to call if hasStart() returns true.
   * Returns the starting key name for the range defined by these query parameters
   */
  getIndexStartName() {
    return V(this.startSet_, "Only valid if start has been set"), this.startNameSet_ ? this.indexStartName_ : bi;
  }
  hasEnd() {
    return this.endSet_;
  }
  /**
   * Only valid to call if hasEnd() returns true.
   */
  getIndexEndValue() {
    return V(this.endSet_, "Only valid if end has been set"), this.indexEndValue_;
  }
  /**
   * Only valid to call if hasEnd() returns true.
   * Returns the end key name for the range defined by these query parameters
   */
  getIndexEndName() {
    return V(this.endSet_, "Only valid if end has been set"), this.endNameSet_ ? this.indexEndName_ : Vn;
  }
  hasLimit() {
    return this.limitSet_;
  }
  /**
   * @returns True if a limit has been set and it has been explicitly anchored
   */
  hasAnchoredLimit() {
    return this.limitSet_ && this.viewFrom_ !== "";
  }
  /**
   * Only valid to call if hasLimit() returns true
   */
  getLimit() {
    return V(this.limitSet_, "Only valid if limit has been set"), this.limit_;
  }
  getIndex() {
    return this.index_;
  }
  loadsAllData() {
    return !(this.startSet_ || this.endSet_ || this.limitSet_);
  }
  isDefault() {
    return this.loadsAllData() && this.index_ === qe;
  }
  copy() {
    const e = new Fh();
    return e.limitSet_ = this.limitSet_, e.limit_ = this.limit_, e.startSet_ = this.startSet_, e.indexStartValue_ = this.indexStartValue_, e.startNameSet_ = this.startNameSet_, e.indexStartName_ = this.indexStartName_, e.endSet_ = this.endSet_, e.indexEndValue_ = this.indexEndValue_, e.endNameSet_ = this.endNameSet_, e.indexEndName_ = this.indexEndName_, e.index_ = this.index_, e.viewFrom_ = this.viewFrom_, e;
  }
}
function t9(t) {
  return t.loadsAllData() ? new $h(t.getIndex()) : t.hasLimit() ? new e9(t) : new cs(t);
}
function n9(t, e) {
  const n = t.copy();
  return n.limitSet_ = !0, n.limit_ = e, n.viewFrom_ = "r", n;
}
function Pp(t, e, n) {
  const r = t.copy();
  return r.startSet_ = !0, e === void 0 && (e = null), r.indexStartValue_ = e, n != null ? (r.startNameSet_ = !0, r.indexStartName_ = n) : (r.startNameSet_ = !1, r.indexStartName_ = ""), r;
}
function r9(t, e, n) {
  let r;
  if (t.index_ === dr)
    typeof e == "string" && (e = Dp(e)), r = Pp(t, e, n);
  else {
    let i;
    n == null ? i = Vn : i = Dp(n), r = Pp(t, e, i);
  }
  return r.startAfterSet_ = !0, r;
}
function my(t, e) {
  const n = t.copy();
  return n.index_ = e, n;
}
function Rp(t) {
  const e = {};
  if (t.isDefault())
    return e;
  let n;
  return t.index_ === qe ? n = "$priority" : t.index_ === gy ? n = "$value" : t.index_ === dr ? n = "$key" : (V(t.index_ instanceof Lh, "Unrecognized index type!"), n = t.index_.toString()), e.orderBy = rt(n), t.startSet_ && (e.startAt = rt(t.indexStartValue_), t.startNameSet_ && (e.startAt += "," + rt(t.indexStartName_))), t.endSet_ && (e.endAt = rt(t.indexEndValue_), t.endNameSet_ && (e.endAt += "," + rt(t.indexEndName_))), t.limitSet_ && (t.isViewFromLeft() ? e.limitToFirst = t.limit_ : e.limitToLast = t.limit_), e;
}
function Lp(t) {
  const e = {};
  if (t.startSet_ && (e.sp = t.indexStartValue_, t.startNameSet_ && (e.sn = t.indexStartName_)), t.endSet_ && (e.ep = t.indexEndValue_, t.endNameSet_ && (e.en = t.indexEndName_)), t.limitSet_) {
    e.l = t.limit_;
    let n = t.viewFrom_;
    n === "" && (t.isViewFromLeft() ? n = "l" : n = "r"), e.vf = n;
  }
  return t.index_ !== qe && (e.i = t.index_.toString()), e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class af extends oy {
  /**
   * @param repoInfo_ - Data about the namespace we are connecting to
   * @param onDataUpdate_ - A callback for new data from the server
   */
  constructor(e, n, r, i) {
    super(), this.repoInfo_ = e, this.onDataUpdate_ = n, this.authTokenProvider_ = r, this.appCheckTokenProvider_ = i, this.log_ = Fs("p:rest:"), this.listens_ = {};
  }
  reportStats(e) {
    throw new Error("Method not implemented.");
  }
  static getListenId_(e, n) {
    return n !== void 0 ? "tag$" + n : (V(e._queryParams.isDefault(), "should have a tag if it's not a default query."), e._path.toString());
  }
  /** @inheritDoc */
  listen(e, n, r, i) {
    const o = e._path.toString();
    this.log_("Listen called for " + o + " " + e._queryIdentifier);
    const a = af.getListenId_(e, r), s = {};
    this.listens_[a] = s;
    const l = Rp(e._queryParams);
    this.restRequest_(o + ".json", l, (f, c) => {
      let u = c;
      if (f === 404 && (u = null, f = null), f === null && this.onDataUpdate_(
        o,
        u,
        /*isMerge=*/
        !1,
        r
      ), Co(this.listens_, a) === s) {
        let d;
        f ? f === 401 ? d = "permission_denied" : d = "rest_error:" + f : d = "ok", i(d, null);
      }
    });
  }
  /** @inheritDoc */
  unlisten(e, n) {
    const r = af.getListenId_(e, n);
    delete this.listens_[r];
  }
  get(e) {
    const n = Rp(e._queryParams), r = e._path.toString(), i = new Fn();
    return this.restRequest_(r + ".json", n, (o, a) => {
      let s = a;
      o === 404 && (s = null, o = null), o === null ? (this.onDataUpdate_(
        r,
        s,
        /*isMerge=*/
        !1,
        /*tag=*/
        null
      ), i.resolve(s)) : i.reject(new Error(s));
    }), i.promise;
  }
  /** @inheritDoc */
  refreshAuthToken(e) {
  }
  /**
   * Performs a REST request to the given path, with the provided query string parameters,
   * and any auth credentials we have.
   */
  restRequest_(e, n = {}, r) {
    return n.format = "export", Promise.all([
      this.authTokenProvider_.getToken(
        /*forceRefresh=*/
        !1
      ),
      this.appCheckTokenProvider_.getToken(
        /*forceRefresh=*/
        !1
      )
    ]).then(([i, o]) => {
      i && i.accessToken && (n.auth = i.accessToken), o && o.token && (n.ac = o.token);
      const a = (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host + e + "?ns=" + this.repoInfo_.namespace + vh(n);
      this.log_("Sending REST request for " + a);
      const s = new XMLHttpRequest();
      s.onreadystatechange = () => {
        if (r && s.readyState === 4) {
          this.log_("REST Response for " + a + " received. status:", s.status, "response:", s.responseText);
          let l = null;
          if (s.status >= 200 && s.status < 300) {
            try {
              l = rs(s.responseText);
            } catch {
              Pt("Failed to parse JSON response for " + a + ": " + s.responseText);
            }
            r(null, l);
          } else
            s.status !== 401 && s.status !== 404 && Pt("Got unsuccessful REST response for " + a + " Status: " + s.status), r(s.status);
          r = null;
        }
      }, s.open(
        "GET",
        a,
        /*asynchronous=*/
        !0
      ), s.send();
    });
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class i9 {
  constructor() {
    this.rootNode_ = re.EMPTY_NODE;
  }
  getNode(e) {
    return this.rootNode_.getChild(e);
  }
  updateSnapshot(e, n) {
    this.rootNode_ = this.rootNode_.updateChild(e, n);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function sf() {
  return {
    value: null,
    children: /* @__PURE__ */ new Map()
  };
}
function Ko(t, e, n) {
  if (me(e))
    t.value = n, t.children.clear();
  else if (t.value !== null)
    t.value = t.value.updateChild(e, n);
  else {
    const r = pe(e);
    t.children.has(r) || t.children.set(r, sf());
    const i = t.children.get(r);
    e = Re(e), Ko(i, e, n);
  }
}
function qd(t, e) {
  if (me(e))
    return t.value = null, t.children.clear(), !0;
  if (t.value !== null) {
    if (t.value.isLeafNode())
      return !1;
    {
      const n = t.value;
      return t.value = null, n.forEachChild(qe, (r, i) => {
        Ko(t, new Ne(r), i);
      }), qd(t, e);
    }
  } else if (t.children.size > 0) {
    const n = pe(e);
    return e = Re(e), t.children.has(n) && qd(t.children.get(n), e) && t.children.delete(n), t.children.size === 0;
  } else
    return !0;
}
function Gd(t, e, n) {
  t.value !== null ? n(e, t.value) : o9(t, (r, i) => {
    const o = new Ne(e.toString() + "/" + r);
    Gd(i, o, n);
  });
}
function o9(t, e) {
  t.children.forEach((n, r) => {
    e(r, n);
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class a9 {
  constructor(e) {
    this.collection_ = e, this.last_ = null;
  }
  get() {
    const e = this.collection_.get(), n = Object.assign({}, e);
    return this.last_ && bt(this.last_, (r, i) => {
      n[r] = n[r] - i;
    }), this.last_ = e, n;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const $p = 10 * 1e3, s9 = 30 * 1e3, l9 = 5 * 60 * 1e3;
class f9 {
  constructor(e, n) {
    this.server_ = n, this.statsToReport_ = {}, this.statsListener_ = new a9(e);
    const r = $p + (s9 - $p) * Math.random();
    $a(this.reportStats_.bind(this), Math.floor(r));
  }
  reportStats_() {
    const e = this.statsListener_.get(), n = {};
    let r = !1;
    bt(e, (i, o) => {
      o > 0 && qn(this.statsToReport_, i) && (n[i] = o, r = !0);
    }), r && this.server_.reportStats(n), $a(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * l9));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Sn;
(function(t) {
  t[t.OVERWRITE = 0] = "OVERWRITE", t[t.MERGE = 1] = "MERGE", t[t.ACK_USER_WRITE = 2] = "ACK_USER_WRITE", t[t.LISTEN_COMPLETE = 3] = "LISTEN_COMPLETE";
})(Sn || (Sn = {}));
function jh() {
  return {
    fromUser: !0,
    fromServer: !1,
    queryId: null,
    tagged: !1
  };
}
function zh() {
  return {
    fromUser: !1,
    fromServer: !0,
    queryId: null,
    tagged: !1
  };
}
function Bh(t) {
  return {
    fromUser: !1,
    fromServer: !0,
    queryId: t,
    tagged: !0
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class lf {
  /**
   * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
   */
  constructor(e, n, r) {
    this.path = e, this.affectedTree = n, this.revert = r, this.type = Sn.ACK_USER_WRITE, this.source = jh();
  }
  operationForChild(e) {
    if (me(this.path)) {
      if (this.affectedTree.value != null)
        return V(this.affectedTree.children.isEmpty(), "affectedTree should not have overlapping affected paths."), this;
      {
        const n = this.affectedTree.subtree(new Ne(e));
        return new lf(Te(), n, this.revert);
      }
    } else
      return V(pe(this.path) === e, "operationForChild called for unrelated child."), new lf(Re(this.path), this.affectedTree, this.revert);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class us {
  constructor(e, n) {
    this.source = e, this.path = n, this.type = Sn.LISTEN_COMPLETE;
  }
  operationForChild(e) {
    return me(this.path) ? new us(this.source, Te()) : new us(this.source, Re(this.path));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class yi {
  constructor(e, n, r) {
    this.source = e, this.path = n, this.snap = r, this.type = Sn.OVERWRITE;
  }
  operationForChild(e) {
    return me(this.path) ? new yi(this.source, Te(), this.snap.getImmediateChild(e)) : new yi(this.source, Re(this.path), this.snap);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Io {
  constructor(e, n, r) {
    this.source = e, this.path = n, this.children = r, this.type = Sn.MERGE;
  }
  operationForChild(e) {
    if (me(this.path)) {
      const n = this.children.subtree(new Ne(e));
      return n.isEmpty() ? null : n.value ? new yi(this.source, Te(), n.value) : new Io(this.source, Te(), n);
    } else
      return V(pe(this.path) === e, "Can't get a merge for a child not on the path of the operation"), new Io(this.source, Re(this.path), this.children);
  }
  toString() {
    return "Operation(" + this.path + ": " + this.source.toString() + " merge: " + this.children.toString() + ")";
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Rr {
  constructor(e, n, r) {
    this.node_ = e, this.fullyInitialized_ = n, this.filtered_ = r;
  }
  /**
   * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
   */
  isFullyInitialized() {
    return this.fullyInitialized_;
  }
  /**
   * Returns whether this node is potentially missing children due to a filter applied to the node
   */
  isFiltered() {
    return this.filtered_;
  }
  isCompleteForPath(e) {
    if (me(e))
      return this.isFullyInitialized() && !this.filtered_;
    const n = pe(e);
    return this.isCompleteForChild(n);
  }
  isCompleteForChild(e) {
    return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(e);
  }
  getNode() {
    return this.node_;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class c9 {
  constructor(e) {
    this.query_ = e, this.index_ = this.query_._queryParams.getIndex();
  }
}
function u9(t, e, n, r) {
  const i = [], o = [];
  return e.forEach((a) => {
    a.type === "child_changed" && t.index_.indexedValueChanged(a.oldSnap, a.snapshotNode) && o.push(ZI(a.childName, a.snapshotNode));
  }), ka(t, i, "child_removed", e, r, n), ka(t, i, "child_added", e, r, n), ka(t, i, "child_moved", o, r, n), ka(t, i, "child_changed", e, r, n), ka(t, i, "value", e, r, n), i;
}
function ka(t, e, n, r, i, o) {
  const a = r.filter((s) => s.type === n);
  a.sort((s, l) => h9(t, s, l)), a.forEach((s) => {
    const l = d9(t, s, o);
    i.forEach((f) => {
      f.respondsTo(s.type) && e.push(f.createEvent(l, t.query_));
    });
  });
}
function d9(t, e, n) {
  return e.type === "value" || e.type === "child_removed" || (e.prevName = n.getPredecessorChildName(e.childName, e.snapshotNode, t.index_)), e;
}
function h9(t, e, n) {
  if (e.childName == null || n.childName == null)
    throw Ho("Should only compare child_ events.");
  const r = new ve(e.childName, e.snapshotNode), i = new ve(n.childName, n.snapshotNode);
  return t.index_.compare(r, i);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ic(t, e) {
  return { eventCache: t, serverCache: e };
}
function Fa(t, e, n, r) {
  return ic(new Rr(e, n, r), t.serverCache);
}
function vy(t, e, n, r) {
  return ic(t.eventCache, new Rr(e, n, r));
}
function ff(t) {
  return t.eventCache.isFullyInitialized() ? t.eventCache.getNode() : null;
}
function _i(t) {
  return t.serverCache.isFullyInitialized() ? t.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Pu;
const g9 = () => (Pu || (Pu = new Ut(GS)), Pu);
class Fe {
  constructor(e, n = g9()) {
    this.value = e, this.children = n;
  }
  static fromObject(e) {
    let n = new Fe(null);
    return bt(e, (r, i) => {
      n = n.set(new Ne(r), i);
    }), n;
  }
  /**
   * True if the value is empty and there are no children
   */
  isEmpty() {
    return this.value === null && this.children.isEmpty();
  }
  /**
   * Given a path and predicate, return the first node and the path to that node
   * where the predicate returns true.
   *
   * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
   * objects on the way back out, it may be better to pass down a pathSoFar obj.
   *
   * @param relativePath - The remainder of the path
   * @param predicate - The predicate to satisfy to return a node
   */
  findRootMostMatchingPathAndValue(e, n) {
    if (this.value != null && n(this.value))
      return { path: Te(), value: this.value };
    if (me(e))
      return null;
    {
      const r = pe(e), i = this.children.get(r);
      if (i !== null) {
        const o = i.findRootMostMatchingPathAndValue(Re(e), n);
        return o != null ? { path: Ge(new Ne(r), o.path), value: o.value } : null;
      } else
        return null;
    }
  }
  /**
   * Find, if it exists, the shortest subpath of the given path that points a defined
   * value in the tree
   */
  findRootMostValueAndPath(e) {
    return this.findRootMostMatchingPathAndValue(e, () => !0);
  }
  /**
   * @returns The subtree at the given path
   */
  subtree(e) {
    if (me(e))
      return this;
    {
      const n = pe(e), r = this.children.get(n);
      return r !== null ? r.subtree(Re(e)) : new Fe(null);
    }
  }
  /**
   * Sets a value at the specified path.
   *
   * @param relativePath - Path to set value at.
   * @param toSet - Value to set.
   * @returns Resulting tree.
   */
  set(e, n) {
    if (me(e))
      return new Fe(n, this.children);
    {
      const r = pe(e), o = (this.children.get(r) || new Fe(null)).set(Re(e), n), a = this.children.insert(r, o);
      return new Fe(this.value, a);
    }
  }
  /**
   * Removes the value at the specified path.
   *
   * @param relativePath - Path to value to remove.
   * @returns Resulting tree.
   */
  remove(e) {
    if (me(e))
      return this.children.isEmpty() ? new Fe(null) : new Fe(null, this.children);
    {
      const n = pe(e), r = this.children.get(n);
      if (r) {
        const i = r.remove(Re(e));
        let o;
        return i.isEmpty() ? o = this.children.remove(n) : o = this.children.insert(n, i), this.value === null && o.isEmpty() ? new Fe(null) : new Fe(this.value, o);
      } else
        return this;
    }
  }
  /**
   * Gets a value from the tree.
   *
   * @param relativePath - Path to get value for.
   * @returns Value at path, or null.
   */
  get(e) {
    if (me(e))
      return this.value;
    {
      const n = pe(e), r = this.children.get(n);
      return r ? r.get(Re(e)) : null;
    }
  }
  /**
   * Replace the subtree at the specified path with the given new tree.
   *
   * @param relativePath - Path to replace subtree for.
   * @param newTree - New tree.
   * @returns Resulting tree.
   */
  setTree(e, n) {
    if (me(e))
      return n;
    {
      const r = pe(e), o = (this.children.get(r) || new Fe(null)).setTree(Re(e), n);
      let a;
      return o.isEmpty() ? a = this.children.remove(r) : a = this.children.insert(r, o), new Fe(this.value, a);
    }
  }
  /**
   * Performs a depth first fold on this tree. Transforms a tree into a single
   * value, given a function that operates on the path to a node, an optional
   * current value, and a map of child names to folded subtrees
   */
  fold(e) {
    return this.fold_(Te(), e);
  }
  /**
   * Recursive helper for public-facing fold() method
   */
  fold_(e, n) {
    const r = {};
    return this.children.inorderTraversal((i, o) => {
      r[i] = o.fold_(Ge(e, i), n);
    }), n(e, this.value, r);
  }
  /**
   * Find the first matching value on the given path. Return the result of applying f to it.
   */
  findOnPath(e, n) {
    return this.findOnPath_(e, Te(), n);
  }
  findOnPath_(e, n, r) {
    const i = this.value ? r(n, this.value) : !1;
    if (i)
      return i;
    if (me(e))
      return null;
    {
      const o = pe(e), a = this.children.get(o);
      return a ? a.findOnPath_(Re(e), Ge(n, o), r) : null;
    }
  }
  foreachOnPath(e, n) {
    return this.foreachOnPath_(e, Te(), n);
  }
  foreachOnPath_(e, n, r) {
    if (me(e))
      return this;
    {
      this.value && r(n, this.value);
      const i = pe(e), o = this.children.get(i);
      return o ? o.foreachOnPath_(Re(e), Ge(n, i), r) : new Fe(null);
    }
  }
  /**
   * Calls the given function for each node in the tree that has a value.
   *
   * @param f - A function to be called with the path from the root of the tree to
   * a node, and the value at that node. Called in depth-first order.
   */
  foreach(e) {
    this.foreach_(Te(), e);
  }
  foreach_(e, n) {
    this.children.inorderTraversal((r, i) => {
      i.foreach_(Ge(e, r), n);
    }), this.value && n(e, this.value);
  }
  foreachChild(e) {
    this.children.inorderTraversal((n, r) => {
      r.value && e(n, r.value);
    });
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Nn {
  constructor(e) {
    this.writeTree_ = e;
  }
  static empty() {
    return new Nn(new Fe(null));
  }
}
function ja(t, e, n) {
  if (me(e))
    return new Nn(new Fe(n));
  {
    const r = t.writeTree_.findRootMostValueAndPath(e);
    if (r != null) {
      const i = r.path;
      let o = r.value;
      const a = Ot(i, e);
      return o = o.updateChild(a, n), new Nn(t.writeTree_.set(i, o));
    } else {
      const i = new Fe(n), o = t.writeTree_.setTree(e, i);
      return new Nn(o);
    }
  }
}
function Qd(t, e, n) {
  let r = t;
  return bt(n, (i, o) => {
    r = ja(r, Ge(e, i), o);
  }), r;
}
function Fp(t, e) {
  if (me(e))
    return Nn.empty();
  {
    const n = t.writeTree_.setTree(e, new Fe(null));
    return new Nn(n);
  }
}
function Xd(t, e) {
  return Mi(t, e) != null;
}
function Mi(t, e) {
  const n = t.writeTree_.findRootMostValueAndPath(e);
  return n != null ? t.writeTree_.get(n.path).getChild(Ot(n.path, e)) : null;
}
function jp(t) {
  const e = [], n = t.writeTree_.value;
  return n != null ? n.isLeafNode() || n.forEachChild(qe, (r, i) => {
    e.push(new ve(r, i));
  }) : t.writeTree_.children.inorderTraversal((r, i) => {
    i.value != null && e.push(new ve(r, i.value));
  }), e;
}
function Sr(t, e) {
  if (me(e))
    return t;
  {
    const n = Mi(t, e);
    return n != null ? new Nn(new Fe(n)) : new Nn(t.writeTree_.subtree(e));
  }
}
function Jd(t) {
  return t.writeTree_.isEmpty();
}
function No(t, e) {
  return by(Te(), t.writeTree_, e);
}
function by(t, e, n) {
  if (e.value != null)
    return n.updateChild(t, e.value);
  {
    let r = null;
    return e.children.inorderTraversal((i, o) => {
      i === ".priority" ? (V(o.value !== null, "Priority writes must always be leaf nodes"), r = o.value) : n = by(Ge(t, i), o, n);
    }), !n.getChild(t).isEmpty() && r !== null && (n = n.updateChild(Ge(t, ".priority"), r)), n;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function oc(t, e) {
  return ky(e, t);
}
function p9(t, e, n, r, i) {
  V(r > t.lastWriteId, "Stacking an older write on top of newer ones"), i === void 0 && (i = !0), t.allWrites.push({
    path: e,
    snap: n,
    writeId: r,
    visible: i
  }), i && (t.visibleWrites = ja(t.visibleWrites, e, n)), t.lastWriteId = r;
}
function m9(t, e, n, r) {
  V(r > t.lastWriteId, "Stacking an older merge on top of newer ones"), t.allWrites.push({
    path: e,
    children: n,
    writeId: r,
    visible: !0
  }), t.visibleWrites = Qd(t.visibleWrites, e, n), t.lastWriteId = r;
}
function v9(t, e) {
  for (let n = 0; n < t.allWrites.length; n++) {
    const r = t.allWrites[n];
    if (r.writeId === e)
      return r;
  }
  return null;
}
function b9(t, e) {
  const n = t.allWrites.findIndex((s) => s.writeId === e);
  V(n >= 0, "removeWrite called with nonexistent writeId.");
  const r = t.allWrites[n];
  t.allWrites.splice(n, 1);
  let i = r.visible, o = !1, a = t.allWrites.length - 1;
  for (; i && a >= 0; ) {
    const s = t.allWrites[a];
    s.visible && (a >= n && y9(s, r.path) ? i = !1 : fn(r.path, s.path) && (o = !0)), a--;
  }
  if (i) {
    if (o)
      return _9(t), !0;
    if (r.snap)
      t.visibleWrites = Fp(t.visibleWrites, r.path);
    else {
      const s = r.children;
      bt(s, (l) => {
        t.visibleWrites = Fp(t.visibleWrites, Ge(r.path, l));
      });
    }
    return !0;
  } else
    return !1;
}
function y9(t, e) {
  if (t.snap)
    return fn(t.path, e);
  for (const n in t.children)
    if (t.children.hasOwnProperty(n) && fn(Ge(t.path, n), e))
      return !0;
  return !1;
}
function _9(t) {
  t.visibleWrites = yy(t.allWrites, w9, Te()), t.allWrites.length > 0 ? t.lastWriteId = t.allWrites[t.allWrites.length - 1].writeId : t.lastWriteId = -1;
}
function w9(t) {
  return t.visible;
}
function yy(t, e, n) {
  let r = Nn.empty();
  for (let i = 0; i < t.length; ++i) {
    const o = t[i];
    if (e(o)) {
      const a = o.path;
      let s;
      if (o.snap)
        fn(n, a) ? (s = Ot(n, a), r = ja(r, s, o.snap)) : fn(a, n) && (s = Ot(a, n), r = ja(r, Te(), o.snap.getChild(s)));
      else if (o.children) {
        if (fn(n, a))
          s = Ot(n, a), r = Qd(r, s, o.children);
        else if (fn(a, n))
          if (s = Ot(a, n), me(s))
            r = Qd(r, Te(), o.children);
          else {
            const l = Co(o.children, pe(s));
            if (l) {
              const f = l.getChild(Re(s));
              r = ja(r, Te(), f);
            }
          }
      } else
        throw Ho("WriteRecord should have .snap or .children");
    }
  }
  return r;
}
function _y(t, e, n, r, i) {
  if (!r && !i) {
    const o = Mi(t.visibleWrites, e);
    if (o != null)
      return o;
    {
      const a = Sr(t.visibleWrites, e);
      if (Jd(a))
        return n;
      if (n == null && !Xd(a, Te()))
        return null;
      {
        const s = n || re.EMPTY_NODE;
        return No(a, s);
      }
    }
  } else {
    const o = Sr(t.visibleWrites, e);
    if (!i && Jd(o))
      return n;
    if (!i && n == null && !Xd(o, Te()))
      return null;
    {
      const a = function(f) {
        return (f.visible || i) && (!r || !~r.indexOf(f.writeId)) && (fn(f.path, e) || fn(e, f.path));
      }, s = yy(t.allWrites, a, e), l = n || re.EMPTY_NODE;
      return No(s, l);
    }
  }
}
function k9(t, e, n) {
  let r = re.EMPTY_NODE;
  const i = Mi(t.visibleWrites, e);
  if (i)
    return i.isLeafNode() || i.forEachChild(qe, (o, a) => {
      r = r.updateImmediateChild(o, a);
    }), r;
  if (n) {
    const o = Sr(t.visibleWrites, e);
    return n.forEachChild(qe, (a, s) => {
      const l = No(Sr(o, new Ne(a)), s);
      r = r.updateImmediateChild(a, l);
    }), jp(o).forEach((a) => {
      r = r.updateImmediateChild(a.name, a.node);
    }), r;
  } else {
    const o = Sr(t.visibleWrites, e);
    return jp(o).forEach((a) => {
      r = r.updateImmediateChild(a.name, a.node);
    }), r;
  }
}
function C9(t, e, n, r, i) {
  V(r || i, "Either existingEventSnap or existingServerSnap must exist");
  const o = Ge(e, n);
  if (Xd(t.visibleWrites, o))
    return null;
  {
    const a = Sr(t.visibleWrites, o);
    return Jd(a) ? i.getChild(n) : No(a, i.getChild(n));
  }
}
function x9(t, e, n, r) {
  const i = Ge(e, n), o = Mi(t.visibleWrites, i);
  if (o != null)
    return o;
  if (r.isCompleteForChild(n)) {
    const a = Sr(t.visibleWrites, i);
    return No(a, r.getNode().getImmediateChild(n));
  } else
    return null;
}
function E9(t, e) {
  return Mi(t.visibleWrites, e);
}
function T9(t, e, n, r, i, o, a) {
  let s;
  const l = Sr(t.visibleWrites, e), f = Mi(l, Te());
  if (f != null)
    s = f;
  else if (n != null)
    s = No(l, n);
  else
    return [];
  if (s = s.withIndex(a), !s.isEmpty() && !s.isLeafNode()) {
    const c = [], u = a.getCompare(), d = o ? s.getReverseIteratorFrom(r, a) : s.getIteratorFrom(r, a);
    let h = d.getNext();
    for (; h && c.length < i; )
      u(h, r) !== 0 && c.push(h), h = d.getNext();
    return c;
  } else
    return [];
}
function S9() {
  return {
    visibleWrites: Nn.empty(),
    allWrites: [],
    lastWriteId: -1
  };
}
function cf(t, e, n, r) {
  return _y(t.writeTree, t.treePath, e, n, r);
}
function Wh(t, e) {
  return k9(t.writeTree, t.treePath, e);
}
function zp(t, e, n, r) {
  return C9(t.writeTree, t.treePath, e, n, r);
}
function uf(t, e) {
  return E9(t.writeTree, Ge(t.treePath, e));
}
function I9(t, e, n, r, i, o) {
  return T9(t.writeTree, t.treePath, e, n, r, i, o);
}
function Uh(t, e, n) {
  return x9(t.writeTree, t.treePath, e, n);
}
function wy(t, e) {
  return ky(Ge(t.treePath, e), t.writeTree);
}
function ky(t, e) {
  return {
    treePath: t,
    writeTree: e
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class N9 {
  constructor() {
    this.changeMap = /* @__PURE__ */ new Map();
  }
  trackChildChange(e) {
    const n = e.type, r = e.childName;
    V(n === "child_added" || n === "child_changed" || n === "child_removed", "Only child changes supported for tracking"), V(r !== ".priority", "Only non-priority child changes can be tracked.");
    const i = this.changeMap.get(r);
    if (i) {
      const o = i.type;
      if (n === "child_added" && o === "child_removed")
        this.changeMap.set(r, fs(r, e.snapshotNode, i.snapshotNode));
      else if (n === "child_removed" && o === "child_added")
        this.changeMap.delete(r);
      else if (n === "child_removed" && o === "child_changed")
        this.changeMap.set(r, ls(r, i.oldSnap));
      else if (n === "child_changed" && o === "child_added")
        this.changeMap.set(r, So(r, e.snapshotNode));
      else if (n === "child_changed" && o === "child_changed")
        this.changeMap.set(r, fs(r, e.snapshotNode, i.oldSnap));
      else
        throw Ho("Illegal combination of changes: " + e + " occurred after " + i);
    } else
      this.changeMap.set(r, e);
  }
  getChanges() {
    return Array.from(this.changeMap.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class M9 {
  getCompleteChild(e) {
    return null;
  }
  getChildAfterChild(e, n, r) {
    return null;
  }
}
const Cy = new M9();
class Hh {
  constructor(e, n, r = null) {
    this.writes_ = e, this.viewCache_ = n, this.optCompleteServerCache_ = r;
  }
  getCompleteChild(e) {
    const n = this.viewCache_.eventCache;
    if (n.isCompleteForChild(e))
      return n.getNode().getImmediateChild(e);
    {
      const r = this.optCompleteServerCache_ != null ? new Rr(this.optCompleteServerCache_, !0, !1) : this.viewCache_.serverCache;
      return Uh(this.writes_, e, r);
    }
  }
  getChildAfterChild(e, n, r) {
    const i = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : _i(this.viewCache_), o = I9(this.writes_, i, n, 1, r, e);
    return o.length === 0 ? null : o[0];
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function A9(t) {
  return { filter: t };
}
function O9(t, e) {
  V(e.eventCache.getNode().isIndexed(t.filter.getIndex()), "Event snap not indexed"), V(e.serverCache.getNode().isIndexed(t.filter.getIndex()), "Server snap not indexed");
}
function D9(t, e, n, r, i) {
  const o = new N9();
  let a, s;
  if (n.type === Sn.OVERWRITE) {
    const f = n;
    f.source.fromUser ? a = Zd(t, e, f.path, f.snap, r, i, o) : (V(f.source.fromServer, "Unknown source."), s = f.source.tagged || e.serverCache.isFiltered() && !me(f.path), a = df(t, e, f.path, f.snap, r, i, s, o));
  } else if (n.type === Sn.MERGE) {
    const f = n;
    f.source.fromUser ? a = R9(t, e, f.path, f.children, r, i, o) : (V(f.source.fromServer, "Unknown source."), s = f.source.tagged || e.serverCache.isFiltered(), a = e1(t, e, f.path, f.children, r, i, s, o));
  } else if (n.type === Sn.ACK_USER_WRITE) {
    const f = n;
    f.revert ? a = F9(t, e, f.path, r, i, o) : a = L9(t, e, f.path, f.affectedTree, r, i, o);
  } else if (n.type === Sn.LISTEN_COMPLETE)
    a = $9(t, e, n.path, r, o);
  else
    throw Ho("Unknown operation type: " + n.type);
  const l = o.getChanges();
  return P9(e, a, l), { viewCache: a, changes: l };
}
function P9(t, e, n) {
  const r = e.eventCache;
  if (r.isFullyInitialized()) {
    const i = r.getNode().isLeafNode() || r.getNode().isEmpty(), o = ff(t);
    (n.length > 0 || !t.eventCache.isFullyInitialized() || i && !r.getNode().equals(o) || !r.getNode().getPriority().equals(o.getPriority())) && n.push(py(ff(e)));
  }
}
function xy(t, e, n, r, i, o) {
  const a = e.eventCache;
  if (uf(r, n) != null)
    return e;
  {
    let s, l;
    if (me(n))
      if (V(e.serverCache.isFullyInitialized(), "If change path is empty, we must have complete server data"), e.serverCache.isFiltered()) {
        const f = _i(e), c = f instanceof re ? f : re.EMPTY_NODE, u = Wh(r, c);
        s = t.filter.updateFullNode(e.eventCache.getNode(), u, o);
      } else {
        const f = cf(r, _i(e));
        s = t.filter.updateFullNode(e.eventCache.getNode(), f, o);
      }
    else {
      const f = pe(n);
      if (f === ".priority") {
        V(Pr(n) === 1, "Can't have a priority with additional path components");
        const c = a.getNode();
        l = e.serverCache.getNode();
        const u = zp(r, n, c, l);
        u != null ? s = t.filter.updatePriority(c, u) : s = a.getNode();
      } else {
        const c = Re(n);
        let u;
        if (a.isCompleteForChild(f)) {
          l = e.serverCache.getNode();
          const d = zp(r, n, a.getNode(), l);
          d != null ? u = a.getNode().getImmediateChild(f).updateChild(c, d) : u = a.getNode().getImmediateChild(f);
        } else
          u = Uh(r, f, e.serverCache);
        u != null ? s = t.filter.updateChild(a.getNode(), f, u, c, i, o) : s = a.getNode();
      }
    }
    return Fa(e, s, a.isFullyInitialized() || me(n), t.filter.filtersNodes());
  }
}
function df(t, e, n, r, i, o, a, s) {
  const l = e.serverCache;
  let f;
  const c = a ? t.filter : t.filter.getIndexedFilter();
  if (me(n))
    f = c.updateFullNode(l.getNode(), r, null);
  else if (c.filtersNodes() && !l.isFiltered()) {
    const h = l.getNode().updateChild(n, r);
    f = c.updateFullNode(l.getNode(), h, null);
  } else {
    const h = pe(n);
    if (!l.isCompleteForPath(n) && Pr(n) > 1)
      return e;
    const p = Re(n), v = l.getNode().getImmediateChild(h).updateChild(p, r);
    h === ".priority" ? f = c.updatePriority(l.getNode(), v) : f = c.updateChild(l.getNode(), h, v, p, Cy, null);
  }
  const u = vy(e, f, l.isFullyInitialized() || me(n), c.filtersNodes()), d = new Hh(i, u, o);
  return xy(t, u, n, i, d, s);
}
function Zd(t, e, n, r, i, o, a) {
  const s = e.eventCache;
  let l, f;
  const c = new Hh(i, e, o);
  if (me(n))
    f = t.filter.updateFullNode(e.eventCache.getNode(), r, a), l = Fa(e, f, !0, t.filter.filtersNodes());
  else {
    const u = pe(n);
    if (u === ".priority")
      f = t.filter.updatePriority(e.eventCache.getNode(), r), l = Fa(e, f, s.isFullyInitialized(), s.isFiltered());
    else {
      const d = Re(n), h = s.getNode().getImmediateChild(u);
      let p;
      if (me(d))
        p = r;
      else {
        const m = c.getCompleteChild(u);
        m != null ? Oh(d) === ".priority" && m.getChild(sy(d)).isEmpty() ? p = m : p = m.updateChild(d, r) : p = re.EMPTY_NODE;
      }
      if (h.equals(p))
        l = e;
      else {
        const m = t.filter.updateChild(s.getNode(), u, p, d, c, a);
        l = Fa(e, m, s.isFullyInitialized(), t.filter.filtersNodes());
      }
    }
  }
  return l;
}
function Bp(t, e) {
  return t.eventCache.isCompleteForChild(e);
}
function R9(t, e, n, r, i, o, a) {
  let s = e;
  return r.foreach((l, f) => {
    const c = Ge(n, l);
    Bp(e, pe(c)) && (s = Zd(t, s, c, f, i, o, a));
  }), r.foreach((l, f) => {
    const c = Ge(n, l);
    Bp(e, pe(c)) || (s = Zd(t, s, c, f, i, o, a));
  }), s;
}
function Wp(t, e, n) {
  return n.foreach((r, i) => {
    e = e.updateChild(r, i);
  }), e;
}
function e1(t, e, n, r, i, o, a, s) {
  if (e.serverCache.getNode().isEmpty() && !e.serverCache.isFullyInitialized())
    return e;
  let l = e, f;
  me(n) ? f = r : f = new Fe(null).setTree(n, r);
  const c = e.serverCache.getNode();
  return f.children.inorderTraversal((u, d) => {
    if (c.hasChild(u)) {
      const h = e.serverCache.getNode().getImmediateChild(u), p = Wp(t, h, d);
      l = df(t, l, new Ne(u), p, i, o, a, s);
    }
  }), f.children.inorderTraversal((u, d) => {
    const h = !e.serverCache.isCompleteForChild(u) && d.value === void 0;
    if (!c.hasChild(u) && !h) {
      const p = e.serverCache.getNode().getImmediateChild(u), m = Wp(t, p, d);
      l = df(t, l, new Ne(u), m, i, o, a, s);
    }
  }), l;
}
function L9(t, e, n, r, i, o, a) {
  if (uf(i, n) != null)
    return e;
  const s = e.serverCache.isFiltered(), l = e.serverCache;
  if (r.value != null) {
    if (me(n) && l.isFullyInitialized() || l.isCompleteForPath(n))
      return df(t, e, n, l.getNode().getChild(n), i, o, s, a);
    if (me(n)) {
      let f = new Fe(null);
      return l.getNode().forEachChild(dr, (c, u) => {
        f = f.set(new Ne(c), u);
      }), e1(t, e, n, f, i, o, s, a);
    } else
      return e;
  } else {
    let f = new Fe(null);
    return r.foreach((c, u) => {
      const d = Ge(n, c);
      l.isCompleteForPath(d) && (f = f.set(c, l.getNode().getChild(d)));
    }), e1(t, e, n, f, i, o, s, a);
  }
}
function $9(t, e, n, r, i) {
  const o = e.serverCache, a = vy(e, o.getNode(), o.isFullyInitialized() || me(n), o.isFiltered());
  return xy(t, a, n, r, Cy, i);
}
function F9(t, e, n, r, i, o) {
  let a;
  if (uf(r, n) != null)
    return e;
  {
    const s = new Hh(r, e, i), l = e.eventCache.getNode();
    let f;
    if (me(n) || pe(n) === ".priority") {
      let c;
      if (e.serverCache.isFullyInitialized())
        c = cf(r, _i(e));
      else {
        const u = e.serverCache.getNode();
        V(u instanceof re, "serverChildren would be complete if leaf node"), c = Wh(r, u);
      }
      c = c, f = t.filter.updateFullNode(l, c, o);
    } else {
      const c = pe(n);
      let u = Uh(r, c, e.serverCache);
      u == null && e.serverCache.isCompleteForChild(c) && (u = l.getImmediateChild(c)), u != null ? f = t.filter.updateChild(l, c, u, Re(n), s, o) : e.eventCache.getNode().hasChild(c) ? f = t.filter.updateChild(l, c, re.EMPTY_NODE, Re(n), s, o) : f = l, f.isEmpty() && e.serverCache.isFullyInitialized() && (a = cf(r, _i(e)), a.isLeafNode() && (f = t.filter.updateFullNode(f, a, o)));
    }
    return a = e.serverCache.isFullyInitialized() || uf(r, Te()) != null, Fa(e, f, a, t.filter.filtersNodes());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class j9 {
  constructor(e, n) {
    this.query_ = e, this.eventRegistrations_ = [];
    const r = this.query_._queryParams, i = new $h(r.getIndex()), o = t9(r);
    this.processor_ = A9(o);
    const a = n.serverCache, s = n.eventCache, l = i.updateFullNode(re.EMPTY_NODE, a.getNode(), null), f = o.updateFullNode(re.EMPTY_NODE, s.getNode(), null), c = new Rr(l, a.isFullyInitialized(), i.filtersNodes()), u = new Rr(f, s.isFullyInitialized(), o.filtersNodes());
    this.viewCache_ = ic(u, c), this.eventGenerator_ = new c9(this.query_);
  }
  get query() {
    return this.query_;
  }
}
function z9(t) {
  return t.viewCache_.serverCache.getNode();
}
function B9(t) {
  return ff(t.viewCache_);
}
function W9(t, e) {
  const n = _i(t.viewCache_);
  return n && (t.query._queryParams.loadsAllData() || !me(e) && !n.getImmediateChild(pe(e)).isEmpty()) ? n.getChild(e) : null;
}
function Up(t) {
  return t.eventRegistrations_.length === 0;
}
function U9(t, e) {
  t.eventRegistrations_.push(e);
}
function Hp(t, e, n) {
  const r = [];
  if (n) {
    V(e == null, "A cancel should cancel all event registrations.");
    const i = t.query._path;
    t.eventRegistrations_.forEach((o) => {
      const a = o.createCancelEvent(n, i);
      a && r.push(a);
    });
  }
  if (e) {
    let i = [];
    for (let o = 0; o < t.eventRegistrations_.length; ++o) {
      const a = t.eventRegistrations_[o];
      if (!a.matches(e))
        i.push(a);
      else if (e.hasAnyCallback()) {
        i = i.concat(t.eventRegistrations_.slice(o + 1));
        break;
      }
    }
    t.eventRegistrations_ = i;
  } else
    t.eventRegistrations_ = [];
  return r;
}
function Vp(t, e, n, r) {
  e.type === Sn.MERGE && e.source.queryId !== null && (V(_i(t.viewCache_), "We should always have a full cache before handling merges"), V(ff(t.viewCache_), "Missing event cache, even though we have a server cache"));
  const i = t.viewCache_, o = D9(t.processor_, i, e, n, r);
  return O9(t.processor_, o.viewCache), V(o.viewCache.serverCache.isFullyInitialized() || !i.serverCache.isFullyInitialized(), "Once a server snap is complete, it should never go back"), t.viewCache_ = o.viewCache, Ey(t, o.changes, o.viewCache.eventCache.getNode(), null);
}
function H9(t, e) {
  const n = t.viewCache_.eventCache, r = [];
  return n.getNode().isLeafNode() || n.getNode().forEachChild(qe, (o, a) => {
    r.push(So(o, a));
  }), n.isFullyInitialized() && r.push(py(n.getNode())), Ey(t, r, n.getNode(), e);
}
function Ey(t, e, n, r) {
  const i = r ? [r] : t.eventRegistrations_;
  return u9(t.eventGenerator_, e, n, i);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let hf;
class Ty {
  constructor() {
    this.views = /* @__PURE__ */ new Map();
  }
}
function V9(t) {
  V(!hf, "__referenceConstructor has already been defined"), hf = t;
}
function K9() {
  return V(hf, "Reference.ts has not been loaded"), hf;
}
function Y9(t) {
  return t.views.size === 0;
}
function Vh(t, e, n, r) {
  const i = e.source.queryId;
  if (i !== null) {
    const o = t.views.get(i);
    return V(o != null, "SyncTree gave us an op for an invalid query."), Vp(o, e, n, r);
  } else {
    let o = [];
    for (const a of t.views.values())
      o = o.concat(Vp(a, e, n, r));
    return o;
  }
}
function Kh(t, e, n, r, i) {
  const o = e._queryIdentifier, a = t.views.get(o);
  if (!a) {
    let s = cf(n, i ? r : null), l = !1;
    s ? l = !0 : r instanceof re ? (s = Wh(n, r), l = !1) : (s = re.EMPTY_NODE, l = !1);
    const f = ic(new Rr(s, l, !1), new Rr(r, i, !1));
    return new j9(e, f);
  }
  return a;
}
function q9(t, e, n, r, i, o) {
  const a = Kh(t, e, r, i, o);
  return t.views.has(e._queryIdentifier) || t.views.set(e._queryIdentifier, a), U9(a, n), H9(a, n);
}
function G9(t, e, n, r) {
  const i = e._queryIdentifier, o = [];
  let a = [];
  const s = Lr(t);
  if (i === "default")
    for (const [l, f] of t.views.entries())
      a = a.concat(Hp(f, n, r)), Up(f) && (t.views.delete(l), f.query._queryParams.loadsAllData() || o.push(f.query));
  else {
    const l = t.views.get(i);
    l && (a = a.concat(Hp(l, n, r)), Up(l) && (t.views.delete(i), l.query._queryParams.loadsAllData() || o.push(l.query)));
  }
  return s && !Lr(t) && o.push(new (K9())(e._repo, e._path)), { removed: o, events: a };
}
function Sy(t) {
  const e = [];
  for (const n of t.views.values())
    n.query._queryParams.loadsAllData() || e.push(n);
  return e;
}
function Ir(t, e) {
  let n = null;
  for (const r of t.views.values())
    n = n || W9(r, e);
  return n;
}
function Iy(t, e) {
  if (e._queryParams.loadsAllData())
    return ac(t);
  {
    const r = e._queryIdentifier;
    return t.views.get(r);
  }
}
function Ny(t, e) {
  return Iy(t, e) != null;
}
function Lr(t) {
  return ac(t) != null;
}
function ac(t) {
  for (const e of t.views.values())
    if (e.query._queryParams.loadsAllData())
      return e;
  return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let gf;
function Q9(t) {
  V(!gf, "__referenceConstructor has already been defined"), gf = t;
}
function X9() {
  return V(gf, "Reference.ts has not been loaded"), gf;
}
let J9 = 1;
class Kp {
  /**
   * @param listenProvider_ - Used by SyncTree to start / stop listening
   *   to server data.
   */
  constructor(e) {
    this.listenProvider_ = e, this.syncPointTree_ = new Fe(null), this.pendingWriteTree_ = S9(), this.tagToQueryMap = /* @__PURE__ */ new Map(), this.queryToTagMap = /* @__PURE__ */ new Map();
  }
}
function My(t, e, n, r, i) {
  return p9(t.pendingWriteTree_, e, n, r, i), i ? Yo(t, new yi(jh(), e, n)) : [];
}
function Z9(t, e, n, r) {
  m9(t.pendingWriteTree_, e, n, r);
  const i = Fe.fromObject(n);
  return Yo(t, new Io(jh(), e, i));
}
function wr(t, e, n = !1) {
  const r = v9(t.pendingWriteTree_, e);
  if (b9(t.pendingWriteTree_, e)) {
    let o = new Fe(null);
    return r.snap != null ? o = o.set(Te(), !0) : bt(r.children, (a) => {
      o = o.set(new Ne(a), !0);
    }), Yo(t, new lf(r.path, o, n));
  } else
    return [];
}
function zs(t, e, n) {
  return Yo(t, new yi(zh(), e, n));
}
function eN(t, e, n) {
  const r = Fe.fromObject(n);
  return Yo(t, new Io(zh(), e, r));
}
function tN(t, e) {
  return Yo(t, new us(zh(), e));
}
function nN(t, e, n) {
  const r = qh(t, n);
  if (r) {
    const i = Gh(r), o = i.path, a = i.queryId, s = Ot(o, e), l = new us(Bh(a), s);
    return Qh(t, o, l);
  } else
    return [];
}
function pf(t, e, n, r) {
  const i = e._path, o = t.syncPointTree_.get(i);
  let a = [];
  if (o && (e._queryIdentifier === "default" || Ny(o, e))) {
    const s = G9(o, e, n, r);
    Y9(o) && (t.syncPointTree_ = t.syncPointTree_.remove(i));
    const l = s.removed;
    a = s.events;
    const f = l.findIndex((u) => u._queryParams.loadsAllData()) !== -1, c = t.syncPointTree_.findOnPath(i, (u, d) => Lr(d));
    if (f && !c) {
      const u = t.syncPointTree_.subtree(i);
      if (!u.isEmpty()) {
        const d = aN(u);
        for (let h = 0; h < d.length; ++h) {
          const p = d[h], m = p.query, v = Ry(t, p);
          t.listenProvider_.startListening(za(m), ds(t, m), v.hashFn, v.onComplete);
        }
      }
    }
    !c && l.length > 0 && !r && (f ? t.listenProvider_.stopListening(za(e), null) : l.forEach((u) => {
      const d = t.queryToTagMap.get(sc(u));
      t.listenProvider_.stopListening(za(u), d);
    })), sN(t, l);
  }
  return a;
}
function rN(t, e) {
  const { syncPoint: n, serverCache: r, writesCache: i, serverCacheComplete: o } = Oy(e, t), a = Kh(n, e, i, r, o);
  return n.views.has(e._queryIdentifier) || n.views.set(e._queryIdentifier, a), e._queryParams.loadsAllData() ? null : ds(t, e);
}
function Ay(t, e, n, r) {
  const i = qh(t, r);
  if (i != null) {
    const o = Gh(i), a = o.path, s = o.queryId, l = Ot(a, e), f = new yi(Bh(s), l, n);
    return Qh(t, a, f);
  } else
    return [];
}
function iN(t, e, n, r) {
  const i = qh(t, r);
  if (i) {
    const o = Gh(i), a = o.path, s = o.queryId, l = Ot(a, e), f = Fe.fromObject(n), c = new Io(Bh(s), l, f);
    return Qh(t, a, c);
  } else
    return [];
}
function Oy(t, e) {
  const n = t._path;
  let r = null, i = !1;
  e.syncPointTree_.foreachOnPath(n, (f, c) => {
    const u = Ot(f, n);
    r = r || Ir(c, u), i = i || Lr(c);
  });
  let o = e.syncPointTree_.get(n);
  o ? (i = i || Lr(o), r = r || Ir(o, Te())) : (o = new Ty(), e.syncPointTree_ = e.syncPointTree_.set(n, o));
  let a;
  r != null ? a = !0 : (a = !1, r = re.EMPTY_NODE, e.syncPointTree_.subtree(n).foreachChild((c, u) => {
    const d = Ir(u, Te());
    d && (r = r.updateImmediateChild(c, d));
  }));
  const s = Ny(o, t);
  if (!s && !t._queryParams.loadsAllData()) {
    const f = sc(t);
    V(!e.queryToTagMap.has(f), "View does not exist, but we have a tag");
    const c = lN();
    e.queryToTagMap.set(f, c), e.tagToQueryMap.set(c, f);
  }
  const l = oc(e.pendingWriteTree_, n);
  return {
    syncPoint: o,
    writesCache: l,
    serverCache: r,
    serverCacheComplete: a,
    foundAncestorDefaultView: i,
    viewAlreadyExists: s
  };
}
function Yp(t, e, n) {
  const { syncPoint: r, serverCache: i, writesCache: o, serverCacheComplete: a, viewAlreadyExists: s, foundAncestorDefaultView: l } = Oy(e, t);
  let f = q9(r, e, n, o, i, a);
  if (!s && !l) {
    const c = Iy(r, e);
    f = f.concat(fN(t, e, c));
  }
  return f;
}
function Yh(t, e, n) {
  const i = t.pendingWriteTree_, o = t.syncPointTree_.findOnPath(e, (a, s) => {
    const l = Ot(a, e), f = Ir(s, l);
    if (f)
      return f;
  });
  return _y(i, e, o, n, !0);
}
function oN(t, e) {
  const n = e._path;
  let r = null;
  t.syncPointTree_.foreachOnPath(n, (f, c) => {
    const u = Ot(f, n);
    r = r || Ir(c, u);
  });
  let i = t.syncPointTree_.get(n);
  i ? r = r || Ir(i, Te()) : (i = new Ty(), t.syncPointTree_ = t.syncPointTree_.set(n, i));
  const o = r != null, a = o ? new Rr(r, !0, !1) : null, s = oc(t.pendingWriteTree_, e._path), l = Kh(i, e, s, o ? a.getNode() : re.EMPTY_NODE, o);
  return B9(l);
}
function Yo(t, e) {
  return Dy(
    e,
    t.syncPointTree_,
    /*serverCache=*/
    null,
    oc(t.pendingWriteTree_, Te())
  );
}
function Dy(t, e, n, r) {
  if (me(t.path))
    return Py(t, e, n, r);
  {
    const i = e.get(Te());
    n == null && i != null && (n = Ir(i, Te()));
    let o = [];
    const a = pe(t.path), s = t.operationForChild(a), l = e.children.get(a);
    if (l && s) {
      const f = n ? n.getImmediateChild(a) : null, c = wy(r, a);
      o = o.concat(Dy(s, l, f, c));
    }
    return i && (o = o.concat(Vh(i, t, r, n))), o;
  }
}
function Py(t, e, n, r) {
  const i = e.get(Te());
  n == null && i != null && (n = Ir(i, Te()));
  let o = [];
  return e.children.inorderTraversal((a, s) => {
    const l = n ? n.getImmediateChild(a) : null, f = wy(r, a), c = t.operationForChild(a);
    c && (o = o.concat(Py(c, s, l, f)));
  }), i && (o = o.concat(Vh(i, t, r, n))), o;
}
function Ry(t, e) {
  const n = e.query, r = ds(t, n);
  return {
    hashFn: () => (z9(e) || re.EMPTY_NODE).hash(),
    onComplete: (i) => {
      if (i === "ok")
        return r ? nN(t, n._path, r) : tN(t, n._path);
      {
        const o = JS(i, n);
        return pf(
          t,
          n,
          /*eventRegistration*/
          null,
          o
        );
      }
    }
  };
}
function ds(t, e) {
  const n = sc(e);
  return t.queryToTagMap.get(n);
}
function sc(t) {
  return t._path.toString() + "$" + t._queryIdentifier;
}
function qh(t, e) {
  return t.tagToQueryMap.get(e);
}
function Gh(t) {
  const e = t.indexOf("$");
  return V(e !== -1 && e < t.length - 1, "Bad queryKey."), {
    queryId: t.substr(e + 1),
    path: new Ne(t.substr(0, e))
  };
}
function Qh(t, e, n) {
  const r = t.syncPointTree_.get(e);
  V(r, "Missing sync point for query tag that we're tracking");
  const i = oc(t.pendingWriteTree_, e);
  return Vh(r, n, i, null);
}
function aN(t) {
  return t.fold((e, n, r) => {
    if (n && Lr(n))
      return [ac(n)];
    {
      let i = [];
      return n && (i = Sy(n)), bt(r, (o, a) => {
        i = i.concat(a);
      }), i;
    }
  });
}
function za(t) {
  return t._queryParams.loadsAllData() && !t._queryParams.isDefault() ? new (X9())(t._repo, t._path) : t;
}
function sN(t, e) {
  for (let n = 0; n < e.length; ++n) {
    const r = e[n];
    if (!r._queryParams.loadsAllData()) {
      const i = sc(r), o = t.queryToTagMap.get(i);
      t.queryToTagMap.delete(i), t.tagToQueryMap.delete(o);
    }
  }
}
function lN() {
  return J9++;
}
function fN(t, e, n) {
  const r = e._path, i = ds(t, e), o = Ry(t, n), a = t.listenProvider_.startListening(za(e), i, o.hashFn, o.onComplete), s = t.syncPointTree_.subtree(r);
  if (i)
    V(!Lr(s.value), "If we're adding a query, it shouldn't be shadowed");
  else {
    const l = s.fold((f, c, u) => {
      if (!me(f) && c && Lr(c))
        return [ac(c).query];
      {
        let d = [];
        return c && (d = d.concat(Sy(c).map((h) => h.query))), bt(u, (h, p) => {
          d = d.concat(p);
        }), d;
      }
    });
    for (let f = 0; f < l.length; ++f) {
      const c = l[f];
      t.listenProvider_.stopListening(za(c), ds(t, c));
    }
  }
  return a;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Xh {
  constructor(e) {
    this.node_ = e;
  }
  getImmediateChild(e) {
    const n = this.node_.getImmediateChild(e);
    return new Xh(n);
  }
  node() {
    return this.node_;
  }
}
class Jh {
  constructor(e, n) {
    this.syncTree_ = e, this.path_ = n;
  }
  getImmediateChild(e) {
    const n = Ge(this.path_, e);
    return new Jh(this.syncTree_, n);
  }
  node() {
    return Yh(this.syncTree_, this.path_);
  }
}
const cN = function(t) {
  return t = t || {}, t.timestamp = t.timestamp || new Date().getTime(), t;
}, qp = function(t, e, n) {
  if (!t || typeof t != "object")
    return t;
  if (V(".sv" in t, "Unexpected leaf node or priority contents"), typeof t[".sv"] == "string")
    return uN(t[".sv"], e, n);
  if (typeof t[".sv"] == "object")
    return dN(t[".sv"], e);
  V(!1, "Unexpected server value: " + JSON.stringify(t, null, 2));
}, uN = function(t, e, n) {
  switch (t) {
    case "timestamp":
      return n.timestamp;
    default:
      V(!1, "Unexpected server value: " + t);
  }
}, dN = function(t, e, n) {
  t.hasOwnProperty("increment") || V(!1, "Unexpected server value: " + JSON.stringify(t, null, 2));
  const r = t.increment;
  typeof r != "number" && V(!1, "Unexpected increment value: " + r);
  const i = e.node();
  if (V(i !== null && typeof i < "u", "Expected ChildrenNode.EMPTY_NODE for nulls"), !i.isLeafNode())
    return r;
  const a = i.getValue();
  return typeof a != "number" ? r : a + r;
}, Ly = function(t, e, n, r) {
  return Zh(e, new Jh(n, t), r);
}, $y = function(t, e, n) {
  return Zh(t, new Xh(e), n);
};
function Zh(t, e, n) {
  const r = t.getPriority().val(), i = qp(r, e.getImmediateChild(".priority"), n);
  let o;
  if (t.isLeafNode()) {
    const a = t, s = qp(a.getValue(), e, n);
    return s !== a.getValue() || i !== a.getPriority().val() ? new ft(s, Je(i)) : t;
  } else {
    const a = t;
    return o = a, i !== a.getPriority().val() && (o = o.updatePriority(new ft(i))), a.forEachChild(qe, (s, l) => {
      const f = Zh(l, e.getImmediateChild(s), n);
      f !== l && (o = o.updateImmediateChild(s, f));
    }), o;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class e0 {
  /**
   * @param name - Optional name of the node.
   * @param parent - Optional parent node.
   * @param node - Optional node to wrap.
   */
  constructor(e = "", n = null, r = { children: {}, childCount: 0 }) {
    this.name = e, this.parent = n, this.node = r;
  }
}
function t0(t, e) {
  let n = e instanceof Ne ? e : new Ne(e), r = t, i = pe(n);
  for (; i !== null; ) {
    const o = Co(r.node.children, i) || {
      children: {},
      childCount: 0
    };
    r = new e0(i, r, o), n = Re(n), i = pe(n);
  }
  return r;
}
function qo(t) {
  return t.node.value;
}
function Fy(t, e) {
  t.node.value = e, t1(t);
}
function jy(t) {
  return t.node.childCount > 0;
}
function hN(t) {
  return qo(t) === void 0 && !jy(t);
}
function lc(t, e) {
  bt(t.node.children, (n, r) => {
    e(new e0(n, t, r));
  });
}
function zy(t, e, n, r) {
  n && !r && e(t), lc(t, (i) => {
    zy(i, e, !0, r);
  }), n && r && e(t);
}
function gN(t, e, n) {
  let r = n ? t : t.parent;
  for (; r !== null; ) {
    if (e(r))
      return !0;
    r = r.parent;
  }
  return !1;
}
function Bs(t) {
  return new Ne(t.parent === null ? t.name : Bs(t.parent) + "/" + t.name);
}
function t1(t) {
  t.parent !== null && pN(t.parent, t.name, t);
}
function pN(t, e, n) {
  const r = hN(n), i = qn(t.node.children, e);
  r && i ? (delete t.node.children[e], t.node.childCount--, t1(t)) : !r && !i && (t.node.children[e] = n.node, t.node.childCount++, t1(t));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const mN = /[\[\].#$\/\u0000-\u001F\u007F]/, vN = /[\[\].#$\u0000-\u001F\u007F]/, Ru = 10 * 1024 * 1024, fc = function(t) {
  return typeof t == "string" && t.length !== 0 && !mN.test(t);
}, By = function(t) {
  return typeof t == "string" && t.length !== 0 && !vN.test(t);
}, bN = function(t) {
  return t && (t = t.replace(/^\/*\.info(\/|$)/, "/")), By(t);
}, mf = function(t) {
  return t === null || typeof t == "string" || typeof t == "number" && !nc(t) || t && typeof t == "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
  qn(t, ".sv");
}, hs = function(t, e, n, r) {
  r && e === void 0 || cc(hi(t, "value"), e, n);
}, cc = function(t, e, n) {
  const r = n instanceof Ne ? new OI(n, t) : n;
  if (e === void 0)
    throw new Error(t + "contains undefined " + Qr(r));
  if (typeof e == "function")
    throw new Error(t + "contains a function " + Qr(r) + " with contents = " + e.toString());
  if (nc(e))
    throw new Error(t + "contains " + e.toString() + " " + Qr(r));
  if (typeof e == "string" && e.length > Ru / 3 && tc(e) > Ru)
    throw new Error(t + "contains a string greater than " + Ru + " utf8 bytes " + Qr(r) + " ('" + e.substring(0, 50) + "...')");
  if (e && typeof e == "object") {
    let i = !1, o = !1;
    if (bt(e, (a, s) => {
      if (a === ".value")
        i = !0;
      else if (a !== ".priority" && a !== ".sv" && (o = !0, !fc(a)))
        throw new Error(t + " contains an invalid key (" + a + ") " + Qr(r) + `.  Keys must be non-empty strings and can't contain ".", "#", "$", "/", "[", or "]"`);
      DI(r, a), cc(t, s, r), PI(r);
    }), i && o)
      throw new Error(t + ' contains ".value" child ' + Qr(r) + " in addition to actual children.");
  }
}, yN = function(t, e) {
  let n, r;
  for (n = 0; n < e.length; n++) {
    r = e[n];
    const o = ss(r);
    for (let a = 0; a < o.length; a++)
      if (!(o[a] === ".priority" && a === o.length - 1)) {
        if (!fc(o[a]))
          throw new Error(t + "contains an invalid key (" + o[a] + ") in path " + r.toString() + `. Keys must be non-empty strings and can't contain ".", "#", "$", "/", "[", or "]"`);
      }
  }
  e.sort(AI);
  let i = null;
  for (n = 0; n < e.length; n++) {
    if (r = e[n], i !== null && fn(i, r))
      throw new Error(t + "contains a path " + i.toString() + " that is ancestor of another path " + r.toString());
    i = r;
  }
}, Wy = function(t, e, n, r) {
  if (r && e === void 0)
    return;
  const i = hi(t, "values");
  if (!(e && typeof e == "object") || Array.isArray(e))
    throw new Error(i + " must be an object containing the children to replace.");
  const o = [];
  bt(e, (a, s) => {
    const l = new Ne(a);
    if (cc(i, s, Ge(n, l)), Oh(l) === ".priority" && !mf(s))
      throw new Error(i + "contains an invalid value for '" + l.toString() + "', which must be a valid Firebase priority (a string, finite number, server value, or null).");
    o.push(l);
  }), yN(i, o);
}, _N = function(t, e, n) {
  if (!(n && e === void 0)) {
    if (nc(e))
      throw new Error(hi(t, "priority") + "is " + e.toString() + ", but must be a valid Firebase priority (a string, finite number, server value, or null).");
    if (!mf(e))
      throw new Error(hi(t, "priority") + "must be a valid Firebase priority (a string, finite number, server value, or null).");
  }
}, wN = function(t, e, n, r) {
  if (!(r && n === void 0) && !fc(n))
    throw new Error(hi(t, e) + 'was an invalid key = "' + n + `".  Firebase keys must be non-empty strings and can't contain ".", "#", "$", "/", "[", or "]").`);
}, n0 = function(t, e, n, r) {
  if (!(r && n === void 0) && !By(n))
    throw new Error(hi(t, e) + 'was an invalid path = "' + n + `". Paths must be non-empty strings and can't contain ".", "#", "$", "[", or "]"`);
}, kN = function(t, e, n, r) {
  n && (n = n.replace(/^\/*\.info(\/|$)/, "/")), n0(t, e, n, r);
}, ni = function(t, e) {
  if (pe(e) === ".info")
    throw new Error(t + " failed = Can't modify data under /.info/");
}, CN = function(t, e) {
  const n = e.path.toString();
  if (typeof e.repoInfo.host != "string" || e.repoInfo.host.length === 0 || !fc(e.repoInfo.namespace) && e.repoInfo.host.split(":")[0] !== "localhost" || n.length !== 0 && !bN(n))
    throw new Error(hi(t, "url") + `must be a valid firebase URL and the path can't contain ".", "#", "$", "[", or "]".`);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class xN {
  constructor() {
    this.eventLists_ = [], this.recursionDepth_ = 0;
  }
}
function uc(t, e) {
  let n = null;
  for (let r = 0; r < e.length; r++) {
    const i = e[r], o = i.getPath();
    n !== null && !Dh(o, n.path) && (t.eventLists_.push(n), n = null), n === null && (n = { events: [], path: o }), n.events.push(i);
  }
  n && t.eventLists_.push(n);
}
function Uy(t, e, n) {
  uc(t, n), Hy(t, (r) => Dh(r, e));
}
function An(t, e, n) {
  uc(t, n), Hy(t, (r) => fn(r, e) || fn(e, r));
}
function Hy(t, e) {
  t.recursionDepth_++;
  let n = !0;
  for (let r = 0; r < t.eventLists_.length; r++) {
    const i = t.eventLists_[r];
    if (i) {
      const o = i.path;
      e(o) ? (EN(t.eventLists_[r]), t.eventLists_[r] = null) : n = !1;
    }
  }
  n && (t.eventLists_ = []), t.recursionDepth_--;
}
function EN(t) {
  for (let e = 0; e < t.events.length; e++) {
    const n = t.events[e];
    if (n !== null) {
      t.events[e] = null;
      const r = n.getEventRunner();
      ii && ht("event: " + n.toString()), Vo(r);
    }
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const TN = "repo_interrupt", SN = 25;
class IN {
  constructor(e, n, r, i) {
    this.repoInfo_ = e, this.forceRestClient_ = n, this.authTokenProvider_ = r, this.appCheckProvider_ = i, this.dataUpdateCount = 0, this.statsListener_ = null, this.eventQueue_ = new xN(), this.nextWriteId_ = 1, this.interceptServerDataCallback_ = null, this.onDisconnect_ = sf(), this.transactionQueueTree_ = new e0(), this.persistentConnection_ = null, this.key = this.repoInfo_.toURLString();
  }
  /**
   * @returns The URL corresponding to the root of this Firebase.
   */
  toString() {
    return (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host;
  }
}
function NN(t, e, n) {
  if (t.stats_ = Mh(t.repoInfo_), t.forceRestClient_ || tI())
    t.server_ = new af(t.repoInfo_, (r, i, o, a) => {
      Gp(t, r, i, o, a);
    }, t.authTokenProvider_, t.appCheckProvider_), setTimeout(() => Qp(
      t,
      /* connectStatus= */
      !0
    ), 0);
  else {
    if (typeof n < "u" && n !== null) {
      if (typeof n != "object")
        throw new Error("Only objects are supported for option databaseAuthVariableOverride");
      try {
        rt(n);
      } catch (r) {
        throw new Error("Invalid authOverride provided: " + r);
      }
    }
    t.persistentConnection_ = new ur(t.repoInfo_, e, (r, i, o, a) => {
      Gp(t, r, i, o, a);
    }, (r) => {
      Qp(t, r);
    }, (r) => {
      MN(t, r);
    }, t.authTokenProvider_, t.appCheckProvider_, n), t.server_ = t.persistentConnection_;
  }
  t.authTokenProvider_.addTokenChangeListener((r) => {
    t.server_.refreshAuthToken(r);
  }), t.appCheckProvider_.addTokenChangeListener((r) => {
    t.server_.refreshAppCheckToken(r.token);
  }), t.statsReporter_ = sI(t.repoInfo_, () => new f9(t.stats_, t.server_)), t.infoData_ = new i9(), t.infoSyncTree_ = new Kp({
    startListening: (r, i, o, a) => {
      let s = [];
      const l = t.infoData_.getNode(r._path);
      return l.isEmpty() || (s = zs(t.infoSyncTree_, r._path, l), setTimeout(() => {
        a("ok");
      }, 0)), s;
    },
    stopListening: () => {
    }
  }), r0(t, "connected", !1), t.serverSyncTree_ = new Kp({
    startListening: (r, i, o, a) => (t.server_.listen(r, o, i, (s, l) => {
      const f = a(s, l);
      An(t.eventQueue_, r._path, f);
    }), []),
    stopListening: (r, i) => {
      t.server_.unlisten(r, i);
    }
  });
}
function Vy(t) {
  const n = t.infoData_.getNode(new Ne(".info/serverTimeOffset")).val() || 0;
  return new Date().getTime() + n;
}
function dc(t) {
  return cN({
    timestamp: Vy(t)
  });
}
function Gp(t, e, n, r, i) {
  t.dataUpdateCount++;
  const o = new Ne(e);
  n = t.interceptServerDataCallback_ ? t.interceptServerDataCallback_(e, n) : n;
  let a = [];
  if (i)
    if (r) {
      const l = Kl(n, (f) => Je(f));
      a = iN(t.serverSyncTree_, o, l, i);
    } else {
      const l = Je(n);
      a = Ay(t.serverSyncTree_, o, l, i);
    }
  else if (r) {
    const l = Kl(n, (f) => Je(f));
    a = eN(t.serverSyncTree_, o, l);
  } else {
    const l = Je(n);
    a = zs(t.serverSyncTree_, o, l);
  }
  let s = o;
  a.length > 0 && (s = Ao(t, o)), An(t.eventQueue_, s, a);
}
function Qp(t, e) {
  r0(t, "connected", e), e === !1 && PN(t);
}
function MN(t, e) {
  bt(e, (n, r) => {
    r0(t, n, r);
  });
}
function r0(t, e, n) {
  const r = new Ne("/.info/" + e), i = Je(n);
  t.infoData_.updateSnapshot(r, i);
  const o = zs(t.infoSyncTree_, r, i);
  An(t.eventQueue_, r, o);
}
function i0(t) {
  return t.nextWriteId_++;
}
function AN(t, e) {
  const n = oN(t.serverSyncTree_, e);
  return n != null ? Promise.resolve(n) : t.server_.get(e).then((r) => {
    const i = Je(r).withIndex(e._queryParams.getIndex());
    if (e._queryParams.loadsAllData())
      zs(t.serverSyncTree_, e._path, i);
    else {
      const a = rN(t.serverSyncTree_, e);
      Ay(t.serverSyncTree_, e._path, i, a);
    }
    return pf(t.serverSyncTree_, e, null).length > 0 && Mo(t, "unexpected cancel events in repoGetValue"), i;
  }, (r) => (Mo(t, "get for query " + rt(e) + " failed: " + r), Promise.reject(new Error(r))));
}
function ON(t, e, n, r, i) {
  Mo(t, "set", {
    path: e.toString(),
    value: n,
    priority: r
  });
  const o = dc(t), a = Je(n, r), s = Yh(t.serverSyncTree_, e), l = $y(a, s, o), f = i0(t), c = My(t.serverSyncTree_, e, l, f, !0);
  uc(t.eventQueue_, c), t.server_.put(e.toString(), a.val(
    /*export=*/
    !0
  ), (d, h) => {
    const p = d === "ok";
    p || Pt("set at " + e + " failed: " + d);
    const m = wr(t.serverSyncTree_, f, !p);
    An(t.eventQueue_, e, m), $r(t, i, d, h);
  });
  const u = a0(t, e);
  Ao(t, u), An(t.eventQueue_, u, []);
}
function DN(t, e, n, r) {
  Mo(t, "update", { path: e.toString(), value: n });
  let i = !0;
  const o = dc(t), a = {};
  if (bt(n, (s, l) => {
    i = !1, a[s] = Ly(Ge(e, s), Je(l), t.serverSyncTree_, o);
  }), i)
    ht("update() called with empty data.  Don't do anything."), $r(t, r, "ok", void 0);
  else {
    const s = i0(t), l = Z9(t.serverSyncTree_, e, a, s);
    uc(t.eventQueue_, l), t.server_.merge(e.toString(), n, (f, c) => {
      const u = f === "ok";
      u || Pt("update at " + e + " failed: " + f);
      const d = wr(t.serverSyncTree_, s, !u), h = d.length > 0 ? Ao(t, e) : e;
      An(t.eventQueue_, h, d), $r(t, r, f, c);
    }), bt(n, (f) => {
      const c = a0(t, Ge(e, f));
      Ao(t, c);
    }), An(t.eventQueue_, e, []);
  }
}
function PN(t) {
  Mo(t, "onDisconnectEvents");
  const e = dc(t), n = sf();
  Gd(t.onDisconnect_, Te(), (i, o) => {
    const a = Ly(i, o, t.serverSyncTree_, e);
    Ko(n, i, a);
  });
  let r = [];
  Gd(n, Te(), (i, o) => {
    r = r.concat(zs(t.serverSyncTree_, i, o));
    const a = a0(t, i);
    Ao(t, a);
  }), t.onDisconnect_ = sf(), An(t.eventQueue_, Te(), r);
}
function RN(t, e, n) {
  t.server_.onDisconnectCancel(e.toString(), (r, i) => {
    r === "ok" && qd(t.onDisconnect_, e), $r(t, n, r, i);
  });
}
function Xp(t, e, n, r) {
  const i = Je(n);
  t.server_.onDisconnectPut(e.toString(), i.val(
    /*export=*/
    !0
  ), (o, a) => {
    o === "ok" && Ko(t.onDisconnect_, e, i), $r(t, r, o, a);
  });
}
function LN(t, e, n, r, i) {
  const o = Je(n, r);
  t.server_.onDisconnectPut(e.toString(), o.val(
    /*export=*/
    !0
  ), (a, s) => {
    a === "ok" && Ko(t.onDisconnect_, e, o), $r(t, i, a, s);
  });
}
function $N(t, e, n, r) {
  if (Md(n)) {
    ht("onDisconnect().update() called with empty data.  Don't do anything."), $r(t, r, "ok", void 0);
    return;
  }
  t.server_.onDisconnectMerge(e.toString(), n, (i, o) => {
    i === "ok" && bt(n, (a, s) => {
      const l = Je(s);
      Ko(t.onDisconnect_, Ge(e, a), l);
    }), $r(t, r, i, o);
  });
}
function FN(t, e, n) {
  let r;
  pe(e._path) === ".info" ? r = Yp(t.infoSyncTree_, e, n) : r = Yp(t.serverSyncTree_, e, n), Uy(t.eventQueue_, e._path, r);
}
function Jp(t, e, n) {
  let r;
  pe(e._path) === ".info" ? r = pf(t.infoSyncTree_, e, n) : r = pf(t.serverSyncTree_, e, n), Uy(t.eventQueue_, e._path, r);
}
function jN(t) {
  t.persistentConnection_ && t.persistentConnection_.interrupt(TN);
}
function Mo(t, ...e) {
  let n = "";
  t.persistentConnection_ && (n = t.persistentConnection_.id + ":"), ht(n, ...e);
}
function $r(t, e, n, r) {
  e && Vo(() => {
    if (n === "ok")
      e(null);
    else {
      const i = (n || "error").toUpperCase();
      let o = i;
      r && (o += ": " + r);
      const a = new Error(o);
      a.code = i, e(a);
    }
  });
}
function Ky(t, e, n) {
  return Yh(t.serverSyncTree_, e, n) || re.EMPTY_NODE;
}
function o0(t, e = t.transactionQueueTree_) {
  if (e || hc(t, e), qo(e)) {
    const n = qy(t, e);
    V(n.length > 0, "Sending zero length transaction queue"), n.every(
      (i) => i.status === 0
      /* RUN */
    ) && zN(t, Bs(e), n);
  } else
    jy(e) && lc(e, (n) => {
      o0(t, n);
    });
}
function zN(t, e, n) {
  const r = n.map((f) => f.currentWriteId), i = Ky(t, e, r);
  let o = i;
  const a = i.hash();
  for (let f = 0; f < n.length; f++) {
    const c = n[f];
    V(c.status === 0, "tryToSendTransactionQueue_: items in queue should all be run."), c.status = 1, c.retryCount++;
    const u = Ot(e, c.path);
    o = o.updateChild(u, c.currentOutputSnapshotRaw);
  }
  const s = o.val(!0), l = e;
  t.server_.put(l.toString(), s, (f) => {
    Mo(t, "transaction put response", {
      path: l.toString(),
      status: f
    });
    let c = [];
    if (f === "ok") {
      const u = [];
      for (let d = 0; d < n.length; d++)
        n[d].status = 2, c = c.concat(wr(t.serverSyncTree_, n[d].currentWriteId)), n[d].onComplete && u.push(() => n[d].onComplete(null, !0, n[d].currentOutputSnapshotResolved)), n[d].unwatcher();
      hc(t, t0(t.transactionQueueTree_, e)), o0(t, t.transactionQueueTree_), An(t.eventQueue_, e, c);
      for (let d = 0; d < u.length; d++)
        Vo(u[d]);
    } else {
      if (f === "datastale")
        for (let u = 0; u < n.length; u++)
          n[u].status === 3 ? n[u].status = 4 : n[u].status = 0;
      else {
        Pt("transaction at " + l.toString() + " failed: " + f);
        for (let u = 0; u < n.length; u++)
          n[u].status = 4, n[u].abortReason = f;
      }
      Ao(t, e);
    }
  }, a);
}
function Ao(t, e) {
  const n = Yy(t, e), r = Bs(n), i = qy(t, n);
  return BN(t, i, r), r;
}
function BN(t, e, n) {
  if (e.length === 0)
    return;
  const r = [];
  let i = [];
  const a = e.filter((s) => s.status === 0).map((s) => s.currentWriteId);
  for (let s = 0; s < e.length; s++) {
    const l = e[s], f = Ot(n, l.path);
    let c = !1, u;
    if (V(f !== null, "rerunTransactionsUnderNode_: relativePath should not be null."), l.status === 4)
      c = !0, u = l.abortReason, i = i.concat(wr(t.serverSyncTree_, l.currentWriteId, !0));
    else if (l.status === 0)
      if (l.retryCount >= SN)
        c = !0, u = "maxretry", i = i.concat(wr(t.serverSyncTree_, l.currentWriteId, !0));
      else {
        const d = Ky(t, l.path, a);
        l.currentInputSnapshot = d;
        const h = e[s].update(d.val());
        if (h !== void 0) {
          cc("transaction failed: Data returned ", h, l.path);
          let p = Je(h);
          typeof h == "object" && h != null && qn(h, ".priority") || (p = p.updatePriority(d.getPriority()));
          const v = l.currentWriteId, b = dc(t), k = $y(p, d, b);
          l.currentOutputSnapshotRaw = p, l.currentOutputSnapshotResolved = k, l.currentWriteId = i0(t), a.splice(a.indexOf(v), 1), i = i.concat(My(t.serverSyncTree_, l.path, k, l.currentWriteId, l.applyLocally)), i = i.concat(wr(t.serverSyncTree_, v, !0));
        } else
          c = !0, u = "nodata", i = i.concat(wr(t.serverSyncTree_, l.currentWriteId, !0));
      }
    An(t.eventQueue_, n, i), i = [], c && (e[s].status = 2, function(d) {
      setTimeout(d, Math.floor(0));
    }(e[s].unwatcher), e[s].onComplete && (u === "nodata" ? r.push(() => e[s].onComplete(null, !1, e[s].currentInputSnapshot)) : r.push(() => e[s].onComplete(new Error(u), !1, null))));
  }
  hc(t, t.transactionQueueTree_);
  for (let s = 0; s < r.length; s++)
    Vo(r[s]);
  o0(t, t.transactionQueueTree_);
}
function Yy(t, e) {
  let n, r = t.transactionQueueTree_;
  for (n = pe(e); n !== null && qo(r) === void 0; )
    r = t0(r, n), e = Re(e), n = pe(e);
  return r;
}
function qy(t, e) {
  const n = [];
  return Gy(t, e, n), n.sort((r, i) => r.order - i.order), n;
}
function Gy(t, e, n) {
  const r = qo(e);
  if (r)
    for (let i = 0; i < r.length; i++)
      n.push(r[i]);
  lc(e, (i) => {
    Gy(t, i, n);
  });
}
function hc(t, e) {
  const n = qo(e);
  if (n) {
    let r = 0;
    for (let i = 0; i < n.length; i++)
      n[i].status !== 2 && (n[r] = n[i], r++);
    n.length = r, Fy(e, n.length > 0 ? n : void 0);
  }
  lc(e, (r) => {
    hc(t, r);
  });
}
function a0(t, e) {
  const n = Bs(Yy(t, e)), r = t0(t.transactionQueueTree_, e);
  return gN(r, (i) => {
    Lu(t, i);
  }), Lu(t, r), zy(r, (i) => {
    Lu(t, i);
  }), n;
}
function Lu(t, e) {
  const n = qo(e);
  if (n) {
    const r = [];
    let i = [], o = -1;
    for (let a = 0; a < n.length; a++)
      n[a].status === 3 || (n[a].status === 1 ? (V(o === a - 1, "All SENT items should be at beginning of queue."), o = a, n[a].status = 3, n[a].abortReason = "set") : (V(n[a].status === 0, "Unexpected transaction status in abort"), n[a].unwatcher(), i = i.concat(wr(t.serverSyncTree_, n[a].currentWriteId, !0)), n[a].onComplete && r.push(n[a].onComplete.bind(null, new Error("set"), !1, null))));
    o === -1 ? Fy(e, void 0) : n.length = o + 1, An(t.eventQueue_, Bs(e), i);
    for (let a = 0; a < r.length; a++)
      Vo(r[a]);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function WN(t) {
  let e = "";
  const n = t.split("/");
  for (let r = 0; r < n.length; r++)
    if (n[r].length > 0) {
      let i = n[r];
      try {
        i = decodeURIComponent(i.replace(/\+/g, " "));
      } catch {
      }
      e += "/" + i;
    }
  return e;
}
function UN(t) {
  const e = {};
  t.charAt(0) === "?" && (t = t.substring(1));
  for (const n of t.split("&")) {
    if (n.length === 0)
      continue;
    const r = n.split("=");
    r.length === 2 ? e[decodeURIComponent(r[0])] = decodeURIComponent(r[1]) : Pt(`Invalid query segment '${n}' in query '${t}'`);
  }
  return e;
}
const Zp = function(t, e) {
  const n = HN(t), r = n.namespace;
  n.domain === "firebase.com" && vi(n.host + " is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead"), (!r || r === "undefined") && n.domain !== "localhost" && vi("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com"), n.secure || YS();
  const i = n.scheme === "ws" || n.scheme === "wss";
  return {
    repoInfo: new iI(
      n.host,
      n.secure,
      r,
      i,
      e,
      /*persistenceKey=*/
      "",
      /*includeNamespaceInQueryParams=*/
      r !== n.subdomain
    ),
    path: new Ne(n.pathString)
  };
}, HN = function(t) {
  let e = "", n = "", r = "", i = "", o = "", a = !0, s = "https", l = 443;
  if (typeof t == "string") {
    let f = t.indexOf("//");
    f >= 0 && (s = t.substring(0, f - 1), t = t.substring(f + 2));
    let c = t.indexOf("/");
    c === -1 && (c = t.length);
    let u = t.indexOf("?");
    u === -1 && (u = t.length), e = t.substring(0, Math.min(c, u)), c < u && (i = WN(t.substring(c, u)));
    const d = UN(t.substring(Math.min(t.length, u)));
    f = e.indexOf(":"), f >= 0 ? (a = s === "https" || s === "wss", l = parseInt(e.substring(f + 1), 10)) : f = e.length;
    const h = e.slice(0, f);
    if (h.toLowerCase() === "localhost")
      n = "localhost";
    else if (h.split(".").length <= 2)
      n = h;
    else {
      const p = e.indexOf(".");
      r = e.substring(0, p).toLowerCase(), n = e.substring(p + 1), o = r;
    }
    "ns" in d && (o = d.ns);
  }
  return {
    host: e,
    port: l,
    domain: n,
    subdomain: r,
    secure: a,
    scheme: s,
    pathString: i,
    namespace: o
  };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Qy {
  /**
   * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
   * @param eventRegistration - The function to call to with the event data. User provided
   * @param snapshot - The data backing the event
   * @param prevName - Optional, the name of the previous child for child_* events.
   */
  constructor(e, n, r, i) {
    this.eventType = e, this.eventRegistration = n, this.snapshot = r, this.prevName = i;
  }
  getPath() {
    const e = this.snapshot.ref;
    return this.eventType === "value" ? e._path : e.parent._path;
  }
  getEventType() {
    return this.eventType;
  }
  getEventRunner() {
    return this.eventRegistration.getEventRunner(this);
  }
  toString() {
    return this.getPath().toString() + ":" + this.eventType + ":" + rt(this.snapshot.exportVal());
  }
}
class Xy {
  constructor(e, n, r) {
    this.eventRegistration = e, this.error = n, this.path = r;
  }
  getPath() {
    return this.path;
  }
  getEventType() {
    return "cancel";
  }
  getEventRunner() {
    return this.eventRegistration.getEventRunner(this);
  }
  toString() {
    return this.path.toString() + ":cancel";
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class VN {
  constructor(e, n) {
    this.snapshotCallback = e, this.cancelCallback = n;
  }
  onValue(e, n) {
    this.snapshotCallback.call(null, e, n);
  }
  onCancel(e) {
    return V(this.hasCancelCallback, "Raising a cancel event on a listener with no cancel callback"), this.cancelCallback.call(null, e);
  }
  get hasCancelCallback() {
    return !!this.cancelCallback;
  }
  matches(e) {
    return this.snapshotCallback === e.snapshotCallback || this.snapshotCallback.userCallback !== void 0 && this.snapshotCallback.userCallback === e.snapshotCallback.userCallback && this.snapshotCallback.context === e.snapshotCallback.context;
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class KN {
  /** @hideconstructor */
  constructor(e, n) {
    this._repo = e, this._path = n;
  }
  /**
   * Cancels all previously queued `onDisconnect()` set or update events for this
   * location and all children.
   *
   * If a write has been queued for this location via a `set()` or `update()` at a
   * parent location, the write at this location will be canceled, though writes
   * to sibling locations will still occur.
   *
   * @returns Resolves when synchronization to the server is complete.
   */
  cancel() {
    const e = new Fn();
    return RN(this._repo, this._path, e.wrapCallback(() => {
    })), e.promise;
  }
  /**
   * Ensures the data at this location is deleted when the client is disconnected
   * (due to closing the browser, navigating to a new page, or network issues).
   *
   * @returns Resolves when synchronization to the server is complete.
   */
  remove() {
    ni("OnDisconnect.remove", this._path);
    const e = new Fn();
    return Xp(this._repo, this._path, null, e.wrapCallback(() => {
    })), e.promise;
  }
  /**
   * Ensures the data at this location is set to the specified value when the
   * client is disconnected (due to closing the browser, navigating to a new page,
   * or network issues).
   *
   * `set()` is especially useful for implementing "presence" systems, where a
   * value should be changed or cleared when a user disconnects so that they
   * appear "offline" to other users. See
   * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
   * for more information.
   *
   * Note that `onDisconnect` operations are only triggered once. If you want an
   * operation to occur each time a disconnect occurs, you'll need to re-establish
   * the `onDisconnect` operations each time.
   *
   * @param value - The value to be written to this location on disconnect (can
   * be an object, array, string, number, boolean, or null).
   * @returns Resolves when synchronization to the Database is complete.
   */
  set(e) {
    ni("OnDisconnect.set", this._path), hs("OnDisconnect.set", e, this._path, !1);
    const n = new Fn();
    return Xp(this._repo, this._path, e, n.wrapCallback(() => {
    })), n.promise;
  }
  /**
   * Ensures the data at this location is set to the specified value and priority
   * when the client is disconnected (due to closing the browser, navigating to a
   * new page, or network issues).
   *
   * @param value - The value to be written to this location on disconnect (can
   * be an object, array, string, number, boolean, or null).
   * @param priority - The priority to be written (string, number, or null).
   * @returns Resolves when synchronization to the Database is complete.
   */
  setWithPriority(e, n) {
    ni("OnDisconnect.setWithPriority", this._path), hs("OnDisconnect.setWithPriority", e, this._path, !1), _N("OnDisconnect.setWithPriority", n, !1);
    const r = new Fn();
    return LN(this._repo, this._path, e, n, r.wrapCallback(() => {
    })), r.promise;
  }
  /**
   * Writes multiple values at this location when the client is disconnected (due
   * to closing the browser, navigating to a new page, or network issues).
   *
   * The `values` argument contains multiple property-value pairs that will be
   * written to the Database together. Each child property can either be a simple
   * property (for example, "name") or a relative path (for example, "name/first")
   * from the current location to the data to update.
   *
   * As opposed to the `set()` method, `update()` can be use to selectively update
   * only the referenced properties at the current location (instead of replacing
   * all the child properties at the current location).
   *
   * @param values - Object containing multiple values.
   * @returns Resolves when synchronization to the Database is complete.
   */
  update(e) {
    ni("OnDisconnect.update", this._path), Wy("OnDisconnect.update", e, this._path, !1);
    const n = new Fn();
    return $N(this._repo, this._path, e, n.wrapCallback(() => {
    })), n.promise;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ai {
  /**
   * @hideconstructor
   */
  constructor(e, n, r, i) {
    this._repo = e, this._path = n, this._queryParams = r, this._orderByCalled = i;
  }
  get key() {
    return me(this._path) ? null : Oh(this._path);
  }
  get ref() {
    return new Gn(this._repo, this._path);
  }
  get _queryIdentifier() {
    const e = Lp(this._queryParams), n = Ih(e);
    return n === "{}" ? "default" : n;
  }
  /**
   * An object representation of the query parameters used by this Query.
   */
  get _queryObject() {
    return Lp(this._queryParams);
  }
  isEqual(e) {
    if (e = gn(e), !(e instanceof Ai))
      return !1;
    const n = this._repo === e._repo, r = Dh(this._path, e._path), i = this._queryIdentifier === e._queryIdentifier;
    return n && r && i;
  }
  toJSON() {
    return this.toString();
  }
  toString() {
    return this._repo.toString() + MI(this._path);
  }
}
function Jy(t, e) {
  if (t._orderByCalled === !0)
    throw new Error(e + ": You can't combine multiple orderBy calls.");
}
function s0(t) {
  let e = null, n = null;
  if (t.hasStart() && (e = t.getIndexStartValue()), t.hasEnd() && (n = t.getIndexEndValue()), t.getIndex() === dr) {
    const r = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().", i = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
    if (t.hasStart()) {
      if (t.getIndexStartName() !== bi)
        throw new Error(r);
      if (typeof e != "string")
        throw new Error(i);
    }
    if (t.hasEnd()) {
      if (t.getIndexEndName() !== Vn)
        throw new Error(r);
      if (typeof n != "string")
        throw new Error(i);
    }
  } else if (t.getIndex() === qe) {
    if (e != null && !mf(e) || n != null && !mf(n))
      throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
  } else if (V(t.getIndex() instanceof Lh || t.getIndex() === gy, "unknown index type."), e != null && typeof e == "object" || n != null && typeof n == "object")
    throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
}
function YN(t) {
  if (t.hasStart() && t.hasEnd() && t.hasLimit() && !t.hasAnchoredLimit())
    throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
class Gn extends Ai {
  /** @hideconstructor */
  constructor(e, n) {
    super(e, n, new Fh(), !1);
  }
  get parent() {
    const e = sy(this._path);
    return e === null ? null : new Gn(this._repo, e);
  }
  get root() {
    let e = this;
    for (; e.parent !== null; )
      e = e.parent;
    return e;
  }
}
class Oo {
  /**
   * @param _node - A SnapshotNode to wrap.
   * @param ref - The location this snapshot came from.
   * @param _index - The iteration order for this snapshot
   * @hideconstructor
   */
  constructor(e, n, r) {
    this._node = e, this.ref = n, this._index = r;
  }
  /**
   * Gets the priority value of the data in this `DataSnapshot`.
   *
   * Applications need not use priority but can order collections by
   * ordinary properties (see
   * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
   * ).
   */
  get priority() {
    return this._node.getPriority().val();
  }
  /**
   * The key (last part of the path) of the location of this `DataSnapshot`.
   *
   * The last token in a Database location is considered its key. For example,
   * "ada" is the key for the /users/ada/ node. Accessing the key on any
   * `DataSnapshot` will return the key for the location that generated it.
   * However, accessing the key on the root URL of a Database will return
   * `null`.
   */
  get key() {
    return this.ref.key;
  }
  /** Returns the number of child properties of this `DataSnapshot`. */
  get size() {
    return this._node.numChildren();
  }
  /**
   * Gets another `DataSnapshot` for the location at the specified relative path.
   *
   * Passing a relative path to the `child()` method of a DataSnapshot returns
   * another `DataSnapshot` for the location at the specified relative path. The
   * relative path can either be a simple child name (for example, "ada") or a
   * deeper, slash-separated path (for example, "ada/name/first"). If the child
   * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
   * whose value is `null`) is returned.
   *
   * @param path - A relative path to the location of child data.
   */
  child(e) {
    const n = new Ne(e), r = Do(this.ref, e);
    return new Oo(this._node.getChild(n), r, qe);
  }
  /**
   * Returns true if this `DataSnapshot` contains any data. It is slightly more
   * efficient than using `snapshot.val() !== null`.
   */
  exists() {
    return !this._node.isEmpty();
  }
  /**
   * Exports the entire contents of the DataSnapshot as a JavaScript object.
   *
   * The `exportVal()` method is similar to `val()`, except priority information
   * is included (if available), making it suitable for backing up your data.
   *
   * @returns The DataSnapshot's contents as a JavaScript value (Object,
   *   Array, string, number, boolean, or `null`).
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  exportVal() {
    return this._node.val(!0);
  }
  /**
   * Enumerates the top-level children in the `DataSnapshot`.
   *
   * Because of the way JavaScript objects work, the ordering of data in the
   * JavaScript object returned by `val()` is not guaranteed to match the
   * ordering on the server nor the ordering of `onChildAdded()` events. That is
   * where `forEach()` comes in handy. It guarantees the children of a
   * `DataSnapshot` will be iterated in their query order.
   *
   * If no explicit `orderBy*()` method is used, results are returned
   * ordered by key (unless priorities are used, in which case, results are
   * returned by priority).
   *
   * @param action - A function that will be called for each child DataSnapshot.
   * The callback can return true to cancel further enumeration.
   * @returns true if enumeration was canceled due to your callback returning
   * true.
   */
  forEach(e) {
    return this._node.isLeafNode() ? !1 : !!this._node.forEachChild(this._index, (r, i) => e(new Oo(i, Do(this.ref, r), qe)));
  }
  /**
   * Returns true if the specified child path has (non-null) data.
   *
   * @param path - A relative path to the location of a potential child.
   * @returns `true` if data exists at the specified child path; else
   *  `false`.
   */
  hasChild(e) {
    const n = new Ne(e);
    return !this._node.getChild(n).isEmpty();
  }
  /**
   * Returns whether or not the `DataSnapshot` has any non-`null` child
   * properties.
   *
   * You can use `hasChildren()` to determine if a `DataSnapshot` has any
   * children. If it does, you can enumerate them using `forEach()`. If it
   * doesn't, then either this snapshot contains a primitive value (which can be
   * retrieved with `val()`) or it is empty (in which case, `val()` will return
   * `null`).
   *
   * @returns true if this snapshot has any children; else false.
   */
  hasChildren() {
    return this._node.isLeafNode() ? !1 : !this._node.isEmpty();
  }
  /**
   * Returns a JSON-serializable representation of this object.
   */
  toJSON() {
    return this.exportVal();
  }
  /**
   * Extracts a JavaScript value from a `DataSnapshot`.
   *
   * Depending on the data in a `DataSnapshot`, the `val()` method may return a
   * scalar type (string, number, or boolean), an array, or an object. It may
   * also return null, indicating that the `DataSnapshot` is empty (contains no
   * data).
   *
   * @returns The DataSnapshot's contents as a JavaScript value (Object,
   *   Array, string, number, boolean, or `null`).
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  val() {
    return this._node.val();
  }
}
function qN(t, e) {
  return t = gn(t), t._checkNotDeleted("ref"), e !== void 0 ? Do(t._root, e) : t._root;
}
function Do(t, e) {
  return t = gn(t), pe(t._path) === null ? kN("child", "path", e, !1) : n0("child", "path", e, !1), new Gn(t._repo, Ge(t._path, e));
}
function GN(t) {
  return t = gn(t), new KN(t._repo, t._path);
}
function $u(t, e) {
  t = gn(t), ni("push", t._path), hs("push", e, t._path, !0);
  const n = Vy(t._repo), r = JI(n), i = Do(t, r), o = Do(t, r);
  let a;
  return e != null ? a = vf(o, e).then(() => o) : a = Promise.resolve(o), i.then = a.then.bind(a), i.catch = a.then.bind(a, void 0), i;
}
function QN(t) {
  return ni("remove", t._path), vf(t, null);
}
function vf(t, e) {
  t = gn(t), ni("set", t._path), hs("set", e, t._path, !1);
  const n = new Fn();
  return ON(
    t._repo,
    t._path,
    e,
    /*priority=*/
    null,
    n.wrapCallback(() => {
    })
  ), n.promise;
}
function sl(t, e) {
  Wy("update", e, t._path, !1);
  const n = new Fn();
  return DN(t._repo, t._path, e, n.wrapCallback(() => {
  })), n.promise;
}
function lr(t) {
  return t = gn(t), AN(t._repo, t).then((e) => new Oo(e, new Gn(t._repo, t._path), t._queryParams.getIndex()));
}
class l0 {
  constructor(e) {
    this.callbackContext = e;
  }
  respondsTo(e) {
    return e === "value";
  }
  createEvent(e, n) {
    const r = n._queryParams.getIndex();
    return new Qy("value", this, new Oo(e.snapshotNode, new Gn(n._repo, n._path), r));
  }
  getEventRunner(e) {
    return e.getEventType() === "cancel" ? () => this.callbackContext.onCancel(e.error) : () => this.callbackContext.onValue(e.snapshot, null);
  }
  createCancelEvent(e, n) {
    return this.callbackContext.hasCancelCallback ? new Xy(this, e, n) : null;
  }
  matches(e) {
    return e instanceof l0 ? !e.callbackContext || !this.callbackContext ? !0 : e.callbackContext.matches(this.callbackContext) : !1;
  }
  hasAnyCallback() {
    return this.callbackContext !== null;
  }
}
class f0 {
  constructor(e, n) {
    this.eventType = e, this.callbackContext = n;
  }
  respondsTo(e) {
    let n = e === "children_added" ? "child_added" : e;
    return n = n === "children_removed" ? "child_removed" : n, this.eventType === n;
  }
  createCancelEvent(e, n) {
    return this.callbackContext.hasCancelCallback ? new Xy(this, e, n) : null;
  }
  createEvent(e, n) {
    V(e.childName != null, "Child events should have a childName.");
    const r = Do(new Gn(n._repo, n._path), e.childName), i = n._queryParams.getIndex();
    return new Qy(e.type, this, new Oo(e.snapshotNode, r, i), e.prevName);
  }
  getEventRunner(e) {
    return e.getEventType() === "cancel" ? () => this.callbackContext.onCancel(e.error) : () => this.callbackContext.onValue(e.snapshot, e.prevName);
  }
  matches(e) {
    return e instanceof f0 ? this.eventType === e.eventType && (!this.callbackContext || !e.callbackContext || this.callbackContext.matches(e.callbackContext)) : !1;
  }
  hasAnyCallback() {
    return !!this.callbackContext;
  }
}
function Ws(t, e, n, r, i) {
  let o;
  if (typeof r == "object" && (o = void 0, i = r), typeof r == "function" && (o = r), i && i.onlyOnce) {
    const l = n, f = (c, u) => {
      Jp(t._repo, t, s), l(c, u);
    };
    f.userCallback = n.userCallback, f.context = n.context, n = f;
  }
  const a = new VN(n, o || void 0), s = e === "value" ? new l0(a) : new f0(e, a);
  return FN(t._repo, t, s), () => Jp(t._repo, t, s);
}
function gc(t, e, n, r) {
  return Ws(t, "value", e, n, r);
}
function oi(t, e, n, r) {
  return Ws(t, "child_added", e, n, r);
}
function Zy(t, e, n, r) {
  return Ws(t, "child_changed", e, n, r);
}
function em(t, e, n, r) {
  return Ws(t, "child_moved", e, n, r);
}
function e_(t, e, n, r) {
  return Ws(t, "child_removed", e, n, r);
}
class pc {
}
class XN extends pc {
  constructor(e, n) {
    super(), this._value = e, this._key = n;
  }
  _apply(e) {
    hs("startAfter", this._value, e._path, !1);
    const n = r9(e._queryParams, this._value, this._key);
    if (YN(n), s0(n), e._queryParams.hasStart())
      throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
    return new Ai(e._repo, e._path, n, e._orderByCalled);
  }
}
function JN(t, e) {
  return wN("startAfter", "key", e, !0), new XN(t, e);
}
class ZN extends pc {
  constructor(e) {
    super(), this._limit = e;
  }
  _apply(e) {
    if (e._queryParams.hasLimit())
      throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
    return new Ai(e._repo, e._path, n9(e._queryParams, this._limit), e._orderByCalled);
  }
}
function tm(t) {
  if (typeof t != "number" || Math.floor(t) !== t || t <= 0)
    throw new Error("limitToLast: First argument must be a positive integer.");
  return new ZN(t);
}
class eM extends pc {
  constructor(e) {
    super(), this._path = e;
  }
  _apply(e) {
    Jy(e, "orderByChild");
    const n = new Ne(this._path);
    if (me(n))
      throw new Error("orderByChild: cannot pass in empty path. Use orderByValue() instead.");
    const r = new Lh(n), i = my(e._queryParams, r);
    return s0(i), new Ai(
      e._repo,
      e._path,
      i,
      /*orderByCalled=*/
      !0
    );
  }
}
function nm(t) {
  if (t === "$key")
    throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
  if (t === "$priority")
    throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
  if (t === "$value")
    throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
  return n0("orderByChild", "path", t, !1), new eM(t);
}
class tM extends pc {
  _apply(e) {
    Jy(e, "orderByKey");
    const n = my(e._queryParams, dr);
    return s0(n), new Ai(
      e._repo,
      e._path,
      n,
      /*orderByCalled=*/
      !0
    );
  }
}
function rm() {
  return new tM();
}
function gs(t, ...e) {
  let n = gn(t);
  for (const r of e)
    n = r._apply(n);
  return n;
}
V9(Gn);
Q9(Gn);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const nM = "FIREBASE_DATABASE_EMULATOR_HOST", n1 = {};
let rM = !1;
function iM(t, e, n, r, i) {
  let o = r || t.options.databaseURL;
  o === void 0 && (t.options.projectId || vi("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp()."), ht("Using default host for project ", t.options.projectId), o = `${t.options.projectId}-default-rtdb.firebaseio.com`);
  let a = Zp(o, i), s = a.repoInfo, l, f;
  typeof process < "u" && process.env && (f = process.env[nM]), f ? (l = !0, o = `http://${f}?ns=${s.namespace}`, a = Zp(o, i), s = a.repoInfo) : l = !a.repoInfo.secure;
  const c = i && l ? new Vd(Vd.OWNER) : new rI(t.name, t.options, e);
  CN("Invalid Firebase Database URL", a), me(a.path) || vi("Database URL must point to the root of a Firebase Database (not including a child path).");
  const u = aM(s, t, c, new nI(t.name, n));
  return new sM(u, t);
}
function oM(t, e) {
  const n = n1[e];
  (!n || n[t.key] !== t) && vi(`Database ${e}(${t.repoInfo_}) has already been deleted.`), jN(t), delete n[t.key];
}
function aM(t, e, n, r) {
  let i = n1[e.name];
  i || (i = {}, n1[e.name] = i);
  let o = i[t.toURLString()];
  return o && vi("Database initialized multiple times. Please make sure the format of the database URL matches with each database() call."), o = new IN(t, rM, n, r), i[t.toURLString()] = o, o;
}
class sM {
  /** @hideconstructor */
  constructor(e, n) {
    this._repoInternal = e, this.app = n, this.type = "database", this._instanceStarted = !1;
  }
  get _repo() {
    return this._instanceStarted || (NN(this._repoInternal, this.app.options.appId, this.app.options.databaseAuthVariableOverride), this._instanceStarted = !0), this._repoInternal;
  }
  get _root() {
    return this._rootInternal || (this._rootInternal = new Gn(this._repo, Te())), this._rootInternal;
  }
  _delete() {
    return this._rootInternal !== null && (oM(this._repo, this.app.name), this._repoInternal = null, this._rootInternal = null), Promise.resolve();
  }
  _checkNotDeleted(e) {
    this._rootInternal === null && vi("Cannot call " + e + " on a deleted database.");
  }
}
function lM(t = kh(), e) {
  return pb(t, "database").getImmediate({
    identifier: e
  });
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function fM(t) {
  WS(wh), xo(new gi(
    "database",
    (e, { instanceIdentifier: n }) => {
      const r = e.getProvider("app").getImmediate(), i = e.getProvider("auth-internal"), o = e.getProvider("app-check-internal");
      return iM(r, i, o, n);
    },
    "PUBLIC"
    /* PUBLIC */
  ).setMultipleInstances(!0)), Tr(vp, bp, t), Tr(vp, bp, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const cM = {
  ".sv": "timestamp"
};
function t_() {
  return cM;
}
ur.prototype.simpleListen = function(t, e) {
  this.sendRequest("q", { p: t }, e);
};
ur.prototype.echo = function(t, e) {
  this.sendRequest("echo", { d: t }, e);
};
fM();
function ae(t, ...e) {
  const n = n_(t, ...e);
  return qN(lM(kh("CollabKit")), n);
}
function n_(t, ...e) {
  return e.reduce(
    (n, r, i) => n + gh(r) + t[i + 1],
    t[0]
  );
}
ae.path = n_;
async function uM(t) {
  const { appId: e, userId: n, workspaceId: r, threadId: i, subs: o } = t, a = `isTyping-${r}/${i}`, s = `${a}-added`, l = `${a}-removed`;
  if (o[s] && o[l])
    return;
  n && await GN(ae`/isTyping/${e}/${r}/${i}/${n}`).remove();
  const f = ae`/isTyping/${e}/${r}/${i}`;
  try {
    o[s] = oi(f, (c) => {
      const u = c.key && gt(c.key);
      u && t.onThreadTypingChange({
        threadId: i,
        workspaceId: r,
        userId: u,
        isTyping: !0
      });
    }), o[l] = e_(f, (c) => {
      const u = c.key && gt(c.key);
      u && t.onThreadTypingChange({
        threadId: i,
        workspaceId: r,
        userId: u,
        isTyping: !1
      });
    });
  } catch (c) {
    console.error(c);
  }
}
const r_ = {
  amber: "hsla(41, 95%, 66%, 1)",
  blue: "hsla(211, 94%, 62%, 1)",
  brown: "hsla(28, 36%, 54%, 1)",
  crimson: "hsla(342, 70%, 62%, 1)",
  cyan: "hsla(192, 55%, 50%, 1)",
  grass: "hsla(124, 30%, 53%, 1)",
  green: "hsla(146, 34%, 49%, 1)",
  indigo: "hsla(225, 70%, 59%, 1)",
  lime: "hsla(74, 78%, 64%, 1)",
  mint: "hsla(162, 71%, 78%, 1)",
  orange: "hsla(23, 90%, 60%, 1)",
  pink: "hsla(325, 60%, 59%, 1)",
  plum: "hsla(291, 43%, 55%, 1)",
  purple: "hsla(268, 50%, 58%, 1)",
  red: "hsla(2, 73%, 62%, 1)",
  sky: "hsla(194, 96%, 78%, 1)",
  teal: "hsla(173, 45%, 46%, 1)",
  tomato: "hsla(11, 71%, 58%, 1)",
  violet: "hsla(11, 71%, 58%, 1)",
  yellow: "hsla(52, 100%, 71%, 1)"
};
function i_(t) {
  return t != null && typeof t == "string" && t in r_;
}
function c0() {
  const t = Object.keys(r_);
  return t[Math.floor(Math.random() * t.length)];
}
function o_(t) {
  return t ? t.reduce((e, n) => (e[gh(n)] = !0, e), {}) : null;
}
function dM(t) {
  const { attachments: e } = t;
  let n = null;
  if (e) {
    n = {};
    for (const i in e) {
      const o = e[i];
      switch (o.type) {
        case "pin":
          n[i] = {
            type: o.type,
            x: o.x,
            y: o.y,
            objectId: o.objectId,
            meta: o.meta
          };
      }
    }
  }
  return {
    type: t.type,
    body: t.body,
    system: t.system ?? null,
    createdById: gh(t.createdById),
    mentions: o_(t.mentions),
    parentId: t.parentId ?? null,
    createdAt: t.createdAt,
    attachments: n
  };
}
function a_(t, e = t.key) {
  const n = t.val();
  return !n || !e ? (console.warn("[snapshotToEvent]: could not convert snapshot", n), null) : (n.id = gt(e), n.createdById = gt(n.createdById), n.mentions = Object.keys(n.mentions ?? {}).map((r) => gt(r)), n);
}
function hM(t) {
  const e = t.val();
  return !e || !t.key ? (console.warn("[snapshotToUser]: could not convert snapshot", e), null) : (e.userId = gt(t.key), e);
}
function Ba(t) {
  const e = t.val();
  return !e || !t.key ? (console.warn("[snapshotToProfile]: could not convert snapshot", e), null) : (e.id = gt(t.key), i_(e.color) || (e.color = c0()), e);
}
function s_(t) {
  var o, a, s;
  const e = a_(t);
  if (!e)
    return null;
  const n = e.id, r = (a = (o = t.ref.parent) == null ? void 0 : o.ref.parent) == null ? void 0 : a.key, i = (s = t.ref.parent) == null ? void 0 : s.key;
  return !n || !r || !i ? null : {
    threadId: i,
    workspaceId: r,
    eventId: n,
    event: e
  };
}
function gM(t, e) {
  const n = s_(t);
  n && e(n);
}
async function pM({
  subs: t,
  ...e
}) {
  var p, m;
  const { appId: n, workspaceId: r, threadId: i } = e, o = gs(
    ae`/timeline/${n}/${r}/${i}`,
    // this is going to cause problems on larger threads...
    // todo: add pagination
    // limitToLast(50),
    // to add pagination we also need to store computed reactions, edits and isResolved
    // in firebase so we don't need access to the entire event list to render the timeline
    rm()
  ), a = ae`/views/isOpen/${n}/${r}/${i}`, s = ae`/views/threadProfiles/${n}/${r}/${i}`, l = await Promise.allSettled([
    lr(o),
    lr(s),
    lr(a)
  ]);
  let f = null;
  if (l[1].status === "fulfilled") {
    const v = l[1].value.val();
    v && e.onThreadProfiles({
      threadId: i,
      workspaceId: r,
      profiles: v
    });
  } else
    console.error("get threadProfiles", l[1].reason);
  const c = l[2].status === "fulfilled" ? l[2].value.val() : !1, u = [];
  l[0].status === "fulfilled" ? l[0].value.forEach((v) => {
    f = v.key;
    const b = s_(v);
    b && u.push(b);
  }) : console.error("get timeline", l[0].reason);
  const d = [rm()];
  f && d.push(JN(f));
  const h = gs(
    ae`/timeline/${n}/${r}/${i}`,
    ...d
  );
  if ((p = e.onTimelineGetComplete) == null || p.call(e, u), (m = e.onThreadResolveChange) == null || m.call(e, { threadId: i, workspaceId: r, isResolved: !c }), t[s.toString()] || (t[s.toString()] = oi(s, (v) => {
    v.key && e.onThreadProfile({
      threadId: i,
      workspaceId: r,
      userId: gt(v.key)
    });
  })), t[a.toString()] || (t[s.toString()] = gc(a, (v) => {
    var b;
    (b = e.onThreadResolveChange) == null || b.call(e, {
      threadId: i,
      workspaceId: r,
      isResolved: !v.exists()
    });
  })), !t[o.toString()])
    try {
      t[o.toString()] = oi(h, (v) => {
        gM(v, e.onTimelineEventAdded);
      });
    } catch (v) {
      console.error("onChildAdded", v);
    }
}
function mM(t, e) {
  const n = new Set(Object.keys(t)), r = new Set(Object.keys(e)), i = new Set([...n].filter((a) => !r.has(a))), o = new Set([...r].filter((a) => !n.has(a)));
  return { removed: i, added: o };
}
function vM(t = { test: !1 }) {
  wT(
    t.test ? {
      apiKey: "AIzaSyBj5LhfGbP_UrXYOTzJK5e70iZuI-itsxc",
      authDomain: "collabkit-test.firebaseapp.com",
      databaseURL: "https://collabkit-test-default-rtdb.europe-west1.firebasedatabase.app",
      projectId: "collabkit-test",
      storageBucket: "collabkit-test.appspot.com",
      messagingSenderId: "847051916849",
      appId: "1:847051916849:web:417a95d387d2e3d8f57710"
    } : {
      apiKey: "AIzaSyDYl8MwTEgsIzXO7EHgBlvuN5BLVJqPZ6k",
      authDomain: "collabkit-dev.firebaseapp.com",
      databaseURL: "https://collabkit-dev-default-rtdb.europe-west1.firebasedatabase.app",
      projectId: "collabkit-dev",
      storageBucket: "collabkit-dev.appspot.com",
      messagingSenderId: "927079647438",
      appId: "1:927079647438:web:3535f7ba40a758167ee89f"
    },
    "CollabKit"
  );
}
const bM = !1, Xe = {
  addAttachment({
    appId: t,
    workspaceId: e,
    attachment: n,
    attachmentId: r,
    eventId: i,
    userId: o,
    threadId: a
  }) {
    const s = {};
    switch (n.type) {
      case "pin": {
        const l = r, { objectId: f, x: c, y: u, meta: d } = n;
        let h = !1;
        if (d === null)
          h = !0;
        else
          try {
            JSON.parse(d), h = !0;
          } catch {
            h = !1;
          }
        if (!h)
          throw new Error("Invalid meta data for pin");
        const p = {
          x: c,
          y: u,
          eventId: i,
          threadId: a,
          createdById: o,
          meta: d
        };
        s[ae.path`/views/openPins/${t}/${e}/${f}/${l}`] = p;
      }
    }
    return s;
  },
  removeAttachment({
    appId: t,
    workspaceId: e,
    attachment: n,
    attachmentId: r
  }) {
    const i = {};
    switch (n.type) {
      case "pin": {
        const o = r, { objectId: a } = n;
        i[ae.path`/views/openPins/${t}/${e}/${a}/${o}`] = null;
      }
    }
    return i;
  },
  updateEventAttachments({
    eventId: t,
    appId: e,
    workspaceId: n,
    threadId: r,
    userId: i,
    event: o
  }) {
    let a = {};
    if (o.attachments)
      for (const s in o.attachments) {
        const l = o.attachments[s];
        a = {
          ...a,
          ...Xe.addAttachment({
            eventId: t,
            appId: e,
            workspaceId: n,
            threadId: r,
            userId: i,
            attachmentId: s,
            attachment: l
          })
        };
      }
    return a;
  },
  editEventAttachments({
    appId: t,
    workspaceId: e,
    event: n,
    parentEvent: r,
    userId: i,
    threadId: o,
    eventId: a,
    parentEventId: s
  }) {
    let l = {};
    const { added: f, removed: c } = mM(r.attachments ?? {}, n.attachments ?? {});
    return c.forEach((u) => {
      if (r.attachments) {
        const d = r.attachments[u];
        l = {
          ...l,
          ...Xe.removeAttachment({
            appId: t,
            workspaceId: e,
            userId: i,
            threadId: o,
            eventId: s,
            attachmentId: u,
            attachment: d
          })
        };
      }
    }), f.forEach((u) => {
      if (n.attachments) {
        const d = n.attachments[u];
        l = {
          ...l,
          ...Xe.addAttachment({
            appId: t,
            workspaceId: e,
            userId: i,
            threadId: o,
            eventId: a,
            attachmentId: u,
            attachment: d
          })
        };
      }
    }), l;
  },
  removeEventAttachments({
    appId: t,
    workspaceId: e,
    threadId: n,
    userId: r,
    event: i,
    eventId: o
  }) {
    let a = {};
    if (i.attachments)
      for (const s in i.attachments) {
        const l = i.attachments[s];
        a = {
          ...a,
          ...Xe.removeAttachment({
            appId: t,
            workspaceId: e,
            attachmentId: s,
            threadId: n,
            userId: r,
            attachment: l,
            eventId: o
          })
        };
      }
    return a;
  },
  removeThreadAttachments({
    appId: t,
    workspaceId: e,
    timeline: n,
    threadId: r,
    userId: i
  }) {
    return Object.values(n).reduce((o, a) => ({
      ...o,
      ...Xe.removeEventAttachments({
        event: a,
        workspaceId: e,
        appId: t,
        eventId: a.id,
        threadId: r,
        userId: i
      })
    }), {});
  },
  stopTyping({
    appId: t,
    workspaceId: e,
    threadId: n,
    userId: r
  }) {
    return {
      [ae.path`/isTyping/${t}/${e}/${n}/${r}`]: null
    };
  },
  seen({
    appId: t,
    workspaceId: e,
    threadId: n,
    userId: r,
    seenUntilId: i
  }) {
    const o = { seenUntilId: i, seenAt: t_() };
    return {
      [ae.path`/seen/${t}/${r}/${e}/${n}/`]: o,
      [ae.path`/views/seenBy/${t}/${e}/${n}/${r}`]: o
    };
  },
  resolve({
    appId: t,
    workspaceId: e,
    threadId: n
  }) {
    return {
      [ae.path`/views/isOpen/${t}/${e}/${n}`]: null,
      [ae.path`/views/isResolved/${t}/${e}/${n}`]: !0
    };
  },
  reopen({
    appId: t,
    workspaceId: e,
    threadId: n
  }) {
    return {
      [ae.path`/views/isOpen/${t}/${e}/${n}`]: !0,
      [ae.path`/views/isResolved/${t}/${e}/${n}`]: null
    };
  }
};
class yM {
  constructor(e = { test: !1 }) {
    vM(e);
  }
  nextPinId(e) {
    const { appId: n, objectId: r, workspaceId: i } = e, o = $u(ae`/pins/${n}/${i}/${r}`);
    if (!o.key)
      throw new Error("pinId is undefined");
    return o.key;
  }
  nextEventId(e) {
    const { appId: n, threadId: r, workspaceId: i } = e, o = $u(ae`/timeline/${n}/${i}/${r}`);
    if (!o.key)
      throw new Error("eventId is undefined");
    return o.key;
  }
  nextThreadId(e) {
    const { appId: n, workspaceId: r } = e, i = $u(ae`/timeline/${n}/${r}`);
    if (!i.key)
      throw new Error("threadId is undefined");
    return i.key;
  }
  async subscribeOpenPins(e) {
    var c, u, d;
    const { subs: n, appId: r, workspaceId: i, onObjectChange: o, onObjectAdded: a, onObjectRemove: s, onGet: l } = e, f = ae`/views/openPins/${r}/${i}`;
    await lr(f).then((h) => {
      const p = h.val();
      l(p || {});
    }).catch((h) => {
      console.error("CollabKit pin fetch failed", h);
    }), n[c = f.toString() + "onChildAdded"] || (n[c] = oi(
      f,
      (h) => {
        const p = h.key, m = h.val();
        p != null && a(gt(p), m);
      }
    )), n[u = f.toString() + "onChildChanged"] || (n[u] = Zy(
      f,
      (h) => {
        const p = h.key, m = h.val();
        p != null && o(gt(p), m);
      }
    )), n[d = f.toString() + "onChildRemoved"] || (n[d] = e_(
      f,
      (h) => {
        const p = h.key;
        p != null && s(gt(p));
      }
    ));
  }
  saveThreadInfo(e) {
    const { appId: n, workspaceId: r, threadId: i, info: o } = e, a = {
      [ae.path`/threadInfo/${n}/${r}/${i}`]: o ? {
        ...o,
        defaultSubscribers: o_(o.defaultSubscribers)
      } : null
    };
    return sl(ae`/`, a);
  }
  saveWorkspace(e) {
    return e.workspace && e.workspace.name && e.workspaceId !== "default" && // setting name to null deletes it
    (typeof e.workspace.name == "string" || e.workspace.name === null) ? vf(
      ae`/workspaces/${e.appId}/${e.workspaceId}/name/`,
      e.workspace.name
    ) : Promise.resolve();
  }
  shouldAuthenticate() {
    return !0;
  }
  serverTimestamp() {
    return t_();
  }
  async saveProfile(e) {
    const { appId: n, userId: r, workspaceId: i, profile: o } = e, a = {
      [ae.path`/profiles/${n}/${r}`]: o
    };
    i !== "default" && (a[ae.path`/views/workspaceProfiles/${n}/${i}/${r}`] = o, a[ae.path`/workspaces/${n}/${i}/profiles/${r}`] = !0);
    try {
      await sl(ae`/`, a);
    } catch (s) {
      console.error("CollabKit: failed to save profile", s);
    }
  }
  async getProfile(e) {
    const n = await lr(ae`/profiles/${e.appId}/${e.userId}`);
    return Ba(n);
  }
  async markSeen({
    appId: e,
    userId: n,
    workspaceId: r,
    threadId: i,
    eventId: o
  }) {
    await sl(
      ae`/`,
      Xe.seen({ appId: e, userId: n, workspaceId: r, threadId: i, seenUntilId: o })
    );
  }
  async startTyping({
    appId: e,
    userId: n,
    workspaceId: r,
    threadId: i
  }) {
    await vf(ae`/isTyping/${e}/${r}/${i}/${n}`, !0);
  }
  async stopTyping({
    appId: e,
    userId: n,
    workspaceId: r,
    threadId: i
  }) {
    await QN(ae`/isTyping/${e}/${r}/${i}/${n}`);
  }
  async getIsTyping({
    appId: e,
    userId: n,
    workspaceId: r,
    threadId: i
  }) {
    const o = await lr(ae`/isTyping/${e}/${r}/${i}/${n}`);
    return o.exists() ? o.val() : null;
  }
  async sendMessage({
    appId: e,
    userId: n,
    workspaceId: r,
    threadId: i,
    event: o,
    parentEvent: a,
    newEventId: s,
    timeline: l
  }) {
    const f = dM(o);
    let c = {};
    switch (o.type) {
      case "message":
        c = {
          ...c,
          ...Xe.updateEventAttachments({
            event: o,
            eventId: s,
            threadId: i,
            userId: n,
            workspaceId: r,
            appId: e
          }),
          ...Xe.reopen({ appId: e, workspaceId: r, threadId: i })
        }, c[ae.path`/views/inbox/${e}/${r}/${i}`] = {
          ...f,
          id: s,
          name: i
        };
        break;
      case "delete":
        if (!a)
          throw new Error("Cannot delete event without parent event");
        if (!o.parentId)
          throw new Error("Cannot delete event without parent id");
        const u = eb(l), d = u[u.length - 1], h = u.length === 1 && o.parentId == d.id, p = {
          ...f,
          type: "system",
          system: "resolve",
          parentId: null
        };
        c = {
          ...c,
          ...Xe.removeEventAttachments({
            event: a,
            workspaceId: r,
            appId: e,
            userId: n,
            threadId: i,
            eventId: o.parentId
          }),
          ...h ? {
            ...Xe.resolve({ appId: e, workspaceId: r, threadId: i }),
            ...Xe.removeThreadAttachments({
              appId: e,
              workspaceId: r,
              timeline: l,
              userId: n,
              threadId: i
            }),
            [ae.path`/timeline/${e}/${r}/${i}/${this.nextEventId({
              appId: e,
              workspaceId: r,
              threadId: i
            })}`]: p
          } : Xe.reopen({ appId: e, workspaceId: r, threadId: i })
        };
        break;
      case "edit":
        if (!a)
          throw new Error("Cannot edit event without parent event");
        if (!o.parentId)
          throw new Error("Cannot edit event without parent id");
        c = {
          ...c,
          ...Xe.editEventAttachments({
            event: o,
            eventId: s,
            threadId: i,
            userId: n,
            workspaceId: r,
            appId: e,
            parentEvent: a,
            parentEventId: o.parentId
          }),
          ...Xe.reopen({ appId: e, workspaceId: r, threadId: i })
        };
        break;
      case "adminMessage":
        c = {
          ...c,
          ...Xe.reopen({ appId: e, workspaceId: r, threadId: i })
        };
        break;
      case "reaction":
        c = {
          ...c,
          ...Xe.reopen({ appId: e, workspaceId: r, threadId: i })
        };
        break;
      case "system":
        switch (o.system) {
          case "resolve":
            c = {
              ...c,
              // remove all attachment views for the event
              ...Xe.removeThreadAttachments({
                appId: e,
                workspaceId: r,
                timeline: l,
                userId: n,
                threadId: i
              }),
              ...Xe.resolve({ appId: e, workspaceId: r, threadId: i })
            };
            break;
          case "reopen":
            const m = ec(l);
            c = {
              ...c,
              ...Object.values(l).reduce((v, b) => m.has(b.id) ? {} : {
                ...v,
                ...Xe.updateEventAttachments({
                  event: b,
                  workspaceId: r,
                  appId: e,
                  userId: b.createdById,
                  threadId: i,
                  eventId: b.id
                })
              }, {}),
              ...Xe.reopen({ appId: e, workspaceId: r, threadId: i })
            };
            break;
        }
        break;
    }
    c[ae.path`/timeline/${e}/${r}/${i}/${s}`] = f, c[ae.path`/views/threadProfiles/${e}/${r}/${i}/${n}`] = !0, c = {
      ...c,
      ...Xe.stopTyping({ appId: e, workspaceId: r, threadId: i, userId: n }),
      ...Xe.seen({
        appId: e,
        workspaceId: r,
        threadId: i,
        userId: n,
        seenUntilId: s
      })
    };
    try {
      bM && console.log("updates", c), await sl(ae`/`, c);
    } catch (u) {
      const d = new Error("[CollabKit] failed to write msg: " + u.message);
      throw d.stack += u.stack, d;
    }
  }
  subscribeSeen({
    appId: e,
    userId: n,
    workspaceId: r,
    subs: i,
    onSeenChange: o
  }) {
    var f, c;
    const a = gs(
      ae`/seen/${e}/${n}/${r}`,
      nm("seenUntilId"),
      tm(100)
    );
    function s(u) {
      const d = u.key && gt(u.key);
      if (d && r) {
        const { seenUntilId: h } = u.val();
        o({ threadId: d, seenUntilId: h });
      }
    }
    function l(u) {
      console.error({ e: u });
    }
    i[f = `${e}-${r}-seen-added`] || (i[f] = oi(a, s, l)), i[c = `${e}-${r}-seen-moved`] || (i[c] = em(a, s, l));
  }
  subscribeThreadInfo(e) {
    var r, i;
    const n = ae`/threadInfo/${e.appId}/${e.workspaceId}/${e.threadId}`;
    (r = e.subs)[i = `${n.toString()}#onValue`] || (r[i] = gc(n, (o) => {
      const a = o.val();
      e.onThreadInfo({ workspaceId: e.workspaceId, threadId: e.threadId, info: a });
    }));
  }
  subscribeInbox(e) {
    var i, o, a, s;
    const n = gs(
      ae`/views/inbox/${e.appId}/${e.workspaceId}`,
      nm("createdAt"),
      tm(100)
    );
    function r(l) {
      var u;
      const f = l.key && gt(l.key), c = a_(l, (u = l.val()) == null ? void 0 : u.id);
      !f || !c || e.onInboxChange({ event: c, threadId: f });
    }
    (i = e.subs)[o = `${n.toString()}#added`] || (i[o] = oi(
      n,
      r,
      (l) => {
        console.error(l);
      }
    )), (a = e.subs)[s = `${n.toString()}#moved`] || (a[s] = em(
      n,
      r,
      (l) => {
        console.error(l);
      }
    ));
  }
  subscribeThread(e) {
    pM(e), uM(e), this.subscribeThreadInfo(e);
  }
  async getThreadInfo(e) {
    return (await lr(
      ae`/threadInfo/${e.appId}/${e.workspaceId}/${e.threadId}`
    )).val();
  }
  async getUser(e) {
    const n = await lr(ae`/profiles/${e.appId}/${e.userId}`);
    return hM(n);
  }
}
function mc(t) {
  return Pb(t);
}
function l_() {
  return {
    isTyping: {},
    editor: null,
    enabled: !1,
    isMentioning: !1,
    hasText: !1,
    attachments: {}
  };
}
function ps() {
  return {
    inbox: {},
    profiles: {},
    name: "",
    timeline: {},
    composers: {},
    seen: {},
    threadInfo: {},
    threadProfiles: {},
    pendingThreadInfo: {},
    openPins: {},
    eventPins: {},
    computed: {},
    isResolved: {},
    isOpen: {}
  };
}
function _M() {
  return {
    isFigmaStyle: !0,
    sync: null,
    isConnected: !1,
    isSidebarOpen: !1,
    uiState: "idle",
    config: null,
    userId: null,
    user: null,
    workspaceId: null,
    selectedId: null,
    menuId: null,
    reactingId: null,
    viewingId: null,
    previewingId: null,
    hoveringId: null,
    focusedId: null,
    editingId: null,
    editingEventSnapshots: {},
    composerId: null,
    workspaces: {},
    profiles: {},
    avatarErrors: {},
    subs: {},
    callbacks: {},
    mentionableUsers: {},
    nextThreadId: null,
    clientX: 0,
    clientY: 0,
    commentables: {},
    expandedThreadIds: [],
    resolvedVisible: {},
    channelScrollTop: {},
    pinsVisible: !0,
    dragPinObjectId: "",
    dragPinUpdate: [],
    visiblePinPositions: []
  };
}
function wM(t) {
  const e = new yM({ test: t._test ?? !1 });
  return kM(t, e);
}
function kM(t, e) {
  const n = Db(_M());
  return n.config = t, n.sync = mc(e), Lb(
    {
      pins: (r) => {
        const i = r(n), { workspaceId: o, viewingId: a, previewingId: s } = i;
        if (!o)
          return {};
        const l = i.workspaces[o];
        if (!l)
          return {};
        const f = Object.entries((l == null ? void 0 : l.openPins) ?? {}).map(([c, u]) => Object.values(u).map((d) => ({ ...d, objectId: c }))).flat();
        for (const c in l.composers) {
          const u = l.composers[c];
          for (const d in u) {
            const h = u[d], { attachments: p } = h;
            if (p)
              for (const m in p) {
                if (p[m].type !== "pin")
                  continue;
                f.find((b) => b.id === m) || f.push({
                  ...p[m],
                  id: m,
                  eventId: d,
                  threadId: c,
                  workspaceId: o,
                  createdById: n.userId
                });
              }
          }
        }
        if (s && s.type === "pin") {
          const c = f.findIndex((u) => u.id === s.id);
          if (c > -1) {
            const u = f[c];
            f.splice(c, 1), f.push(u);
          }
        }
        if (a && a.type === "pin") {
          const c = f.findIndex((u) => u.id === a.id);
          if (c > -1) {
            const u = f[c];
            f.splice(c, 1), f.push(u);
          }
        }
        return {
          open: f
        };
      }
    },
    {
      proxy: n
    }
  ), n;
}
async function CM(t) {
  const { appId: e, apiKey: n, apiHost: r } = t;
  try {
    const i = await fetch(
      `${r}/v1/generateToken?apiKey=${n}&appId=${e}&mode=UNSECURED`
    );
    if (i.ok) {
      const o = await i.json();
      if (o.status === 200 || o.status === 201)
        return o.data;
      console.error(o);
    } else
      console.error("Failed to generateToken", i.status, await i.text());
  } catch (i) {
    console.error("Failed to generateToken", i);
  }
  return null;
}
var xM = "Function.prototype.bind called on incompatible ", Fu = Array.prototype.slice, EM = Object.prototype.toString, TM = "[object Function]", SM = function(e) {
  var n = this;
  if (typeof n != "function" || EM.call(n) !== TM)
    throw new TypeError(xM + n);
  for (var r = Fu.call(arguments, 1), i, o = function() {
    if (this instanceof i) {
      var c = n.apply(
        this,
        r.concat(Fu.call(arguments))
      );
      return Object(c) === c ? c : this;
    } else
      return n.apply(
        e,
        r.concat(Fu.call(arguments))
      );
  }, a = Math.max(0, n.length - r.length), s = [], l = 0; l < a; l++)
    s.push("$" + l);
  if (i = Function("binder", "return function (" + s.join(",") + "){ return binder.apply(this,arguments); }")(o), n.prototype) {
    var f = function() {
    };
    f.prototype = n.prototype, i.prototype = new f(), f.prototype = null;
  }
  return i;
}, IM = SM, NM = Function.prototype.bind || IM, MM = NM, Wa = MM.call(Function.call, Object.prototype.hasOwnProperty);
function AM(t) {
  return typeof t != "object" || t == null || Array.isArray(t) ? !1 : !Wa(t, "token") || t.token === null || typeof t.token == "string";
}
async function OM(t, e, n) {
  const r = await fetch(`${t}/v1/generateCustomToken`, {
    method: "POST",
    body: JSON.stringify({
      appId: e,
      userToken: n
    }),
    headers: {
      "Content-Type": "application/json"
    }
  }), i = await r.json();
  if (r.ok && AM(i))
    return i.data.token;
  throw console.error("Failed to generateCustomToken", r.status, i), new Error("Token authentication failed");
}
const im = "https://api.collabkit.dev", om = "https://test-api.collabkit.dev", DM = 34;
async function f_(t) {
  var r, i, o;
  if (!t.sync.shouldAuthenticate())
    return;
  const { config: e } = t, n = DT(kh("CollabKit"), {
    persistence: Ld,
    popupRedirectResolver: void 0
  });
  if ("token" in e && e.token != null) {
    const a = await OM(
      e._test ? om : im,
      e.appId,
      e.token
    ), l = await (await dp(n, a)).user.getIdTokenResult();
    let { appId: f, userId: c, workspaceId: u, mode: d } = l.claims;
    if (!f || !c || !u || !d)
      throw new Error("invalid claims: " + JSON.stringify(l.claims));
    if (typeof f != "string")
      throw new Error("`appId` must be a string");
    if (typeof c != "string")
      throw new Error("`userId` must be a string");
    if (typeof u != "string")
      throw new Error("`workspaceId` must be a string");
    f = gt(f), c = gt(c), u = gt(u);
    const h = await t.sync.getUser({ appId: f, userId: c });
    t.userId = c, t.user = h ?? { id: c, userId: c }, t.workspaceId = u, t.workspaces[u] = ps(), t.nextThreadId = t.sync.nextThreadId({ appId: f, workspaceId: u }), t.workspaceId !== "default" && t.config.mentionableUsers === "allWorkspace" && F1(t), $1(t);
  } else if ("apiKey" in e) {
    const a = await CM({
      appId: e.appId,
      apiKey: e.apiKey,
      apiHost: e._test ? om : im
    }), s = ((r = e.user) == null ? void 0 : r.userId) ?? ((i = e.user) == null ? void 0 : i.id);
    if (!s)
      throw new Error("Missing `user.id`");
    if (!((o = e.workspace) != null && o.id))
      throw new Error("Missing `workspace.id`");
    if (!a)
      throw new Error("Failed to auth");
    const f = await (await dp(n, a.token)).user.getIdTokenResult();
    if (f.claims.mode !== "UNSECURED")
      throw new Error("invalid claims: " + JSON.stringify(f.claims));
    t.userId = s, t.user = { ...e.user, id: s }, t.workspaceId = e.workspace.id, t.workspaces[e.workspace.id] = ps(), t.nextThreadId = t.sync.nextThreadId({
      appId: e.appId,
      workspaceId: e.workspace.id
    }), e.workspace.name && (t.workspaces[e.workspace.id].name = e.workspace.name), await $6(t), t.workspaceId !== "default" && t.config.mentionableUsers === "allWorkspace" && F1(t), $1(t);
  } else
    throw new Error("Missing `token` or `apiKey`");
}
var vc = function t(e, n) {
  if (e === n)
    return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor)
      return !1;
    var r, i, o;
    if (Array.isArray(e)) {
      if (r = e.length, r != n.length)
        return !1;
      for (i = r; i-- !== 0; )
        if (!t(e[i], n[i]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === n.source && e.flags === n.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === n.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === n.toString();
    if (o = Object.keys(e), r = o.length, r !== Object.keys(n).length)
      return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, o[i]))
        return !1;
    for (i = r; i-- !== 0; ) {
      var a = o[i];
      if (!t(e[a], n[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
};
function c_(t, e) {
  vc(t.focusedId, e.target) && (t.focusedId = null);
}
function oo(t) {
  t.viewingId = null, t.previewingId = null;
}
function u_(t) {
  t.reactingId = null;
}
function r1(t) {
  t.menuId = null;
}
function bf(t, e) {
  Uo(t.viewingId, e.target) && (t.viewingId = null);
}
function Tl(t, e) {
  Uo(t.previewingId, e.target) && (t.previewingId = null);
}
function PM(t, e) {
  const n = t.expandedThreadIds.findIndex((r) => r === e.threadId);
  n > -1 && t.expandedThreadIds.slice(n, 1);
}
const am = (t) => typeof jd(t) == "number";
async function Go(t, e) {
  const { event: n, parentEvent: r, threadId: i } = e, o = t.config.appId, a = t.userId;
  if (!a)
    throw new Error("CollabKit: cannot create event, anonymous user");
  const s = t.workspaceId;
  if (!s)
    throw new Error("CollabKit: cannot create event, no workspace");
  const l = t.sync.nextEventId({ appId: o, workspaceId: s, threadId: i }), f = t.sync.sendMessage({
    appId: o,
    workspaceId: s,
    threadId: i,
    event: am(n) ? Eo(n) : n,
    parentEvent: r ? am(r) ? Eo(r) : r : null,
    newEventId: l,
    userId: a,
    timeline: t.workspaces[s].timeline[i]
  }), c = t.workspaces[s].timeline;
  c[i] || (c[i] = {}), c[i][l] = {
    ...n,
    createdAt: +Date.now(),
    id: l
  };
  try {
    await f;
  } catch (u) {
    console.error(u), delete c[i][l];
  }
  return c[i][l];
}
async function d_(t, e) {
  const { workspaceId: n, threadId: r, eventId: i } = e, { userId: o } = t;
  if (!o) {
    console.warn("[CollabKit]: cannot send a message, anonymous user"), t.config.onAuthenticationRequired && t.config.onAuthenticationRequired();
    return;
  }
  const s = t.workspaces[n].timeline[r][i];
  return await Go(t, {
    event: {
      type: "delete",
      body: "",
      createdAt: t.sync.serverTimestamp(),
      createdById: o,
      parentId: i
    },
    threadId: r,
    parentEvent: s
  });
}
async function h_(t, e) {
}
function fo(t) {
  var e, n, r;
  if (((e = t.selectedId) == null ? void 0 : e.type) === "pin") {
    const i = t.workspaces[t.selectedId.workspaceId].eventPins[t.selectedId.eventId];
    if (!i)
      return;
    (r = (n = t.callbacks) == null ? void 0 : n.onPinDeselect) == null || r.call(n, {
      userId: t.userId,
      objectId: t.selectedId.objectId,
      workspaceId: t.selectedId.workspaceId,
      threadId: t.selectedId.threadId,
      meta: i.meta
    });
  }
  t.selectedId = null;
}
function i1({
  store: t,
  visibility: e,
  pinObjectId: n
}) {
  n && !e ? t.dragPinObjectId = n : n && e && (t.dragPinObjectId = "", t.dragPinUpdate = []);
}
function g_(t, e) {
  !!t.expandedThreadIds.find((r) => r === e.threadId) || t.expandedThreadIds.push(e.threadId);
}
function u0(t, e) {
  t.focusedId = e.target, e.target.type === "composer" && e.target.isNewThread && fo(t);
}
async function o1(t) {
  t.isSidebarOpen = !1;
}
function p_(t, e) {
  var r, i;
  const { target: n } = e;
  switch (t.hoveringId = n, n.type) {
    case "comment": {
      if (t.uiState === "selecting")
        return;
      t.hoveringId = n;
      const o = t.workspaces[n.workspaceId].eventPins[n.eventId];
      o && ((i = (r = t.callbacks) == null ? void 0 : r.onPinHover) == null || i.call(r, {
        userId: "",
        objectId: o.objectId,
        workspaceId: n.workspaceId,
        threadId: n.threadId,
        meta: o.meta
      }));
    }
  }
}
function Qo(t, e) {
  var s, l, f;
  const { workspaceId: n, threadId: r, eventId: i } = e, o = t.workspaces[n].composers;
  o[r] ?? (o[r] = {}), o[r][i] || (o[r][i] = l_());
  const a = (f = (l = (s = t.workspaces) == null ? void 0 : s[n].timeline) == null ? void 0 : l[r]) == null ? void 0 : f[i];
  return a && (o[r][i].attachments = a.attachments ?? {}), o[r][i];
}
function bc(t, e) {
  var a, s, l, f;
  const { workspaceId: n, threadId: r } = e;
  (a = t.workspaces)[n] || (a[n] = ps());
  const i = t.workspaces[n];
  (s = i.timeline)[r] || (s[r] = {}), (l = i.threadProfiles)[r] || (l[r] = {});
  const { timeline: o } = i;
  (f = i.computed)[r] || (f[r] = Lb({
    isResolved: (c) => jC(c(o)[r]),
    hasFetchedAllProfiles: (c) => Object.values(c(o[r])).every(
      (u) => c(t.profiles)[u.createdById]
    ),
    messageEvents: (c) => eb(c(o)[r]),
    unreadCount: (c) => {
      const u = c(t).userId;
      if (!u)
        return 0;
      const d = c(i).seen[r], h = c(i).timeline[r] ?? {}, p = ec(h), m = Object.keys(h).filter(
        (v) => !p.has(v) && h[v].type === "message"
      );
      return d == null ? 0 : m.filter((v) => h[v].createdById !== u).reduce((v, b) => b > d ? v + 1 : v, 0);
    },
    reactions: (c) => FC(c(o)[r]),
    replyCount: (c) => zC(c(o)[r]),
    canonicalEvents: (c) => {
      const u = c(o)[r], d = {};
      for (const h of Object.keys(u)) {
        const p = BC(u, h);
        p && (d[h] = p);
      }
      return { ...u, ...d };
    }
  }));
}
var W = {};
let d0 = {}, m_ = {}, ms = {}, Ua = {}, a1 = {}, mo = {}, h0 = {}, s1 = {}, vs = {}, bs = {}, kr = {}, g0 = {}, p0 = {}, v_ = {}, b_ = {}, y_ = {}, __ = {}, w_ = {}, k_ = {}, yf = {}, C_ = {}, x_ = {}, E_ = {}, T_ = {}, S_ = {}, I_ = {}, N_ = {}, M_ = {}, A_ = {}, m0 = {}, v0 = {}, O_ = {}, D_ = {}, P_ = {};
function ee(t) {
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?code=${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
let Wr = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", RM = Wr && "documentMode" in document ? document.documentMode : null, $t = Wr && /Mac|iPod|iPhone|iPad/.test(navigator.platform), wi = Wr && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), _f = Wr && "InputEvent" in window && !RM ? "getTargetRanges" in new window.InputEvent("input") : !1, b0 = Wr && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), y0 = Wr && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, LM = Wr && /^(?=.*Chrome).*/i.test(navigator.userAgent), yc = b0 || y0 ? " " : "​", $M = wi ? " " : yc, FM = /^[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]*[\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]/, jM = /^[^\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]*[A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]/, ai = {
  bold: 1,
  code: 16,
  italic: 2,
  strikethrough: 4,
  subscript: 32,
  superscript: 64,
  underline: 8
}, zM = { directionless: 1, unmergeable: 2 }, sm = { center: 2, end: 6, justify: 4, left: 1, right: 3, start: 5 }, BM = { 2: "center", 6: "end", 4: "justify", 1: "left", 3: "right", 5: "start" }, WM = { normal: 0, segmented: 2, token: 1 }, UM = { 0: "normal", 2: "segmented", 1: "token" }, l1 = !1, _0 = 0;
function HM(t) {
  _0 = t.timeStamp;
}
function ju(t, e, n) {
  return e.__lexicalLineBreak === t || t[`__lexicalKey_${n._key}`] !== void 0;
}
function VM(t) {
  return t.getEditorState().read(() => {
    let e = He();
    return e !== null ? e.clone() : null;
  });
}
function R_(t, e, n) {
  l1 = !0;
  let r = 100 < performance.now() - _0;
  try {
    rn(t, () => {
      let i = He() || VM(t);
      var o = /* @__PURE__ */ new Map(), a = t.getRootElement(), s = t._editorState, l = t._blockCursorElement;
      let f = !1, c = "";
      for (var u = 0; u < e.length; u++) {
        var d = e[u], h = d.type, p = d.target, m = Us(p, s);
        if (!(m === null && p !== a || Ye(m))) {
          if (h === "characterData") {
            if (d = r && J(m))
              e: {
                d = i, h = p;
                var v = m;
                if (de(d)) {
                  var b = d.anchor.getNode();
                  if (b.is(v) && d.format !== b.getFormat()) {
                    d = !1;
                    break e;
                  }
                }
                d = h.nodeType === 3 && v.isAttached();
              }
            d && (v = Qn(t._window), h = d = null, v !== null && v.anchorNode === p && (d = v.anchorOffset, h = v.focusOffset), p = p.nodeValue, p !== null && k0(m, p, d, h, !1));
          } else if (h === "childList") {
            for (f = !0, h = d.addedNodes, v = 0; v < h.length; v++) {
              b = h[v];
              var k = U_(b), _ = b.parentNode;
              _ == null || b === l || k !== null || b.nodeName === "BR" && ju(b, _, t) || (wi && (k = b.innerText || b.nodeValue) && (c += k), _.removeChild(b));
            }
            if (d = d.removedNodes, h = d.length, 0 < h) {
              for (v = 0, b = 0; b < h; b++)
                _ = d[b], (_.nodeName === "BR" && ju(_, p, t) || l === _) && (p.appendChild(_), v++);
              h !== v && (p === a && (m = s._nodeMap.get("root")), o.set(p, m));
            }
          }
        }
      }
      if (0 < o.size)
        for (let [E, S] of o)
          if (H(S))
            for (o = S.getChildrenKeys(), a = E.firstChild, s = 0; s < o.length; s++)
              l = t.getElementByKey(o[s]), l !== null && (a == null ? (E.appendChild(l), a = l) : a !== l && E.replaceChild(l, a), a = a.nextSibling);
          else
            J(S) && S.markDirty();
      if (o = n.takeRecords(), 0 < o.length) {
        for (a = 0; a < o.length; a++)
          for (l = o[a], s = l.addedNodes, l = l.target, u = 0; u < s.length; u++)
            m = s[u], p = m.parentNode, p == null || m.nodeName !== "BR" || ju(m, l, t) || p.removeChild(m);
        n.takeRecords();
      }
      i !== null && (f && (i.dirty = !0, Fr(i)), wi && q_(t) && i.insertRawText(c));
    });
  } finally {
    l1 = !1;
  }
}
function L_(t) {
  let e = t._observer;
  if (e !== null) {
    let n = e.takeRecords();
    R_(t, n, e);
  }
}
function $_(t) {
  _0 === 0 && kc(t).addEventListener("textInput", HM, !0), t._observer = new MutationObserver((e, n) => {
    R_(t, e, n);
  });
}
let KM = 1, YM = typeof queueMicrotask == "function" ? queueMicrotask : (t) => {
  Promise.resolve().then(t);
};
function F_(t) {
  let e = document.activeElement;
  if (e === null)
    return !1;
  let n = e.nodeName;
  return Ye(Us(t)) && (n === "INPUT" || n === "TEXTAREA" || e.contentEditable === "true" && e.__collabKitEditor == null);
}
function _c(t, e, n) {
  let r = t.getRootElement();
  try {
    return r !== null && r.contains(e) && r.contains(n) && e !== null && !F_(e) && j_(e) === t;
  } catch {
    return !1;
  }
}
function j_(t) {
  for (; t != null; ) {
    let e = t.__collabKitEditor;
    if (e != null)
      return e;
    t = wc(t);
  }
  return null;
}
function f1(t) {
  return t.isToken() || t.isSegmented();
}
function wf(t) {
  for (; t != null; ) {
    if (t.nodeType === 3)
      return t;
    t = t.firstChild;
  }
  return null;
}
function z_(t, e, n) {
  return e = ai[e], t & e && (n === null || !(n & e)) ? t ^ e : n === null || n & e ? t | e : t;
}
function B_(t) {
  return J(t) || Cs(t) || Ye(t);
}
function W_(t, e) {
  if (e != null)
    t.__key = e;
  else {
    At(), 99 < ks && ee(14), e = et();
    var n = Xn(), r = "" + KM++;
    n._nodeMap.set(r, t), H(t) ? e._dirtyElements.set(r, !0) : e._dirtyLeaves.add(r), e._cloneNotNeeded.add(r), e._dirtyType = 1, t.__key = r;
  }
}
function si(t) {
  var e = t.getParent();
  if (e !== null) {
    let i = t.getWritable();
    e = e.getWritable();
    var n = t.getPreviousSibling();
    if (t = t.getNextSibling(), n === null)
      if (t !== null) {
        var r = t.getWritable();
        e.__first = t.__key, r.__prev = null;
      } else
        e.__first = null;
    else {
      if (r = n.getWritable(), t !== null) {
        let o = t.getWritable();
        o.__prev = r.__key, r.__next = o.__key;
      } else
        r.__next = null;
      i.__prev = null;
    }
    t === null ? n !== null ? (t = n.getWritable(), e.__last = n.__key, t.__next = null) : e.__last = null : (t = t.getWritable(), n !== null ? (n = n.getWritable(), n.__next = t.__key, t.__prev = n.__key) : t.__prev = null, i.__next = null), e.__size--, i.__parent = null;
  }
}
function kf(t) {
  99 < ks && ee(14);
  var e = t.getLatest(), n = e.__parent, r = Xn();
  let i = et(), o = r._nodeMap;
  if (r = i._dirtyElements, n !== null)
    e:
      for (; n !== null; ) {
        if (r.has(n))
          break e;
        let a = o.get(n);
        if (a === void 0)
          break;
        r.set(n, !1), n = a.__parent;
      }
  e = e.__key, i._dirtyType = 1, H(t) ? r.set(e, !0) : i._dirtyLeaves.add(e);
}
function Ct(t) {
  At();
  var e = et();
  let n = e._compositionKey;
  t !== n && (e._compositionKey = t, n !== null && (e = it(n), e !== null && e.getWritable()), t !== null && (t = it(t), t !== null && t.getWritable()));
}
function Cr() {
  return Xo() ? null : et()._compositionKey;
}
function it(t, e) {
  return t = (e || Xn())._nodeMap.get(t), t === void 0 ? null : t;
}
function U_(t, e) {
  let n = et();
  return t = t[`__lexicalKey_${n._key}`], t !== void 0 ? it(t, e) : null;
}
function Us(t, e) {
  for (; t != null; ) {
    let n = U_(t, e);
    if (n !== null)
      return n;
    t = wc(t);
  }
  return null;
}
function H_(t) {
  let e = Object.assign({}, t._decorators);
  return t._pendingDecorators = e;
}
function lm(t) {
  return t.read(() => Ur().getTextContent());
}
function qM(t, e) {
  rn(t, () => {
    var n = Xn();
    if (!n.isEmpty())
      if (e === "root")
        Ur().markDirty();
      else {
        n = n._nodeMap;
        for (let [, r] of n)
          r.markDirty();
      }
  }, t._pendingEditorState === null ? { tag: "history-merge" } : void 0);
}
function Ur() {
  return Xn()._nodeMap.get("root");
}
function Fr(t) {
  At();
  let e = Xn();
  t !== null && (t.dirty = !0, t._cachedNodes = null), e._selection = t;
}
function co(t) {
  var e = et(), n;
  e: {
    for (n = t; n != null; ) {
      let r = n[`__lexicalKey_${e._key}`];
      if (r !== void 0) {
        n = r;
        break e;
      }
      n = wc(n);
    }
    n = null;
  }
  return n === null ? (e = e.getRootElement(), t === e ? it("root") : null) : it(n);
}
function V_(t) {
  return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(t);
}
function w0(t) {
  let e = [];
  for (; t !== null; )
    e.push(t), t = t._parentEditor;
  return e;
}
function K_() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}
function Y_(t, e, n) {
  if (e = Qn(e._window), e !== null) {
    var r = e.anchorNode, { anchorOffset: i, focusOffset: o } = e;
    if (r !== null && (e = r.nodeType === 3 ? r.nodeValue : null, r = Us(r), e !== null && J(r))) {
      if (e === yc && n) {
        let a = n.length;
        e = n, o = i = a;
      }
      e !== null && k0(r, e, i, o, t);
    }
  }
}
function k0(t, e, n, r, i) {
  let o = t;
  if (o.isAttached() && (i || !o.isDirty())) {
    var a = o.isComposing();
    if (t = e, (a || i) && e[e.length - 1] === yc && (t = e.slice(0, -1)), e = o.getTextContent(), i || t !== e)
      if (t === "")
        if (Ct(null), b0 || y0)
          o.remove();
        else {
          let s = et();
          setTimeout(() => {
            s.update(() => {
              o.isAttached() && o.remove();
            });
          }, 20);
        }
      else
        i = o.getParent(), e = Vs(), o.isToken() || Cr() !== null && !a || i !== null && de(e) && !i.canInsertTextBefore() && e.anchor.offset === 0 ? o.markDirty() : (a = He(), de(a) && n !== null && r !== null && (a.setTextNodeRange(o, n, o, r), o.isSegmented() && (n = o.getTextContent(), n = kt(n), o.replace(n), o = n)), o.setTextContent(t));
  }
}
function GM(t, e) {
  if (e.isSegmented())
    return !0;
  if (!t.isCollapsed())
    return !1;
  t = t.anchor.offset;
  let n = e.getParentOrThrow(), r = e.isToken();
  return t === 0 ? ((t = !e.canInsertTextBefore() || !n.canInsertTextBefore() || r) || (e = e.getPreviousSibling(), t = (J(e) || H(e) && e.isInline()) && !e.canInsertTextAfter()), t) : t === e.getTextContentSize() ? !e.canInsertTextAfter() || !n.canInsertTextAfter() || r : !1;
}
function Ha(t, e) {
  var n = t[e];
  return typeof n == "string" ? (n = n.split(" "), t[e] = n) : n;
}
function C0(t, e, n, r, i) {
  n.size !== 0 && (n = r.__key, e = e.get(r.__type), e === void 0 && ee(33), r = e.klass, e = t.get(r), e === void 0 && (e = /* @__PURE__ */ new Map(), t.set(r, e)), t = e.get(n), r = t === "destroyed" && i === "created", (t === void 0 || r) && e.set(n, r ? "updated" : i));
}
function fm(t, e, n) {
  let r = t.getParent(), i = n;
  return r !== null && (e && n === 0 ? (i = t.getIndexWithinParent(), t = r) : e || n !== t.getChildrenSize() || (i = t.getIndexWithinParent() + 1, t = r)), t.getChildAtIndex(e ? i - 1 : i);
}
function c1(t, e) {
  var n = t.offset;
  return t.type === "element" ? (t = t.getNode(), fm(t, e, n)) : (t = t.getNode(), e && n === 0 || !e && n === t.getTextContentSize() ? (n = e ? t.getPreviousSibling() : t.getNextSibling(), n === null ? fm(t.getParentOrThrow(), e, t.getIndexWithinParent() + (e ? 0 : 1)) : n) : null);
}
function q_(t) {
  return t = (t = kc(t).event) && t.inputType, t === "insertFromPaste" || t === "insertFromPasteAsQuotation";
}
function u1(t) {
  return !nn(t) && !t.isLastChild() && !t.isInline();
}
function Cf(t, e) {
  return t = t._keyToDOMMap.get(e), t === void 0 && ee(75), t;
}
function wc(t) {
  return t = t.assignedSlot || t.parentElement, t !== null && t.nodeType === 11 ? t.host : t;
}
function QM(t, e, n) {
  let r = n.ownerDocument, i = r.defaultView;
  if (i !== null) {
    var { top: o, bottom: a } = e;
    for (e = n; e !== null; ) {
      if (n = e === r.body)
        var s = 0, l = kc(t).innerHeight;
      else {
        var f = e.getBoundingClientRect();
        s = f.top, l = f.bottom;
      }
      if (f = 0, o < s ? f = -(s - o) : a > l && (f = a - l), f !== 0 && (n ? i.scrollBy(0, f) : (s = e.scrollTop, e.scrollTop += f, s = e.scrollTop - s, o -= s, a -= s)), n)
        break;
      e = wc(e);
    }
  }
}
function XM(t, e = 0) {
  if (e !== 0 && ee(1), e = He(), !de(e) || !H(t))
    return e;
  let { anchor: n, focus: r } = e, i = n.getNode(), o = r.getNode();
  return xf(i, t) && n.set(t.__key, 0, "element"), xf(o, t) && r.set(t.__key, 0, "element"), e;
}
function xf(t, e) {
  for (t = t.getParent(); t !== null; ) {
    if (t.is(e))
      return !0;
    t = t.getParent();
  }
  return !1;
}
function kc(t) {
  return t = t._window, t === null && ee(78), t;
}
function G_(t) {
  for (t = t.getParentOrThrow(); t !== null && !Nr(t); )
    t = t.getParentOrThrow();
  return t;
}
function Nr(t) {
  return nn(t) || H(t) && t.isShadowRoot();
}
function Cc(t) {
  var e = et();
  let n = t.constructor.getType();
  return e = e._nodes.get(n), e === void 0 && ee(97), e = e.replace, e !== null ? (e = e(t), e instanceof t.constructor || ee(98), e) : t;
}
function zu(t, e) {
  t = t.getParent(), !nn(t) || H(e) || Ye(e) || ee(99);
}
function Bu(t) {
  return (Ye(t) || H(t) && !t.canBeEmpty()) && !t.isInline();
}
function d1(t, e, n) {
  n.style.removeProperty("caret-color"), e._blockCursorElement = null, e = t.parentElement, e !== null && e.removeChild(t);
}
function Qn(t) {
  return Wr ? (t || window).getSelection() : null;
}
function Q_(t, e, n, r, i) {
  for (t = t.getFirstChild(); t !== null; ) {
    let o = t.__key;
    t !== void 0 && t.__parent === e && (H(t) && Q_(t, o, n, r, i), n.has(o) || i.delete(o), r.delete(o)), t = t.isAttached() ? t.getNextSibling() : null;
  }
}
function JM(t, e, n, r) {
  t = t._nodeMap, e = e._nodeMap;
  for (let i of n) {
    let o = e.get(i);
    o === void 0 || o.isAttached() || (t.has(i) || n.delete(i), e.delete(i));
  }
  for (let [i] of r)
    n = e.get(i), n === void 0 || n.isAttached() || (H(n) && Q_(n, i, t, e, r), t.has(i) || r.delete(i), e.delete(i));
}
function cm(t, e) {
  let n = t.__mode, r = t.__format;
  t = t.__style;
  let i = e.__mode, o = e.__format;
  return e = e.__style, (n === null || n === i) && (r === null || r === o) && (t === null || t === e);
}
function um(t, e) {
  let n = t.mergeWithSibling(e), r = et()._normalizedNodes;
  return r.add(t.__key), r.add(e.__key), n;
}
function X_(t) {
  if (t.__text === "" && t.isSimpleText() && !t.isUnmergeable())
    t.remove();
  else {
    for (var e; (e = t.getPreviousSibling()) !== null && J(e) && e.isSimpleText() && !e.isUnmergeable(); )
      if (e.__text === "")
        e.remove();
      else {
        cm(e, t) && (t = um(e, t));
        break;
      }
    for (var n; (n = t.getNextSibling()) !== null && J(n) && n.isSimpleText() && !n.isUnmergeable(); )
      if (n.__text === "")
        n.remove();
      else {
        cm(t, n) && um(t, n);
        break;
      }
  }
}
function J_(t) {
  return dm(t.anchor), dm(t.focus), t;
}
function dm(t) {
  for (; t.type === "element"; ) {
    var e = t.getNode(), n = t.offset;
    if (n === e.getChildrenSize() ? (e = e.getChildAtIndex(n - 1), n = !0) : (e = e.getChildAtIndex(n), n = !1), J(e)) {
      t.set(e.__key, n ? e.getTextContentSize() : 0, "text");
      break;
    } else if (!H(e))
      break;
    t.set(e.__key, n ? e.getChildrenSize() : 0, "element");
  }
}
let ct = "", Mt = "", ar = "", ki, It, ys, Z_ = !1, x0 = !1, xc, Sl = null, h1, g1, Ci, jr, p1, _s;
function Il(t, e) {
  let n = Ci.get(t);
  if (e !== null) {
    let r = b1(t);
    r.parentNode === e && e.removeChild(r);
  }
  jr.has(t) || It._keyToDOMMap.delete(t), H(n) && (t = Ef(n, Ci), m1(t, 0, t.length - 1, null)), n !== void 0 && C0(_s, ys, xc, n, "destroyed");
}
function m1(t, e, n, r) {
  for (; e <= n; ++e) {
    let i = t[e];
    i !== void 0 && Il(i, r);
  }
}
function Kr(t, e) {
  t.setProperty("text-align", e);
}
function ew(t, e) {
  t.style.setProperty("padding-inline-start", e === 0 ? "" : 20 * e + "px");
}
function tw(t, e) {
  t = t.style, e === 0 ? Kr(t, "") : e === 1 ? Kr(t, "left") : e === 2 ? Kr(t, "center") : e === 3 ? Kr(t, "right") : e === 4 ? Kr(t, "justify") : e === 5 ? Kr(t, "start") : e === 6 && Kr(t, "end");
}
function Nl(t, e, n) {
  let r = jr.get(t);
  r === void 0 && ee(60);
  let i = r.createDOM(ki, It);
  var o = It._keyToDOMMap;
  if (i["__lexicalKey_" + It._key] = t, o.set(t, i), J(r) ? i.setAttribute("data-lexical-text", "true") : Ye(r) && i.setAttribute("data-lexical-decorator", "true"), H(r)) {
    if (t = r.__indent, o = r.__size, t !== 0 && ew(i, t), o !== 0) {
      --o, t = Ef(r, jr);
      var a = Mt;
      Mt = "", v1(t, 0, o, i, null), rw(r, i), Mt = a;
    }
    t = r.__format, t !== 0 && tw(i, t), r.isInline() || nw(null, r, i), u1(r) && (ct += `

`, ar += `

`);
  } else
    o = r.getTextContent(), Ye(r) ? (a = r.decorate(It, ki), a !== null && iw(
      t,
      a
    ), i.contentEditable = "false") : J(r) && (r.isDirectionless() || (Mt += o)), ct += o, ar += o;
  return e !== null && (n != null ? e.insertBefore(i, n) : (n = e.__lexicalLineBreak, n != null ? e.insertBefore(i, n) : e.appendChild(i))), C0(_s, ys, xc, r, "created"), i;
}
function v1(t, e, n, r, i) {
  let o = ct;
  for (ct = ""; e <= n; ++e)
    Nl(t[e], r, i);
  r.__lexicalTextContent = ct, ct = o + ct;
}
function hm(t, e) {
  return t = e.get(t), Cs(t) || Ye(t) && t.isInline();
}
function nw(t, e, n) {
  t = t !== null && (t.__size === 0 || hm(t.__last, Ci)), e = e.__size === 0 || hm(e.__last, jr), t ? e || (e = n.__lexicalLineBreak, e != null && n.removeChild(e), n.__lexicalLineBreak = null) : e && (e = document.createElement("br"), n.__lexicalLineBreak = e, n.appendChild(e));
}
function rw(t, e) {
  var n = e.__lexicalDir;
  if (e.__lexicalDirTextContent !== Mt || n !== Sl) {
    let o = Mt === "";
    if (o)
      var r = Sl;
    else
      r = Mt, r = FM.test(r) ? "rtl" : jM.test(r) ? "ltr" : null;
    if (r !== n) {
      let a = e.classList, s = ki.theme;
      var i = n !== null ? s[n] : void 0;
      let l = r !== null ? s[r] : void 0;
      i !== void 0 && (typeof i == "string" && (i = i.split(" "), i = s[n] = i), a.remove(...i)), r === null || o && r === "ltr" ? e.removeAttribute("dir") : (l !== void 0 && (typeof l == "string" && (n = l.split(" "), l = s[r] = n), l !== void 0 && a.add(...l)), e.dir = r), x0 || (t.getWritable().__dir = r);
    }
    Sl = r, e.__lexicalDirTextContent = Mt, e.__lexicalDir = r;
  }
}
function Ef(t, e) {
  let n = [];
  for (t = t.__first; t !== null; ) {
    let r = e.get(t);
    r === void 0 && ee(101), n.push(t), t = r.__next;
  }
  return n;
}
function Sa(t, e) {
  var n = Ci.get(t), r = jr.get(t);
  n !== void 0 && r !== void 0 || ee(61);
  var i = Z_ || g1.has(t) || h1.has(t);
  let o = Cf(It, t);
  if (n === r && !i)
    return H(n) ? (r = o.__lexicalTextContent, r !== void 0 && (ct += r, ar += r), r = o.__lexicalDirTextContent, r !== void 0 && (Mt += r)) : (r = n.getTextContent(), J(n) && !n.isDirectionless() && (Mt += r), ar += r, ct += r), o;
  if (n !== r && i && C0(_s, ys, xc, r, "updated"), r.updateDOM(n, o, ki))
    return r = Nl(t, null, null), e === null && ee(62), e.replaceChild(r, o), Il(t, null), r;
  if (H(n) && H(r)) {
    if (t = r.__indent, t !== n.__indent && ew(o, t), t = r.__format, t !== n.__format && tw(o, t), i) {
      t = r, i = Mt, Mt = "", e = ct;
      var a = n.__size, s = t.__size;
      if (ct = "", a === 1 && s === 1) {
        var l = n.__first, f = t.__first;
        if (l === f)
          Sa(l, o);
        else {
          var c = b1(l);
          f = Nl(f, null, null), o.replaceChild(f, c), Il(l, null);
        }
      } else {
        f = Ef(n, Ci);
        var u = Ef(t, jr);
        if (a === 0)
          s !== 0 && v1(u, 0, s - 1, o, null);
        else if (s === 0)
          a !== 0 && (l = o.__lexicalLineBreak == null, m1(f, 0, a - 1, l ? null : o), l && (o.textContent = ""));
        else {
          var d = f;
          f = u, u = a - 1, a = s - 1;
          let p = o.firstChild, m = 0;
          for (s = 0; m <= u && s <= a; ) {
            var h = d[m];
            let v = f[s];
            if (h === v)
              p = Wu(Sa(v, o)), m++, s++;
            else {
              l === void 0 && (l = new Set(d)), c === void 0 && (c = new Set(f));
              let b = c.has(h), k = l.has(v);
              b ? (k ? (h = Cf(It, v), h === p ? p = Wu(Sa(v, o)) : (p != null ? o.insertBefore(h, p) : o.appendChild(h), Sa(v, o)), m++) : Nl(v, o, p), s++) : (p = Wu(b1(h)), Il(h, o), m++);
            }
          }
          l = m > u, c = s > a, l && !c ? (l = f[a + 1], l = l === void 0 ? null : It.getElementByKey(l), v1(f, s, a, o, l)) : c && !l && m1(d, m, u, o);
        }
      }
      u1(t) && (ct += `

`), o.__lexicalTextContent = ct, ct = e + ct, rw(t, o), Mt = i, nn(r) || r.isInline() || nw(n, r, o);
    }
    u1(r) && (ct += `

`, ar += `

`);
  } else
    n = r.getTextContent(), Ye(r) ? (i = r.decorate(It, ki), i !== null && iw(t, i)) : J(r) && !r.isDirectionless() && (Mt += n), ct += n, ar += n;
  return !x0 && nn(r) && r.__cachedText !== ar && (r = r.getWritable(), r.__cachedText = ar), o;
}
function iw(t, e) {
  let n = It._pendingDecorators, r = It._decorators;
  if (n === null) {
    if (r[t] === e)
      return;
    n = H_(It);
  }
  n[t] = e;
}
function Wu(t) {
  return t = t.nextSibling, t !== null && t === It._blockCursorElement && (t = t.nextSibling), t;
}
function b1(t) {
  return t = p1.get(t), t === void 0 && ee(75), t;
}
let ir = Object.freeze({}), y1 = [["keydown", sA], ["pointerdown", eA], ["compositionstart", oA], ["compositionend", aA], ["input", iA], ["click", ZM], ["cut", ir], ["copy", ir], ["dragstart", ir], ["dragover", ir], ["dragend", ir], ["paste", ir], ["focus", ir], ["blur", ir], ["drop", ir]];
_f && y1.push(["beforeinput", (t, e) => rA(t, e)]);
let ws = 0, ow = 0, aw = 0, Va = 0, _1 = !1, w1 = !1, Ka = !1, Ia = !1, sw = [0, 0, "root", 0];
function lw(t, e, n, r) {
  let i = t.anchor, o = t.focus, a = i.getNode();
  var s = et(), l = Qn(s._window);
  l = l !== null ? l.anchorNode : null;
  let f = i.key;
  s = s.getElementByKey(f);
  let c = e.length;
  return f !== o.key || !J(a) || (!r && (!_f || aw < n + 50) || 2 > c || V_(e)) && i.offset !== o.offset && !a.isComposing() || f1(a) || a.isDirty() && 1 < c || (r || !_f) && s !== null && !a.isComposing() && l !== wf(s) || a.getFormat() !== t.format || GM(t, a);
}
function gm(t, e) {
  return t !== null && t.nodeValue !== null && t.nodeType === 3 && e !== 0 && e !== t.nodeValue.length;
}
function pm(t, e, n) {
  let { anchorNode: r, anchorOffset: i, focusNode: o, focusOffset: a } = t;
  _1 && (_1 = !1, gm(r, i) && gm(o, a)) || rn(e, () => {
    if (!n)
      Fr(null);
    else if (_c(e, r, o)) {
      var s = He();
      if (de(s)) {
        var l = s.anchor, f = l.getNode();
        if (s.isCollapsed()) {
          t.type === "Range" && t.anchorNode === t.focusNode && (s.dirty = !0);
          var c = kc(e).event;
          c = c ? c.timeStamp : performance.now();
          let [u, d, h, p] = sw;
          c < p + 200 && l.offset === d && l.key === h ? s.format = u : l.type === "text" ? s.format = f.getFormat() : l.type === "element" && (s.format = 0);
        } else {
          l = 127, f = !1, c = s.getNodes();
          let u = c.length;
          for (let d = 0; d < u; d++) {
            let h = c[d];
            if (J(h) && (f = !0, l &= h.getFormat(), l === 0))
              break;
          }
          s.format = f ? l : 0;
        }
      }
      Q(e, d0, void 0);
    }
  });
}
function ZM(t, e) {
  rn(e, () => {
    let n = He(), r = Qn(e._window), i = Vs();
    if (de(n)) {
      let o = n.anchor, a = o.getNode();
      r && o.type === "element" && o.offset === 0 && n.isCollapsed() && !nn(a) && Ur().getChildrenSize() === 1 && a.getTopLevelElementOrThrow().isEmpty() && i !== null && n.is(i) && (r.removeAllRanges(), n.dirty = !0);
    }
    Q(e, m_, t);
  });
}
function eA(t, e) {
  let n = t.target;
  t = t.pointerType, n instanceof Node && t !== "touch" && rn(e, () => {
    Ye(Us(n)) || (w1 = !0);
  });
}
function tA(t, e) {
  e.getTargetRanges && (e = e.getTargetRanges()[0]) && t.applyDOMRange(e);
}
function nA(t, e) {
  return t !== e || H(t) || H(e) || !t.isToken() || !e.isToken();
}
function rA(t, e) {
  let n = t.inputType;
  n === "deleteCompositionText" || wi && q_(e) || n !== "insertCompositionText" && rn(e, () => {
    let r = He();
    if (n === "deleteContentBackward") {
      if (r === null) {
        var i = Vs();
        if (!de(i))
          return;
        Fr(i.clone());
      }
      if (de(r)) {
        ow === 229 && t.timeStamp < ws + 30 && e.isComposing() && r.anchor.key === r.focus.key ? (Ct(null), ws = 0, setTimeout(() => {
          rn(e, () => {
            Ct(null);
          });
        }, 30), de(r) && (i = r.anchor.getNode(), i.markDirty(), r.format = i.getFormat())) : (t.preventDefault(), Q(e, ms, !0));
        return;
      }
    }
    if (de(r)) {
      i = t.data, r.dirty || !r.isCollapsed() || nn(r.anchor.getNode()) || tA(r, t);
      var o = r.focus, a = r.anchor.getNode();
      if (o = o.getNode(), n === "insertText" || n === "insertTranspose")
        i === `
` ? (t.preventDefault(), Q(e, Ua, !1)) : i === `

` ? (t.preventDefault(), Q(e, a1, void 0)) : i == null && t.dataTransfer ? (i = t.dataTransfer.getData("text/plain"), t.preventDefault(), r.insertRawText(i)) : i != null && lw(r, i, t.timeStamp, !0) && (t.preventDefault(), Q(e, mo, i)), aw = t.timeStamp;
      else
        switch (t.preventDefault(), n) {
          case "insertFromYank":
          case "insertFromDrop":
          case "insertReplacementText":
            Q(e, mo, t);
            break;
          case "insertFromComposition":
            Ct(null), Q(e, mo, t);
            break;
          case "insertLineBreak":
            Ct(null), Q(e, Ua, !1);
            break;
          case "insertParagraph":
            Ct(null), Ka ? (Ka = !1, Q(e, Ua, !1)) : Q(e, a1, void 0);
            break;
          case "insertFromPaste":
          case "insertFromPasteAsQuotation":
            Q(e, h0, t);
            break;
          case "deleteByComposition":
            nA(a, o) && Q(e, s1, void 0);
            break;
          case "deleteByDrag":
          case "deleteByCut":
            Q(e, s1, void 0);
            break;
          case "deleteContent":
            Q(e, ms, !1);
            break;
          case "deleteWordBackward":
            Q(e, vs, !0);
            break;
          case "deleteWordForward":
            Q(e, vs, !1);
            break;
          case "deleteHardLineBackward":
          case "deleteSoftLineBackward":
            Q(
              e,
              bs,
              !0
            );
            break;
          case "deleteContentForward":
          case "deleteHardLineForward":
          case "deleteSoftLineForward":
            Q(e, bs, !1);
            break;
          case "formatStrikeThrough":
            Q(e, kr, "strikethrough");
            break;
          case "formatBold":
            Q(e, kr, "bold");
            break;
          case "formatItalic":
            Q(e, kr, "italic");
            break;
          case "formatUnderline":
            Q(e, kr, "underline");
            break;
          case "historyUndo":
            Q(e, g0, void 0);
            break;
          case "historyRedo":
            Q(e, p0, void 0);
        }
    }
  });
}
function iA(t, e) {
  t.stopPropagation(), rn(e, () => {
    var n = He(), r = t.data;
    if (r != null && de(n) && lw(n, r, t.timeStamp, !1)) {
      Ia && (k1(e, r), Ia = !1);
      var i = n.anchor, o = i.getNode(), a = Qn(e._window);
      if (a === null)
        return;
      let s = i.offset;
      (i = _f && !n.isCollapsed() && J(o) && a.anchorNode !== null) && (o = o.getTextContent().slice(0, s) + r + o.getTextContent().slice(s + n.focus.offset), a = a.anchorNode, i = o === (a.nodeType === 3 ? a.nodeValue : null)), i || Q(e, mo, r), r = r.length, wi && 1 < r && t.inputType === "insertCompositionText" && !e.isComposing() && (n.anchor.offset -= r), b0 || y0 || !e.isComposing() || (ws = 0, Ct(null));
    } else
      Y_(!1, e), Ia && (k1(e, r || void 0), Ia = !1);
    At(), n = et(), L_(n);
  });
}
function oA(t, e) {
  rn(e, () => {
    let n = He();
    if (de(n) && !e.isComposing()) {
      let r = n.anchor;
      Ct(r.key), (t.timeStamp < ws + 30 || r.type === "element" || !n.isCollapsed() || n.anchor.getNode().getFormat() !== n.format) && Q(e, mo, $M);
    }
  });
}
function k1(t, e) {
  var n = t._compositionKey;
  if (Ct(null), n !== null && e != null) {
    if (e === "") {
      e = it(n), t = wf(t.getElementByKey(n)), t !== null && t.nodeValue !== null && J(e) && k0(e, t.nodeValue, null, null, !0);
      return;
    }
    if (e[e.length - 1] === `
` && (n = He(), de(n))) {
      e = n.focus, n.anchor.set(e.key, e.offset, e.type), Q(t, yf, null);
      return;
    }
  }
  Y_(!0, t, e);
}
function aA(t, e) {
  wi ? Ia = !0 : rn(e, () => {
    k1(e, t.data);
  });
}
function sA(t, e) {
  if (ws = t.timeStamp, ow = t.keyCode, !e.isComposing()) {
    var { keyCode: n, shiftKey: r, ctrlKey: i, metaKey: o, altKey: a } = t;
    if (n !== 39 || i || o || a)
      if (n !== 39 || a || r || !i && !o)
        if (n !== 37 || i || o || a)
          if (n !== 37 || a || r || !i && !o)
            if (n !== 38 || i || o)
              if (n !== 40 || i || o)
                if (n === 13 && r)
                  Ka = !0, Q(e, yf, t);
                else if (n === 32)
                  Q(e, C_, t);
                else if ($t && i && n === 79)
                  t.preventDefault(), Ka = !0, Q(e, Ua, !0);
                else if (n !== 13 || r) {
                  var s = $t ? a || o ? !1 : n === 8 || n === 72 && i : i || a || o ? !1 : n === 8;
                  s ? n === 8 ? Q(e, x_, t) : (t.preventDefault(), Q(e, ms, !0)) : n === 27 ? Q(e, E_, t) : (s = $t ? r || a || o ? !1 : n === 46 || n === 68 && i : i || a || o ? !1 : n === 46, s ? n === 46 ? Q(e, T_, t) : (t.preventDefault(), Q(e, ms, !1)) : n === 8 && ($t ? a : i) ? (t.preventDefault(), Q(e, vs, !0)) : n === 46 && ($t ? a : i) ? (t.preventDefault(), Q(e, vs, !1)) : $t && o && n === 8 ? (t.preventDefault(), Q(e, bs, !0)) : $t && o && n === 46 ? (t.preventDefault(), Q(e, bs, !1)) : n === 66 && !a && ($t ? o : i) ? (t.preventDefault(), Q(e, kr, "bold")) : n === 85 && !a && ($t ? o : i) ? (t.preventDefault(), Q(e, kr, "underline")) : n === 73 && !a && ($t ? o : i) ? (t.preventDefault(), Q(e, kr, "italic")) : n !== 9 || a || i || o ? n === 90 && !r && ($t ? o : i) ? (t.preventDefault(), Q(e, g0, void 0)) : (s = $t ? n === 90 && o && r : n === 89 && i || n === 90 && i && r, s ? (t.preventDefault(), Q(e, p0, void 0)) : Hs(e._editorState._selection) && (s = r ? !1 : n === 67 ? $t ? o : i : !1, s ? (t.preventDefault(), Q(e, m0, t)) : (s = r ? !1 : n === 88 ? $t ? o : i : !1, s && (t.preventDefault(), Q(e, v0, t))))) : Q(e, S_, t));
                } else
                  Ka = !1, Q(e, yf, t);
              else
                Q(e, k_, t);
            else
              Q(e, w_, t);
          else
            Q(e, __, t);
        else
          Q(e, y_, t);
      else
        Q(e, b_, t);
    else
      Q(e, v_, t);
    (i || r || a || o) && Q(e, P_, t);
  }
}
function fw(t) {
  let e = t.__lexicalEventHandles;
  return e === void 0 && (e = [], t.__lexicalEventHandles = e), e;
}
let vo = /* @__PURE__ */ new Map();
function cw(t) {
  t = t.target;
  let e = Qn(t == null ? null : t.nodeType === 9 ? t.defaultView : t.ownerDocument.defaultView);
  if (e !== null) {
    var n = j_(e.anchorNode);
    if (n !== null) {
      w1 && (w1 = !1, rn(n, () => {
        var a = Vs(), s = e.anchorNode;
        s !== null && (s = s.nodeType, s === 1 || s === 3) && (a = gw(a, e, n), Fr(a));
      })), t = w0(n), t = t[t.length - 1];
      var r = t._key, i = vo.get(r), o = i || t;
      o !== n && pm(e, o, !1), pm(e, n, !0), n !== t ? vo.set(r, n) : i && vo.delete(r);
    }
  }
}
function lA(t, e) {
  Va === 0 && t.ownerDocument.addEventListener("selectionchange", cw), Va++, t.__collabKitEditor = e;
  let n = fw(t);
  for (let r = 0; r < y1.length; r++) {
    let [i, o] = y1[r], a = typeof o == "function" ? (s) => {
      s._lexicalHandled !== !0 && (s._lexicalHandled = !0, e.isEditable() && o(s, e));
    } : (s) => {
      if (s._lexicalHandled !== !0 && (s._lexicalHandled = !0, e.isEditable()))
        switch (i) {
          case "cut":
            return Q(e, v0, s);
          case "copy":
            return Q(e, m0, s);
          case "paste":
            return Q(e, h0, s);
          case "dragstart":
            return Q(e, N_, s);
          case "dragover":
            return Q(e, M_, s);
          case "dragend":
            return Q(
              e,
              A_,
              s
            );
          case "focus":
            return Q(e, O_, s);
          case "blur":
            return Q(e, D_, s);
          case "drop":
            return Q(e, I_, s);
        }
    };
    t.addEventListener(i, a), n.push(() => {
      t.removeEventListener(i, a);
    });
  }
}
function fA(t, e, n, r) {
  sw = [t, e, n, r];
}
let Kn = class {
  constructor(e, n, r) {
    this._selection = null, this.key = e, this.offset = n, this.type = r;
  }
  is(e) {
    return this.key === e.key && this.offset === e.offset && this.type === e.type;
  }
  isBefore(e) {
    let n = this.getNode(), r = e.getNode(), i = this.offset;
    if (e = e.offset, H(n)) {
      var o = n.getDescendantByIndex(i);
      n = o ?? n;
    }
    return H(r) && (o = r.getDescendantByIndex(e), r = o ?? r), n === r ? i < e : n.isBefore(r);
  }
  getNode() {
    let e = it(this.key);
    return e === null && ee(20), e;
  }
  set(e, n, r) {
    let i = this._selection, o = this.key;
    this.key = e, this.offset = n, this.type = r, Xo() || (Cr() === o && Ct(e), i !== null && (i._cachedNodes = null, i.dirty = !0));
  }
};
function Uu(t, e) {
  let n = e.__key, r = t.offset, i = "element";
  if (J(e))
    i = "text", e = e.getTextContentSize(), r > e && (r = e);
  else if (!H(e)) {
    var o = e.getNextSibling();
    J(o) ? (n = o.__key, r = 0, i = "text") : (o = e.getParent()) && (n = o.__key, r = e.getIndexWithinParent() + 1);
  }
  t.set(n, r, i);
}
function mm(t, e) {
  if (H(e)) {
    let n = e.getLastDescendant();
    H(n) || J(n) ? Uu(t, n) : Uu(t, e);
  } else
    Uu(t, e);
}
function vm(t, e, n) {
  let r = t.getNode(), i = r.getChildAtIndex(t.offset), o = kt(), a = nn(r) ? Ro().append(o) : o;
  o.setFormat(n), i === null ? r.append(a) : i.insertBefore(a), t.is(e) && e.set(o.__key, 0, "text"), t.set(o.__key, 0, "text");
}
function _r(t, e, n, r) {
  t.key = e, t.offset = n, t.type = r;
}
class Ec {
  constructor(e) {
    this.dirty = !1, this._nodes = e, this._cachedNodes = null;
  }
  is(e) {
    if (!Hs(e))
      return !1;
    let n = this._nodes, r = e._nodes;
    return n.size === r.size && Array.from(n).every((i) => r.has(i));
  }
  add(e) {
    this.dirty = !0, this._nodes.add(e), this._cachedNodes = null;
  }
  delete(e) {
    this.dirty = !0, this._nodes.delete(e), this._cachedNodes = null;
  }
  clear() {
    this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
  }
  has(e) {
    return this._nodes.has(e);
  }
  clone() {
    return new Ec(new Set(this._nodes));
  }
  extract() {
    return this.getNodes();
  }
  insertRawText() {
  }
  insertText() {
  }
  insertNodes(e, n) {
    let r = this.getNodes(), i = r.length;
    var o = r[i - 1];
    if (J(o))
      o = o.select();
    else {
      let a = o.getIndexWithinParent() + 1;
      o = o.getParentOrThrow().select(a, a);
    }
    for (o.insertNodes(e, n), e = 0; e < i; e++)
      r[e].remove();
    return !0;
  }
  getNodes() {
    var e = this._cachedNodes;
    if (e !== null)
      return e;
    var n = this._nodes;
    e = [];
    for (let r of n)
      n = it(r), n !== null && e.push(n);
    return Xo() || (this._cachedNodes = e), e;
  }
  getTextContent() {
    let e = this.getNodes(), n = "";
    for (let r = 0; r < e.length; r++)
      n += e[r].getTextContent();
    return n;
  }
}
function de(t) {
  return t instanceof Oi;
}
class Tc {
  constructor(e, n, r) {
    this.gridKey = e, this.anchor = n, this.focus = r, this.dirty = !1, this._cachedNodes = null, n._selection = this, r._selection = this;
  }
  is(e) {
    return E0(e) ? this.gridKey === e.gridKey && this.anchor.is(e.anchor) && this.focus.is(e.focus) : !1;
  }
  set(e, n, r) {
    this.dirty = !0, this.gridKey = e, this.anchor.key = n, this.focus.key = r, this._cachedNodes = null;
  }
  clone() {
    return new Tc(this.gridKey, this.anchor, this.focus);
  }
  isCollapsed() {
    return !1;
  }
  isBackward() {
    return this.focus.isBefore(this.anchor);
  }
  getCharacterOffsets() {
    return Ml(this);
  }
  extract() {
    return this.getNodes();
  }
  insertRawText() {
  }
  insertText() {
  }
  insertNodes(e, n) {
    let r = this.focus.getNode();
    return J_(r.select(0, r.getChildrenSize())).insertNodes(e, n);
  }
  getShape() {
    var e = it(this.anchor.key);
    e === null && ee(21);
    var n = e.getIndexWithinParent();
    e = e.getParentOrThrow().getIndexWithinParent();
    var r = it(this.focus.key);
    r === null && ee(22);
    var i = r.getIndexWithinParent();
    let o = r.getParentOrThrow().getIndexWithinParent();
    return r = Math.min(n, i), n = Math.max(n, i), i = Math.min(e, o), e = Math.max(e, o), { fromX: Math.min(r, n), fromY: Math.min(i, e), toX: Math.max(r, n), toY: Math.max(i, e) };
  }
  getNodes() {
    var e = this._cachedNodes;
    if (e !== null)
      return e;
    e = /* @__PURE__ */ new Set();
    let { fromX: n, fromY: r, toX: i, toY: o } = this.getShape();
    var a = it(this.gridKey);
    Sw(a) || ee(23), e.add(a), a = a.getChildren();
    for (let f = r; f <= o; f++) {
      var s = a[f];
      e.add(s), Nw(s) || ee(24), s = s.getChildren();
      for (let c = n; c <= i; c++) {
        var l = s[c];
        for (Ew(l) || ee(25), e.add(l), l = l.getChildren(); 0 < l.length; ) {
          let u = l.shift();
          e.add(u), H(u) && l.unshift(...u.getChildren());
        }
      }
    }
    return e = Array.from(e), Xo() || (this._cachedNodes = e), e;
  }
  getTextContent() {
    let e = this.getNodes(), n = "";
    for (let r = 0; r < e.length; r++)
      n += e[r].getTextContent();
    return n;
  }
}
function E0(t) {
  return t instanceof Tc;
}
class Oi {
  constructor(e, n, r) {
    this.anchor = e, this.focus = n, this.dirty = !1, this.format = r, this._cachedNodes = null, e._selection = this, n._selection = this;
  }
  is(e) {
    return de(e) ? this.anchor.is(e.anchor) && this.focus.is(e.focus) && this.format === e.format : !1;
  }
  isBackward() {
    return this.focus.isBefore(this.anchor);
  }
  isCollapsed() {
    return this.anchor.is(this.focus);
  }
  getNodes() {
    var e = this._cachedNodes;
    if (e !== null)
      return e;
    var n = this.anchor, r = this.focus;
    e = n.getNode();
    let i = r.getNode();
    return H(e) && (n = e.getDescendantByIndex(n.offset), e = n ?? e), H(i) && (r = i.getDescendantByIndex(r.offset), i = r ?? i), e = e.is(i) ? H(e) && 0 < e.getChildrenSize() ? [] : [e] : e.getNodesBetween(i), Xo() || (this._cachedNodes = e), e;
  }
  setTextNodeRange(e, n, r, i) {
    _r(this.anchor, e.__key, n, "text"), _r(this.focus, r.__key, i, "text"), this._cachedNodes = null, this.dirty = !0;
  }
  getTextContent() {
    let e = this.getNodes();
    if (e.length === 0)
      return "";
    let n = e[0], r = e[e.length - 1], i = this.anchor.isBefore(this.focus), [o, a] = Ml(this), s = "", l = !0;
    for (let f = 0; f < e.length; f++) {
      let c = e[f];
      if (H(c) && !c.isInline())
        l || (s += `
`), l = !c.isEmpty();
      else if (l = !1, J(c)) {
        let u = c.getTextContent();
        c === n ? u = c === r ? o < a ? u.slice(o, a) : u.slice(a, o) : i ? u.slice(o) : u.slice(a) : c === r && (u = i ? u.slice(0, a) : u.slice(0, o)), s += u;
      } else
        !Ye(c) && !Cs(c) || c === r && this.isCollapsed() || (s += c.getTextContent());
    }
    return s;
  }
  applyDOMRange(e) {
    let n = et(), r = n.getEditorState()._selection;
    if (e = dw(e.startContainer, e.startOffset, e.endContainer, e.endOffset, n, r), e !== null) {
      var [i, o] = e;
      _r(this.anchor, i.key, i.offset, i.type), _r(this.focus, o.key, o.offset, o.type), this._cachedNodes = null;
    }
  }
  clone() {
    let e = this.anchor, n = this.focus;
    return new Oi(new Kn(e.key, e.offset, e.type), new Kn(n.key, n.offset, n.type), this.format);
  }
  toggleFormat(e) {
    this.format = z_(this.format, e, null), this.dirty = !0;
  }
  hasFormat(e) {
    return (this.format & ai[e]) !== 0;
  }
  insertRawText(e) {
    let n = e.split(/\r?\n/);
    if (n.length === 1)
      this.insertText(e);
    else {
      e = [];
      let r = n.length;
      for (let i = 0; i < r; i++) {
        let o = n[i];
        o !== "" && e.push(kt(o)), i !== r - 1 && e.push(Po());
      }
      this.insertNodes(e);
    }
  }
  insertText(e) {
    var n = this.anchor, r = this.focus, i = this.isCollapsed() || n.isBefore(r), o = this.format;
    i && n.type === "element" ? vm(n, r, o) : i || r.type !== "element" || vm(r, n, o);
    var a = this.getNodes(), s = a.length, l = i ? r : n;
    r = (i ? n : r).offset;
    var f = l.offset;
    n = a[0], J(n) || ee(26), i = n.getTextContent().length;
    var c = n.getParentOrThrow(), u = a[s - 1];
    if (this.isCollapsed() && r === i && (n.isSegmented() || n.isToken() || !n.canInsertTextAfter() || !c.canInsertTextAfter() && n.getNextSibling() === null)) {
      var d = n.getNextSibling();
      if ((!J(d) || f1(d)) && (d = kt(), d.setFormat(o), c.canInsertTextAfter() ? n.insertAfter(d) : c.insertAfter(d)), d.select(0, 0), n = d, e !== "") {
        this.insertText(e);
        return;
      }
    } else if (this.isCollapsed() && r === 0 && (n.isSegmented() || n.isToken() || !n.canInsertTextBefore() || !c.canInsertTextBefore() && n.getPreviousSibling() === null)) {
      if (d = n.getPreviousSibling(), (!J(d) || f1(d)) && (d = kt(), d.setFormat(o), c.canInsertTextBefore() ? n.insertBefore(d) : c.insertBefore(d)), d.select(), n = d, e !== "") {
        this.insertText(e);
        return;
      }
    } else if (n.isSegmented() && r !== i)
      c = kt(n.getTextContent()), c.setFormat(o), n.replace(c), n = c;
    else if (!(this.isCollapsed() || e === "" || (d = u.getParent(), c.canInsertTextBefore() && c.canInsertTextAfter() && (!H(d) || d.canInsertTextBefore() && d.canInsertTextAfter())))) {
      this.insertText(""), uw(this.anchor, this.focus, null), this.insertText(e);
      return;
    }
    if (s === 1)
      if (n.isToken())
        e = kt(e), e.select(), n.replace(e);
      else {
        if (a = n.getFormat(), r === f && a !== o)
          if (n.getTextContent() === "")
            n.setFormat(o);
          else {
            a = kt(e), a.setFormat(o), a.select(), r === 0 ? n.insertBefore(a, !1) : ([s] = n.splitText(r), s.insertAfter(a, !1)), a.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= e.length);
            return;
          }
        n = n.spliceText(r, f - r, e, !0), n.getTextContent() === "" ? n.remove() : this.anchor.type === "text" && (n.isComposing() ? this.anchor.offset -= e.length : this.format = a);
      }
    else {
      o = /* @__PURE__ */ new Set([...n.getParentKeys(), ...u.getParentKeys()]);
      var h = H(n) ? n : n.getParentOrThrow();
      if (c = H(u) ? u : u.getParentOrThrow(), d = u, !h.is(c) && c.isInline())
        do
          d = c, c = c.getParentOrThrow();
        while (c.isInline());
      l.type === "text" && (f !== 0 || u.getTextContent() === "") || l.type === "element" && u.getIndexWithinParent() < f ? J(u) && !u.isToken() && f !== u.getTextContentSize() ? (u.isSegmented() && (l = kt(u.getTextContent()), u.replace(l), u = l), u = u.spliceText(0, f, ""), o.add(u.__key)) : (l = u.getParentOrThrow(), l.canBeEmpty() || l.getChildrenSize() !== 1 ? u.remove() : l.remove()) : o.add(u.__key), l = c.getChildren(), f = new Set(a), u = h.is(c), h = h.isInline() && n.getNextSibling() === null ? h : n;
      for (let p = l.length - 1; 0 <= p; p--) {
        let m = l[p];
        if (m.is(n) || H(m) && m.isParentOf(n))
          break;
        m.isAttached() && (!f.has(m) || m.is(d) ? u || h.insertAfter(m, !1) : m.remove());
      }
      if (!u)
        for (l = c, f = null; l !== null; )
          u = l.getChildren(), c = u.length, (c === 0 || u[c - 1].is(f)) && (o.delete(l.__key), f = l), l = l.getParent();
      for (n.isToken() ? r === i ? n.select() : (e = kt(e), e.select(), n.replace(e)) : (n = n.spliceText(r, i - r, e, !0), n.getTextContent() === "" ? n.remove() : n.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= e.length)), e = 1; e < s; e++)
        n = a[e], o.has(n.__key) || n.remove();
    }
  }
  removeText() {
    this.insertText("");
  }
  formatText(e) {
    if (this.isCollapsed())
      this.toggleFormat(e), Ct(null);
    else {
      var n = this.getNodes(), r = [];
      for (var i of n)
        J(i) && r.push(i);
      var o = r.length;
      if (o === 0)
        this.toggleFormat(e), Ct(null);
      else {
        i = this.anchor;
        var a = this.focus, s = this.isBackward();
        n = s ? a : i, i = s ? i : a;
        var l = 0, f = r[0];
        if (a = n.type === "element" ? 0 : n.offset, n.type === "text" && a === f.getTextContentSize() && (l = 1, f = r[1], a = 0), f != null) {
          s = f.getFormatFlags(e, null);
          var c = o - 1, u = r[c];
          if (o = i.type === "text" ? i.offset : u.getTextContentSize(), f.is(u))
            a !== o && (a === 0 && o === f.getTextContentSize() ? f.setFormat(s) : (e = f.splitText(a, o), e = a === 0 ? e[0] : e[1], e.setFormat(s), n.type === "text" && n.set(e.__key, 0, "text"), i.type === "text" && i.set(e.__key, o - a, "text")), this.format = s);
          else {
            a !== 0 && ([, f] = f.splitText(a), a = 0), f.setFormat(s);
            var d = u.getFormatFlags(e, s);
            for (0 < o && (o !== u.getTextContentSize() && ([u] = u.splitText(o)), u.setFormat(d)), l += 1; l < c; l++) {
              let h = r[l];
              if (!h.isToken()) {
                let p = h.getFormatFlags(e, d);
                h.setFormat(p);
              }
            }
            n.type === "text" && n.set(f.__key, a, "text"), i.type === "text" && i.set(u.__key, o, "text"), this.format = s | d;
          }
        }
      }
    }
  }
  insertNodes(e, n) {
    if (!this.isCollapsed()) {
      var r = this.isBackward() ? this.anchor : this.focus, i = r.getNode().getNextSibling();
      if (i = i ? i.getKey() : null, r = (r = r.getNode().getPreviousSibling()) ? r.getKey() : null, this.removeText(), this.isCollapsed() && this.focus.type === "element") {
        if (this.focus.key === i && this.focus.offset === 0) {
          var o = kt();
          this.focus.getNode().insertBefore(o);
        } else
          this.focus.key === r && this.focus.offset === this.focus.getNode().getChildrenSize() && (o = kt(), this.focus.getNode().insertAfter(o));
        o && (this.focus.set(o.__key, 0, "text"), this.anchor.set(o.__key, 0, "text"));
      }
    }
    i = this.anchor, r = i.offset;
    var a = i.getNode();
    o = a, i.type === "element" && (o = i.getNode(), i = o.getChildAtIndex(r - 1), o = i === null ? o : i), i = [];
    var s = a.getNextSiblings(), l = Nr(a) ? null : a.getTopLevelElementOrThrow();
    if (J(a))
      if (o = a.getTextContent().length, r === 0 && o !== 0)
        o = a.getPreviousSibling(), o = o !== null ? o : a.getParentOrThrow(), i.push(a);
      else if (r === o)
        o = a;
      else {
        if (a.isToken())
          return !1;
        [o, a] = a.splitText(r), i.push(a);
      }
    a = o, i.push(...s), s = e[0];
    var f = !1, c = null;
    for (let p = 0; p < e.length; p++) {
      var u = e[p];
      if (Ye(o) || !H(u) || u.isInline())
        f && !Ye(u) && Nr(o.getParent()) && ee(28);
      else {
        if (u.is(s)) {
          if (H(o) && o.isEmpty() && o.canReplaceWith(u)) {
            o.replace(u), o = u, f = !0;
            continue;
          }
          var d = u.getFirstDescendant();
          if (B_(d)) {
            for (d = d.getParentOrThrow(); d.isInline(); )
              d = d.getParentOrThrow();
            if (c = d.getChildren(), f = c.length, H(o)) {
              var h = o.getFirstChild();
              for (let m = 0; m < f; m++) {
                let v = c[m];
                h === null ? o.append(v) : h.insertAfter(v), h = v;
              }
            } else {
              for (h = f - 1; 0 <= h; h--)
                o.insertAfter(c[h]);
              o = o.getParentOrThrow();
            }
            if (c = c[f - 1], d.remove(), f = !0, d.is(u))
              continue;
          }
        }
        J(o) && (l === null && ee(27), o = l);
      }
      f = !1, H(o) && !o.isInline() ? (c = u, Ye(u) && !u.isInline() ? o = o.insertAfter(u, !1) : H(u) ? (u.canBeEmpty() || !u.isEmpty()) && (nn(o) ? (d = o.getChildAtIndex(r), d !== null ? d.insertBefore(u) : o.append(u), o = u) : o = o.insertAfter(u, !1)) : (d = o.getFirstChild(), d !== null ? d.insertBefore(u) : o.append(u), o = u)) : !H(u) || H(u) && u.isInline() || Ye(o) && !o.isInline() ? (c = u, o = o.insertAfter(u, !1)) : (u = o.getParentOrThrow(), Cs(o) && o.remove(), o = u, p--);
    }
    if (n && (J(a) ? a.select() : (e = o.getPreviousSibling(), J(e) ? e.select() : (e = o.getIndexWithinParent(), o.getParentOrThrow().select(e, e)))), H(o)) {
      if (e = J(c) ? c : H(c) && c.isInline() ? c.getLastDescendant() : o.getLastDescendant(), n || (e === null ? o.select() : J(e) ? e.getTextContent() === "" ? e.selectPrevious() : e.select() : e.selectNext()), i.length !== 0)
        for (n = o, e = i.length - 1; 0 <= e; e--)
          r = i[e], l = r.getParentOrThrow(), !H(o) || km(r) || Ye(r) && (!r.isInline() || r.isIsolated()) ? H(o) || km(r) ? H(r) && !r.canInsertAfter(o) ? (a = l.constructor.clone(l), H(a) || ee(29), a.append(r), o.insertAfter(a)) : o.insertAfter(r) : (o.insertBefore(r), o = r) : (n === o ? o.append(r) : o.insertBefore(r), o = r), l.isEmpty() && !l.canBeEmpty() && l.remove();
    } else
      n || (J(o) ? o.select() : (n = o.getParentOrThrow(), e = o.getIndexWithinParent() + 1, n.select(e, e)));
    return !0;
  }
  insertParagraph() {
    this.isCollapsed() || this.removeText();
    var e = this.anchor, n = e.offset, r = [];
    if (e.type === "text") {
      var i = e.getNode(), o = i.getNextSiblings().reverse(), a = i.getParentOrThrow(), s = a.isInline(), l = s ? a.getTextContentSize() : i.getTextContentSize();
      n === 0 ? o.push(i) : (s && (r = a.getNextSiblings()), n === l || s && n === i.getTextContentSize() || ([, i] = i.splitText(n), o.push(i)));
    } else {
      if (a = e.getNode(), Nr(a)) {
        o = Ro(), r = a.getChildAtIndex(n), o.select(), r !== null ? r.insertBefore(o, !1) : a.append(o);
        return;
      }
      o = a.getChildren().slice(n).reverse();
    }
    if (i = o.length, n === 0 && 0 < i && a.isInline()) {
      if (r = a.getParentOrThrow(), o = r.insertNewAfter(this, !1), H(o))
        for (r = r.getChildren(), a = 0; a < r.length; a++)
          o.append(r[a]);
    } else if (s = a.insertNewAfter(this, !1), s === null)
      this.insertLineBreak();
    else if (H(s))
      if (l = a.getFirstChild(), n === 0 && (a.is(e.getNode()) || l && l.is(e.getNode())) && 0 < i)
        a.insertBefore(s);
      else {
        if (a = null, n = r.length, e = s.getParentOrThrow(), 0 < n)
          for (l = 0; l < n; l++)
            e.append(r[l]);
        if (i !== 0)
          for (r = 0; r < i; r++)
            n = o[r], a === null ? s.append(n) : a.insertBefore(n), a = n;
        s.canBeEmpty() || s.getChildrenSize() !== 0 ? s.selectStart() : (s.selectPrevious(), s.remove());
      }
  }
  insertLineBreak(e) {
    let n = Po();
    var r = this.anchor;
    r.type === "element" && (r = r.getNode(), nn(r) && this.insertParagraph()), e ? this.insertNodes([n], !0) : this.insertNodes([n]) && n.selectNext(0, 0);
  }
  getCharacterOffsets() {
    return Ml(this);
  }
  extract() {
    var e = this.getNodes(), n = e.length, r = n - 1, i = this.anchor;
    let o = this.focus;
    var a = e[0];
    let s = e[r], [l, f] = Ml(this);
    return n === 0 ? [] : n === 1 ? J(a) && !this.isCollapsed() ? (e = l > f ? f : l, r = a.splitText(e, l > f ? l : f), e = e === 0 ? r[0] : r[1], e != null ? [e] : []) : [a] : (n = i.isBefore(o), J(a) && (i = n ? l : f, i === a.getTextContentSize() ? e.shift() : i !== 0 && ([, a] = a.splitText(i), e[0] = a)), J(s) && (a = s.getTextContent().length, n = n ? f : l, n === 0 ? e.pop() : n !== a && ([s] = s.splitText(n), e[r] = s)), e);
  }
  modify(e, n, r) {
    var i = this.focus, o = this.anchor, a = e === "move", s = c1(i, n);
    if (Ye(s) && !s.isIsolated())
      a && s.isKeyboardSelectable() ? (n = C1(), n.add(s.__key), Fr(n)) : (e = n ? s.getPreviousSibling() : s.getNextSibling(), J(e) ? (s = e.__key, n = n ? e.getTextContent().length : 0, i.set(s, n, "text"), a && o.set(s, n, "text")) : (r = s.getParentOrThrow(), H(e) ? (r = e.__key, s = n ? e.getChildrenSize() : 0) : (s = s.getIndexWithinParent(), r = r.__key, n || s++), i.set(r, s, "element"), a && o.set(r, s, "element")));
    else if (o = et(), i = Qn(o._window)) {
      var l = o._blockCursorElement, f = o._rootElement;
      if (f === null || l === null || !H(s) || s.isInline() || s.canBeEmpty() || d1(l, o, f), i.modify(e, n ? "backward" : "forward", r), 0 < i.rangeCount && (s = i.getRangeAt(0), o = this.anchor.getNode(), o = nn(o) ? o : G_(o), this.applyDOMRange(s), this.dirty = !0, !a)) {
        for (a = this.getNodes(), e = [], r = !1, l = 0; l < a.length; l++)
          f = a[l], xf(f, o) ? e.push(f) : r = !0;
        r && 0 < e.length && (n ? (n = e[0], H(n) ? n.selectStart() : n.getParentOrThrow().selectStart()) : (n = e[e.length - 1], H(n) ? n.selectEnd() : n.getParentOrThrow().selectEnd())), (i.anchorNode !== s.startContainer || i.anchorOffset !== s.startOffset) && (n = this.focus, a = this.anchor, i = a.key, s = a.offset, o = a.type, _r(a, n.key, n.offset, n.type), _r(n, i, s, o), this._cachedNodes = null);
      }
    }
  }
  deleteCharacter(e) {
    if (this.isCollapsed()) {
      var n = this.anchor, r = this.focus, i = n.getNode();
      if (!e && (n.type === "element" && H(i) && n.offset === i.getChildrenSize() || n.type === "text" && n.offset === i.getTextContentSize())) {
        var o = i.getParent();
        if (o = i.getNextSibling() || (o === null ? null : o.getNextSibling()), H(o) && !o.canExtractContents())
          return;
      }
      if (o = c1(r, e), Ye(o) && !o.isIsolated()) {
        o.isKeyboardSelectable() && H(i) && i.getChildrenSize() === 0 ? (i.remove(), e = C1(), e.add(o.__key), Fr(e)) : o.remove();
        return;
      }
      if (this.modify("extend", e, "character"), this.isCollapsed()) {
        if (e && n.offset === 0 && (n.type === "element" ? n.getNode() : n.getNode().getParentOrThrow()).collapseAtStart(this))
          return;
      } else {
        if (o = r.type === "text" ? r.getNode() : null, i = n.type === "text" ? n.getNode() : null, o !== null && o.isSegmented()) {
          if (n = r.offset, r = o.getTextContentSize(), o.is(i) || e && n !== r || !e && n !== 0) {
            ym(o, e, n);
            return;
          }
        } else if (i !== null && i.isSegmented() && (n = n.offset, r = i.getTextContentSize(), i.is(o) || e && n !== 0 || !e && n !== r)) {
          ym(i, e, n);
          return;
        }
        if (i = this.anchor, o = this.focus, n = i.getNode(), r = o.getNode(), n === r && i.type === "text" && o.type === "text") {
          var a = i.offset, s = o.offset;
          let l = a < s;
          r = l ? a : s, s = l ? s : a, a = s - 1, r !== a && (n = n.getTextContent().slice(r, s), V_(n) || (e ? o.offset = a : i.offset = a));
        }
      }
    }
    this.removeText();
  }
  deleteLine(e) {
    this.isCollapsed() && (this.anchor.type === "text" && this.modify("extend", e, "lineboundary"), (e ? this.focus : this.anchor).offset === 0 && this.modify("extend", e, "character")), this.removeText();
  }
  deleteWord(e) {
    this.isCollapsed() && this.modify("extend", e, "word"), this.removeText();
  }
}
function Hs(t) {
  return t instanceof Ec;
}
function bm(t) {
  let e = t.offset;
  return t.type === "text" ? e : (t = t.getNode(), e === t.getChildrenSize() ? t.getTextContent().length : 0);
}
function Ml(t) {
  let e = t.anchor;
  return t = t.focus, e.type === "element" && t.type === "element" && e.key === t.key && e.offset === t.offset ? [0, 0] : [bm(e), bm(t)];
}
function ym(t, e, n) {
  let r = t.getTextContent().split(/(?=\s)/g), i = r.length, o = 0, a = 0;
  for (let s = 0; s < i; s++) {
    let l = r[s], f = s === i - 1;
    if (a = o, o += l.length, e && o === n || o > n || f) {
      r.splice(s, 1), f && (a = void 0);
      break;
    }
  }
  e = r.join("").trim(), e === "" ? t.remove() : (t.setTextContent(e), t.select(a, a));
}
function _m(t, e, n, r) {
  var i = e;
  if (t.nodeType === 1) {
    let s = !1;
    var o = t.childNodes, a = o.length;
    i === a && (s = !0, i = a - 1);
    let l = o[i];
    if (a = !1, l === r._blockCursorElement ? (l = o[i + 1], a = !0) : r._blockCursorElement !== null && i--, r = co(l), J(r))
      i = s ? r.getTextContentSize() : 0;
    else {
      if (o = co(t), o === null)
        return null;
      if (H(o) ? (t = o.getChildAtIndex(i), (e = H(t)) && (e = t.getParent(), e = n === null || e === null || !e.canBeEmpty() || e !== n.getNode()), e && (n = s ? t.getLastDescendant() : t.getFirstDescendant(), n === null ? (o = t, i = 0) : (t = n, o = H(t) ? t : t.getParentOrThrow())), J(t) ? (r = t, o = null, i = s ? t.getTextContentSize() : 0) : t !== o && s && !a && i++) : (i = o.getIndexWithinParent(), i = e === 0 && Ye(o) && co(t) === o ? i : i + 1, o = o.getParentOrThrow()), H(o))
        return new Kn(o.__key, i, "element");
    }
  } else
    r = co(t);
  return J(r) ? new Kn(r.__key, i, "text") : null;
}
function wm(t, e, n) {
  var r = t.offset, i = t.getNode();
  r === 0 ? (r = i.getPreviousSibling(), i = i.getParent(), e ? (n || !e) && r === null && H(i) && i.isInline() && (e = i.getPreviousSibling(), J(e) && (t.key = e.__key, t.offset = e.getTextContent().length)) : H(r) && !n && r.isInline() ? (t.key = r.__key, t.offset = r.getChildrenSize(), t.type = "element") : J(r) && (t.key = r.__key, t.offset = r.getTextContent().length)) : r === i.getTextContent().length && (r = i.getNextSibling(), i = i.getParent(), e && H(r) && r.isInline() ? (t.key = r.__key, t.offset = 0, t.type = "element") : (n || e) && r === null && H(i) && i.isInline() && !i.canInsertTextAfter() && (e = i.getNextSibling(), J(e) && (t.key = e.__key, t.offset = 0)));
}
function uw(t, e, n) {
  if (t.type === "text" && e.type === "text") {
    var r = t.isBefore(e);
    let i = t.is(e);
    wm(t, r, i), wm(e, !r, i), i && (e.key = t.key, e.offset = t.offset, e.type = t.type), r = et(), r.isComposing() && r._compositionKey !== t.key && de(n) && (r = n.anchor, n = n.focus, _r(t, r.key, r.offset, r.type), _r(e, n.key, n.offset, n.type));
  }
}
function dw(t, e, n, r, i, o) {
  return t === null || n === null || !_c(i, t, n) || (e = _m(t, e, de(o) ? o.anchor : null, i), e === null) || (r = _m(n, r, de(o) ? o.focus : null, i), r === null || e.type === "element" && r.type === "element" && (t = co(t), n = co(n), Ye(t) && Ye(n))) ? null : (uw(e, r, o), [e, r]);
}
function km(t) {
  return H(t) && !t.isInline();
}
function hw(t, e, n, r, i, o) {
  let a = Xn();
  return t = new Oi(new Kn(t, e, i), new Kn(n, r, o), 0), t.dirty = !0, a._selection = t;
}
function C1() {
  return new Ec(/* @__PURE__ */ new Set());
}
function cA(t) {
  let e = t.getEditorState()._selection, n = Qn(t._window);
  return Hs(e) || E0(e) ? e.clone() : gw(e, n, t);
}
function gw(t, e, n) {
  var r = n._window;
  if (r === null)
    return null;
  var i = r.event, o = i ? i.type : void 0;
  r = o === "selectionchange", i = !l1 && (r || o === "beforeinput" || o === "compositionstart" || o === "compositionend" || o === "click" && i && i.detail === 3 || o === "drop" || o === void 0);
  let a;
  if (!de(t) || i) {
    if (e === null)
      return null;
    if (i = e.anchorNode, o = e.focusNode, a = e.anchorOffset, e = e.focusOffset, r && de(t) && !_c(n, i, o))
      return t.clone();
  } else
    return t.clone();
  if (n = dw(i, a, o, e, n, t), n === null)
    return null;
  let [s, l] = n;
  return new Oi(s, l, de(t) ? t.format : 0);
}
function He() {
  return Xn()._selection;
}
function Vs() {
  return et()._editorState._selection;
}
function Tf(t, e, n, r = 1) {
  var i = t.anchor, o = t.focus, a = i.getNode(), s = o.getNode();
  if (e.is(a) || e.is(s))
    if (a = e.__key, t.isCollapsed())
      e = i.offset, n <= e && (n = Math.max(0, e + r), i.set(a, n, "element"), o.set(a, n, "element"), Cm(t));
    else {
      var l = t.isBackward();
      s = l ? o : i;
      var f = s.getNode();
      i = l ? i : o, o = i.getNode(), e.is(f) && (f = s.offset, n <= f && s.set(a, Math.max(0, f + r), "element")), e.is(o) && (e = i.offset, n <= e && i.set(a, Math.max(0, e + r), "element")), Cm(t);
    }
}
function Cm(t) {
  var e = t.anchor, n = e.offset;
  let r = t.focus;
  var i = r.offset, o = e.getNode(), a = r.getNode();
  if (t.isCollapsed())
    H(o) && (a = o.getChildrenSize(), a = (i = n >= a) ? o.getChildAtIndex(a - 1) : o.getChildAtIndex(n), J(a) && (n = 0, i && (n = a.getTextContentSize()), e.set(a.__key, n, "text"), r.set(a.__key, n, "text")));
  else {
    if (H(o)) {
      let s = o.getChildrenSize();
      n = (t = n >= s) ? o.getChildAtIndex(s - 1) : o.getChildAtIndex(n), J(n) && (o = 0, t && (o = n.getTextContentSize()), e.set(n.__key, o, "text"));
    }
    H(a) && (n = a.getChildrenSize(), i = (e = i >= n) ? a.getChildAtIndex(n - 1) : a.getChildAtIndex(i), J(i) && (a = 0, e && (a = i.getTextContentSize()), r.set(i.__key, a, "text")));
  }
}
function uA(t, e) {
  if (e = e.getEditorState()._selection, t = t._selection, de(t)) {
    var n = t.anchor;
    let r = t.focus, i;
    n.type === "text" && (i = n.getNode(), i.selectionTransform(e, t)), r.type === "text" && (n = r.getNode(), i !== n && n.selectionTransform(e, t));
  }
}
function Sf(t, e, n, r, i) {
  let o = null, a = 0, s = null;
  r !== null ? (o = r.__key, J(r) ? (a = r.getTextContentSize(), s = "text") : H(r) && (a = r.getChildrenSize(), s = "element")) : i !== null && (o = i.__key, J(i) ? s = "text" : H(i) && (s = "element")), o !== null && s !== null ? t.set(o, a, s) : (a = e.getIndexWithinParent(), a === -1 && (a = n.getChildrenSize()), t.set(n.__key, a, "element"));
}
function xm(t, e, n, r, i) {
  t.type === "text" ? (t.key = n, e || (t.offset += i)) : t.offset > r.getIndexWithinParent() && --t.offset;
}
function dA(t, e, n, r, i, o, a) {
  let s = r.anchorNode, l = r.focusNode, f = r.anchorOffset, c = r.focusOffset, u = document.activeElement;
  if (!(i.has("collaboration") && u !== o || u !== null && F_(u)))
    if (de(e)) {
      var d = e.anchor, h = e.focus, p = d.key, m = h.key, v = Cf(n, p);
      m = Cf(n, m);
      var b = d.offset, k = h.offset, _ = e.format, E = e.isCollapsed(), S = v, C = m, N = !1;
      if (d.type === "text" && (S = wf(v), N = d.getNode().getFormat() !== _), h.type === "text" && (C = wf(m)), S !== null && C !== null) {
        if (E && (t === null || N || de(t) && t.format !== _) && fA(_, b, p, performance.now()), f === b && c === k && s === S && l === C && (r.type !== "Range" || !E) && (u !== null && o.contains(u) || o.focus({ preventScroll: !0 }), d.type !== "element"))
          return;
        try {
          LM && 1e3 < a ? window.requestAnimationFrame(() => r.setBaseAndExtent(S, b, C, k)) : r.setBaseAndExtent(S, b, C, k);
        } catch {
        }
        !i.has("skip-scroll-into-view") && e.isCollapsed() && o !== null && o === document.activeElement && (t = e instanceof Oi && e.anchor.type === "element" ? S.childNodes[b] || null : 0 < r.rangeCount ? r.getRangeAt(0) : null, t !== null && (t = t.getBoundingClientRect(), QM(n, t, o))), _1 = !0;
      }
    } else
      t !== null && _c(
        n,
        s,
        l
      ) && r.removeAllRanges();
}
let pt = null, mt = null, Vt = !1, Hu = !1, ks = 0, Em = { characterData: !0, childList: !0, subtree: !0 };
function Xo() {
  return Vt || pt !== null && pt._readOnly;
}
function At() {
  Vt && ee(13);
}
function Xn() {
  return pt === null && ee(15), pt;
}
function et() {
  return mt === null && ee(16), mt;
}
function Tm(t, e, n) {
  var r = e.__type;
  let i = t._nodes.get(r);
  for (i === void 0 && ee(30), t = n.get(r), t === void 0 && (t = Array.from(i.transforms), n.set(r, t)), n = t.length, r = 0; r < n && (t[r](e), e.isAttached()); r++)
    ;
}
function hA(t, e) {
  e = e._dirtyLeaves, t = t._nodeMap;
  for (let n of e)
    e = t.get(n), J(e) && e.isAttached() && e.isSimpleText() && !e.isUnmergeable() && X_(e);
}
function gA(t, e) {
  let n = e._dirtyLeaves, r = e._dirtyElements;
  t = t._nodeMap;
  let i = Cr(), o = /* @__PURE__ */ new Map();
  var a = n;
  let s = a.size;
  for (var l = r, f = l.size; 0 < s || 0 < f; ) {
    if (0 < s) {
      e._dirtyLeaves = /* @__PURE__ */ new Set();
      for (let c of a)
        a = t.get(c), J(a) && a.isAttached() && a.isSimpleText() && !a.isUnmergeable() && X_(a), a !== void 0 && a !== void 0 && a.__key !== i && a.isAttached() && Tm(e, a, o), n.add(c);
      if (a = e._dirtyLeaves, s = a.size, 0 < s) {
        ks++;
        continue;
      }
    }
    e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements = /* @__PURE__ */ new Map();
    for (let c of l)
      l = c[0], f = c[1], (l === "root" || f) && (a = t.get(l), a !== void 0 && a !== void 0 && a.__key !== i && a.isAttached() && Tm(e, a, o), r.set(l, f));
    a = e._dirtyLeaves, s = a.size, l = e._dirtyElements, f = l.size, ks++;
  }
  e._dirtyLeaves = n, e._dirtyElements = r;
}
function T0(t, e) {
  var n = e.get(t.type);
  if (n === void 0 && ee(17), n = n.klass, t.type !== n.getType() && ee(18), n = n.importJSON(t), t = t.children, H(n) && Array.isArray(t))
    for (let r = 0; r < t.length; r++) {
      let i = T0(t[r], e);
      n.append(i);
    }
  return n;
}
function Sm(t, e) {
  let n = pt, r = Vt, i = mt;
  pt = t, Vt = !0, mt = null;
  try {
    return e();
  } finally {
    pt = n, Vt = r, mt = i;
  }
}
function li(t) {
  var e = t._pendingEditorState, n = t._rootElement, r = t._headless || n === null;
  if (e !== null) {
    var i = t._editorState, o = i._selection, a = e._selection, s = t._dirtyType !== 0, l = pt, f = Vt, c = mt, u = t._updating, d = t._observer, h = null;
    if (t._pendingEditorState = null, t._editorState = e, !r && s && d !== null) {
      mt = t, pt = e, Vt = !1, t._updating = !0;
      try {
        var p = t._dirtyType, m = t._dirtyElements, v = t._dirtyLeaves;
        d.disconnect(), Mt = ar = ct = "", Z_ = p === 2, Sl = null, It = t, ki = t._config, ys = t._nodes, xc = It._listeners.mutation, h1 = m, g1 = v, Ci = i._nodeMap, jr = e._nodeMap, x0 = e._readOnly, p1 = new Map(t._keyToDOMMap);
        var b = /* @__PURE__ */ new Map();
        _s = b, Sa("root", null), _s = p1 = ki = jr = Ci = g1 = h1 = ys = It = void 0, h = b;
      } catch (N) {
        if (N instanceof Error && t._onError(N), Hu)
          throw N;
        Cw(t, null, n, e), $_(t), t._dirtyType = 2, Hu = !0, li(t), Hu = !1;
        return;
      } finally {
        d.observe(n, Em), t._updating = u, pt = l, Vt = f, mt = c;
      }
    }
    e._readOnly || (e._readOnly = !0), u = t._dirtyLeaves, b = t._dirtyElements, p = t._normalizedNodes, v = t._updateTags, f = t._deferred, m = e._nodeMap.size, s && (t._dirtyType = 0, t._cloneNotNeeded.clear(), t._dirtyLeaves = /* @__PURE__ */ new Set(), t._dirtyElements = /* @__PURE__ */ new Map(), t._normalizedNodes = /* @__PURE__ */ new Set(), t._updateTags = /* @__PURE__ */ new Set());
    var k = t._decorators, _ = t._pendingDecorators || k, E = e._nodeMap, S;
    for (S in _)
      E.has(S) || (_ === k && (_ = H_(t)), delete _[S]);
    if (r = r ? null : Qn(t._window), t._editable && r !== null && (s || a === null || a.dirty)) {
      mt = t, pt = e;
      try {
        if (d !== null && d.disconnect(), s || a === null || a.dirty) {
          var C = t._blockCursorElement;
          C !== null && d1(C, t, n), dA(o, a, t, r, v, n, m);
        }
        e: {
          let N = t._blockCursorElement;
          if (de(a) && a.isCollapsed() && a.anchor.type === "element" && n.contains(document.activeElement)) {
            let $ = a.anchor, I = $.getNode(), O = $.offset, y = I.getChildrenSize();
            if (s = !1, C = null, O === y) {
              let A = I.getChildAtIndex(O - 1);
              Bu(A) && (s = !0);
            } else {
              let A = I.getChildAtIndex(O);
              if (Bu(A)) {
                let z = A.getPreviousSibling();
                (z === null || Bu(z)) && (s = !0, C = t.getElementByKey(A.__key));
              }
            }
            if (s) {
              let A = t.getElementByKey(I.__key);
              if (N === null) {
                let z = t._config.theme, F = document.createElement("div");
                F.contentEditable = "false", F.setAttribute("data-lexical-cursor", "true");
                let P = z.blockCursor;
                if (P !== void 0) {
                  if (typeof P == "string") {
                    let L = P.split(" ");
                    P = z.blockCursor = L;
                  }
                  P !== void 0 && F.classList.add(...P);
                }
                t._blockCursorElement = N = F;
              }
              n.style.caretColor = "transparent", C === null ? A.appendChild(N) : A.insertBefore(N, C);
              break e;
            }
          }
          N !== null && d1(N, t, n);
        }
        d !== null && d.observe(n, Em);
      } finally {
        mt = c, pt = l;
      }
    }
    if (h !== null)
      for (n = h, l = Array.from(t._listeners.mutation), c = l.length, d = 0; d < c; d++) {
        let [N, $] = l[d];
        h = n.get($), h !== void 0 && N(h, { dirtyLeaves: u, updateTags: v });
      }
    if (de(a) || a === null || o !== null && o.is(a) || t.dispatchCommand(d0, void 0), o = t._pendingDecorators, o !== null && (t._decorators = o, t._pendingDecorators = null, Ya("decorator", t, !0, o)), o = lm(i), a = lm(e), o !== a && Ya("textcontent", t, !0, a), Ya("update", t, !0, { dirtyElements: b, dirtyLeaves: u, editorState: e, normalizedNodes: p, prevEditorState: i, tags: v }), t._deferred = [], f.length !== 0) {
      e = t._updating, t._updating = !0;
      try {
        for (i = 0; i < f.length; i++)
          f[i]();
      } finally {
        t._updating = e;
      }
    }
    if (e = t._updates, e.length !== 0 && (e = e.shift())) {
      let [N, $] = e;
      pw(t, N, $);
    }
  }
}
function Ya(t, e, n, ...r) {
  let i = e._updating;
  e._updating = n;
  try {
    let o = Array.from(e._listeners[t]);
    for (t = 0; t < o.length; t++)
      o[t].apply(null, r);
  } finally {
    e._updating = i;
  }
}
function Q(t, e, n) {
  if (t._updating === !1 || mt !== t) {
    let o = !1;
    return t.update(() => {
      o = Q(t, e, n);
    }), o;
  }
  let r = w0(t);
  for (let o = 4; 0 <= o; o--)
    for (let a = 0; a < r.length; a++) {
      var i = r[a]._commands.get(e);
      if (i !== void 0 && (i = i[o], i !== void 0)) {
        i = Array.from(i);
        let s = i.length;
        for (let l = 0; l < s; l++)
          if (i[l](n, t) === !0)
            return !0;
      }
    }
  return !1;
}
function Im(t, e) {
  let n = t._updates;
  for (e = e || !1; n.length !== 0; ) {
    var r = n.shift();
    if (r) {
      let [i, o] = r, a;
      o !== void 0 && (r = o.onUpdate, a = o.tag, o.skipTransforms && (e = !0), r && t._deferred.push(r), a && t._updateTags.add(a)), i();
    }
  }
  return e;
}
function pw(t, e, n) {
  let r = t._updateTags;
  var i, o = i = !1;
  if (n !== void 0) {
    var a = n.onUpdate;
    i = n.tag, i != null && r.add(i), i = n.skipTransforms || !1, o = n.discrete || !1;
  }
  a && t._deferred.push(a);
  let s = t._editorState;
  n = t._pendingEditorState, a = !1, (n === null || n._readOnly) && (n = t._pendingEditorState = new yw(new Map((n || s)._nodeMap)), a = !0), n._flushSync = o, o = pt;
  let l = Vt, f = mt, c = t._updating;
  pt = n, Vt = !1, t._updating = !0, mt = t;
  try {
    a && (t._headless ? s._selection != null && (n._selection = s._selection.clone()) : n._selection = cA(t));
    let u = t._compositionKey;
    e(), i = Im(t, i), uA(n, t), t._dirtyType !== 0 && (i ? hA(n, t) : gA(n, t), Im(t), JM(s, n, t._dirtyLeaves, t._dirtyElements)), u !== t._compositionKey && (n._flushSync = !0);
    let d = n._selection;
    if (de(d)) {
      let h = n._nodeMap, p = d.focus.key;
      h.get(d.anchor.key) !== void 0 && h.get(p) !== void 0 || ee(19);
    } else
      Hs(d) && d._nodes.size === 0 && (n._selection = null);
  } catch (u) {
    u instanceof Error && t._onError(u), t._pendingEditorState = s, t._dirtyType = 2, t._cloneNotNeeded.clear(), t._dirtyLeaves = /* @__PURE__ */ new Set(), t._dirtyElements.clear(), li(t);
    return;
  } finally {
    pt = o, Vt = l, mt = f, t._updating = c, ks = 0;
  }
  e = t._window !== null ? window.event : null, e = e != null ? e.type : null, t._dirtyType !== 0 || pA(n, t) || t._blockCursorElement !== null && e === "blur" ? n._flushSync ? (n._flushSync = !1, li(t)) : a && YM(() => {
    li(t);
  }) : (n._flushSync = !1, a && (r.clear(), t._deferred = [], t._pendingEditorState = null));
}
function rn(t, e, n) {
  t._updating ? t._updates.push([e, n]) : pw(t, e, n);
}
function x1(t, e, n) {
  At();
  var r = t.__key;
  let i = t.getParent();
  if (i !== null) {
    var o = XM(t), a = !1;
    if (de(o) && e) {
      let s = o.anchor, l = o.focus;
      s.key === r && (Sf(s, t, i, t.getPreviousSibling(), t.getNextSibling()), a = !0), l.key === r && (Sf(l, t, i, t.getPreviousSibling(), t.getNextSibling()), a = !0);
    }
    de(o) && e && !a ? (r = t.getIndexWithinParent(), si(t), Tf(o, i, r, -1)) : si(t), n || Nr(i) || i.canBeEmpty() || !i.isEmpty() || x1(i, e), e && nn(i) && i.isEmpty() && i.selectEnd();
  }
}
let Sc = class {
  static getType() {
    ee(64);
  }
  static clone() {
    ee(65);
  }
  constructor(e) {
    this.__type = this.constructor.getType(), this.__next = this.__prev = this.__parent = null, W_(this, e);
  }
  getType() {
    return this.__type;
  }
  isAttached() {
    for (var e = this.__key; e !== null; ) {
      if (e === "root")
        return !0;
      if (e = it(e), e === null)
        break;
      e = e.__parent;
    }
    return !1;
  }
  isSelected() {
    let e = He();
    if (e == null)
      return !1;
    let n = e.getNodes().some((r) => r.__key === this.__key);
    return J(this) ? n : de(e) && e.anchor.type === "element" && e.focus.type === "element" && e.anchor.key === e.focus.key && e.anchor.offset === e.focus.offset ? !1 : n;
  }
  getKey() {
    return this.__key;
  }
  getIndexWithinParent() {
    var e = this.getParent();
    if (e === null)
      return -1;
    e = e.getFirstChild();
    let n = 0;
    for (; e !== null; ) {
      if (this.is(e))
        return n;
      n++, e = e.getNextSibling();
    }
    return -1;
  }
  getParent() {
    let e = this.getLatest().__parent;
    return e === null ? null : it(e);
  }
  getParentOrThrow() {
    let e = this.getParent();
    return e === null && ee(66), e;
  }
  getTopLevelElement() {
    let e = this;
    for (; e !== null; ) {
      let n = e.getParent();
      if (Nr(n))
        return e;
      e = n;
    }
    return null;
  }
  getTopLevelElementOrThrow() {
    let e = this.getTopLevelElement();
    return e === null && ee(67), e;
  }
  getParents() {
    let e = [], n = this.getParent();
    for (; n !== null; )
      e.push(n), n = n.getParent();
    return e;
  }
  getParentKeys() {
    let e = [], n = this.getParent();
    for (; n !== null; )
      e.push(n.__key), n = n.getParent();
    return e;
  }
  getPreviousSibling() {
    let e = this.getLatest().__prev;
    return e === null ? null : it(e);
  }
  getPreviousSiblings() {
    let e = [];
    var n = this.getParent();
    if (n === null)
      return e;
    for (n = n.getFirstChild(); n !== null && !n.is(this); )
      e.push(n), n = n.getNextSibling();
    return e;
  }
  getNextSibling() {
    let e = this.getLatest().__next;
    return e === null ? null : it(e);
  }
  getNextSiblings() {
    let e = [], n = this.getNextSibling();
    for (; n !== null; )
      e.push(n), n = n.getNextSibling();
    return e;
  }
  getCommonAncestor(e) {
    let n = this.getParents();
    var r = e.getParents();
    H(this) && n.unshift(this), H(e) && r.unshift(e), e = n.length;
    var i = r.length;
    if (e === 0 || i === 0 || n[e - 1] !== r[i - 1])
      return null;
    for (r = new Set(r), i = 0; i < e; i++) {
      let o = n[i];
      if (r.has(o))
        return o;
    }
    return null;
  }
  is(e) {
    return e == null ? !1 : this.__key === e.__key;
  }
  isBefore(e) {
    if (e.isParentOf(this))
      return !0;
    if (this.isParentOf(e))
      return !1;
    var n = this.getCommonAncestor(e);
    let r = this;
    for (; ; ) {
      var i = r.getParentOrThrow();
      if (i === n) {
        i = r.getIndexWithinParent();
        break;
      }
      r = i;
    }
    for (r = e; ; ) {
      if (e = r.getParentOrThrow(), e === n) {
        n = r.getIndexWithinParent();
        break;
      }
      r = e;
    }
    return i < n;
  }
  isParentOf(e) {
    let n = this.__key;
    if (n === e.__key)
      return !1;
    for (; e !== null; ) {
      if (e.__key === n)
        return !0;
      e = e.getParent();
    }
    return !1;
  }
  getNodesBetween(e) {
    let n = this.isBefore(e), r = [], i = /* @__PURE__ */ new Set();
    for (var o = this; ; ) {
      var a = o.__key;
      if (i.has(a) || (i.add(a), r.push(o)), o === e)
        break;
      if (a = H(o) ? n ? o.getFirstChild() : o.getLastChild() : null, a !== null)
        o = a;
      else if (a = n ? o.getNextSibling() : o.getPreviousSibling(), a !== null)
        o = a;
      else {
        if (o = o.getParentOrThrow(), i.has(o.__key) || r.push(o), o === e)
          break;
        a = o;
        do
          a === null && ee(68), o = n ? a.getNextSibling() : a.getPreviousSibling(), a = a.getParent(), a !== null && (o !== null || i.has(a.__key) || r.push(a));
        while (o === null);
      }
    }
    return n || r.reverse(), r;
  }
  isDirty() {
    let e = et()._dirtyLeaves;
    return e !== null && e.has(this.__key);
  }
  getLatest() {
    let e = it(this.__key);
    return e === null && ee(69), e;
  }
  getWritable() {
    At();
    var e = Xn(), n = et();
    e = e._nodeMap;
    let r = this.__key, i = this.getLatest(), o = i.__parent;
    n = n._cloneNotNeeded;
    var a = He();
    return a !== null && (a._cachedNodes = null), n.has(r) ? (kf(i), i) : (a = i.constructor.clone(i), a.__parent = o, a.__next = i.__next, a.__prev = i.__prev, H(i) && H(a) ? (a.__first = i.__first, a.__last = i.__last, a.__size = i.__size, a.__indent = i.__indent, a.__format = i.__format, a.__dir = i.__dir) : J(i) && J(a) && (a.__format = i.__format, a.__style = i.__style, a.__mode = i.__mode, a.__detail = i.__detail), n.add(r), a.__key = r, kf(a), e.set(r, a), a);
  }
  getTextContent() {
    return "";
  }
  getTextContentSize() {
    return this.getTextContent().length;
  }
  createDOM() {
    ee(70);
  }
  updateDOM() {
    ee(71);
  }
  exportDOM(e) {
    return { element: this.createDOM(
      e._config,
      e
    ) };
  }
  exportJSON() {
    ee(72);
  }
  static importJSON() {
    ee(18);
  }
  remove(e) {
    x1(this, !0, e);
  }
  replace(e, n) {
    At();
    var r = He();
    r !== null && (r = r.clone()), zu(this, e);
    let i = this.getLatest(), o = this.__key, a = e.__key, s = e.getWritable();
    e = this.getParentOrThrow().getWritable();
    let l = e.__size;
    si(s);
    let f = i.getPreviousSibling(), c = i.getNextSibling(), u = i.__prev, d = i.__next, h = i.__parent;
    return x1(i, !1, !0), f === null ? e.__first = a : f.getWritable().__next = a, s.__prev = u, c === null ? e.__last = a : c.getWritable().__prev = a, s.__next = d, s.__parent = h, e.__size = l, n && this.getChildren().forEach((p) => {
      s.append(p);
    }), de(r) && (Fr(r), n = r.anchor, r = r.focus, n.key === o && mm(n, s), r.key === o && mm(r, s)), Cr() === o && Ct(a), s;
  }
  insertAfter(e, n = !0) {
    At(), zu(this, e);
    var r = this.getWritable();
    let i = e.getWritable();
    var o = i.getParent();
    let a = He();
    var s = !1, l = !1;
    if (o !== null) {
      var f = e.getIndexWithinParent();
      si(i), de(a) && (l = o.__key, s = a.anchor, o = a.focus, s = s.type === "element" && s.key === l && s.offset === f + 1, l = o.type === "element" && o.key === l && o.offset === f + 1);
    }
    o = this.getNextSibling(), f = this.getParentOrThrow().getWritable();
    let c = i.__key, u = r.__next;
    return o === null ? f.__last = c : o.getWritable().__prev = c, f.__size++, r.__next = c, i.__next = u, i.__prev = r.__key, i.__parent = r.__parent, n && de(a) && (n = this.getIndexWithinParent(), Tf(a, f, n + 1), r = f.__key, s && a.anchor.set(r, n + 2, "element"), l && a.focus.set(r, n + 2, "element")), e;
  }
  insertBefore(e, n = !0) {
    At(), zu(this, e);
    var r = this.getWritable();
    let i = e.getWritable(), o = i.__key;
    si(i);
    let a = this.getPreviousSibling(), s = this.getParentOrThrow().getWritable(), l = r.__prev, f = this.getIndexWithinParent();
    return a === null ? s.__first = o : a.getWritable().__next = o, s.__size++, r.__prev = o, i.__prev = l, i.__next = r.__key, i.__parent = r.__parent, r = He(), n && de(r) && (n = this.getParentOrThrow(), Tf(r, n, f)), e;
  }
  selectPrevious(e, n) {
    At();
    let r = this.getPreviousSibling(), i = this.getParentOrThrow();
    return r === null ? i.select(0, 0) : H(r) ? r.select() : J(r) ? r.select(e, n) : (e = r.getIndexWithinParent() + 1, i.select(e, e));
  }
  selectNext(e, n) {
    At();
    let r = this.getNextSibling(), i = this.getParentOrThrow();
    return r === null ? i.select() : H(r) ? r.select(0, 0) : J(r) ? r.select(e, n) : (e = r.getIndexWithinParent(), i.select(
      e,
      e
    ));
  }
  markDirty() {
    this.getWritable();
  }
}, mw = class extends Sc {
  constructor(e) {
    super(e);
  }
  decorate() {
    ee(47);
  }
  isIsolated() {
    return !1;
  }
  isInline() {
    return !0;
  }
  isKeyboardSelectable() {
    return !0;
  }
};
function Ye(t) {
  return t instanceof mw;
}
class Di extends Sc {
  constructor(e) {
    super(e), this.__last = this.__first = null, this.__indent = this.__format = this.__size = 0, this.__dir = null;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getFormatType() {
    let e = this.getFormat();
    return BM[e] || "";
  }
  getIndent() {
    return this.getLatest().__indent;
  }
  getChildren() {
    let e = [], n = this.getFirstChild();
    for (; n !== null; )
      e.push(n), n = n.getNextSibling();
    return e;
  }
  getChildrenKeys() {
    let e = [], n = this.getFirstChild();
    for (; n !== null; )
      e.push(n.__key), n = n.getNextSibling();
    return e;
  }
  getChildrenSize() {
    return this.getLatest().__size;
  }
  isEmpty() {
    return this.getChildrenSize() === 0;
  }
  isDirty() {
    let e = et()._dirtyElements;
    return e !== null && e.has(this.__key);
  }
  isLastChild() {
    let e = this.getLatest(), n = this.getParentOrThrow().getLastChild();
    return n !== null && n.is(e);
  }
  getAllTextNodes() {
    let e = [], n = this.getFirstChild();
    for (; n !== null; ) {
      if (J(n) && e.push(n), H(n)) {
        let r = n.getAllTextNodes();
        e.push(...r);
      }
      n = n.getNextSibling();
    }
    return e;
  }
  getFirstDescendant() {
    let e = this.getFirstChild();
    for (; e !== null; ) {
      if (H(e)) {
        let n = e.getFirstChild();
        if (n !== null) {
          e = n;
          continue;
        }
      }
      break;
    }
    return e;
  }
  getLastDescendant() {
    let e = this.getLastChild();
    for (; e !== null; ) {
      if (H(e)) {
        let n = e.getLastChild();
        if (n !== null) {
          e = n;
          continue;
        }
      }
      break;
    }
    return e;
  }
  getDescendantByIndex(e) {
    let n = this.getChildren(), r = n.length;
    return e >= r ? (e = n[r - 1], H(e) && e.getLastDescendant() || e || null) : (e = n[e], H(e) && e.getFirstDescendant() || e || null);
  }
  getFirstChild() {
    let e = this.getLatest().__first;
    return e === null ? null : it(e);
  }
  getFirstChildOrThrow() {
    let e = this.getFirstChild();
    return e === null && ee(45), e;
  }
  getLastChild() {
    let e = this.getLatest().__last;
    return e === null ? null : it(e);
  }
  getLastChildOrThrow() {
    let e = this.getLastChild();
    return e === null && ee(96), e;
  }
  getChildAtIndex(e) {
    var n = this.getChildrenSize();
    let r;
    if (e < n / 2) {
      for (r = this.getFirstChild(), n = 0; r !== null && n <= e; ) {
        if (n === e)
          return r;
        r = r.getNextSibling(), n++;
      }
      return null;
    }
    for (r = this.getLastChild(), --n; r !== null && n >= e; ) {
      if (n === e)
        return r;
      r = r.getPreviousSibling(), n--;
    }
    return null;
  }
  getTextContent() {
    let e = "", n = this.getChildren(), r = n.length;
    for (let i = 0; i < r; i++) {
      let o = n[i];
      e += o.getTextContent(), H(o) && i !== r - 1 && !o.isInline() && (e += `

`);
    }
    return e;
  }
  getDirection() {
    return this.getLatest().__dir;
  }
  hasFormat(e) {
    return e !== "" ? (e = sm[e], (this.getFormat() & e) !== 0) : !1;
  }
  select(e, n) {
    At();
    let r = He(), i = e, o = n;
    var a = this.getChildrenSize();
    if (!this.canBeEmpty()) {
      if (e === 0 && n === 0) {
        if (e = this.getFirstChild(), J(e) || H(e))
          return e.select(0, 0);
      } else if (!(e !== void 0 && e !== a || n !== void 0 && n !== a) && (e = this.getLastChild(), J(e) || H(e)))
        return e.select();
    }
    if (i === void 0 && (i = a), o === void 0 && (o = a), a = this.__key, de(r))
      r.anchor.set(a, i, "element"), r.focus.set(a, o, "element"), r.dirty = !0;
    else
      return hw(a, i, a, o, "element", "element");
    return r;
  }
  selectStart() {
    let e = this.getFirstDescendant();
    return H(e) || J(e) ? e.select(0, 0) : e !== null ? e.selectPrevious() : this.select(0, 0);
  }
  selectEnd() {
    let e = this.getLastDescendant();
    return H(e) || J(e) ? e.select() : e !== null ? e.selectNext() : this.select();
  }
  clear() {
    let e = this.getWritable();
    return this.getChildren().forEach((n) => n.remove()), e;
  }
  append(...e) {
    return this.splice(this.getChildrenSize(), 0, e);
  }
  setDirection(e) {
    let n = this.getWritable();
    return n.__dir = e, n;
  }
  setFormat(e) {
    return this.getWritable().__format = e !== "" ? sm[e] : 0, this;
  }
  setIndent(e) {
    return this.getWritable().__indent = e, this;
  }
  splice(e, n, r) {
    let i = r.length, o = this.getChildrenSize(), a = this.getWritable(), s = a.__key;
    var l = [], f = [];
    let c = this.getChildAtIndex(e + n), u = null, d = o - n + i;
    if (e !== 0)
      if (e === o)
        u = this.getLastChild();
      else {
        var h = this.getChildAtIndex(e);
        h !== null && (u = h.getPreviousSibling());
      }
    if (0 < n) {
      var p = u === null ? this.getFirstChild() : u.getNextSibling();
      for (h = 0; h < n; h++) {
        p === null && ee(100);
        var m = p.getNextSibling(), v = p.__key;
        p = p.getWritable(), si(p), f.push(v), p = m;
      }
    }
    for (h = u, m = 0; m < i; m++) {
      v = r[m], h !== null && v.is(h) && (u = h = h.getPreviousSibling()), p = v.getWritable(), p.__parent === s && d--, si(p);
      let b = v.__key;
      h === null ? (a.__first = b, p.__prev = null) : (h = h.getWritable(), h.__next = b, p.__prev = h.__key), v.__key === s && ee(76), p.__parent = s, l.push(b), h = v;
    }
    if (e + n === o ? h !== null && (h.getWritable().__next = null, a.__last = h.__key) : c !== null && (e = c.getWritable(), h !== null ? (n = h.getWritable(), e.__prev = h.__key, n.__next = c.__key) : e.__prev = null), a.__size = d, f.length && (e = He(), de(e))) {
      f = new Set(f), l = new Set(l);
      let { anchor: b, focus: k } = e;
      Nm(b, f, l) && Sf(b, b.getNode(), this, u, c), Nm(k, f, l) && Sf(
        k,
        k.getNode(),
        this,
        u,
        c
      ), d !== 0 || this.canBeEmpty() || Nr(this) || this.remove();
    }
    return a;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "element", version: 1 };
  }
  insertNewAfter() {
    return null;
  }
  canInsertTab() {
    return !1;
  }
  canIndent() {
    return !0;
  }
  collapseAtStart() {
    return !1;
  }
  excludeFromCopy() {
    return !1;
  }
  canExtractContents() {
    return !0;
  }
  canReplaceWith() {
    return !0;
  }
  canInsertAfter() {
    return !0;
  }
  canBeEmpty() {
    return !0;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  isInline() {
    return !1;
  }
  isShadowRoot() {
    return !1;
  }
  canMergeWith() {
    return !1;
  }
  extractWithChild() {
    return !1;
  }
}
function H(t) {
  return t instanceof Di;
}
function Nm(t, e, n) {
  for (t = t.getNode(); t; ) {
    let r = t.__key;
    if (e.has(r) && !n.has(r))
      return !0;
    t = t.getParent();
  }
  return !1;
}
let Ic = class vw extends Di {
  static getType() {
    return "root";
  }
  static clone() {
    return new vw();
  }
  constructor() {
    super("root"), this.__cachedText = null;
  }
  getTopLevelElementOrThrow() {
    ee(51);
  }
  getTextContent() {
    let e = this.__cachedText;
    return !Xo() && et()._dirtyType !== 0 || e === null ? super.getTextContent() : e;
  }
  remove() {
    ee(52);
  }
  replace() {
    ee(53);
  }
  insertBefore() {
    ee(54);
  }
  insertAfter() {
    ee(55);
  }
  updateDOM() {
    return !1;
  }
  append(...e) {
    for (let n = 0; n < e.length; n++) {
      let r = e[n];
      H(r) || Ye(r) || ee(56);
    }
    return super.append(...e);
  }
  static importJSON(e) {
    let n = Ur();
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "root", version: 1 };
  }
  collapseAtStart() {
    return !0;
  }
};
function nn(t) {
  return t instanceof Ic;
}
function pA(t, e) {
  if (e = e.getEditorState()._selection, t = t._selection, t !== null) {
    if (t.dirty || !t.is(e))
      return !0;
  } else if (e !== null)
    return !0;
  return !1;
}
function S0() {
  return new yw(/* @__PURE__ */ new Map([["root", new Ic()]]));
}
function bw(t) {
  let e = t.exportJSON();
  e.type !== t.constructor.getType() && ee(58);
  let n = e.children;
  if (H(t)) {
    Array.isArray(n) || ee(59), t = t.getChildren();
    for (let r = 0; r < t.length; r++) {
      let i = bw(t[r]);
      n.push(i);
    }
  }
  return e;
}
let yw = class _w {
  constructor(e, n) {
    this._nodeMap = e, this._selection = n || null, this._readOnly = this._flushSync = !1;
  }
  isEmpty() {
    return this._nodeMap.size === 1 && this._selection === null;
  }
  read(e) {
    return Sm(this, e);
  }
  clone(e) {
    return e = new _w(this._nodeMap, e === void 0 ? this._selection : e), e._readOnly = !0, e;
  }
  toJSON() {
    return Sm(this, () => ({ root: bw(Ur()) }));
  }
}, Nc = class ww extends Sc {
  static getType() {
    return "linebreak";
  }
  static clone(e) {
    return new ww(e.__key);
  }
  constructor(e) {
    super(e);
  }
  getTextContent() {
    return `
`;
  }
  createDOM() {
    return document.createElement("br");
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { br: (e) => {
      let n = e.parentElement;
      return n != null && n.firstChild === e && n.lastChild === e ? null : { conversion: mA, priority: 0 };
    } };
  }
  static importJSON() {
    return Po();
  }
  exportJSON() {
    return { type: "linebreak", version: 1 };
  }
};
function mA() {
  return { node: Po() };
}
function Po() {
  return Cc(new Nc());
}
function Cs(t) {
  return t instanceof Nc;
}
function Vu(t, e) {
  return e & 16 ? "code" : e & 32 ? "sub" : e & 64 ? "sup" : null;
}
function Ku(t, e) {
  return e & 1 ? "strong" : e & 2 ? "em" : "span";
}
function Yu(t, e, n, r, i) {
  t = r.classList, r = Ha(i, "base"), r !== void 0 && t.add(...r), r = Ha(i, "underlineStrikethrough");
  let o = !1, a = e & 8 && e & 4;
  var s = n & 8 && n & 4;
  r !== void 0 && (s ? (o = !0, a || t.add(...r)) : a && t.remove(...r));
  for (let l in ai)
    s = ai[l], r = Ha(i, l), r !== void 0 && (n & s ? !o || l !== "underline" && l !== "strikethrough" ? (!(e & s) || a && l === "underline" || l === "strikethrough") && t.add(...r) : e & s && t.remove(...r) : e & s && t.remove(...r));
}
function qu(t, e, n) {
  let r = e.firstChild;
  if (n = n.isComposing(), t += n ? yc : "", r == null)
    e.textContent = t;
  else if (e = r.nodeValue, e !== t)
    if (n || wi) {
      n = e.length;
      let i = t.length, o = 0, a = 0;
      for (; o < n && o < i && e[o] === t[o]; )
        o++;
      for (; a + o < n && a + o < i && e[n - a - 1] === t[i - a - 1]; )
        a++;
      t = [o, n - o - a, t.slice(o, i - a)];
      let [s, l, f] = t;
      l !== 0 && r.deleteData(s, l), r.insertData(s, f);
    } else
      r.nodeValue = t;
}
function ll(t, e) {
  return e = document.createElement(e), e.appendChild(t), e;
}
let Mc = class kw extends Sc {
  static getType() {
    return "text";
  }
  static clone(e) {
    return new kw(e.__text, e.__key);
  }
  constructor(e, n) {
    super(n), this.__text = e, this.__format = 0, this.__style = "", this.__detail = this.__mode = 0;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getDetail() {
    return this.getLatest().__detail;
  }
  getMode() {
    let e = this.getLatest();
    return UM[e.__mode];
  }
  getStyle() {
    return this.getLatest().__style;
  }
  isToken() {
    return this.getLatest().__mode === 1;
  }
  isComposing() {
    return this.__key === Cr();
  }
  isSegmented() {
    return this.getLatest().__mode === 2;
  }
  isDirectionless() {
    return (this.getLatest().__detail & 1) !== 0;
  }
  isUnmergeable() {
    return (this.getLatest().__detail & 2) !== 0;
  }
  hasFormat(e) {
    return e = ai[e], (this.getFormat() & e) !== 0;
  }
  isSimpleText() {
    return this.__type === "text" && this.__mode === 0;
  }
  getTextContent() {
    return this.getLatest().__text;
  }
  getFormatFlags(e, n) {
    let r = this.getLatest().__format;
    return z_(r, e, n);
  }
  createDOM(e) {
    var n = this.__format, r = Vu(this, n);
    let i = Ku(this, n), o = document.createElement(r === null ? i : r), a = o;
    return r !== null && (a = document.createElement(i), o.appendChild(a)), r = a, qu(this.__text, r, this), e = e.theme.text, e !== void 0 && Yu(i, 0, n, r, e), n = this.__style, n !== "" && (o.style.cssText = n), o;
  }
  updateDOM(e, n, r) {
    let i = this.__text;
    var o = e.__format, a = this.__format, s = Vu(this, o);
    let l = Vu(this, a);
    var f = Ku(this, o);
    let c = Ku(this, a);
    return (s === null ? f : s) !== (l === null ? c : l) ? !0 : s === l && f !== c ? (o = n.firstChild, o == null && ee(48), e = s = document.createElement(c), qu(i, e, this), r = r.theme.text, r !== void 0 && Yu(c, 0, a, e, r), n.replaceChild(s, o), !1) : (f = n, l !== null && s !== null && (f = n.firstChild, f == null && ee(49)), qu(i, f, this), r = r.theme.text, r !== void 0 && o !== a && Yu(c, o, a, f, r), a = this.__style, e.__style !== a && (n.style.cssText = a), !1);
  }
  static importDOM() {
    return { "#text": () => ({ conversion: _A, priority: 0 }), b: () => ({ conversion: yA, priority: 0 }), br: () => ({ conversion: bA, priority: 0 }), code: () => ({ conversion: Yr, priority: 0 }), em: () => ({ conversion: Yr, priority: 0 }), i: () => ({ conversion: Yr, priority: 0 }), span: () => ({ conversion: vA, priority: 0 }), strong: () => ({ conversion: Yr, priority: 0 }), sub: () => ({ conversion: Yr, priority: 0 }), sup: () => ({ conversion: Yr, priority: 0 }), u: () => ({
      conversion: Yr,
      priority: 0
    }) };
  }
  static importJSON(e) {
    let n = kt(e.text);
    return n.setFormat(e.format), n.setDetail(e.detail), n.setMode(e.mode), n.setStyle(e.style), n;
  }
  exportDOM(e) {
    return { element: e } = super.exportDOM(e), e !== null && (this.hasFormat("bold") && (e = ll(e, "b")), this.hasFormat("italic") && (e = ll(e, "i")), this.hasFormat("strikethrough") && (e = ll(e, "s")), this.hasFormat("underline") && (e = ll(e, "u"))), { element: e };
  }
  exportJSON() {
    return {
      detail: this.getDetail(),
      format: this.getFormat(),
      mode: this.getMode(),
      style: this.getStyle(),
      text: this.getTextContent(),
      type: "text",
      version: 1
    };
  }
  selectionTransform() {
  }
  setFormat(e) {
    let n = this.getWritable();
    return n.__format = typeof e == "string" ? ai[e] : e, n;
  }
  setDetail(e) {
    let n = this.getWritable();
    return n.__detail = typeof e == "string" ? zM[e] : e, n;
  }
  setStyle(e) {
    let n = this.getWritable();
    return n.__style = e, n;
  }
  toggleFormat(e) {
    return e = ai[e], this.setFormat(this.getFormat() ^ e);
  }
  toggleDirectionless() {
    let e = this.getWritable();
    return e.__detail ^= 1, e;
  }
  toggleUnmergeable() {
    let e = this.getWritable();
    return e.__detail ^= 2, e;
  }
  setMode(e) {
    if (e = WM[e], this.__mode === e)
      return this;
    let n = this.getWritable();
    return n.__mode = e, n;
  }
  setTextContent(e) {
    if (this.__text === e)
      return this;
    let n = this.getWritable();
    return n.__text = e, n;
  }
  select(e, n) {
    At();
    let r = He();
    var i = this.getTextContent();
    let o = this.__key;
    if (typeof i == "string" ? (i = i.length, e === void 0 && (e = i), n === void 0 && (n = i)) : n = e = 0, de(r))
      i = Cr(), i !== r.anchor.key && i !== r.focus.key || Ct(o), r.setTextNodeRange(this, e, this, n);
    else
      return hw(o, e, o, n, "text", "text");
    return r;
  }
  spliceText(e, n, r, i) {
    let o = this.getWritable(), a = o.__text, s = r.length, l = e;
    0 > l && (l = s + l, 0 > l && (l = 0));
    let f = He();
    return i && de(f) && (e += s, f.setTextNodeRange(o, e, o, e)), n = a.slice(0, l) + r + a.slice(l + n), o.__text = n, o;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  splitText(...e) {
    At();
    var n = this.getLatest(), r = n.getTextContent(), i = n.__key, o = Cr(), a = new Set(e);
    e = [];
    for (var s = r.length, l = "", f = 0; f < s; f++)
      l !== "" && a.has(f) && (e.push(l), l = ""), l += r[f];
    if (l !== "" && e.push(l), a = e.length, a === 0)
      return [];
    if (e[0] === r)
      return [n];
    var c = e[0];
    r = n.getParentOrThrow(), f = n.getFormat();
    let u = n.getStyle(), d = n.__detail;
    s = !1, n.isSegmented() ? (l = kt(c), l.__format = f, l.__style = u, l.__detail = d, s = !0) : (l = n.getWritable(), l.__text = c), n = He(), l = [l], c = c.length;
    for (let m = 1; m < a; m++) {
      var h = e[m], p = h.length;
      h = kt(h).getWritable(), h.__format = f, h.__style = u, h.__detail = d;
      let v = h.__key;
      if (p = c + p, de(n)) {
        let b = n.anchor, k = n.focus;
        b.key === i && b.type === "text" && b.offset > c && b.offset <= p && (b.key = v, b.offset -= c, n.dirty = !0), k.key === i && k.type === "text" && k.offset > c && k.offset <= p && (k.key = v, k.offset -= c, n.dirty = !0);
      }
      o === i && Ct(v), c = p, l.push(h);
    }
    return i = this.getPreviousSibling(), o = this.getNextSibling(), i !== null && kf(i), o !== null && kf(o), i = r.getWritable(), o = this.getIndexWithinParent(), s ? (i.splice(o, 0, l), this.remove()) : i.splice(o, 1, l), de(n) && Tf(n, r, o, a - 1), l;
  }
  mergeWithSibling(e) {
    var n = e === this.getPreviousSibling();
    n || e === this.getNextSibling() || ee(50);
    var r = this.__key;
    let i = e.__key, o = this.__text, a = o.length;
    Cr() === i && Ct(r);
    let s = He();
    if (de(s)) {
      let l = s.anchor, f = s.focus;
      l !== null && l.key === i && (xm(l, n, r, e, a), s.dirty = !0), f !== null && f.key === i && (xm(f, n, r, e, a), s.dirty = !0);
    }
    return r = e.__text, this.setTextContent(n ? r + o : o + r), n = this.getWritable(), e.remove(), n;
  }
  isTextEntity() {
    return !1;
  }
};
function vA(t) {
  let e = t.style.fontWeight === "700", n = t.style.textDecoration === "line-through", r = t.style.fontStyle === "italic", i = t.style.textDecoration === "underline", o = t.style.verticalAlign;
  return { forChild: (a) => (J(a) && (e && a.toggleFormat("bold"), n && a.toggleFormat("strikethrough"), r && a.toggleFormat("italic"), i && a.toggleFormat("underline"), o === "sub" && a.toggleFormat("subscript"), o === "super" && a.toggleFormat("superscript")), a), node: null };
}
function bA() {
  return { node: Po() };
}
function yA(t) {
  let e = t.style.fontWeight === "normal";
  return { forChild: (n) => (J(n) && !e && n.toggleFormat("bold"), n), node: null };
}
function _A(t, e, n) {
  return t = t.textContent || "", !n && /\n/.test(t) && (t = t.replace(/\r?\n/gm, " "), t.trim().length === 0) ? { node: null } : { node: kt(t) };
}
let wA = { code: "code", em: "italic", i: "italic", strong: "bold", sub: "subscript", sup: "superscript", u: "underline" };
function Yr(t) {
  let e = wA[t.nodeName.toLowerCase()];
  return e === void 0 ? { node: null } : { forChild: (n) => (J(n) && !n.hasFormat(e) && n.toggleFormat(e), n), node: null };
}
function kt(t = "") {
  return Cc(new Mc(t));
}
function J(t) {
  return t instanceof Mc;
}
class Jo extends Di {
  static getType() {
    return "paragraph";
  }
  static clone(e) {
    return new Jo(e.__key);
  }
  createDOM(e) {
    let n = document.createElement("p");
    return e = Ha(e.theme, "paragraph"), e !== void 0 && n.classList.add(...e), n;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { p: () => ({ conversion: kA, priority: 0 }) };
  }
  exportDOM(e) {
    if ({ element: e } = super.exportDOM(e), e && this.isEmpty() && e.append(document.createElement("br")), e) {
      var n = this.getFormatType();
      e.style.textAlign = n, (n = this.getDirection()) && (e.dir = n), n = this.getIndent(), 0 < n && (e.style.textIndent = `${20 * n}px`);
    }
    return { element: e };
  }
  static importJSON(e) {
    let n = Ro();
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "paragraph", version: 1 };
  }
  insertNewAfter(e, n) {
    e = Ro();
    let r = this.getDirection();
    return e.setDirection(r), this.insertAfter(e, n), e;
  }
  collapseAtStart() {
    let e = this.getChildren();
    if (e.length === 0 || J(e[0]) && e[0].getTextContent().trim() === "") {
      if (this.getNextSibling() !== null)
        return this.selectNext(), this.remove(), !0;
      if (this.getPreviousSibling() !== null)
        return this.selectPrevious(), this.remove(), !0;
    }
    return !1;
  }
}
function kA() {
  return { node: Ro() };
}
function Ro() {
  return Cc(new Jo());
}
function Cw(t, e, n, r) {
  let i = t._keyToDOMMap;
  i.clear(), t._editorState = S0(), t._pendingEditorState = r, t._compositionKey = null, t._dirtyType = 0, t._cloneNotNeeded.clear(), t._dirtyLeaves = /* @__PURE__ */ new Set(), t._dirtyElements.clear(), t._normalizedNodes = /* @__PURE__ */ new Set(), t._updateTags = /* @__PURE__ */ new Set(), t._updates = [], t._blockCursorElement = null, r = t._observer, r !== null && (r.disconnect(), t._observer = null), e !== null && (e.textContent = ""), n !== null && (n.textContent = "", i.set("root", n));
}
function CA(t) {
  let e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set();
  return t.forEach((r) => {
    if (r = r.klass.importDOM != null ? r.klass.importDOM.bind(r.klass) : null, r != null && !n.has(r)) {
      n.add(r);
      var i = r();
      i !== null && Object.keys(i).forEach((o) => {
        let a = e.get(o);
        a === void 0 && (a = [], e.set(o, a)), a.push(i[o]);
      });
    }
  }), e;
}
class xA {
  constructor(e, n, r, i, o, a) {
    this._parentEditor = n, this._rootElement = null, this._editorState = e, this._compositionKey = this._pendingEditorState = null, this._deferred = [], this._keyToDOMMap = /* @__PURE__ */ new Map(), this._updates = [], this._updating = !1, this._listeners = { decorator: /* @__PURE__ */ new Set(), editable: /* @__PURE__ */ new Set(), mutation: /* @__PURE__ */ new Map(), root: /* @__PURE__ */ new Set(), textcontent: /* @__PURE__ */ new Set(), update: /* @__PURE__ */ new Set() }, this._commands = /* @__PURE__ */ new Map(), this._config = i, this._nodes = r, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = 0, this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._dirtyElements = /* @__PURE__ */ new Map(), this._normalizedNodes = /* @__PURE__ */ new Set(), this._updateTags = /* @__PURE__ */ new Set(), this._observer = null, this._key = K_(), this._onError = o, this._htmlConversions = a, this._editable = !0, this._headless = n !== null && n._headless, this._blockCursorElement = this._window = null;
  }
  isComposing() {
    return this._compositionKey != null;
  }
  registerUpdateListener(e) {
    let n = this._listeners.update;
    return n.add(e), () => {
      n.delete(e);
    };
  }
  registerEditableListener(e) {
    let n = this._listeners.editable;
    return n.add(e), () => {
      n.delete(e);
    };
  }
  registerDecoratorListener(e) {
    let n = this._listeners.decorator;
    return n.add(e), () => {
      n.delete(e);
    };
  }
  registerTextContentListener(e) {
    let n = this._listeners.textcontent;
    return n.add(e), () => {
      n.delete(e);
    };
  }
  registerRootListener(e) {
    let n = this._listeners.root;
    return e(this._rootElement, null), n.add(e), () => {
      e(null, this._rootElement), n.delete(e);
    };
  }
  registerCommand(e, n, r) {
    r === void 0 && ee(35);
    let i = this._commands;
    i.has(e) || i.set(e, [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]);
    let o = i.get(e);
    o === void 0 && ee(36);
    let a = o[r];
    return a.add(n), () => {
      a.delete(n), o.every((s) => s.size === 0) && i.delete(e);
    };
  }
  registerMutationListener(e, n) {
    this._nodes.get(e.getType()) === void 0 && ee(37);
    let r = this._listeners.mutation;
    return r.set(n, e), () => {
      r.delete(n);
    };
  }
  registerNodeTransform(e, n) {
    e = e.getType();
    let r = this._nodes.get(e);
    r === void 0 && ee(37);
    let i = r.transforms;
    return i.add(n), qM(this, e), () => {
      i.delete(n);
    };
  }
  hasNodes(e) {
    for (let n = 0; n < e.length; n++) {
      let r = e[n].getType();
      if (!this._nodes.has(r))
        return !1;
    }
    return !0;
  }
  dispatchCommand(e, n) {
    return Q(this, e, n);
  }
  getDecorators() {
    return this._decorators;
  }
  getRootElement() {
    return this._rootElement;
  }
  getKey() {
    return this._key;
  }
  setRootElement(e) {
    let n = this._rootElement;
    if (e !== n) {
      let o = Ha(this._config.theme, "root");
      var r = this._pendingEditorState || this._editorState;
      if (this._rootElement = e, Cw(this, n, e, r), n !== null) {
        if (!this._config.disableEvents) {
          if (Va !== 0 && (Va--, Va === 0 && n.ownerDocument.removeEventListener("selectionchange", cw)), r = n.__collabKitEditor, r != null) {
            if (r._parentEditor !== null) {
              var i = w0(r);
              i = i[i.length - 1]._key, vo.get(i) === r && vo.delete(i);
            } else
              vo.delete(r._key);
            n.__collabKitEditor = null;
          }
          for (r = fw(n), i = 0; i < r.length; i++)
            r[i]();
          n.__lexicalEventHandles = [];
        }
        o != null && n.classList.remove(...o);
      }
      e !== null ? (r = (r = e.ownerDocument) && r.defaultView || null, i = e.style, i.userSelect = "text", i.whiteSpace = "pre-wrap", i.wordBreak = "break-word", e.setAttribute("data-lexical-editor", "true"), this._window = r, this._dirtyType = 2, $_(this), this._updateTags.add("history-merge"), li(this), this._config.disableEvents || lA(e, this), o != null && e.classList.add(...o)) : this._window = null, Ya("root", this, !1, e, n);
    }
  }
  getElementByKey(e) {
    return this._keyToDOMMap.get(e) || null;
  }
  getEditorState() {
    return this._editorState;
  }
  setEditorState(e, n) {
    e.isEmpty() && ee(38), L_(this);
    let r = this._pendingEditorState, i = this._updateTags;
    n = n !== void 0 ? n.tag : null, r === null || r.isEmpty() || (n != null && i.add(n), li(this)), this._pendingEditorState = e, this._dirtyType = 2, this._dirtyElements.set("root", !1), this._compositionKey = null, n != null && i.add(n), li(this);
  }
  parseEditorState(e, n) {
    e = typeof e == "string" ? JSON.parse(e) : e;
    let r = S0(), i = pt, o = Vt, a = mt, s = this._dirtyElements, l = this._dirtyLeaves, f = this._cloneNotNeeded, c = this._dirtyType;
    this._dirtyElements = /* @__PURE__ */ new Map(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyType = 0, pt = r, Vt = !1, mt = this;
    try {
      T0(e.root, this._nodes), n && n(), r._readOnly = !0;
    } finally {
      this._dirtyElements = s, this._dirtyLeaves = l, this._cloneNotNeeded = f, this._dirtyType = c, pt = i, Vt = o, mt = a;
    }
    return r;
  }
  update(e, n) {
    rn(this, e, n);
  }
  focus(e, n = {}) {
    let r = this._rootElement;
    r !== null && (r.setAttribute("autocapitalize", "off"), rn(this, () => {
      let i = He(), o = Ur();
      i !== null ? i.dirty = !0 : o.getChildrenSize() !== 0 && (n.defaultSelection === "rootStart" ? o.selectStart() : o.selectEnd());
    }, { onUpdate: () => {
      r.removeAttribute("autocapitalize"), e && e();
    } }), this._pendingEditorState === null && r.removeAttribute("autocapitalize"));
  }
  blur() {
    var e = this._rootElement;
    e !== null && e.blur(), e = Qn(this._window), e !== null && e.removeAllRanges();
  }
  isEditable() {
    return this._editable;
  }
  setEditable(e) {
    this._editable !== e && (this._editable = e, Ya("editable", this, !0, e));
  }
  toJSON() {
    return { editorState: this._editorState.toJSON() };
  }
}
let xw = class extends Di {
  constructor(e, n) {
    super(n), this.__colSpan = e;
  }
  exportJSON() {
    return { ...super.exportJSON(), colSpan: this.__colSpan };
  }
};
function Ew(t) {
  return t instanceof xw;
}
let Tw = class extends Di {
};
function Sw(t) {
  return t instanceof Tw;
}
let Iw = class extends Di {
};
function Nw(t) {
  return t instanceof Iw;
}
W.$addUpdateTag = function(t) {
  At(), et()._updateTags.add(t);
};
W.$applyNodeReplacement = Cc;
W.$copyNode = function(t) {
  return t = t.constructor.clone(t), W_(t, null), t;
};
W.$createLineBreakNode = Po;
W.$createNodeSelection = C1;
W.$createParagraphNode = Ro;
W.$createRangeSelection = function() {
  let t = new Kn("root", 0, "element"), e = new Kn("root", 0, "element");
  return new Oi(t, e, 0);
};
W.$createTextNode = kt;
W.$getAdjacentNode = c1;
W.$getNearestNodeFromDOMNode = Us;
W.$getNearestRootOrShadowRoot = G_;
W.$getNodeByKey = it;
W.$getPreviousSelection = Vs;
W.$getRoot = Ur;
W.$getSelection = He;
W.$getTextContent = function() {
  let t = He();
  return t === null ? "" : t.getTextContent();
};
W.$hasAncestor = xf;
W.$insertNodes = function(t, e) {
  let n = He();
  return n === null && (n = Ur().selectEnd()), n.insertNodes(t, e);
};
W.$isDecoratorNode = Ye;
W.$isElementNode = H;
W.$isInlineElementOrDecoratorNode = function(t) {
  return H(t) && t.isInline() || Ye(t) && t.isInline();
};
W.$isLeafNode = B_;
W.$isLineBreakNode = Cs;
W.$isNodeSelection = Hs;
W.$isParagraphNode = function(t) {
  return t instanceof Jo;
};
W.$isRangeSelection = de;
W.$isRootNode = nn;
W.$isRootOrShadowRoot = Nr;
W.$isTextNode = J;
W.$nodesOfType = function(t) {
  var e = Xn();
  let n = e._readOnly, r = t.getType();
  e = e._nodeMap;
  let i = [];
  for (let [, o] of e)
    o instanceof t && o.__type === r && (n || o.isAttached()) && i.push(o);
  return i;
};
W.$normalizeSelection__EXPERIMENTAL = J_;
W.$parseSerializedNode = function(t) {
  return T0(t, et()._nodes);
};
W.$setCompositionKey = Ct;
W.$setSelection = Fr;
W.BLUR_COMMAND = D_;
W.CAN_REDO_COMMAND = {};
W.CAN_UNDO_COMMAND = {};
W.CLEAR_EDITOR_COMMAND = {};
W.CLEAR_HISTORY_COMMAND = {};
W.CLICK_COMMAND = m_;
W.COMMAND_PRIORITY_CRITICAL = 4;
W.COMMAND_PRIORITY_EDITOR = 0;
W.COMMAND_PRIORITY_HIGH = 3;
W.COMMAND_PRIORITY_LOW = 1;
W.COMMAND_PRIORITY_NORMAL = 2;
W.CONTROLLED_TEXT_INSERTION_COMMAND = mo;
W.COPY_COMMAND = m0;
W.CUT_COMMAND = v0;
W.DELETE_CHARACTER_COMMAND = ms;
W.DELETE_LINE_COMMAND = bs;
W.DELETE_WORD_COMMAND = vs;
W.DEPRECATED_$createGridSelection = function() {
  let t = new Kn("root", 0, "element"), e = new Kn("root", 0, "element");
  return new Tc("root", t, e);
};
W.DEPRECATED_$isGridCellNode = Ew;
W.DEPRECATED_$isGridNode = Sw;
W.DEPRECATED_$isGridRowNode = Nw;
W.DEPRECATED_$isGridSelection = E0;
W.DEPRECATED_GridCellNode = xw;
W.DEPRECATED_GridNode = Tw;
W.DEPRECATED_GridRowNode = Iw;
W.DRAGEND_COMMAND = A_;
W.DRAGOVER_COMMAND = M_;
W.DRAGSTART_COMMAND = N_;
W.DROP_COMMAND = I_;
W.DecoratorNode = mw;
W.ElementNode = Di;
W.FOCUS_COMMAND = O_;
W.FORMAT_ELEMENT_COMMAND = {};
W.FORMAT_TEXT_COMMAND = kr;
W.INDENT_CONTENT_COMMAND = {};
W.INSERT_LINE_BREAK_COMMAND = Ua;
W.INSERT_PARAGRAPH_COMMAND = a1;
W.KEY_ARROW_DOWN_COMMAND = k_;
W.KEY_ARROW_LEFT_COMMAND = y_;
W.KEY_ARROW_RIGHT_COMMAND = v_;
W.KEY_ARROW_UP_COMMAND = w_;
W.KEY_BACKSPACE_COMMAND = x_;
W.KEY_DELETE_COMMAND = T_;
W.KEY_ENTER_COMMAND = yf;
W.KEY_ESCAPE_COMMAND = E_;
W.KEY_MODIFIER_COMMAND = P_;
W.KEY_SPACE_COMMAND = C_;
W.KEY_TAB_COMMAND = S_;
W.LineBreakNode = Nc;
W.MOVE_TO_END = b_;
W.MOVE_TO_START = __;
W.OUTDENT_CONTENT_COMMAND = {};
W.PASTE_COMMAND = h0;
W.ParagraphNode = Jo;
W.REDO_COMMAND = p0;
W.REMOVE_TEXT_COMMAND = s1;
W.RootNode = Ic;
W.SELECTION_CHANGE_COMMAND = d0;
W.TextNode = Mc;
W.UNDO_COMMAND = g0;
W.createCommand = function() {
  return {};
};
W.createEditor = function(t) {
  var e = t || {}, n = mt, r = e.theme || {};
  let i = t === void 0 ? n : e.parentEditor || null, o = e.disableEvents || !1, a = S0(), s = e.namespace || (i !== null ? i._config.namespace : K_()), l = e.editorState, f = [Ic, Mc, Nc, Jo, ...e.nodes || []], c = e.onError;
  if (e = e.editable !== void 0 ? e.editable : !0, t === void 0 && n !== null)
    t = n._nodes;
  else
    for (t = /* @__PURE__ */ new Map(), n = 0; n < f.length; n++) {
      let d = f[n];
      var u = null;
      typeof d != "function" && (u = d, d = u.replace, u = u.with);
      let h = d.getType();
      t.set(h, { klass: d, replace: u, transforms: /* @__PURE__ */ new Set() });
    }
  return r = new xA(
    a,
    i,
    t,
    { disableEvents: o, namespace: s, theme: r },
    c || console.error,
    CA(t),
    e
  ), l !== void 0 && (r._pendingEditorState = l, r._dirtyType = 2), r;
};
const EA = W;
var Z = EA, Qe = {};
function TA(t) {
  throw new Error("$createCodeNode is not implemented (stub)");
}
function SA(t) {
  return !1;
}
const IA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $createCodeNode: TA,
  $isCodeNode: SA,
  CodeNode: Z.ElementNode
}, Symbol.toStringTag, { value: "Module" })), NA = /* @__PURE__ */ SS(IA);
var Et = {}, Rt = {}, dt = Z;
function Mw(t) {
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?code=${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function Aw(t, e) {
  for (let n of e)
    if (t.type.startsWith(n))
      return !0;
  return !1;
}
function Ow(t, e) {
  for (; t !== dt.$getRoot() && t != null; ) {
    if (e(t))
      return t;
    t = t.getParent();
  }
  return null;
}
function Dw(t, e) {
  let n = t.getChildAtIndex(e);
  n == null && (n = t), dt.$isRootOrShadowRoot(t) && Mw(102);
  let r = (a) => {
    const s = a.getParentOrThrow(), l = dt.$isRootOrShadowRoot(s), f = a !== n || l ? dt.$copyNode(a) : a;
    if (l)
      return a.insertAfter(f), [a, f, f];
    const [c, u, d] = r(s);
    return a = a.getNextSiblings(), d.append(f, ...a), [c, u, f];
  }, [i, o] = r(n);
  return [i, o];
}
Rt.$dfs = function(t, e) {
  let n = [];
  t = (t || dt.$getRoot()).getLatest(), e = e || (dt.$isElementNode(t) ? t.getLastDescendant() : t);
  for (var r = t, i = 0; (r = r.getParent()) !== null; )
    i++;
  for (r = i; t !== null && !t.is(e); )
    if (n.push({ depth: r, node: t }), dt.$isElementNode(t) && 0 < t.getChildrenSize())
      t = t.getFirstChild(), r++;
    else
      for (i = null; i === null && t !== null; )
        i = t.getNextSibling(), i === null ? (t = t.getParent(), r--) : t = i;
  return t !== null && t.is(e) && n.push({ depth: r, node: t }), n;
};
Rt.$findMatchingParent = Ow;
Rt.$getNearestBlockElementAncestorOrThrow = function(t) {
  return t = Ow(t, (e) => dt.$isElementNode(e) && !e.isInline()), dt.$isElementNode(t) || Mw(4), t;
};
Rt.$getNearestNodeOfType = function(t, e) {
  for (; t != null; ) {
    if (t instanceof e)
      return t;
    t = t.getParent();
  }
  return null;
};
Rt.$insertNodeToNearestRoot = function(t) {
  var e = dt.$getSelection();
  if (dt.$isRangeSelection(e)) {
    var { focus: n } = e;
    if (e = n.getNode(), n = n.offset, dt.$isRootOrShadowRoot(e))
      n = e.getChildAtIndex(n), n == null ? e.append(t) : n.insertBefore(t), t.selectNext();
    else {
      let r, i;
      dt.$isTextNode(e) ? (r = e.getParentOrThrow(), i = e.getIndexWithinParent(), 0 < n && (i += 1, e.splitText(n))) : (r = e, i = n), [, e] = Dw(r, i), e.insertBefore(t), e.selectStart();
    }
  } else
    dt.$isNodeSelection(e) || dt.DEPRECATED_$isGridSelection(e) ? (e = e.getNodes(), e[e.length - 1].getTopLevelElementOrThrow().insertAfter(t)) : dt.$getRoot().append(t), e = dt.$createParagraphNode(), t.insertAfter(e), e.select();
  return t.getLatest();
};
Rt.$restoreEditorState = function(t, e) {
  let n = new Map(e._nodeMap), r = t._pendingEditorState;
  r && (r._nodeMap = n), t._dirtyType = 2, t = e._selection, dt.$setSelection(t === null ? null : t.clone());
};
Rt.$splitNode = Dw;
Rt.$wrapNodeInElement = function(t, e) {
  return e = e(), t.replace(e), e.append(t), e;
};
Rt.addClassNamesToElement = function(t, ...e) {
  e.forEach((n) => {
    typeof n == "string" && (n = n.split(" ").filter((r) => r !== ""), t.classList.add(...n));
  });
};
Rt.isMimeType = Aw;
Rt.mediaFileReader = function(t, e) {
  let n = t[Symbol.iterator]();
  return new Promise((r, i) => {
    let o = [], a = () => {
      const { done: s, value: l } = n.next();
      if (s)
        return r(o);
      const f = new FileReader();
      f.addEventListener("error", i), f.addEventListener("load", () => {
        const c = f.result;
        typeof c == "string" && o.push({ file: l, result: c }), a();
      }), Aw(l, e) ? f.readAsDataURL(l) : a();
    };
    a();
  });
};
Rt.mergeRegister = function(...t) {
  return () => {
    t.forEach((e) => e());
  };
};
Rt.registerNestedElementResolver = function(t, e, n, r) {
  return t.registerNodeTransform(e, (i) => {
    e: {
      for (var o = i.getChildren(), a = 0; a < o.length; a++)
        if (o[a] instanceof e) {
          o = null;
          break e;
        }
      for (o = i; o !== null; )
        if (a = o, o = o.getParent(), o instanceof e) {
          o = { child: a, parent: o };
          break e;
        }
      o = null;
    }
    if (o !== null) {
      const { child: s, parent: l } = o;
      if (s.is(i)) {
        if (r(l, i), i = s.getNextSiblings(), o = i.length, l.insertAfter(s), o !== 0) {
          a = n(l), s.insertAfter(a);
          for (let f = 0; f < o; f++)
            a.append(i[f]);
        }
        l.canBeEmpty() || l.getChildrenSize() !== 0 || l.remove();
      }
    }
  });
};
Rt.removeClassNamesFromElement = function(t, ...e) {
  e.forEach((n) => {
    typeof n == "string" && t.classList.remove(...n.split(" "));
  });
};
const MA = Rt;
var Jn = MA, Ce = Z, xs = Jn;
function Ks(t) {
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?code=${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function Pw(t) {
  let e = 1;
  for (t = t.getParent(); t != null; ) {
    if (Ue(t)) {
      if (t = t.getParent(), ye(t)) {
        e++, t = t.getParent();
        continue;
      }
      Ks(40);
    }
    break;
  }
  return e;
}
function E1(t) {
  t = t.getParent(), ye(t) || Ks(40);
  let e = t;
  for (; e !== null; )
    e = e.getParent(), ye(e) && (t = e);
  return t;
}
function Rw(t) {
  let e = [];
  t = t.getChildren().filter(Ue);
  for (let n = 0; n < t.length; n++) {
    let r = t[n], i = r.getFirstChild();
    ye(i) ? e = e.concat(Rw(i)) : e.push(r);
  }
  return e;
}
function ao(t) {
  return Ue(t) && ye(t.getFirstChild());
}
function AA(t) {
  for (; t.getNextSibling() == null && t.getPreviousSibling() == null; ) {
    let e = t.getParent();
    if (e == null || !Ue(t) && !ye(t))
      break;
    t = e;
  }
  t.remove();
}
function Mm(t) {
  return dn().append(t);
}
function Lw(t, e) {
  return Ue(t) && (e.length === 0 || e.length === 1 && t.is(e[0]) && t.getChildrenSize() === 0);
}
function xi(t, e) {
  t.splice(t.getChildrenSize(), 0, e);
}
function Am(t, e) {
  if (ye(t))
    return t;
  let n = t.getPreviousSibling(), r = t.getNextSibling(), i = dn();
  return i.setFormat(t.getFormatType()), i.setIndent(t.getIndent()), xi(i, t.getChildren()), ye(n) && e === n.getListType() ? (n.append(i), t.remove(), ye(r) && e === r.getListType() && (xi(n, r.getChildren()), r.remove()), n) : ye(r) && e === r.getListType() ? (r.getFirstChildOrThrow().insertBefore(i), t.remove(), r) : (e = Kt(e), e.append(i), t.replace(e), en(e), e);
}
function en(t, e) {
  if (t = e || t.getChildren(), t !== void 0)
    for (e = 0; e < t.length; e++) {
      let o = t[e];
      if (Ue(o)) {
        let a = o.getValue();
        var n = o, r = n.getParent(), i = 1;
        for (r != null && (ye(r) ? i = r.getStart() : Ks(44)), n = n.getPreviousSiblings(), r = 0; r < n.length; r++) {
          let s = n[r];
          Ue(s) && !ye(s.getFirstChild()) && i++;
        }
        a !== i && o.setValue(i);
      }
    }
}
function $w(t) {
  let e = /* @__PURE__ */ new Set();
  t.forEach((n) => {
    if (!ao(n) && !e.has(n.getKey())) {
      var r = n.getParent(), i = n.getNextSibling(), o = n.getPreviousSibling();
      if (ao(i) && ao(o))
        o = o.getFirstChild(), ye(o) && (o.append(n), n = i.getFirstChild(), ye(n) && (n = n.getChildren(), xi(o, n), i.remove(), e.add(i.getKey())), en(o));
      else if (ao(i))
        i = i.getFirstChild(), ye(i) && (o = i.getFirstChild(), o !== null && o.insertBefore(n), en(i));
      else if (ao(o))
        i = o.getFirstChild(), ye(i) && (i.append(n), en(i));
      else if (ye(r)) {
        let a = dn(), s = Kt(r.getListType());
        a.append(s), s.append(n), o ? o.insertAfter(a) : i ? i.insertBefore(a) : r.append(a);
      }
      ye(r) && en(r);
    }
  });
}
function Fw(t) {
  t.forEach((e) => {
    if (!ao(e)) {
      var n = e.getParent(), r = n ? n.getParent() : void 0, i = r ? r.getParent() : void 0;
      if (ye(i) && Ue(r) && ye(n)) {
        var o = n ? n.getFirstChild() : void 0, a = n ? n.getLastChild() : void 0;
        if (e.is(o))
          r.insertBefore(e), n.isEmpty() && r.remove();
        else if (e.is(a))
          r.insertAfter(e), n.isEmpty() && r.remove();
        else {
          var s = n.getListType();
          o = dn();
          let l = Kt(s);
          o.append(l), e.getPreviousSiblings().forEach((f) => l.append(f)), a = dn(), s = Kt(s), a.append(s), xi(s, e.getNextSiblings()), r.insertBefore(o), r.insertAfter(a), r.replace(e);
        }
        en(n), en(i);
      }
    }
  });
}
function jw(t) {
  var e = Ce.$getSelection();
  if (Ce.$isRangeSelection(e)) {
    var n = e.getNodes(), r = [];
    if (n.length === 0 && n.push(e.anchor.getNode()), n.length === 1) {
      e: {
        for (n = n[0]; n !== null; ) {
          if (Ue(n))
            break e;
          n = n.getParent();
        }
        n = null;
      }
      n !== null && (r = [n]);
    } else {
      for (r = /* @__PURE__ */ new Set(), e = 0; e < n.length; e++) {
        let i = n[e];
        Ue(i) && r.add(i);
      }
      r = Array.from(r);
    }
    0 < r.length && (t === "indent" ? $w(r) : Fw(r));
  }
}
let Ac = class T1 extends Ce.ElementNode {
  static getType() {
    return "listitem";
  }
  static clone(e) {
    return new T1(e.__value, e.__checked, e.__key);
  }
  constructor(e, n, r) {
    super(r), this.__value = e === void 0 ? 1 : e, this.__checked = n;
  }
  createDOM(e) {
    let n = document.createElement("li"), r = this.getParent();
    return ye(r) && (en(r), Dm(n, this, null, r)), n.value = this.__value, Om(n, e.theme, this), n;
  }
  updateDOM(e, n, r) {
    let i = this.getParent();
    return ye(i) && (en(i), Dm(n, this, e, i)), n.value = this.__value, Om(n, r.theme, this), !1;
  }
  static importDOM() {
    return { li: () => ({
      conversion: OA,
      priority: 0
    }) };
  }
  static importJSON(e) {
    let n = new T1(e.value, e.checked);
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), checked: this.getChecked(), type: "listitem", value: this.getValue(), version: 1 };
  }
  append(...e) {
    for (let n = 0; n < e.length; n++) {
      let r = e[n];
      if (Ce.$isElementNode(r) && this.canMergeWith(r)) {
        let i = r.getChildren();
        this.append(...i), r.remove();
      } else
        super.append(r);
    }
    return this;
  }
  replace(e, n) {
    if (Ue(e))
      return super.replace(e);
    let r = this.getParentOrThrow();
    if (ye(r)) {
      var i = r.getChildrenKeys();
      let a = i.length;
      var o = i.indexOf(this.__key);
      if (o === 0)
        r.insertBefore(e);
      else if (o === a - 1)
        r.insertAfter(e);
      else {
        i = Kt(r.getListType());
        let s = r.getChildren();
        for (o += 1; o < a; o++)
          i.append(s[o]);
        r.insertAfter(e), e.insertAfter(i);
      }
      n && this.getChildren().forEach((s) => {
        e.append(s);
      }), this.remove(), a === 1 && r.remove();
    }
    return e;
  }
  insertAfter(e, n = !0) {
    var r = this.getParentOrThrow();
    ye(r) || Ks(39);
    var i = this.getNextSiblings();
    if (Ue(e))
      return n = super.insertAfter(e, n), e = e.getParentOrThrow(), ye(e) && en(e), n;
    if (ye(e) && e.getListType() === r.getListType()) {
      for (r = e, e = e.getChildren(), i = e.length - 1; 0 <= i; i--)
        r = e[i], this.insertAfter(r, n);
      return r;
    }
    if (r.insertAfter(e, n), i.length !== 0) {
      let o = Kt(r.getListType());
      i.forEach((a) => o.append(a)), e.insertAfter(o, n);
    }
    return e;
  }
  remove(e) {
    let n = this.getNextSibling();
    super.remove(e), n !== null && (e = n.getParent(), ye(e) && en(e));
  }
  insertNewAfter(e, n = !0) {
    return e = dn(this.__checked == null ? void 0 : !1), this.insertAfter(e, n), e;
  }
  collapseAtStart(e) {
    let n = Ce.$createParagraphNode();
    this.getChildren().forEach((a) => n.append(a));
    var r = this.getParentOrThrow(), i = r.getParentOrThrow();
    let o = Ue(i);
    return r.getChildrenSize() === 1 ? o ? (r.remove(), i.select()) : (r.insertBefore(n), r.remove(), r = e.anchor, e = e.focus, i = n.getKey(), r.type === "element" && r.getNode().is(this) && r.set(i, r.offset, "element"), e.type === "element" && e.getNode().is(this) && e.set(i, e.offset, "element")) : (r.insertBefore(n), this.remove()), !0;
  }
  getValue() {
    return this.getLatest().__value;
  }
  setValue(e) {
    this.getWritable().__value = e;
  }
  getChecked() {
    return this.getLatest().__checked;
  }
  setChecked(e) {
    this.getWritable().__checked = e;
  }
  toggleChecked() {
    this.setChecked(!this.__checked);
  }
  getIndent() {
    var e = this.getParent();
    if (e === null)
      return this.getLatest().__indent;
    e = e.getParentOrThrow();
    let n = 0;
    for (; Ue(e); )
      e = e.getParentOrThrow().getParentOrThrow(), n++;
    return n;
  }
  setIndent(e) {
    let n = this.getIndent();
    for (; n !== e; )
      n < e ? ($w([this]), n++) : (Fw([this]), n--);
    return this;
  }
  canIndent() {
    return !1;
  }
  insertBefore(e) {
    if (Ue(e)) {
      let n = this.getParentOrThrow();
      if (ye(n)) {
        let r = this.getNextSiblings();
        en(n, r);
      }
    }
    return super.insertBefore(e);
  }
  canInsertAfter(e) {
    return Ue(e);
  }
  canReplaceWith(e) {
    return Ue(e);
  }
  canMergeWith(e) {
    return Ce.$isParagraphNode(e) || Ue(e);
  }
  extractWithChild(e, n) {
    if (!Ce.$isRangeSelection(n))
      return !1;
    e = n.anchor.getNode();
    let r = n.focus.getNode();
    return this.isParentOf(e) && this.isParentOf(r) && this.getTextContent().length === n.getTextContent().length;
  }
};
function Om(t, e, n) {
  let r = [], i = [];
  var o = (e = e.list) ? e.listitem : void 0;
  if (e && e.nested)
    var a = e.nested.listitem;
  if (o !== void 0 && (o = o.split(" "), r.push(...o)), e) {
    o = n.getParent(), o = ye(o) && o.getListType() === "check";
    let s = n.getChecked();
    o && !s || i.push(e.listitemUnchecked), o && s || i.push(e.listitemChecked), o && r.push(s ? e.listitemChecked : e.listitemUnchecked);
  }
  a !== void 0 && (a = a.split(" "), n.getChildren().some((s) => ye(s)) ? r.push(...a) : i.push(...a)), 0 < i.length && xs.removeClassNamesFromElement(t, ...i), 0 < r.length && xs.addClassNamesToElement(
    t,
    ...r
  );
}
function Dm(t, e, n, r) {
  r.getListType() === "check" ? ye(e.getFirstChild()) ? (t.removeAttribute("role"), t.removeAttribute("tabIndex"), t.removeAttribute("aria-checked")) : (t.setAttribute("role", "checkbox"), t.setAttribute("tabIndex", "-1"), n && e.__checked === n.__checked || t.setAttribute("aria-checked", e.getChecked() ? "true" : "false")) : e.getChecked() != null && e.setChecked(void 0);
}
function OA(t) {
  return t = t instanceof HTMLElement && t.getAttribute("aria-checked") === "true", { node: dn(t) };
}
function dn(t) {
  return Ce.$applyNodeReplacement(new Ac(void 0, t));
}
function Ue(t) {
  return t instanceof Ac;
}
let I0 = class zw extends Ce.ElementNode {
  static getType() {
    return "list";
  }
  static clone(e) {
    return new zw(e.__listType || Lm[e.__tag], e.__start, e.__key);
  }
  constructor(e, n, r) {
    super(r), this.__listType = e = Lm[e] || e, this.__tag = e === "number" ? "ol" : "ul", this.__start = n;
  }
  getTag() {
    return this.__tag;
  }
  getListType() {
    return this.__listType;
  }
  getStart() {
    return this.__start;
  }
  createDOM(e) {
    let n = document.createElement(this.__tag);
    return this.__start !== 1 && n.setAttribute("start", String(this.__start)), n.__lexicalListType = this.__listType, Pm(n, e.theme, this), n;
  }
  updateDOM(e, n, r) {
    return e.__tag !== this.__tag ? !0 : (Pm(n, r.theme, this), !1);
  }
  static importDOM() {
    return { ol: () => ({ conversion: Rm, priority: 0 }), ul: () => ({ conversion: Rm, priority: 0 }) };
  }
  static importJSON(e) {
    let n = Kt(e.listType, e.start);
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportDOM() {
    let e = document.createElement(this.__tag);
    return this.__start !== 1 && e.setAttribute("start", String(this.__start)), this.__listType === "check" && e.setAttribute("__lexicalListType", "check"), { element: e };
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      listType: this.getListType(),
      start: this.getStart(),
      tag: this.getTag(),
      type: "list",
      version: 1
    };
  }
  canBeEmpty() {
    return !1;
  }
  canIndent() {
    return !1;
  }
  append(...e) {
    for (let r = 0; r < e.length; r++) {
      var n = e[r];
      if (Ue(n))
        super.append(n);
      else {
        let i = dn();
        ye(n) || Ce.$isElementNode(n) && (n = Ce.$createTextNode(n.getTextContent())), i.append(n), super.append(i);
      }
    }
    return this;
  }
  extractWithChild(e) {
    return Ue(e);
  }
};
function Pm(t, e, n) {
  let r = [], i = [];
  var o = e.list;
  if (o !== void 0) {
    let s = o[`${n.__tag}Depth`] || [];
    e = Pw(n) - 1;
    let l = e % s.length;
    var a = s[l];
    let f = o[n.__tag], c;
    if (o = o.nested, o !== void 0 && o.list && (c = o.list), f !== void 0 && r.push(f), a !== void 0)
      for (a = a.split(" "), r.push(...a), a = 0; a < s.length; a++)
        a !== l && i.push(n.__tag + a);
    c !== void 0 && (n = c.split(" "), 1 < e ? r.push(...n) : i.push(...n));
  }
  0 < i.length && xs.removeClassNamesFromElement(t, ...i), 0 < r.length && xs.addClassNamesToElement(t, ...r);
}
function DA(t) {
  let e = [];
  for (let n = 0; n < t.length; n++) {
    let r = t[n];
    Ue(r) ? (e.push(r), r.getChildren().forEach((i) => {
      ye(i) && e.push(Mm(i));
    })) : e.push(Mm(r));
  }
  return e;
}
function Rm(t) {
  let e = t.nodeName.toLowerCase(), n = null;
  return e === "ol" ? n = Kt("number") : e === "ul" && (n = t instanceof HTMLElement && t.getAttribute("__lexicallisttype") === "check" ? Kt("check") : Kt("bullet")), { after: DA, node: n };
}
let Lm = { ol: "number", ul: "bullet" };
function Kt(t, e = 1) {
  return Ce.$applyNodeReplacement(new I0(t, e));
}
function ye(t) {
  return t instanceof I0;
}
let PA = Ce.createCommand("INSERT_UNORDERED_LIST_COMMAND"), RA = Ce.createCommand("INSERT_ORDERED_LIST_COMMAND"), LA = Ce.createCommand("INSERT_CHECK_LIST_COMMAND"), $A = Ce.createCommand("REMOVE_LIST_COMMAND");
Et.$createListItemNode = dn;
Et.$createListNode = Kt;
Et.$getListDepth = Pw;
Et.$handleListInsertParagraph = function() {
  var t = Ce.$getSelection();
  if (!Ce.$isRangeSelection(t) || !t.isCollapsed() || (t = t.anchor.getNode(), !Ue(t) || t.getTextContent() !== ""))
    return !1;
  var e = E1(t), n = t.getParent();
  ye(n) || Ks(40);
  let r = n.getParent(), i;
  if (Ce.$isRootOrShadowRoot(r))
    i = Ce.$createParagraphNode(), e.insertAfter(i);
  else if (Ue(r))
    i = dn(), r.insertAfter(i);
  else
    return !1;
  if (i.select(), e = t.getNextSiblings(), 0 < e.length) {
    let o = Kt(n.getListType());
    Ce.$isParagraphNode(i) ? i.insertAfter(o) : (n = dn(), n.append(o), i.insertAfter(n)), e.forEach((a) => {
      a.remove(), o.append(a);
    });
  }
  return AA(t), !0;
};
Et.$isListItemNode = Ue;
Et.$isListNode = ye;
Et.INSERT_CHECK_LIST_COMMAND = LA;
Et.INSERT_ORDERED_LIST_COMMAND = RA;
Et.INSERT_UNORDERED_LIST_COMMAND = PA;
Et.ListItemNode = Ac;
Et.ListNode = I0;
Et.REMOVE_LIST_COMMAND = $A;
Et.indentList = function() {
  jw("indent");
};
Et.insertList = function(t, e) {
  t.update(() => {
    var n = Ce.$getSelection();
    if (Ce.$isRangeSelection(n) || Ce.DEPRECATED_$isGridSelection(n)) {
      var r = n.getNodes();
      n = n.anchor.getNode();
      var i = n.getParent();
      if (Lw(n, r))
        r = Kt(e), Ce.$isRootOrShadowRoot(i) ? (n.replace(r), i = dn(), Ce.$isElementNode(n) && (i.setFormat(n.getFormatType()), i.setIndent(n.getIndent())), r.append(i)) : Ue(n) && (n = n.getParentOrThrow(), xi(r, n.getChildren()), n.replace(r));
      else
        for (n = /* @__PURE__ */ new Set(), i = 0; i < r.length; i++) {
          var o = r[i];
          if (Ce.$isElementNode(o) && o.isEmpty() && !n.has(o.getKey()))
            Am(
              o,
              e
            );
          else if (Ce.$isLeafNode(o))
            for (o = o.getParent(); o != null; ) {
              let s = o.getKey();
              if (ye(o)) {
                if (!n.has(s)) {
                  var a = Kt(e);
                  xi(a, o.getChildren()), o.replace(a), en(a), n.add(s);
                }
                break;
              } else {
                if (a = o.getParent(), Ce.$isRootOrShadowRoot(a) && !n.has(s)) {
                  n.add(s), Am(o, e);
                  break;
                }
                o = a;
              }
            }
        }
    }
  });
};
Et.outdentList = function() {
  jw("outdent");
};
Et.removeList = function(t) {
  t.update(() => {
    let e = Ce.$getSelection();
    if (Ce.$isRangeSelection(e)) {
      var n = /* @__PURE__ */ new Set(), r = e.getNodes(), i = e.anchor.getNode();
      if (Lw(i, r))
        n.add(E1(i));
      else
        for (i = 0; i < r.length; i++) {
          var o = r[i];
          Ce.$isLeafNode(o) && (o = xs.$getNearestNodeOfType(o, Ac), o != null && n.add(E1(o)));
        }
      for (let a of n) {
        n = a, r = Rw(a);
        for (let s of r)
          r = Ce.$createParagraphNode(), xi(r, s.getChildren()), n.insertAfter(r), n = r, s.__key === e.anchor.key && e.anchor.set(r.getKey(), 0, "element"), s.__key === e.focus.key && e.focus.set(r.getKey(), 0, "element"), s.remove();
        a.remove();
      }
    }
  });
};
const FA = Et;
var Bw = FA, Zn = {}, hr = {}, N0 = {}, yt = {}, ne = Z;
let If = /* @__PURE__ */ new Map();
function $m(t) {
  for (; t != null; ) {
    if (t.nodeType === Node.TEXT_NODE)
      return t;
    t = t.firstChild;
  }
  return null;
}
function Fm(t) {
  let e = t.parentNode;
  if (e == null)
    throw Error("Should never happen");
  return [e, Array.from(e.childNodes).indexOf(t)];
}
function Ww(t) {
  let e = {};
  t = t.split(";");
  for (let n of t)
    if (n !== "") {
      let [r, i] = n.split(/:([^]+)/);
      e[r.trim()] = i.trim();
    }
  return e;
}
function M0(t) {
  let e = If.get(t);
  return e === void 0 && (e = Ww(t), If.set(t, e)), e;
}
function jA(t) {
  let e = "";
  for (let n in t)
    n && (e += `${n}: ${t[n]};`);
  return e;
}
function Ca(t, e) {
  var n = M0(t.getStyle());
  e = Object.entries(e).reduce((r, [i, o]) => (o === null ? delete r[i] : r[i] = o, r), { ...n }), n = jA(e), t.setStyle(n), If.set(n, e);
}
function zA(t) {
  for (; t !== null && !ne.$isRootOrShadowRoot(t); ) {
    let e = t.getLatest(), n = t.getParent();
    e.getChildrenSize() === 0 && t.remove(!0), t = n;
  }
}
function Gu(t, e, n, r, i = null) {
  if (e.length !== 0) {
    var o = e[0], a = /* @__PURE__ */ new Map(), s = [];
    o = ne.$isElementNode(o) ? o : o.getParentOrThrow(), o.isInline() && (o = o.getParentOrThrow());
    for (var l = !1; o !== null; ) {
      var f = o.getPreviousSibling();
      if (f !== null) {
        o = f, l = !0;
        break;
      }
      if (o = o.getParentOrThrow(), ne.$isRootOrShadowRoot(o))
        break;
    }
    f = /* @__PURE__ */ new Set();
    for (var c = 0; c < n; c++) {
      var u = e[c];
      ne.$isElementNode(u) && u.getChildrenSize() === 0 && f.add(u.getKey());
    }
    var d = /* @__PURE__ */ new Set();
    for (c = 0; c < n; c++) {
      u = e[c];
      var h = u.getParent();
      if (h !== null && h.isInline() && (h = h.getParent()), h !== null && ne.$isLeafNode(u) && !d.has(u.getKey())) {
        if (u = h.getKey(), a.get(u) === void 0) {
          let p = r();
          p.setFormat(h.getFormatType()), p.setIndent(h.getIndent()), s.push(p), a.set(u, p), h.getChildren().forEach((m) => {
            p.append(m), d.add(m.getKey()), ne.$isElementNode(m) && m.getChildrenKeys().forEach((v) => d.add(v));
          }), zA(h);
        }
      } else
        f.has(u.getKey()) && (h = r(), h.setFormat(u.getFormatType()), h.setIndent(u.getIndent()), s.push(h), u.remove(!0));
    }
    if (i !== null)
      for (e = 0; e < s.length; e++)
        i.append(s[e]);
    if (e = null, ne.$isRootOrShadowRoot(o))
      if (l)
        if (i !== null)
          o.insertAfter(i);
        else
          for (i = s.length - 1; 0 <= i; i--)
            o.insertAfter(s[i]);
      else if (l = o.getFirstChild(), ne.$isElementNode(l) && (o = l), l === null)
        if (i)
          o.append(i);
        else
          for (i = 0; i < s.length; i++)
            l = s[i], o.append(l), e = l;
      else if (i !== null)
        l.insertBefore(i);
      else
        for (o = 0; o < s.length; o++)
          i = s[o], l.insertBefore(i), e = i;
    else if (i)
      o.insertAfter(i);
    else
      for (i = s.length - 1; 0 <= i; i--)
        l = s[i], o.insertAfter(l), e = l;
    s = ne.$getPreviousSelection(), ne.$isRangeSelection(s) && s.anchor.getNode().isAttached() && s.focus.getNode().isAttached() ? ne.$setSelection(s.clone()) : e !== null ? e.selectEnd() : t.dirty = !0;
  }
}
function Uw(t, e, n, r) {
  t.modify(e ? "extend" : "move", n, r);
}
function Hw(t) {
  return t = t.anchor.getNode(), (ne.$isRootNode(t) ? t : t.getParentOrThrow()).getDirection() === "rtl";
}
yt.$addNodeStyle = function(t) {
  t = t.getStyle();
  let e = Ww(t);
  If.set(t, e);
};
yt.$cloneWithProperties = function(t) {
  t = t.getLatest();
  let e = t.constructor.clone(t);
  return e.__parent = t.__parent, e.__next = t.__next, e.__prev = t.__prev, ne.$isElementNode(t) && ne.$isElementNode(e) ? (e.__first = t.__first, e.__last = t.__last, e.__size = t.__size, e.__format = t.__format, e.__indent = t.__indent, e.__dir = t.__dir, e) : (ne.$isTextNode(t) && ne.$isTextNode(e) && (e.__format = t.__format, e.__style = t.__style, e.__mode = t.__mode, e.__detail = t.__detail), e);
};
yt.$getSelectionStyleValueForProperty = function(t, e, n = "") {
  let r = null, i = t.getNodes();
  var o = t.anchor, a = t.focus, s = t.isBackward();
  for (t = s ? a.offset : o.offset, o = s ? a.getNode() : o.getNode(), a = 0; a < i.length; a++) {
    var l = i[a];
    if ((a === 0 || t !== 0 || !l.is(o)) && ne.$isTextNode(l)) {
      s = e;
      var f = n;
      if (l = l.getStyle(), l = M0(l), s = l !== null && l[s] || f, r === null)
        r = s;
      else if (r !== s) {
        r = "";
        break;
      }
    }
  }
  return r === null ? n : r;
};
yt.$isAtNodeEnd = function(t) {
  return t.type === "text" ? t.offset === t.getNode().getTextContentSize() : t.offset === t.getNode().getChildrenSize();
};
yt.$isParentElementRTL = Hw;
yt.$moveCaretSelection = Uw;
yt.$moveCharacter = function(t, e, n) {
  let r = Hw(t);
  Uw(t, e, n ? !r : r, "character");
};
yt.$patchStyleText = function(t, e) {
  var n = t.getNodes();
  let r = n.length - 1, i = n[0], o = n[r];
  if (!t.isCollapsed()) {
    var a = t.anchor, s = t.focus, l = i.getTextContent().length, f = s.offset, c = a.offset, u = a.isBefore(s), d = u ? c : f;
    t = u ? f : c;
    var h = u ? a.type : s.type, p = u ? s.type : a.type;
    if (a = u ? s.key : a.key, ne.$isTextNode(i) && d === l && (s = i.getNextSibling(), ne.$isTextNode(s) && (d = c = 0, i = s)), i.is(o))
      ne.$isTextNode(i) && (d = h === "element" ? 0 : c > f ? f : c, t = p === "element" ? l : c > f ? c : f, d !== t && (d === 0 && t === l ? (Ca(i, e), i.select(d, t)) : (n = i.splitText(d, t), n = d === 0 ? n[0] : n[1], Ca(n, e), n.select(0, t - d))));
    else
      for (ne.$isTextNode(i) && d < i.getTextContentSize() && (d !== 0 && (i = i.splitText(d)[1]), Ca(i, e)), ne.$isTextNode(o) && (d = o.getTextContent().length, o.__key !== a && t !== 0 && (t = d), t !== d && ([o] = o.splitText(t)), t !== 0 && Ca(o, e)), t = 1; t < r; t++)
        d = n[t], l = d.getKey(), ne.$isTextNode(d) && l !== i.getKey() && l !== o.getKey() && !d.isToken() && Ca(d, e);
  }
};
yt.$selectAll = function(t) {
  let e = t.anchor;
  t = t.focus;
  var n = e.getNode().getTopLevelElementOrThrow().getParentOrThrow();
  let r = n.getFirstDescendant();
  n = n.getLastDescendant();
  let i = "element", o = "element", a = 0;
  ne.$isTextNode(r) ? i = "text" : ne.$isElementNode(r) || r === null || (r = r.getParentOrThrow()), ne.$isTextNode(n) ? (o = "text", a = n.getTextContentSize()) : ne.$isElementNode(n) || n === null || (n = n.getParentOrThrow()), r && n && (e.set(r.getKey(), 0, i), t.set(n.getKey(), a, o));
};
yt.$setBlocksType_experimental = function(t, e) {
  if (t.anchor.key === "root") {
    e = e();
    var n = ne.$getRoot();
    (t = n.getFirstChild()) ? t.replace(e, !0) : n.append(e);
  } else
    for (n = t.getNodes(), t.anchor.type === "text" && (t = t.anchor.getNode().getParent(), t = t.isInline() ? t.getParent() : t, n.indexOf(t) === -1 && n.push(t)), t = 0; t < n.length; t++) {
      let i = n[t];
      var r = i;
      !ne.$isElementNode(r) || ne.$isRootOrShadowRoot(r) || r.isInline() || (r = e(), r.setFormat(i.getFormatType()), r.setIndent(i.getIndent()), i.replace(r, !0));
    }
};
yt.$shouldOverrideDefaultCharacterSelection = function(t, e) {
  return t = ne.$getAdjacentNode(t.focus, e), ne.$isDecoratorNode(t) && !t.isIsolated() || ne.$isElementNode(t) && !t.isInline() && !t.canBeEmpty();
};
yt.$sliceSelectedTextNodeContent = function(t, e) {
  if (e.isSelected() && !e.isSegmented() && !e.isToken() && (ne.$isRangeSelection(t) || ne.DEPRECATED_$isGridSelection(t))) {
    var n = t.anchor.getNode(), r = t.focus.getNode(), i = e.is(n), o = e.is(r);
    if (i || o) {
      i = t.isBackward();
      let [a, s] = t.getCharacterOffsets();
      t = n.is(r), o = e.is(i ? r : n), r = e.is(i ? n : r), n = 0;
      let l;
      t ? (n = a > s ? s : a, l = a > s ? a : s) : o ? (n = i ? s : a, l = void 0) : r && (i = i ? a : s, n = 0, l = i), e.__text = e.__text.slice(n, l);
    }
  }
  return e;
};
yt.$wrapNodes = function(t, e, n = null) {
  var r = t.getNodes();
  let i = r.length;
  var o = t.anchor;
  if (i === 0 || i === 1 && o.type === "element" && o.getNode().getChildrenSize() === 0) {
    t = o.type === "text" ? o.getNode().getParentOrThrow() : o.getNode(), r = t.getChildren();
    let s = e();
    s.setFormat(t.getFormatType()), s.setIndent(t.getIndent()), r.forEach((l) => s.append(l)), n && (s = n.append(s)), t.replace(s);
  } else {
    o = null;
    var a = [];
    for (let s = 0; s < i; s++) {
      let l = r[s];
      ne.$isRootOrShadowRoot(l) ? (Gu(t, a, a.length, e, n), a = [], o = l) : o === null || o !== null && ne.$hasAncestor(
        l,
        o
      ) ? a.push(l) : (Gu(t, a, a.length, e, n), a = [l]);
    }
    Gu(t, a, a.length, e, n);
  }
};
yt.createDOMRange = function(t, e, n, r, i) {
  let o = e.getKey(), a = r.getKey(), s = document.createRange(), l = t.getElementByKey(o);
  if (t = t.getElementByKey(a), ne.$isTextNode(e) && (l = $m(l)), ne.$isTextNode(r) && (t = $m(t)), e === void 0 || r === void 0 || l === null || t === null)
    return null;
  l.nodeName === "BR" && ([l, n] = Fm(l)), t.nodeName === "BR" && ([t, i] = Fm(t)), e = l.firstChild, l === t && e != null && e.nodeName === "BR" && n === 0 && i === 0 && (i = 1);
  try {
    s.setStart(l, n), s.setEnd(t, i);
  } catch {
    return null;
  }
  return !s.collapsed || n === i && o === a || (s.setStart(t, i), s.setEnd(
    l,
    n
  )), s;
};
yt.createRectsFromDOMRange = function(t, e) {
  var n = t.getRootElement();
  if (n === null)
    return [];
  t = n.getBoundingClientRect(), n = getComputedStyle(n), n = parseFloat(n.paddingLeft) + parseFloat(n.paddingRight), e = Array.from(e.getClientRects());
  let r = e.length, i;
  for (let o = 0; o < r; o++) {
    let a = e[o], s = a.width + n === t.width;
    i && i.top === a.top && i.left === a.left && i.width === a.width && i.height === a.height || s ? (e.splice(o--, 1), r--) : i = a;
  }
  return e;
};
yt.getStyleObjectFromCSS = M0;
yt.trimTextContentFromAnchor = function(t, e, n) {
  let r = e.getNode();
  if (ne.$isElementNode(r)) {
    var i = r.getDescendantByIndex(e.offset);
    i !== null && (r = i);
  }
  for (; 0 < n && r !== null; ) {
    var o = r.getPreviousSibling(), a = 0;
    if (o === null) {
      i = r.getParentOrThrow();
      for (var s = i.getPreviousSibling(); s === null; ) {
        if (i = i.getParent(), i === null) {
          o = null;
          break;
        }
        s = i.getPreviousSibling();
      }
      i !== null && (a = i.isInline() ? 0 : 2, o = ne.$isElementNode(s) ? s.getLastDescendant() : s);
    }
    let l = r.getTextContent();
    l === "" && ne.$isElementNode(r) && !r.isInline() && (l = `

`), i = l.length, s = i - n;
    let f = l.slice(0, s);
    if (!ne.$isTextNode(r) || n >= i)
      s = r.getParent(), r.remove(), s != null && s.getChildrenSize() === 0 && s.remove(), n -= i + a, r = o;
    else {
      let c = r.getKey();
      o = t.getEditorState().read(() => {
        const u = ne.$getNodeByKey(c);
        return ne.$isTextNode(u) && u.isSimpleText() ? u.getTextContent() : null;
      }), o !== null && o !== l ? (n = ne.$getPreviousSelection(), i = r, r.isSimpleText() ? r.setTextContent(o) : (i = ne.$createTextNode(o), r.replace(i)), ne.$isRangeSelection(n) && n.isCollapsed() && (n = n.anchor.offset, i.select(n, n))) : r.isSimpleText() ? (o = e.key === c, a = e.offset, a < n && (a = i), n = o ? a - n : 0, i = o ? a : s, o && n === 0 ? ([n] = r.splitText(n, i), n.remove()) : ([, n] = r.splitText(n, i), n.remove())) : (n = ne.$createTextNode(f), r.replace(n)), n = 0;
    }
  }
};
const BA = yt;
var Oc = BA, jm = Oc, uo = Z;
function Vw(t, e, n, r = null) {
  let i = r != null ? e.isSelected() : !0, o = uo.$isElementNode(e) && e.excludeFromCopy("html");
  var a = e;
  r !== null && (a = jm.$cloneWithProperties(e), a = uo.$isTextNode(a) && r != null ? jm.$sliceSelectedTextNodeContent(r, a) : a);
  let s = uo.$isElementNode(a) ? a.getChildren() : [], { element: l, after: f } = a.exportDOM(t);
  if (!l)
    return !1;
  let c = new DocumentFragment();
  for (let u = 0; u < s.length; u++) {
    let d = s[u], h = Vw(t, d, c, r);
    !i && uo.$isElementNode(e) && h && e.extractWithChild(d, r, "html") && (i = !0);
  }
  return i && !o ? (l.append(c), n.append(l), f && (t = f.call(
    a,
    l
  )) && l.replaceWith(t)) : n.append(c), i;
}
let Kw = /* @__PURE__ */ new Set(["STYLE"]);
function Yw(t, e, n = /* @__PURE__ */ new Map(), r, i = !1) {
  let o = [];
  if (Kw.has(t.nodeName))
    return o;
  let a = null;
  var { nodeName: s } = t, l = e._htmlConversions.get(s.toLowerCase());
  if (s = null, l !== void 0)
    for (f of l)
      l = f(t), l !== null && (s === null || s.priority < l.priority) && (s = l);
  var f = (f = s !== null ? s.conversion : null) ? f(t, void 0, i) : null;
  if (s = null, f !== null) {
    if (s = f.after, a = f.node, a !== null) {
      for (var [, c] of n)
        if (a = c(a, r), !a)
          break;
      a && o.push(a);
    }
    f.forChild != null && n.set(t.nodeName, f.forChild);
  }
  for (t = t.childNodes, r = [], c = 0; c < t.length; c++)
    r.push(...Yw(
      t[c],
      e,
      new Map(n),
      a,
      i || (f && f.preformatted) === !0
    ));
  return s != null && (r = s(r)), a == null ? o = o.concat(r) : uo.$isElementNode(a) && a.append(...r), o;
}
N0.$generateHtmlFromNodes = function(t, e) {
  if (typeof document > "u" || typeof window > "u")
    throw Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
  let n = document.createElement("div"), r = uo.$getRoot().getChildren();
  for (let i = 0; i < r.length; i++)
    Vw(t, r[i], n, e);
  return n.innerHTML;
};
N0.$generateNodesFromDOM = function(t, e) {
  let n = [];
  e = e.body ? Array.from(e.body.childNodes) : [];
  let r = e.length;
  for (let o = 0; o < r; o++) {
    var i = e[o];
    Kw.has(i.nodeName) || (i = Yw(i, t), i !== null && (n = n.concat(i)));
  }
  return n;
};
const WA = N0;
var UA = WA, qw = UA, zm = Bw, S1 = Oc, qa = Jn, se = Z;
function sr(t) {
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?code=${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function Gw(t) {
  let e = se.$getSelection();
  if (e == null)
    throw Error("Expected valid LexicalSelection");
  return se.$isRangeSelection(e) && e.isCollapsed() || e.getNodes().length === 0 ? "" : qw.$generateHtmlFromNodes(t, e);
}
function Qw(t) {
  let e = se.$getSelection();
  if (e == null)
    throw Error("Expected valid LexicalSelection");
  return se.$isRangeSelection(e) && e.isCollapsed() || e.getNodes().length === 0 ? null : JSON.stringify(Jw(t, e));
}
function I1(t, e, n) {
  (se.DEPRECATED_$isGridSelection(n) || qa.$findMatchingParent(n.anchor.getNode(), (r) => se.DEPRECATED_$isGridCellNode(r)) !== null && qa.$findMatchingParent(n.focus.getNode(), (r) => se.DEPRECATED_$isGridCellNode(r)) !== null) && e.length === 1 && se.DEPRECATED_$isGridNode(e[0]) ? VA(e, n, !1, t) : HA(e, n);
}
function HA(t, e) {
  let n = [], r = null, i = null;
  for (let o = 0; o < t.length; o++) {
    let a = t[o];
    if (zm.$isListItemNode(a)) {
      i == null && (i = zm.$createListNode("bullet"), n.push(i)), i.append(a);
      continue;
    } else
      i != null && (i = null);
    let s = se.$isLineBreakNode(a);
    if (s || se.$isDecoratorNode(a) && a.isInline() || se.$isElementNode(a) && a.isInline() || se.$isTextNode(a)) {
      if (r === null && (r = se.$createParagraphNode(), n.push(r), s))
        continue;
      r !== null && r.append(a);
    } else
      n.push(a), r = null;
  }
  se.$isRangeSelection(e) ? e.insertNodes(n) : se.DEPRECATED_$isGridSelection(e) && (t = e.anchor.getNode(), se.DEPRECATED_$isGridCellNode(t) || sr(41), t.append(...n));
}
function VA(t, e, n, r) {
  t.length === 1 && se.DEPRECATED_$isGridNode(t[0]) || sr(42);
  var i = t[0];
  t = i.getChildren(), n = i.getFirstChildOrThrow().getChildrenSize();
  var o = i.getChildrenSize(), a = qa.$findMatchingParent(e.anchor.getNode(), (h) => se.DEPRECATED_$isGridCellNode(h));
  e = (i = a && qa.$findMatchingParent(a, (h) => se.DEPRECATED_$isGridRowNode(h))) && qa.$findMatchingParent(i, (h) => se.DEPRECATED_$isGridNode(h)), se.DEPRECATED_$isGridCellNode(a) && se.DEPRECATED_$isGridRowNode(i) && se.DEPRECATED_$isGridNode(e) || sr(43);
  var s = i.getIndexWithinParent(), l = Math.min(e.getChildrenSize() - 1, s + o - 1);
  o = a.getIndexWithinParent(), a = Math.min(i.getChildrenSize() - 1, o + n - 1), n = Math.min(o, a), i = Math.min(s, l), o = Math.max(o, a), s = Math.max(s, l), l = e.getChildren(), a = 0;
  let f, c;
  for (let h = i; h <= s; h++) {
    var u = l[h];
    se.DEPRECATED_$isGridRowNode(u) || sr(24);
    var d = t[a];
    se.DEPRECATED_$isGridRowNode(d) || sr(24), u = u.getChildren(), d = d.getChildren();
    let p = 0;
    for (let m = n; m <= o; m++) {
      let v = u[m];
      se.DEPRECATED_$isGridCellNode(v) || sr(25);
      let b = d[p];
      se.DEPRECATED_$isGridCellNode(b) || sr(25), h === i && m === n ? f = v.getKey() : h === s && m === o && (c = v.getKey());
      let k = v.getChildren();
      b.getChildren().forEach((_) => {
        se.$isTextNode(_) && se.$createParagraphNode().append(_), v.append(_);
      }), k.forEach((_) => _.remove()), p++;
    }
    a++;
  }
  f && c && (t = se.DEPRECATED_$createGridSelection(), t.set(e.getKey(), f, c), se.$setSelection(t), r.dispatchCommand(se.SELECTION_CHANGE_COMMAND, void 0));
}
function Xw(t, e, n, r = []) {
  let i = e != null ? n.isSelected() : !0, o = se.$isElementNode(n) && n.excludeFromCopy("html");
  var a = n;
  if (e !== null) {
    var s = S1.$cloneWithProperties(n);
    a = s = se.$isTextNode(s) && e != null ? S1.$sliceSelectedTextNodeContent(e, s) : s;
  }
  let l = se.$isElementNode(a) ? a.getChildren() : [];
  var f = a;
  s = f.exportJSON(), s.type !== f.constructor.getType() && sr(58);
  var c = s.children;
  for (se.$isElementNode(f) && (Array.isArray(c) || sr(59)), se.$isTextNode(a) && (s.text = a.__text), a = 0; a < l.length; a++)
    f = l[a], c = Xw(t, e, f, s.children), !i && se.$isElementNode(n) && c && n.extractWithChild(f, e, "clone") && (i = !0);
  if (i && !o)
    r.push(s);
  else if (Array.isArray(s.children))
    for (t = 0; t < s.children.length; t++)
      r.push(s.children[t]);
  return i;
}
function Jw(t, e) {
  let n = [], r = se.$getRoot().getChildren();
  for (let i = 0; i < r.length; i++)
    Xw(t, e, r[i], n);
  return { namespace: t._config.namespace, nodes: n };
}
function Zw(t) {
  let e = [];
  for (let n = 0; n < t.length; n++) {
    let r = se.$parseSerializedNode(t[n]);
    se.$isTextNode(r) && S1.$addNodeStyle(r), e.push(r);
  }
  return e;
}
let no = null;
function Bm(t, e) {
  if (e.preventDefault(), e = e.clipboardData, e === null)
    return !1;
  let n = se.$getSelection(), r = Gw(t);
  t = Qw(t);
  let i = "";
  return n !== null && (i = n.getTextContent()), r !== null && e.setData("text/html", r), t !== null && e.setData("application/x-lexical-editor", t), e.setData("text/plain", i), !0;
}
hr.$generateJSONFromSelectedNodes = Jw;
hr.$generateNodesFromSerializedNodes = Zw;
hr.$getHtmlContent = Gw;
hr.$getLexicalContent = Qw;
hr.$insertDataTransferForPlainText = function(t, e) {
  t = t.getData("text/plain"), t != null && e.insertRawText(t);
};
hr.$insertDataTransferForRichText = function(t, e, n) {
  var r = t.getData("application/x-lexical-editor");
  if (r)
    try {
      let o = JSON.parse(r);
      if (o.namespace === n._config.namespace && Array.isArray(o.nodes)) {
        let a = Zw(o.nodes);
        return I1(n, a, e);
      }
    } catch {
    }
  if (r = t.getData("text/html"))
    try {
      var i = new DOMParser().parseFromString(r, "text/html");
      let o = qw.$generateNodesFromDOM(n, i);
      return I1(n, o, e);
    } catch {
    }
  if (t = t.getData("text/plain"), t != null)
    if (se.$isRangeSelection(e))
      for (t = t.split(/\r?\n/), n = t.length, i = 0; i < n; i++)
        e.insertText(t[i]), i < n - 1 && e.insertParagraph();
    else
      e.insertRawText(t);
};
hr.$insertGeneratedNodes = I1;
hr.copyToClipboard__EXPERIMENTAL = async function(t, e) {
  if (no !== null)
    return !1;
  if (e !== null)
    return new Promise((o) => {
      t.update(() => {
        o(Bm(t, e));
      });
    });
  var n = t.getRootElement();
  let r = document.getSelection();
  if (n === null || r === null)
    return !1;
  let i = document.createElement("span");
  return i.style.cssText = "position: fixed; top: -1000px;", i.append(document.createTextNode("#")), n.append(i), n = new Range(), n.setStart(i, 0), n.setEnd(i, 1), r.removeAllRanges(), r.addRange(n), new Promise((o) => {
    let a = t.registerCommand(
      se.COPY_COMMAND,
      (s) => (s instanceof ClipboardEvent && (a(), no !== null && (window.clearTimeout(no), no = null), o(Bm(t, s))), !0),
      se.COMMAND_PRIORITY_CRITICAL
    );
    no = window.setTimeout(() => {
      a(), no = null, o(!1);
    }, 50), document.execCommand("copy"), i.remove();
  });
};
const KA = hr;
var A0 = KA, Nf = A0, fl = Oc, bo = Jn, M = Z;
function Wm(t, e) {
  return typeof document.caretRangeFromPoint < "u" ? (t = document.caretRangeFromPoint(t, e), t === null ? null : { node: t.startContainer, offset: t.startOffset }) : document.caretPositionFromPoint !== "undefined" ? (t = document.caretPositionFromPoint(t, e), t === null ? null : { node: t.offsetNode, offset: t.offset }) : null;
}
let Dc = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", YA = Dc && "documentMode" in document ? document.documentMode : null, qA = Dc && "InputEvent" in window && !YA ? "getTargetRanges" in new window.InputEvent("input") : !1, GA = Dc && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), QA = Dc && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, N1 = M.createCommand("DRAG_DROP_PASTE_FILE"), O0 = class e6 extends M.ElementNode {
  static getType() {
    return "quote";
  }
  static clone(e) {
    return new e6(e.__key);
  }
  constructor(e) {
    super(e);
  }
  createDOM(e) {
    let n = document.createElement("blockquote");
    return bo.addClassNamesToElement(n, e.theme.quote), n;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { blockquote: () => ({ conversion: XA, priority: 0 }) };
  }
  static importJSON(e) {
    let n = D0();
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "quote" };
  }
  insertNewAfter(e, n) {
    e = M.$createParagraphNode();
    let r = this.getDirection();
    return e.setDirection(r), this.insertAfter(e, n), e;
  }
  collapseAtStart() {
    let e = M.$createParagraphNode();
    return this.getChildren().forEach((n) => e.append(n)), this.replace(e), !0;
  }
};
function D0() {
  return M.$applyNodeReplacement(new O0());
}
let P0 = class t6 extends M.ElementNode {
  static getType() {
    return "heading";
  }
  static clone(e) {
    return new t6(e.__tag, e.__key);
  }
  constructor(e, n) {
    super(n), this.__tag = e;
  }
  getTag() {
    return this.__tag;
  }
  createDOM(e) {
    let n = this.__tag, r = document.createElement(n);
    return e = e.theme.heading, e !== void 0 && bo.addClassNamesToElement(r, e[n]), r;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { h1: () => ({ conversion: ro, priority: 0 }), h2: () => ({ conversion: ro, priority: 0 }), h3: () => ({ conversion: ro, priority: 0 }), h4: () => ({ conversion: ro, priority: 0 }), h5: () => ({
      conversion: ro,
      priority: 0
    }), h6: () => ({ conversion: ro, priority: 0 }), p: (e) => (e = e.firstChild, e !== null && Um(e) ? { conversion: () => ({ node: null }), priority: 3 } : null), span: (e) => Um(e) ? { conversion: () => ({ node: ho("h1") }), priority: 3 } : null };
  }
  static importJSON(e) {
    let n = ho(e.tag);
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), tag: this.getTag(), type: "heading", version: 1 };
  }
  insertNewAfter(e, n = !0) {
    e = e ? e.anchor.offset : 0, e = 0 < e && e < this.getTextContentSize() ? ho(this.getTag()) : M.$createParagraphNode();
    let r = this.getDirection();
    return e.setDirection(r), this.insertAfter(e, n), e;
  }
  collapseAtStart() {
    let e = this.isEmpty() ? M.$createParagraphNode() : ho(this.getTag());
    return this.getChildren().forEach((n) => e.append(n)), this.replace(e), !0;
  }
  extractWithChild() {
    return !0;
  }
};
function Um(t) {
  return t.nodeName.toLowerCase() === "span" ? t.style.fontSize === "26pt" : !1;
}
function ro(t) {
  t = t.nodeName.toLowerCase();
  let e = null;
  return (t === "h1" || t === "h2" || t === "h3" || t === "h4" || t === "h5" || t === "h6") && (e = ho(t)), { node: e };
}
function XA() {
  return { node: D0() };
}
function ho(t) {
  return M.$applyNodeReplacement(new P0(t));
}
function JA(t, e) {
  t.preventDefault(), e.update(() => {
    let n = M.$getSelection(), r = t instanceof InputEvent || t instanceof KeyboardEvent ? null : t.clipboardData;
    r != null && (M.$isRangeSelection(n) || M.DEPRECATED_$isGridSelection(n)) && Nf.$insertDataTransferForRichText(r, n, e);
  }, { tag: "paste" });
}
async function ZA(t, e) {
  await Nf.copyToClipboard__EXPERIMENTAL(e, t instanceof ClipboardEvent ? t : null), e.update(() => {
    let n = M.$getSelection();
    M.$isRangeSelection(n) ? n.removeText() : M.$isNodeSelection(n) && n.getNodes().forEach((r) => r.remove());
  });
}
function Na(t) {
  let e = null;
  if (t instanceof DragEvent ? e = t.dataTransfer : t instanceof ClipboardEvent && (e = t.clipboardData), e === null)
    return [!1, [], !1];
  var n = e.types;
  return t = n.includes("Files"), n = n.includes("text/html") || n.includes("text/plain"), [t, Array.from(e.files), n];
}
function Hm(t, e) {
  var n = M.$getSelection();
  if (M.$isRangeSelection(n)) {
    var r = /* @__PURE__ */ new Set();
    n = n.getNodes();
    for (let i = 0; i < n.length; i++) {
      let o = n[i], a = o.getKey();
      if (r.has(a))
        continue;
      let s = bo.$getNearestBlockElementAncestorOrThrow(o), l = s.getKey();
      s.canInsertTab() ? (t(o), r.add(a)) : s.canIndent() && !r.has(l) && (r.add(l), e(s));
    }
  }
}
function cl(t) {
  return t = M.$getNearestNodeFromDOMNode(t), M.$isDecoratorNode(t);
}
Zn.$createHeadingNode = ho;
Zn.$createQuoteNode = D0;
Zn.$isHeadingNode = function(t) {
  return t instanceof P0;
};
Zn.$isQuoteNode = function(t) {
  return t instanceof O0;
};
Zn.DRAG_DROP_PASTE = N1;
Zn.HeadingNode = P0;
Zn.QuoteNode = O0;
Zn.eventFiles = Na;
Zn.registerRichText = function(t) {
  return bo.mergeRegister(
    t.registerCommand(M.CLICK_COMMAND, () => {
      const e = M.$getSelection();
      return M.$isNodeSelection(e) ? (e.clear(), !0) : !1;
    }, 0),
    t.registerCommand(M.DELETE_CHARACTER_COMMAND, (e) => {
      const n = M.$getSelection();
      return M.$isRangeSelection(n) ? (n.deleteCharacter(e), !0) : !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.DELETE_WORD_COMMAND, (e) => {
      const n = M.$getSelection();
      return M.$isRangeSelection(n) ? (n.deleteWord(e), !0) : !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.DELETE_LINE_COMMAND, (e) => {
      const n = M.$getSelection();
      return M.$isRangeSelection(n) ? (n.deleteLine(e), !0) : !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.CONTROLLED_TEXT_INSERTION_COMMAND, (e) => {
      const n = M.$getSelection();
      if (typeof e == "string")
        M.$isRangeSelection(n) ? n.insertText(e) : M.DEPRECATED_$isGridSelection(n);
      else {
        if (!M.$isRangeSelection(n) && !M.DEPRECATED_$isGridSelection(n))
          return !1;
        const r = e.dataTransfer;
        r != null ? Nf.$insertDataTransferForRichText(r, n, t) : M.$isRangeSelection(n) && (e = e.data) && n.insertText(e);
      }
      return !0;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.REMOVE_TEXT_COMMAND, () => {
      const e = M.$getSelection();
      return M.$isRangeSelection(e) ? (e.removeText(), !0) : !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.FORMAT_TEXT_COMMAND, (e) => {
      const n = M.$getSelection();
      return M.$isRangeSelection(n) ? (n.formatText(e), !0) : !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.FORMAT_ELEMENT_COMMAND, (e) => {
      var n = M.$getSelection();
      if (!M.$isRangeSelection(n) && !M.$isNodeSelection(n))
        return !1;
      n = n.getNodes();
      for (const r of n)
        bo.$getNearestBlockElementAncestorOrThrow(r).setFormat(e);
      return !0;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.INSERT_LINE_BREAK_COMMAND, (e) => {
      const n = M.$getSelection();
      return M.$isRangeSelection(n) ? (n.insertLineBreak(e), !0) : !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.INSERT_PARAGRAPH_COMMAND, () => {
      const e = M.$getSelection();
      return M.$isRangeSelection(e) ? (e.insertParagraph(), !0) : !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(
      M.INDENT_CONTENT_COMMAND,
      () => (Hm(() => {
        t.dispatchCommand(M.CONTROLLED_TEXT_INSERTION_COMMAND, "	");
      }, (e) => {
        const n = e.getIndent();
        n !== 10 && e.setIndent(n + 1);
      }), !0),
      M.COMMAND_PRIORITY_EDITOR
    ),
    t.registerCommand(M.OUTDENT_CONTENT_COMMAND, () => (Hm((e) => {
      M.$isTextNode(e) && (e = e.getTextContent(), e[e.length - 1] === "	" && t.dispatchCommand(M.DELETE_CHARACTER_COMMAND, !0));
    }, (e) => {
      const n = e.getIndent();
      n !== 0 && e.setIndent(n - 1);
    }), !0), M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.KEY_ARROW_UP_COMMAND, (e) => {
      var n = M.$getSelection();
      if (M.$isNodeSelection(n) && !cl(e.target)) {
        if (e = n.getNodes(), 0 < e.length)
          return e[0].selectPrevious(), !0;
      } else if (M.$isRangeSelection(n)) {
        if (n = M.$getAdjacentNode(n.focus, !0), M.$isDecoratorNode(n) && !n.isIsolated())
          return n.selectPrevious(), e.preventDefault(), !0;
        if (M.$isElementNode(n) && !n.isInline() && !n.canBeEmpty())
          return n.select(), e.preventDefault(), !0;
      }
      return !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.KEY_ARROW_DOWN_COMMAND, (e) => {
      var n = M.$getSelection();
      if (M.$isNodeSelection(n)) {
        if (e = n.getNodes(), 0 < e.length)
          return e[0].selectNext(
            0,
            0
          ), !0;
      } else if (M.$isRangeSelection(n)) {
        let r = n.focus;
        if (r.key === "root" && r.offset === M.$getRoot().getChildrenSize())
          return e.preventDefault(), !0;
        if (n = M.$getAdjacentNode(n.focus, !1), M.$isDecoratorNode(n) && !n.isIsolated())
          return n.selectNext(), e.preventDefault(), !0;
      }
      return !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.KEY_ARROW_LEFT_COMMAND, (e) => {
      const n = M.$getSelection();
      if (M.$isNodeSelection(n)) {
        var r = n.getNodes();
        if (0 < r.length)
          return e.preventDefault(), r[0].selectPrevious(), !0;
      }
      return M.$isRangeSelection(n) && fl.$shouldOverrideDefaultCharacterSelection(n, !0) ? (r = e.shiftKey, e.preventDefault(), fl.$moveCharacter(n, r, !0), !0) : !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.KEY_ARROW_RIGHT_COMMAND, (e) => {
      const n = M.$getSelection();
      if (M.$isNodeSelection(n) && !cl(e.target)) {
        var r = n.getNodes();
        if (0 < r.length)
          return e.preventDefault(), r[0].selectNext(0, 0), !0;
      }
      return M.$isRangeSelection(n) ? (r = e.shiftKey, fl.$shouldOverrideDefaultCharacterSelection(n, !1) ? (e.preventDefault(), fl.$moveCharacter(n, r, !1), !0) : !1) : !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.KEY_BACKSPACE_COMMAND, (e) => {
      if (cl(e.target))
        return !1;
      const n = M.$getSelection();
      if (!M.$isRangeSelection(n))
        return !1;
      e.preventDefault(), { anchor: e } = n;
      const r = e.getNode();
      return n.isCollapsed() && e.offset === 0 && !M.$isRootNode(r) && 0 < bo.$getNearestBlockElementAncestorOrThrow(r).getIndent() ? t.dispatchCommand(M.OUTDENT_CONTENT_COMMAND, void 0) : t.dispatchCommand(M.DELETE_CHARACTER_COMMAND, !0);
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.KEY_DELETE_COMMAND, (e) => {
      if (cl(e.target))
        return !1;
      const n = M.$getSelection();
      return M.$isRangeSelection(n) ? (e.preventDefault(), t.dispatchCommand(M.DELETE_CHARACTER_COMMAND, !1)) : !1;
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.KEY_ENTER_COMMAND, (e) => {
      const n = M.$getSelection();
      if (!M.$isRangeSelection(n))
        return !1;
      if (e !== null) {
        if ((QA || GA) && qA)
          return !1;
        if (e.preventDefault(), e.shiftKey)
          return t.dispatchCommand(M.INSERT_LINE_BREAK_COMMAND, !1);
      }
      return t.dispatchCommand(M.INSERT_PARAGRAPH_COMMAND, void 0);
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(
      M.KEY_ESCAPE_COMMAND,
      () => {
        const e = M.$getSelection();
        return M.$isRangeSelection(e) ? (t.blur(), !0) : !1;
      },
      M.COMMAND_PRIORITY_EDITOR
    ),
    t.registerCommand(M.DROP_COMMAND, (e) => {
      const [, n] = Na(e);
      if (0 < n.length) {
        var r = Wm(e.clientX, e.clientY);
        if (r !== null) {
          const { offset: o, node: a } = r;
          var i = M.$getNearestNodeFromDOMNode(a);
          if (i !== null) {
            if (r = M.$createRangeSelection(), M.$isTextNode(i))
              r.anchor.set(i.getKey(), o, "text"), r.focus.set(i.getKey(), o, "text");
            else {
              const s = i.getParentOrThrow().getKey();
              i = i.getIndexWithinParent() + 1, r.anchor.set(
                s,
                i,
                "element"
              ), r.focus.set(s, i, "element");
            }
            r = M.$normalizeSelection__EXPERIMENTAL(r), M.$setSelection(r);
          }
          t.dispatchCommand(N1, n);
        }
        return e.preventDefault(), !0;
      }
      return e = M.$getSelection(), !!M.$isRangeSelection(e);
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.DRAGSTART_COMMAND, (e) => {
      [e] = Na(e);
      const n = M.$getSelection();
      return !(e && !M.$isRangeSelection(n));
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.DRAGOVER_COMMAND, (e) => {
      var [n] = Na(e);
      const r = M.$getSelection();
      return n && !M.$isRangeSelection(r) ? !1 : (n = Wm(e.clientX, e.clientY), n !== null && (n = M.$getNearestNodeFromDOMNode(n.node), M.$isDecoratorNode(n) && e.preventDefault()), !0);
    }, M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.COPY_COMMAND, (e) => (Nf.copyToClipboard__EXPERIMENTAL(t, e instanceof ClipboardEvent ? e : null), !0), M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.CUT_COMMAND, (e) => (ZA(e, t), !0), M.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(M.PASTE_COMMAND, (e) => {
      const [, n, r] = Na(e);
      if (0 < n.length && !r)
        return t.dispatchCommand(N1, n), !0;
      const i = M.$getSelection();
      return M.$isRangeSelection(i) || M.DEPRECATED_$isGridSelection(i) ? (JA(e, t), !0) : !1;
    }, M.COMMAND_PRIORITY_EDITOR)
  );
};
const eO = Zn;
var tO = eO, gr = {}, nO = Jn, Bn = Z;
let Pc = class n6 extends Bn.ElementNode {
  static getType() {
    return "link";
  }
  static clone(e) {
    return new n6(e.__url, { rel: e.__rel, target: e.__target }, e.__key);
  }
  constructor(e, n = {}, r) {
    super(r);
    let { target: i = null, rel: o = null } = n;
    this.__url = e, this.__target = i, this.__rel = o;
  }
  createDOM(e) {
    let n = document.createElement("a");
    return n.href = this.__url, this.__target !== null && (n.target = this.__target), this.__rel !== null && (n.rel = this.__rel), nO.addClassNamesToElement(n, e.theme.link), n;
  }
  updateDOM(e, n) {
    let r = this.__url, i = this.__target, o = this.__rel;
    return r !== e.__url && (n.href = r), i !== e.__target && (i ? n.target = i : n.removeAttribute("target")), o !== e.__rel && (o ? n.rel = o : n.removeAttribute("rel")), !1;
  }
  static importDOM() {
    return { a: () => ({ conversion: rO, priority: 1 }) };
  }
  static importJSON(e) {
    let n = Es(e.url, { rel: e.rel, target: e.target });
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), rel: this.getRel(), target: this.getTarget(), type: "link", url: this.getURL(), version: 1 };
  }
  getURL() {
    return this.getLatest().__url;
  }
  setURL(e) {
    this.getWritable().__url = e;
  }
  getTarget() {
    return this.getLatest().__target;
  }
  setTarget(e) {
    this.getWritable().__target = e;
  }
  getRel() {
    return this.getLatest().__rel;
  }
  setRel(e) {
    this.getWritable().__rel = e;
  }
  insertNewAfter(e, n = !0) {
    return e = this.getParentOrThrow().insertNewAfter(e, n), Bn.$isElementNode(e) ? (n = Es(this.__url, { rel: this.__rel, target: this.__target }), e.append(n), n) : null;
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
  canBeEmpty() {
    return !1;
  }
  isInline() {
    return !0;
  }
  extractWithChild(e, n) {
    if (!Bn.$isRangeSelection(n))
      return !1;
    e = n.anchor.getNode();
    let r = n.focus.getNode();
    return this.isParentOf(e) && this.isParentOf(r) && 0 < n.getTextContent().length;
  }
};
function rO(t) {
  let e = null;
  if (t instanceof HTMLAnchorElement) {
    let n = t.textContent;
    n !== null && n !== "" && (e = Es(t.getAttribute("href") || "", { rel: t.getAttribute("rel"), target: t.getAttribute("target") }));
  }
  return { node: e };
}
function Es(t, e) {
  return Bn.$applyNodeReplacement(new Pc(t, e));
}
function Zr(t) {
  return t instanceof Pc;
}
let R0 = class r6 extends Pc {
  static getType() {
    return "autolink";
  }
  static clone(e) {
    return new r6(e.__url, { rel: e.__rel, target: e.__target }, e.__key);
  }
  static importJSON(e) {
    let n = M1(e.url, { rel: e.rel, target: e.target });
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  static importDOM() {
    return null;
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "autolink", version: 1 };
  }
  insertNewAfter(e, n = !0) {
    return e = this.getParentOrThrow().insertNewAfter(e, n), Bn.$isElementNode(e) ? (n = M1(this.__url, {
      rel: this._rel,
      target: this.__target
    }), e.append(n), n) : null;
  }
};
function M1(t, e) {
  return Bn.$applyNodeReplacement(new R0(t, e));
}
let iO = Bn.createCommand("TOGGLE_LINK_COMMAND");
function oO(t) {
  return aO(t, (e) => Zr(e));
}
function aO(t, e) {
  for (; t !== null && (t = t.getParent()) !== null && !e(t); )
    ;
  return t;
}
gr.$createAutoLinkNode = M1;
gr.$createLinkNode = Es;
gr.$isAutoLinkNode = function(t) {
  return t instanceof R0;
};
gr.$isLinkNode = Zr;
gr.AutoLinkNode = R0;
gr.LinkNode = Pc;
gr.TOGGLE_LINK_COMMAND = iO;
gr.toggleLink = function(t, e = {}) {
  let { target: n } = e, r = e.rel === void 0 ? "noopener" : e.rel;
  if (e = Bn.$getSelection(), Bn.$isRangeSelection(e))
    if (e = e.extract(), t === null)
      e.forEach((o) => {
        if (o = o.getParent(), Zr(o)) {
          let a = o.getChildren();
          for (let s = 0; s < a.length; s++)
            o.insertBefore(a[s]);
          o.remove();
        }
      });
    else {
      if (e.length === 1) {
        var i = e[0];
        if (i = Zr(i) ? i : oO(i), i !== null) {
          i.setURL(t), n !== void 0 && i.setTarget(n), r !== null && i.setRel(r);
          return;
        }
      }
      let o = null, a = null;
      e.forEach((s) => {
        var l = s.getParent();
        if (l !== a && l !== null && (!Bn.$isElementNode(s) || s.isInline()))
          if (Zr(l))
            a = l, l.setURL(t), n !== void 0 && l.setTarget(n), r !== null && a.setRel(r);
          else if (l.is(o) || (o = l, a = Es(t, { rel: r, target: n }), Zr(l) ? s.getPreviousSibling() === null ? l.insertBefore(a) : l.insertAfter(a) : s.insertBefore(a)), Zr(s)) {
            if (!s.is(a)) {
              if (a !== null) {
                l = s.getChildren();
                for (let f = 0; f < l.length; f++)
                  a.append(l[f]);
              }
              s.remove();
            }
          } else
            a !== null && a.append(s);
      });
    }
};
const sO = gr;
var lO = sO, we = Z, Ga = NA, xt = Bw, xr = tO, fO = Jn, Qu = lO;
function A1(t, e) {
  let n = {};
  for (let r of t)
    t = e(r), n[t] ? n[t].push(r) : n[t] = [r];
  return n;
}
function L0(t) {
  return t = A1(t, (e) => e.type), { element: t.element || [], textFormat: t["text-format"] || [], textMatch: t["text-match"] || [] };
}
let Mf = /[!-/:-@[-`{-~\s]/;
function cO(t) {
  let e = L0(t), n = e.textFormat.filter((r) => r.format.length === 1);
  return () => {
    let r = [];
    var i = we.$getRoot().getChildren();
    for (let o of i)
      i = uO(o, e.element, n, e.textMatch), i != null && r.push(i);
    return r.join(`

`);
  };
}
function uO(t, e, n, r) {
  for (let i of e)
    if (e = i.export(t, (o) => Af(o, n, r)), e != null)
      return e;
  return we.$isElementNode(t) ? Af(t, n, r) : we.$isDecoratorNode(t) ? t.getTextContent() : null;
}
function Af(t, e, n) {
  let r = [];
  t = t.getChildren();
  e:
    for (let i of t) {
      for (let o of n)
        if (t = o.export(i, (a) => Af(a, e, n), (a, s) => Vm(a, s, e)), t != null) {
          r.push(t);
          continue e;
        }
      we.$isLineBreakNode(i) ? r.push(`
`) : we.$isTextNode(i) ? r.push(Vm(i, i.getTextContent(), e)) : we.$isElementNode(i) ? r.push(Af(i, e, n)) : we.$isDecoratorNode(i) && r.push(i.getTextContent());
    }
  return r.join("");
}
function Vm(t, e, n) {
  let r = e.trim(), i = r, o = /* @__PURE__ */ new Set();
  for (let s of n) {
    n = s.format[0];
    let l = s.tag;
    if (Xu(t, n) && !o.has(n)) {
      o.add(n);
      var a = Km(t, !0);
      Xu(a, n) || (i = l + i), a = Km(t, !1), Xu(a, n) || (i += l);
    }
  }
  return e.replace(r, i);
}
function Km(t, e) {
  let n = e ? t.getPreviousSibling() : t.getNextSibling();
  for (n || (t = t.getParentOrThrow(), t.isInline() && (n = e ? t.getPreviousSibling() : t.getNextSibling())); n; ) {
    if (we.$isElementNode(n)) {
      if (!n.isInline())
        break;
      if (t = e ? n.getLastDescendant() : n.getFirstDescendant(), we.$isTextNode(t))
        return t;
      n = e ? n.getPreviousSibling() : n.getNextSibling();
    }
    if (we.$isTextNode(n))
      return n;
    if (!we.$isElementNode(n))
      break;
  }
  return null;
}
function Xu(t, e) {
  return we.$isTextNode(t) && t.hasFormat(e);
}
let Rc = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", dO = Rc && "documentMode" in document ? document.documentMode : null;
Rc && "InputEvent" in window && !dO && "getTargetRanges" in new window.InputEvent("input");
let Ym = Rc && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), qm = Rc && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, hO = /^\s{0,3}$/, Gm = /^```(\w{1,10})?\s?$/;
function gO(t) {
  let e = L0(t), n = mO(e.textFormat);
  return (r) => {
    var i = r.split(`
`), o = i.length;
    r = we.$getRoot(), r.clear();
    for (let p = 0; p < o; p++) {
      var a = i[p];
      e: {
        var s = i, l = p, f = r, c = s[l].match(Gm);
        if (c) {
          for (var u = l, d = s.length; ++u < d; )
            if (s[u].match(Gm)) {
              c = Ga.$createCodeNode(c[1]), s = we.$createTextNode(s.slice(l + 1, u).join(`
`)), c.append(s), f.append(c), f = [c, u];
              break e;
            }
        }
        f = [null, l];
      }
      let [m, v] = f;
      if (m != null)
        p = v;
      else {
        f = a, d = r;
        var h = e.element;
        u = n, s = e.textMatch, l = f.trim(), c = we.$createTextNode(l), a = we.$createParagraphNode(), a.append(c), d.append(a);
        for (let { regExp: b, replace: k } of h)
          if (d = f.match(b)) {
            c.setTextContent(f.slice(d[0].length)), k(a, [c], d, !0);
            break;
          }
        Al(c, u, s), a.isAttached() && 0 < l.length && (f = a.getPreviousSibling(), we.$isParagraphNode(f) || xr.$isQuoteNode(f) || xt.$isListNode(f)) && (u = f, xt.$isListNode(f) && (f = f.getLastDescendant(), u = f == null ? null : fO.$findMatchingParent(f, xt.$isListItemNode)), u != null && 0 < u.getTextContentSize() && (u.splice(u.getChildrenSize(), 0, [we.$createLineBreakNode(), ...a.getChildren()]), a.remove()));
      }
    }
    i = r.getChildren();
    for (let p of i)
      i = p, we.$isParagraphNode(i) ? (o = i.getFirstChild(), i = o == null || i.getChildrenSize() === 1 && we.$isTextNode(o) && hO.test(o.getTextContent())) : i = !1, i && p.remove();
    r.selectEnd();
  };
}
function Al(t, e, n) {
  var r = t.getTextContent();
  let i = pO(r, e);
  if (i) {
    var o, a;
    if (i[0] === r)
      var s = t;
    else {
      r = i.index || 0;
      let l = r + i[0].length;
      r === 0 ? [s, o] = t.splitText(l) : [a, s, o] = t.splitText(r, l);
    }
    if (s.setTextContent(i[2]), t = e.transformersByTag[i[1]])
      for (let l of t.format)
        s.hasFormat(l) || s.toggleFormat(l);
    s.hasFormat("code") || Al(s, e, n), a && Al(a, e, n), o && Al(o, e, n);
  } else
    i6(t, n);
}
function i6(t, e) {
  e:
    for (; t; ) {
      for (let n of e) {
        let r = t.getTextContent().match(n.importRegExp);
        if (!r)
          continue;
        let i = r.index || 0, o = i + r[0].length, a, s, l;
        i === 0 ? [a, t] = t.splitText(o) : [s, a, l] = t.splitText(i, o), s && i6(s, e), l && (t = l), n.replace(a, r);
        continue e;
      }
      break;
    }
}
function pO(t, e) {
  var n = t.match(e.openTagsRegExp);
  if (n == null)
    return null;
  for (let o of n) {
    var r = o.replace(/^\s/, "");
    if (n = e.fullMatchRegExpByTag[r], n != null && (n = t.match(n), r = e.transformersByTag[r], n != null && r != null)) {
      if (r.intraword !== !1)
        return n;
      var { index: i = 0 } = n;
      if (r = t[i - 1], i = t[i + n[0].length], !(r && !Mf.test(r) || i && !Mf.test(i)))
        return n;
    }
  }
  return null;
}
function mO(t) {
  let e = {}, n = {}, r = [];
  for (let i of t) {
    ({ tag: t } = i), e[t] = i;
    let o = t.replace(/(\*|\^|\+)/g, "\\$1");
    r.push(o), n[t] = Ym || qm ? new RegExp(`(${o})(?![${o}\\s])(.*?[^${o}\\s])${o}(?!${o})`) : new RegExp(`(?<![\\\\${o}])(${o})((\\\\${o})?.*?[^${o}\\s](\\\\${o})?)((?<!\\\\)|(?<=\\\\\\\\))(${o})(?![\\\\${o}])`);
  }
  return { fullMatchRegExpByTag: n, openTagsRegExp: new RegExp((Ym || qm ? "" : "(?<![\\\\])") + "(" + r.join("|") + ")", "g"), transformersByTag: e };
}
function Qm(t, e, n) {
  let r = n.length;
  for (; e >= r; e--) {
    let i = e - r;
    if (o6(t, i, n, 0, r) && t[i + r] !== " ")
      return i;
  }
  return -1;
}
function o6(t, e, n, r, i) {
  for (let o = 0; o < i; o++)
    if (t[e + o] !== n[r + o])
      return !1;
  return !0;
}
let a6 = (t) => (e, n, r) => {
  r = t(r), r.append(...n), e.replace(r), r.select(0, 0);
}, $0 = (t) => (e, n, r) => {
  var i = e.getPreviousSibling();
  const o = xt.$createListItemNode(t === "check" ? r[3] === "x" : void 0);
  xt.$isListNode(i) && i.getListType() === t ? (i.append(o), e.remove()) : (i = xt.$createListNode(t, t === "number" ? Number(r[2]) : void 0), i.append(o), e.replace(i)), o.append(...n), o.select(0, 0), (e = Math.floor(r[1].length / 4)) && o.setIndent(e);
}, Lc = (t, e, n) => {
  const r = [];
  var i = t.getChildren();
  let o = 0;
  for (const s of i)
    if (xt.$isListItemNode(s)) {
      if (s.getChildrenSize() === 1 && (i = s.getFirstChild(), xt.$isListNode(i))) {
        r.push(Lc(i, e, n + 1));
        continue;
      }
      i = " ".repeat(4 * n);
      var a = t.getListType();
      a = a === "number" ? `${t.getStart() + o}. ` : a === "check" ? `- [${s.getChecked() ? "x" : " "}] ` : "- ", r.push(i + a + e(s)), o++;
    }
  return r.join(`
`);
}, s6 = { dependencies: [xr.HeadingNode], export: (t, e) => {
  if (!xr.$isHeadingNode(t))
    return null;
  const n = Number(t.getTag().slice(1));
  return "#".repeat(n) + " " + e(t);
}, regExp: /^(#{1,6})\s/, replace: a6((t) => xr.$createHeadingNode("h" + t[1].length)), type: "element" }, l6 = {
  dependencies: [xr.QuoteNode],
  export: (t, e) => {
    if (!xr.$isQuoteNode(t))
      return null;
    t = e(t).split(`
`), e = [];
    for (const n of t)
      e.push("> " + n);
    return e.join(`
`);
  },
  regExp: /^>\s/,
  replace: (t, e, n, r) => {
    if (r && (n = t.getPreviousSibling(), xr.$isQuoteNode(n))) {
      n.splice(n.getChildrenSize(), 0, [we.$createLineBreakNode(), ...e]), n.select(0, 0), t.remove();
      return;
    }
    n = xr.$createQuoteNode(), n.append(...e), t.replace(n), n.select(0, 0);
  },
  type: "element"
}, f6 = { dependencies: [Ga.CodeNode], export: (t) => {
  if (!Ga.$isCodeNode(t))
    return null;
  const e = t.getTextContent();
  return "```" + (t.getLanguage() || "") + (e ? `
` + e : "") + "\n```";
}, regExp: /^```(\w{1,10})?\s/, replace: a6((t) => Ga.$createCodeNode(t ? t[1] : void 0)), type: "element" }, c6 = { dependencies: [xt.ListNode, xt.ListItemNode], export: (t, e) => xt.$isListNode(t) ? Lc(t, e, 0) : null, regExp: /^(\s*)[-*+]\s/, replace: $0("bullet"), type: "element" }, vO = { dependencies: [xt.ListNode, xt.ListItemNode], export: (t, e) => xt.$isListNode(t) ? Lc(t, e, 0) : null, regExp: /^(\s*)(?:-\s)?\s?(\[(\s|x)?\])\s/i, replace: $0("check"), type: "element" }, u6 = { dependencies: [xt.ListNode, xt.ListItemNode], export: (t, e) => xt.$isListNode(t) ? Lc(t, e, 0) : null, regExp: /^(\s*)(\d{1,})\.\s/, replace: $0("number"), type: "element" }, d6 = { format: ["code"], tag: "`", type: "text-format" }, h6 = { format: ["bold", "italic"], tag: "***", type: "text-format" }, g6 = { format: ["bold", "italic"], intraword: !1, tag: "___", type: "text-format" }, p6 = { format: ["bold"], tag: "**", type: "text-format" }, m6 = { format: ["bold"], intraword: !1, tag: "__", type: "text-format" }, v6 = { format: ["strikethrough"], tag: "~~", type: "text-format" }, b6 = { format: ["italic"], tag: "*", type: "text-format" }, y6 = {
  format: ["italic"],
  intraword: !1,
  tag: "_",
  type: "text-format"
}, _6 = { dependencies: [Qu.LinkNode], export: (t, e, n) => {
  if (!Qu.$isLinkNode(t))
    return null;
  e = `[${t.getTextContent()}](${t.getURL()})`;
  const r = t.getFirstChild();
  return t.getChildrenSize() === 1 && we.$isTextNode(r) ? n(r, e) : e;
}, importRegExp: /(?:\[([^[]+)\])(?:\(([^()]+)\))/, regExp: /(?:\[([^[]+)\])(?:\(([^()]+)\))$/, replace: (t, e) => {
  const [, n, r] = e;
  e = Qu.$createLinkNode(r);
  const i = we.$createTextNode(n);
  i.setFormat(t.getFormat()), e.append(i), t.replace(e);
}, trigger: ")", type: "text-match" }, w6 = [s6, l6, f6, c6, u6], k6 = [d6, h6, g6, p6, m6, b6, y6, v6], C6 = [_6], $c = [...w6, ...k6, ...C6];
Qe.$convertFromMarkdownString = function(t, e = $c) {
  return gO(e)(t);
};
Qe.$convertToMarkdownString = function(t = $c) {
  return cO(t)();
};
Qe.BOLD_ITALIC_STAR = h6;
Qe.BOLD_ITALIC_UNDERSCORE = g6;
Qe.BOLD_STAR = p6;
Qe.BOLD_UNDERSCORE = m6;
Qe.CHECK_LIST = vO;
Qe.CODE = f6;
Qe.ELEMENT_TRANSFORMERS = w6;
Qe.HEADING = s6;
Qe.INLINE_CODE = d6;
Qe.ITALIC_STAR = b6;
Qe.ITALIC_UNDERSCORE = y6;
Qe.LINK = _6;
Qe.ORDERED_LIST = u6;
Qe.QUOTE = l6;
Qe.STRIKETHROUGH = v6;
Qe.TEXT_FORMAT_TRANSFORMERS = k6;
Qe.TEXT_MATCH_TRANSFORMERS = C6;
Qe.TRANSFORMERS = $c;
Qe.UNORDERED_LIST = c6;
Qe.registerMarkdownShortcuts = function(t, e = $c) {
  let n = L0(e), r = A1(n.textFormat, ({ tag: o }) => o[o.length - 1]), i = A1(n.textMatch, ({ trigger: o }) => o);
  for (let o of e)
    if (e = o.type, (e === "element" || e === "text-match") && !t.hasNodes(o.dependencies))
      throw Error("Minified Lexical error #79; visit https://lexical.dev/docs/error?code=79 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
  return t.registerUpdateListener(({ tags: o, dirtyLeaves: a, editorState: s, prevEditorState: l }) => {
    if (!o.has("historic")) {
      var f = s.read(we.$getSelection);
      if (o = l.read(we.$getSelection), we.$isRangeSelection(o) && we.$isRangeSelection(f) && f.isCollapsed()) {
        l = f.anchor.key;
        var c = f.anchor.offset, u = s._nodeMap.get(l);
        we.$isTextNode(u) && a.has(l) && (c === 1 || c === o.anchor.offset + 1) && t.update(() => {
          if (!u.hasFormat("code")) {
            var d = u.getParent();
            if (d !== null && !Ga.$isCodeNode(d)) {
              var h = f.anchor.offset;
              e: {
                var p = n.element, m = d.getParent();
                if (we.$isRootOrShadowRoot(m) && d.getFirstChild() === u && (m = u.getTextContent(), m[h - 1] === " ")) {
                  for (let {
                    regExp: S,
                    replace: C
                  } of p)
                    if ((p = m.match(S)) && p[0].length === h) {
                      m = u.getNextSiblings();
                      let [N, $] = u.splitText(h);
                      N.remove(), m = $ ? [$, ...m] : m, C(d, m, p, !1), d = !0;
                      break e;
                    }
                }
                d = !1;
              }
              if (!d) {
                e: {
                  if (p = u.getTextContent(), d = i[p[h - 1]], d != null) {
                    h < p.length && (p = p.slice(0, h));
                    for (b of d)
                      if (d = p.match(b.regExp), d !== null) {
                        p = d.index || 0, m = p + d[0].length;
                        var v = void 0;
                        p === 0 ? [v] = u.splitText(m) : [, v] = u.splitText(p, m), v.selectNext(0, 0), b.replace(v, d);
                        var b = !0;
                        break e;
                      }
                  }
                  b = !1;
                }
                if (!b)
                  e: {
                    m = u.getTextContent(), --h;
                    var k = m[h];
                    if (b = r[k])
                      for (let S of b) {
                        var { tag: _ } = S;
                        b = _.length;
                        let C = h - b + 1;
                        if (!(1 < b && !o6(m, C, _, 0, b) || m[C - 1] === " ") && (v = m[h + 1], S.intraword !== !1 || !v || Mf.test(v))) {
                          d = v = u, p = Qm(m, C, _);
                          for (var E = d; 0 > p && (E = E.getPreviousSibling()) && !we.$isLineBreakNode(E); )
                            we.$isTextNode(E) && (p = E.getTextContent(), d = E, p = Qm(p, p.length, _));
                          if (!(0 > p || d === v && p + b === C || (_ = d.getTextContent(), 0 < p && _[p - 1] === k || (E = _[p - 1], S.intraword === !1 && E && !Mf.test(E))))) {
                            m = v.getTextContent(), m = m.slice(0, C) + m.slice(h + 1), v.setTextContent(m), m = d === v ? m : _, d.setTextContent(m.slice(0, p) + m.slice(p + b)), m = we.$getSelection(), k = we.$createRangeSelection(), we.$setSelection(k), h = h - b * (d === v ? 2 : 1) + 1, k.anchor.set(d.__key, p, "text"), k.focus.set(v.__key, h, "text");
                            for (let N of S.format)
                              k.hasFormat(N) || k.formatText(N);
                            k.anchor.set(k.focus.key, k.focus.offset, k.focus.type);
                            for (let N of S.format)
                              k.hasFormat(N) && k.toggleFormat(N);
                            we.$isRangeSelection(m) && (k.format = m.format);
                            break e;
                          }
                        }
                      }
                  }
              }
            }
          }
        });
      }
    }
  });
};
const bO = Qe;
var Of = bO;
function yO(t) {
  if (t.nodeType !== Node.ELEMENT_NODE)
    throw new Error("Expected an element node");
  const e = t.getAttribute("data-lexical-mention");
  if (e == null)
    throw new Error("failed to convert mention element");
  return {
    node: Fc(e, t.textContent ?? "")
  };
}
class Pi extends Z.TextNode {
  constructor(n, r, i) {
    super(r ?? "", i);
    pa(this, "__id");
    this.__id = n;
  }
  static getType() {
    return "mention";
  }
  static clone(n) {
    return new Pi(n.__id, n.__text, n.__key);
  }
  static importJSON(n) {
    const r = Fc(n.id, n.text);
    return r.setFormat(n.format), r.setDetail(n.detail), r.setMode(n.mode), r.setStyle(n.style), r;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      id: this.__id,
      type: "mention",
      version: 1
    };
  }
  createDOM(n) {
    const r = super.createDOM(n);
    return r.className = "collabkit-mention-node", r;
  }
  exportDOM() {
    const n = document.createElement("span");
    return n.setAttribute("data-lexical-mention", JSON.stringify(this.__id)), n.textContent = this.__text, {
      element: n
    };
  }
  static importDOM() {
    return {
      span: (n) => n.hasAttribute("data-lexical-mention") ? {
        conversion: yO,
        priority: 1
      } : null
    };
  }
  isTextEntity() {
    return !0;
  }
}
function Fc(t, e) {
  const n = new Pi(t, e);
  return n.setMode("segmented").toggleDirectionless(), Z.$applyNodeReplacement(n);
}
function _O(t) {
  return t instanceof Pi;
}
var Ts = {}, wO = {
  get exports() {
    return Ts;
  },
  set exports(t) {
    Ts = t;
  }
}, jc = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kO = he, CO = Symbol.for("react.element"), xO = Symbol.for("react.fragment"), EO = Object.prototype.hasOwnProperty, TO = kO.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, SO = { key: !0, ref: !0, __self: !0, __source: !0 };
function x6(t, e, n) {
  var r, i = {}, o = null, a = null;
  n !== void 0 && (o = "" + n), e.key !== void 0 && (o = "" + e.key), e.ref !== void 0 && (a = e.ref);
  for (r in e)
    EO.call(e, r) && !SO.hasOwnProperty(r) && (i[r] = e[r]);
  if (t && t.defaultProps)
    for (r in e = t.defaultProps, e)
      i[r] === void 0 && (i[r] = e[r]);
  return { $$typeof: CO, type: t, key: o, ref: a, props: i, _owner: TO.current };
}
jc.Fragment = xO;
jc.jsx = x6;
jc.jsxs = x6;
(function(t) {
  t.exports = jc;
})(wO);
const K = Ts.Fragment, g = Ts.jsx, D = Ts.jsxs;
class Zo extends Z.DecoratorNode {
  constructor(n, r) {
    super(r);
    pa(this, "__id");
    this.__id = n;
  }
  static getType() {
    return "pin";
  }
  static clone(n) {
    return new Zo(n.__id, n.__key);
  }
  getTextContent() {
    return " ";
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      pinId: this.__id,
      type: "pin",
      version: 1
    };
  }
  static importJSON(n) {
    return F0(n.pinId);
  }
  isInline() {
    return !0;
  }
  createDOM() {
    return document.createElement("span");
  }
  updateDOM() {
    return !1;
  }
  decorate() {
    return /* @__PURE__ */ g(E6, {
      id: this.__id
    });
  }
}
function F0(t) {
  return new Zo(t);
}
function IO(t) {
  return t instanceof Zo;
}
function E6(t) {
  return (
    // @ts-ignore
    /* @__PURE__ */ D("svg", {
      "data-pin-id": t.id,
      className: "collabkit-composer-pin",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/* @__PURE__ */ g("path", {
        d: "M8.64639 14.563L11.8552 11.3541C12.8774 10.3319 13.4517 8.94557 13.4517 7.5C13.4517 6.05443 12.8774 4.66806 11.8552 3.64589L11.8552 3.64588C11.3491 3.13976 10.7482 2.73827 10.087 2.46436C9.42566 2.19044 8.7169 2.04946 8.00112 2.04946C7.28535 2.04946 6.57658 2.19044 5.91529 2.46436C5.254 2.73827 4.65314 3.13976 4.14701 3.64589L4.147 3.64589C3.64087 4.15202 3.23939 4.75288 2.96547 5.41417C2.69156 6.07546 2.55058 6.78423 2.55058 7.5C2.55058 8.21577 2.69156 8.92454 2.96547 9.58583C3.23939 10.2471 3.64087 10.848 4.147 11.3541L7.35586 14.563C7.52699 14.7341 7.7591 14.8302 8.00112 14.8302C8.24315 14.8302 8.47525 14.7341 8.64639 14.563Z",
        fill: "#222222",
        stroke: "#222222",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /* @__PURE__ */ g("circle", {
        cx: "8",
        cy: "7",
        r: "2",
        fill: "white"
      })]
    }, "collabkit-composer-pin")
  );
}
function NO(t) {
  return {
    node: zc(t.textContent ?? "")
  };
}
const MO = "font-weight: 700";
class Ri extends Z.TextNode {
  constructor(n, r, i) {
    super(r ?? n, i);
    pa(this, "__timestamp");
    this.__timestamp = n;
  }
  static getType() {
    return "timestamp";
  }
  static clone(n) {
    return new Ri(n.__timestamp, n.__text, n.__key);
  }
  static importJSON(n) {
    const r = zc(n.timestamp);
    return r.setTextContent(n.text), r.setFormat(n.format), r.setDetail(n.detail), r.setMode(n.mode), r.setStyle(n.style), r;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      timestamp: this.__timestamp,
      type: "timestamp",
      version: 1
    };
  }
  createDOM(n) {
    const r = super.createDOM(n);
    return r.style.cssText = MO, r.className = "timestamp", r;
  }
  exportDOM() {
    const n = document.createElement("span");
    return n.setAttribute("data-lexical-timestamp", "true"), n.textContent = this.__text, {
      element: n
    };
  }
  static importDOM() {
    return {
      // @ts-ignore
      span: (n) => n.hasAttribute("data-lexical-timestamp") ? {
        conversion: NO,
        priority: 1
      } : null
    };
  }
  isTextEntity() {
    return !0;
  }
}
function zc(t) {
  const e = new Ri(t);
  return e.setMode("token").toggleDirectionless(), e;
}
function AO(t) {
  return t instanceof Ri;
}
const OO = {
  dependencies: [Pi],
  export: (t) => t.getType() !== "mention" ? null : `[${t.getTextContent()}](#@${encodeURIComponent(
    t.__id
  )})`,
  importRegExp: /(?:\[([^[]+)\])(?:\(#@([^(]+)\))/,
  regExp: /(?:\[([^[]+)\])(?:\(#@([^(]+)\))$/,
  replace: (t, e) => {
    const [, n, r] = e, i = Fc(r, n);
    t.replace(i);
  },
  trigger: ")",
  type: "text-match"
}, DO = {
  dependencies: [Ri],
  export: (t) => AO(t) ? `[${t.getTextContent()}](#T${t.__timestamp})` : null,
  importRegExp: /(?:\[([^[]+)\])(?:\(#T([^(]+)\))/,
  regExp: /(?:\[([^[]+)\])(?:\(#T([^(]+)\))$/,
  replace: (t, e) => {
    const [, n] = e, r = zc(n);
    t.replace(r);
  },
  trigger: ")",
  type: "text-match"
}, PO = {
  dependencies: [Zo],
  export: (t) => IO(t) ? `[PIN](#PIN${t.__pinId})` : null,
  importRegExp: /(?:\[([^[]+)\])(?:\(#PIN([^(]+)\))/,
  regExp: /(?:\[([^[]+)\])(?:\(#PIN([^(]+)\))$/,
  replace: (t, e) => {
    const [, , n] = e, r = F0(n);
    t.replace(r);
  },
  trigger: ")",
  type: "text-match"
}, RO = [OO, DO, PO], T6 = [
  ...Of.ELEMENT_TRANSFORMERS,
  ...Of.TEXT_FORMAT_TRANSFORMERS,
  ...RO
], S6 = Z.createCommand(), I6 = Z.createCommand();
function Df(t) {
  return new Bc(t);
}
function LO(t) {
  if (t.nodeType !== Node.TEXT_NODE)
    throw new Error("Expected an element node");
  return {
    node: Df(t.textContent ?? "")
  };
}
class Bc extends Z.TextNode {
  isInline() {
    return !0;
  }
  static getType() {
    return "inline-text";
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "inline-text",
      version: 1
    };
  }
  static clone(e) {
    return new Bc(e.__text, e.__key);
  }
  static importJSON(e) {
    const n = Df(e.text);
    return n.setFormat(e.format), n.setDetail(e.detail), n.setMode(e.mode), n.setStyle(e.style), n;
  }
  static importDOM() {
    return {
      span: (e) => e.hasAttribute("data-lexical-mention") ? {
        conversion: LO,
        priority: 1
      } : null
    };
  }
}
function N6() {
  const t = Z.$getSelection();
  if (Z.$isRangeSelection(t)) {
    const e = Z.$createRangeSelection();
    return e.anchor.offset = t.anchor.offset - 1 < 0 ? 0 : t.anchor.offset - 1, e.focus.offset = t.anchor.offset, e.getTextContent();
  } else
    return null;
}
function M6(t) {
  let e = [], n = "";
  return t.getEditorState().read(() => {
    e = Z.$getRoot().getAllTextNodes().filter((r) => _O(r)).map((r) => r.__id).filter((r) => typeof r == "string"), n = Of.$convertToMarkdownString(T6);
  }), { body: n, mentions: e };
}
function $O(t, e) {
  const { composerId: n } = t;
  if (!n)
    throw new Error("CollabKit: no composerId set");
  const { pinId: r } = e, { workspaceId: i, threadId: o, eventId: a } = n, s = t.workspaces[i], { editor: l } = s.composers[o][a];
  l == null || l.update(() => {
    const f = Z.$getSelection();
    if (Z.$isRangeSelection(f)) {
      const c = N6(), u = Z.$createParagraphNode();
      !(c != null && c.match(/[\s]/)) && c !== "" && u.append(Df(" ")), u.append(F0(r), Df(" ")), Z.$getRoot().isEmpty() ? (Z.$getRoot().append(u), u.select()) : f.insertNodes([u]);
    }
  });
}
var FO = "Expected a function", Xm = 0 / 0, jO = "[object Symbol]", zO = /^\s+|\s+$/g, BO = /^[-+]0x[0-9a-f]+$/i, WO = /^0b[01]+$/i, UO = /^0o[0-7]+$/i, HO = parseInt, VO = typeof Bt == "object" && Bt && Bt.Object === Object && Bt, KO = typeof self == "object" && self && self.Object === Object && self, YO = VO || KO || Function("return this")(), qO = Object.prototype, GO = qO.toString, QO = Math.max, XO = Math.min, Ju = function() {
  return YO.Date.now();
};
function JO(t, e, n) {
  var r, i, o, a, s, l, f = 0, c = !1, u = !1, d = !0;
  if (typeof t != "function")
    throw new TypeError(FO);
  e = Jm(e) || 0, O1(n) && (c = !!n.leading, u = "maxWait" in n, o = u ? QO(Jm(n.maxWait) || 0, e) : o, d = "trailing" in n ? !!n.trailing : d);
  function h(C) {
    var N = r, $ = i;
    return r = i = void 0, f = C, a = t.apply($, N), a;
  }
  function p(C) {
    return f = C, s = setTimeout(b, e), c ? h(C) : a;
  }
  function m(C) {
    var N = C - l, $ = C - f, I = e - N;
    return u ? XO(I, o - $) : I;
  }
  function v(C) {
    var N = C - l, $ = C - f;
    return l === void 0 || N >= e || N < 0 || u && $ >= o;
  }
  function b() {
    var C = Ju();
    if (v(C))
      return k(C);
    s = setTimeout(b, m(C));
  }
  function k(C) {
    return s = void 0, d && r ? h(C) : (r = i = void 0, a);
  }
  function _() {
    s !== void 0 && clearTimeout(s), f = 0, r = l = i = s = void 0;
  }
  function E() {
    return s === void 0 ? a : k(Ju());
  }
  function S() {
    var C = Ju(), N = v(C);
    if (r = arguments, i = this, l = C, N) {
      if (s === void 0)
        return p(l);
      if (u)
        return s = setTimeout(b, e), h(l);
    }
    return s === void 0 && (s = setTimeout(b, e)), a;
  }
  return S.cancel = _, S.flush = E, S;
}
function O1(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function ZO(t) {
  return !!t && typeof t == "object";
}
function eD(t) {
  return typeof t == "symbol" || ZO(t) && GO.call(t) == jO;
}
function Jm(t) {
  if (typeof t == "number")
    return t;
  if (eD(t))
    return Xm;
  if (O1(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = O1(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(zO, "");
  var n = WO.test(t);
  return n || UO.test(t) ? HO(t.slice(2), n ? 2 : 8) : BO.test(t) ? Xm : +t;
}
var tD = JO;
const nD = tD;
async function rD(t, e) {
  const { config: n } = t, { workspaceId: r, threadId: i, eventId: o } = e.target;
  if (!t.userId) {
    console.warn("CollabKit: cannot start typing, no userId");
    return;
  }
  const a = t.workspaces[r].composers[i][o].isTypingTimeoutID;
  a && clearTimeout(a);
  const s = {
    appId: n.appId,
    workspaceId: r,
    threadId: i,
    userId: t.userId
  };
  await t.sync.startTyping(s), t.workspaces[r].composers[i][o].isTypingTimeoutID = setTimeout(
    () => t.sync.stopTyping(s),
    1e3
  );
}
const D1 = nD(rD, 1e3, {
  leading: !0,
  maxWait: 1e3
});
function A6(t, e) {
  if (t.subs.connectionState)
    return;
  const n = ae`.info/connected`;
  t.subs.connectionState = gc(n, (r) => {
    !t.isConnected && r.val() && e.onConnectionStateChange(r.val());
  });
}
function Zm(t, e) {
  var l, f;
  const { id: n, eventId: r, objectId: i, threadId: o, workspaceId: a } = e, s = { id: n, eventId: r, objectId: i, threadId: o, workspaceId: a, type: "pin" };
  (f = (l = t.callbacks) == null ? void 0 : l.onPinClick) == null || f.call(l, {
    userId: t.userId,
    workspaceId: e.workspaceId,
    meta: e.meta,
    objectId: e.objectId,
    threadId: e.threadId
  }), t.isFigmaStyle && setTimeout(() => {
    t.viewingId = s, t.previewingId = s, t.selectedId = s;
  }, 32);
}
function En(t, e) {
  const { userId: n } = t, { target: r } = e;
  if (!n)
    throw new Error("[CollabKit] select: userId is required");
  switch (r.type) {
    case "thread":
      t.selectedId = r;
      break;
    case "pinNextThreadIconButton":
    case "pinPrevThreadIconButton":
      const i = t.pins.open.find((a) => a.id === r.id);
      i && Zm(t, i);
      break;
    case "pin":
    case "commentPin":
      const o = t.pins.open.find((a) => a.id === r.id);
      o && Zm(t, o);
      break;
  }
}
function O6(t, e) {
  var f, c;
  const { threadId: n, workspaceId: r } = e, { workspaces: i, userId: o } = t;
  if (!o)
    return;
  const a = i[r], s = Object.keys(a.computed[n].canonicalEvents)[0], l = a.computed[n].canonicalEvents[s];
  if (l != null && l.attachments) {
    const u = Object.keys(l.attachments);
    for (const d of u) {
      const h = l.attachments[d];
      if (h.type === "pin") {
        const p = {
          type: "pin",
          id: d,
          workspaceId: r,
          objectId: h.objectId,
          threadId: n,
          eventId: s
        };
        En(t, {
          target: p
        });
        return;
      }
    }
  }
  (c = (f = t.callbacks) == null ? void 0 : f.onInboxThreadClick) == null || c.call(f, {
    userId: o,
    workspaceId: r,
    threadId: n,
    info: {}
  });
}
function D6(t, e) {
  t.menuId = e.target;
}
function P6(t, e) {
  var o;
  const { workspaceId: n } = e, r = t.workspaces[n].composers[e.threadId][e.eventId];
  if (!r.attachments)
    return;
  const i = r.attachments[e.attachmentId];
  i && (i.type === "pin" && ((o = t.workspaces[n].openPins[i.objectId]) != null && o[e.attachmentId]) && delete t.workspaces[n].openPins[i.objectId][e.attachmentId], delete r.attachments[e.attachmentId]);
}
async function R6(t, e) {
  var o, a;
  const { workspaceId: n, threadId: r } = e, { userId: i } = t;
  if (!i) {
    console.warn("CollabKit: cannot reopen thread, anonymous user");
    return;
  }
  try {
    t.workspaces[n].isOpen[r] = !0, t.workspaces[n].isResolved[r] = !1;
    const s = await Go(t, {
      event: {
        type: "system",
        body: "",
        system: "reopen",
        createdAt: t.sync.serverTimestamp(),
        createdById: i
      },
      parentEvent: null,
      threadId: r
    });
    try {
      (a = (o = t.callbacks) == null ? void 0 : o.onThreadReopen) == null || a.call(o, {
        userId: i,
        workspaceId: n,
        threadId: r,
        info: t.workspaces[n].threadInfo[r]
      });
    } catch (l) {
      console.error("failed to call onThreadReopen callback", l);
    }
    return s;
  } catch (s) {
    console.error("failed to reopen thread", s), t.workspaces[n].isOpen[r] = !1, t.workspaces[n].isResolved[r] = !0;
  }
}
async function Pf(t, e) {
  var o, a;
  const { userId: n } = t, { workspaceId: r, threadId: i } = e;
  if (!n) {
    console.warn("CollabKit: cannot resolve thread, anonymous user");
    return;
  }
  bf(t, { target: { type: "thread", workspaceId: r, threadId: i } }), t.workspaces[r].isOpen[i] = !1, t.workspaces[r].isResolved[i] = !0;
  try {
    const s = await Go(t, {
      event: {
        type: "system",
        body: "",
        system: "resolve",
        createdAt: t.sync.serverTimestamp(),
        createdById: n
      },
      parentEvent: null,
      threadId: i
    });
    return (a = (o = t.callbacks) == null ? void 0 : o.onThreadResolve) == null || a.call(o, {
      userId: n,
      workspaceId: r,
      threadId: i,
      info: t.workspaces[r].threadInfo[i]
    }), s;
  } catch (s) {
    console.error("failed to resolve thread", s), t.workspaces[r].isOpen[i] = !0, t.workspaces[r].isResolved[i] = !1;
  }
}
async function L6(t, e) {
  const { workspaceId: n } = t;
  if (!n)
    return;
  const { appId: r } = t.config;
  Array.isArray(e) && e.forEach((i) => {
    const o = t.profiles[i.id];
    o ? t.mentionableUsers[i.id] = o : "apiKey" in t.config && (t.mentionableUsers[i.id] || (t.mentionableUsers[i.id] = {
      ...i,
      color: c0()
    }, t.sync.saveProfile({
      appId: r,
      userId: i.id,
      workspaceId: n,
      profile: t.mentionableUsers[i.id]
    })));
  });
}
async function $6(t) {
  var n, r, i;
  const { config: e } = t;
  if ("apiKey" in e)
    try {
      const o = ((n = e.user) == null ? void 0 : n.userId) ?? ((r = e.user) == null ? void 0 : r.id);
      if (!o) {
        console.log("CollabKit: cannot save profile without userId");
        return;
      }
      const s = {
        ...await t.sync.getProfile({ appId: e.appId, userId: o }),
        ...e.user,
        id: o
      };
      delete s.userId;
      const l = F6(s), f = t.workspaceId ?? ((i = e.workspace) == null ? void 0 : i.id);
      if (!f) {
        console.log("CollabKit: cannot save profile without workspaceId");
        return;
      }
      t.sync.saveProfile({ appId: e.appId, userId: o, workspaceId: f, profile: l }), e.workspace && t.sync.saveWorkspace({ appId: e.appId, workspaceId: f, workspace: e.workspace }), t.profiles[o] = l;
    } catch (o) {
      console.error("CollabKit: saveProfile failed", o);
    }
}
function F6(t) {
  let e = t.color;
  return i_(e) ? { ...t, color: e } : { ...t, color: c0() };
}
function er(t) {
  const { config: e } = t, n = e.appId, r = "apiKey" in e ? e.apiKey : null, i = "token" in e ? e.token : null, o = i ? "SECURED" : "UNSECURED", a = t.userId, s = t.workspaceId;
  if (!n)
    throw new Error("Missing `appId`");
  if (o === "UNSECURED" && !r)
    throw new Error("Missing `apiKey`");
  if (!a)
    throw new Error("Missing `userId`");
  if (!s)
    throw new Error("Missing `workspaceId`");
  return { appId: n, apiKey: r, token: i, mode: o, userId: a, workspaceId: s };
}
function j6(t, e) {
  const { threadId: n, workspaceId: r } = e, { appId: i } = er(t), { threadInfo: o } = t.workspaces[r];
  o[n] = e.info;
  try {
    return t.sync.saveThreadInfo({ ...e, appId: i });
  } catch (a) {
    console.error("failed to set thread info", a);
  }
}
async function z6(t, e) {
  const { appId: n, userId: r, workspaceId: i } = er(t);
  if (!r) {
    console.warn("CollabKit: cannot mark seen, no userId");
    return;
  }
  if (typeof document < "u" && !document.hasFocus()) {
    console.log("CollabKit: not marking seen, document not defined or focused");
    return;
  }
  const { threadId: o, eventId: a } = e.target;
  if (!o || !a) {
    console.warn("CollabKit: cannot mark seen, no threadId or eventId");
    return;
  }
  const s = t.workspaces[i].seen[o];
  if (s ? a > s : !0) {
    t.workspaces[i].seen[o] = a;
    try {
      t.sync.markSeen({ appId: n, userId: r, workspaceId: i, threadId: o, eventId: a });
    } catch (f) {
      console.log("CollabKit: error marking seen", {
        appId: n,
        userId: r,
        workspaceId: i,
        threadId: o,
        eventId: a
      }), console.error(f);
    }
  }
}
function iD(t, e) {
  var s;
  const { workspaceId: n, threadId: r, eventId: i } = e;
  (s = t.workspaces[n].composers[r][i].editor) == null || s.update(() => {
    Z.$getRoot().clear();
  });
}
function B6(t, e) {
  const { workspaceId: n } = e, r = t.workspaces[n].composers[e.threadId][e.eventId];
  r.attachments = {};
}
async function P1(t, e) {
  var m, v, b, k;
  const { userId: n } = t, { workspaceId: r, threadId: i, eventId: o } = e;
  if (!n) {
    console.warn("[CollabKit]: cannot send a message, anonymous user"), t.config.onAuthenticationRequired && t.config.onAuthenticationRequired();
    return;
  }
  const a = t.workspaces[r], s = a.composers[i][o], { editor: l } = s, { body: f, mentions: c } = l ? M6(l) : { body: "", mentions: [] }, { attachments: u } = s;
  if (`${f}`.trim().length === 0) {
    console.warn("[CollabKit] tried to send an empty message");
    return;
  }
  iD(t, { workspaceId: r, threadId: i, eventId: o });
  const d = a.pendingThreadInfo[i];
  d && await j6(t, {
    workspaceId: r,
    threadId: i,
    info: d
  });
  const h = Object.keys(a.timeline[i] ?? {}).length === 0, p = await Go(t, {
    event: {
      type: "message",
      body: f,
      createdAt: t.sync.serverTimestamp(),
      createdById: n,
      mentions: c,
      attachments: u
    },
    parentEvent: null,
    threadId: i
  });
  B6(t, { workspaceId: r, threadId: i, eventId: o }), (v = (m = t.callbacks) == null ? void 0 : m.onCommentSend) == null || v.call(m, { workspaceId: r, threadId: i, userId: n, event: p }), h && ((k = (b = t.callbacks) == null ? void 0 : b.onThreadCreated) == null || k.call(b, {
    workspaceId: r,
    threadId: i,
    userId: n,
    event: p
  }));
}
function W6(t, e) {
  t.avatarErrors[e.avatar] = !0;
}
function Ol(t, e) {
  t.composerId = e.target;
}
function Dl({ store: t, visibility: e }) {
  t.pinsVisible = e;
}
function R1(t, e) {
  Uo(t.previewingId, e.target) || (t.previewingId = JSON.parse(JSON.stringify(e.target)));
}
async function Qa(t) {
  t.isSidebarOpen = !0;
}
function U6(t, e) {
  t.editingId = {
    ...e,
    type: "comment"
  }, t.editingEventSnapshots[e.eventId] = Pb(
    Eo(t.workspaces[e.workspaceId].timeline[e.threadId][e.eventId])
  ), Qo(t, e);
  const { eventId: n, workspaceId: r, threadId: i } = e, { attachments: o } = t.workspaces[r].timeline[i][n];
  if (o) {
    t.workspaces[r].composers[i][n].attachments = JSON.parse(
      JSON.stringify(o)
    );
    const a = Object.keys(o).find((s) => o[s].type === "pin");
    if (a) {
      const s = o[a], l = {
        type: "pin",
        id: a,
        workspaceId: r,
        threadId: i,
        objectId: s.objectId,
        eventId: n
      };
      En(t, { target: l });
    }
  }
}
function H6(t, e) {
  const { isMentioning: n, editor: r } = t.workspaces[e.workspaceId].composers[e.threadId][e.eventId];
  r && (n ? r.dispatchCommand(S6, void 0) : r.focus(
    () => {
      r.update(() => {
        const i = Z.$getSelection();
        if (Z.$isRangeSelection(i)) {
          const o = N6();
          o != null && o.endsWith("@") ? r.dispatchCommand(I6, void 0) : o != null && o.endsWith(" ") || Z.$getRoot().isEmpty() ? i.insertRawText("@") : i.insertRawText(" @");
        }
      });
    },
    { defaultSelection: "rootEnd" }
  ));
}
function L1(t) {
  t.uiState = "selecting";
}
function so(t, e) {
  if (e != null && e.target && e.target.type === "commentCancelButton") {
    const { target: n } = e, { workspaceId: r, threadId: i, eventId: o } = n, a = t.editingEventSnapshots[o];
    if (a) {
      const s = structuredClone(a.attachments ?? {});
      t.workspaces[r].composers[i][o].attachments = s, t.workspaces[r].timeline[i][o].attachments = s;
    }
  }
  t.editingId = null;
}
function Ma(t) {
  t.uiState = "idle";
}
async function V6(t, e) {
  const { userId: n } = t, { appId: r } = er(t);
  if (!n)
    throw new Error("CollabKit: cannot stop typing without a user");
  if (!r)
    throw new Error("CollabKit: cannot stop typing without an app");
  const { workspaceId: i, threadId: o, eventId: a } = e.target;
  if (!n)
    return;
  const s = t.workspaces[i].composers[o][a].isTypingTimeoutID;
  s && clearTimeout(s), await t.sync.stopTyping({
    appId: r,
    workspaceId: i,
    threadId: o,
    userId: n
  });
}
async function j0(t) {
  const { userId: e, workspaceId: n, config: r } = t, i = r.appId;
  if (!e || !n || !i)
    return;
  function o(a) {
    var s;
    a.threadId && n && ((s = t.workspaces)[n] || (s[n] = ps()), t.workspaces[n].inbox[a.threadId] = a.event, fi(t, { workspaceId: n, threadId: a.threadId }));
  }
  t.sync.subscribeInbox({ appId: i, workspaceId: n, subs: t.subs, onInboxChange: o });
}
async function Aa(t, e) {
  var s, l;
  const { profileId: n } = e, { appId: r } = er(t), i = (f) => {
    console.error({ e: f });
  }, o = gt(n), a = ae`/profiles/${r}/${o}`;
  t.profiles[n] || (s = t.subs)[l = a.toString()] || (s[l] = gc(
    a,
    (f) => {
      const c = Ba(f);
      c ? (t.profiles[o] = F6(c), c.isDeleted || (t.mentionableUsers[o] = c), e.onSubscribe(c)) : console.warn(`[CollabKit] Profile '${o}' not found'`);
    },
    i
  ));
}
async function fi(t, e) {
  const { workspaceId: n, threadId: r } = e, i = `${n}-${r}`;
  if (t.subs[i])
    return;
  t.subs[i] = () => {
  }, bc(t, { workspaceId: n, threadId: r }), Qo(t, {
    workspaceId: n,
    threadId: r,
    eventId: "default"
  });
  const { appId: o, userId: a } = er(t);
  function s(l) {
    var f, c;
    (f = t.workspaces[l.workspaceId].timeline[l.threadId])[c = l.eventId] || (f[c] = {
      ...l.event,
      id: l.eventId
    }), t.config.mentionableUsers !== "allWorkspace" && Aa(t, {
      profileId: l.event.createdById,
      onSubscribe: () => {
      }
    });
  }
  t.sync.subscribeThread({
    appId: o,
    userId: a,
    workspaceId: n,
    threadId: r,
    subs: t.subs,
    onTimelineEventAdded: (l) => {
      s(l);
    },
    onThreadTypingChange: ({ workspaceId: l, threadId: f, userId: c, isTyping: u }) => {
      t.workspaces[l].composers[f].default.isTyping[c] = u;
    },
    onThreadInfo: (l) => {
      l.info ? t.workspaces[l.workspaceId].threadInfo[l.threadId] = l.info : delete t.workspaces[l.workspaceId].threadInfo[l.threadId];
    },
    onThreadResolveChange: (l) => {
      t.workspaces[l.workspaceId].isResolved[l.threadId] = l.isResolved, t.workspaces[l.workspaceId].isOpen[l.threadId] = !l.isResolved;
    },
    onThreadProfile: (l) => {
      t.workspaces[l.workspaceId].threadProfiles[l.threadId][l.userId] = !0, t.config.mentionableUsers !== "allWorkspace" && Aa(t, {
        profileId: l.userId,
        onSubscribe: () => {
        }
      });
    },
    onTimelineGetComplete: (l) => {
      if (!l.length)
        return;
      const { workspaceId: f, threadId: c } = l[0];
      t.workspaces[f].timeline[c] = l.reduce((u, d) => (u[d.eventId] = d.event, u), {}), t.config.mentionableUsers !== "allWorkspace" && l.map((u) => u.event.createdById).filter(function(d, h, p) {
        return p.indexOf(d) === h;
      }).map(
        (u) => Aa(t, { profileId: u, onSubscribe: () => {
        } })
      );
    },
    onThreadProfiles: (l) => {
      if (t.workspaces[l.workspaceId].threadProfiles[l.threadId] = l.profiles, t.config.mentionableUsers !== "allWorkspace")
        for (const f of Object.keys(l.profiles)) {
          if (t.profiles[f])
            return;
          Aa(t, {
            profileId: f,
            onSubscribe: () => {
            }
          });
        }
    }
  });
}
function oD(t) {
  return typeof t == "object" && t !== null && Wa(t, "x") && Wa(t, "y") && typeof t.x == "number" && typeof t.y == "number" && Wa(t, "threadId") && typeof t.threadId == "string";
}
function aD(t) {
  if (typeof t != "object" || t === null)
    return !1;
  const e = t;
  for (const n in e) {
    if (typeof e[n] != "object" || e[n] === null)
      return !1;
    const r = e[n];
    if (!K6(r))
      return !1;
  }
  return !0;
}
function K6(t) {
  if (typeof t != "object" || t === null)
    return !1;
  const e = t;
  for (const n in e)
    if (!oD(e[n]))
      return !1;
  return !0;
}
function Y6(t) {
  var a;
  const { appId: e, workspaceId: n } = er(t);
  (a = t.workspaces)[n] || (a[n] = ps());
  function r(s) {
    var f;
    const l = t.workspaces[n];
    if (aD(s))
      for (const c in s) {
        const u = gt(c);
        (f = l.openPins)[u] || (f[u] = {});
        for (const d in s[u]) {
          const h = s[u][d], { meta: p, ...m } = h, v = {
            ...m,
            id: d,
            workspaceId: n,
            objectId: u,
            meta: p ?? null
          };
          l.eventPins[v.eventId] = v, l.openPins[u][d] = v, fi(t, { ...v });
        }
      }
    else
      console.error("[CollabKit] invalid pins", s);
  }
  function i(s, l) {
    var f;
    if (K6(l)) {
      const c = t.workspaces[n];
      (f = c.openPins)[s] || (f[s] = {});
      const u = Object.keys(c.openPins[s]), d = Object.keys(l), h = u.filter((p) => !d.includes(p));
      for (const p of h) {
        const m = c.openPins[s][p];
        delete c.eventPins[m.eventId], delete c.openPins[s][p];
      }
      for (const p in l) {
        const m = l[p], { meta: v, ...b } = m, k = {
          ...b,
          id: p,
          workspaceId: n,
          objectId: s,
          meta: v ?? null
        };
        c.openPins[s][p] = k, c.eventPins[k.eventId] = k, fi(t, { ...k });
      }
      for (const p in d) {
        const m = c.openPins[s][p];
        fi(t, { ...m });
      }
    } else
      console.error("[CollabKit] invalid pins", l);
  }
  function o(s) {
    for (const l in t.workspaces[n].openPins[s]) {
      const f = t.workspaces[n].openPins[s][l];
      delete t.workspaces[n].eventPins[f.eventId];
    }
    delete t.workspaces[n].openPins[s];
  }
  t.sync.subscribeOpenPins({
    appId: e,
    workspaceId: n,
    subs: t.subs,
    onGet: r,
    onObjectChange: i,
    onObjectAdded: i,
    onObjectRemove: o
  });
}
async function $1(t) {
  const { appId: e, userId: n, workspaceId: r } = er(t);
  if (!n)
    return;
  const i = (o) => {
    t.workspaces[r].seen[o.threadId] = o.seenUntilId;
  };
  t.sync.subscribeSeen({ appId: e, userId: n, workspaceId: r, subs: t.subs, onSeenChange: i });
}
async function F1(t) {
  const { appId: e, workspaceId: n } = er(t), r = (m) => {
    console.error({ e: m });
  }, i = (m) => {
    const v = Ba(m);
    v && (t.profiles[v.id] = v, t.config.mentionableUsers === "allWorkspace" && (v.isDeleted ? delete t.mentionableUsers[v.id] : t.mentionableUsers[v.id] = v));
  }, o = (m) => {
    var b, k, _, E;
    const v = Ba(m);
    v && ((b = t.profiles)[k = v.id] || (b[k] = v), t.config.mentionableUsers === "allWorkspace" && (v.isDeleted || (_ = t.mentionableUsers)[E = v.id] || (_[E] = v)));
  }, a = ae`/views/workspaceProfiles/${e}/${n}`, s = gs(a), l = {}, f = await lr(s);
  let c = 0, u = !1;
  function d() {
    u || (console.warn(
      '[CollabKit] Setting mentionableUsers to "allWorkspace" in workspaces with a large number of users is not recommended. To ensure optimal performance, please consider passing an array of mentionable users instead or contact us for support.'
    ), u = !0);
  }
  if (f.forEach((m) => {
    c++, c > 100 && d();
    const v = Ba(m);
    v && (l[v.id] = v);
  }), t.profiles = l, t.config.mentionableUsers === "allWorkspace")
    for (const m in l) {
      const v = l[m];
      v.isDeleted || (t.mentionableUsers[m] = v);
    }
  const h = `${a.toString()}#added`, p = `${a.toString()}#changed`;
  t.subs[h] || (t.subs[h] = oi(a, o, r)), t.subs[p] || (t.subs[p] = Zy(a, i, r));
}
async function j1(t, e) {
  var c, u;
  const { userId: n } = t;
  if (!n) {
    console.warn("[CollabKit] Cannot toggle emoji without userId");
    return;
  }
  const { emoji: r } = e.target, { workspaceId: i, threadId: o, eventId: a } = e.target, s = t.workspaces[i].timeline[o][a], l = (u = (c = t.workspaces[i].computed[o].reactions) == null ? void 0 : c[a]) == null ? void 0 : u[r.u], f = l && // if they have reacted already, mark this as a delete
  l.userIds.includes(n) ? `delete-${r.u}` : r.u;
  Go(t, {
    event: {
      type: "reaction",
      body: f,
      createdAt: t.sync.serverTimestamp(),
      createdById: n,
      parentId: a
    },
    parentEvent: s,
    threadId: o
  }), u_(t);
}
function q6(t, e) {
  e.open ? t.reactingId = mc(e.target) : t.reactingId = null;
}
function G6(t, e) {
  var n, r;
  if (Uo(t.hoveringId, e.target))
    switch (t.hoveringId = null, e.target.type) {
      case "comment": {
        const i = t.workspaces[e.target.workspaceId].eventPins[e.target.eventId];
        i && ((r = (n = t.callbacks) == null ? void 0 : n.onPinUnhover) == null || r.call(n, {
          userId: t.userId,
          objectId: t.workspaces[e.target.workspaceId].eventPins[e.target.eventId].objectId,
          workspaceId: e.target.workspaceId,
          threadId: e.target.threadId,
          meta: i.meta
        }));
      }
    }
}
async function Pl(t) {
  if (!t.editingId) {
    console.warn("[CollabKit] cannot update comment, editingId is not defined");
    return;
  }
  const { userId: e } = er(t), { workspaceId: n, threadId: r, eventId: i } = t.editingId;
  if (!e) {
    console.warn("[CollabKit]: cannot edit comment, anonymous user"), t.config.onAuthenticationRequired && t.config.onAuthenticationRequired();
    return;
  }
  const o = t.workspaces[n], a = t.editingEventSnapshots[i];
  if (!a) {
    console.warn("[CollabKit]: cannot edit comment, parent event not found");
    return;
  }
  const s = o.composers[r][i], { editor: l, attachments: f } = s, { body: c, mentions: u } = l ? M6(l) : { body: "", mentions: [] };
  Go(t, {
    event: {
      type: "edit",
      body: c,
      createdAt: t.sync.serverTimestamp(),
      createdById: e,
      parentId: i,
      mentions: u,
      attachments: f
    },
    parentEvent: a,
    threadId: r
  }), B6(t, { workspaceId: n, threadId: r, eventId: i });
}
function Q6(t, e) {
  const { target: n, editor: r } = e, i = Qo(t, n);
  i.editor = mc(r);
  let o = !0;
  i.editor.getEditorState().read(() => {
    o = Z.$getRoot().getTextContentSize() === 0;
  }), i.enabled = !o, i.hasText = !o, o ? (D1.cancel(), setTimeout(() => {
    V6(t, { target: n });
  }, 100)) : D1(t, { target: n });
}
async function X6(t) {
  t.isSidebarOpen = !t.isSidebarOpen;
}
function J6(t) {
  return {
    onInsertText: (e, n) => {
      var i, o;
      const r = (o = (i = t.workspaces[e.workspaceId].composers[e.threadId]) == null ? void 0 : i.default) == null ? void 0 : o.editor;
      r && r.update(() => {
        var a;
        (a = Z.$getSelection()) == null || a.insertRawText(n);
      });
    },
    onComposerChange: (e, n) => {
      e.type === "composer" && Q6(t, { target: e, editor: n });
    },
    onConnectionStateChange: async (e) => {
      t.isConnected = e;
      try {
        await f_(t);
      } catch (n) {
        console.error("[CollabKit] failed to authenticate", { e: n });
      }
    },
    // make this fetch workspaceId and threadId from store
    onSend: (e, n) => {
      P1(t, { workspaceId: e, threadId: n, eventId: "default" });
    },
    onEdit: () => {
      Pl(t), so(t);
    },
    onFocus: (e, n) => {
      u0(t, n);
    },
    onClick: (e, n) => {
      const { target: r } = n;
      if (e.button === 0)
        switch (r.type === "pin" || (e.preventDefault(), e.stopPropagation()), t.uiState) {
          case "selecting": {
            switch (r.type) {
              case "overlay":
                e.stopPropagation(), e.preventDefault(), Z2(t, r);
                break;
              case "composerPinButton":
                Ma(t);
                break;
              case "hideSidebarButton":
                Ma(t), o1(t);
                break;
            }
            break;
          }
          case "idle": {
            switch (r.type) {
              case "pinThreadPreview":
                t.isFigmaStyle || Qa(t), En(t, { target: { ...r, type: "pin" } });
                break;
              case "thread":
                En(t, { target: r });
                break;
              case "pinCommentButton":
                L1(t);
                const i = t.nextThreadId;
                if (!i)
                  return;
                const o = {
                  ...r,
                  type: "composer",
                  threadId: i,
                  eventId: "default"
                };
                Qo(t, { ...r, threadId: i, eventId: "default" }), Ol(t, { target: o });
                break;
              case "overlay":
                fo(t);
                break;
              case "inboxItem":
                O6(t, r);
                break;
              case "pinThreadCloseIconButton":
                fo(t), oo(t);
                break;
              case "pinNextThreadIconButton":
                En(t, { target: r });
                break;
              case "pinPrevThreadIconButton":
                En(t, { target: r });
                break;
              case "pinThreadResolveIconButton":
                Pf(t, r), oo(t), fo(t);
                break;
              case "toggleSidebarButton":
                X6(t);
                break;
              case "showSidebarButton":
                Qa(t);
                break;
              case "hideSidebarButton":
                o1(t);
                break;
              case "channel":
                En(t, { target: r }), Da(t, { ...r, type: "composer", eventId: "default" });
                break;
              case "emoji":
                j1(t, { target: r });
                break;
              case "commentPin":
                En(t, { target: r });
                break;
              case "pin":
                if (En(t, { target: r }), t.isFigmaStyle)
                  return;
                Qa(t);
                break;
              case "composer":
                Ol(t, { target: r }), Da(t, r);
                break;
              case "pinDeleteButton":
                h_();
                return;
              case "commentDeleteButton":
                d_(t, r);
                break;
              case "commentEditButton":
                U6(t, r);
                break;
              case "reopenThreadButton":
                R6(t, r);
                break;
              case "commentReplyButton":
              case "commentSeeAllRepliesButton":
                e.preventDefault(), e.stopPropagation(), En(t, { target: { ...r, type: "thread" } }), g_(t, r), Da(t, {
                  type: "composer",
                  workspaceId: r.workspaceId,
                  threadId: r.threadId,
                  eventId: "default"
                });
                break;
              case "commentSaveButton":
                Pl(t), so(t);
                break;
              case "commentCancelButton":
                so(t, { target: r });
                break;
              case "composerPin":
                P6(t, { ...r, attachmentId: r.pinId }), Ma(t);
                break;
              case "composerPinButton":
                Ol(t, { target: { ...r, type: "composer" } }), L1(t);
                break;
              case "composerMentionsButton":
                H6(t, r);
                break;
              case "closeThreadButton":
                oo(t);
                break;
              case "resolveThreadButton":
                Pf(t, r);
                break;
              case "channelToggleShowResolved":
                n4(t, r);
                break;
            }
            break;
          }
        }
    },
    onReactionPick: (e) => {
      j1(t, e);
    },
    onBlur: (e, n) => {
      c_(t, n);
    },
    onMenuOpen: (e) => {
      D6(t, e);
    },
    onMenuClose: (e) => {
      r1(t);
    },
    onKeyDown: (e) => {
      var n;
      if (t.uiState === "selecting" && e.key === "Escape") {
        Ma(t), e.stopPropagation(), e.preventDefault();
        return;
      }
      if (t.reactingId && e.key === "Escape") {
        t.reactingId = null, e.stopPropagation(), e.preventDefault();
        return;
      }
      if (t.editingId) {
        if (e.key === "Enter" && !e.shiftKey && (e.stopPropagation(), e.preventDefault(), Pl(t), so(t)), e.key === "Escape") {
          so(t), e.stopPropagation(), e.preventDefault();
          return;
        }
      } else if (((n = t.focusedId) == null ? void 0 : n.type) === "composer" && e.key === "Enter" && !e.shiftKey && (e.stopPropagation(), e.preventDefault(), t.focusedId.eventId === "default" && (P1(t, { ...t.focusedId }), t.focusedId.isNewThread))) {
        const { appId: r } = er(t);
        t.nextThreadId = t.sync.nextThreadId({
          workspaceId: t.workspaceId,
          appId: r
        }), t.focusedId.threadId = t.nextThreadId;
      }
      if (t.menuId && e.key === "Escape") {
        r1(t), e.stopPropagation(), e.preventDefault();
        return;
      }
      t.viewingId && e.key === "Escape" && (oo(t), e.stopPropagation(), e.preventDefault());
    },
    onMouseEnter: (e, n) => {
      const { target: r } = n, { type: i } = r;
      switch (i) {
        case "composerPinButton":
        case "comment":
          p_(t, { target: r });
          break;
      }
    },
    onMouseLeave: (e, n) => {
      const { target: r } = n, { type: i } = r;
      switch (i) {
        case "composerPinButton":
        case "comment":
          G6(t, { target: r });
          break;
      }
    },
    onMouseOver: (e, n) => {
    },
    onMouseOut: (e, n) => {
    },
    onGlobalPointerDown: (e) => {
      const n = e.target;
      n instanceof Element && n.closest(".collabkit") || fo(t);
    },
    onSeen: (e) => {
      z6(t, e);
    },
    onReactionPickerOpenChange: (e) => {
      q6(t, e);
    },
    onPopoverPreviewChange: (e) => {
      e.open ? R1(t, e) : Tl(t, e);
    },
    onPopoverContentChange: (e) => {
      e.open ? Bl(t, e) : oo(t);
    },
    onSetPopoverState: ({
      target: e,
      state: n
    }) => {
      switch (n) {
        case "open":
          Tl(t, { target: e }), Bl(t, { target: e });
          break;
        case "preview":
          bf(t, { target: e }), R1(t, { target: e });
          break;
        case "closed":
          Tl(t, { target: e }), bf(t, { target: e });
          break;
        default:
          throw new Error(`invalid popover state: ${n}`);
      }
    },
    onReactFlowViewportChange: ({ state: e }) => {
      switch (e) {
        case "start":
          Dl({ store: t, visibility: !1 });
          break;
        case "stop":
          Dl({ store: t, visibility: !0 });
          break;
        case "change":
          Dl({ store: t, visibility: !1 });
          break;
      }
    },
    onReactFlowNodeDrag: ({
      state: e,
      pinObjectId: n
    }) => {
      switch (e) {
        case "start":
          i1({ store: t, pinObjectId: n, visibility: !1 });
          break;
        case "stop":
          i1({ store: t, pinObjectId: n, visibility: !0 });
          break;
      }
    }
  };
}
function Z6(t) {
  var n, r;
  const e = J6(t);
  A6(t, e), (n = t.subs).keydown || (n.keydown = sD(e)), (r = t.subs).pointerdown || (r.pointerdown = lD(e));
}
function sD(t) {
  return document.addEventListener("keydown", t.onKeyDown), () => {
    document.removeEventListener("keydown", t.onKeyDown);
  };
}
function lD(t) {
  return document.addEventListener("pointerdown", t.onGlobalPointerDown), () => {
    document.removeEventListener("pointerdown", t.onGlobalPointerDown);
  };
}
function e4(t) {
  for (const e of Object.values(t.subs))
    e();
  t.subs = {};
}
function t4(t, e) {
  const n = t.callbacks;
  n.onAuthenticationRequired = e.onAuthenticationRequired, n.onPinClick = e.onPinClick, n.onPinHover = e.onPinHover, n.onPinUnhover = e.onPinUnhover, n.onPinDeselect = e.onPinDeselect, n.onPinAttach = e.onPinAttach, n.onThreadCreated = e.onThreadCreated, n.onCommentSend = e.onCommentSend, n.onTimestampClick = e.onTimestampClick, n.onMentionClick = e.onMentionClick, n.onInboxThreadClick = e.onInboxThreadClick, n.onThreadResolve = e.onThreadResolve, n.onThreadReopen = e.onThreadReopen, n.onInboxCloseButtonClick = e.onInboxCloseButtonClick, e.mentionableUsers !== t.config.mentionableUsers && L6(t, e.mentionableUsers);
}
function n4(t, e) {
  t.resolvedVisible[e.channelId] = !t.resolvedVisible[e.channelId];
}
const QW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attachComposerPin: Z2,
  authenticate: f_,
  blur: c_,
  closeAllPopovers: oo,
  closeEmojiReactionPicker: u_,
  closeMenu: r1,
  closePopoverContent: bf,
  closePopoverPreview: Tl,
  collapseThread: PM,
  deleteMessage: d_,
  deletePin: h_,
  deselectAll: fo,
  destroy: e4,
  dragPin: i1,
  expandThread: g_,
  focus: u0,
  focusComposer: Da,
  hideSidebar: o1,
  hover: p_,
  initComposer: Qo,
  initThread: bc,
  insertComposerPin: $O,
  install: Z6,
  isTyping: D1,
  monitorConnection: A6,
  openInboxItem: O6,
  openMenu: D6,
  removeAttachment: P6,
  reopenThread: R6,
  resolveThread: Pf,
  saveMentionableUsers: L6,
  saveProfile: $6,
  saveThreadInfo: j6,
  seen: z6,
  select: En,
  sendMessage: P1,
  setAvatarError: W6,
  setComposer: Ol,
  setConfig: t4,
  setPinVisibility: Dl,
  showPreview: R1,
  showSidebar: Qa,
  startEditing: U6,
  startMentioning: H6,
  startSelecting: L1,
  stopEditing: so,
  stopSelecting: Ma,
  stopTyping: V6,
  subscribeInbox: j0,
  subscribeOpenPins: Y6,
  subscribeProfile: Aa,
  subscribeSeen: $1,
  subscribeThread: fi,
  subscribeWorkspaceProfiles: F1,
  toggleEmoji: j1,
  toggleEmojiPicker: q6,
  toggleShowResolved: n4,
  toggleSidebar: X6,
  unhover: G6,
  updateComment: Pl,
  updateComposer: Q6,
  viewContent: Bl
}, Symbol.toStringTag, { value: "Module" })), r4 = ui(null);
function fD({
  children: t,
  store: e
}) {
  const n = Yt(() => {
    const r = J6(e);
    return {
      store: e,
      events: r
    };
  }, [e]);
  return /* @__PURE__ */ g(r4.Provider, {
    value: n,
    children: t
  });
}
var cD = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, io = /* @__PURE__ */ new WeakMap(), ul = /* @__PURE__ */ new WeakMap(), dl = {}, Zu = 0, uD = function(t, e, n) {
  e === void 0 && (e = cD(t)), n === void 0 && (n = "data-aria-hidden");
  var r = Array.isArray(t) ? t : [t];
  dl[n] || (dl[n] = /* @__PURE__ */ new WeakMap());
  var i = dl[n], o = [], a = /* @__PURE__ */ new Set(), s = function(f) {
    !f || a.has(f) || (a.add(f), s(f.parentNode));
  };
  r.forEach(s);
  var l = function(f) {
    !f || r.indexOf(f) >= 0 || Array.prototype.forEach.call(f.children, function(c) {
      if (a.has(c))
        l(c);
      else {
        var u = c.getAttribute("aria-hidden"), d = u !== null && u !== "false", h = (io.get(c) || 0) + 1, p = (i.get(c) || 0) + 1;
        io.set(c, h), i.set(c, p), o.push(c), h === 1 && d && ul.set(c, !0), p === 1 && c.setAttribute(n, "true"), d || c.setAttribute("aria-hidden", "true");
      }
    });
  };
  return l(e), a.clear(), Zu++, function() {
    o.forEach(function(f) {
      var c = io.get(f) - 1, u = i.get(f) - 1;
      io.set(f, c), i.set(f, u), c || (ul.has(f) || f.removeAttribute("aria-hidden"), ul.delete(f)), u || f.removeAttribute(n);
    }), Zu--, Zu || (io = /* @__PURE__ */ new WeakMap(), io = /* @__PURE__ */ new WeakMap(), ul = /* @__PURE__ */ new WeakMap(), dl = {});
  };
};
/*!
* tabbable 6.0.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var dD = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"], z1 = /* @__PURE__ */ dD.join(","), i4 = typeof Element > "u", Ss = i4 ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Rf = !i4 && Element.prototype.getRootNode ? function(t) {
  return t.getRootNode();
} : function(t) {
  return t.ownerDocument;
}, hD = function(e, n, r) {
  var i = Array.prototype.slice.apply(e.querySelectorAll(z1));
  return n && Ss.call(e, z1) && i.unshift(e), i = i.filter(r), i;
}, gD = function t(e, n, r) {
  for (var i = [], o = Array.from(e); o.length; ) {
    var a = o.shift();
    if (a.tagName === "SLOT") {
      var s = a.assignedElements(), l = s.length ? s : a.children, f = t(l, !0, r);
      r.flatten ? i.push.apply(i, f) : i.push({
        scopeParent: a,
        candidates: f
      });
    } else {
      var c = Ss.call(a, z1);
      c && r.filter(a) && (n || !e.includes(a)) && i.push(a);
      var u = a.shadowRoot || // check for an undisclosed shadow
      typeof r.getShadowRoot == "function" && r.getShadowRoot(a), d = !r.shadowRootFilter || r.shadowRootFilter(a);
      if (u && d) {
        var h = t(u === !0 ? a.children : u.children, !0, r);
        r.flatten ? i.push.apply(i, h) : i.push({
          scopeParent: a,
          candidates: h
        });
      } else
        o.unshift.apply(o, a.children);
    }
  }
  return i;
}, o4 = function(e, n) {
  return e.tabIndex < 0 && (n || /^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || e.isContentEditable) && isNaN(parseInt(e.getAttribute("tabindex"), 10)) ? 0 : e.tabIndex;
}, pD = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, a4 = function(e) {
  return e.tagName === "INPUT";
}, mD = function(e) {
  return a4(e) && e.type === "hidden";
}, vD = function(e) {
  var n = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, bD = function(e, n) {
  for (var r = 0; r < e.length; r++)
    if (e[r].checked && e[r].form === n)
      return e[r];
}, yD = function(e) {
  if (!e.name)
    return !0;
  var n = e.form || Rf(e), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(e.name));
  else
    try {
      i = r(e.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var o = bD(i, e.form);
  return !o || o === e;
}, _D = function(e) {
  return a4(e) && e.type === "radio";
}, wD = function(e) {
  return _D(e) && !yD(e);
}, kD = function(e) {
  for (var n, r = Rf(e).host, i = !!((n = r) !== null && n !== void 0 && n.ownerDocument.contains(r) || e.ownerDocument.contains(e)); !i && r; ) {
    var o;
    r = Rf(r).host, i = !!((o = r) !== null && o !== void 0 && o.ownerDocument.contains(r));
  }
  return i;
}, ev = function(e) {
  var n = e.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, CD = function(e, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var o = Ss.call(e, "details>summary:first-of-type"), a = o ? e.parentElement : e;
  if (Ss.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var s = e; e; ) {
        var l = e.parentElement, f = Rf(e);
        if (l && !l.shadowRoot && i(l) === !0)
          return ev(e);
        e.assignedSlot ? e = e.assignedSlot : !l && f !== e.ownerDocument ? e = f.host : e = l;
      }
      e = s;
    }
    if (kD(e))
      return !e.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return ev(e);
  return !1;
}, xD = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return Ss.call(n, "fieldset[disabled] *") ? !0 : !i.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, ED = function(e, n) {
  return !(n.disabled || mD(n) || CD(n, e) || // For a details element with a summary, the summary element gets the focus
  vD(n) || xD(n));
}, tv = function(e, n) {
  return !(wD(n) || o4(n) < 0 || !ED(e, n));
}, TD = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, SD = function t(e) {
  var n = [], r = [];
  return e.forEach(function(i, o) {
    var a = !!i.scopeParent, s = a ? i.scopeParent : i, l = o4(s, a), f = a ? t(i.candidates) : s;
    l === 0 ? a ? n.push.apply(n, f) : n.push(s) : r.push({
      documentOrder: o,
      tabIndex: l,
      item: i,
      isScope: a,
      content: f
    });
  }), r.sort(pD).reduce(function(i, o) {
    return o.isScope ? i.push.apply(i, o.content) : i.push(o.content), i;
  }, []).concat(n);
}, Lf = function(e, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = gD([e], n.includeContainer, {
    filter: tv.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: TD
  }) : r = hD(e, n.includeContainer, tv.bind(null, n)), SD(r);
};
function Ys(t) {
  return t.split("-")[1];
}
function s4(t) {
  return t === "y" ? "height" : "width";
}
function Mr(t) {
  return t.split("-")[0];
}
function qs(t) {
  return ["top", "bottom"].includes(Mr(t)) ? "x" : "y";
}
function nv(t, e, n) {
  let { reference: r, floating: i } = t;
  const o = r.x + r.width / 2 - i.width / 2, a = r.y + r.height / 2 - i.height / 2, s = qs(e), l = s4(s), f = r[l] / 2 - i[l] / 2, c = s === "x";
  let u;
  switch (Mr(e)) {
    case "top":
      u = { x: o, y: r.y - i.height };
      break;
    case "bottom":
      u = { x: o, y: r.y + r.height };
      break;
    case "right":
      u = { x: r.x + r.width, y: a };
      break;
    case "left":
      u = { x: r.x - i.width, y: a };
      break;
    default:
      u = { x: r.x, y: r.y };
  }
  switch (Ys(e)) {
    case "start":
      u[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      u[s] += f * (n && c ? -1 : 1);
  }
  return u;
}
const ID = async (t, e, n) => {
  const { placement: r = "bottom", strategy: i = "absolute", middleware: o = [], platform: a } = n, s = o.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(e));
  let f = await a.getElementRects({ reference: t, floating: e, strategy: i }), { x: c, y: u } = nv(f, r, l), d = r, h = {}, p = 0;
  for (let m = 0; m < s.length; m++) {
    const { name: v, fn: b } = s[m], { x: k, y: _, data: E, reset: S } = await b({ x: c, y: u, initialPlacement: r, placement: d, strategy: i, middlewareData: h, rects: f, platform: a, elements: { reference: t, floating: e } });
    c = k ?? c, u = _ ?? u, h = { ...h, [v]: { ...h[v], ...E } }, S && p <= 50 && (p++, typeof S == "object" && (S.placement && (d = S.placement), S.rects && (f = S.rects === !0 ? await a.getElementRects({ reference: t, floating: e, strategy: i }) : S.rects), { x: c, y: u } = nv(f, d, l)), m = -1);
  }
  return { x: c, y: u, placement: d, strategy: i, middlewareData: h };
};
function ND(t) {
  return typeof t != "number" ? function(e) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...e };
  }(t) : { top: t, right: t, bottom: t, left: t };
}
function B1(t) {
  return { ...t, top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height };
}
async function z0(t, e) {
  var n;
  e === void 0 && (e = {});
  const { x: r, y: i, platform: o, rects: a, elements: s, strategy: l } = t, { boundary: f = "clippingAncestors", rootBoundary: c = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: h = 0 } = e, p = ND(h), m = s[d ? u === "floating" ? "reference" : "floating" : u], v = B1(await o.getClippingRect({ element: (n = await (o.isElement == null ? void 0 : o.isElement(m))) == null || n ? m : m.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)), boundary: f, rootBoundary: c, strategy: l })), b = u === "floating" ? { ...a.floating, x: r, y: i } : a.reference, k = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), _ = await (o.isElement == null ? void 0 : o.isElement(k)) && await (o.getScale == null ? void 0 : o.getScale(k)) || { x: 1, y: 1 }, E = B1(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: b, offsetParent: k, strategy: l }) : b);
  return { top: (v.top - E.top + p.top) / _.y, bottom: (E.bottom - v.bottom + p.bottom) / _.y, left: (v.left - E.left + p.left) / _.x, right: (E.right - v.right + p.right) / _.x };
}
const W1 = Math.min, Xr = Math.max;
function rv(t, e, n) {
  return Xr(t, W1(e, n));
}
const MD = ["top", "right", "bottom", "left"];
MD.reduce((t, e) => t.concat(e, e + "-start", e + "-end"), []);
const AD = { left: "right", right: "left", bottom: "top", top: "bottom" };
function $f(t) {
  return t.replace(/left|right|bottom|top/g, (e) => AD[e]);
}
function OD(t, e, n) {
  n === void 0 && (n = !1);
  const r = Ys(t), i = qs(t), o = s4(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (a = $f(a)), { main: a, cross: $f(a) };
}
const DD = { start: "end", end: "start" };
function ed(t) {
  return t.replace(/start|end/g, (e) => DD[e]);
}
const Is = function(t) {
  return t === void 0 && (t = {}), { name: "flip", options: t, async fn(e) {
    var n;
    const { placement: r, middlewareData: i, rects: o, initialPlacement: a, platform: s, elements: l } = e, { mainAxis: f = !0, crossAxis: c = !0, fallbackPlacements: u, fallbackStrategy: d = "bestFit", fallbackAxisSideDirection: h = "none", flipAlignment: p = !0, ...m } = t, v = Mr(r), b = Mr(a) === a, k = await (s.isRTL == null ? void 0 : s.isRTL(l.floating)), _ = u || (b || !p ? [$f(a)] : function(y) {
      const A = $f(y);
      return [ed(y), A, ed(A)];
    }(a));
    u || h === "none" || _.push(...function(y, A, z, F) {
      const P = Ys(y);
      let L = function(X, B, G) {
        const j = ["left", "right"], w = ["right", "left"], x = ["top", "bottom"], oe = ["bottom", "top"];
        switch (X) {
          case "top":
          case "bottom":
            return G ? B ? w : j : B ? j : w;
          case "left":
          case "right":
            return B ? x : oe;
          default:
            return [];
        }
      }(Mr(y), z === "start", F);
      return P && (L = L.map((X) => X + "-" + P), A && (L = L.concat(L.map(ed)))), L;
    }(a, p, h, k));
    const E = [a, ..._], S = await z0(e, m), C = [];
    let N = ((n = i.flip) == null ? void 0 : n.overflows) || [];
    if (f && C.push(S[v]), c) {
      const { main: y, cross: A } = OD(r, o, k);
      C.push(S[y], S[A]);
    }
    if (N = [...N, { placement: r, overflows: C }], !C.every((y) => y <= 0)) {
      var $, I;
      const y = ((($ = i.flip) == null ? void 0 : $.index) || 0) + 1, A = E[y];
      if (A)
        return { data: { index: y, overflows: N }, reset: { placement: A } };
      let z = (I = N.filter((F) => F.overflows[0] <= 0).sort((F, P) => F.overflows[1] - P.overflows[1])[0]) == null ? void 0 : I.placement;
      if (!z)
        switch (d) {
          case "bestFit": {
            var O;
            const F = (O = N.map((P) => [P.placement, P.overflows.filter((L) => L > 0).reduce((L, X) => L + X, 0)]).sort((P, L) => P[1] - L[1])[0]) == null ? void 0 : O[0];
            F && (z = F);
            break;
          }
          case "initialPlacement":
            z = a;
        }
      if (r !== z)
        return { reset: { placement: z } };
    }
    return {};
  } };
}, Lo = function(t) {
  return t === void 0 && (t = 0), { name: "offset", options: t, async fn(e) {
    const { x: n, y: r } = e, i = await async function(o, a) {
      const { placement: s, platform: l, elements: f } = o, c = await (l.isRTL == null ? void 0 : l.isRTL(f.floating)), u = Mr(s), d = Ys(s), h = qs(s) === "x", p = ["left", "top"].includes(u) ? -1 : 1, m = c && h ? -1 : 1, v = typeof a == "function" ? a(o) : a;
      let { mainAxis: b, crossAxis: k, alignmentAxis: _ } = typeof v == "number" ? { mainAxis: v, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...v };
      return d && typeof _ == "number" && (k = d === "end" ? -1 * _ : _), h ? { x: k * m, y: b * p } : { x: b * p, y: k * m };
    }(e, t);
    return { x: n + i.x, y: r + i.y, data: i };
  } };
};
function PD(t) {
  return t === "x" ? "y" : "x";
}
const Ff = function(t) {
  return t === void 0 && (t = {}), { name: "shift", options: t, async fn(e) {
    const { x: n, y: r, placement: i } = e, { mainAxis: o = !0, crossAxis: a = !1, limiter: s = { fn: (v) => {
      let { x: b, y: k } = v;
      return { x: b, y: k };
    } }, ...l } = t, f = { x: n, y: r }, c = await z0(e, l), u = qs(Mr(i)), d = PD(u);
    let h = f[u], p = f[d];
    if (o) {
      const v = u === "y" ? "bottom" : "right";
      h = rv(h + c[u === "y" ? "top" : "left"], h, h - c[v]);
    }
    if (a) {
      const v = d === "y" ? "bottom" : "right";
      p = rv(p + c[d === "y" ? "top" : "left"], p, p - c[v]);
    }
    const m = s.fn({ ...e, [u]: h, [d]: p });
    return { ...m, data: { x: m.x - n, y: m.y - r } };
  } };
}, U1 = function(t) {
  return t === void 0 && (t = {}), { name: "size", options: t, async fn(e) {
    const { placement: n, rects: r, platform: i, elements: o } = e, { apply: a = () => {
    }, ...s } = t, l = await z0(e, s), f = Mr(n), c = Ys(n), u = qs(n) === "x", { width: d, height: h } = r.floating;
    let p, m;
    f === "top" || f === "bottom" ? (p = f, m = c === (await (i.isRTL == null ? void 0 : i.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (m = f, p = c === "end" ? "top" : "bottom");
    const v = h - l[p], b = d - l[m];
    let k = v, _ = b;
    if (u ? _ = W1(d - l.right - l.left, b) : k = W1(h - l.bottom - l.top, v), !e.middlewareData.shift && !c) {
      const S = Xr(l.left, 0), C = Xr(l.right, 0), N = Xr(l.top, 0), $ = Xr(l.bottom, 0);
      u ? _ = d - 2 * (S !== 0 || C !== 0 ? S + C : Xr(l.left, l.right)) : k = h - 2 * (N !== 0 || $ !== 0 ? N + $ : Xr(l.top, l.bottom));
    }
    await a({ ...e, availableWidth: _, availableHeight: k });
    const E = await i.getDimensions(o.floating);
    return d !== E.width || h !== E.height ? { reset: { rects: !0 } } : {};
  } };
};
function tn(t) {
  var e;
  return ((e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Wn(t) {
  return tn(t).getComputedStyle(t);
}
const iv = Math.min, Xa = Math.max, jf = Math.round;
function l4(t) {
  const e = Wn(t);
  let n = parseFloat(e.width), r = parseFloat(e.height);
  const i = t.offsetWidth, o = t.offsetHeight, a = jf(n) !== i || jf(r) !== o;
  return a && (n = i, r = o), { width: n, height: r, fallback: a };
}
function zr(t) {
  return c4(t) ? (t.nodeName || "").toLowerCase() : "";
}
let hl;
function f4() {
  if (hl)
    return hl;
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? (hl = t.brands.map((e) => e.brand + "/" + e.version).join(" "), hl) : navigator.userAgent;
}
function Un(t) {
  return t instanceof tn(t).HTMLElement;
}
function Mn(t) {
  return t instanceof tn(t).Element;
}
function c4(t) {
  return t instanceof tn(t).Node;
}
function ov(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof tn(t).ShadowRoot || t instanceof ShadowRoot;
}
function Wc(t) {
  const { overflow: e, overflowX: n, overflowY: r, display: i } = Wn(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(i);
}
function RD(t) {
  return ["table", "td", "th"].includes(zr(t));
}
function H1(t) {
  const e = /firefox/i.test(f4()), n = Wn(t), r = n.backdropFilter || n.WebkitBackdropFilter;
  return n.transform !== "none" || n.perspective !== "none" || !!r && r !== "none" || e && n.willChange === "filter" || e && !!n.filter && n.filter !== "none" || ["transform", "perspective"].some((i) => n.willChange.includes(i)) || ["paint", "layout", "strict", "content"].some((i) => {
    const o = n.contain;
    return o != null && o.includes(i);
  });
}
function V1() {
  return /^((?!chrome|android).)*safari/i.test(f4());
}
function B0(t) {
  return ["html", "body", "#document"].includes(zr(t));
}
function u4(t) {
  return Mn(t) ? t : t.contextElement;
}
const d4 = { x: 1, y: 1 };
function yo(t) {
  const e = u4(t);
  if (!Un(e))
    return d4;
  const n = e.getBoundingClientRect(), { width: r, height: i, fallback: o } = l4(e);
  let a = (o ? jf(n.width) : n.width) / r, s = (o ? jf(n.height) : n.height) / i;
  return a && Number.isFinite(a) || (a = 1), s && Number.isFinite(s) || (s = 1), { x: a, y: s };
}
function Ei(t, e, n, r) {
  var i, o;
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const a = t.getBoundingClientRect(), s = u4(t);
  let l = d4;
  e && (r ? Mn(r) && (l = yo(r)) : l = yo(t));
  const f = s ? tn(s) : window, c = V1() && n;
  let u = (a.left + (c && ((i = f.visualViewport) == null ? void 0 : i.offsetLeft) || 0)) / l.x, d = (a.top + (c && ((o = f.visualViewport) == null ? void 0 : o.offsetTop) || 0)) / l.y, h = a.width / l.x, p = a.height / l.y;
  if (s) {
    const m = tn(s), v = r && Mn(r) ? tn(r) : r;
    let b = m.frameElement;
    for (; b && r && v !== m; ) {
      const k = yo(b), _ = b.getBoundingClientRect(), E = getComputedStyle(b);
      _.x += (b.clientLeft + parseFloat(E.paddingLeft)) * k.x, _.y += (b.clientTop + parseFloat(E.paddingTop)) * k.y, u *= k.x, d *= k.y, h *= k.x, p *= k.y, u += _.x, d += _.y, b = tn(b).frameElement;
    }
  }
  return { width: h, height: p, top: d, right: u + h, bottom: d + p, left: u, x: u, y: d };
}
function Ar(t) {
  return ((c4(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function Uc(t) {
  return Mn(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function h4(t) {
  return Ei(Ar(t)).left + Uc(t).scrollLeft;
}
function Ns(t) {
  if (zr(t) === "html")
    return t;
  const e = t.assignedSlot || t.parentNode || ov(t) && t.host || Ar(t);
  return ov(e) ? e.host : e;
}
function g4(t) {
  const e = Ns(t);
  return B0(e) ? e.ownerDocument.body : Un(e) && Wc(e) ? e : g4(e);
}
function Or(t, e) {
  var n;
  e === void 0 && (e = []);
  const r = g4(t), i = r === ((n = t.ownerDocument) == null ? void 0 : n.body), o = tn(r);
  return i ? e.concat(o, o.visualViewport || [], Wc(r) ? r : []) : e.concat(r, Or(r));
}
function av(t, e, n) {
  let r;
  if (e === "viewport")
    r = function(a, s) {
      const l = tn(a), f = Ar(a), c = l.visualViewport;
      let u = f.clientWidth, d = f.clientHeight, h = 0, p = 0;
      if (c) {
        u = c.width, d = c.height;
        const m = V1();
        (!m || m && s === "fixed") && (h = c.offsetLeft, p = c.offsetTop);
      }
      return { width: u, height: d, x: h, y: p };
    }(t, n);
  else if (e === "document")
    r = function(a) {
      const s = Ar(a), l = Uc(a), f = a.ownerDocument.body, c = Xa(s.scrollWidth, s.clientWidth, f.scrollWidth, f.clientWidth), u = Xa(s.scrollHeight, s.clientHeight, f.scrollHeight, f.clientHeight);
      let d = -l.scrollLeft + h4(a);
      const h = -l.scrollTop;
      return Wn(f).direction === "rtl" && (d += Xa(s.clientWidth, f.clientWidth) - c), { width: c, height: u, x: d, y: h };
    }(Ar(t));
  else if (Mn(e))
    r = function(a, s) {
      const l = Ei(a, !0, s === "fixed"), f = l.top + a.clientTop, c = l.left + a.clientLeft, u = Un(a) ? yo(a) : { x: 1, y: 1 };
      return { width: a.clientWidth * u.x, height: a.clientHeight * u.y, x: c * u.x, y: f * u.y };
    }(e, n);
  else {
    const a = { ...e };
    if (V1()) {
      var i, o;
      const s = tn(t);
      a.x -= ((i = s.visualViewport) == null ? void 0 : i.offsetLeft) || 0, a.y -= ((o = s.visualViewport) == null ? void 0 : o.offsetTop) || 0;
    }
    r = a;
  }
  return B1(r);
}
function sv(t, e) {
  return Un(t) && Wn(t).position !== "fixed" ? e ? e(t) : t.offsetParent : null;
}
function lv(t, e) {
  const n = tn(t);
  let r = sv(t, e);
  for (; r && RD(r) && Wn(r).position === "static"; )
    r = sv(r, e);
  return r && (zr(r) === "html" || zr(r) === "body" && Wn(r).position === "static" && !H1(r)) ? n : r || function(i) {
    let o = Ns(i);
    for (; Un(o) && !B0(o); ) {
      if (H1(o))
        return o;
      o = Ns(o);
    }
    return null;
  }(t) || n;
}
function LD(t, e, n) {
  const r = Un(e), i = Ar(e), o = Ei(t, !0, n === "fixed", e);
  let a = { scrollLeft: 0, scrollTop: 0 };
  const s = { x: 0, y: 0 };
  if (r || !r && n !== "fixed")
    if ((zr(e) !== "body" || Wc(i)) && (a = Uc(e)), Un(e)) {
      const l = Ei(e, !0);
      s.x = l.x + e.clientLeft, s.y = l.y + e.clientTop;
    } else
      i && (s.x = h4(i));
  return { x: o.left + a.scrollLeft - s.x, y: o.top + a.scrollTop - s.y, width: o.width, height: o.height };
}
const $D = { getClippingRect: function(t) {
  let { element: e, boundary: n, rootBoundary: r, strategy: i } = t;
  const o = n === "clippingAncestors" ? function(f, c) {
    const u = c.get(f);
    if (u)
      return u;
    let d = Or(f).filter((v) => Mn(v) && zr(v) !== "body"), h = null;
    const p = Wn(f).position === "fixed";
    let m = p ? Ns(f) : f;
    for (; Mn(m) && !B0(m); ) {
      const v = Wn(m), b = H1(m);
      v.position === "fixed" ? h = null : (p ? b || h : b || v.position !== "static" || !h || !["absolute", "fixed"].includes(h.position)) ? h = v : d = d.filter((k) => k !== m), m = Ns(m);
    }
    return c.set(f, d), d;
  }(e, this._c) : [].concat(n), a = [...o, r], s = a[0], l = a.reduce((f, c) => {
    const u = av(e, c, i);
    return f.top = Xa(u.top, f.top), f.right = iv(u.right, f.right), f.bottom = iv(u.bottom, f.bottom), f.left = Xa(u.left, f.left), f;
  }, av(e, s, i));
  return { width: l.right - l.left, height: l.bottom - l.top, x: l.left, y: l.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  let { rect: e, offsetParent: n, strategy: r } = t;
  const i = Un(n), o = Ar(n);
  if (n === o)
    return e;
  let a = { scrollLeft: 0, scrollTop: 0 }, s = { x: 1, y: 1 };
  const l = { x: 0, y: 0 };
  if ((i || !i && r !== "fixed") && ((zr(n) !== "body" || Wc(o)) && (a = Uc(n)), Un(n))) {
    const f = Ei(n);
    s = yo(n), l.x = f.x + n.clientLeft, l.y = f.y + n.clientTop;
  }
  return { width: e.width * s.x, height: e.height * s.y, x: e.x * s.x - a.scrollLeft * s.x + l.x, y: e.y * s.y - a.scrollTop * s.y + l.y };
}, isElement: Mn, getDimensions: function(t) {
  return Un(t) ? l4(t) : t.getBoundingClientRect();
}, getOffsetParent: lv, getDocumentElement: Ar, getScale: yo, async getElementRects(t) {
  let { reference: e, floating: n, strategy: r } = t;
  const i = this.getOffsetParent || lv, o = this.getDimensions;
  return { reference: LD(e, await i(n), r), floating: { x: 0, y: 0, ...await o(n) } };
}, getClientRects: (t) => Array.from(t.getClientRects()), isRTL: (t) => Wn(t).direction === "rtl" };
function $o(t, e, n, r) {
  r === void 0 && (r = {});
  const { ancestorScroll: i = !0, ancestorResize: o = !0, elementResize: a = !0, animationFrame: s = !1 } = r, l = i && !s, f = l || o ? [...Mn(t) ? Or(t) : t.contextElement ? Or(t.contextElement) : [], ...Or(e)] : [];
  f.forEach((h) => {
    l && h.addEventListener("scroll", n, { passive: !0 }), o && h.addEventListener("resize", n);
  });
  let c, u = null;
  if (a) {
    let h = !0;
    u = new ResizeObserver(() => {
      h || n(), h = !1;
    }), Mn(t) && !s && u.observe(t), Mn(t) || !t.contextElement || s || u.observe(t.contextElement), u.observe(e);
  }
  let d = s ? Ei(t) : null;
  return s && function h() {
    const p = Ei(t);
    !d || p.x === d.x && p.y === d.y && p.width === d.width && p.height === d.height || n(), d = p, c = requestAnimationFrame(h);
  }(), n(), () => {
    var h;
    f.forEach((p) => {
      l && p.removeEventListener("scroll", n), o && p.removeEventListener("resize", n);
    }), (h = u) == null || h.disconnect(), u = null, s && cancelAnimationFrame(c);
  };
}
const FD = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = { platform: $D, ...n }, o = { ...i.platform, _c: r };
  return ID(t, e, { ...i, platform: o });
};
var Rl = typeof document < "u" ? Ds : ce;
function zf(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, r, i;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!zf(t[r], e[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && t.$$typeof) && !zf(t[o], e[o]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function fv(t) {
  const e = T.useRef(t);
  return Rl(() => {
    e.current = t;
  }), e;
}
function jD(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    whileElementsMounted: o,
    open: a
  } = t, [s, l] = T.useState({
    x: null,
    y: null,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, c] = T.useState(r);
  zf(f, r) || c(r);
  const u = T.useRef(null), d = T.useRef(null), h = T.useRef(s), p = fv(o), m = fv(i), [v, b] = T.useState(null), [k, _] = T.useState(null), E = T.useCallback((O) => {
    u.current !== O && (u.current = O, b(O));
  }, []), S = T.useCallback((O) => {
    d.current !== O && (d.current = O, _(O));
  }, []), C = T.useCallback(() => {
    if (!u.current || !d.current)
      return;
    const O = {
      placement: e,
      strategy: n,
      middleware: f
    };
    m.current && (O.platform = m.current), FD(u.current, d.current, O).then((y) => {
      const A = {
        ...y,
        isPositioned: !0
      };
      N.current && !zf(h.current, A) && (h.current = A, LC.flushSync(() => {
        l(A);
      }));
    });
  }, [f, e, n, m]);
  Rl(() => {
    a === !1 && h.current.isPositioned && (h.current.isPositioned = !1, l((O) => ({
      ...O,
      isPositioned: !1
    })));
  }, [a]);
  const N = T.useRef(!1);
  Rl(() => (N.current = !0, () => {
    N.current = !1;
  }), []), Rl(() => {
    if (v && k) {
      if (p.current)
        return p.current(v, k, C);
      C();
    }
  }, [v, k, C, p]);
  const $ = T.useMemo(() => ({
    reference: u,
    floating: d,
    setReference: E,
    setFloating: S
  }), [E, S]), I = T.useMemo(() => ({
    reference: v,
    floating: k
  }), [v, k]);
  return T.useMemo(() => ({
    ...s,
    update: C,
    refs: $,
    elements: I,
    reference: E,
    floating: S
  }), [s, C, $, I, E, S]);
}
var ot = typeof document < "u" ? Ds : ce;
let td = !1, zD = 0;
const cv = () => "floating-ui-" + zD++;
function BD() {
  const [t, e] = T.useState(() => td ? cv() : void 0);
  return ot(() => {
    t == null && e(cv());
  }, []), T.useEffect(() => {
    td || (td = !0);
  }, []), t;
}
const WD = T[/* @__PURE__ */ "useId".toString()], Bf = WD || BD;
function p4() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, n) {
      var r;
      (r = t.get(e)) == null || r.forEach((i) => i(n));
    },
    on(e, n) {
      t.set(e, [...t.get(e) || [], n]);
    },
    off(e, n) {
      t.set(e, (t.get(e) || []).filter((r) => r !== n));
    }
  };
}
const m4 = /* @__PURE__ */ T.createContext(null), v4 = /* @__PURE__ */ T.createContext(null), Li = () => {
  var t;
  return ((t = T.useContext(m4)) == null ? void 0 : t.id) || null;
}, $i = () => T.useContext(v4), Hc = (t) => {
  const e = Bf(), n = $i(), r = Li(), i = t || r;
  return ot(() => {
    const o = {
      id: e,
      parentId: i
    };
    return n == null || n.addNode(o), () => {
      n == null || n.removeNode(o);
    };
  }, [n, e, i]), e;
}, W0 = (t) => {
  let {
    children: e,
    id: n
  } = t;
  const r = Li();
  return /* @__PURE__ */ g(m4.Provider, {
    value: T.useMemo(() => ({
      id: n,
      parentId: r
    }), [n, r]),
    children: e
  });
}, b4 = (t) => {
  let {
    children: e
  } = t;
  const n = T.useRef([]), r = T.useCallback((a) => {
    n.current = [...n.current, a];
  }, []), i = T.useCallback((a) => {
    n.current = n.current.filter((s) => s !== a);
  }, []), o = T.useState(() => p4())[0];
  return /* @__PURE__ */ g(v4.Provider, {
    value: T.useMemo(() => ({
      nodesRef: n,
      addNode: r,
      removeNode: i,
      events: o
    }), [n, r, i, o]),
    children: e
  });
};
function Ht(t) {
  return (t == null ? void 0 : t.ownerDocument) || document;
}
function U0() {
  const t = navigator.userAgentData;
  return t != null && t.platform ? t.platform : navigator.platform;
}
function UD() {
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map((e) => {
    let {
      brand: n,
      version: r
    } = e;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function H0(t) {
  return Ht(t).defaultView || window;
}
function cn(t) {
  return t ? t instanceof H0(t).Element : !1;
}
function Ti(t) {
  return t ? t instanceof H0(t).HTMLElement : !1;
}
function HD(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  const e = H0(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function y4(t) {
  if (t.mozInputSource === 0 && t.isTrusted)
    return !0;
  const e = /Android/i;
  return (e.test(U0()) || e.test(UD())) && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function _4(t) {
  return t.width === 0 && t.height === 0 || t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0;
}
function K1() {
  return /apple/i.test(navigator.vendor);
}
function w4() {
  return U0().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Wf(t, e) {
  const n = ["mouse", "pen"];
  return e || n.push("", void 0), n.includes(t);
}
function Dr(t) {
  const e = vt(t);
  return ot(() => {
    e.current = t;
  }), e;
}
const uv = "data-floating-ui-safe-polygon";
function nd(t, e, n) {
  return n && !Wf(n) ? 0 : typeof t == "number" ? t : t == null ? void 0 : t[e];
}
const k4 = function(t, e) {
  let {
    enabled: n = !0,
    delay: r = 0,
    handleClose: i = null,
    mouseOnly: o = !1,
    restMs: a = 0,
    move: s = !0
  } = e === void 0 ? {} : e;
  const {
    open: l,
    onOpenChange: f,
    dataRef: c,
    events: u,
    elements: {
      domReference: d,
      floating: h
    },
    refs: p
  } = t, m = $i(), v = Li(), b = Dr(i), k = Dr(r), _ = T.useRef(), E = T.useRef(), S = T.useRef(), C = T.useRef(), N = T.useRef(!0), $ = T.useRef(!1), I = T.useRef(() => {
  }), O = T.useCallback(() => {
    var F;
    const P = (F = c.current.openEvent) == null ? void 0 : F.type;
    return (P == null ? void 0 : P.includes("mouse")) && P !== "mousedown";
  }, [c]);
  T.useEffect(() => {
    if (!n)
      return;
    function F() {
      clearTimeout(E.current), clearTimeout(C.current), N.current = !0;
    }
    return u.on("dismiss", F), () => {
      u.off("dismiss", F);
    };
  }, [n, u]), T.useEffect(() => {
    if (!n || !b.current || !l)
      return;
    function F() {
      O() && f(!1);
    }
    const P = Ht(h).documentElement;
    return P.addEventListener("mouseleave", F), () => {
      P.removeEventListener("mouseleave", F);
    };
  }, [h, l, f, n, b, c, O]);
  const y = T.useCallback(function(F) {
    F === void 0 && (F = !0);
    const P = nd(k.current, "close", _.current);
    P && !S.current ? (clearTimeout(E.current), E.current = setTimeout(() => f(!1), P)) : F && (clearTimeout(E.current), f(!1));
  }, [k, f]), A = T.useCallback(() => {
    I.current(), S.current = void 0;
  }, []), z = T.useCallback(() => {
    if ($.current) {
      const F = Ht(p.floating.current).body;
      F.style.pointerEvents = "", F.removeAttribute(uv), $.current = !1;
    }
  }, [p]);
  return T.useEffect(() => {
    if (!n)
      return;
    function F() {
      return c.current.openEvent ? ["click", "mousedown"].includes(c.current.openEvent.type) : !1;
    }
    function P(B) {
      if (clearTimeout(E.current), N.current = !1, o && !Wf(_.current) || a > 0 && nd(k.current, "open") === 0)
        return;
      c.current.openEvent = B;
      const G = nd(k.current, "open", _.current);
      G ? E.current = setTimeout(() => {
        f(!0);
      }, G) : f(!0);
    }
    function L(B) {
      if (F())
        return;
      I.current();
      const G = Ht(h);
      if (clearTimeout(C.current), b.current) {
        l || clearTimeout(E.current), S.current = b.current({
          ...t,
          tree: m,
          x: B.clientX,
          y: B.clientY,
          onClose() {
            z(), A(), y();
          }
        });
        const j = S.current;
        G.addEventListener("mousemove", j), I.current = () => {
          G.removeEventListener("mousemove", j);
        };
        return;
      }
      y();
    }
    function X(B) {
      F() || b.current == null || b.current({
        ...t,
        tree: m,
        x: B.clientX,
        y: B.clientY,
        onClose() {
          z(), A(), y();
        }
      })(B);
    }
    if (cn(d)) {
      const B = d;
      return l && B.addEventListener("mouseleave", X), h == null || h.addEventListener("mouseleave", X), s && B.addEventListener("mousemove", P, {
        once: !0
      }), B.addEventListener("mouseenter", P), B.addEventListener("mouseleave", L), () => {
        l && B.removeEventListener("mouseleave", X), h == null || h.removeEventListener("mouseleave", X), s && B.removeEventListener("mousemove", P), B.removeEventListener("mouseenter", P), B.removeEventListener("mouseleave", L);
      };
    }
  }, [d, h, n, t, o, a, s, y, A, z, f, l, m, k, b, c]), ot(() => {
    var F;
    if (n && l && (F = b.current) != null && F.__options.blockPointerEvents && O()) {
      const X = Ht(h).body;
      if (X.setAttribute(uv, ""), X.style.pointerEvents = "none", $.current = !0, cn(d) && h) {
        var P, L;
        const B = d, G = m == null || (P = m.nodesRef.current.find((j) => j.id === v)) == null || (L = P.context) == null ? void 0 : L.elements.floating;
        return G && (G.style.pointerEvents = ""), B.style.pointerEvents = "auto", h.style.pointerEvents = "auto", () => {
          B.style.pointerEvents = "", h.style.pointerEvents = "";
        };
      }
    }
  }, [n, l, v, h, d, m, b, c, O]), ot(() => {
    l || (_.current = void 0, A(), z());
  }, [l, A, z]), T.useEffect(() => () => {
    A(), clearTimeout(E.current), clearTimeout(C.current), z();
  }, [n, A, z]), T.useMemo(() => {
    if (!n)
      return {};
    function F(P) {
      _.current = P.pointerType;
    }
    return {
      reference: {
        onPointerDown: F,
        onPointerEnter: F,
        onMouseMove() {
          l || a === 0 || (clearTimeout(C.current), C.current = setTimeout(() => {
            N.current || f(!0);
          }, a));
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(E.current);
        },
        onMouseLeave() {
          u.emit("dismiss", {
            type: "mouseLeave",
            data: {
              returnFocus: !1
            }
          }), y(!1);
        }
      }
    };
  }, [u, n, a, l, f, y]);
};
function Si(t) {
  let e = t.activeElement;
  for (; ((n = e) == null || (r = n.shadowRoot) == null ? void 0 : r.activeElement) != null; ) {
    var n, r;
    e = e.shadowRoot.activeElement;
  }
  return e;
}
function jt(t, e) {
  if (!t || !e)
    return !1;
  const n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && HD(n)) {
    let r = e;
    do {
      if (r && t === r)
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
let dv = 0;
function yr(t, e) {
  e === void 0 && (e = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: i = !1
  } = e;
  r && cancelAnimationFrame(dv);
  const o = () => t == null ? void 0 : t.focus({
    preventScroll: n
  });
  i ? o() : dv = requestAnimationFrame(o);
}
function VD(t, e) {
  var n;
  let r = [], i = (n = t.find((o) => o.id === e)) == null ? void 0 : n.parentId;
  for (; i; ) {
    const o = t.find((a) => a.id === i);
    i = o == null ? void 0 : o.parentId, o && (r = r.concat(o));
  }
  return r;
}
function Ja(t, e) {
  let n = t.filter((i) => {
    var o;
    return i.parentId === e && ((o = i.context) == null ? void 0 : o.open);
  }) || [], r = n;
  for (; r.length; )
    r = t.filter((i) => {
      var o;
      return (o = r) == null ? void 0 : o.some((a) => {
        var s;
        return i.parentId === a.id && ((s = i.context) == null ? void 0 : s.open);
      });
    }) || [], n = n.concat(r);
  return n;
}
function Vc(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
const KD = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function C4(t) {
  return Ti(t) && t.matches(KD);
}
function on(t) {
  t.preventDefault(), t.stopPropagation();
}
const Uf = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function x4(t, e) {
  const n = Lf(t, Uf());
  e === "prev" && n.reverse();
  const r = n.indexOf(Si(Ht(t)));
  return n.slice(r + 1)[0];
}
function E4() {
  return x4(document.body, "next");
}
function T4() {
  return x4(document.body, "prev");
}
function Za(t, e) {
  const n = e || t.currentTarget, r = t.relatedTarget;
  return !r || !jt(n, r);
}
function YD(t) {
  Lf(t, Uf()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function qD(t) {
  t.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const GD = T[/* @__PURE__ */ "useInsertionEffect".toString()], QD = GD || ((t) => t());
function Gs(t) {
  const e = T.useRef(() => {
  });
  return QD(() => {
    e.current = t;
  }), T.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return e.current == null ? void 0 : e.current(...r);
  }, []);
}
const V0 = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let Y1, K0;
function hv(t) {
  t.key === "Tab" && (Y1 = t.target, clearTimeout(K0));
}
function XD(t) {
  const e = Y1 === t.relatedTarget;
  return Y1 = t.relatedTarget, clearTimeout(K0), e;
}
const Hf = /* @__PURE__ */ T.forwardRef(function(e, n) {
  const r = Gs(e.onFocus), [i, o] = T.useState();
  return ot(() => (K1() && o("button"), document.addEventListener("keydown", hv), () => {
    document.removeEventListener("keydown", hv);
  }), []), /* @__PURE__ */ g("span", {
    ...e,
    ref: n,
    tabIndex: 0,
    role: i,
    "aria-hidden": i ? void 0 : !0,
    "data-floating-ui-focus-guard": "",
    style: V0,
    onFocus: (a) => {
      K1() && w4() && !XD(a) ? (a.persist(), K0 = window.setTimeout(() => {
        r(a);
      }, 50)) : r(a);
    }
  });
}), S4 = /* @__PURE__ */ T.createContext(null), JD = function(t) {
  let {
    id: e,
    enabled: n = !0
  } = t === void 0 ? {} : t;
  const [r, i] = T.useState(null), o = Bf(), a = I4();
  return ot(() => {
    if (!n)
      return;
    const s = e ? document.getElementById(e) : null;
    if (s)
      s.setAttribute("data-floating-ui-portal", ""), i(s);
    else {
      const l = document.createElement("div");
      e !== "" && (l.id = e || o), l.setAttribute("data-floating-ui-portal", ""), i(l);
      const f = (a == null ? void 0 : a.portalNode) || document.body;
      return f.appendChild(l), () => {
        f.removeChild(l);
      };
    }
  }, [e, a, o, n]), r;
}, ea = (t) => {
  let {
    children: e,
    id: n,
    root: r = null,
    preserveTabOrder: i = !0
  } = t;
  const o = JD({
    id: n,
    enabled: !r
  }), [a, s] = T.useState(null), l = T.useRef(null), f = T.useRef(null), c = T.useRef(null), u = T.useRef(null), d = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!a && // Guards are only for non-modal focus management.
    !a.modal && !!(r || o) && i
  );
  return T.useEffect(() => {
    if (!o || !i || a != null && a.modal)
      return;
    function h(p) {
      o && Za(p) && (p.type === "focusin" ? qD : YD)(o);
    }
    return o.addEventListener("focusin", h, !0), o.addEventListener("focusout", h, !0), () => {
      o.removeEventListener("focusin", h, !0), o.removeEventListener("focusout", h, !0);
    };
  }, [o, i, a == null ? void 0 : a.modal]), /* @__PURE__ */ D(S4.Provider, {
    value: T.useMemo(() => ({
      preserveTabOrder: i,
      beforeOutsideRef: l,
      afterOutsideRef: f,
      beforeInsideRef: c,
      afterInsideRef: u,
      portalNode: o,
      setFocusManagerState: s
    }), [i, o]),
    children: [d && o && /* @__PURE__ */ g(Hf, {
      "data-type": "outside",
      ref: l,
      onFocus: (h) => {
        if (Za(h, o)) {
          var p;
          (p = c.current) == null || p.focus();
        } else {
          const m = T4() || (a == null ? void 0 : a.refs.domReference.current);
          m == null || m.focus();
        }
      }
    }), d && o && /* @__PURE__ */ g("span", {
      "aria-owns": o.id,
      style: V0
    }), r ? /* @__PURE__ */ Wg(e, r) : o ? /* @__PURE__ */ Wg(e, o) : null, d && o && /* @__PURE__ */ g(Hf, {
      "data-type": "outside",
      ref: f,
      onFocus: (h) => {
        if (Za(h, o)) {
          var p;
          (p = u.current) == null || p.focus();
        } else {
          const m = E4() || (a == null ? void 0 : a.refs.domReference.current);
          m == null || m.focus(), a != null && a.closeOnFocusOut && (a == null || a.onOpenChange(!1));
        }
      }
    })]
  });
}, I4 = () => T.useContext(S4), ZD = /* @__PURE__ */ T.forwardRef(function(e, n) {
  return /* @__PURE__ */ g("button", {
    ...e,
    type: "button",
    ref: n,
    tabIndex: -1,
    style: V0
  });
});
function eP(t) {
  let {
    context: e,
    children: n,
    order: r = ["content"],
    guards: i = !0,
    initialFocus: o = 0,
    returnFocus: a = !0,
    modal: s = !0,
    visuallyHiddenDismiss: l = !1,
    closeOnFocusOut: f = !0
  } = t;
  const {
    refs: c,
    nodeId: u,
    onOpenChange: d,
    events: h,
    dataRef: p,
    elements: {
      domReference: m,
      floating: v
    }
  } = e, b = Dr(r), k = $i(), _ = I4(), [E, S] = T.useState(null), C = typeof o == "number" && o < 0, N = T.useRef(null), $ = T.useRef(null), I = T.useRef(!1), O = T.useRef(null), y = T.useRef(!1), A = _ != null, z = m && m.getAttribute("role") === "combobox" && C4(m), F = T.useCallback(function(B) {
    return B === void 0 && (B = v), B ? Lf(B, Uf()) : [];
  }, [v]), P = T.useCallback((B) => {
    const G = F(B);
    return b.current.map((j) => m && j === "reference" ? m : v && j === "floating" ? v : G).filter(Boolean).flat();
  }, [m, v, b, F]);
  T.useEffect(() => {
    if (!s)
      return;
    function B(j) {
      if (j.key === "Tab") {
        F().length === 0 && !z && on(j);
        const w = P(), x = Vc(j);
        b.current[0] === "reference" && x === m && (on(j), j.shiftKey ? yr(w[w.length - 1]) : yr(w[1])), b.current[1] === "floating" && x === v && j.shiftKey && (on(j), yr(w[0]));
      }
    }
    const G = Ht(v);
    return G.addEventListener("keydown", B), () => {
      G.removeEventListener("keydown", B);
    };
  }, [m, v, s, b, c, z, F, P]), T.useEffect(() => {
    if (!f)
      return;
    function B() {
      y.current = !0, setTimeout(() => {
        y.current = !1;
      });
    }
    function G(j) {
      const w = j.relatedTarget, x = !(jt(m, w) || jt(v, w) || jt(w, v) || jt(_ == null ? void 0 : _.portalNode, w) || w != null && w.hasAttribute("data-floating-ui-focus-guard") || k && (Ja(k.nodesRef.current, u).find((oe) => {
        var Me, Ae;
        return jt((Me = oe.context) == null ? void 0 : Me.elements.floating, w) || jt((Ae = oe.context) == null ? void 0 : Ae.elements.domReference, w);
      }) || VD(k.nodesRef.current, u).find((oe) => {
        var Me, Ae;
        return ((Me = oe.context) == null ? void 0 : Me.elements.floating) === w || ((Ae = oe.context) == null ? void 0 : Ae.elements.domReference) === w;
      })));
      w && x && !y.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
      w !== O.current && (I.current = !0, setTimeout(() => d(!1)));
    }
    if (v && Ti(m))
      return m.addEventListener("focusout", G), m.addEventListener("pointerdown", B), !s && v.addEventListener("focusout", G), () => {
        m.removeEventListener("focusout", G), m.removeEventListener("pointerdown", B), !s && v.removeEventListener("focusout", G);
      };
  }, [m, v, s, u, k, _, d, f]), T.useEffect(() => {
    var B;
    const G = Array.from((_ == null || (B = _.portalNode) == null ? void 0 : B.querySelectorAll("[data-floating-ui-portal]")) || []);
    function j() {
      return [N.current, $.current].filter(Boolean);
    }
    if (v && s) {
      const w = [v, ...G, ...j()], x = uD(b.current.includes("reference") || z ? w.concat(m || []) : w);
      return () => {
        x();
      };
    }
  }, [m, v, s, b, _, z]), T.useEffect(() => {
    if (s && !i && v) {
      const B = [], G = Uf(), j = Lf(Ht(v).body, G), w = P(), x = j.filter((oe) => !w.includes(oe));
      return x.forEach((oe, Me) => {
        B[Me] = oe.getAttribute("tabindex"), oe.setAttribute("tabindex", "-1");
      }), () => {
        x.forEach((oe, Me) => {
          const Ae = B[Me];
          Ae == null ? oe.removeAttribute("tabindex") : oe.setAttribute("tabindex", Ae);
        });
      };
    }
  }, [v, s, i, P]), ot(() => {
    if (!v)
      return;
    const B = Ht(v);
    let G = a, j = !1;
    const w = Si(B), x = p.current;
    O.current = w;
    const oe = P(v), Me = (typeof o == "number" ? oe[o] : o.current) || v;
    !C && yr(Me, {
      preventScroll: Me === v
    });
    function Ae(te) {
      if (te.type === "escapeKey" && c.domReference.current && (O.current = c.domReference.current), ["referencePress", "escapeKey"].includes(te.type))
        return;
      const Ve = te.data.returnFocus;
      typeof Ve == "object" ? (G = !0, j = Ve.preventScroll) : G = Ve;
    }
    return h.on("dismiss", Ae), () => {
      if (h.off("dismiss", Ae), jt(v, Si(B)) && c.domReference.current && (O.current = c.domReference.current), G && Ti(O.current) && !I.current)
        if (!c.domReference.current || y.current)
          yr(O.current, {
            // When dismissing nested floating elements, by the time the rAF has
            // executed, the menus will all have been unmounted. When they try
            // to get focused, the calls get ignored — leaving the root
            // reference focused as desired.
            cancelPrevious: !1,
            preventScroll: j
          });
        else {
          var te;
          x.__syncReturnFocus = !0, (te = O.current) == null || te.focus({
            preventScroll: j
          }), setTimeout(() => {
            delete x.__syncReturnFocus;
          });
        }
    };
  }, [v, P, o, a, p, c, h, C]), ot(() => {
    if (_)
      return _.setFocusManagerState({
        ...e,
        modal: s,
        closeOnFocusOut: f
        // Not concerned about the <RT> generic type.
      }), () => {
        _.setFocusManagerState(null);
      };
  }, [_, s, f, e]), ot(() => {
    if (C || !v)
      return;
    function B() {
      S(F().length);
    }
    if (B(), typeof MutationObserver == "function") {
      const G = new MutationObserver(B);
      return G.observe(v, {
        childList: !0,
        subtree: !0
      }), () => {
        G.disconnect();
      };
    }
  }, [v, F, C, c]);
  const L = i && (A || s) && !z;
  function X(B) {
    return l && s ? /* @__PURE__ */ g(ZD, {
      ref: B === "start" ? N : $,
      onClick: () => d(!1),
      children: typeof l == "string" ? l : "Dismiss"
    }) : null;
  }
  return /* @__PURE__ */ D(K, {
    children: [L && /* @__PURE__ */ g(Hf, {
      "data-type": "inside",
      ref: _ == null ? void 0 : _.beforeInsideRef,
      onFocus: (B) => {
        if (s) {
          const j = P();
          yr(r[0] === "reference" ? j[0] : j[j.length - 1]);
        } else if (_ != null && _.preserveTabOrder && _.portalNode)
          if (I.current = !1, Za(B, _.portalNode)) {
            const j = E4() || m;
            j == null || j.focus();
          } else {
            var G;
            (G = _.beforeOutsideRef.current) == null || G.focus();
          }
      }
    }), z ? null : X("start"), /* @__PURE__ */ T.cloneElement(n, E === 0 || r.includes("floating") ? {
      tabIndex: 0
    } : {}), X("end"), L && /* @__PURE__ */ g(Hf, {
      "data-type": "inside",
      ref: _ == null ? void 0 : _.afterInsideRef,
      onFocus: (B) => {
        if (s)
          yr(P()[0]);
        else if (_ != null && _.preserveTabOrder && _.portalNode)
          if (I.current = !0, Za(B, _.portalNode)) {
            const j = T4() || m;
            j == null || j.focus();
          } else {
            var G;
            (G = _.afterOutsideRef.current) == null || G.focus();
          }
      }
    })]
  });
}
const gl = "data-floating-ui-scroll-lock", tP = /* @__PURE__ */ T.forwardRef(function(e, n) {
  let {
    lockScroll: r = !1,
    ...i
  } = e;
  return ot(() => {
    var o, a;
    if (!r || document.body.hasAttribute(gl))
      return;
    document.body.setAttribute(gl, "");
    const f = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft ? "paddingLeft" : "paddingRight", c = window.innerWidth - document.documentElement.clientWidth;
    if (!/iP(hone|ad|od)|iOS/.test(U0()))
      return Object.assign(document.body.style, {
        overflow: "hidden",
        [f]: c + "px"
      }), () => {
        document.body.removeAttribute(gl), Object.assign(document.body.style, {
          overflow: "",
          [f]: ""
        });
      };
    const u = ((o = window.visualViewport) == null ? void 0 : o.offsetLeft) || 0, d = ((a = window.visualViewport) == null ? void 0 : a.offsetTop) || 0, h = window.pageXOffset, p = window.pageYOffset;
    return Object.assign(document.body.style, {
      position: "fixed",
      overflow: "hidden",
      top: -(p - Math.floor(d)) + "px",
      left: -(h - Math.floor(u)) + "px",
      right: "0",
      [f]: c + "px"
    }), () => {
      Object.assign(document.body.style, {
        position: "",
        overflow: "",
        top: "",
        left: "",
        right: "",
        [f]: ""
      }), document.body.removeAttribute(gl), window.scrollTo(h, p);
    };
  }, [r]), /* @__PURE__ */ g("div", {
    ref: n,
    ...i,
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...i.style
    }
  });
});
function gv(t) {
  return Ti(t.target) && t.target.tagName === "BUTTON";
}
function pv(t) {
  return C4(t);
}
const N4 = function(t, e) {
  let {
    open: n,
    onOpenChange: r,
    dataRef: i,
    elements: {
      domReference: o
    }
  } = t, {
    enabled: a = !0,
    event: s = "click",
    toggle: l = !0,
    ignoreMouse: f = !1,
    keyboardHandlers: c = !0
  } = e === void 0 ? {} : e;
  const u = T.useRef();
  return T.useMemo(() => a ? {
    reference: {
      onPointerDown(d) {
        u.current = d.pointerType;
      },
      onMouseDown(d) {
        d.button === 0 && (Wf(u.current, !0) && f || s !== "click" && (n ? l && (!i.current.openEvent || i.current.openEvent.type === "mousedown") && r(!1) : (d.preventDefault(), r(!0)), i.current.openEvent = d.nativeEvent));
      },
      onClick(d) {
        if (!i.current.__syncReturnFocus) {
          if (s === "mousedown" && u.current) {
            u.current = void 0;
            return;
          }
          Wf(u.current, !0) && f || (n ? l && (!i.current.openEvent || i.current.openEvent.type === "click") && r(!1) : r(!0), i.current.openEvent = d.nativeEvent);
        }
      },
      onKeyDown(d) {
        u.current = void 0, c && (gv(d) || (d.key === " " && !pv(o) && d.preventDefault(), d.key === "Enter" && (n ? l && r(!1) : r(!0))));
      },
      onKeyUp(d) {
        c && (gv(d) || pv(o) || d.key === " " && (n ? l && r(!1) : r(!0)));
      }
    }
  } : {}, [a, i, s, f, c, o, l, n, r]);
};
function Ll(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const n = t;
  return n.target != null && e.contains(n.target);
}
const nP = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, rP = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, iP = function(t) {
  var e, n;
  return t === void 0 && (t = !0), {
    escapeKeyBubbles: typeof t == "boolean" ? t : (e = t.escapeKey) != null ? e : !0,
    outsidePressBubbles: typeof t == "boolean" ? t : (n = t.outsidePress) != null ? n : !0
  };
}, Vf = function(t, e) {
  let {
    open: n,
    onOpenChange: r,
    events: i,
    nodeId: o,
    elements: {
      reference: a,
      domReference: s,
      floating: l
    },
    dataRef: f
  } = t, {
    enabled: c = !0,
    escapeKey: u = !0,
    outsidePress: d = !0,
    outsidePressEvent: h = "pointerdown",
    referencePress: p = !1,
    referencePressEvent: m = "pointerdown",
    ancestorScroll: v = !1,
    bubbles: b = !0
  } = e === void 0 ? {} : e;
  const k = $i(), _ = Li() != null, E = Gs(typeof d == "function" ? d : () => !1), S = typeof d == "function" ? E : d, C = T.useRef(!1), {
    escapeKeyBubbles: N,
    outsidePressBubbles: $
  } = iP(b);
  return T.useEffect(() => {
    if (!n || !c)
      return;
    f.current.__escapeKeyBubbles = N, f.current.__outsidePressBubbles = $;
    function I(F) {
      if (F.key === "Escape") {
        const P = k ? Ja(k.nodesRef.current, o) : [];
        if (P.length > 0) {
          let L = !0;
          if (P.forEach((X) => {
            var B;
            if ((B = X.context) != null && B.open && !X.context.dataRef.current.__escapeKeyBubbles) {
              L = !1;
              return;
            }
          }), !L)
            return;
        }
        i.emit("dismiss", {
          type: "escapeKey",
          data: {
            returnFocus: {
              preventScroll: !1
            }
          }
        }), r(!1);
      }
    }
    function O(F) {
      const P = C.current;
      if (C.current = !1, P || typeof S == "function" && !S(F))
        return;
      const L = Vc(F);
      if (Ti(L) && l) {
        const G = l.ownerDocument.defaultView || window, j = L.scrollWidth > L.clientWidth, w = L.scrollHeight > L.clientHeight;
        let x = w && F.offsetX > L.clientWidth;
        if (w && G.getComputedStyle(L).direction === "rtl" && (x = F.offsetX <= L.offsetWidth - L.clientWidth), x || j && F.offsetY > L.clientHeight)
          return;
      }
      const X = k && Ja(k.nodesRef.current, o).some((G) => {
        var j;
        return Ll(F, (j = G.context) == null ? void 0 : j.elements.floating);
      });
      if (Ll(F, l) || Ll(F, s) || X)
        return;
      const B = k ? Ja(k.nodesRef.current, o) : [];
      if (B.length > 0) {
        let G = !0;
        if (B.forEach((j) => {
          var w;
          if ((w = j.context) != null && w.open && !j.context.dataRef.current.__outsidePressBubbles) {
            G = !1;
            return;
          }
        }), !G)
          return;
      }
      i.emit("dismiss", {
        type: "outsidePress",
        data: {
          returnFocus: _ ? {
            preventScroll: !0
          } : y4(F) || _4(F)
        }
      }), r(!1);
    }
    function y() {
      r(!1);
    }
    const A = Ht(l);
    u && A.addEventListener("keydown", I), S && A.addEventListener(h, O);
    let z = [];
    return v && (cn(s) && (z = Or(s)), cn(l) && (z = z.concat(Or(l))), !cn(a) && a && a.contextElement && (z = z.concat(Or(a.contextElement)))), z = z.filter((F) => {
      var P;
      return F !== ((P = A.defaultView) == null ? void 0 : P.visualViewport);
    }), z.forEach((F) => {
      F.addEventListener("scroll", y, {
        passive: !0
      });
    }), () => {
      u && A.removeEventListener("keydown", I), S && A.removeEventListener(h, O), z.forEach((F) => {
        F.removeEventListener("scroll", y);
      });
    };
  }, [f, l, s, a, u, S, h, i, k, o, n, r, v, c, N, $, _]), T.useEffect(() => {
    C.current = !1;
  }, [S, h]), T.useMemo(() => c ? {
    reference: {
      [nP[m]]: () => {
        p && (i.emit("dismiss", {
          type: "referencePress",
          data: {
            returnFocus: !1
          }
        }), r(!1));
      }
    },
    floating: {
      [rP[h]]: () => {
        C.current = !0;
      }
    }
  } : {}, [c, i, p, h, m, r]);
}, oP = function(t, e) {
  let {
    open: n,
    onOpenChange: r,
    dataRef: i,
    events: o,
    refs: a,
    elements: {
      floating: s,
      domReference: l
    }
  } = t, {
    enabled: f = !0,
    keyboardOnly: c = !0
  } = e === void 0 ? {} : e;
  const u = T.useRef(""), d = T.useRef(!1), h = T.useRef();
  return T.useEffect(() => {
    if (!f)
      return;
    const m = Ht(s).defaultView || window;
    function v() {
      !n && Ti(l) && l === Si(Ht(l)) && (d.current = !0);
    }
    return m.addEventListener("blur", v), () => {
      m.removeEventListener("blur", v);
    };
  }, [s, l, n, f]), T.useEffect(() => {
    if (!f)
      return;
    function p(m) {
      (m.type === "referencePress" || m.type === "escapeKey") && (d.current = !0);
    }
    return o.on("dismiss", p), () => {
      o.off("dismiss", p);
    };
  }, [o, f]), T.useEffect(() => () => {
    clearTimeout(h.current);
  }, []), T.useMemo(() => f ? {
    reference: {
      onPointerDown(p) {
        let {
          pointerType: m
        } = p;
        u.current = m, d.current = !!(m && c);
      },
      onMouseLeave() {
        d.current = !1;
      },
      onFocus(p) {
        var m;
        d.current || p.type === "focus" && ((m = i.current.openEvent) == null ? void 0 : m.type) === "mousedown" && i.current.openEvent && Ll(i.current.openEvent, l) || (i.current.openEvent = p.nativeEvent, r(!0));
      },
      onBlur(p) {
        d.current = !1;
        const m = p.relatedTarget, v = cn(m) && m.hasAttribute("data-floating-ui-focus-guard") && m.getAttribute("data-type") === "outside";
        h.current = setTimeout(() => {
          jt(a.floating.current, m) || jt(l, m) || v || r(!1);
        });
      }
    }
  } : {}, [f, c, l, a, i, r]);
};
let mv = !1;
const Y0 = "ArrowUp", Kc = "ArrowDown", Fo = "ArrowLeft", Qs = "ArrowRight";
function pl(t, e, n) {
  return Math.floor(t / e) !== n;
}
function xa(t, e) {
  return e < 0 || e >= t.current.length;
}
function St(t, e) {
  let {
    startingIndex: n = -1,
    decrement: r = !1,
    disabledIndices: i,
    amount: o = 1
  } = e === void 0 ? {} : e;
  const a = t.current;
  let s = n;
  do {
    var l, f;
    s = s + (r ? -o : o);
  } while (s >= 0 && s <= a.length - 1 && (i ? i.includes(s) : a[s] == null || (l = a[s]) != null && l.hasAttribute("disabled") || ((f = a[s]) == null ? void 0 : f.getAttribute("aria-disabled")) === "true"));
  return s;
}
function Yc(t, e, n) {
  switch (t) {
    case "vertical":
      return e;
    case "horizontal":
      return n;
    default:
      return e || n;
  }
}
function vv(t, e) {
  return Yc(e, t === Y0 || t === Kc, t === Fo || t === Qs);
}
function rd(t, e, n) {
  return Yc(e, t === Kc, n ? t === Fo : t === Qs) || t === "Enter" || t == " " || t === "";
}
function aP(t, e, n) {
  return Yc(e, n ? t === Fo : t === Qs, t === Kc);
}
function sP(t, e, n) {
  return Yc(e, n ? t === Qs : t === Fo, t === Y0);
}
function id(t, e) {
  return St(t, {
    disabledIndices: e
  });
}
function bv(t, e) {
  return St(t, {
    decrement: !0,
    startingIndex: t.current.length,
    disabledIndices: e
  });
}
const lP = function(t, e) {
  let {
    open: n,
    onOpenChange: r,
    refs: i,
    elements: {
      domReference: o
    }
  } = t, {
    listRef: a,
    activeIndex: s,
    onNavigate: l = () => {
    },
    enabled: f = !0,
    selectedIndex: c = null,
    allowEscape: u = !1,
    loop: d = !1,
    nested: h = !1,
    rtl: p = !1,
    virtual: m = !1,
    focusItemOnOpen: v = "auto",
    focusItemOnHover: b = !0,
    openOnArrowKeyDown: k = !0,
    disabledIndices: _ = void 0,
    orientation: E = "vertical",
    cols: S = 1,
    scrollItemIntoView: C = !0
  } = e === void 0 ? {
    listRef: {
      current: []
    },
    activeIndex: null,
    onNavigate: () => {
    }
  } : e;
  const N = Li(), $ = $i(), I = Gs(l), O = T.useRef(v), y = T.useRef(c ?? -1), A = T.useRef(null), z = T.useRef(!0), F = T.useRef(I), P = T.useRef(n), L = T.useRef(!1), X = T.useRef(!1), B = Dr(_), G = Dr(n), j = Dr(C), [w, x] = T.useState(), oe = T.useCallback(function(te, Ve, Ee) {
    Ee === void 0 && (Ee = !1);
    const $e = te.current[Ve.current];
    m ? x($e == null ? void 0 : $e.id) : yr($e, {
      preventScroll: !0,
      // Mac Safari does not move the virtual cursor unless the focus call
      // is sync. However, for the very first focus call, we need to wait
      // for the position to be ready in order to prevent unwanted
      // scrolling. This means the virtual cursor will not move to the first
      // item when first opening the floating element, but will on
      // subsequent calls. `preventScroll` is supported in modern Safari,
      // so we can use that instead.
      // iOS Safari must be async or the first item will not be focused.
      sync: w4() && K1() ? mv || L.current : !1
    }), requestAnimationFrame(() => {
      const Qt = j.current;
      Qt && $e && (Ee || !z.current) && ($e.scrollIntoView == null || $e.scrollIntoView(typeof Qt == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : Qt));
    });
  }, [m, j]);
  ot(() => {
    document.createElement("div").focus({
      get preventScroll() {
        return mv = !0, !1;
      }
    });
  }, []), ot(() => {
    f && (n ? O.current && c != null && (X.current = !0, I(c)) : P.current && (y.current = -1, F.current(null)));
  }, [f, n, c, I]), ot(() => {
    if (f && n)
      if (s == null) {
        if (L.current = !1, c != null)
          return;
        P.current && (y.current = -1, oe(a, y)), !P.current && O.current && (A.current != null || O.current === !0 && A.current == null) && (y.current = A.current == null || rd(A.current, E, p) || h ? id(a, B.current) : bv(a, B.current), I(y.current));
      } else
        xa(a, s) || (y.current = s, oe(a, y, X.current), X.current = !1);
  }, [f, n, s, c, h, a, E, p, I, oe, B]), ot(() => {
    if (f && P.current && !n) {
      var te, Ve;
      const Ee = $ == null || (te = $.nodesRef.current.find(($e) => $e.id === N)) == null || (Ve = te.context) == null ? void 0 : Ve.elements.floating;
      Ee && !jt(Ee, Si(Ht(Ee))) && Ee.focus({
        preventScroll: !0
      });
    }
  }, [f, n, $, N]), ot(() => {
    A.current = null, F.current = I, P.current = n;
  });
  const Me = s != null, Ae = T.useMemo(() => {
    function te(Ee) {
      if (!n)
        return;
      const $e = a.current.indexOf(Ee);
      $e !== -1 && I($e);
    }
    return {
      onFocus(Ee) {
        let {
          currentTarget: $e
        } = Ee;
        te($e);
      },
      onClick: (Ee) => {
        let {
          currentTarget: $e
        } = Ee;
        return $e.focus({
          preventScroll: !0
        });
      },
      // Safari
      ...b && {
        onMouseMove(Ee) {
          let {
            currentTarget: $e
          } = Ee;
          te($e);
        },
        onPointerLeave() {
          if (z.current && (y.current = -1, oe(a, y), J2(() => I(null)), !m)) {
            var Ee;
            (Ee = i.floating.current) == null || Ee.focus({
              preventScroll: !0
            });
          }
        }
      }
    };
  }, [n, i, oe, b, a, I, m]);
  return T.useMemo(() => {
    if (!f)
      return {};
    const te = B.current;
    function Ve(ue) {
      if (z.current = !1, L.current = !0, !G.current && ue.currentTarget === i.floating.current)
        return;
      if (h && sP(ue.key, E, p)) {
        on(ue), r(!1), Ti(o) && o.focus();
        return;
      }
      const Xt = y.current, kn = id(a, te), Lt = bv(a, te);
      if (ue.key === "Home" && (y.current = kn, I(y.current)), ue.key === "End" && (y.current = Lt, I(y.current)), S > 1) {
        const Se = y.current;
        if (ue.key === Y0) {
          if (on(ue), Se === -1)
            y.current = Lt;
          else if (y.current = St(a, {
            startingIndex: Se,
            amount: S,
            decrement: !0,
            disabledIndices: te
          }), d && (Se - S < kn || y.current < 0)) {
            const Cn = Se % S, mr = Lt % S, ua = Lt - (mr - Cn);
            mr === Cn ? y.current = Lt : y.current = mr > Cn ? ua : ua - S;
          }
          xa(a, y.current) && (y.current = Se), I(y.current);
        }
        if (ue.key === Kc && (on(ue), Se === -1 ? y.current = kn : (y.current = St(a, {
          startingIndex: Se,
          amount: S,
          disabledIndices: te
        }), d && Se + S > Lt && (y.current = St(a, {
          startingIndex: Se % S - S,
          amount: S,
          disabledIndices: te
        }))), xa(a, y.current) && (y.current = Se), I(y.current)), E === "both") {
          const Cn = Math.floor(Se / S);
          ue.key === Qs && (on(ue), Se % S !== S - 1 ? (y.current = St(a, {
            startingIndex: Se,
            disabledIndices: te
          }), d && pl(y.current, S, Cn) && (y.current = St(a, {
            startingIndex: Se - Se % S - 1,
            disabledIndices: te
          }))) : d && (y.current = St(a, {
            startingIndex: Se - Se % S - 1,
            disabledIndices: te
          })), pl(y.current, S, Cn) && (y.current = Se)), ue.key === Fo && (on(ue), Se % S !== 0 ? (y.current = St(a, {
            startingIndex: Se,
            disabledIndices: te,
            decrement: !0
          }), d && pl(y.current, S, Cn) && (y.current = St(a, {
            startingIndex: Se + (S - Se % S),
            decrement: !0,
            disabledIndices: te
          }))) : d && (y.current = St(a, {
            startingIndex: Se + (S - Se % S),
            decrement: !0,
            disabledIndices: te
          })), pl(y.current, S, Cn) && (y.current = Se));
          const mr = Math.floor(Lt / S) === Cn;
          xa(a, y.current) && (d && mr ? y.current = ue.key === Fo ? Lt : St(a, {
            startingIndex: Se - Se % S - 1,
            disabledIndices: te
          }) : y.current = Se), I(y.current);
          return;
        }
      }
      if (vv(ue.key, E)) {
        if (on(ue), n && !m && Si(ue.currentTarget.ownerDocument) === ue.currentTarget) {
          y.current = rd(ue.key, E, p) ? kn : Lt, I(y.current);
          return;
        }
        rd(ue.key, E, p) ? d ? y.current = Xt >= Lt ? u && Xt !== a.current.length ? -1 : kn : St(a, {
          startingIndex: Xt,
          disabledIndices: te
        }) : y.current = Math.min(Lt, St(a, {
          startingIndex: Xt,
          disabledIndices: te
        })) : d ? y.current = Xt <= kn ? u && Xt !== -1 ? a.current.length : Lt : St(a, {
          startingIndex: Xt,
          decrement: !0,
          disabledIndices: te
        }) : y.current = Math.max(kn, St(a, {
          startingIndex: Xt,
          decrement: !0,
          disabledIndices: te
        })), xa(a, y.current) ? I(null) : I(y.current);
      }
    }
    function Ee(ue) {
      v === "auto" && y4(ue.nativeEvent) && (O.current = !0);
    }
    function $e(ue) {
      O.current = v, v === "auto" && _4(ue.nativeEvent) && (O.current = !0);
    }
    const Qt = m && n && Me && {
      "aria-activedescendant": w
    };
    return {
      reference: {
        ...Qt,
        onKeyDown(ue) {
          z.current = !1;
          const Xt = ue.key.indexOf("Arrow") === 0;
          if (m && n)
            return Ve(ue);
          if (!n && !k && Xt)
            return;
          if ((Xt || ue.key === "Enter" || ue.key === " " || ue.key === "") && (A.current = ue.key), h) {
            aP(ue.key, E, p) && (on(ue), n ? (y.current = id(a, te), I(y.current)) : r(!0));
            return;
          }
          vv(ue.key, E) && (c != null && (y.current = c), on(ue), !n && k ? r(!0) : Ve(ue), n && I(y.current));
        },
        onFocus() {
          n && I(null);
        },
        onPointerDown: $e,
        onMouseDown: Ee,
        onClick: Ee
      },
      floating: {
        "aria-orientation": E === "both" ? void 0 : E,
        ...Qt,
        onKeyDown: Ve,
        onPointerMove() {
          z.current = !0;
        }
      },
      item: Ae
    };
  }, [o, i, w, B, G, a, f, E, p, m, n, Me, h, c, k, u, S, d, v, I, r, Ae]);
};
function M4(t) {
  return T.useMemo(() => t.every((e) => e == null) ? null : (e) => {
    t.forEach((n) => {
      typeof n == "function" ? n(e) : n != null && (n.current = e);
    });
  }, t);
}
const A4 = function(t, e) {
  let {
    open: n
  } = t, {
    enabled: r = !0,
    role: i = "dialog"
  } = e === void 0 ? {} : e;
  const o = Bf(), a = Bf();
  return T.useMemo(() => {
    const s = {
      id: o,
      role: i
    };
    return r ? i === "tooltip" ? {
      reference: {
        "aria-describedby": n ? o : void 0
      },
      floating: s
    } : {
      reference: {
        "aria-expanded": n ? "true" : "false",
        "aria-haspopup": i === "alertdialog" ? "dialog" : i,
        "aria-controls": n ? o : void 0,
        ...i === "listbox" && {
          role: "combobox"
        },
        ...i === "menu" && {
          id: a
        }
      },
      floating: {
        ...s,
        ...i === "menu" && {
          "aria-labelledby": a
        }
      }
    } : {};
  }, [r, i, n, o, a]);
}, fP = function(t, e) {
  var n;
  let {
    open: r,
    dataRef: i,
    refs: o
  } = t, {
    listRef: a,
    activeIndex: s,
    onMatch: l = () => {
    },
    enabled: f = !0,
    findMatch: c = null,
    resetMs: u = 1e3,
    ignoreKeys: d = [],
    selectedIndex: h = null
  } = e === void 0 ? {
    listRef: {
      current: []
    },
    activeIndex: null
  } : e;
  const p = T.useRef(), m = T.useRef(""), v = T.useRef((n = h ?? s) != null ? n : -1), b = T.useRef(null), k = Gs(l), _ = Dr(c), E = Dr(d);
  return ot(() => {
    r && (clearTimeout(p.current), b.current = null, m.current = "");
  }, [r]), ot(() => {
    if (r && m.current === "") {
      var S;
      v.current = (S = h ?? s) != null ? S : -1;
    }
  }, [r, h, s]), T.useMemo(() => {
    if (!f)
      return {};
    function S(C) {
      var N;
      const $ = Vc(C.nativeEvent);
      if (cn($) && (Si(Ht($)) !== C.currentTarget ? (N = o.floating.current) != null && N.contains($) && $.closest('[role="dialog"],[role="menu"],[role="listbox"],[role="tree"],[role="grid"]') !== C.currentTarget : !C.currentTarget.contains($)))
        return;
      m.current.length > 0 && m.current[0] !== " " && (i.current.typing = !0, C.key === " " && on(C));
      const I = a.current;
      if (I == null || E.current.includes(C.key) || // Character key.
      C.key.length !== 1 || // Modifier key.
      C.ctrlKey || C.metaKey || C.altKey)
        return;
      I.every((P) => {
        var L, X;
        return P ? ((L = P[0]) == null ? void 0 : L.toLocaleLowerCase()) !== ((X = P[1]) == null ? void 0 : X.toLocaleLowerCase()) : !0;
      }) && m.current === C.key && (m.current = "", v.current = b.current), m.current += C.key, clearTimeout(p.current), p.current = setTimeout(() => {
        m.current = "", v.current = b.current, i.current.typing = !1;
      }, u);
      const y = v.current, A = [...I.slice((y || 0) + 1), ...I.slice(0, (y || 0) + 1)], z = _.current ? _.current(A, m.current) : A.find((P) => (P == null ? void 0 : P.toLocaleLowerCase().indexOf(m.current.toLocaleLowerCase())) === 0), F = z ? I.indexOf(z) : -1;
      F !== -1 && (k(F), b.current = F);
    }
    return {
      reference: {
        onKeyDown: S
      },
      floating: {
        onKeyDown: S
      }
    };
  }, [f, i, a, u, E, _, k, o]);
};
function cP(t, e) {
  const [n, r] = t;
  let i = !1;
  const o = e.length;
  for (let a = 0, s = o - 1; a < o; s = a++) {
    const [l, f] = e[a] || [0, 0], [c, u] = e[s] || [0, 0];
    f >= r != u >= r && n <= (c - l) * (r - f) / (u - f) + l && (i = !i);
  }
  return i;
}
function uP(t, e) {
  return t[0] >= e.x && t[0] <= e.x + e.width && t[1] >= e.y && t[1] <= e.y + e.height;
}
function dP(t) {
  let {
    restMs: e = 0,
    buffer: n = 0.5,
    blockPointerEvents: r = !1
  } = t === void 0 ? {} : t, i, o = !1, a = !1;
  const s = (l) => {
    let {
      x: f,
      y: c,
      placement: u,
      elements: d,
      onClose: h,
      nodeId: p,
      tree: m
    } = l;
    return function(b) {
      function k() {
        clearTimeout(i), h();
      }
      if (clearTimeout(i), !d.domReference || !d.floating || u == null || f == null || c == null)
        return;
      const {
        clientX: _,
        clientY: E
      } = b, S = [_, E], C = Vc(b), N = b.type === "mouseleave", $ = jt(d.floating, C), I = jt(d.domReference, C), O = d.domReference.getBoundingClientRect(), y = d.floating.getBoundingClientRect(), A = u.split("-")[0], z = f > y.right - y.width / 2, F = c > y.bottom - y.height / 2, P = uP(S, O);
      if ($ && (a = !0, !N))
        return;
      if (I && (a = !1), I && !N) {
        a = !0;
        return;
      }
      if (N && cn(b.relatedTarget) && jt(d.floating, b.relatedTarget) || m && Ja(m.nodesRef.current, p).some((G) => {
        let {
          context: j
        } = G;
        return j == null ? void 0 : j.open;
      }))
        return;
      if (A === "top" && c >= O.bottom - 1 || A === "bottom" && c <= O.top + 1 || A === "left" && f >= O.right - 1 || A === "right" && f <= O.left + 1)
        return k();
      let L = [];
      switch (A) {
        case "top":
          L = [[y.left, O.top + 1], [y.left, y.bottom - 1], [y.right, y.bottom - 1], [y.right, O.top + 1]], o = _ >= y.left && _ <= y.right && E >= y.top && E <= O.top + 1;
          break;
        case "bottom":
          L = [[y.left, y.top + 1], [y.left, O.bottom - 1], [y.right, O.bottom - 1], [y.right, y.top + 1]], o = _ >= y.left && _ <= y.right && E >= O.bottom - 1 && E <= y.bottom;
          break;
        case "left":
          L = [[y.right - 1, y.bottom], [y.right - 1, y.top], [O.left + 1, y.top], [O.left + 1, y.bottom]], o = _ >= y.left && _ <= O.left + 1 && E >= y.top && E <= y.bottom;
          break;
        case "right":
          L = [[O.right - 1, y.bottom], [O.right - 1, y.top], [y.left + 1, y.top], [y.left + 1, y.bottom]], o = _ >= O.right - 1 && _ <= y.right && E >= y.top && E <= y.bottom;
          break;
      }
      function X(G) {
        let [j, w] = G;
        const x = y.width > O.width, oe = y.height > O.height;
        switch (A) {
          case "top": {
            const Me = [x ? j + n / 2 : z ? j + n * 4 : j - n * 4, w + n + 1], Ae = [x ? j - n / 2 : z ? j + n * 4 : j - n * 4, w + n + 1], te = [[y.left, z || x ? y.bottom - n : y.top], [y.right, z ? x ? y.bottom - n : y.top : y.bottom - n]];
            return [Me, Ae, ...te];
          }
          case "bottom": {
            const Me = [x ? j + n / 2 : z ? j + n * 4 : j - n * 4, w - n], Ae = [x ? j - n / 2 : z ? j + n * 4 : j - n * 4, w - n], te = [[y.left, z || x ? y.top + n : y.bottom], [y.right, z ? x ? y.top + n : y.bottom : y.top + n]];
            return [Me, Ae, ...te];
          }
          case "left": {
            const Me = [j + n + 1, oe ? w + n / 2 : F ? w + n * 4 : w - n * 4], Ae = [j + n + 1, oe ? w - n / 2 : F ? w + n * 4 : w - n * 4];
            return [...[[F || oe ? y.right - n : y.left, y.top], [F ? oe ? y.right - n : y.left : y.right - n, y.bottom]], Me, Ae];
          }
          case "right": {
            const Me = [j - n, oe ? w + n / 2 : F ? w + n * 4 : w - n * 4], Ae = [j - n, oe ? w - n / 2 : F ? w + n * 4 : w - n * 4], te = [[F || oe ? y.left + n : y.right, y.top], [F ? oe ? y.left + n : y.right : y.left + n, y.bottom]];
            return [Me, Ae, ...te];
          }
        }
      }
      const B = o ? L : X([f, c]);
      if (!o) {
        if (a && !P)
          return k();
        cP([_, E], B) ? e && !a && (i = setTimeout(k, e)) : k();
      }
    };
  };
  return s.__options = {
    blockPointerEvents: r
  }, s;
}
function jo(t) {
  t === void 0 && (t = {});
  const {
    open: e = !1,
    onOpenChange: n,
    nodeId: r
  } = t, i = jD(t), o = $i(), a = T.useRef(null), s = T.useRef({}), l = T.useState(() => p4())[0], [f, c] = T.useState(null), u = T.useCallback((b) => {
    const k = cn(b) ? {
      getBoundingClientRect: () => b.getBoundingClientRect(),
      contextElement: b
    } : b;
    i.refs.setReference(k);
  }, [i.refs]), d = T.useCallback((b) => {
    (cn(b) || b === null) && (a.current = b, c(b)), (cn(i.refs.reference.current) || i.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    b !== null && !cn(b)) && i.refs.setReference(b);
  }, [i.refs]), h = T.useMemo(() => ({
    ...i.refs,
    setReference: d,
    setPositionReference: u,
    domReference: a
  }), [i.refs, d, u]), p = T.useMemo(() => ({
    ...i.elements,
    domReference: f
  }), [i.elements, f]), m = Gs(n), v = T.useMemo(() => ({
    ...i,
    refs: h,
    elements: p,
    dataRef: s,
    nodeId: r,
    events: l,
    open: e,
    onOpenChange: m
  }), [i, r, l, e, m, h, p]);
  return ot(() => {
    const b = o == null ? void 0 : o.nodesRef.current.find((k) => k.id === r);
    b && (b.context = v);
  }), T.useMemo(() => ({
    ...i,
    context: v,
    refs: h,
    reference: d,
    positionReference: u
  }), [i, h, v, d, u]);
}
function od(t, e, n) {
  const r = /* @__PURE__ */ new Map();
  return {
    ...n === "floating" && {
      tabIndex: -1
    },
    ...t,
    ...e.map((i) => i ? i[n] : null).concat(t).reduce((i, o) => (o && Object.entries(o).forEach((a) => {
      let [s, l] = a;
      if (s.indexOf("on") === 0) {
        if (r.has(s) || r.set(s, []), typeof l == "function") {
          var f;
          (f = r.get(s)) == null || f.push(l), i[s] = function() {
            for (var c, u = arguments.length, d = new Array(u), h = 0; h < u; h++)
              d[h] = arguments[h];
            (c = r.get(s)) == null || c.forEach((p) => p(...d));
          };
        }
      } else
        i[s] = l;
    }), i), {})
  };
}
const Kf = function(t) {
  t === void 0 && (t = []);
  const e = t, n = T.useCallback(
    (o) => od(o, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), r = T.useCallback(
    (o) => od(o, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), i = T.useCallback(
    (o) => od(o, t, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t.map((o) => o == null ? void 0 : o.item)
  );
  return T.useMemo(() => ({
    getReferenceProps: n,
    getFloatingProps: r,
    getItemProps: i
  }), [n, r, i]);
}, O4 = ui(void 0);
function hP({
  theme: t,
  children: e
}) {
  return /* @__PURE__ */ g(O4.Provider, {
    value: t,
    children: e
  });
}
const D4 = he.createContext(void 0);
function gP({
  children: t,
  renderAvatar: e
}) {
  return e ? /* @__PURE__ */ g(D4.Provider, {
    value: e,
    children: t
  }) : /* @__PURE__ */ g(K, {
    children: t
  });
}
function pP() {
  return he.useContext(D4);
}
function ke() {
  const t = Ii(r4);
  if (t == null)
    throw new Error("useApp must be used within a CollabKitProvider");
  return t;
}
function _e() {
  const { store: t } = ke();
  return t;
}
function Xs() {
  const t = _e(), {
    config: e,
    userId: n,
    workspaceId: r
  } = ie(t);
  return !(!e.appId || !r || !n);
}
var mP = "_1qia8j91", yv = "_1qia8j90";
const Js = ui(null);
function Fi() {
  const t = Ii(Js);
  if (!t)
    throw new Error("Target context not found");
  return t;
}
function q0({
  children: t,
  ...e
}) {
  return /* @__PURE__ */ g(eP, {
    ...e,
    children: Wo(t, {
      key: "FloatingFocusManager-child"
    })
  });
}
function P4(t) {
  return (e) => {
    t.forEach((n) => {
      typeof n == "function" ? n(e) : n != null && (n.current = e);
    });
  };
}
function _v(t) {
  var e = t.match(/^var\((.*)\)$/);
  return e ? e[1] : t;
}
function vP(t, e) {
  var n = t;
  for (var r of e) {
    if (!(r in n))
      throw new Error("Path ".concat(e.join(" -> "), " does not exist in object"));
    n = n[r];
  }
  return n;
}
function R4(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = t.constructor();
  for (var i in t) {
    var o = t[i], a = [...n, i];
    typeof o == "string" || typeof o == "number" || o == null ? r[i] = e(o, a) : typeof o == "object" && !Array.isArray(o) ? r[i] = R4(o, e, a) : console.warn('Skipping invalid key "'.concat(a.join("."), '". Should be a string, number, null or object. Received: "').concat(Array.isArray(o) ? "Array" : typeof o, '"'));
  }
  return r;
}
function bP(t, e) {
  var n = {};
  if (typeof e == "object") {
    var r = t;
    R4(e, (a, s) => {
      var l = vP(r, s);
      n[_v(l)] = String(a);
    });
  } else {
    var i = t;
    for (var o in i)
      n[_v(o)] = i[o];
  }
  return Object.defineProperty(n, "toString", {
    value: function() {
      return Object.keys(this).map((s) => "".concat(s, ":").concat(this[s])).join(";");
    },
    writable: !1
  }), n;
}
var yP = "_1dpjd7h0", je = { avatar: { size: "var(--collabkit-avatar-size)", fontSize: "var(--collabkit-avatar-placeholder-font-size)", colors: { amber: "var(--collabkit-avatar-color-amber)", blue: "var(--collabkit-avatar-color-blue)", brown: "var(--collabkit-avatar-color-brown)", crimson: "var(--collabkit-avatar-color-crimson)", cyan: "var(--collabkit-avatar-color-cyan)", grass: "var(--collabkit-avatar-color-grass)", green: "var(--collabkit-avatar-color-green)", indigo: "var(--collabkit-avatar-color-indigo)", lime: "var(--collabkit-avatar-color-lime)", mint: "var(--collabkit-avatar-color-mint)", orange: "var(--collabkit-avatar-color-orange)", pink: "var(--collabkit-avatar-color-pink)", plum: "var(--collabkit-avatar-color-plum)", purple: "var(--collabkit-avatar-color-purple)", red: "var(--collabkit-avatar-color-red)", sky: "var(--collabkit-avatar-color-sky)", teal: "var(--collabkit-avatar-color-teal)", tomato: "var(--collabkit-avatar-color-tomato)", violet: "var(--collabkit-avatar-color-violet)", yellow: "var(--collabkit-avatar-color-yellow)" } }, iconButton: { background: "var(--collabkit-icon-button-background)", color: "var(--collabkit-icon-button-color)", width: "var(--collabkit-icon-button-width)", height: "var(--collabkit-icon-button-height)", borderRadius: "var(--collabkit-icon-button-border-radius)", active: { background: "var(--collabkit-icon-button-active-background)" }, hover: { background: "var(--collabkit-icon-button-hover-background)" }, small: { width: "var(--collabkit-icon-button-small-width)", height: "var(--collabkit-icon-button-small-height)" } }, buttonGroup: { gap: "var(--collabkit-button-group-gap)", padding: "var(--collabkit-button-group-padding)" }, button: { fontSize: "var(--collabkit-button-font-size)", fontWeight: "var(--collabkit-button-font-weight)", letterSpacing: "var(--collabkit-button-letter-spacing)", lineHeight: "var(--collabkit-button-line-height)", borderRadius: "var(--collabkit-button-border-radius)", padding: "var(--collabkit-button-padding)", primary: { fontSize: "var(--collabkit-button-primary-font-size)", fontWeight: "var(--collabkit-button-primary-font-weight)", lineHeight: "var(--collabkit-button-primary-line-height)", letterSpacing: "var(--collabkit-button-primary-letter-spacing)", color: "var(--collabkit-button-primary-color)", background: "var(--collabkit-button-primary-background)", active: { color: "var(--collabkit-button-primary-active-color)", background: "var(--collabkit-button-primary-active-background)" }, hover: { color: "var(--collabkit-button-primary-hover-color)", background: "var(--collabkit-button-primary-hover-background)" }, disabled: { color: "var(--collabkit-button-primary-disabled-color)", background: "var(--collabkit-button-primary-disabled-background)" } }, secondary: { fontWeight: "var(--collabkit-button-secondary-font-weight)", letterSpacing: "var(--collabkit-button-secondary-letter-spacing)", color: "var(--collabkit-button-secondary-color)", background: "var(--collabkit-button-secondary-background)", fontSize: "var(--collabkit-button-secondary-font-size)", lineHeight: "var(--collabkit-button-secondary-line-height)", active: { color: "var(--collabkit-button-secondary-active-color)", background: "var(--collabkit-button-secondary-active-background)" }, hover: { color: "var(--collabkit-button-secondary-hover-color)", background: "var(--collabkit-button-secondary-hover-background)" }, disabled: { color: "var(--collabkit-button-secondary-disabled-color)", background: "var(--collabkit-button-secondary-disabled-background)" } }, disabled: { color: "var(--collabkit-button-disabled-color)", background: "var(--collabkit-button-disabled-background)" } }, color: { background: "var(--collabkit-color-background)", backgroundMedium: "var(--collabkit-color-background-medium)", surface: "var(--collabkit-color-surface)", surfaceOverlay: "var(--collabkit-color-surface-overlay)", textPrimary: "var(--collabkit-color-text-primary)", textSecondary: "var(--collabkit-color-text-secondary)", textDisabled: "var(--collabkit-color-text-disabled)", border: "var(--collabkit-color-border)", icon: "var(--collabkit-color-icon)", iconSecondary: "var(--collabkit-color-icon-secondary)", iconDisabled: "var(--collabkit-color-icon-disabled)", attention: "var(--collabkit-color-attention)", attentionBlue: "var(--collabkit-color-attention-blue)" }, comment: { paddingLeft: "var(--collabkit-comment-padding-left)", paddingRight: "var(--collabkit-comment-padding-right)", paddingTop: "var(--collabkit-comment-padding-top)", paddingBottom: "var(--collabkit-comment-padding-bottom)", gap: "var(--collabkit-comment-gap)", hover: { background: "var(--collabkit-comment-hover-background)" }, header: { gap: "var(--collabkit-comment-header-gap)", nameAndTimestamp: { gap: "var(--collabkit-comment-header-name-and-timestamp-gap)", flexDirection: "var(--collabkit-comment-header-name-and-timestamp-flex-direction)" }, profile: { gap: "var(--collabkit-comment-header-profile-gap)" } }, actions: { gap: "var(--collabkit-comment-actions-gap)" }, body: { color: "var(--collabkit-comment-body-color)", fontSize: "var(--collabkit-comment-body-font-size)", lineHeight: "var(--collabkit-comment-body-line-height)", fontWeight: "var(--collabkit-comment-body-font-weight)", letterSpacing: "var(--collabkit-comment-body-letter-spacing)" }, pin: { background: "var(--collabkit-comment-pin-background)", color: "var(--collabkit-comment-pin-color)", active: { background: "var(--collabkit-comment-pin-active-background)", color: "var(--collabkit-comment-pin-active-color)" } }, timestamp: { color: "var(--collabkit-comment-timestamp-color)", fontSize: "var(--collabkit-comment-timestamp-font-size)", lineHeight: "var(--collabkit-comment-timestamp-line-height)", fontWeight: "var(--collabkit-comment-timestamp-font-weight)", letterSpacing: "var(--collabkit-comment-timestamp-letter-spacing)" }, replyCountButton: { padding: "var(--collabkit-comment-reply-count-button-padding)", borderRadius: "var(--collabkit-comment-reply-count-button-border-radius)", background: "var(--collabkit-comment-reply-count-button-background)", border: "var(--collabkit-comment-reply-count-button-border)", hover: { background: "var(--collabkit-comment-reply-count-button-hover-background)", border: "var(--collabkit-comment-reply-count-button-hover-border)" }, text: { color: "var(--collabkit-comment-reply-count-button-text-color)", fontSize: "var(--collabkit-comment-reply-count-button-text-font-size)", lineHeight: "var(--collabkit-comment-reply-count-button-text-line-height)", fontWeight: "var(--collabkit-comment-reply-count-button-text-font-weight)", letterSpacing: "var(--collabkit-comment-reply-count-button-text-letter-spacing)" }, icon: { color: "var(--collabkit-comment-reply-count-button-icon-color)", fontSize: "var(--collabkit-comment-reply-count-button-icon-font-size)", lineHeight: "var(--collabkit-comment-reply-count-button-icon-line-height)", fontWeight: "var(--collabkit-comment-reply-count-button-icon-font-weight)", letterSpacing: "var(--collabkit-comment-reply-count-button-icon-letter-spacing)" } } }, commentList: { gap: "var(--collabkit-comment-list-gap)", padding: "var(--collabkit-comment-list-padding)" }, composer: { padding: "var(--collabkit-composer-padding)", border: "var(--collabkit-composer-border)", gap: "var(--collabkit-composer-gap)", typingIndicator: { color: "var(--collabkit-composer-typing-indicator-color)", fontSize: "var(--collabkit-composer-typing-indicator-font-size)", lineHeight: "var(--collabkit-composer-typing-indicator-line-height)", fontWeight: "var(--collabkit-composer-typing-indicator-font-weight)", letterSpacing: "var(--collabkit-composer-typing-indicator-letter-spacing)" }, input: { background: "var(--collabkit-composer-input-background)", border: "var(--collabkit-composer-input-border)", borderRadius: "var(--collabkit-composer-input-border-radius)", caretColor: "var(--collabkit-composer-input-caret-color)", color: "var(--collabkit-composer-input-color)", fontSize: "var(--collabkit-composer-input-font-size)", lineHeight: "var(--collabkit-composer-input-line-height)", fontWeight: "var(--collabkit-composer-input-font-weight)", letterSpacing: "var(--collabkit-composer-input-letter-spacing)", padding: "var(--collabkit-composer-input-padding)", active: { background: "var(--collabkit-composer-input-active-background)", border: "var(--collabkit-composer-input-active-border)" }, hover: { background: "var(--collabkit-composer-input-hover-background)", border: "var(--collabkit-composer-input-hover-border)" }, disabled: { background: "var(--collabkit-composer-input-disabled-background)", border: "var(--collabkit-composer-input-disabled-border)", color: "var(--collabkit-composer-input-disabled-color)" }, placeholder: { color: "var(--collabkit-composer-input-placeholder-color)" } } }, facepile: { overlap: "var(--collabkit-facepile-overlap)", avatar: { borderSize: "var(--collabkit-facepile-avatar-border-size)", borderColor: "var(--collabkit-facepile-avatar-border-color)", hover: { borderColor: "var(--collabkit-facepile-avatar-hover-border-color)" } } }, inbox: { gap: "var(--collabkit-inbox-gap)", background: "var(--collabkit-inbox-background)", width: "var(--collabkit-inbox-width)", header: { color: "var(--collabkit-inbox-header-color)", fontSize: "var(--collabkit-inbox-header-font-size)", fontWeight: "var(--collabkit-inbox-header-font-weight)", lineHeight: "var(--collabkit-inbox-header-line-height)", letterSpacing: "var(--collabkit-inbox-header-letter-spacing)" }, item: { background: "var(--collabkit-inbox-item-background)", borderBottom: "var(--collabkit-inbox-item-border-bottom)", gap: "var(--collabkit-inbox-item-gap)", paddingTop: "var(--collabkit-inbox-item-padding-top)", paddingRight: "var(--collabkit-inbox-item-padding-right)", paddingLeft: "var(--collabkit-inbox-item-padding-left)", paddingBottom: "var(--collabkit-inbox-item-padding-bottom)", hover: { background: "var(--collabkit-inbox-item-hover-background)" }, active: { background: "var(--collabkit-inbox-item-active-background)" }, facepile: { avatar: { size: "var(--collabkit-inbox-item-facepile-avatar-size)" } }, replyCount: { fontWeight: "var(--collabkit-inbox-item-reply-count-font-weight)", fontSize: "var(--collabkit-inbox-item-reply-count-font-size)", lineHeight: "var(--collabkit-inbox-item-reply-count-line-height)", letterSpacing: "var(--collabkit-inbox-item-reply-count-letter-spacing)", color: "var(--collabkit-inbox-item-reply-count-color)" }, timestamp: { fontWeight: "var(--collabkit-inbox-item-timestamp-font-weight)", fontSize: "var(--collabkit-inbox-item-timestamp-font-size)", lineHeight: "var(--collabkit-inbox-item-timestamp-line-height)", letterSpacing: "var(--collabkit-inbox-item-timestamp-letter-spacing)", color: "var(--collabkit-inbox-item-timestamp-color)" }, unreadDot: { width: "var(--collabkit-inbox-item-unread-dot-width)", height: "var(--collabkit-inbox-item-unread-dot-height)", borderRadius: "var(--collabkit-inbox-item-unread-dot-border-radius)", background: "var(--collabkit-inbox-item-unread-dot-background)" } } }, mentions: { pill: { fontSize: "var(--collabkit-mentions-pill-font-size)", fontWeight: "var(--collabkit-mentions-pill-font-weight)", letterSpacing: "var(--collabkit-mentions-pill-letter-spacing)", lineHeight: "var(--collabkit-mentions-pill-line-height)", padding: "var(--collabkit-mentions-pill-padding)", color: "var(--collabkit-mentions-pill-color)", borderRadius: "var(--collabkit-mentions-pill-border-radius)", background: "var(--collabkit-mentions-pill-background)" }, typeahead: { background: "var(--collabkit-mentions-typeahead-background)", border: "var(--collabkit-mentions-typeahead-border)", borderRadius: "var(--collabkit-mentions-typeahead-border-radius)", boxShadow: "var(--collabkit-mentions-typeahead-box-shadow)", padding: "var(--collabkit-mentions-typeahead-padding)", item: { fontSize: "var(--collabkit-mentions-typeahead-item-font-size)", fontWeight: "var(--collabkit-mentions-typeahead-item-font-weight)", letterSpacing: "var(--collabkit-mentions-typeahead-item-letter-spacing)", lineHeight: "var(--collabkit-mentions-typeahead-item-line-height)", padding: "var(--collabkit-mentions-typeahead-item-padding)", gap: "var(--collabkit-mentions-typeahead-item-gap)", color: "var(--collabkit-mentions-typeahead-item-color)", mark: { fontWeight: "var(--collabkit-mentions-typeahead-item-mark-font-weight)", color: "var(--collabkit-mentions-typeahead-item-mark-color)", background: "var(--collabkit-mentions-typeahead-item-mark-background)", borderRadius: "var(--collabkit-mentions-typeahead-item-mark-border-radius)" }, active: { background: "var(--collabkit-mentions-typeahead-item-active-background)", color: "var(--collabkit-mentions-typeahead-item-active-color)" }, nameAndEmailWrapper: { gap: "var(--collabkit-mentions-typeahead-item-name-and-email-wrappper-gap)", flexDirection: "var(--collabkit-mentions-typeahead-item-name-and-email-wrappper-flex-direction)" }, name: { fontSize: "var(--collabkit-mentions-typeahead-item-name-font-size)", fontWeight: "var(--collabkit-mentions-typeahead-item-name-font-weight)", letterSpacing: "var(--collabkit-mentions-typeahead-item-name-letter-spacing)", lineHeight: "var(--collabkit-mentions-typeahead-item-name-line-height)", color: "var(--collabkit-mentions-typeahead-item-name-color)" }, email: { fontSize: "var(--collabkit-mentions-typeahead-item-email-font-size)", fontWeight: "var(--collabkit-mentions-typeahead-item-email-font-weight)", letterSpacing: "var(--collabkit-mentions-typeahead-item-email-letter-spacing)", lineHeight: "var(--collabkit-mentions-typeahead-item-email-line-height)", display: "var(--collabkit-mentions-typeahead-item-email-display)", color: "var(--collabkit-mentions-typeahead-item-email-color)" } } } }, menu: { background: "var(--collabkit-menu-background)", border: "var(--collabkit-menu-border)", borderRadius: "var(--collabkit-menu-border-radius)", boxShadow: "var(--collabkit-menu-box-shadow)", item: { color: "var(--collabkit-menu-item-color)", fontSize: "var(--collabkit-menu-item-font-size)", fontWeight: "var(--collabkit-menu-item-font-weight)", letterSpacing: "var(--collabkit-menu-item-letter-spacing)", lineHeight: "var(--collabkit-menu-item-line-height)", active: { color: "var(--collabkit-menu-item-active-color)", background: "var(--collabkit-menu-item-active-background)" }, hover: { color: "var(--collabkit-menu-item-hover-color)", background: "var(--collabkit-menu-item-hover-background)" } } }, pin: { background: "var(--collabkit-pin-background)", borderColor: "var(--collabkit-pin-border-color)", active: { background: "var(--collabkit-pin-active-background)", borderColor: "var(--collabkit-pin-active-border-color)" } }, profile: { gap: "var(--collabkit-profile-gap)", avatar: { borderRadius: "var(--collabkit-profile-avatar-border-radius)", fontSize: "var(--collabkit-profile-avatar-font-size)", fontWeight: "var(--collabkit-profile-avatar-font-weight)", color: "var(--collabkit-profile-avatar-color)", background: "var(--collabkit-profile-avatar-background)" }, name: { color: "var(--collabkit-profile-name-color)", fontSize: "var(--collabkit-profile-name-font-size)", fontWeight: "var(--collabkit-profile-name-font-weight)", lineHeight: "var(--collabkit-profile-name-line-height)", letterSpacing: "var(--collabkit-profile-name-letter-spacing)" } }, scrollbar: { thumb: { background: "var(--collabkit-scrollbar-thumb-background)", width: "var(--collabkit-scrollbar-thumb-width)", borderRadius: "var(--collabkit-scrollbar-thumb-border-radius)" }, padding: "var(--collabkit-scrollbar-padding)", background: "var(--collabkit-scrollbar-background)", hover: { background: "var(--collabkit-scrollbar-hover-background)" }, borderRadius: "var(--collabkit-scrollbar-border-radius)" }, shadow: { standard: "var(--collabkit-shadow-standard)", high: "var(--collabkit-shadow-high)" }, sidebar: { boxShadow: "var(--collabkit-sidebar-box-shadow)", background: "var(--collabkit-sidebar-background)", borderLeft: "var(--collabkit-sidebar-border-left)", width: "var(--collabkit-sidebar-width)", title: { fontSize: "var(--collabkit-sidebar-title-font-size)", fontWeight: "var(--collabkit-sidebar-title-font-weight)", letterSpacing: "var(--collabkit-sidebar-title-letter-spacing)", lineHeight: "var(--collabkit-sidebar-title-line-height)", borderBottom: "var(--collabkit-sidebar-title-border-bottom)", borderBottomColor: "var(--collabkit-sidebar-title-border-bottom-color)", color: "var(--collabkit-sidebar-title-color)", paddingBottom: "var(--collabkit-sidebar-title-padding-bottom)", paddingTop: "var(--collabkit-sidebar-title-padding-top)" }, unreadDot: { background: "var(--collabkit-sidebar-unreadDot-color)" } }, space: { 0: "var(--collabkit-space-0)", 1: "var(--collabkit-space-1)", 2: "var(--collabkit-space-2)", 3: "var(--collabkit-space-3)", 4: "var(--collabkit-space-4)", 5: "var(--collabkit-space-5)", 6: "var(--collabkit-space-6)", 7: "var(--collabkit-space-7)", 8: "var(--collabkit-space-8)" }, text: { tiny: { fontSize: "var(--collabkit-text-tiny-font-size)", letterSpacing: "var(--collabkit-text-tiny-letter-spacing)", lineHeight: "var(--collabkit-text-tiny-line-height)" }, small: { fontSize: "var(--collabkit-text-small-font-size)", letterSpacing: "var(--collabkit-text-small-letter-spacing)", lineHeight: "var(--collabkit-text-small-line-height)" }, base: { fontSize: "var(--collabkit-text-base-font-size)", letterSpacing: "var(--collabkit-text-base-letter-spacing)", lineHeight: "var(--collabkit-text-base-line-height)" }, large: { fontSize: "var(--collabkit-text-large-font-size)", letterSpacing: "var(--collabkit-text-large-letter-spacing)", lineHeight: "var(--collabkit-text-large-line-height)" } }, fontWeight: { regular: "var(--collabkit-font-weight-regular)", medium: "var(--collabkit-font-weight-medium)", bold: "var(--collabkit-font-weight-bold)" }, fontFamily: "var(--collabkit-font-family)", thread: { background: "var(--collabkit-thread-background)", border: "var(--collabkit-thread-border)", borderRadius: "var(--collabkit-thread-border-radius)", boxShadow: "var(--collabkit-thread-box-shadow)", header: { color: "var(--collabkit-thread-header-color)", fontSize: "var(--collabkit-thread-header-font-size)", fontWeight: "var(--collabkit-thread-header-font-weight)", lineHeight: "var(--collabkit-thread-header-line-height)", letterSpacing: "var(--collabkit-thread-header-letter-spacing)" } }, newIndicator: { color: "var(--collabkit-inbox-new-indicator-color)", fontSize: "var(--collabkit-inbox-new-indicator-font-size)", fontWeight: "var(--collabkit-inbox-new-indicator-font-weight)", lineHeight: "var(--collabkit-inbox-new-indicator-line-height)", letterSpacing: "var(--collabkit-inbox-new-indicator-letter-spacing)", inlay: { background: "var(--collabkit-inbox-new-indicator-inlay-background)" }, line: { background: "var(--collabkit-inbox-new-indicator-line-background)" }, padding: "var(--collabkit-inbox-new-indicator-padding)", margin: "var(--collabkit-inbox-new-indicator-margin)" }, zIndex: { floating: "var(--collabkit-z-index-floating)" } };
var _P = "_43g8ad0";
function L4(t) {
  const e = Yt(() => ["collabkit", _P, t.className].filter((n) => !!n).join(" "), [t.className]);
  return /* @__PURE__ */ g("div", {
    ...t,
    className: e
  });
}
function qt(t) {
  const e = Ii(O4);
  let n, r = null;
  return e == null || e === "light" || (e === "dark" ? n = yP : r = e), /* @__PURE__ */ g(L4, {
    ...t,
    className: n,
    "data-collabkit-internal": "true",
    style: {
      display: "contents",
      // Casting to ThemeTokens is needed because we are assigning a partial
      // theme where assignInlineVars expects a full theme.
      ...r != null ? bP(je, r) : null,
      ...t.style
    },
    children: t.children
  });
}
function qc(t) {
  const {
    getProps: e,
    ref: n
  } = G0(), r = "trigger" in t && t.trigger;
  return ce(() => {
    r && t.trigger.current && n(t.trigger.current);
  }, [r]), r ? null : "children" in t && di(t.children) ? Wo(t.children, e(t.children.props)) : null;
}
function wP(t) {
  const {
    context: e,
    previewContext: n,
    open: r,
    preview: i,
    setOpen: o,
    getPreviewFloatingProps: a
  } = G0(), s = Oe((l) => {
    l.preventDefault(), l.stopPropagation(), o(!0);
  }, [o]);
  return !e.open && n.open ? /* @__PURE__ */ g("div", {
    ref: n.floating,
    style: {
      position: n.strategy,
      top: n.y ?? 0,
      left: n.x ?? 0,
      outline: "none",
      opacity: 0
    },
    ...a({
      onClick: s
    }),
    children: i && !r ? /* @__PURE__ */ g("div", {
      onClick: s,
      children: t.children
    }) : null
  }) : null;
}
function Gc(t) {
  const {
    context: e,
    open: n,
    getFloatingProps: r
  } = G0();
  return e.open ? /* @__PURE__ */ g(tP, {
    lockScroll: t.lockScroll,
    style: {
      zIndex: je.zIndex.floating
    },
    children: /* @__PURE__ */ g(q0, {
      context: e,
      children: /* @__PURE__ */ g(qt, {
        children: /* @__PURE__ */ g("div", {
          ref: e.floating,
          style: {
            position: e.strategy,
            top: e.y ?? 0,
            left: e.x ?? 0,
            outline: "none",
            opacity: 0,
            zIndex: je.zIndex.floating
          },
          "data-testid": "collabkit-popover-content",
          ...r({}),
          children: n ? t.children : null
        })
      })
    })
  }) : null;
}
const $4 = he.createContext(null);
function G0() {
  const t = he.useContext($4);
  if (!t)
    throw new Error("usePopoverContext must be used within a Popover");
  return t;
}
function Qc(t) {
  Li();
  const {
    placement: e,
    children: n,
    previewVisible: r,
    contentVisible: i,
    onContentChange: o,
    onPreviewChange: a
  } = t, s = Hc(), l = t.dismissOnClickOutside ?? !0, f = t.shouldFlipToKeepInView ?? !0, {
    reference: c,
    context: u
  } = jo({
    placement: e ?? "right-start",
    open: r,
    whileElementsMounted: $o,
    onOpenChange: a,
    nodeId: s,
    middleware: [Lo(4), ...f ? [Is({
      padding: 24,
      fallbackAxisSideDirection: "start",
      crossAxis: !1,
      fallbackPlacements: ["left-start", "left-end"]
    })] : [], U1({
      padding: 12,
      apply({
        availableWidth: C,
        elements: N
      }) {
        Object.assign(N.floating.style, {
          maxWidth: `${C}px`,
          maxHeight: `${window.innerHeight * 0.88}px`,
          opacity: 1
        });
      }
    }), Ff({
      padding: 24
    })]
  }), {
    reference: d,
    context: h,
    update: p
  } = jo({
    placement: e ?? "right-start",
    open: i,
    whileElementsMounted: $o,
    onOpenChange: o,
    nodeId: s,
    middleware: [Lo(4), ...f ? [Is({
      padding: 24,
      fallbackAxisSideDirection: "start",
      crossAxis: !1,
      fallbackPlacements: ["left-start", "left-end"]
    })] : [], U1({
      padding: 12,
      apply({
        availableWidth: C,
        elements: N
      }) {
        const $ = Math.round(window.innerHeight * 0.88);
        Object.assign(N.floating.style, {
          maxWidth: `${C}px`,
          maxHeight: `${$}px`,
          opacity: 1
        });
      }
    }), Ff({
      padding: 24
    })]
  }), {
    getReferenceProps: m,
    getFloatingProps: v
  } = Kf([k4(u, {
    enabled: !i,
    handleClose: dP()
  }), Vf(u, {
    enabled: l ?? !0
  })]), {
    getReferenceProps: b,
    getFloatingProps: k
  } = Kf([N4(h, {}), Vf(h, {
    escapeKey: !1,
    enabled: l ?? !0
  })]), _ = Yt(() => P4([c, d]), [c, d]), E = (C) => m(b({
    ref: _,
    ...C
  })), S = Yt(() => ({
    previewContext: u,
    context: h,
    getProps: E,
    open: i,
    preview: r,
    setOpen: o,
    ref: _,
    getPreviewFloatingProps: v,
    getFloatingProps: k,
    update: p
  }), [u, h, E, i, r, _]);
  return /* @__PURE__ */ g(W0, {
    id: s,
    children: /* @__PURE__ */ g($4.Provider, {
      value: S,
      children: n
    })
  });
}
function Q0({
  children: t
}) {
  return /* @__PURE__ */ g(ea, {
    id: "collabkit-floating-root",
    children: t
  });
}
var X0 = "_1udouyv0", kP = "_1udouyv1", CP = "_1udouyv2";
const ta = he.createContext(null);
function F4() {
  const t = he.useContext(ta);
  if (t == null)
    throw new Error("[useProfile] Profile context not found");
  return t;
}
function Xc(t) {
  return /* @__PURE__ */ g(ta.Provider, {
    value: t.profileId,
    children: t.children
  });
}
function j4(t) {
  const e = _e(), n = F4(), i = ie(e.profiles)[n];
  return /* @__PURE__ */ g("span", {
    className: kP,
    ...t,
    children: (i == null ? void 0 : i.name) || (i == null ? void 0 : i.email) || "Anonymous"
  });
}
function wv({
  size: t,
  profile: e,
  ...n
}) {
  var r, i;
  return /* @__PURE__ */ g("div", {
    ...n,
    className: n.className ?? X0,
    style: {
      ...t ? {
        width: t,
        height: t,
        lineHeight: t
      } : {},
      ...e.color ? {
        backgroundColor: je.avatar.colors[e.color]
      } : {}
    },
    children: ((r = e.name) == null ? void 0 : r.charAt(0)) || ((i = e.email) == null ? void 0 : i.charAt(0)) || "A"
  });
}
function xP({
  size: t,
  number: e,
  ...n
}) {
  return /* @__PURE__ */ g("div", {
    ...n,
    className: n.className ?? X0,
    style: {
      ...t ? {
        width: t,
        height: t,
        lineHeight: t
      } : {}
    },
    children: e
  });
}
function On({
  size: t,
  ...e
}) {
  const n = _e(), r = pP(), {
    profiles: i,
    avatarErrors: o
  } = ie(n), a = F4(), s = i[a];
  if (s == null)
    return null;
  if (r != null)
    return /* @__PURE__ */ g(K, {
      children: r({
        profile: s,
        size: t
      })
    });
  const l = s.avatar;
  return l ? o[l] ? /* @__PURE__ */ g(wv, {
    size: t,
    profile: s
  }) : /* @__PURE__ */ g("img", {
    src: s.avatar,
    className: X0,
    ...e,
    style: {
      ...t ? {
        width: t,
        height: t,
        lineHeight: t
      } : null
    },
    onError: () => W6(n, {
      avatar: l
    })
  }) : /* @__PURE__ */ g(wv, {
    size: t,
    profile: s
  });
}
function XW(t) {
  return /* @__PURE__ */ g(Xc, {
    profileId: t.profileId,
    children: /* @__PURE__ */ D("div", {
      className: CP,
      ...t,
      children: [/* @__PURE__ */ g(On, {}), /* @__PURE__ */ g(j4, {})]
    })
  });
}
const tr = he.createContext(null);
function xe() {
  const t = he.useContext(tr);
  if (!t)
    throw new Error("ThreadContext not found");
  return t;
}
var EP = Object.create, J0 = Object.defineProperty, TP = Object.getOwnPropertyDescriptor, SP = Object.getOwnPropertyNames, IP = Object.getPrototypeOf, NP = Object.prototype.hasOwnProperty, na = (t, e) => () => (e || t((e = { exports: {} }).exports, e), e.exports), MP = (t, e) => {
  for (var n in e)
    J0(t, n, { get: e[n], enumerable: !0 });
}, AP = (t, e, n, r) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let i of SP(e))
      !NP.call(t, i) && i !== n && J0(t, i, { get: () => e[i], enumerable: !(r = TP(e, i)) || r.enumerable });
  return t;
}, z4 = (t, e, n) => (n = t != null ? EP(IP(t)) : {}, AP(e || !t || !t.__esModule ? J0(n, "default", { value: t, enumerable: !0 }) : n, t)), OP = na((t, e) => {
  var n = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, r = /\n/g, i = /^\s*/, o = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, s = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, l = /^[;\s]*/, f = /^\s+|\s+$/g, c = `
`, u = "/", d = "*", h = "", p = "comment", m = "declaration";
  e.exports = function(b, k) {
    if (typeof b != "string")
      throw new TypeError("First argument must be a string");
    if (!b)
      return [];
    k = k || {};
    var _ = 1, E = 1;
    function S(P) {
      var L = P.match(r);
      L && (_ += L.length);
      var X = P.lastIndexOf(c);
      E = ~X ? P.length - X : E + P.length;
    }
    function C() {
      var P = { line: _, column: E };
      return function(L) {
        return L.position = new N(P), O(), L;
      };
    }
    function N(P) {
      this.start = P, this.end = { line: _, column: E }, this.source = k.source;
    }
    N.prototype.content = b;
    function $(P) {
      var L = new Error(k.source + ":" + _ + ":" + E + ": " + P);
      if (L.reason = P, L.filename = k.source, L.line = _, L.column = E, L.source = b, !k.silent)
        throw L;
    }
    function I(P) {
      var L = P.exec(b);
      if (L) {
        var X = L[0];
        return S(X), b = b.slice(X.length), L;
      }
    }
    function O() {
      I(i);
    }
    function y(P) {
      var L;
      for (P = P || []; L = A(); )
        L !== !1 && P.push(L);
      return P;
    }
    function A() {
      var P = C();
      if (!(u != b.charAt(0) || d != b.charAt(1))) {
        for (var L = 2; h != b.charAt(L) && (d != b.charAt(L) || u != b.charAt(L + 1)); )
          ++L;
        if (L += 2, h === b.charAt(L - 1))
          return $("End of comment missing");
        var X = b.slice(2, L - 2);
        return E += 2, S(X), b = b.slice(L), E += 2, P({ type: p, comment: X });
      }
    }
    function z() {
      var P = C(), L = I(o);
      if (L) {
        if (A(), !I(a))
          return $("property missing ':'");
        var X = I(s), B = P({
          type: m,
          property: v(L[0].replace(n, h)),
          value: X ? v(X[0].replace(n, h)) : h
        });
        return I(l), B;
      }
    }
    function F() {
      var P = [];
      y(P);
      for (var L; L = z(); )
        L !== !1 && (P.push(L), y(P));
      return P;
    }
    return O(), F();
  };
  function v(b) {
    return b ? b.replace(f, h) : h;
  }
}), DP = na((t, e) => {
  var n = OP();
  function r(i, o) {
    var a = null;
    if (!i || typeof i != "string")
      return a;
    for (var s, l = n(i), f = typeof o == "function", c, u, d = 0, h = l.length; d < h; d++)
      s = l[d], c = s.property, u = s.value, f ? o(c, u, s) : u && (a || (a = {}), a[c] = u);
    return a;
  }
  e.exports = r;
}), PP = na((t, e) => {
  e.exports = n;
  function n(l) {
    if (typeof l == "string")
      return a(l);
    if (l == null)
      return s;
    if (typeof l == "object")
      return ("length" in l ? o : i)(l);
    if (typeof l == "function")
      return l;
    throw new Error("Expected function, string, or object as test");
  }
  function r(l) {
    for (var f = [], c = l.length, u = -1; ++u < c; )
      f[u] = n(l[u]);
    return f;
  }
  function i(l) {
    return f;
    function f(c) {
      var u;
      for (u in l)
        if (c[u] !== l[u])
          return !1;
      return !0;
    }
  }
  function o(l) {
    var f = r(l), c = f.length;
    return u;
    function u() {
      for (var d = -1; ++d < c; )
        if (f[d].apply(this, arguments))
          return !0;
      return !1;
    }
  }
  function a(l) {
    return f;
    function f(c) {
      return Boolean(c && c.type === l);
    }
  }
  function s() {
    return !0;
  }
}), RP = na((t, e) => {
  e.exports = a;
  var n = PP(), r = !0, i = "skip", o = !1;
  a.CONTINUE = r, a.SKIP = i, a.EXIT = o;
  function a(l, f, c, u) {
    var d;
    typeof f == "function" && typeof c != "function" && (u = c, c = f, f = null), d = n(f), h(l, null, []);
    function h(m, v, b) {
      var k = [], _;
      return (!f || d(m, v, b[b.length - 1] || null)) && (k = s(c(m, b)), k[0] === o) ? k : m.children && k[0] !== i ? (_ = s(p(m.children, b.concat(m))), _[0] === o ? _ : k) : k;
    }
    function p(m, v) {
      for (var b = -1, k = u ? -1 : 1, _ = (u ? m.length : b) + k, E; _ > b && _ < m.length; ) {
        if (E = h(m[_], _, v), E[0] === o)
          return E;
        _ = typeof E[1] == "number" ? E[1] : _ + k;
      }
    }
  }
  function s(l) {
    return l !== null && typeof l == "object" && "length" in l ? l : typeof l == "number" ? [r, l] : [l];
  }
}), LP = na((t, e) => {
  e.exports = a;
  var n = RP(), r = n.CONTINUE, i = n.SKIP, o = n.EXIT;
  a.CONTINUE = r, a.SKIP = i, a.EXIT = o;
  function a(s, l, f, c) {
    typeof l == "function" && typeof f != "function" && (c = f, f = l, l = null), n(s, l, u, c);
    function u(d, h) {
      var p = h[h.length - 1], m = p ? p.children.indexOf(d) : null;
      return f(d, m, p);
    }
  }
}), $P = na((t, e) => {
  var n = LP(), r = Object.prototype.hasOwnProperty, i = { align: "text-align", valign: "vertical-align", height: "height", width: "width" };
  e.exports = function(s) {
    return n(s, "element", o), s;
  };
  function o(s) {
    if (!(s.tagName !== "tr" && s.tagName !== "td" && s.tagName !== "th")) {
      var l, f;
      for (l in i)
        !r.call(i, l) || s.properties[l] === void 0 || (f = i[l], a(s, f, s.properties[l]), delete s.properties[l]);
    }
  }
  function a(s, l, f) {
    var c = (s.properties.style || "").trim();
    c && !/;\s*/.test(c) && (c += ";"), c && (c += " ");
    var u = c + l + ": " + f + ";";
    s.properties.style = u;
  }
}), Zs = class {
  constructor(e, n, r) {
    this.property = e, this.normal = n, r && (this.space = r);
  }
};
Zs.prototype.property = {};
Zs.prototype.normal = {};
Zs.prototype.space = null;
function B4(t, e) {
  let n = {}, r = {}, i = -1;
  for (; ++i < t.length; )
    Object.assign(n, t[i].property), Object.assign(r, t[i].normal);
  return new Zs(n, r, e);
}
function q1(t) {
  return t.toLowerCase();
}
var pn = class {
  constructor(e, n) {
    this.property = e, this.attribute = n;
  }
};
pn.prototype.space = null;
pn.prototype.boolean = !1;
pn.prototype.booleanish = !1;
pn.prototype.overloadedBoolean = !1;
pn.prototype.number = !1;
pn.prototype.commaSeparated = !1;
pn.prototype.spaceSeparated = !1;
pn.prototype.commaOrSpaceSeparated = !1;
pn.prototype.mustUseProperty = !1;
pn.prototype.defined = !1;
var Yf = {};
MP(Yf, {
  boolean: () => ge,
  booleanish: () => tt,
  commaOrSpaceSeparated: () => Jt,
  commaSeparated: () => _o,
  number: () => U,
  overloadedBoolean: () => W4,
  spaceSeparated: () => We
});
var FP = 0, ge = ji(), tt = ji(), W4 = ji(), U = ji(), We = ji(), _o = ji(), Jt = ji();
function ji() {
  return 2 ** ++FP;
}
var ad = Object.keys(Yf), Z0 = class extends pn {
  constructor(e, n, r, i) {
    let o = -1;
    if (super(e, n), kv(this, "space", i), typeof r == "number")
      for (; ++o < ad.length; ) {
        let a = ad[o];
        kv(this, ad[o], (r & Yf[a]) === Yf[a]);
      }
  }
};
Z0.prototype.defined = !0;
function kv(t, e, n) {
  n && (t[e] = n);
}
var jP = {}.hasOwnProperty;
function ra(t) {
  let e = {}, n = {}, r;
  for (r in t.properties)
    if (jP.call(t.properties, r)) {
      let i = t.properties[r], o = new Z0(r, t.transform(t.attributes || {}, r), i, t.space);
      t.mustUseProperty && t.mustUseProperty.includes(r) && (o.mustUseProperty = !0), e[r] = o, n[q1(r)] = r, n[q1(o.attribute)] = r;
    }
  return new Zs(e, n, t.space);
}
var U4 = ra({
  space: "xlink",
  transform(t, e) {
    return "xlink:" + e.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), H4 = ra({
  space: "xml",
  transform(t, e) {
    return "xml:" + e.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function V4(t, e) {
  return e in t ? t[e] : e;
}
function K4(t, e) {
  return V4(t, e.toLowerCase());
}
var Y4 = ra({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: K4,
  properties: { xmlns: null, xmlnsXLink: null }
}), q4 = ra({
  transform(t, e) {
    return e === "role" ? e : "aria-" + e.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: tt,
    ariaAutoComplete: null,
    ariaBusy: tt,
    ariaChecked: tt,
    ariaColCount: U,
    ariaColIndex: U,
    ariaColSpan: U,
    ariaControls: We,
    ariaCurrent: null,
    ariaDescribedBy: We,
    ariaDetails: null,
    ariaDisabled: tt,
    ariaDropEffect: We,
    ariaErrorMessage: null,
    ariaExpanded: tt,
    ariaFlowTo: We,
    ariaGrabbed: tt,
    ariaHasPopup: null,
    ariaHidden: tt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: We,
    ariaLevel: U,
    ariaLive: null,
    ariaModal: tt,
    ariaMultiLine: tt,
    ariaMultiSelectable: tt,
    ariaOrientation: null,
    ariaOwns: We,
    ariaPlaceholder: null,
    ariaPosInSet: U,
    ariaPressed: tt,
    ariaReadOnly: tt,
    ariaRelevant: null,
    ariaRequired: tt,
    ariaRoleDescription: We,
    ariaRowCount: U,
    ariaRowIndex: U,
    ariaRowSpan: U,
    ariaSelected: tt,
    ariaSetSize: U,
    ariaSort: null,
    ariaValueMax: U,
    ariaValueMin: U,
    ariaValueNow: U,
    ariaValueText: null,
    role: null
  }
}), zP = ra({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: K4,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    abbr: null,
    accept: _o,
    acceptCharset: We,
    accessKey: We,
    action: null,
    allow: null,
    allowFullScreen: ge,
    allowPaymentRequest: ge,
    allowUserMedia: ge,
    alt: null,
    as: null,
    async: ge,
    autoCapitalize: null,
    autoComplete: We,
    autoFocus: ge,
    autoPlay: ge,
    capture: ge,
    charSet: null,
    checked: ge,
    cite: null,
    className: We,
    cols: U,
    colSpan: null,
    content: null,
    contentEditable: tt,
    controls: ge,
    controlsList: We,
    coords: U | _o,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: ge,
    defer: ge,
    dir: null,
    dirName: null,
    disabled: ge,
    download: W4,
    draggable: tt,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: ge,
    formTarget: null,
    headers: We,
    height: U,
    hidden: ge,
    high: U,
    href: null,
    hrefLang: null,
    htmlFor: We,
    httpEquiv: We,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: ge,
    itemId: null,
    itemProp: We,
    itemRef: We,
    itemScope: ge,
    itemType: We,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: ge,
    low: U,
    manifest: null,
    max: null,
    maxLength: U,
    media: null,
    method: null,
    min: null,
    minLength: U,
    multiple: ge,
    muted: ge,
    name: null,
    nonce: null,
    noModule: ge,
    noValidate: ge,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: ge,
    optimum: U,
    pattern: null,
    ping: We,
    placeholder: null,
    playsInline: ge,
    poster: null,
    preload: null,
    readOnly: ge,
    referrerPolicy: null,
    rel: We,
    required: ge,
    reversed: ge,
    rows: U,
    rowSpan: U,
    sandbox: We,
    scope: null,
    scoped: ge,
    seamless: ge,
    selected: ge,
    shape: null,
    size: U,
    sizes: null,
    slot: null,
    span: U,
    spellCheck: tt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: U,
    step: null,
    style: null,
    tabIndex: U,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: ge,
    useMap: null,
    value: tt,
    width: U,
    wrap: null,
    align: null,
    aLink: null,
    archive: We,
    axis: null,
    background: null,
    bgColor: null,
    border: U,
    borderColor: null,
    bottomMargin: U,
    cellPadding: null,
    cellSpacing: null,
    char: null,
    charOff: null,
    classId: null,
    clear: null,
    code: null,
    codeBase: null,
    codeType: null,
    color: null,
    compact: ge,
    declare: ge,
    event: null,
    face: null,
    frame: null,
    frameBorder: null,
    hSpace: U,
    leftMargin: U,
    link: null,
    longDesc: null,
    lowSrc: null,
    marginHeight: U,
    marginWidth: U,
    noResize: ge,
    noHref: ge,
    noShade: ge,
    noWrap: ge,
    object: null,
    profile: null,
    prompt: null,
    rev: null,
    rightMargin: U,
    rules: null,
    scheme: null,
    scrolling: tt,
    standby: null,
    summary: null,
    text: null,
    topMargin: U,
    valueType: null,
    version: null,
    vAlign: null,
    vLink: null,
    vSpace: U,
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: ge,
    disableRemotePlayback: ge,
    prefix: null,
    property: null,
    results: U,
    security: null,
    unselectable: null
  }
}), BP = ra({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: V4,
  properties: {
    about: Jt,
    accentHeight: U,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: U,
    amplitude: U,
    arabicForm: null,
    ascent: U,
    attributeName: null,
    attributeType: null,
    azimuth: U,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: U,
    by: null,
    calcMode: null,
    capHeight: U,
    className: We,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: U,
    diffuseConstant: U,
    direction: null,
    display: null,
    dur: null,
    divisor: U,
    dominantBaseline: null,
    download: ge,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: U,
    enableBackground: null,
    end: null,
    event: null,
    exponent: U,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: U,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: _o,
    g2: _o,
    glyphName: _o,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: U,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: U,
    horizOriginX: U,
    horizOriginY: U,
    id: null,
    ideographic: U,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: U,
    k: U,
    k1: U,
    k2: U,
    k3: U,
    k4: U,
    kernelMatrix: Jt,
    kernelUnitLength: null,
    keyPoints: null,
    keySplines: null,
    keyTimes: null,
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: U,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: U,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: U,
    overlineThickness: U,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: U,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: We,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: U,
    pointsAtY: U,
    pointsAtZ: U,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Jt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Jt,
    rev: Jt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Jt,
    requiredFeatures: Jt,
    requiredFonts: Jt,
    requiredFormats: Jt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: U,
    specularExponent: U,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: U,
    strikethroughThickness: U,
    string: null,
    stroke: null,
    strokeDashArray: Jt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: U,
    strokeOpacity: U,
    strokeWidth: null,
    style: null,
    surfaceScale: U,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Jt,
    tabIndex: U,
    tableValues: null,
    target: null,
    targetX: U,
    targetY: U,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Jt,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: U,
    underlineThickness: U,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: U,
    values: null,
    vAlphabetic: U,
    vMathematical: U,
    vectorEffect: null,
    vHanging: U,
    vIdeographic: U,
    version: null,
    vertAdvY: U,
    vertOriginX: U,
    vertOriginY: U,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: U,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), WP = /^data[-\w.:]+$/i, Cv = /-[a-z]/g, UP = /[A-Z]/g;
function HP(t, e) {
  let n = q1(e), r = e, i = pn;
  if (n in t.normal)
    return t.property[t.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && WP.test(e)) {
    if (e.charAt(4) === "-") {
      let o = e.slice(5).replace(Cv, KP);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      let o = e.slice(4);
      if (!Cv.test(o)) {
        let a = o.replace(UP, VP);
        a.charAt(0) !== "-" && (a = "-" + a), e = "data" + a;
      }
    }
    i = Z0;
  }
  return new i(r, e);
}
function VP(t) {
  return "-" + t.toLowerCase();
}
function KP(t) {
  return t.charAt(1).toUpperCase();
}
var YP = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, qP = B4([H4, U4, Y4, q4, zP], "html"), G4 = B4([H4, U4, Y4, q4, BP], "svg");
function GP(t) {
  return t.join(" ").trim();
}
function QP(t, e) {
  var n = e || {};
  return t[t.length - 1] === "" && (t = t.concat("")), t.join((n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")).trim();
}
var XP = z4(DP(), 1), JP = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, Jc = function(t) {
  if (t == null)
    return nR;
  if (typeof t == "string")
    return tR(t);
  if (typeof t == "object")
    return Array.isArray(t) ? ZP(t) : eR(t);
  if (typeof t == "function")
    return Zc(t);
  throw new Error("Expected function, string, or object as test");
};
function ZP(t) {
  let e = [], n = -1;
  for (; ++n < t.length; )
    e[n] = Jc(t[n]);
  return Zc(r);
  function r(...i) {
    let o = -1;
    for (; ++o < e.length; )
      if (e[o].call(this, ...i))
        return !0;
    return !1;
  }
}
function eR(t) {
  return Zc(e);
  function e(n) {
    let r;
    for (r in t)
      if (n[r] !== t[r])
        return !1;
    return !0;
  }
}
function tR(t) {
  return Zc(e);
  function e(n) {
    return n && n.type === t;
  }
}
function Zc(t) {
  return e;
  function e(...n) {
    return Boolean(t.call(this, ...n));
  }
}
function nR() {
  return !0;
}
var rR = JP, iR = YP, oR = {}.hasOwnProperty, aR = Jc("root"), G1 = Jc("element"), sR = Jc("text");
function lR(t, e, n) {
  if (typeof t != "function")
    throw new TypeError("h is not a function");
  let r = cR(t), i = hR(t), o = dR(t), a, s;
  if (typeof n == "string" || typeof n == "boolean" ? (a = n, n = {}) : (n || (n = {}), a = n.prefix), aR(e))
    s = e.children.length === 1 && G1(e.children[0]) ? e.children[0] : { type: "element", tagName: "div", properties: {}, children: e.children };
  else if (G1(e))
    s = e;
  else
    throw new Error("Expected root or element, not `" + (e && e.type || e) + "`");
  return Q4(t, s, {
    schema: n.space === "svg" ? G4 : qP,
    prefix: a == null ? r || i || o ? "h-" : null : typeof a == "string" ? a : a ? "h-" : null,
    key: 0,
    react: r,
    vue: i,
    vdom: o,
    hyperscript: uR(t)
  });
}
function Q4(t, e, n) {
  let r = n.schema, i = r, o = e.tagName, a = {}, s = [], l = -1, f;
  r.space === "html" && o.toLowerCase() === "svg" && (i = G4, n.schema = i);
  for (f in e.properties)
    e.properties && oR.call(e.properties, f) && fR(a, f, e.properties[f], n, o);
  if (n.vdom && (i.space === "html" ? o = o.toUpperCase() : i.space && (a.namespace = rR[i.space])), n.prefix && (n.key++, a.key = n.prefix + n.key), e.children)
    for (; ++l < e.children.length; ) {
      let c = e.children[l];
      G1(c) ? s.push(Q4(t, c, n)) : sR(c) && s.push(c.value);
    }
  return n.schema = r, s.length > 0 ? t.call(e, o, a, s) : t.call(e, o, a);
}
function fR(t, e, n, r, i) {
  let o = HP(r.schema, e), a;
  n == null || typeof n == "number" && Number.isNaN(n) || n === !1 && (r.vue || r.vdom || r.hyperscript) || !n && o.boolean && (r.vue || r.vdom || r.hyperscript) || (Array.isArray(n) && (n = o.commaSeparated ? QP(n) : GP(n)), o.boolean && r.hyperscript && (n = ""), o.property === "style" && typeof n == "string" && (r.react || r.vue || r.vdom) && (n = gR(n, i)), r.vue ? o.property !== "style" && (a = "attrs") : o.mustUseProperty || (r.vdom ? o.property !== "style" && (a = "attributes") : r.hyperscript && (a = "attrs")), a ? t[a] = Object.assign(t[a] || {}, { [o.attribute]: n }) : o.space && r.react ? t[iR[o.property] || o.property] = n : t[o.attribute] = n);
}
function cR(t) {
  let e = t("div", {});
  return Boolean(e && ("_owner" in e || "_store" in e) && (e.key === void 0 || e.key === null));
}
function uR(t) {
  return "context" in t && "cleanup" in t;
}
function dR(t) {
  return t("div", {}).type === "VirtualNode";
}
function hR(t) {
  let e = t("div", {});
  return Boolean(e && e.context && e.context._isVue);
}
function gR(t, e) {
  let n = {};
  try {
    (0, XP.default)(t, (r, i) => {
      r.slice(0, 4) === "-ms-" && (r = "ms-" + r.slice(4)), n[r.replace(/-([a-z])/g, (o, a) => a.toUpperCase())] = i;
    });
  } catch (r) {
    throw r.message = e + "[style]" + r.message.slice(9), r;
  }
  return n;
}
var pR = z4($P(), 1);
function mR(t) {
  var e = t && typeof t == "object" && t.type === "text" ? t.value || "" : t;
  return typeof e == "string" && e.replace(/[ \t\n\f\r]/g, "") === "";
}
var vR = {}.hasOwnProperty, bR = /* @__PURE__ */ new Set(["table", "thead", "tbody", "tfoot", "tr", "th", "td"]);
function yR(t) {
  if (!t || typeof t.createElement != "function")
    throw new TypeError("createElement is not a function");
  let e = t.createElement;
  Object.assign(this, { Compiler: n });
  function n(i) {
    let o = lR(r, (0, pR.default)(i), t.prefix);
    return i.type === "root" ? (o = o && typeof o == "object" && "type" in o && "props" in o && o.type === "div" && (i.children.length !== 1 || i.children[0].type !== "element") ? o.props.children : [o], e(t.Fragment || "div", {}, o)) : o;
  }
  function r(i, o, a) {
    if (a && bR.has(i) && (a = a.filter((s) => !mR(s))), t.components && vR.call(t.components, i)) {
      let s = t.components[i];
      return t.passNode && typeof s == "function" && (o = Object.assign({ node: this }, o)), e(s, o, a);
    }
    return e(i, o, a);
  }
}
var st = function(t, e, n) {
  var r = { type: String(t) };
  return n == null && (typeof e == "string" || Array.isArray(e)) ? n = e : Object.assign(r, e), Array.isArray(n) ? r.children = n : n != null && (r.value = String(n)), r;
}, $l = {}.hasOwnProperty;
function _R(t, e) {
  let n = e.data || {};
  return "value" in e && !($l.call(n, "hName") || $l.call(n, "hProperties") || $l.call(n, "hChildren")) ? t.augment(e, st("text", e.value)) : t(e, "div", Nt(t, e));
}
function X4(t, e, n) {
  let r = e && e.type, i;
  if (!r)
    throw new Error("Expected node, got `" + e + "`");
  return $l.call(t.handlers, r) ? i = t.handlers[r] : t.passThrough && t.passThrough.includes(r) ? i = wR : i = t.unknownHandler, (typeof i == "function" ? i : _R)(t, e, n);
}
function wR(t, e) {
  return "children" in e ? { ...e, children: Nt(t, e) } : e;
}
function Nt(t, e) {
  let n = [];
  if ("children" in e) {
    let r = e.children, i = -1;
    for (; ++i < r.length; ) {
      let o = X4(t, r[i], e);
      if (o) {
        if (i && r[i - 1].type === "break" && (!Array.isArray(o) && o.type === "text" && (o.value = o.value.replace(/^\s+/, "")), !Array.isArray(o) && o.type === "element")) {
          let a = o.children[0];
          a && a.type === "text" && (a.value = a.value.replace(/^\s+/, ""));
        }
        Array.isArray(o) ? n.push(...o) : n.push(o);
      }
    }
  }
  return n;
}
var J4 = function(t) {
  if (t == null)
    return ER;
  if (typeof t == "string")
    return xR(t);
  if (typeof t == "object")
    return Array.isArray(t) ? kR(t) : CR(t);
  if (typeof t == "function")
    return eu(t);
  throw new Error("Expected function, string, or object as test");
};
function kR(t) {
  let e = [], n = -1;
  for (; ++n < t.length; )
    e[n] = J4(t[n]);
  return eu(r);
  function r(...i) {
    let o = -1;
    for (; ++o < e.length; )
      if (e[o].call(this, ...i))
        return !0;
    return !1;
  }
}
function CR(t) {
  return eu(e);
  function e(n) {
    let r;
    for (r in t)
      if (n[r] !== t[r])
        return !1;
    return !0;
  }
}
function xR(t) {
  return eu(e);
  function e(n) {
    return n && n.type === t;
  }
}
function eu(t) {
  return e;
  function e(...n) {
    return Boolean(t.call(this, ...n));
  }
}
function ER() {
  return !0;
}
var TR = !0, SR = "skip", xv = !1, IR = function(t, e, n, r) {
  typeof e == "function" && typeof n != "function" && (r = n, n = e, e = null);
  let i = J4(e), o = r ? -1 : 1;
  a(t, null, [])();
  function a(s, l, f) {
    let c = typeof s == "object" && s !== null ? s : {}, u;
    return typeof c.type == "string" && (u = typeof c.tagName == "string" ? c.tagName : typeof c.name == "string" ? c.name : void 0, Object.defineProperty(d, "name", { value: "node (" + (c.type + (u ? "<" + u + ">" : "")) + ")" })), d;
    function d() {
      let h = [], p, m, v;
      if ((!e || i(s, l, f[f.length - 1] || null)) && (h = NR(n(s, f)), h[0] === xv))
        return h;
      if (s.children && h[0] !== SR)
        for (m = (r ? s.children.length : -1) + o, v = f.concat(s); m > -1 && m < s.children.length; ) {
          if (p = a(s.children[m], m, v)(), p[0] === xv)
            return p;
          m = typeof p[1] == "number" ? p[1] : m + o;
        }
      return h;
    }
  }
};
function NR(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [TR, t] : [t];
}
var Z4 = function(t, e, n, r) {
  typeof e == "function" && typeof n != "function" && (r = n, n = e, e = null), IR(t, e, i, r);
  function i(o, a) {
    let s = a[a.length - 1];
    return n(o, s ? s.children.indexOf(o) : null, s);
  }
}, e3 = n3("start"), t3 = n3("end");
function n3(t) {
  return e;
  function e(n) {
    let r = n && n.position && n.position[t] || {};
    return { line: r.line || null, column: r.column || null, offset: r.offset > -1 ? r.offset : null };
  }
}
function MR(t) {
  return !t || !t.position || !t.position.start || !t.position.start.line || !t.position.start.column || !t.position.end || !t.position.end.line || !t.position.end.column;
}
var Ev = {}.hasOwnProperty;
function AR(t) {
  let e = /* @__PURE__ */ Object.create(null);
  if (!t || !t.type)
    throw new Error("mdast-util-definitions expected node");
  return Z4(t, "definition", (r) => {
    let i = Tv(r.identifier);
    i && !Ev.call(e, i) && (e[i] = r);
  }), n;
  function n(r) {
    let i = Tv(r);
    return i && Ev.call(e, i) ? e[i] : null;
  }
}
function Tv(t) {
  return String(t || "").toUpperCase();
}
var Sv = OR(/[\dA-Za-z]/);
function OR(t) {
  return e;
  function e(n) {
    return n !== null && t.test(String.fromCharCode(n));
  }
}
function ia(t) {
  let e = [], n = -1, r = 0, i = 0;
  for (; ++n < t.length; ) {
    let o = t.charCodeAt(n), a = "";
    if (o === 37 && Sv(t.charCodeAt(n + 1)) && Sv(t.charCodeAt(n + 2)))
      i = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (a = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      let s = t.charCodeAt(n + 1);
      o < 56320 && s > 56319 && s < 57344 ? (a = String.fromCharCode(o, s), i = 1) : a = "�";
    } else
      a = String.fromCharCode(o);
    a && (e.push(t.slice(r, n), encodeURIComponent(a)), r = n + i + 1, a = ""), i && (n += i, i = 0);
  }
  return e.join("") + t.slice(r);
}
function cr(t, e) {
  let n = [], r = -1;
  for (e && n.push(st("text", `
`)); ++r < t.length; )
    r && n.push(st("text", `
`)), n.push(t[r]);
  return e && t.length > 0 && n.push(st("text", `
`)), n;
}
function DR(t) {
  let e = -1, n = [];
  for (; ++e < t.footnoteOrder.length; ) {
    let r = t.footnoteById[t.footnoteOrder[e].toUpperCase()];
    if (!r)
      continue;
    let i = Nt(t, r), o = String(r.identifier), a = ia(o.toLowerCase()), s = 0, l = [];
    for (; ++s <= t.footnoteCounts[o]; ) {
      let u = { type: "element", tagName: "a", properties: { href: "#" + t.clobberPrefix + "fnref-" + a + (s > 1 ? "-" + s : ""), dataFootnoteBackref: !0, className: ["data-footnote-backref"], ariaLabel: t.footnoteBackLabel }, children: [{ type: "text", value: "↩" }] };
      s > 1 && u.children.push({ type: "element", tagName: "sup", children: [{ type: "text", value: String(s) }] }), l.length > 0 && l.push({ type: "text", value: " " }), l.push(u);
    }
    let f = i[i.length - 1];
    if (f && f.type === "element" && f.tagName === "p") {
      let u = f.children[f.children.length - 1];
      u && u.type === "text" ? u.value += " " : f.children.push({ type: "text", value: " " }), f.children.push(...l);
    } else
      i.push(...l);
    let c = { type: "element", tagName: "li", properties: { id: t.clobberPrefix + "fn-" + a }, children: cr(i, !0) };
    r.position && (c.position = r.position), n.push(c);
  }
  return n.length === 0 ? null : { type: "element", tagName: "section", properties: { dataFootnotes: !0, className: ["footnotes"] }, children: [{ type: "element", tagName: t.footnoteLabelTagName, properties: { ...JSON.parse(JSON.stringify(t.footnoteLabelProperties)), id: "footnote-label" }, children: [st("text", t.footnoteLabel)] }, { type: "text", value: `
` }, { type: "element", tagName: "ol", properties: {}, children: cr(n, !0) }, { type: "text", value: `
` }] };
}
function PR(t, e) {
  return t(e, "blockquote", cr(Nt(t, e), !0));
}
function RR(t, e) {
  return [t(e, "br"), st("text", `
`)];
}
function LR(t, e) {
  let n = e.value ? e.value + `
` : "", r = e.lang && e.lang.match(/^[^ \t]+(?=[ \t]|$)/), i = {};
  r && (i.className = ["language-" + r]);
  let o = t(e, "code", i, [st("text", n)]);
  return e.meta && (o.data = { meta: e.meta }), t(e.position, "pre", [o]);
}
function $R(t, e) {
  return t(e, "del", Nt(t, e));
}
function FR(t, e) {
  return t(e, "em", Nt(t, e));
}
function r3(t, e) {
  let n = String(e.identifier), r = ia(n.toLowerCase()), i = t.footnoteOrder.indexOf(n), o;
  i === -1 ? (t.footnoteOrder.push(n), t.footnoteCounts[n] = 1, o = t.footnoteOrder.length) : (t.footnoteCounts[n]++, o = i + 1);
  let a = t.footnoteCounts[n];
  return t(e, "sup", [t(e.position, "a", { href: "#" + t.clobberPrefix + "fn-" + r, id: t.clobberPrefix + "fnref-" + r + (a > 1 ? "-" + a : ""), dataFootnoteRef: !0, ariaDescribedBy: "footnote-label" }, [st("text", String(o))])]);
}
function jR(t, e) {
  let n = t.footnoteById, r = 1;
  for (; r in n; )
    r++;
  let i = String(r);
  return n[i] = { type: "footnoteDefinition", identifier: i, children: [{ type: "paragraph", children: e.children }], position: e.position }, r3(t, { type: "footnoteReference", identifier: i, position: e.position });
}
function zR(t, e) {
  return t(e, "h" + e.depth, Nt(t, e));
}
function BR(t, e) {
  return t.dangerous ? t.augment(e, st("raw", e.value)) : null;
}
function i3(t, e) {
  let n = e.referenceType, r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (e.label || e.identifier) + "]"), e.type === "imageReference")
    return st("text", "![" + e.alt + r);
  let i = Nt(t, e), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift(st("text", "["));
  let a = i[i.length - 1];
  return a && a.type === "text" ? a.value += r : i.push(st("text", r)), i;
}
function WR(t, e) {
  let n = t.definition(e.identifier);
  if (!n)
    return i3(t, e);
  let r = { src: ia(n.url || ""), alt: e.alt };
  return n.title !== null && n.title !== void 0 && (r.title = n.title), t(e, "img", r);
}
function UR(t, e) {
  let n = { src: ia(e.url), alt: e.alt };
  return e.title !== null && e.title !== void 0 && (n.title = e.title), t(e, "img", n);
}
function HR(t, e) {
  return t(e, "code", [st("text", e.value.replace(/\r?\n|\r/g, " "))]);
}
function VR(t, e) {
  let n = t.definition(e.identifier);
  if (!n)
    return i3(t, e);
  let r = { href: ia(n.url || "") };
  return n.title !== null && n.title !== void 0 && (r.title = n.title), t(e, "a", r, Nt(t, e));
}
function KR(t, e) {
  let n = { href: ia(e.url) };
  return e.title !== null && e.title !== void 0 && (n.title = e.title), t(e, "a", n, Nt(t, e));
}
function YR(t, e, n) {
  let r = Nt(t, e), i = n ? qR(n) : o3(e), o = {}, a = [];
  if (typeof e.checked == "boolean") {
    let f;
    r[0] && r[0].type === "element" && r[0].tagName === "p" ? f = r[0] : (f = t(null, "p", []), r.unshift(f)), f.children.length > 0 && f.children.unshift(st("text", " ")), f.children.unshift(t(null, "input", { type: "checkbox", checked: e.checked, disabled: !0 })), o.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < r.length; ) {
    let f = r[s];
    (i || s !== 0 || f.type !== "element" || f.tagName !== "p") && a.push(st("text", `
`)), f.type === "element" && f.tagName === "p" && !i ? a.push(...f.children) : a.push(f);
  }
  let l = r[r.length - 1];
  return l && (i || !("tagName" in l) || l.tagName !== "p") && a.push(st("text", `
`)), t(e, "li", o, a);
}
function qR(t) {
  let e = t.spread, n = t.children, r = -1;
  for (; !e && ++r < n.length; )
    e = o3(n[r]);
  return Boolean(e);
}
function o3(t) {
  return t.spread ?? t.children.length > 1;
}
function GR(t, e) {
  let n = {}, r = e.ordered ? "ol" : "ul", i = Nt(t, e), o = -1;
  for (typeof e.start == "number" && e.start !== 1 && (n.start = e.start); ++o < i.length; ) {
    let a = i[o];
    if (a.type === "element" && a.tagName === "li" && a.properties && Array.isArray(a.properties.className) && a.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  return t(e, r, n, cr(i, !0));
}
function QR(t, e) {
  return t(e, "p", Nt(t, e));
}
function XR(t, e) {
  return t.augment(e, st("root", cr(Nt(t, e))));
}
function JR(t, e) {
  return t(e, "strong", Nt(t, e));
}
function ZR(t, e) {
  let n = e.children, r = -1, i = e.align || [], o = [];
  for (; ++r < n.length; ) {
    let a = n[r].children, s = r === 0 ? "th" : "td", l = [], f = -1, c = e.align ? i.length : a.length;
    for (; ++f < c; ) {
      let u = a[f];
      l.push(t(u, s, { align: i[f] }, u ? Nt(t, u) : []));
    }
    o[r] = t(n[r], "tr", cr(l, !0));
  }
  return t(e, "table", cr([t(o[0].position, "thead", cr([o[0]], !0))].concat(o[1] ? t({ start: e3(o[1]), end: t3(o[o.length - 1]) }, "tbody", cr(o.slice(1), !0)) : []), !0));
}
function e8(t) {
  let e = String(t), n = /\r?\n|\r/g, r = n.exec(e), i = 0, o = [];
  for (; r; )
    o.push(Iv(e.slice(i, r.index), i > 0, !0), r[0]), i = r.index + r[0].length, r = n.exec(e);
  return o.push(Iv(e.slice(i), i > 0, !1)), o.join("");
}
function Iv(t, e, n) {
  let r = 0, i = t.length;
  if (e) {
    let o = t.codePointAt(r);
    for (; o === 9 || o === 32; )
      r++, o = t.codePointAt(r);
  }
  if (n) {
    let o = t.codePointAt(i - 1);
    for (; o === 9 || o === 32; )
      i--, o = t.codePointAt(i - 1);
  }
  return i > r ? t.slice(r, i) : "";
}
function t8(t, e) {
  return t.augment(e, st("text", e8(String(e.value))));
}
function n8(t, e) {
  return t(e, "hr");
}
var r8 = { blockquote: PR, break: RR, code: LR, delete: $R, emphasis: FR, footnoteReference: r3, footnote: jR, heading: zR, html: BR, imageReference: WR, image: UR, inlineCode: HR, linkReference: VR, link: KR, listItem: YR, list: GR, paragraph: QR, root: XR, strong: JR, table: ZR, text: t8, thematicBreak: n8, toml: ml, yaml: ml, definition: ml, footnoteDefinition: ml };
function ml() {
  return null;
}
var i8 = {}.hasOwnProperty;
function o8(t, e) {
  let n = e || {}, r = n.allowDangerousHtml || !1, i = {};
  return a.dangerous = r, a.clobberPrefix = n.clobberPrefix === void 0 || n.clobberPrefix === null ? "user-content-" : n.clobberPrefix, a.footnoteLabel = n.footnoteLabel || "Footnotes", a.footnoteLabelTagName = n.footnoteLabelTagName || "h2", a.footnoteLabelProperties = n.footnoteLabelProperties || { className: ["sr-only"] }, a.footnoteBackLabel = n.footnoteBackLabel || "Back to content", a.definition = AR(t), a.footnoteById = i, a.footnoteOrder = [], a.footnoteCounts = {}, a.augment = o, a.handlers = { ...r8, ...n.handlers }, a.unknownHandler = n.unknownHandler, a.passThrough = n.passThrough, Z4(t, "footnoteDefinition", (s) => {
    let l = String(s.identifier).toUpperCase();
    i8.call(i, l) || (i[l] = s);
  }), a;
  function o(s, l) {
    if (s && "data" in s && s.data) {
      let f = s.data;
      f.hName && (l.type !== "element" && (l = { type: "element", tagName: "", properties: {}, children: [] }), l.tagName = f.hName), l.type === "element" && f.hProperties && (l.properties = { ...l.properties, ...f.hProperties }), "children" in l && l.children && f.hChildren && (l.children = f.hChildren);
    }
    if (s) {
      let f = "type" in s ? s : { position: s };
      MR(f) || (l.position = { start: e3(f), end: t3(f) });
    }
    return l;
  }
  function a(s, l, f, c) {
    return Array.isArray(f) && (c = f, f = {}), o(s, { type: "element", tagName: l, properties: f || {}, children: c || [] });
  }
}
function a3(t, e) {
  let n = o8(t, e), r = X4(n, t, null), i = DR(n);
  return i && r.children.push(st("text", `
`), i), Array.isArray(r) ? { type: "root", children: r } : r;
}
var a8 = function(t, e) {
  return t && "run" in t ? l8(t, e) : f8(t || e);
}, s8 = a8;
function l8(t, e) {
  return (n, r, i) => {
    t.run(a3(n, e), r, (o) => {
      i(o);
    });
  };
}
function f8(t) {
  return (e) => a3(e, t);
}
var c8 = Object.defineProperty, u8 = (t, e) => {
  for (var n in e)
    c8(t, n, { get: e[n], enumerable: !0 });
};
function d8(t, e) {
  var { includeImageAlt: n = !0 } = e || {};
  return s3(t, n);
}
function s3(t, e) {
  return t && typeof t == "object" && (t.value || (e ? t.alt : "") || "children" in t && Nv(t.children, e) || Array.isArray(t) && Nv(t, e)) || "";
}
function Nv(t, e) {
  for (var n = [], r = -1; ++r < t.length; )
    n[r] = s3(t[r], e);
  return n.join("");
}
function Yn(t, e, n, r) {
  let i = t.length, o = 0, a;
  if (e < 0 ? e = -e > i ? 0 : i + e : e = e > i ? i : e, n = n > 0 ? n : 0, r.length < 1e4)
    a = Array.from(r), a.unshift(e, n), [].splice.apply(t, a);
  else
    for (n && [].splice.apply(t, [e, n]); o < r.length; )
      a = r.slice(o, o + 1e4), a.unshift(e, 0), [].splice.apply(t, a), o += 1e4, e += 1e4;
}
function an(t, e) {
  return t.length > 0 ? (Yn(t, t.length, 0, e), t) : e;
}
var Mv = {}.hasOwnProperty;
function h8(t) {
  let e = {}, n = -1;
  for (; ++n < t.length; )
    g8(e, t[n]);
  return e;
}
function g8(t, e) {
  let n;
  for (n in e) {
    let r = (Mv.call(t, n) ? t[n] : void 0) || (t[n] = {}), i = e[n], o;
    for (o in i) {
      Mv.call(r, o) || (r[o] = []);
      let a = i[o];
      p8(r[o], Array.isArray(a) ? a : a ? [a] : []);
    }
  }
}
function p8(t, e) {
  let n = -1, r = [];
  for (; ++n < e.length; )
    (e[n].add === "after" ? t : r).push(e[n]);
  Yn(t, 0, 0, r);
}
var m8 = /[!-/:-@[-`{-~\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, jn = Hr(/[A-Za-z]/), Q1 = Hr(/\d/), v8 = Hr(/[\dA-Fa-f]/), In = Hr(/[\dA-Za-z]/), b8 = Hr(/[!-/:-@[-`{-~]/), Av = Hr(/[#-'*+\--9=?A-Z^-~]/);
function X1(t) {
  return t !== null && (t < 32 || t === 127);
}
function un(t) {
  return t !== null && (t < 0 || t === 32);
}
function le(t) {
  return t !== null && t < -2;
}
function nt(t) {
  return t === -2 || t === -1 || t === 32;
}
var y8 = Hr(/\s/), _8 = Hr(m8);
function Hr(t) {
  return e;
  function e(n) {
    return n !== null && t.test(String.fromCharCode(n));
  }
}
function Le(t, e, n, r) {
  let i = r ? r - 1 : Number.POSITIVE_INFINITY, o = 0;
  return a;
  function a(l) {
    return nt(l) ? (t.enter(n), s(l)) : e(l);
  }
  function s(l) {
    return nt(l) && o++ < i ? (t.consume(l), s) : (t.exit(n), e(l));
  }
}
var w8 = { tokenize: k8 };
function k8(t) {
  let e = t.attempt(this.parser.constructs.contentInitial, r, i), n;
  return e;
  function r(s) {
    if (s === null) {
      t.consume(s);
      return;
    }
    return t.enter("lineEnding"), t.consume(s), t.exit("lineEnding"), Le(t, e, "linePrefix");
  }
  function i(s) {
    return t.enter("paragraph"), o(s);
  }
  function o(s) {
    let l = t.enter("chunkText", { contentType: "text", previous: n });
    return n && (n.next = l), n = l, a(s);
  }
  function a(s) {
    if (s === null) {
      t.exit("chunkText"), t.exit("paragraph"), t.consume(s);
      return;
    }
    return le(s) ? (t.consume(s), t.exit("chunkText"), o) : (t.consume(s), a);
  }
}
var C8 = { tokenize: x8 }, Ov = { tokenize: E8 };
function x8(t) {
  let e = this, n = [], r = 0, i, o, a;
  return s;
  function s(_) {
    if (r < n.length) {
      let E = n[r];
      return e.containerState = E[1], t.attempt(E[0].continuation, l, f)(_);
    }
    return f(_);
  }
  function l(_) {
    if (r++, e.containerState._closeFlow) {
      e.containerState._closeFlow = void 0, i && k();
      let E = e.events.length, S = E, C;
      for (; S--; )
        if (e.events[S][0] === "exit" && e.events[S][1].type === "chunkFlow") {
          C = e.events[S][1].end;
          break;
        }
      b(r);
      let N = E;
      for (; N < e.events.length; )
        e.events[N][1].end = Object.assign({}, C), N++;
      return Yn(e.events, S + 1, 0, e.events.slice(E)), e.events.length = N, f(_);
    }
    return s(_);
  }
  function f(_) {
    if (r === n.length) {
      if (!i)
        return d(_);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return p(_);
      e.interrupt = Boolean(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return e.containerState = {}, t.check(Ov, c, u)(_);
  }
  function c(_) {
    return i && k(), b(r), d(_);
  }
  function u(_) {
    return e.parser.lazy[e.now().line] = r !== n.length, a = e.now().offset, p(_);
  }
  function d(_) {
    return e.containerState = {}, t.attempt(Ov, h, p)(_);
  }
  function h(_) {
    return r++, n.push([e.currentConstruct, e.containerState]), d(_);
  }
  function p(_) {
    if (_ === null) {
      i && k(), b(0), t.consume(_);
      return;
    }
    return i = i || e.parser.flow(e.now()), t.enter("chunkFlow", { contentType: "flow", previous: o, _tokenizer: i }), m(_);
  }
  function m(_) {
    if (_ === null) {
      v(t.exit("chunkFlow"), !0), b(0), t.consume(_);
      return;
    }
    return le(_) ? (t.consume(_), v(t.exit("chunkFlow")), r = 0, e.interrupt = void 0, s) : (t.consume(_), m);
  }
  function v(_, E) {
    let S = e.sliceStream(_);
    if (E && S.push(null), _.previous = o, o && (o.next = _), o = _, i.defineSkip(_.start), i.write(S), e.parser.lazy[_.start.line]) {
      let C = i.events.length;
      for (; C--; )
        if (i.events[C][1].start.offset < a && (!i.events[C][1].end || i.events[C][1].end.offset > a))
          return;
      let N = e.events.length, $ = N, I, O;
      for (; $--; )
        if (e.events[$][0] === "exit" && e.events[$][1].type === "chunkFlow") {
          if (I) {
            O = e.events[$][1].end;
            break;
          }
          I = !0;
        }
      for (b(r), C = N; C < e.events.length; )
        e.events[C][1].end = Object.assign({}, O), C++;
      Yn(e.events, $ + 1, 0, e.events.slice(N)), e.events.length = C;
    }
  }
  function b(_) {
    let E = n.length;
    for (; E-- > _; ) {
      let S = n[E];
      e.containerState = S[1], S[0].exit.call(e, t);
    }
    n.length = _;
  }
  function k() {
    i.write([null]), o = void 0, i = void 0, e.containerState._closeFlow = void 0;
  }
}
function E8(t, e, n) {
  return Le(
    t,
    t.attempt(this.parser.constructs.document, e, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function Dv(t) {
  if (t === null || un(t) || y8(t))
    return 1;
  if (_8(t))
    return 2;
}
function eg(t, e, n) {
  let r = [], i = -1;
  for (; ++i < t.length; ) {
    let o = t[i].resolveAll;
    o && !r.includes(o) && (e = o(e, n), r.push(o));
  }
  return e;
}
var J1 = { name: "attention", tokenize: S8, resolveAll: T8 };
function T8(t, e) {
  let n = -1, r, i, o, a, s, l, f, c;
  for (; ++n < t.length; )
    if (t[n][0] === "enter" && t[n][1].type === "attentionSequence" && t[n][1]._close) {
      for (r = n; r--; )
        if (t[r][0] === "exit" && t[r][1].type === "attentionSequence" && t[r][1]._open && e.sliceSerialize(t[r][1]).charCodeAt(0) === e.sliceSerialize(t[n][1]).charCodeAt(0)) {
          if ((t[r][1]._close || t[n][1]._open) && (t[n][1].end.offset - t[n][1].start.offset) % 3 && !((t[r][1].end.offset - t[r][1].start.offset + t[n][1].end.offset - t[n][1].start.offset) % 3))
            continue;
          l = t[r][1].end.offset - t[r][1].start.offset > 1 && t[n][1].end.offset - t[n][1].start.offset > 1 ? 2 : 1;
          let u = Object.assign({}, t[r][1].end), d = Object.assign({}, t[n][1].start);
          Pv(u, -l), Pv(d, l), a = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: u,
            end: Object.assign({}, t[r][1].end)
          }, s = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, t[n][1].start),
            end: d
          }, o = {
            type: l > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, t[r][1].end),
            end: Object.assign({}, t[n][1].start)
          }, i = {
            type: l > 1 ? "strong" : "emphasis",
            start: Object.assign({}, a.start),
            end: Object.assign({}, s.end)
          }, t[r][1].end = Object.assign({}, a.start), t[n][1].start = Object.assign({}, s.end), f = [], t[r][1].end.offset - t[r][1].start.offset && (f = an(f, [
            ["enter", t[r][1], e],
            ["exit", t[r][1], e]
          ])), f = an(f, [
            ["enter", i, e],
            ["enter", a, e],
            ["exit", a, e],
            ["enter", o, e]
          ]), f = an(f, eg(e.parser.constructs.insideSpan.null, t.slice(r + 1, n), e)), f = an(f, [
            ["exit", o, e],
            ["enter", s, e],
            ["exit", s, e],
            ["exit", i, e]
          ]), t[n][1].end.offset - t[n][1].start.offset ? (c = 2, f = an(f, [
            ["enter", t[n][1], e],
            ["exit", t[n][1], e]
          ])) : c = 0, Yn(t, r - 1, n - r + 3, f), n = r + f.length - c - 2;
          break;
        }
    }
  for (n = -1; ++n < t.length; )
    t[n][1].type === "attentionSequence" && (t[n][1].type = "data");
  return t;
}
function S8(t, e) {
  let n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Dv(r), o;
  return a;
  function a(l) {
    return t.enter("attentionSequence"), o = l, s(l);
  }
  function s(l) {
    if (l === o)
      return t.consume(l), s;
    let f = t.exit("attentionSequence"), c = Dv(l), u = !c || c === 2 && i || n.includes(l), d = !i || i === 2 && c || n.includes(r);
    return f._open = Boolean(o === 42 ? u : u && (i || !d)), f._close = Boolean(o === 42 ? d : d && (c || !u)), e(l);
  }
}
function Pv(t, e) {
  t.column += e, t.offset += e, t._bufferIndex += e;
}
var I8 = { name: "autolink", tokenize: N8 };
function N8(t, e, n) {
  let r = 1;
  return i;
  function i(p) {
    return t.enter("autolink"), t.enter("autolinkMarker"), t.consume(p), t.exit("autolinkMarker"), t.enter("autolinkProtocol"), o;
  }
  function o(p) {
    return jn(p) ? (t.consume(p), a) : Av(p) ? f(p) : n(p);
  }
  function a(p) {
    return p === 43 || p === 45 || p === 46 || In(p) ? s(p) : f(p);
  }
  function s(p) {
    return p === 58 ? (t.consume(p), l) : (p === 43 || p === 45 || p === 46 || In(p)) && r++ < 32 ? (t.consume(p), s) : f(p);
  }
  function l(p) {
    return p === 62 ? (t.exit("autolinkProtocol"), h(p)) : p === null || p === 32 || p === 60 || X1(p) ? n(p) : (t.consume(p), l);
  }
  function f(p) {
    return p === 64 ? (t.consume(p), r = 0, c) : Av(p) ? (t.consume(p), f) : n(p);
  }
  function c(p) {
    return In(p) ? u(p) : n(p);
  }
  function u(p) {
    return p === 46 ? (t.consume(p), r = 0, c) : p === 62 ? (t.exit("autolinkProtocol").type = "autolinkEmail", h(p)) : d(p);
  }
  function d(p) {
    return (p === 45 || In(p)) && r++ < 63 ? (t.consume(p), p === 45 ? d : u) : n(p);
  }
  function h(p) {
    return t.enter("autolinkMarker"), t.consume(p), t.exit("autolinkMarker"), t.exit("autolink"), e;
  }
}
var tu = { tokenize: M8, partial: !0 };
function M8(t, e, n) {
  return Le(t, r, "linePrefix");
  function r(i) {
    return i === null || le(i) ? e(i) : n(i);
  }
}
var l3 = { name: "blockQuote", tokenize: A8, continuation: { tokenize: O8 }, exit: D8 };
function A8(t, e, n) {
  let r = this;
  return i;
  function i(a) {
    if (a === 62) {
      let s = r.containerState;
      return s.open || (t.enter("blockQuote", { _container: !0 }), s.open = !0), t.enter("blockQuotePrefix"), t.enter("blockQuoteMarker"), t.consume(a), t.exit("blockQuoteMarker"), o;
    }
    return n(a);
  }
  function o(a) {
    return nt(a) ? (t.enter("blockQuotePrefixWhitespace"), t.consume(a), t.exit("blockQuotePrefixWhitespace"), t.exit("blockQuotePrefix"), e) : (t.exit("blockQuotePrefix"), e(a));
  }
}
function O8(t, e, n) {
  return Le(
    t,
    t.attempt(l3, e, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function D8(t) {
  t.exit("blockQuote");
}
var f3 = { name: "characterEscape", tokenize: P8 };
function P8(t, e, n) {
  return r;
  function r(o) {
    return t.enter("characterEscape"), t.enter("escapeMarker"), t.consume(o), t.exit("escapeMarker"), i;
  }
  function i(o) {
    return b8(o) ? (t.enter("characterEscapeValue"), t.consume(o), t.exit("characterEscapeValue"), t.exit("characterEscape"), e) : n(o);
  }
}
var Rv = typeof window < "u" && window.document && window.document.createElement && document.createElement("i");
function tg(t) {
  let e = "&" + t + ";";
  Rv.innerHTML = e;
  let n = Rv.textContent;
  return n.charCodeAt(n.length - 1) === 59 && t !== "semi" || n === e ? !1 : n;
}
var c3 = { name: "characterReference", tokenize: R8 };
function R8(t, e, n) {
  let r = this, i = 0, o, a;
  return s;
  function s(u) {
    return t.enter("characterReference"), t.enter("characterReferenceMarker"), t.consume(u), t.exit("characterReferenceMarker"), l;
  }
  function l(u) {
    return u === 35 ? (t.enter("characterReferenceMarkerNumeric"), t.consume(u), t.exit("characterReferenceMarkerNumeric"), f) : (t.enter("characterReferenceValue"), o = 31, a = In, c(u));
  }
  function f(u) {
    return u === 88 || u === 120 ? (t.enter("characterReferenceMarkerHexadecimal"), t.consume(u), t.exit("characterReferenceMarkerHexadecimal"), t.enter("characterReferenceValue"), o = 6, a = v8, c) : (t.enter("characterReferenceValue"), o = 7, a = Q1, c(u));
  }
  function c(u) {
    let d;
    return u === 59 && i ? (d = t.exit("characterReferenceValue"), a === In && !tg(r.sliceSerialize(d)) ? n(u) : (t.enter("characterReferenceMarker"), t.consume(u), t.exit("characterReferenceMarker"), t.exit("characterReference"), e)) : a(u) && i++ < o ? (t.consume(u), c) : n(u);
  }
}
var Lv = { name: "codeFenced", tokenize: L8, concrete: !0 };
function L8(t, e, n) {
  let r = this, i = { tokenize: S, partial: !0 }, o = { tokenize: E, partial: !0 }, a = this.events[this.events.length - 1], s = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, l = 0, f;
  return c;
  function c(C) {
    return t.enter("codeFenced"), t.enter("codeFencedFence"), t.enter("codeFencedFenceSequence"), f = C, u(C);
  }
  function u(C) {
    return C === f ? (t.consume(C), l++, u) : (t.exit("codeFencedFenceSequence"), l < 3 ? n(C) : Le(t, d, "whitespace")(C));
  }
  function d(C) {
    return C === null || le(C) ? v(C) : (t.enter("codeFencedFenceInfo"), t.enter("chunkString", { contentType: "string" }), h(C));
  }
  function h(C) {
    return C === null || un(C) ? (t.exit("chunkString"), t.exit("codeFencedFenceInfo"), Le(t, p, "whitespace")(C)) : C === 96 && C === f ? n(C) : (t.consume(C), h);
  }
  function p(C) {
    return C === null || le(C) ? v(C) : (t.enter("codeFencedFenceMeta"), t.enter("chunkString", { contentType: "string" }), m(C));
  }
  function m(C) {
    return C === null || le(C) ? (t.exit("chunkString"), t.exit("codeFencedFenceMeta"), v(C)) : C === 96 && C === f ? n(C) : (t.consume(C), m);
  }
  function v(C) {
    return t.exit("codeFencedFence"), r.interrupt ? e(C) : b(C);
  }
  function b(C) {
    return C === null ? _(C) : le(C) ? t.attempt(o, t.attempt(i, _, s ? Le(t, b, "linePrefix", s + 1) : b), _)(C) : (t.enter("codeFlowValue"), k(C));
  }
  function k(C) {
    return C === null || le(C) ? (t.exit("codeFlowValue"), b(C)) : (t.consume(C), k);
  }
  function _(C) {
    return t.exit("codeFenced"), e(C);
  }
  function E(C, N, $) {
    let I = this;
    return O;
    function O(A) {
      return C.enter("lineEnding"), C.consume(A), C.exit("lineEnding"), y;
    }
    function y(A) {
      return I.parser.lazy[I.now().line] ? $(A) : N(A);
    }
  }
  function S(C, N, $) {
    let I = 0;
    return Le(
      C,
      O,
      "linePrefix",
      this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    );
    function O(z) {
      return C.enter("codeFencedFence"), C.enter("codeFencedFenceSequence"), y(z);
    }
    function y(z) {
      return z === f ? (C.consume(z), I++, y) : I < l ? $(z) : (C.exit("codeFencedFenceSequence"), Le(C, A, "whitespace")(z));
    }
    function A(z) {
      return z === null || le(z) ? (C.exit("codeFencedFence"), N(z)) : $(z);
    }
  }
}
var sd = { name: "codeIndented", tokenize: F8 }, $8 = { tokenize: j8, partial: !0 };
function F8(t, e, n) {
  let r = this;
  return i;
  function i(f) {
    return t.enter("codeIndented"), Le(t, o, "linePrefix", 4 + 1)(f);
  }
  function o(f) {
    let c = r.events[r.events.length - 1];
    return c && c[1].type === "linePrefix" && c[2].sliceSerialize(c[1], !0).length >= 4 ? a(f) : n(f);
  }
  function a(f) {
    return f === null ? l(f) : le(f) ? t.attempt($8, a, l)(f) : (t.enter("codeFlowValue"), s(f));
  }
  function s(f) {
    return f === null || le(f) ? (t.exit("codeFlowValue"), a(f)) : (t.consume(f), s);
  }
  function l(f) {
    return t.exit("codeIndented"), e(f);
  }
}
function j8(t, e, n) {
  let r = this;
  return i;
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : le(a) ? (t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), i) : Le(t, o, "linePrefix", 4 + 1)(a);
  }
  function o(a) {
    let s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? e(a) : le(a) ? i(a) : n(a);
  }
}
var z8 = { name: "codeText", tokenize: U8, resolve: B8, previous: W8 };
function B8(t) {
  let e = t.length - 4, n = 3, r, i;
  if ((t[n][1].type === "lineEnding" || t[n][1].type === "space") && (t[e][1].type === "lineEnding" || t[e][1].type === "space")) {
    for (r = n; ++r < e; )
      if (t[r][1].type === "codeTextData") {
        t[n][1].type = "codeTextPadding", t[e][1].type = "codeTextPadding", n += 2, e -= 2;
        break;
      }
  }
  for (r = n - 1, e++; ++r <= e; )
    i === void 0 ? r !== e && t[r][1].type !== "lineEnding" && (i = r) : (r === e || t[r][1].type === "lineEnding") && (t[i][1].type = "codeTextData", r !== i + 2 && (t[i][1].end = t[r - 1][1].end, t.splice(i + 2, r - i - 2), e -= r - i - 2, r = i + 2), i = void 0);
  return t;
}
function W8(t) {
  return t !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function U8(t, e, n) {
  let r = 0, i, o;
  return a;
  function a(u) {
    return t.enter("codeText"), t.enter("codeTextSequence"), s(u);
  }
  function s(u) {
    return u === 96 ? (t.consume(u), r++, s) : (t.exit("codeTextSequence"), l(u));
  }
  function l(u) {
    return u === null ? n(u) : u === 96 ? (o = t.enter("codeTextSequence"), i = 0, c(u)) : u === 32 ? (t.enter("space"), t.consume(u), t.exit("space"), l) : le(u) ? (t.enter("lineEnding"), t.consume(u), t.exit("lineEnding"), l) : (t.enter("codeTextData"), f(u));
  }
  function f(u) {
    return u === null || u === 32 || u === 96 || le(u) ? (t.exit("codeTextData"), l(u)) : (t.consume(u), f);
  }
  function c(u) {
    return u === 96 ? (t.consume(u), i++, c) : i === r ? (t.exit("codeTextSequence"), t.exit("codeText"), e(u)) : (o.type = "codeTextData", f(u));
  }
}
function u3(t) {
  let e = {}, n = -1, r, i, o, a, s, l, f;
  for (; ++n < t.length; ) {
    for (; n in e; )
      n = e[n];
    if (r = t[n], n && r[1].type === "chunkFlow" && t[n - 1][1].type === "listItemPrefix" && (l = r[1]._tokenizer.events, o = 0, o < l.length && l[o][1].type === "lineEndingBlank" && (o += 2), o < l.length && l[o][1].type === "content"))
      for (; ++o < l.length && l[o][1].type !== "content"; )
        l[o][1].type === "chunkText" && (l[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(e, H8(t, n)), n = e[n], f = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o-- && (a = t[o], a[1].type === "lineEnding" || a[1].type === "lineEndingBlank"); )
        a[0] === "enter" && (i && (t[i][1].type = "lineEndingBlank"), a[1].type = "lineEnding", i = o);
      i && (r[1].end = Object.assign({}, t[i][1].start), s = t.slice(i, n), s.unshift(r), Yn(t, i, n - i + 1, s));
    }
  }
  return !f;
}
function H8(t, e) {
  let n = t[e][1], r = t[e][2], i = e - 1, o = [], a = n._tokenizer || r.parser[n.contentType](n.start), s = a.events, l = [], f = {}, c, u, d = -1, h = n, p = 0, m = 0, v = [m];
  for (; h; ) {
    for (; t[++i][1] !== h; )
      ;
    o.push(i), h._tokenizer || (c = r.sliceStream(h), h.next || c.push(null), u && a.defineSkip(h.start), h._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(c), h._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), u = h, h = h.next;
  }
  for (h = n; ++d < s.length; )
    s[d][0] === "exit" && s[d - 1][0] === "enter" && s[d][1].type === s[d - 1][1].type && s[d][1].start.line !== s[d][1].end.line && (m = d + 1, v.push(m), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (a.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : v.pop(), d = v.length; d--; ) {
    let b = s.slice(v[d], v[d + 1]), k = o.pop();
    l.unshift([k, k + b.length - 1]), Yn(t, k, 2, b);
  }
  for (d = -1; ++d < l.length; )
    f[p + l[d][0]] = p + l[d][1], p += l[d][1] - l[d][0] - 1;
  return f;
}
var V8 = { tokenize: q8, resolve: Y8 }, K8 = { tokenize: G8, partial: !0 };
function Y8(t) {
  return u3(t), t;
}
function q8(t, e) {
  let n;
  return r;
  function r(s) {
    return t.enter("content"), n = t.enter("chunkContent", { contentType: "content" }), i(s);
  }
  function i(s) {
    return s === null ? o(s) : le(s) ? t.check(K8, a, o)(s) : (t.consume(s), i);
  }
  function o(s) {
    return t.exit("chunkContent"), t.exit("content"), e(s);
  }
  function a(s) {
    return t.consume(s), t.exit("chunkContent"), n.next = t.enter("chunkContent", { contentType: "content", previous: n }), n = n.next, i;
  }
}
function G8(t, e, n) {
  let r = this;
  return i;
  function i(a) {
    return t.exit("chunkContent"), t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), Le(t, o, "linePrefix");
  }
  function o(a) {
    if (a === null || le(a))
      return n(a);
    let s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? e(a) : t.interrupt(r.parser.constructs.flow, n, e)(a);
  }
}
function d3(t, e, n, r, i, o, a, s, l) {
  let f = l || Number.POSITIVE_INFINITY, c = 0;
  return u;
  function u(b) {
    return b === 60 ? (t.enter(r), t.enter(i), t.enter(o), t.consume(b), t.exit(o), d) : b === null || b === 41 || X1(b) ? n(b) : (t.enter(r), t.enter(a), t.enter(s), t.enter("chunkString", { contentType: "string" }), m(b));
  }
  function d(b) {
    return b === 62 ? (t.enter(o), t.consume(b), t.exit(o), t.exit(i), t.exit(r), e) : (t.enter(s), t.enter("chunkString", { contentType: "string" }), h(b));
  }
  function h(b) {
    return b === 62 ? (t.exit("chunkString"), t.exit(s), d(b)) : b === null || b === 60 || le(b) ? n(b) : (t.consume(b), b === 92 ? p : h);
  }
  function p(b) {
    return b === 60 || b === 62 || b === 92 ? (t.consume(b), h) : h(b);
  }
  function m(b) {
    return b === 40 ? ++c > f ? n(b) : (t.consume(b), m) : b === 41 ? c-- ? (t.consume(b), m) : (t.exit("chunkString"), t.exit(s), t.exit(a), t.exit(r), e(b)) : b === null || un(b) ? c ? n(b) : (t.exit("chunkString"), t.exit(s), t.exit(a), t.exit(r), e(b)) : X1(b) ? n(b) : (t.consume(b), b === 92 ? v : m);
  }
  function v(b) {
    return b === 40 || b === 41 || b === 92 ? (t.consume(b), m) : m(b);
  }
}
function h3(t, e, n, r, i, o) {
  let a = this, s = 0, l;
  return f;
  function f(h) {
    return t.enter(r), t.enter(i), t.consume(h), t.exit(i), t.enter(o), c;
  }
  function c(h) {
    return h === null || h === 91 || h === 93 && !l || h === 94 && !s && "_hiddenFootnoteSupport" in a.parser.constructs || s > 999 ? n(h) : h === 93 ? (t.exit(o), t.enter(i), t.consume(h), t.exit(i), t.exit(r), e) : le(h) ? (t.enter("lineEnding"), t.consume(h), t.exit("lineEnding"), c) : (t.enter("chunkString", { contentType: "string" }), u(h));
  }
  function u(h) {
    return h === null || h === 91 || h === 93 || le(h) || s++ > 999 ? (t.exit("chunkString"), c(h)) : (t.consume(h), l = l || !nt(h), h === 92 ? d : u);
  }
  function d(h) {
    return h === 91 || h === 92 || h === 93 ? (t.consume(h), s++, u) : u(h);
  }
}
function g3(t, e, n, r, i, o) {
  let a;
  return s;
  function s(d) {
    return t.enter(r), t.enter(i), t.consume(d), t.exit(i), a = d === 40 ? 41 : d, l;
  }
  function l(d) {
    return d === a ? (t.enter(i), t.consume(d), t.exit(i), t.exit(r), e) : (t.enter(o), f(d));
  }
  function f(d) {
    return d === a ? (t.exit(o), l(a)) : d === null ? n(d) : le(d) ? (t.enter("lineEnding"), t.consume(d), t.exit("lineEnding"), Le(t, f, "linePrefix")) : (t.enter("chunkString", { contentType: "string" }), c(d));
  }
  function c(d) {
    return d === a || d === null || le(d) ? (t.exit("chunkString"), f(d)) : (t.consume(d), d === 92 ? u : c);
  }
  function u(d) {
    return d === a || d === 92 ? (t.consume(d), c) : c(d);
  }
}
function es(t, e) {
  let n;
  return r;
  function r(i) {
    return le(i) ? (t.enter("lineEnding"), t.consume(i), t.exit("lineEnding"), n = !0, r) : nt(i) ? Le(t, r, n ? "linePrefix" : "lineSuffix")(i) : e(i);
  }
}
function wo(t) {
  return t.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
var Q8 = { name: "definition", tokenize: J8 }, X8 = { tokenize: Z8, partial: !0 };
function J8(t, e, n) {
  let r = this, i;
  return o;
  function o(l) {
    return t.enter("definition"), h3.call(r, t, a, n, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(l);
  }
  function a(l) {
    return i = wo(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), l === 58 ? (t.enter("definitionMarker"), t.consume(l), t.exit("definitionMarker"), es(
      t,
      d3(
        t,
        t.attempt(X8, Le(t, s, "whitespace"), Le(t, s, "whitespace")),
        n,
        "definitionDestination",
        "definitionDestinationLiteral",
        "definitionDestinationLiteralMarker",
        "definitionDestinationRaw",
        "definitionDestinationString"
      )
    )) : n(l);
  }
  function s(l) {
    return l === null || le(l) ? (t.exit("definition"), r.parser.defined.includes(i) || r.parser.defined.push(i), e(l)) : n(l);
  }
}
function Z8(t, e, n) {
  return r;
  function r(a) {
    return un(a) ? es(t, i)(a) : n(a);
  }
  function i(a) {
    return a === 34 || a === 39 || a === 40 ? g3(
      t,
      Le(t, o, "whitespace"),
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(a) : n(a);
  }
  function o(a) {
    return a === null || le(a) ? e(a) : n(a);
  }
}
var e5 = { name: "hardBreakEscape", tokenize: t5 };
function t5(t, e, n) {
  return r;
  function r(o) {
    return t.enter("hardBreakEscape"), t.enter("escapeMarker"), t.consume(o), i;
  }
  function i(o) {
    return le(o) ? (t.exit("escapeMarker"), t.exit("hardBreakEscape"), e(o)) : n(o);
  }
}
var n5 = { name: "headingAtx", tokenize: i5, resolve: r5 };
function r5(t, e) {
  let n = t.length - 2, r = 3, i, o;
  return t[r][1].type === "whitespace" && (r += 2), n - 2 > r && t[n][1].type === "whitespace" && (n -= 2), t[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && t[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = { type: "atxHeadingText", start: t[r][1].start, end: t[n][1].end }, o = { type: "chunkText", start: t[r][1].start, end: t[n][1].end, contentType: "text" }, Yn(t, r, n - r + 1, [
    ["enter", i, e],
    ["enter", o, e],
    ["exit", o, e],
    ["exit", i, e]
  ])), t;
}
function i5(t, e, n) {
  let r = this, i = 0;
  return o;
  function o(c) {
    return t.enter("atxHeading"), t.enter("atxHeadingSequence"), a(c);
  }
  function a(c) {
    return c === 35 && i++ < 6 ? (t.consume(c), a) : c === null || un(c) ? (t.exit("atxHeadingSequence"), r.interrupt ? e(c) : s(c)) : n(c);
  }
  function s(c) {
    return c === 35 ? (t.enter("atxHeadingSequence"), l(c)) : c === null || le(c) ? (t.exit("atxHeading"), e(c)) : nt(c) ? Le(t, s, "whitespace")(c) : (t.enter("atxHeadingText"), f(c));
  }
  function l(c) {
    return c === 35 ? (t.consume(c), l) : (t.exit("atxHeadingSequence"), s(c));
  }
  function f(c) {
    return c === null || c === 35 || un(c) ? (t.exit("atxHeadingText"), s(c)) : (t.consume(c), f);
  }
}
var o5 = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], $v = ["pre", "script", "style", "textarea"], a5 = { name: "htmlFlow", tokenize: f5, resolveTo: l5, concrete: !0 }, s5 = { tokenize: c5, partial: !0 };
function l5(t) {
  let e = t.length;
  for (; e-- && !(t[e][0] === "enter" && t[e][1].type === "htmlFlow"); )
    ;
  return e > 1 && t[e - 2][1].type === "linePrefix" && (t[e][1].start = t[e - 2][1].start, t[e + 1][1].start = t[e - 2][1].start, t.splice(e - 2, 2)), t;
}
function f5(t, e, n) {
  let r = this, i, o, a, s, l;
  return f;
  function f(x) {
    return t.enter("htmlFlow"), t.enter("htmlFlowData"), t.consume(x), c;
  }
  function c(x) {
    return x === 33 ? (t.consume(x), u) : x === 47 ? (t.consume(x), p) : x === 63 ? (t.consume(x), i = 3, r.interrupt ? e : G) : jn(x) ? (t.consume(x), a = String.fromCharCode(x), o = !0, m) : n(x);
  }
  function u(x) {
    return x === 45 ? (t.consume(x), i = 2, d) : x === 91 ? (t.consume(x), i = 5, a = "CDATA[", s = 0, h) : jn(x) ? (t.consume(x), i = 4, r.interrupt ? e : G) : n(x);
  }
  function d(x) {
    return x === 45 ? (t.consume(x), r.interrupt ? e : G) : n(x);
  }
  function h(x) {
    return x === a.charCodeAt(s++) ? (t.consume(x), s === a.length ? r.interrupt ? e : y : h) : n(x);
  }
  function p(x) {
    return jn(x) ? (t.consume(x), a = String.fromCharCode(x), m) : n(x);
  }
  function m(x) {
    return x === null || x === 47 || x === 62 || un(x) ? x !== 47 && o && $v.includes(a.toLowerCase()) ? (i = 1, r.interrupt ? e(x) : y(x)) : o5.includes(a.toLowerCase()) ? (i = 6, x === 47 ? (t.consume(x), v) : r.interrupt ? e(x) : y(x)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(x) : o ? k(x) : b(x)) : x === 45 || In(x) ? (t.consume(x), a += String.fromCharCode(x), m) : n(x);
  }
  function v(x) {
    return x === 62 ? (t.consume(x), r.interrupt ? e : y) : n(x);
  }
  function b(x) {
    return nt(x) ? (t.consume(x), b) : I(x);
  }
  function k(x) {
    return x === 47 ? (t.consume(x), I) : x === 58 || x === 95 || jn(x) ? (t.consume(x), _) : nt(x) ? (t.consume(x), k) : I(x);
  }
  function _(x) {
    return x === 45 || x === 46 || x === 58 || x === 95 || In(x) ? (t.consume(x), _) : E(x);
  }
  function E(x) {
    return x === 61 ? (t.consume(x), S) : nt(x) ? (t.consume(x), E) : k(x);
  }
  function S(x) {
    return x === null || x === 60 || x === 61 || x === 62 || x === 96 ? n(x) : x === 34 || x === 39 ? (t.consume(x), l = x, C) : nt(x) ? (t.consume(x), S) : (l = null, N(x));
  }
  function C(x) {
    return x === null || le(x) ? n(x) : x === l ? (t.consume(x), $) : (t.consume(x), C);
  }
  function N(x) {
    return x === null || x === 34 || x === 39 || x === 60 || x === 61 || x === 62 || x === 96 || un(x) ? E(x) : (t.consume(x), N);
  }
  function $(x) {
    return x === 47 || x === 62 || nt(x) ? k(x) : n(x);
  }
  function I(x) {
    return x === 62 ? (t.consume(x), O) : n(x);
  }
  function O(x) {
    return nt(x) ? (t.consume(x), O) : x === null || le(x) ? y(x) : n(x);
  }
  function y(x) {
    return x === 45 && i === 2 ? (t.consume(x), P) : x === 60 && i === 1 ? (t.consume(x), L) : x === 62 && i === 4 ? (t.consume(x), j) : x === 63 && i === 3 ? (t.consume(x), G) : x === 93 && i === 5 ? (t.consume(x), B) : le(x) && (i === 6 || i === 7) ? t.check(s5, j, A)(x) : x === null || le(x) ? A(x) : (t.consume(x), y);
  }
  function A(x) {
    return t.exit("htmlFlowData"), z(x);
  }
  function z(x) {
    return x === null ? w(x) : le(x) ? t.attempt({ tokenize: F, partial: !0 }, z, w)(x) : (t.enter("htmlFlowData"), y(x));
  }
  function F(x, oe, Me) {
    return Ae;
    function Ae(Ve) {
      return x.enter("lineEnding"), x.consume(Ve), x.exit("lineEnding"), te;
    }
    function te(Ve) {
      return r.parser.lazy[r.now().line] ? Me(Ve) : oe(Ve);
    }
  }
  function P(x) {
    return x === 45 ? (t.consume(x), G) : y(x);
  }
  function L(x) {
    return x === 47 ? (t.consume(x), a = "", X) : y(x);
  }
  function X(x) {
    return x === 62 && $v.includes(a.toLowerCase()) ? (t.consume(x), j) : jn(x) && a.length < 8 ? (t.consume(x), a += String.fromCharCode(x), X) : y(x);
  }
  function B(x) {
    return x === 93 ? (t.consume(x), G) : y(x);
  }
  function G(x) {
    return x === 62 ? (t.consume(x), j) : x === 45 && i === 2 ? (t.consume(x), G) : y(x);
  }
  function j(x) {
    return x === null || le(x) ? (t.exit("htmlFlowData"), w(x)) : (t.consume(x), j);
  }
  function w(x) {
    return t.exit("htmlFlow"), e(x);
  }
}
function c5(t, e, n) {
  return r;
  function r(i) {
    return t.exit("htmlFlowData"), t.enter("lineEndingBlank"), t.consume(i), t.exit("lineEndingBlank"), t.attempt(tu, e, n);
  }
}
var u5 = { name: "htmlText", tokenize: d5 };
function d5(t, e, n) {
  let r = this, i, o, a, s;
  return l;
  function l(w) {
    return t.enter("htmlText"), t.enter("htmlTextData"), t.consume(w), f;
  }
  function f(w) {
    return w === 33 ? (t.consume(w), c) : w === 47 ? (t.consume(w), N) : w === 63 ? (t.consume(w), S) : jn(w) ? (t.consume(w), O) : n(w);
  }
  function c(w) {
    return w === 45 ? (t.consume(w), u) : w === 91 ? (t.consume(w), o = "CDATA[", a = 0, v) : jn(w) ? (t.consume(w), E) : n(w);
  }
  function u(w) {
    return w === 45 ? (t.consume(w), d) : n(w);
  }
  function d(w) {
    return w === null || w === 62 ? n(w) : w === 45 ? (t.consume(w), h) : p(w);
  }
  function h(w) {
    return w === null || w === 62 ? n(w) : p(w);
  }
  function p(w) {
    return w === null ? n(w) : w === 45 ? (t.consume(w), m) : le(w) ? (s = p, B(w)) : (t.consume(w), p);
  }
  function m(w) {
    return w === 45 ? (t.consume(w), j) : p(w);
  }
  function v(w) {
    return w === o.charCodeAt(a++) ? (t.consume(w), a === o.length ? b : v) : n(w);
  }
  function b(w) {
    return w === null ? n(w) : w === 93 ? (t.consume(w), k) : le(w) ? (s = b, B(w)) : (t.consume(w), b);
  }
  function k(w) {
    return w === 93 ? (t.consume(w), _) : b(w);
  }
  function _(w) {
    return w === 62 ? j(w) : w === 93 ? (t.consume(w), _) : b(w);
  }
  function E(w) {
    return w === null || w === 62 ? j(w) : le(w) ? (s = E, B(w)) : (t.consume(w), E);
  }
  function S(w) {
    return w === null ? n(w) : w === 63 ? (t.consume(w), C) : le(w) ? (s = S, B(w)) : (t.consume(w), S);
  }
  function C(w) {
    return w === 62 ? j(w) : S(w);
  }
  function N(w) {
    return jn(w) ? (t.consume(w), $) : n(w);
  }
  function $(w) {
    return w === 45 || In(w) ? (t.consume(w), $) : I(w);
  }
  function I(w) {
    return le(w) ? (s = I, B(w)) : nt(w) ? (t.consume(w), I) : j(w);
  }
  function O(w) {
    return w === 45 || In(w) ? (t.consume(w), O) : w === 47 || w === 62 || un(w) ? y(w) : n(w);
  }
  function y(w) {
    return w === 47 ? (t.consume(w), j) : w === 58 || w === 95 || jn(w) ? (t.consume(w), A) : le(w) ? (s = y, B(w)) : nt(w) ? (t.consume(w), y) : j(w);
  }
  function A(w) {
    return w === 45 || w === 46 || w === 58 || w === 95 || In(w) ? (t.consume(w), A) : z(w);
  }
  function z(w) {
    return w === 61 ? (t.consume(w), F) : le(w) ? (s = z, B(w)) : nt(w) ? (t.consume(w), z) : y(w);
  }
  function F(w) {
    return w === null || w === 60 || w === 61 || w === 62 || w === 96 ? n(w) : w === 34 || w === 39 ? (t.consume(w), i = w, P) : le(w) ? (s = F, B(w)) : nt(w) ? (t.consume(w), F) : (t.consume(w), i = void 0, X);
  }
  function P(w) {
    return w === i ? (t.consume(w), L) : w === null ? n(w) : le(w) ? (s = P, B(w)) : (t.consume(w), P);
  }
  function L(w) {
    return w === 62 || w === 47 || un(w) ? y(w) : n(w);
  }
  function X(w) {
    return w === null || w === 34 || w === 39 || w === 60 || w === 61 || w === 96 ? n(w) : w === 62 || un(w) ? y(w) : (t.consume(w), X);
  }
  function B(w) {
    return t.exit("htmlTextData"), t.enter("lineEnding"), t.consume(w), t.exit("lineEnding"), Le(t, G, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
  }
  function G(w) {
    return t.enter("htmlTextData"), s(w);
  }
  function j(w) {
    return w === 62 ? (t.consume(w), t.exit("htmlTextData"), t.exit("htmlText"), e) : n(w);
  }
}
var ng = { name: "labelEnd", tokenize: b5, resolveTo: v5, resolveAll: m5 }, h5 = { tokenize: y5 }, g5 = { tokenize: _5 }, p5 = { tokenize: w5 };
function m5(t) {
  let e = -1, n;
  for (; ++e < t.length; )
    n = t[e][1], (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (t.splice(e + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", e++);
  return t;
}
function v5(t, e) {
  let n = t.length, r = 0, i, o, a, s;
  for (; n--; )
    if (i = t[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      t[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (a) {
      if (t[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      i.type === "labelEnd" && (a = n);
  let l = {
    type: t[o][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, t[o][1].start),
    end: Object.assign({}, t[t.length - 1][1].end)
  }, f = {
    type: "label",
    start: Object.assign({}, t[o][1].start),
    end: Object.assign({}, t[a][1].end)
  }, c = {
    type: "labelText",
    start: Object.assign({}, t[o + r + 2][1].end),
    end: Object.assign({}, t[a - 2][1].start)
  };
  return s = [
    ["enter", l, e],
    ["enter", f, e]
  ], s = an(s, t.slice(o + 1, o + r + 3)), s = an(s, [["enter", c, e]]), s = an(s, eg(e.parser.constructs.insideSpan.null, t.slice(o + r + 4, a - 3), e)), s = an(s, [["exit", c, e], t[a - 2], t[a - 1], ["exit", f, e]]), s = an(s, t.slice(a + 1)), s = an(s, [["exit", l, e]]), Yn(t, o, t.length, s), t;
}
function b5(t, e, n) {
  let r = this, i = r.events.length, o, a;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return s;
  function s(c) {
    return o ? o._inactive ? f(c) : (a = r.parser.defined.includes(wo(r.sliceSerialize({ start: o.end, end: r.now() }))), t.enter("labelEnd"), t.enter("labelMarker"), t.consume(c), t.exit("labelMarker"), t.exit("labelEnd"), l) : n(c);
  }
  function l(c) {
    return c === 40 ? t.attempt(h5, e, a ? e : f)(c) : c === 91 ? t.attempt(g5, e, a ? t.attempt(p5, e, f) : f)(c) : a ? e(c) : f(c);
  }
  function f(c) {
    return o._balanced = !0, n(c);
  }
}
function y5(t, e, n) {
  return r;
  function r(l) {
    return t.enter("resource"), t.enter("resourceMarker"), t.consume(l), t.exit("resourceMarker"), es(t, i);
  }
  function i(l) {
    return l === 41 ? s(l) : d3(
      t,
      o,
      n,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(l);
  }
  function o(l) {
    return un(l) ? es(t, a)(l) : s(l);
  }
  function a(l) {
    return l === 34 || l === 39 || l === 40 ? g3(t, es(t, s), n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(l) : s(l);
  }
  function s(l) {
    return l === 41 ? (t.enter("resourceMarker"), t.consume(l), t.exit("resourceMarker"), t.exit("resource"), e) : n(l);
  }
}
function _5(t, e, n) {
  let r = this;
  return i;
  function i(a) {
    return h3.call(r, t, o, n, "reference", "referenceMarker", "referenceString")(a);
  }
  function o(a) {
    return r.parser.defined.includes(
      wo(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))
    ) ? e(a) : n(a);
  }
}
function w5(t, e, n) {
  return r;
  function r(o) {
    return t.enter("reference"), t.enter("referenceMarker"), t.consume(o), t.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (t.enter("referenceMarker"), t.consume(o), t.exit("referenceMarker"), t.exit("reference"), e) : n(o);
  }
}
var k5 = { name: "labelStartImage", tokenize: C5, resolveAll: ng.resolveAll };
function C5(t, e, n) {
  let r = this;
  return i;
  function i(s) {
    return t.enter("labelImage"), t.enter("labelImageMarker"), t.consume(s), t.exit("labelImageMarker"), o;
  }
  function o(s) {
    return s === 91 ? (t.enter("labelMarker"), t.consume(s), t.exit("labelMarker"), t.exit("labelImage"), a) : n(s);
  }
  function a(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : e(s);
  }
}
var x5 = { name: "labelStartLink", tokenize: E5, resolveAll: ng.resolveAll };
function E5(t, e, n) {
  let r = this;
  return i;
  function i(a) {
    return t.enter("labelLink"), t.enter("labelMarker"), t.consume(a), t.exit("labelMarker"), t.exit("labelLink"), o;
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : e(a);
  }
}
var ld = { name: "lineEnding", tokenize: T5 };
function T5(t, e) {
  return n;
  function n(r) {
    return t.enter("lineEnding"), t.consume(r), t.exit("lineEnding"), Le(t, e, "linePrefix");
  }
}
var Fl = { name: "thematicBreak", tokenize: S5 };
function S5(t, e, n) {
  let r = 0, i;
  return o;
  function o(l) {
    return t.enter("thematicBreak"), i = l, a(l);
  }
  function a(l) {
    return l === i ? (t.enter("thematicBreakSequence"), s(l)) : nt(l) ? Le(t, a, "whitespace")(l) : r < 3 || l !== null && !le(l) ? n(l) : (t.exit("thematicBreak"), e(l));
  }
  function s(l) {
    return l === i ? (t.consume(l), r++, s) : (t.exit("thematicBreakSequence"), a(l));
  }
}
var Ft = { name: "list", tokenize: M5, continuation: { tokenize: A5 }, exit: D5 }, I5 = { tokenize: P5, partial: !0 }, N5 = { tokenize: O5, partial: !0 };
function M5(t, e, n) {
  let r = this, i = r.events[r.events.length - 1], o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, a = 0;
  return s;
  function s(h) {
    let p = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (p === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : Q1(h)) {
      if (r.containerState.type || (r.containerState.type = p, t.enter(p, { _container: !0 })), p === "listUnordered")
        return t.enter("listItemPrefix"), h === 42 || h === 45 ? t.check(Fl, n, f)(h) : f(h);
      if (!r.interrupt || h === 49)
        return t.enter("listItemPrefix"), t.enter("listItemValue"), l(h);
    }
    return n(h);
  }
  function l(h) {
    return Q1(h) && ++a < 10 ? (t.consume(h), l) : (!r.interrupt || a < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (t.exit("listItemValue"), f(h)) : n(h);
  }
  function f(h) {
    return t.enter("listItemMarker"), t.consume(h), t.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, t.check(tu, r.interrupt ? n : c, t.attempt(I5, d, u));
  }
  function c(h) {
    return r.containerState.initialBlankLine = !0, o++, d(h);
  }
  function u(h) {
    return nt(h) ? (t.enter("listItemPrefixWhitespace"), t.consume(h), t.exit("listItemPrefixWhitespace"), d) : n(h);
  }
  function d(h) {
    return r.containerState.size = o + r.sliceSerialize(t.exit("listItemPrefix"), !0).length, e(h);
  }
}
function A5(t, e, n) {
  let r = this;
  return r.containerState._closeFlow = void 0, t.check(tu, i, o);
  function i(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Le(t, e, "listItemIndent", r.containerState.size + 1)(s);
  }
  function o(s) {
    return r.containerState.furtherBlankLines || !nt(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, a(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, t.attempt(N5, e, a)(s));
  }
  function a(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Le(
      t,
      t.attempt(Ft, e, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(s);
  }
}
function O5(t, e, n) {
  let r = this;
  return Le(t, i, "listItemIndent", r.containerState.size + 1);
  function i(o) {
    let a = r.events[r.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === r.containerState.size ? e(o) : n(o);
  }
}
function D5(t) {
  t.exit(this.containerState.type);
}
function P5(t, e, n) {
  let r = this;
  return Le(
    t,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function i(o) {
    let a = r.events[r.events.length - 1];
    return !nt(o) && a && a[1].type === "listItemPrefixWhitespace" ? e(o) : n(o);
  }
}
var Fv = { name: "setextUnderline", tokenize: L5, resolveTo: R5 };
function R5(t, e) {
  let n = t.length, r, i, o;
  for (; n--; )
    if (t[n][0] === "enter") {
      if (t[n][1].type === "content") {
        r = n;
        break;
      }
      t[n][1].type === "paragraph" && (i = n);
    } else
      t[n][1].type === "content" && t.splice(n, 1), !o && t[n][1].type === "definition" && (o = n);
  let a = {
    type: "setextHeading",
    start: Object.assign({}, t[i][1].start),
    end: Object.assign({}, t[t.length - 1][1].end)
  };
  return t[i][1].type = "setextHeadingText", o ? (t.splice(i, 0, ["enter", a, e]), t.splice(o + 1, 0, ["exit", t[r][1], e]), t[r][1].end = Object.assign({}, t[o][1].end)) : t[r][1] = a, t.push(["exit", a, e]), t;
}
function L5(t, e, n) {
  let r = this, i = r.events.length, o, a;
  for (; i--; )
    if (r.events[i][1].type !== "lineEnding" && r.events[i][1].type !== "linePrefix" && r.events[i][1].type !== "content") {
      a = r.events[i][1].type === "paragraph";
      break;
    }
  return s;
  function s(c) {
    return !r.parser.lazy[r.now().line] && (r.interrupt || a) ? (t.enter("setextHeadingLine"), t.enter("setextHeadingLineSequence"), o = c, l(c)) : n(c);
  }
  function l(c) {
    return c === o ? (t.consume(c), l) : (t.exit("setextHeadingLineSequence"), Le(t, f, "lineSuffix")(c));
  }
  function f(c) {
    return c === null || le(c) ? (t.exit("setextHeadingLine"), e(c)) : n(c);
  }
}
var $5 = { tokenize: F5 };
function F5(t) {
  let e = this, n = t.attempt(
    tu,
    r,
    t.attempt(
      this.parser.constructs.flowInitial,
      i,
      Le(t, t.attempt(this.parser.constructs.flow, i, t.attempt(V8, i)), "linePrefix")
    )
  );
  return n;
  function r(o) {
    if (o === null) {
      t.consume(o);
      return;
    }
    return t.enter("lineEndingBlank"), t.consume(o), t.exit("lineEndingBlank"), e.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      t.consume(o);
      return;
    }
    return t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), e.currentConstruct = void 0, n;
  }
}
var j5 = { resolveAll: m3() }, z5 = p3("string"), B5 = p3("text");
function p3(t) {
  return { tokenize: e, resolveAll: m3(t === "text" ? W5 : void 0) };
  function e(n) {
    let r = this, i = this.parser.constructs[t], o = n.attempt(i, a, s);
    return a;
    function a(c) {
      return f(c) ? o(c) : s(c);
    }
    function s(c) {
      if (c === null) {
        n.consume(c);
        return;
      }
      return n.enter("data"), n.consume(c), l;
    }
    function l(c) {
      return f(c) ? (n.exit("data"), o(c)) : (n.consume(c), l);
    }
    function f(c) {
      if (c === null)
        return !0;
      let u = i[c], d = -1;
      if (u)
        for (; ++d < u.length; ) {
          let h = u[d];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function m3(t) {
  return e;
  function e(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return t ? t(n, r) : n;
  }
}
function W5(t, e) {
  let n = 0;
  for (; ++n <= t.length; )
    if ((n === t.length || t[n][1].type === "lineEnding") && t[n - 1][1].type === "data") {
      let r = t[n - 1][1], i = e.sliceStream(r), o = i.length, a = -1, s = 0, l;
      for (; o--; ) {
        let f = i[o];
        if (typeof f == "string") {
          for (a = f.length; f.charCodeAt(a - 1) === 32; )
            s++, a--;
          if (a)
            break;
          a = -1;
        } else if (f === -2)
          l = !0, s++;
        else if (f !== -1) {
          o++;
          break;
        }
      }
      if (s) {
        let f = {
          type: n === t.length || l || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s,
            _index: r.start._index + o,
            _bufferIndex: o ? a : r.start._bufferIndex + a
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, f.start), r.start.offset === r.end.offset ? Object.assign(r, f) : (t.splice(n, 0, ["enter", f, e], ["exit", f, e]), n += 2);
      }
      n++;
    }
  return t;
}
function U5(t, e, n) {
  let r = Object.assign(n ? Object.assign({}, n) : { line: 1, column: 1, offset: 0 }, {
    _index: 0,
    _bufferIndex: -1
  }), i = {}, o = [], a = [], s = [], l = {
    consume: k,
    enter: _,
    exit: E,
    attempt: N(S),
    check: N(C),
    interrupt: N(C, { interrupt: !0 })
  }, f = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: t,
    sliceStream: h,
    sliceSerialize: d,
    now: p,
    defineSkip: m,
    write: u
  }, c = e.tokenize.call(f, l);
  return e.resolveAll && o.push(e), f;
  function u(y) {
    return a = an(a, y), v(), a[a.length - 1] !== null ? [] : ($(e, 0), f.events = eg(o, f.events, f), f.events);
  }
  function d(y, A) {
    return V5(h(y), A);
  }
  function h(y) {
    return H5(a, y);
  }
  function p() {
    return Object.assign({}, r);
  }
  function m(y) {
    i[y.line] = y.column, O();
  }
  function v() {
    let y;
    for (; r._index < a.length; ) {
      let A = a[r._index];
      if (typeof A == "string")
        for (y = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === y && r._bufferIndex < A.length; )
          b(A.charCodeAt(r._bufferIndex));
      else
        b(A);
    }
  }
  function b(y) {
    c = c(y);
  }
  function k(y) {
    le(y) ? (r.line++, r.column = 1, r.offset += y === -3 ? 2 : 1, O()) : y !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === a[r._index].length && (r._bufferIndex = -1, r._index++)), f.previous = y;
  }
  function _(y, A) {
    let z = A || {};
    return z.type = y, z.start = p(), f.events.push(["enter", z, f]), s.push(z), z;
  }
  function E(y) {
    let A = s.pop();
    return A.end = p(), f.events.push(["exit", A, f]), A;
  }
  function S(y, A) {
    $(y, A.from);
  }
  function C(y, A) {
    A.restore();
  }
  function N(y, A) {
    return z;
    function z(F, P, L) {
      let X, B, G, j;
      return Array.isArray(F) ? x(F) : "tokenize" in F ? x([F]) : w(F);
      function w(te) {
        return Ve;
        function Ve(Ee) {
          let $e = Ee !== null && te[Ee], Qt = Ee !== null && te.null, ue = [
            ...Array.isArray($e) ? $e : $e ? [$e] : [],
            ...Array.isArray(Qt) ? Qt : Qt ? [Qt] : []
          ];
          return x(ue)(Ee);
        }
      }
      function x(te) {
        return X = te, B = 0, te.length === 0 ? L : oe(te[B]);
      }
      function oe(te) {
        return Ve;
        function Ve(Ee) {
          return j = I(), G = te, te.partial || (f.currentConstruct = te), te.name && f.parser.constructs.disable.null.includes(te.name) ? Ae() : te.tokenize.call(A ? Object.assign(Object.create(f), A) : f, l, Me, Ae)(Ee);
        }
      }
      function Me(te) {
        return y(G, j), P;
      }
      function Ae(te) {
        return j.restore(), ++B < X.length ? oe(X[B]) : L;
      }
    }
  }
  function $(y, A) {
    y.resolveAll && !o.includes(y) && o.push(y), y.resolve && Yn(f.events, A, f.events.length - A, y.resolve(f.events.slice(A), f)), y.resolveTo && (f.events = y.resolveTo(f.events, f));
  }
  function I() {
    let y = p(), A = f.previous, z = f.currentConstruct, F = f.events.length, P = Array.from(s);
    return { restore: L, from: F };
    function L() {
      r = y, f.previous = A, f.currentConstruct = z, f.events.length = F, s = P, O();
    }
  }
  function O() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function H5(t, e) {
  let n = e.start._index, r = e.start._bufferIndex, i = e.end._index, o = e.end._bufferIndex, a;
  return n === i ? a = [t[n].slice(r, o)] : (a = t.slice(n, i), r > -1 && (a[0] = a[0].slice(r)), o > 0 && a.push(t[i].slice(0, o))), a;
}
function V5(t, e) {
  let n = -1, r = [], i;
  for (; ++n < t.length; ) {
    let o = t[n], a;
    if (typeof o == "string")
      a = o;
    else
      switch (o) {
        case -5: {
          a = "\r";
          break;
        }
        case -4: {
          a = `
`;
          break;
        }
        case -3: {
          a = `\r
`;
          break;
        }
        case -2: {
          a = e ? " " : "	";
          break;
        }
        case -1: {
          if (!e && i)
            continue;
          a = " ";
          break;
        }
        default:
          a = String.fromCharCode(o);
      }
    i = o === -2, r.push(a);
  }
  return r.join("");
}
var v3 = {};
u8(v3, {
  attentionMarkers: () => Z5,
  contentInitial: () => Y5,
  disable: () => eL,
  document: () => K5,
  flow: () => G5,
  flowInitial: () => q5,
  insideSpan: () => J5,
  string: () => Q5,
  text: () => X5
});
var K5 = {
  [42]: Ft,
  [43]: Ft,
  [45]: Ft,
  [48]: Ft,
  [49]: Ft,
  [50]: Ft,
  [51]: Ft,
  [52]: Ft,
  [53]: Ft,
  [54]: Ft,
  [55]: Ft,
  [56]: Ft,
  [57]: Ft,
  [62]: l3
}, Y5 = { [91]: Q8 }, q5 = { [-2]: sd, [-1]: sd, [32]: sd }, G5 = { [35]: n5, [42]: Fl, [45]: [Fv, Fl], [60]: a5, [61]: Fv, [95]: Fl, [96]: Lv, [126]: Lv }, Q5 = { [38]: c3, [92]: f3 }, X5 = {
  [-5]: ld,
  [-4]: ld,
  [-3]: ld,
  [33]: k5,
  [38]: c3,
  [42]: J1,
  [60]: [I8, u5],
  [91]: x5,
  [92]: [e5, f3],
  [93]: ng,
  [95]: J1,
  [96]: z8
}, J5 = { null: [J1, j5] }, Z5 = { null: [42, 95] }, eL = { null: [] };
function tL(t = {}) {
  let e = h8([v3].concat(t.extensions || [])), n = {
    defined: [],
    lazy: {},
    constructs: e,
    content: r(w8),
    document: r(C8),
    flow: r($5),
    string: r(z5),
    text: r(B5)
  };
  return n;
  function r(i) {
    return o;
    function o(a) {
      return U5(n, i, a);
    }
  }
}
var jv = /[\0\t\n\r]/g;
function nL() {
  let t = 1, e = "", n = !0, r;
  return i;
  function i(o, a, s) {
    let l = [], f, c, u, d, h;
    for (o = e + o.toString(a), u = 0, e = "", n && (o.charCodeAt(0) === 65279 && u++, n = void 0); u < o.length; ) {
      if (jv.lastIndex = u, f = jv.exec(o), d = f && f.index !== void 0 ? f.index : o.length, h = o.charCodeAt(d), !f) {
        e = o.slice(u);
        break;
      }
      if (h === 10 && u === d && r)
        l.push(-3), r = void 0;
      else
        switch (r && (l.push(-5), r = void 0), u < d && (l.push(o.slice(u, d)), t += d - u), h) {
          case 0: {
            l.push(65533), t++;
            break;
          }
          case 9: {
            for (c = Math.ceil(t / 4) * 4, l.push(-2); t++ < c; )
              l.push(-1);
            break;
          }
          case 10: {
            l.push(-4), t = 1;
            break;
          }
          default:
            r = !0, t = 1;
        }
      u = d + 1;
    }
    return s && (r && l.push(-5), e && l.push(e), l.push(null)), l;
  }
}
function rL(t) {
  for (; !u3(t); )
    ;
  return t;
}
function b3(t, e) {
  let n = Number.parseInt(t, e);
  return n < 9 || n === 11 || n > 13 && n < 32 || n > 126 && n < 160 || n > 55295 && n < 57344 || n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || n > 1114111 ? "�" : String.fromCharCode(n);
}
var iL = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function oL(t) {
  return t.replace(iL, aL);
}
function aL(t, e, n) {
  if (e)
    return e;
  if (n.charCodeAt(0) === 35) {
    let r = n.charCodeAt(1), i = r === 120 || r === 88;
    return b3(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return tg(n) || t;
}
function jl(t) {
  return !t || typeof t != "object" ? "" : "position" in t || "type" in t ? zv(t.position) : "start" in t || "end" in t ? zv(t) : "line" in t || "column" in t ? Z1(t) : "";
}
function Z1(t) {
  return Bv(t && t.line) + ":" + Bv(t && t.column);
}
function zv(t) {
  return Z1(t && t.start) + "-" + Z1(t && t.end);
}
function Bv(t) {
  return t && typeof t == "number" ? t : 1;
}
var eh = {}.hasOwnProperty, sL = function(t, e, n) {
  return typeof e != "string" && (n = e, e = void 0), lL(n)(rL(tL(n).document().write(nL()(t, e, !0))));
};
function lL(t = {}) {
  let e = y3(
    {
      transforms: [],
      canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
      enter: {
        autolink: l(zg),
        autolinkProtocol: A,
        autolinkEmail: A,
        atxHeading: l(mr),
        blockQuote: l(Xt),
        characterEscape: A,
        characterReference: A,
        codeFenced: l(kn),
        codeFencedFenceInfo: f,
        codeFencedFenceMeta: f,
        codeIndented: l(kn, f),
        codeText: l(Lt, f),
        codeTextData: A,
        data: A,
        codeFlowValue: A,
        definition: l(Se),
        definitionDestinationString: f,
        definitionLabelString: f,
        definitionTitleString: f,
        emphasis: l(Cn),
        hardBreakEscape: l(ua),
        hardBreakTrailing: l(ua),
        htmlFlow: l(jg, f),
        htmlFlowData: A,
        htmlText: l(jg, f),
        htmlTextData: A,
        image: l(EC),
        label: f,
        link: l(zg),
        listItem: l(TC),
        listItemValue: m,
        listOrdered: l(Bg, p),
        listUnordered: l(Bg),
        paragraph: l(SC),
        reference: te,
        referenceString: f,
        resourceDestinationString: f,
        resourceTitleString: f,
        setextHeading: l(mr),
        strong: l(IC),
        thematicBreak: l(MC)
      },
      exit: {
        atxHeading: u(),
        atxHeadingSequence: $,
        autolink: u(),
        autolinkEmail: ue,
        autolinkProtocol: Qt,
        blockQuote: u(),
        characterEscapeValue: z,
        characterReferenceMarkerHexadecimal: Ee,
        characterReferenceMarkerNumeric: Ee,
        characterReferenceValue: $e,
        codeFenced: u(_),
        codeFencedFence: k,
        codeFencedFenceInfo: v,
        codeFencedFenceMeta: b,
        codeFlowValue: z,
        codeIndented: u(E),
        codeText: u(B),
        codeTextData: z,
        data: z,
        definition: u(),
        definitionDestinationString: N,
        definitionLabelString: S,
        definitionTitleString: C,
        emphasis: u(),
        hardBreakEscape: u(P),
        hardBreakTrailing: u(P),
        htmlFlow: u(L),
        htmlFlowData: z,
        htmlText: u(X),
        htmlTextData: z,
        image: u(j),
        label: x,
        labelText: w,
        lineEnding: F,
        link: u(G),
        listItem: u(),
        listOrdered: u(),
        listUnordered: u(),
        paragraph: u(),
        referenceString: Ve,
        resourceDestinationString: oe,
        resourceTitleString: Me,
        resource: Ae,
        setextHeading: u(y),
        setextHeadingLineSequence: O,
        setextHeadingText: I,
        strong: u(),
        thematicBreak: u()
      }
    },
    t.mdastExtensions || []
  ), n = {};
  return r;
  function r(R) {
    let Y = { type: "root", children: [] }, fe = [Y], De = [], xn = [], da = {
      stack: fe,
      tokenStack: De,
      config: e,
      enter: c,
      exit: d,
      buffer: f,
      resume: h,
      setData: o,
      getData: a
    }, Be = -1;
    for (; ++Be < R.length; )
      if (R[Be][1].type === "listOrdered" || R[Be][1].type === "listUnordered")
        if (R[Be][0] === "enter")
          xn.push(Be);
        else {
          let wt = xn.pop();
          Be = i(R, wt, Be);
        }
    for (Be = -1; ++Be < R.length; ) {
      let wt = e[R[Be][0]];
      eh.call(wt, R[Be][1].type) && wt[R[Be][1].type].call(
        Object.assign({ sliceSerialize: R[Be][2].sliceSerialize }, da),
        R[Be][1]
      );
    }
    if (De.length > 0) {
      let wt = De[De.length - 1];
      (wt[1] || Wv).call(da, void 0, wt[0]);
    }
    for (Y.position = {
      start: s(R.length > 0 ? R[0][1].start : { line: 1, column: 1, offset: 0 }),
      end: s(R.length > 0 ? R[R.length - 2][1].end : { line: 1, column: 1, offset: 0 })
    }, Be = -1; ++Be < e.transforms.length; )
      Y = e.transforms[Be](Y) || Y;
    return Y;
  }
  function i(R, Y, fe) {
    let De = Y - 1, xn = -1, da = !1, Be, wt, ha, ga;
    for (; ++De <= fe; ) {
      let Ze = R[De];
      if (Ze[1].type === "listUnordered" || Ze[1].type === "listOrdered" || Ze[1].type === "blockQuote" ? (Ze[0] === "enter" ? xn++ : xn--, ga = void 0) : Ze[1].type === "lineEndingBlank" ? Ze[0] === "enter" && (Be && !ga && !xn && !ha && (ha = De), ga = void 0) : Ze[1].type === "linePrefix" || Ze[1].type === "listItemValue" || Ze[1].type === "listItemMarker" || Ze[1].type === "listItemPrefix" || Ze[1].type === "listItemPrefixWhitespace" || (ga = void 0), !xn && Ze[0] === "enter" && Ze[1].type === "listItemPrefix" || xn === -1 && Ze[0] === "exit" && (Ze[1].type === "listUnordered" || Ze[1].type === "listOrdered")) {
        if (Be) {
          let yu = De;
          for (wt = void 0; yu--; ) {
            let rr = R[yu];
            if (rr[1].type === "lineEnding" || rr[1].type === "lineEndingBlank") {
              if (rr[0] === "exit")
                continue;
              wt && (R[wt][1].type = "lineEndingBlank", da = !0), rr[1].type = "lineEnding", wt = yu;
            } else if (!(rr[1].type === "linePrefix" || rr[1].type === "blockQuotePrefix" || rr[1].type === "blockQuotePrefixWhitespace" || rr[1].type === "blockQuoteMarker" || rr[1].type === "listItemIndent"))
              break;
          }
          ha && (!wt || ha < wt) && (Be._spread = !0), Be.end = Object.assign({}, wt ? R[wt][1].start : Ze[1].end), R.splice(wt || De, 0, ["exit", Be, Ze[2]]), De++, fe++;
        }
        Ze[1].type === "listItemPrefix" && (Be = { type: "listItem", _spread: !1, start: Object.assign({}, Ze[1].start) }, R.splice(De, 0, ["enter", Be, Ze[2]]), De++, fe++, ha = void 0, ga = !0);
      }
    }
    return R[Y][1]._spread = da, fe;
  }
  function o(R, Y) {
    n[R] = Y;
  }
  function a(R) {
    return n[R];
  }
  function s(R) {
    return { line: R.line, column: R.column, offset: R.offset };
  }
  function l(R, Y) {
    return fe;
    function fe(De) {
      c.call(this, R(De), De), Y && Y.call(this, De);
    }
  }
  function f() {
    this.stack.push({ type: "fragment", children: [] });
  }
  function c(R, Y, fe) {
    return this.stack[this.stack.length - 1].children.push(R), this.stack.push(R), this.tokenStack.push([Y, fe]), R.position = { start: s(Y.start) }, R;
  }
  function u(R) {
    return Y;
    function Y(fe) {
      R && R.call(this, fe), d.call(this, fe);
    }
  }
  function d(R, Y) {
    let fe = this.stack.pop(), De = this.tokenStack.pop();
    if (De)
      De[0].type !== R.type && (Y ? Y.call(this, R, De[0]) : (De[1] || Wv).call(this, R, De[0]));
    else
      throw new Error(
        "Cannot close `" + R.type + "` (" + jl({ start: R.start, end: R.end }) + "): it’s not open"
      );
    return fe.position.end = s(R.end), fe;
  }
  function h() {
    return d8(this.stack.pop());
  }
  function p() {
    o("expectingFirstListItemValue", !0);
  }
  function m(R) {
    if (a("expectingFirstListItemValue")) {
      let Y = this.stack[this.stack.length - 2];
      Y.start = Number.parseInt(this.sliceSerialize(R), 10), o("expectingFirstListItemValue");
    }
  }
  function v() {
    let R = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.lang = R;
  }
  function b() {
    let R = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.meta = R;
  }
  function k() {
    a("flowCodeInside") || (this.buffer(), o("flowCodeInside", !0));
  }
  function _() {
    let R = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = R.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), o("flowCodeInside");
  }
  function E() {
    let R = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = R.replace(/(\r?\n|\r)$/g, "");
  }
  function S(R) {
    let Y = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.label = Y, fe.identifier = wo(this.sliceSerialize(R)).toLowerCase();
  }
  function C() {
    let R = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.title = R;
  }
  function N() {
    let R = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.url = R;
  }
  function $(R) {
    let Y = this.stack[this.stack.length - 1];
    if (!Y.depth) {
      let fe = this.sliceSerialize(R).length;
      Y.depth = fe;
    }
  }
  function I() {
    o("setextHeadingSlurpLineEnding", !0);
  }
  function O(R) {
    let Y = this.stack[this.stack.length - 1];
    Y.depth = this.sliceSerialize(R).charCodeAt(0) === 61 ? 1 : 2;
  }
  function y() {
    o("setextHeadingSlurpLineEnding");
  }
  function A(R) {
    let Y = this.stack[this.stack.length - 1], fe = Y.children[Y.children.length - 1];
    (!fe || fe.type !== "text") && (fe = NC(), fe.position = { start: s(R.start) }, Y.children.push(fe)), this.stack.push(fe);
  }
  function z(R) {
    let Y = this.stack.pop();
    Y.value += this.sliceSerialize(R), Y.position.end = s(R.end);
  }
  function F(R) {
    let Y = this.stack[this.stack.length - 1];
    if (a("atHardBreak")) {
      let fe = Y.children[Y.children.length - 1];
      fe.position.end = s(R.end), o("atHardBreak");
      return;
    }
    !a("setextHeadingSlurpLineEnding") && e.canContainEols.includes(Y.type) && (A.call(this, R), z.call(this, R));
  }
  function P() {
    o("atHardBreak", !0);
  }
  function L() {
    let R = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = R;
  }
  function X() {
    let R = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = R;
  }
  function B() {
    let R = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = R;
  }
  function G() {
    let R = this.stack[this.stack.length - 1];
    a("inReference") ? (R.type += "Reference", R.referenceType = a("referenceType") || "shortcut", delete R.url, delete R.title) : (delete R.identifier, delete R.label), o("referenceType");
  }
  function j() {
    let R = this.stack[this.stack.length - 1];
    a("inReference") ? (R.type += "Reference", R.referenceType = a("referenceType") || "shortcut", delete R.url, delete R.title) : (delete R.identifier, delete R.label), o("referenceType");
  }
  function w(R) {
    let Y = this.stack[this.stack.length - 2], fe = this.sliceSerialize(R);
    Y.label = oL(fe), Y.identifier = wo(fe).toLowerCase();
  }
  function x() {
    let R = this.stack[this.stack.length - 1], Y = this.resume(), fe = this.stack[this.stack.length - 1];
    o("inReference", !0), fe.type === "link" ? fe.children = R.children : fe.alt = Y;
  }
  function oe() {
    let R = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.url = R;
  }
  function Me() {
    let R = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.title = R;
  }
  function Ae() {
    o("inReference");
  }
  function te() {
    o("referenceType", "collapsed");
  }
  function Ve(R) {
    let Y = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.label = Y, fe.identifier = wo(this.sliceSerialize(R)).toLowerCase(), o("referenceType", "full");
  }
  function Ee(R) {
    o("characterReferenceType", R.type);
  }
  function $e(R) {
    let Y = this.sliceSerialize(R), fe = a("characterReferenceType"), De;
    fe ? (De = b3(Y, fe === "characterReferenceMarkerNumeric" ? 10 : 16), o("characterReferenceType")) : De = tg(Y);
    let xn = this.stack.pop();
    xn.value += De, xn.position.end = s(R.end);
  }
  function Qt(R) {
    z.call(this, R);
    let Y = this.stack[this.stack.length - 1];
    Y.url = this.sliceSerialize(R);
  }
  function ue(R) {
    z.call(this, R);
    let Y = this.stack[this.stack.length - 1];
    Y.url = "mailto:" + this.sliceSerialize(R);
  }
  function Xt() {
    return { type: "blockquote", children: [] };
  }
  function kn() {
    return { type: "code", lang: null, meta: null, value: "" };
  }
  function Lt() {
    return { type: "inlineCode", value: "" };
  }
  function Se() {
    return { type: "definition", identifier: "", label: null, title: null, url: "" };
  }
  function Cn() {
    return { type: "emphasis", children: [] };
  }
  function mr() {
    return { type: "heading", depth: void 0, children: [] };
  }
  function ua() {
    return { type: "break" };
  }
  function jg() {
    return { type: "html", value: "" };
  }
  function EC() {
    return { type: "image", title: null, url: "", alt: null };
  }
  function zg() {
    return { type: "link", title: null, url: "", children: [] };
  }
  function Bg(R) {
    return {
      type: "list",
      ordered: R.type === "listOrdered",
      start: null,
      spread: R._spread,
      children: []
    };
  }
  function TC(R) {
    return { type: "listItem", spread: R._spread, checked: null, children: [] };
  }
  function SC() {
    return { type: "paragraph", children: [] };
  }
  function IC() {
    return { type: "strong", children: [] };
  }
  function NC() {
    return { type: "text", value: "" };
  }
  function MC() {
    return { type: "thematicBreak" };
  }
}
function y3(t, e) {
  let n = -1;
  for (; ++n < e.length; ) {
    let r = e[n];
    Array.isArray(r) ? y3(t, r) : fL(t, r);
  }
  return t;
}
function fL(t, e) {
  let n;
  for (n in e)
    if (eh.call(e, n)) {
      let r = n === "canContainEols" || n === "transforms", i = (eh.call(t, n) ? t[n] : void 0) || (t[n] = r ? [] : {}), o = e[n];
      o && (r ? t[n] = [...i, ...o] : Object.assign(i, o));
    }
}
function Wv(t, e) {
  throw t ? new Error(
    "Cannot close `" + t.type + "` (" + jl({ start: t.start, end: t.end }) + "): a different token (`" + e.type + "`, " + jl({ start: e.start, end: e.end }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + e.type + "`, " + jl({ start: e.start, end: e.end }) + ") is still open"
  );
}
function cL(t) {
  Object.assign(this, { Parser: (n) => {
    const r = (
      /** @type {Options} */
      this.data("settings")
    );
    return sL(
      n,
      Object.assign({}, r, t, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data("micromarkExtensions") || [],
        mdastExtensions: this.data("fromMarkdownExtensions") || []
      })
    );
  } });
}
function Uv(t) {
  if (t)
    throw t;
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var _3 = function(e) {
  return e != null && e.constructor != null && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}, zl = Object.prototype.hasOwnProperty, w3 = Object.prototype.toString, Hv = Object.defineProperty, Vv = Object.getOwnPropertyDescriptor, Kv = function(e) {
  return typeof Array.isArray == "function" ? Array.isArray(e) : w3.call(e) === "[object Array]";
}, Yv = function(e) {
  if (!e || w3.call(e) !== "[object Object]")
    return !1;
  var n = zl.call(e, "constructor"), r = e.constructor && e.constructor.prototype && zl.call(e.constructor.prototype, "isPrototypeOf");
  if (e.constructor && !n && !r)
    return !1;
  var i;
  for (i in e)
    ;
  return typeof i > "u" || zl.call(e, i);
}, qv = function(e, n) {
  Hv && n.name === "__proto__" ? Hv(e, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : e[n.name] = n.newValue;
}, Gv = function(e, n) {
  if (n === "__proto__")
    if (zl.call(e, n)) {
      if (Vv)
        return Vv(e, n).value;
    } else
      return;
  return e[n];
}, Qv = function t() {
  var e, n, r, i, o, a, s = arguments[0], l = 1, f = arguments.length, c = !1;
  for (typeof s == "boolean" && (c = s, s = arguments[1] || {}, l = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); l < f; ++l)
    if (e = arguments[l], e != null)
      for (n in e)
        r = Gv(s, n), i = Gv(e, n), s !== i && (c && i && (Yv(i) || (o = Kv(i))) ? (o ? (o = !1, a = r && Kv(r) ? r : []) : a = r && Yv(r) ? r : {}, qv(s, { name: n, newValue: t(c, a, i) })) : typeof i < "u" && qv(s, { name: n, newValue: i }));
  return s;
};
function th(t) {
  if (typeof t != "object" || t === null)
    return !1;
  const e = Object.getPrototypeOf(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}
function uL() {
  const t = [], e = { run: n, use: r };
  return e;
  function n(...i) {
    let o = -1;
    const a = i.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    s(null, ...i);
    function s(l, ...f) {
      const c = t[++o];
      let u = -1;
      if (l) {
        a(l);
        return;
      }
      for (; ++u < i.length; )
        (f[u] === null || f[u] === void 0) && (f[u] = i[u]);
      i = f, c ? dL(c, s)(...f) : a(null, ...f);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return t.push(i), e;
  }
}
function dL(t, e) {
  let n;
  return r;
  function r(...a) {
    const s = t.length > a.length;
    let l;
    s && a.push(i);
    try {
      l = t.apply(this, a);
    } catch (f) {
      const c = (
        /** @type {Error} */
        f
      );
      if (s && n)
        throw c;
      return i(c);
    }
    s || (l instanceof Promise ? l.then(o, i) : l instanceof Error ? i(l) : o(l));
  }
  function i(a, ...s) {
    n || (n = !0, e(a, ...s));
  }
  function o(a) {
    i(null, a);
  }
}
function hL(t) {
  return !t || typeof t != "object" ? "" : "position" in t || "type" in t ? Xv(t.position) : "start" in t || "end" in t ? Xv(t) : "line" in t || "column" in t ? nh(t) : "";
}
function nh(t) {
  return Jv(t && t.line) + ":" + Jv(t && t.column);
}
function Xv(t) {
  return nh(t && t.start) + "-" + nh(t && t.end);
}
function Jv(t) {
  return t && typeof t == "number" ? t : 1;
}
class mn extends Error {
  /**
   * Constructor of a message for `reason` at `place` from `origin`.
   * When an error is passed in as `reason`, copies the `stack`.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   */
  constructor(e, n, r) {
    const i = [null, null];
    let o = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (r = n, n = void 0), typeof r == "string") {
      const a = r.indexOf(":");
      a === -1 ? i[1] = r : (i[0] = r.slice(0, a), i[1] = r.slice(a + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (o = n.position) : "start" in n || "end" in n ? o = n : ("line" in n || "column" in n) && (o.start = n)), this.name = hL(n) || "1:1", this.message = typeof e == "object" ? e.message : e, this.stack = typeof e == "object" ? e.stack : "", this.reason = this.message, this.fatal, this.line = o.start.line, this.column = o.start.column, this.source = i[0], this.ruleId = i[1], this.position = o, this.actual, this.expected, this.file, this.url, this.note;
  }
}
mn.prototype.file = "";
mn.prototype.name = "";
mn.prototype.reason = "";
mn.prototype.message = "";
mn.prototype.stack = "";
mn.prototype.fatal = null;
mn.prototype.column = null;
mn.prototype.line = null;
mn.prototype.source = null;
mn.prototype.ruleId = null;
mn.prototype.position = null;
const Ln = { basename: gL, dirname: pL, extname: mL, join: vL, sep: "/" };
function gL(t, e) {
  if (e !== void 0 && typeof e != "string")
    throw new TypeError('"ext" argument must be a string');
  el(t);
  let n = 0, r = -1, i = t.length, o;
  if (e === void 0 || e.length === 0 || e.length > t.length) {
    for (; i--; )
      if (t.charCodeAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else
        r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : t.slice(n, r);
  }
  if (e === t)
    return "";
  let a = -1, s = e.length - 1;
  for (; i--; )
    if (t.charCodeAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      a < 0 && (o = !0, a = i + 1), s > -1 && (t.charCodeAt(i) === e.charCodeAt(s--) ? s < 0 && (r = i) : (s = -1, r = a));
  return n === r ? r = a : r < 0 && (r = t.length), t.slice(n, r);
}
function pL(t) {
  if (el(t), t.length === 0)
    return ".";
  let e = -1, n = t.length, r;
  for (; --n; )
    if (t.charCodeAt(n) === 47) {
      if (r) {
        e = n;
        break;
      }
    } else
      r || (r = !0);
  return e < 0 ? t.charCodeAt(0) === 47 ? "/" : "." : e === 1 && t.charCodeAt(0) === 47 ? "//" : t.slice(0, e);
}
function mL(t) {
  el(t);
  let e = t.length, n = -1, r = 0, i = -1, o = 0, a;
  for (; e--; ) {
    const s = t.charCodeAt(e);
    if (s === 47) {
      if (a) {
        r = e + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = e + 1), s === 46 ? i < 0 ? i = e : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : t.slice(i, n);
}
function vL(...t) {
  let e = -1, n;
  for (; ++e < t.length; )
    el(t[e]), t[e] && (n = n === void 0 ? t[e] : n + "/" + t[e]);
  return n === void 0 ? "." : bL(n);
}
function bL(t) {
  el(t);
  const e = t.charCodeAt(0) === 47;
  let n = yL(t, !e);
  return n.length === 0 && !e && (n = "."), n.length > 0 && t.charCodeAt(t.length - 1) === 47 && (n += "/"), e ? "/" + n : n;
}
function yL(t, e) {
  let n = "", r = 0, i = -1, o = 0, a = -1, s, l;
  for (; ++a <= t.length; ) {
    if (a < t.length)
      s = t.charCodeAt(a);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === a - 1 || o === 1))
        if (i !== a - 1 && o === 2) {
          if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (l = n.lastIndexOf("/"), l !== n.length - 1) {
                l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), i = a, o = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, i = a, o = 0;
              continue;
            }
          }
          e && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + t.slice(i + 1, a) : n = t.slice(i + 1, a), r = a - i - 1;
      i = a, o = 0;
    } else
      s === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function el(t) {
  if (typeof t != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(t)
    );
}
const _L = { cwd: wL };
function wL() {
  return "/";
}
function rh(t) {
  return t !== null && typeof t == "object" && // @ts-expect-error: indexable.
  t.href && // @ts-expect-error: indexable.
  t.origin;
}
function kL(t) {
  if (typeof t == "string")
    t = new URL(t);
  else if (!rh(t)) {
    const e = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + t + "`"
    );
    throw e.code = "ERR_INVALID_ARG_TYPE", e;
  }
  if (t.protocol !== "file:") {
    const e = new TypeError("The URL must be of scheme file");
    throw e.code = "ERR_INVALID_URL_SCHEME", e;
  }
  return CL(t);
}
function CL(t) {
  if (t.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const e = t.pathname;
  let n = -1;
  for (; ++n < e.length; )
    if (e.charCodeAt(n) === 37 && e.charCodeAt(n + 1) === 50) {
      const r = e.charCodeAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(e);
}
const fd = ["history", "path", "basename", "stem", "extname", "dirname"];
class xL {
  /**
   * Create a new virtual file.
   *
   * If `options` is `string` or `Buffer`, it’s treated as `{value: options}`.
   * If `options` is a `URL`, it’s treated as `{path: options}`.
   * If `options` is a `VFile`, shallow copies its data over to the new file.
   * All fields in `options` are set on the newly created `VFile`.
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * It’s not possible to set either `dirname` or `extname` without setting
   * either `history`, `path`, `basename`, or `stem` as well.
   *
   * @param {Compatible} [value]
   */
  constructor(e) {
    let n;
    e ? typeof e == "string" || _3(e) ? n = { value: e } : rh(e) ? n = { path: e } : n = e : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = _L.cwd(), this.value, this.stored, this.result, this.map;
    let r = -1;
    for (; ++r < fd.length; ) {
      const o = fd[r];
      o in n && n[o] !== void 0 && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      fd.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   * @param {string|URL} path
   */
  set path(e) {
    rh(e) && (e = kL(e)), ud(e, "path"), this.path !== e && this.history.push(e);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? Ln.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(e) {
    Zv(this.basename, "dirname"), this.path = Ln.join(e || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? Ln.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(e) {
    ud(e, "basename"), cd(e, "basename"), this.path = Ln.join(this.dirname || "", e);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? Ln.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(e) {
    if (cd(e, "extname"), Zv(this.dirname, "extname"), e) {
      if (e.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (e.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Ln.join(this.dirname, this.stem + (e || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? Ln.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(e) {
    ud(e, "stem"), cd(e, "stem"), this.path = Ln.join(this.dirname || "", e + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding} [encoding='utf8']
   *   When `value` is a `Buffer`, `encoding` is a character encoding to
   *   understand it as (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(e) {
    return (this.value || "").toString(e);
  }
  /**
   * Constructs a new `VFileMessage`, where `fatal` is set to `false`, and
   * associates it with the file by adding it to `vfile.messages` and setting
   * `message.file` to the current filepath.
   *
   * @param {string|Error} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */
  message(e, n, r) {
    const i = new mn(e, n, r);
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Like `VFile#message()`, but associates an informational message where
   * `fatal` is set to `null`.
   *
   * @param {string|Error} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */
  info(e, n, r) {
    const i = this.message(e, n, r);
    return i.fatal = null, i;
  }
  /**
   * Like `VFile#message()`, but associates a fatal message where `fatal` is
   * set to `true`, and then immediately throws it.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string|Error} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {never}
   *   Message.
   */
  fail(e, n, r) {
    const i = this.message(e, n, r);
    throw i.fatal = !0, i;
  }
}
function cd(t, e) {
  if (t && t.includes(Ln.sep))
    throw new Error(
      "`" + e + "` cannot be a path: did not expect `" + Ln.sep + "`"
    );
}
function ud(t, e) {
  if (!t)
    throw new Error("`" + e + "` cannot be empty");
}
function Zv(t, e) {
  if (!t)
    throw new Error("Setting `" + e + "` requires `path` to be set too");
}
const EL = C3().freeze(), k3 = {}.hasOwnProperty;
function C3() {
  const t = uL(), e = [];
  let n = {}, r, i = -1;
  return o.data = a, o.Parser = void 0, o.Compiler = void 0, o.freeze = s, o.attachers = e, o.use = l, o.parse = f, o.stringify = c, o.run = u, o.runSync = d, o.process = h, o.processSync = p, o;
  function o() {
    const m = C3();
    let v = -1;
    for (; ++v < e.length; )
      m.use(...e[v]);
    return m.data(Qv(!0, {}, n)), m;
  }
  function a(m, v) {
    return typeof m == "string" ? arguments.length === 2 ? (gd("data", r), n[m] = v, o) : k3.call(n, m) && n[m] || null : m ? (gd("data", r), n = m, o) : n;
  }
  function s() {
    if (r)
      return o;
    for (; ++i < e.length; ) {
      const [m, ...v] = e[i];
      if (v[0] === !1)
        continue;
      v[0] === !0 && (v[0] = void 0);
      const b = m.call(o, ...v);
      typeof b == "function" && t.use(b);
    }
    return r = !0, i = Number.POSITIVE_INFINITY, o;
  }
  function l(m, ...v) {
    let b;
    if (gd("use", r), m != null)
      if (typeof m == "function")
        S(m, ...v);
      else if (typeof m == "object")
        Array.isArray(m) ? E(m) : _(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    return b && (n.settings = Object.assign(n.settings || {}, b)), o;
    function k(C) {
      if (typeof C == "function")
        S(C);
      else if (typeof C == "object")
        if (Array.isArray(C)) {
          const [N, ...$] = C;
          S(N, ...$);
        } else
          _(C);
      else
        throw new TypeError("Expected usable value, not `" + C + "`");
    }
    function _(C) {
      E(C.plugins), C.settings && (b = Object.assign(b || {}, C.settings));
    }
    function E(C) {
      let N = -1;
      if (C != null)
        if (Array.isArray(C))
          for (; ++N < C.length; ) {
            const $ = C[N];
            k($);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + C + "`");
    }
    function S(C, N) {
      let $ = -1, I;
      for (; ++$ < e.length; )
        if (e[$][0] === C) {
          I = e[$];
          break;
        }
      I ? (th(I[1]) && th(N) && (N = Qv(!0, I[1], N)), I[1] = N) : e.push([...arguments]);
    }
  }
  function f(m) {
    o.freeze();
    const v = Ea(m), b = o.Parser;
    return dd("parse", b), e2(b, "parse") ? new b(String(v), v).parse() : b(String(v), v);
  }
  function c(m, v) {
    o.freeze();
    const b = Ea(v), k = o.Compiler;
    return hd("stringify", k), t2(m), e2(k, "compile") ? new k(m, b).compile() : k(m, b);
  }
  function u(m, v, b) {
    if (t2(m), o.freeze(), !b && typeof v == "function" && (b = v, v = void 0), !b)
      return new Promise(k);
    k(null, b);
    function k(_, E) {
      t.run(m, Ea(v), S);
      function S(C, N, $) {
        N = N || m, C ? E(C) : _ ? _(N) : b(null, N, $);
      }
    }
  }
  function d(m, v) {
    let b, k;
    return o.run(m, v, _), n2("runSync", "run", k), b;
    function _(E, S) {
      Uv(E), b = S, k = !0;
    }
  }
  function h(m, v) {
    if (o.freeze(), dd("process", o.Parser), hd("process", o.Compiler), !v)
      return new Promise(b);
    b(null, v);
    function b(k, _) {
      const E = Ea(m);
      o.run(o.parse(E), E, (C, N, $) => {
        if (C || !N || !$)
          S(C);
        else {
          const I = o.stringify(N, $);
          I == null || (IL(I) ? $.value = I : $.result = I), S(C, $);
        }
      });
      function S(C, N) {
        C || !N ? _(C) : k ? k(N) : v(null, N);
      }
    }
  }
  function p(m) {
    let v;
    o.freeze(), dd("processSync", o.Parser), hd("processSync", o.Compiler);
    const b = Ea(m);
    return o.process(b, k), n2("processSync", "process", v), b;
    function k(_) {
      v = !0, Uv(_);
    }
  }
}
function e2(t, e) {
  return typeof t == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  t.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (TL(t.prototype) || e in t.prototype);
}
function TL(t) {
  let e;
  for (e in t)
    if (k3.call(t, e))
      return !0;
  return !1;
}
function dd(t, e) {
  if (typeof e != "function")
    throw new TypeError("Cannot `" + t + "` without `Parser`");
}
function hd(t, e) {
  if (typeof e != "function")
    throw new TypeError("Cannot `" + t + "` without `Compiler`");
}
function gd(t, e) {
  if (e)
    throw new Error(
      "Cannot call `" + t + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function t2(t) {
  if (!th(t) || typeof t.type != "string")
    throw new TypeError("Expected node, got `" + t + "`");
}
function n2(t, e, n) {
  if (!n)
    throw new Error(
      "`" + t + "` finished async. Use `" + e + "` instead"
    );
}
function Ea(t) {
  return SL(t) ? t : new xL(t);
}
function SL(t) {
  return Boolean(
    t && typeof t == "object" && "message" in t && "messages" in t
  );
}
function IL(t) {
  return typeof t == "string" || _3(t);
}
function NL(t) {
  return t.href.startsWith("#PIN") ? /* @__PURE__ */ g(E6, {
    id: "foo"
  }) : /* @__PURE__ */ g("a", {
    ...t
  });
}
const ML = !!(typeof window < "u" && window.document && window.document.createElement), AL = ML ? EL().use(cL).use(s8).use(yR, {
  createElement: ko,
  Fragment: X2,
  components: {
    a: NL
  }
}) : {
  processSync: () => ({
    result: null
  })
}, OL = he.memo(function(e) {
  const n = AL.processSync(e.body).result;
  return n ? /* @__PURE__ */ g("div", {
    "data-testid": "collabkit-markdown",
    className: e.className,
    children: n
  }) : null;
}), rg = he.createContext(null);
function ig() {
  return he.useContext(rg);
}
function oa() {
  return ig() ?? "default";
}
function pr() {
  const t = he.useContext(rg);
  if (!t)
    throw new Error("useCommentContext must be used within an CommentContextProvider");
  return t;
}
function DL(t) {
  const {
    timestamp: e
  } = t, n = t.format ? t.format(e, Date.now()) : lE(e, Date.now());
  return /* @__PURE__ */ g("time", {
    className: t.className,
    style: t.style,
    dateTime: iE(e),
    children: n
  });
}
const r2 = he.useId;
let PL = 0;
function RL() {
  const [t] = he.useState(() => PL++);
  return `useId_${t}`;
}
function og() {
  return typeof r2 == "function" ? r2() : RL();
}
function ag() {
  return ie(_e()).workspaceId;
}
function _t() {
  const t = ag();
  if (!t)
    throw new Error("useWorkspaceContext requires authentication");
  return t;
}
function Gt() {
  const t = LL();
  if (t == null)
    throw new Error("[useWorkspaceStore] Workspace not found");
  return t;
}
function LL() {
  const t = _e(), e = ag();
  return e ? t.workspaces[e] : null;
}
function $L(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function i2(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function o2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? i2(Object(n), !0).forEach(function(r) {
      $L(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : i2(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
var FL = (t, e, n) => {
  for (var r of Object.keys(t)) {
    var i;
    if (t[r] !== ((i = e[r]) !== null && i !== void 0 ? i : n[r]))
      return !1;
  }
  return !0;
}, Tt = (t) => (e) => {
  var n = t.defaultClassName, r = o2(o2({}, t.defaultVariants), e);
  for (var i in r) {
    var o, a = (o = r[i]) !== null && o !== void 0 ? o : t.defaultVariants[i];
    if (a != null) {
      var s = a;
      typeof s == "boolean" && (s = s === !0 ? "true" : "false");
      var l = (
        // @ts-expect-error
        t.variantClassNames[i][s]
      );
      l && (n += " " + l);
    }
  }
  for (var [f, c] of t.compoundVariants)
    FL(f, r, t.defaultVariants) && (n += " " + c);
  return n;
}, jL = "_1muzgsqk", zL = "_1muzgsqd", BL = "_1muzgsqi", WL = Tt({ defaultClassName: "_1muzgsq5", variantClassNames: { disabled: { false: "_1muzgsq6", true: "_1muzgsq7" } }, defaultVariants: {}, compoundVariants: [] }), UL = "_1muzgsq9", HL = "_1muzgsq8", VL = "_1muzgsqa", KL = "_1muzgsq3", YL = "_1muzgsqn", qL = "_1muzgsqo", GL = Tt({ defaultClassName: "_1muzgsql", variantClassNames: { isSelected: { true: "_1muzgsqm" } }, defaultVariants: {}, compoundVariants: [] }), x3 = "_1muzgsqb", E3 = "_1muzgsqf", T3 = "_1muzgsqh", S3 = "_1muzgsqg", I3 = Tt({ defaultClassName: "_1muzgsq0", variantClassNames: { indent: { true: "_1muzgsq1", false: "_1muzgsq2" } }, defaultVariants: {}, compoundVariants: [] }), QL = "_1muzgsqj", XL = "_1muzgsqe", N3 = /* @__PURE__ */ ui({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), Dn = function(e, n, r) {
  var i = r.get(e);
  return i ? i(n) : (console.error('Unsupported icon weight. Choose from "thin", "light", "regular", "bold", "fill", or "duotone".'), null);
};
function a2(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
var M3 = /* @__PURE__ */ ze(function(t, e) {
  var n = t.alt, r = t.color, i = t.size, o = t.weight, a = t.mirrored, s = t.children, l = t.renderPath, f = a2(t, ["alt", "color", "size", "weight", "mirrored", "children", "renderPath"]), c = Ii(N3), u = c.color, d = u === void 0 ? "currentColor" : u, h = c.size, p = c.weight, m = p === void 0 ? "regular" : p, v = c.mirrored, b = v === void 0 ? !1 : v, k = a2(c, ["color", "size", "weight", "mirrored"]);
  return /* @__PURE__ */ D("svg", {
    ...Object.assign({
      ref: e,
      xmlns: "http://www.w3.org/2000/svg",
      width: i ?? h,
      height: i ?? h,
      fill: r ?? d,
      viewBox: "0 0 256 256",
      transform: a || b ? "scale(-1, 1)" : void 0
    }, k, f),
    children: [!!n && /* @__PURE__ */ g("title", {
      children: n
    }), s, /* @__PURE__ */ g("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }), l(o ?? m, r ?? d)]
  });
});
M3.displayName = "IconBase";
const Pn = M3;
var zi = /* @__PURE__ */ new Map();
zi.set("bold", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "40",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    }), /* @__PURE__ */ g("path", {
      d: "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    })]
  });
});
zi.set("duotone", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      opacity: "0.2"
    }), /* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "40",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("path", {
      d: "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
zi.set("fill", function() {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("path", {
      d: "M128,24A104.1,104.1,0,0,0,24.1,132.1c2.1,54.7,47,98.8,101.8,99.9a104,104,0,0,0,91.4-50.8,4,4,0,0,0-4.1-6,52.5,52.5,0,0,1-9.2.8c-18.3,0-28.5-8-33.9-14.7a43.9,43.9,0,0,1-3.4-5A48,48,0,1,1,128,80a47.4,47.4,0,0,1,32,12.3v-4a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v40c0,14.6,4.9,32,28,32s27.6-16.2,28-30.5V128A104.1,104.1,0,0,0,128,24Z"
    }), /* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "32"
    })]
  });
});
zi.set("light", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "40",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    }), /* @__PURE__ */ g("path", {
      d: "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    })]
  });
});
zi.set("thin", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "40",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }), /* @__PURE__ */ g("path", {
      d: "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    })]
  });
});
zi.set("regular", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "40",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("path", {
      d: "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
var JL = function(e, n) {
  return Dn(e, n, zi);
}, A3 = /* @__PURE__ */ ze(function(t, e) {
  return /* @__PURE__ */ g(Pn, {
    ...Object.assign({
      ref: e
    }, t, {
      renderPath: JL
    })
  });
});
A3.displayName = "At";
const ZL = A3;
var Bi = /* @__PURE__ */ new Map();
Bi.set("bold", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    })
  });
});
Bi.set("duotone", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("path", {
      d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      opacity: "0.2"
    }), /* @__PURE__ */ g("path", {
      d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
Bi.set("fill", function() {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M216,40H40A16,16,0,0,0,24,56V184a16,16,0,0,0,16,16H99.5l14.8,24.7a16,16,0,0,0,27.4,0L156.5,200H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Z"
    })
  });
});
Bi.set("light", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    })
  });
});
Bi.set("thin", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    })
  });
});
Bi.set("regular", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })
  });
});
var e$ = function(e, n) {
  return Dn(e, n, Bi);
}, O3 = /* @__PURE__ */ ze(function(t, e) {
  return /* @__PURE__ */ g(Pn, {
    ...Object.assign({
      ref: e
    }, t, {
      renderPath: e$
    })
  });
});
O3.displayName = "ChatCentered";
const sg = O3;
var Wi = /* @__PURE__ */ new Map();
Wi.set("bold", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "216 72 104 184 48 128",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    })
  });
});
Wi.set("duotone", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "216 72 104 184 48 128",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })
  });
});
Wi.set("fill", function() {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M104,192a8.5,8.5,0,0,1-5.7-2.3l-56-56a8.1,8.1,0,0,1,11.4-11.4L104,172.7,210.3,66.3a8.1,8.1,0,0,1,11.4,11.4l-112,112A8.5,8.5,0,0,1,104,192Z"
    })
  });
});
Wi.set("light", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "216 72 104 184 48 128",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    })
  });
});
Wi.set("thin", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "216 72 104 184 48 128",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    })
  });
});
Wi.set("regular", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "216 72 104 184 48 128",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })
  });
});
var t$ = function(e, n) {
  return Dn(e, n, Wi);
}, D3 = /* @__PURE__ */ ze(function(t, e) {
  return /* @__PURE__ */ g(Pn, {
    ...Object.assign({
      ref: e
    }, t, {
      renderPath: t$
    })
  });
});
D3.displayName = "Check";
const n$ = D3;
var Ui = /* @__PURE__ */ new Map();
Ui.set("bold", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "172 104 113.3 160 84 132",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    }), /* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    })]
  });
});
Ui.set("duotone", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      opacity: "0.2"
    }), /* @__PURE__ */ g("polyline", {
      points: "172 104 113.3 160 84 132",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
Ui.set("fill", function() {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm49.5,85.8-58.6,56a8.1,8.1,0,0,1-5.6,2.2,7.7,7.7,0,0,1-5.5-2.2l-29.3-28a8,8,0,1,1,11-11.6l23.8,22.7,53.2-50.7a8,8,0,0,1,11,11.6Z"
    })
  });
});
Ui.set("light", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "172 104 113.3 160 84 132",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    }), /* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    })]
  });
});
Ui.set("thin", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "172 104 113.3 160 84 132",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }), /* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    })]
  });
});
Ui.set("regular", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "172 104 113.3 160 84 132",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
var r$ = function(e, n) {
  return Dn(e, n, Ui);
}, P3 = /* @__PURE__ */ ze(function(t, e) {
  return /* @__PURE__ */ g(Pn, {
    ...Object.assign({
      ref: e
    }, t, {
      renderPath: r$
    })
  });
});
P3.displayName = "CheckCircle";
const lg = P3;
var Hi = /* @__PURE__ */ new Map();
Hi.set("bold", function() {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "16"
    }), /* @__PURE__ */ g("circle", {
      cx: "64",
      cy: "128",
      r: "16"
    }), /* @__PURE__ */ g("circle", {
      cx: "192",
      cy: "128",
      r: "16"
    })]
  });
});
Hi.set("duotone", function() {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "12"
    }), /* @__PURE__ */ g("circle", {
      cx: "192",
      cy: "128",
      r: "12"
    }), /* @__PURE__ */ g("circle", {
      cx: "64",
      cy: "128",
      r: "12"
    })]
  });
});
Hi.set("fill", function() {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm52-12a12,12,0,1,0,12,12A12,12,0,0,0,192,116ZM64,116a12,12,0,1,0,12,12A12,12,0,0,0,64,116Z"
    })
  });
});
Hi.set("light", function() {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "10"
    }), /* @__PURE__ */ g("circle", {
      cx: "64",
      cy: "128",
      r: "10"
    }), /* @__PURE__ */ g("circle", {
      cx: "192",
      cy: "128",
      r: "10"
    })]
  });
});
Hi.set("thin", function() {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "8"
    }), /* @__PURE__ */ g("circle", {
      cx: "64",
      cy: "128",
      r: "8"
    }), /* @__PURE__ */ g("circle", {
      cx: "192",
      cy: "128",
      r: "8"
    })]
  });
});
Hi.set("regular", function() {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "12"
    }), /* @__PURE__ */ g("circle", {
      cx: "192",
      cy: "128",
      r: "12"
    }), /* @__PURE__ */ g("circle", {
      cx: "64",
      cy: "128",
      r: "12"
    })]
  });
});
var i$ = function(e, n) {
  return Dn(e, n, Hi);
}, R3 = /* @__PURE__ */ ze(function(t, e) {
  return /* @__PURE__ */ g(Pn, {
    ...Object.assign({
      ref: e
    }, t, {
      renderPath: i$
    })
  });
});
R3.displayName = "DotsThree";
const o$ = R3;
var Vi = /* @__PURE__ */ new Map();
Vi.set("bold", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    }), /* @__PURE__ */ g("circle", {
      cx: "92",
      cy: "108",
      r: "16"
    }), /* @__PURE__ */ g("circle", {
      cx: "164",
      cy: "108",
      r: "16"
    }), /* @__PURE__ */ g("path", {
      d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    })]
  });
});
Vi.set("duotone", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      opacity: "0.2"
    }), /* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      fill: "none",
      stroke: t,
      strokeMiterlimit: "10",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("circle", {
      cx: "92",
      cy: "108",
      r: "12"
    }), /* @__PURE__ */ g("circle", {
      cx: "164",
      cy: "108",
      r: "12"
    }), /* @__PURE__ */ g("path", {
      d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
Vi.set("fill", function() {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm84.5,60a56,56,0,0,1-97,0,8,8,0,1,1,13.8-8,40.1,40.1,0,0,0,69.4,0,8,8,0,0,1,13.8,8Z"
    })
  });
});
Vi.set("light", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    }), /* @__PURE__ */ g("circle", {
      cx: "92",
      cy: "108",
      r: "10"
    }), /* @__PURE__ */ g("circle", {
      cx: "164",
      cy: "108",
      r: "10"
    }), /* @__PURE__ */ g("path", {
      d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    })]
  });
});
Vi.set("thin", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }), /* @__PURE__ */ g("circle", {
      cx: "92",
      cy: "108",
      r: "8"
    }), /* @__PURE__ */ g("circle", {
      cx: "164",
      cy: "108",
      r: "8"
    }), /* @__PURE__ */ g("path", {
      d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    })]
  });
});
Vi.set("regular", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("circle", {
      cx: "128",
      cy: "128",
      r: "96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("circle", {
      cx: "92",
      cy: "108",
      r: "12"
    }), /* @__PURE__ */ g("circle", {
      cx: "164",
      cy: "108",
      r: "12"
    }), /* @__PURE__ */ g("path", {
      d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
var a$ = function(e, n) {
  return Dn(e, n, Vi);
}, L3 = /* @__PURE__ */ ze(function(t, e) {
  return /* @__PURE__ */ g(Pn, {
    ...Object.assign({
      ref: e
    }, t, {
      renderPath: a$
    })
  });
});
L3.displayName = "Smiley";
const s$ = L3;
var Ki = /* @__PURE__ */ new Map();
Ki.set("bold", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("line", {
      x1: "200",
      y1: "56",
      x2: "56",
      y2: "200",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    }), /* @__PURE__ */ g("line", {
      x1: "200",
      y1: "200",
      x2: "56",
      y2: "56",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    })]
  });
});
Ki.set("duotone", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("line", {
      x1: "200",
      y1: "56",
      x2: "56",
      y2: "200",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("line", {
      x1: "200",
      y1: "200",
      x2: "56",
      y2: "56",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
Ki.set("fill", function() {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M139.3,128l66.4-66.3a8.1,8.1,0,0,0-11.4-11.4L128,116.7,61.7,50.3A8.1,8.1,0,0,0,50.3,61.7L116.7,128,50.3,194.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L128,139.3l66.3,66.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4Z"
    })
  });
});
Ki.set("light", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("line", {
      x1: "200",
      y1: "56",
      x2: "56",
      y2: "200",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    }), /* @__PURE__ */ g("line", {
      x1: "200",
      y1: "200",
      x2: "56",
      y2: "56",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    })]
  });
});
Ki.set("thin", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("line", {
      x1: "200",
      y1: "56",
      x2: "56",
      y2: "200",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }), /* @__PURE__ */ g("line", {
      x1: "200",
      y1: "200",
      x2: "56",
      y2: "56",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    })]
  });
});
Ki.set("regular", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("line", {
      x1: "200",
      y1: "56",
      x2: "56",
      y2: "200",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("line", {
      x1: "200",
      y1: "200",
      x2: "56",
      y2: "56",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
var l$ = function(e, n) {
  return Dn(e, n, Ki);
}, $3 = /* @__PURE__ */ ze(function(t, e) {
  return /* @__PURE__ */ g(Pn, {
    ...Object.assign({
      ref: e
    }, t, {
      renderPath: l$
    })
  });
});
$3.displayName = "X";
const F3 = $3;
var Yi = /* @__PURE__ */ new Map();
Yi.set("bold", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "176 104 224 152 176 200",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    }), /* @__PURE__ */ g("path", {
      d: "M32,56a96,96,0,0,0,96,96h96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    })]
  });
});
Yi.set("duotone", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "176 104 224 152 176 200",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("path", {
      d: "M32,56a96,96,0,0,0,96,96h96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
Yi.set("fill", function() {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M229.7,157.7l-48,48A8.3,8.3,0,0,1,176,208a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,200V160H128A104.2,104.2,0,0,1,24,56a8,8,0,0,1,16,0,88.1,88.1,0,0,0,88,88h40V104a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,229.7,157.7Z"
    })
  });
});
Yi.set("light", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "176 104 224 152 176 200",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    }), /* @__PURE__ */ g("path", {
      d: "M32,56a96,96,0,0,0,96,96h96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    })]
  });
});
Yi.set("thin", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "176 104 224 152 176 200",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }), /* @__PURE__ */ g("path", {
      d: "M32,56a96,96,0,0,0,96,96h96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    })]
  });
});
Yi.set("regular", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "176 104 224 152 176 200",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("path", {
      d: "M32,56a96,96,0,0,0,96,96h96",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
var f$ = function(e, n) {
  return Dn(e, n, Yi);
}, j3 = /* @__PURE__ */ ze(function(t, e) {
  return /* @__PURE__ */ g(Pn, {
    ...Object.assign({
      ref: e
    }, t, {
      renderPath: f$
    })
  });
});
j3.displayName = "ArrowBendDownRight";
const fg = j3;
var qi = /* @__PURE__ */ new Map();
qi.set("bold", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "96 48 176 128 96 208",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    })
  });
});
qi.set("duotone", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polygon", {
      points: "96 48 176 128 96 208 96 48",
      opacity: "0.2"
    }), /* @__PURE__ */ g("polygon", {
      points: "96 48 176 128 96 208 96 48",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
qi.set("fill", function() {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M181.7,122.3l-80-80a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,88,48V208a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l80-80A8.1,8.1,0,0,0,181.7,122.3Z"
    })
  });
});
qi.set("light", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "96 48 176 128 96 208",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    })
  });
});
qi.set("thin", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "96 48 176 128 96 208",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    })
  });
});
qi.set("regular", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "96 48 176 128 96 208",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })
  });
});
var c$ = function(e, n) {
  return Dn(e, n, qi);
}, z3 = /* @__PURE__ */ ze(function(t, e) {
  return /* @__PURE__ */ g(Pn, {
    ...Object.assign({
      ref: e
    }, t, {
      renderPath: c$
    })
  });
});
z3.displayName = "CaretRight";
const u$ = z3;
var Gi = /* @__PURE__ */ new Map();
Gi.set("bold", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "160 208 80 128 160 48",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    })
  });
});
Gi.set("duotone", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polygon", {
      points: "160 208 80 128 160 48 160 208",
      opacity: "0.2"
    }), /* @__PURE__ */ g("polygon", {
      points: "160 208 80 128 160 48 160 208",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
Gi.set("fill", function() {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M163.1,40.6a8.4,8.4,0,0,0-8.8,1.7l-80,80a8.1,8.1,0,0,0,0,11.4l80,80A8.3,8.3,0,0,0,160,216a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,168,208V48A8,8,0,0,0,163.1,40.6Z"
    })
  });
});
Gi.set("light", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "160 208 80 128 160 48",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    })
  });
});
Gi.set("thin", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "160 208 80 128 160 48",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    })
  });
});
Gi.set("regular", function(t) {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("polyline", {
      points: "160 208 80 128 160 48",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })
  });
});
var d$ = function(e, n) {
  return Dn(e, n, Gi);
}, B3 = /* @__PURE__ */ ze(function(t, e) {
  return /* @__PURE__ */ g(Pn, {
    ...Object.assign({
      ref: e
    }, t, {
      renderPath: d$
    })
  });
});
B3.displayName = "CaretLeft";
const h$ = B3;
var Qi = /* @__PURE__ */ new Map();
Qi.set("bold", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "144 168 184 208 224 168",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    }), /* @__PURE__ */ g("line", {
      x1: "184",
      y1: "112",
      x2: "184",
      y2: "208",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "128",
      x2: "120",
      y2: "128",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "64",
      x2: "184",
      y2: "64",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "192",
      x2: "104",
      y2: "192",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "24"
    })]
  });
});
Qi.set("duotone", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "144 168 184 208 224 168",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("line", {
      x1: "184",
      y1: "112",
      x2: "184",
      y2: "208",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "128",
      x2: "120",
      y2: "128",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "64",
      x2: "184",
      y2: "64",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "192",
      x2: "104",
      y2: "192",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
Qi.set("fill", function() {
  return /* @__PURE__ */ g(K, {
    children: /* @__PURE__ */ g("path", {
      d: "M229.7,173.7l-40,40a8.2,8.2,0,0,1-11.4,0l-40-40a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,144,160h32V112a8,8,0,0,1,16,0v48h32a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,229.7,173.7ZM120,120H48a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM48,72H184a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Zm56,112H48a8,8,0,0,0,0,16h56a8,8,0,0,0,0-16Z"
    })
  });
});
Qi.set("light", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "144 168 184 208 224 168",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    }), /* @__PURE__ */ g("line", {
      x1: "184",
      y1: "112",
      x2: "184",
      y2: "208",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "128",
      x2: "120",
      y2: "128",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "64",
      x2: "184",
      y2: "64",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "192",
      x2: "104",
      y2: "192",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12"
    })]
  });
});
Qi.set("thin", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "144 168 184 208 224 168",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }), /* @__PURE__ */ g("line", {
      x1: "184",
      y1: "112",
      x2: "184",
      y2: "208",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "128",
      x2: "120",
      y2: "128",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "64",
      x2: "184",
      y2: "64",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "192",
      x2: "104",
      y2: "192",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8"
    })]
  });
});
Qi.set("regular", function(t) {
  return /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("polyline", {
      points: "144 168 184 208 224 168",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("line", {
      x1: "184",
      y1: "112",
      x2: "184",
      y2: "208",
      fill: "none",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "128",
      x2: "120",
      y2: "128",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "64",
      x2: "184",
      y2: "64",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    }), /* @__PURE__ */ g("line", {
      x1: "48",
      y1: "192",
      x2: "104",
      y2: "192",
      stroke: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "16"
    })]
  });
});
var g$ = function(e, n) {
  return Dn(e, n, Qi);
}, W3 = /* @__PURE__ */ ze(function(t, e) {
  return /* @__PURE__ */ g(Pn, {
    ...Object.assign({
      ref: e
    }, t, {
      renderPath: g$
    })
  });
});
W3.displayName = "SortAscending";
const p$ = W3;
var m$ = "_1axa3ol1", v$ = "_1axa3ol3", b$ = "_1axa3ol0", y$ = "_1axa3ol1";
function Wt(t) {
  const e = vt(t);
  return ce(() => {
    e.current = t;
  }), Yt(
    () => (...n) => {
      var r;
      return (r = e.current) === null || r === void 0 ? void 0 : r.call(e, ...n);
    },
    []
  );
}
function hn(t, e, n) {
  const [r, i] = he.useState(() => n(t[e])), o = Wt(n);
  return ce(() => kS(t, e, (a) => {
    i(o(a));
  }), [e, t, o]), r;
}
const pd = ze(({
  label: t,
  disabled: e,
  targetType: n,
  ...r
}, i) => /* @__PURE__ */ g("button", {
  className: y$,
  ...r,
  ref: i,
  role: "menuitem",
  disabled: e,
  children: t
}, t)), _$ = ze(({
  label: t,
  disabled: e,
  targetType: n,
  checked: r,
  ...i
}, o) => /* @__PURE__ */ D("button", {
  className: m$,
  ...i,
  ref: o,
  role: "menuitem",
  disabled: e,
  children: [r && /* @__PURE__ */ g(n$, {
    size: 12
  }), /* @__PURE__ */ g("span", {
    className: v$,
    children: t
  })]
}, t));
function w$(t) {
  return Yt(() => ({
    reference: {
      onContextMenu(e) {
        e.preventDefault(), t.onOpenChange(!0);
      }
    }
  }), []);
}
const U3 = he.memo(function(e) {
  const {
    className: n,
    children: r,
    items: i,
    onItemClick: o,
    context: a,
    event: s = "click",
    ...l
  } = e, [f, c] = Dt(null), [u, d] = Dt(!1), h = vt([]), p = vt(zn.map(i, (j) => di(j) ? j.props.label : null)), m = $i(), v = Hc(), b = Li(), {
    events: k,
    store: _
  } = ke(), {
    menuId: E
  } = ie(_), S = Oe((j) => (j == null ? void 0 : j.type) === "menu" && j.nodeId === v && j.parentId === b, [E, v, b]), C = hn(_, "menuId", S), N = {
    type: "menu",
    nodeId: v,
    parentId: b,
    context: a
  }, $ = Oe((j) => {
    (j ? k.onMenuOpen : k.onMenuClose)({
      target: N
    });
  }, [v, b]), {
    x: I,
    y: O,
    reference: y,
    floating: A,
    strategy: z,
    refs: F,
    context: P
  } = jo({
    open: C,
    onOpenChange: $,
    strategy: "fixed",
    middleware: [Lo({
      mainAxis: 4,
      alignmentAxis: 0
    }), Is(), Ff()],
    placement: "bottom-end",
    nodeId: v,
    whileElementsMounted: $o
  }), {
    getReferenceProps: L,
    getFloatingProps: X,
    getItemProps: B
  } = Kf([s === "click" ? N4(P, {
    toggle: !0,
    event: "mousedown",
    ignoreMouse: !1
  }) : w$(P), A4(P, {
    role: "menu"
  }), Vf(P, {
    bubbles: !1
  }), lP(P, {
    listRef: h,
    activeIndex: f,
    nested: !1,
    onNavigate: c
  }), fP(P, {
    listRef: p,
    onMatch: C ? c : void 0,
    activeIndex: f
  })]);
  if (ce(() => {
    function j() {
      k.onMenuClose({
        target: N
      }), F.reference.current && F.reference.current.focus();
    }
    return m == null || m.events.on("click", j), () => {
      m == null || m.events.off("click", j);
    };
  }, [b, m, F]), ce(() => {
    function j() {
      d(!0);
    }
    function w(x) {
      d(!1);
    }
    return window.addEventListener("pointermove", j, {
      once: !0,
      capture: !0
    }), window.addEventListener("keydown", w, !0), () => {
      window.removeEventListener("pointermove", j, {
        capture: !0
      }), window.removeEventListener("keydown", w, !0);
    };
  }, [u]), !zn.only(e.children))
    throw new Error("Menu must have exactly one child as trigger");
  const G = zn.map(e.children, (j) => he.isValidElement(j) ? he.cloneElement(j, {
    ...L({
      ...l,
      ref: y,
      onClick(w) {
        w.preventDefault(), w.stopPropagation(), w.currentTarget.focus();
      }
    })
  }) : j);
  return /* @__PURE__ */ D(W0, {
    id: v,
    children: [G, /* @__PURE__ */ g(ea, {
      id: "collabkit-floating-root",
      children: C && /* @__PURE__ */ g(q0, {
        context: P,
        modal: !0,
        order: ["reference", "content"],
        children: /* @__PURE__ */ g(qt, {
          children: /* @__PURE__ */ g("div", {
            ...X({
              className: n ?? b$,
              ref: A,
              style: {
                position: z,
                top: O ?? 0,
                left: I ?? 0
              },
              onKeyDown(j) {
                j.key === "Tab" && k.onMenuClose({
                  target: N
                });
              }
            }),
            children: zn.map(i, (j, w) => di(j) && Wo(j, B({
              role: "menuitem",
              key: `menu-item-${w}`,
              ref(oe) {
                h.current[w] = oe;
              },
              onClick(oe) {
                oe.preventDefault(), oe.stopPropagation(), o(oe, j.props.targetType), m == null || m.events.emit("click");
              },
              // By default `focusItemOnHover` uses `mousemove` to sync focus,
              // but when a menu closes we want this to sync it on `enter`
              // even if the cursor didn't move. NB: Safari does not sync in
              // this case.
              onPointerEnter() {
                u && c(w);
              }
            })))
          })
        })
      })
    })]
  });
});
var H3 = {}, nu = {}, V3 = he;
let K3 = V3.createContext(null);
nu.LexicalComposerContext = K3;
nu.createLexicalComposerContext = function(t, e) {
  let n = null;
  return t != null && (n = t[1]), { getTheme: function() {
    return e ?? (n != null ? n.getTheme() : null);
  } };
};
nu.useLexicalComposerContext = function() {
  let t = V3.useContext(K3);
  if (t == null)
    throw Error("Minified Lexical error #8; visit https://lexical.dev/docs/error?code=8 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
  return t;
};
const k$ = nu;
var vn = k$, C$ = vn, ts = he, x$ = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? ts.useLayoutEffect : ts.useEffect;
H3.ContentEditable = function({ ariaActiveDescendantID: t, ariaAutoComplete: e, ariaControls: n, ariaDescribedBy: r, ariaExpanded: i, ariaLabel: o, ariaLabelledBy: a, ariaMultiline: s, ariaOwneeID: l, ariaRequired: f, autoCapitalize: c, autoComplete: u, autoCorrect: d, className: h, id: p, role: m = "textbox", spellCheck: v = !0, style: b, tabIndex: k, testid: _ }) {
  let [E] = C$.useLexicalComposerContext(), [S, C] = ts.useState(!1), N = ts.useCallback(($) => {
    E.setRootElement($);
  }, [E]);
  return x$(
    () => (C(E.isEditable()), E.registerEditableListener(($) => {
      C($);
    })),
    [E]
  ), ts.createElement("div", { "aria-activedescendant": S ? t : null, "aria-autocomplete": S ? e : null, "aria-controls": S ? n : null, "aria-describedby": r, "aria-expanded": S && m === "combobox" ? !!i : null, "aria-label": o, "aria-labelledby": a, "aria-multiline": s, "aria-owns": S ? l : null, "aria-required": f, autoCapitalize: c !== void 0 ? String(c) : void 0, autoComplete: u, autoCorrect: d !== void 0 ? String(d) : void 0, className: h, contentEditable: S, "data-testid": _, id: p, ref: N, role: S ? m : void 0, spellCheck: v, style: b, tabIndex: k });
};
const E$ = H3;
var T$ = E$, Y3 = {}, s2 = vn, Oa = Z, qf = he;
let q3 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
var S$ = q3 ? qf.useLayoutEffect : qf.useEffect;
let vl = { tag: "history-merge" };
function I$(t, e) {
  if (e !== null) {
    if (e === void 0)
      t.update(() => {
        var n = Oa.$getRoot();
        if (n.isEmpty()) {
          let r = Oa.$createParagraphNode();
          n.append(r), n = q3 ? document.activeElement : null, (Oa.$getSelection() !== null || n !== null && n === t.getRootElement()) && r.select();
        }
      }, vl);
    else if (e !== null)
      switch (typeof e) {
        case "string":
          let n = t.parseEditorState(e);
          t.setEditorState(n, vl);
          break;
        case "object":
          t.setEditorState(e, vl);
          break;
        case "function":
          t.update(() => {
            Oa.$getRoot().isEmpty() && e(t);
          }, vl);
      }
  }
}
Y3.LexicalComposer = function({ initialConfig: t, children: e }) {
  let n = qf.useMemo(() => {
    const { theme: r, namespace: i, editor__DEPRECATED: o, nodes: a, onError: s, editorState: l } = t, f = s2.createLexicalComposerContext(null, r);
    let c = o || null;
    if (c === null) {
      const u = Oa.createEditor({ editable: !1, namespace: i, nodes: a, onError: (d) => s(d, u), theme: r });
      I$(u, l), c = u;
    }
    return [c, f];
  }, []);
  return S$(() => {
    let r = t.editable, [i] = n;
    i.setEditable(r !== void 0 ? r : !0);
  }, []), qf.createElement(s2.LexicalComposerContext.Provider, { value: n }, e);
};
const N$ = Y3;
var M$ = N$, G3 = {}, A$ = vn, ns = he, O$ = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? ns.useLayoutEffect : ns.useEffect;
function D$(t) {
  let [e] = A$.useLexicalComposerContext(), n = ns.useMemo(() => t(e), [e, t]), r = ns.useRef(n.initialValueFn()), [i, o] = ns.useState(r.current);
  return O$(() => {
    let { initialValueFn: a, subscribe: s } = n, l = a();
    return r.current !== l && (r.current = l, o(l)), s((f) => {
      r.current = f, o(f);
    });
  }, [n, t]), i;
}
function P$(t) {
  return { initialValueFn: () => t.isEditable(), subscribe: (e) => t.registerEditableListener(e) };
}
var R$ = function() {
  return D$(P$);
};
const L$ = R$;
var $$ = L$, Vr = {}, zt = Z;
function cg(t, e = !0) {
  return t ? !1 : (t = Q3(), e && (t = t.trim()), t === "");
}
function Q3() {
  return zt.$getRoot().getTextContent();
}
function X3(t) {
  if (!cg(t, !1))
    return !1;
  t = zt.$getRoot().getChildren();
  let e = t.length;
  if (1 < e)
    return !1;
  for (let r = 0; r < e; r++) {
    var n = t[r];
    if (zt.$isElementNode(n)) {
      if (!zt.$isParagraphNode(n) || n.__indent !== 0)
        return !1;
      n = n.getChildren();
      let i = n.length;
      for (let o = 0; o < i; o++)
        if (!zt.$isTextNode(n[r]))
          return !1;
    }
  }
  return !0;
}
Vr.$canShowPlaceholder = X3;
Vr.$canShowPlaceholderCurry = function(t) {
  return () => X3(t);
};
Vr.$findTextIntersectionFromCharacters = function(t, e) {
  var n = t.getFirstChild();
  t = 0;
  e:
    for (; n !== null; ) {
      if (zt.$isElementNode(n)) {
        var r = n.getFirstChild();
        if (r !== null) {
          n = r;
          continue;
        }
      } else if (zt.$isTextNode(n)) {
        if (r = n.getTextContentSize(), t + r > e)
          return { node: n, offset: e - t };
        t += r;
      }
      if (r = n.getNextSibling(), r !== null)
        n = r;
      else {
        for (n = n.getParent(); n !== null; ) {
          if (r = n.getNextSibling(), r !== null) {
            n = r;
            continue e;
          }
          n = n.getParent();
        }
        break;
      }
    }
  return null;
};
Vr.$isRootTextContentEmpty = cg;
Vr.$isRootTextContentEmptyCurry = function(t, e) {
  return () => cg(t, e);
};
Vr.$rootTextContent = Q3;
Vr.registerLexicalTextEntity = function(t, e, n, r) {
  let i = (a) => {
    const s = zt.$createTextNode(a.getTextContent());
    s.setFormat(a.getFormat()), a.replace(s);
  }, o = t.registerNodeTransform(zt.TextNode, (a) => {
    if (a.isSimpleText()) {
      var s = a.getPreviousSibling(), l = a.getTextContent(), f = a;
      if (zt.$isTextNode(s)) {
        var c = s.getTextContent(), u = e(c + l);
        if (s instanceof n) {
          if (u === null || s.getLatest().__mode !== 0) {
            i(s);
            return;
          }
          if (u = u.end - c.length, 0 < u) {
            f = l.slice(0, u), f = c + f, s.select(), s.setTextContent(f), u === l.length ? a.remove() : (s = l.slice(u), a.setTextContent(s));
            return;
          }
        } else if (u === null || u.start < c.length)
          return;
      }
      for (; ; ) {
        if (a = e(l), l = u = a === null ? "" : l.slice(a.end), u === "") {
          if (c = f.getNextSibling(), zt.$isTextNode(c)) {
            if (u = f.getTextContent() + c.getTextContent(), u = e(u), u === null) {
              c instanceof n ? i(c) : c.markDirty();
              break;
            } else if (u.start !== 0)
              break;
          }
        } else if (c = e(u), c !== null && c.start === 0)
          break;
        if (a === null)
          break;
        if (a.start === 0 && zt.$isTextNode(s) && s.isTextEntity())
          continue;
        let d;
        if (a.start === 0 ? [d, f] = f.splitText(a.end) : [, d, f] = f.splitText(a.start, a.end), a = r(d), d.replace(a), f == null)
          break;
      }
    }
  });
  return t = t.registerNodeTransform(n, (a) => {
    var s = a.getTextContent();
    const l = e(s);
    l === null || l.start !== 0 ? i(a) : s.length > l.end ? a.splitText(l.end) : (s = a.getPreviousSibling(), zt.$isTextNode(s) && s.isTextEntity() && (i(s), i(a)), s = a.getNextSibling(), zt.$isTextNode(s) && s.isTextEntity() && (i(s), a instanceof n && i(a)));
  }), [o, t];
};
const F$ = Vr;
var j$ = F$, J3 = {}, bl = Z;
J3.registerDragonSupport = function(t) {
  let e = window.location.origin, n = (r) => {
    if (r.origin === e) {
      var i = t.getRootElement();
      if (document.activeElement === i && (i = r.data, typeof i == "string")) {
        try {
          var o = JSON.parse(i);
        } catch {
          return;
        }
        if (o && o.protocol === "nuanria_messaging" && o.type === "request" && (o = o.payload) && o.functionId === "makeChanges" && (o = o.args)) {
          const [a, s, l, f, c] = o;
          t.update(() => {
            const u = bl.$getSelection();
            if (bl.$isRangeSelection(u)) {
              var d = u.anchor;
              let h = d.getNode(), p = 0, m = 0;
              bl.$isTextNode(h) && 0 <= a && 0 <= s && (p = a, m = a + s, u.setTextNodeRange(h, p, h, m)), (p !== m || l !== "") && (u.insertRawText(l), h = d.getNode()), bl.$isTextNode(h) && (p = f, m = f + c, d = h.getTextContentSize(), p = p > d ? d : p, m = m > d ? d : m, u.setTextNodeRange(h, p, h, m)), r.stopImmediatePropagation();
            }
          });
        }
      }
    }
  };
  return window.addEventListener("message", n, !0), () => {
    window.removeEventListener("message", n, !0);
  };
};
const z$ = J3;
var B$ = z$, Z3 = {}, ug = A0, yl = Oc, W$ = Jn, q = Z;
let ru = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", U$ = ru && "documentMode" in document ? document.documentMode : null, H$ = ru && "InputEvent" in window && !U$ ? "getTargetRanges" in new window.InputEvent("input") : !1, V$ = ru && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), K$ = ru && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
function ek(t, e) {
  e.update(() => {
    let n = t instanceof KeyboardEvent ? null : t.clipboardData, r = q.$getSelection();
    if (r !== null && n != null) {
      t.preventDefault();
      let i = ug.$getHtmlContent(e);
      i !== null && n.setData("text/html", i), n.setData("text/plain", r.getTextContent());
    }
  });
}
function Y$(t, e) {
  t.preventDefault(), e.update(() => {
    let n = q.$getSelection(), r = t instanceof InputEvent || t instanceof KeyboardEvent ? null : t.clipboardData;
    r != null && q.$isRangeSelection(n) && ug.$insertDataTransferForPlainText(r, n);
  }, { tag: "paste" });
}
function q$(t, e) {
  ek(t, e), e.update(() => {
    let n = q.$getSelection();
    q.$isRangeSelection(n) && n.removeText();
  });
}
Z3.registerPlainText = function(t) {
  return W$.mergeRegister(
    t.registerCommand(q.DELETE_CHARACTER_COMMAND, (e) => {
      const n = q.$getSelection();
      return q.$isRangeSelection(n) ? (n.deleteCharacter(e), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.DELETE_WORD_COMMAND, (e) => {
      const n = q.$getSelection();
      return q.$isRangeSelection(n) ? (n.deleteWord(e), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.DELETE_LINE_COMMAND, (e) => {
      const n = q.$getSelection();
      return q.$isRangeSelection(n) ? (n.deleteLine(e), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.CONTROLLED_TEXT_INSERTION_COMMAND, (e) => {
      const n = q.$getSelection();
      if (!q.$isRangeSelection(n))
        return !1;
      if (typeof e == "string")
        n.insertText(e);
      else {
        const r = e.dataTransfer;
        r != null ? ug.$insertDataTransferForPlainText(r, n) : (e = e.data) && n.insertText(e);
      }
      return !0;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.REMOVE_TEXT_COMMAND, () => {
      const e = q.$getSelection();
      return q.$isRangeSelection(e) ? (e.removeText(), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(
      q.INSERT_LINE_BREAK_COMMAND,
      (e) => {
        const n = q.$getSelection();
        return q.$isRangeSelection(n) ? (n.insertLineBreak(e), !0) : !1;
      },
      q.COMMAND_PRIORITY_EDITOR
    ),
    t.registerCommand(q.INSERT_PARAGRAPH_COMMAND, () => {
      const e = q.$getSelection();
      return q.$isRangeSelection(e) ? (e.insertLineBreak(), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.KEY_ARROW_LEFT_COMMAND, (e) => {
      const n = q.$getSelection();
      if (!q.$isRangeSelection(n))
        return !1;
      const r = e.shiftKey;
      return yl.$shouldOverrideDefaultCharacterSelection(n, !0) ? (e.preventDefault(), yl.$moveCharacter(
        n,
        r,
        !0
      ), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.KEY_ARROW_RIGHT_COMMAND, (e) => {
      const n = q.$getSelection();
      if (!q.$isRangeSelection(n))
        return !1;
      const r = e.shiftKey;
      return yl.$shouldOverrideDefaultCharacterSelection(n, !1) ? (e.preventDefault(), yl.$moveCharacter(n, r, !1), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.KEY_BACKSPACE_COMMAND, (e) => {
      const n = q.$getSelection();
      return q.$isRangeSelection(n) ? (e.preventDefault(), t.dispatchCommand(q.DELETE_CHARACTER_COMMAND, !0)) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.KEY_DELETE_COMMAND, (e) => {
      const n = q.$getSelection();
      return q.$isRangeSelection(n) ? (e.preventDefault(), t.dispatchCommand(q.DELETE_CHARACTER_COMMAND, !1)) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.KEY_ENTER_COMMAND, (e) => {
      const n = q.$getSelection();
      if (!q.$isRangeSelection(n))
        return !1;
      if (e !== null) {
        if ((K$ || V$) && H$)
          return !1;
        e.preventDefault();
      }
      return t.dispatchCommand(q.INSERT_LINE_BREAK_COMMAND, !1);
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.COPY_COMMAND, (e) => {
      const n = q.$getSelection();
      return q.$isRangeSelection(n) ? (ek(e, t), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.CUT_COMMAND, (e) => {
      const n = q.$getSelection();
      return q.$isRangeSelection(n) ? (q$(e, t), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.PASTE_COMMAND, (e) => {
      const n = q.$getSelection();
      return q.$isRangeSelection(n) ? (Y$(e, t), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.DROP_COMMAND, (e) => {
      const n = q.$getSelection();
      return q.$isRangeSelection(n) ? (e.preventDefault(), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(q.DRAGSTART_COMMAND, (e) => {
      const n = q.$getSelection();
      return q.$isRangeSelection(n) ? (e.preventDefault(), !0) : !1;
    }, q.COMMAND_PRIORITY_EDITOR)
  );
};
const G$ = Z3;
var Q$ = G$, tk = vn, X$ = $$, sn = he, J$ = j$, nk = Jn, l2 = $C, Z$ = B$, e7 = Q$, dg = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? sn.useLayoutEffect : sn.useEffect;
function f2(t) {
  return t.getEditorState().read(J$.$canShowPlaceholderCurry(t.isComposing()));
}
function t7(t) {
  let [e, n] = sn.useState(() => f2(t));
  return dg(() => {
    function r() {
      let i = f2(t);
      n(i);
    }
    return r(), nk.mergeRegister(t.registerUpdateListener(() => {
      r();
    }), t.registerEditableListener(() => {
      r();
    }));
  }, [t]), e;
}
function n7(t, e) {
  let [n, r] = sn.useState(() => t.getDecorators());
  return dg(() => t.registerDecoratorListener((i) => {
    l2.flushSync(() => {
      r(i);
    });
  }), [t]), sn.useEffect(() => {
    r(t.getDecorators());
  }, [t]), sn.useMemo(() => {
    let i = [], o = Object.keys(n);
    for (let s = 0; s < o.length; s++) {
      var a = o[s];
      let l = sn.createElement(e, { onError: (f) => t._onError(f) }, sn.createElement(sn.Suspense, { fallback: null }, n[a]));
      a = t.getElementByKey(a), a !== null && i.push(l2.createPortal(l, a));
    }
    return i;
  }, [e, n, t]);
}
function r7(t) {
  dg(() => nk.mergeRegister(e7.registerPlainText(t), Z$.registerDragonSupport(t)), [t]);
}
function i7({ content: t }) {
  var [e] = tk.useLexicalComposerContext();
  e = t7(e);
  let n = X$();
  return e ? typeof t == "function" ? t(n) : t : null;
}
G3.PlainTextPlugin = function({ contentEditable: t, placeholder: e, ErrorBoundary: n }) {
  let [r] = tk.useLexicalComposerContext();
  return n = n7(r, n), r7(r), sn.createElement(sn.Fragment, null, t, sn.createElement(i7, { content: e }), n);
};
const o7 = G3;
var a7 = o7, hg = {}, gg = {}, s7 = Jn, Ke = Z;
function l7(t, e, n, r, i) {
  if (t === null || n.size === 0 && r.size === 0 && !i)
    return 0;
  var o = e._selection, a = t._selection;
  if (i)
    return 1;
  if (!(Ke.$isRangeSelection(o) && Ke.$isRangeSelection(a) && a.isCollapsed() && o.isCollapsed()))
    return 0;
  i = e._nodeMap;
  let s = [];
  for (let l of n)
    n = i.get(l), n !== void 0 && s.push(n);
  for (let [l, f] of r)
    f && (r = i.get(l), r === void 0 || Ke.$isRootNode(r) || s.push(r));
  return s.length === 0 ? 0 : 1 < s.length ? (r = e._nodeMap, e = r.get(o.anchor.key), a = r.get(a.anchor.key), e && a && !t._nodeMap.has(e.__key) && Ke.$isTextNode(e) && e.__text.length === 1 && o.anchor.offset === 1 ? 2 : 0) : (e = s[0], t = t._nodeMap.get(e.__key), !Ke.$isTextNode(t) || !Ke.$isTextNode(e) || t.__mode !== e.__mode || (t = t.__text, e = e.__text, t === e) || (o = o.anchor, a = a.anchor, o.key !== a.key || o.type !== "text") ? 0 : (o = o.offset, a = a.offset, t = e.length - t.length, t === 1 && a === o - 1 ? 2 : t === -1 && a === o + 1 ? 3 : t === -1 && a === o ? 4 : 0));
}
function f7(t, e) {
  let n = Date.now(), r = 0;
  return (i, o, a, s, l, f) => {
    let c = Date.now();
    if (f.has("historic"))
      return r = 0, n = c, 2;
    let u = l7(i, o, s, l, t.isComposing()), d = (() => {
      var h = a === null || a.editor === t, p = f.has("history-push");
      if (!p && h && f.has("history-merge"))
        return 0;
      if (i === null)
        return 1;
      const m = o._selection, v = i._selection;
      return 0 < s.size || 0 < l.size ? p === !1 && u !== 0 && u === r && c < n + e && h || s.size === 1 && (p = Array.from(s)[0], h = i._nodeMap.get(p), p = o._nodeMap.get(p), h = Ke.$isTextNode(h) && Ke.$isTextNode(p) ? h.__type === p.__type && h.__text === p.__text && h.__mode === p.__mode && h.__detail === p.__detail && h.__style === p.__style && h.__format === p.__format && h.__parent === p.__parent : !1, h) ? 0 : 1 : v === null && m !== null ? 0 : 2;
    })();
    return n = c, r = u, d;
  };
}
gg.createEmptyHistoryState = function() {
  return { current: null, redoStack: [], undoStack: [] };
};
gg.registerHistory = function(t, e, n) {
  let r = f7(t, n);
  n = ({ editorState: a, prevEditorState: s, dirtyLeaves: l, dirtyElements: f, tags: c }) => {
    const u = e.current, d = e.redoStack, h = e.undoStack, p = u === null ? null : u.editorState;
    if (u === null || a !== p) {
      if (l = r(s, a, u, l, f, c), l === 1)
        d.length !== 0 && (e.redoStack = []), u !== null && (h.push({ ...u, undoSelection: s.read(Ke.$getSelection) }), t.dispatchCommand(Ke.CAN_UNDO_COMMAND, !0));
      else if (l === 2)
        return;
      e.current = { editor: t, editorState: a };
    }
  };
  let i = s7.mergeRegister(
    t.registerCommand(
      Ke.UNDO_COMMAND,
      () => {
        let a = e.redoStack, s = e.undoStack;
        if (s.length !== 0) {
          let l = e.current, f = s.pop();
          l !== null && (a.push(l), t.dispatchCommand(Ke.CAN_REDO_COMMAND, !0)), s.length === 0 && t.dispatchCommand(Ke.CAN_UNDO_COMMAND, !1), e.current = f || null, f && f.editor.setEditorState(f.editorState.clone(f.undoSelection), { tag: "historic" });
        }
        return !0;
      },
      Ke.COMMAND_PRIORITY_EDITOR
    ),
    t.registerCommand(Ke.REDO_COMMAND, () => {
      let a = e.redoStack;
      var s = e.undoStack;
      if (a.length !== 0) {
        let l = e.current;
        l !== null && (s.push(l), t.dispatchCommand(Ke.CAN_UNDO_COMMAND, !0)), s = a.pop(), a.length === 0 && t.dispatchCommand(Ke.CAN_REDO_COMMAND, !1), e.current = s || null, s && s.editor.setEditorState(s.editorState, { tag: "historic" });
      }
      return !0;
    }, Ke.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(Ke.CLEAR_EDITOR_COMMAND, () => (e.undoStack = [], e.redoStack = [], e.current = null, !1), Ke.COMMAND_PRIORITY_EDITOR),
    t.registerCommand(Ke.CLEAR_HISTORY_COMMAND, () => (e.undoStack = [], e.redoStack = [], e.current = null, t.dispatchCommand(Ke.CAN_REDO_COMMAND, !1), t.dispatchCommand(Ke.CAN_UNDO_COMMAND, !1), !0), Ke.COMMAND_PRIORITY_EDITOR),
    t.registerUpdateListener(n)
  ), o = t.registerUpdateListener(n);
  return () => {
    i(), o();
  };
};
const c7 = gg;
var u7 = c7, d7 = vn, ih = u7, c2 = he;
function h7(t, e, n = 1e3) {
  let r = c2.useMemo(() => e || ih.createEmptyHistoryState(), [e]);
  c2.useEffect(() => ih.registerHistory(t, r, n), [n, t, r]);
}
hg.createEmptyHistoryState = ih.createEmptyHistoryState;
hg.HistoryPlugin = function({ externalHistoryState: t }) {
  let [e] = d7.useLexicalComposerContext();
  return h7(e, t), null;
};
const g7 = hg;
var p7 = g7, rk = {}, m7 = vn, u2 = he, v7 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? u2.useLayoutEffect : u2.useEffect;
rk.OnChangePlugin = function({ ignoreHistoryMergeTagChange: t = !0, ignoreSelectionChange: e = !1, onChange: n }) {
  let [r] = m7.useLexicalComposerContext();
  return v7(() => {
    if (n)
      return r.registerUpdateListener(({ editorState: i, dirtyElements: o, dirtyLeaves: a, prevEditorState: s, tags: l }) => {
        e && o.size === 0 && a.size === 0 || t && l.has("history-merge") || s.isEmpty() || n(i, r);
      });
  }, [r, t, e, n]), null;
};
const b7 = rk;
var y7 = b7, ik = {}, _7 = vn, w7 = he;
ik.AutoFocusPlugin = function({ defaultSelection: t }) {
  let [e] = _7.useLexicalComposerContext();
  return w7.useEffect(() => {
    e.focus(() => {
      let n = document.activeElement, r = e.getRootElement();
      r === null || n !== null && r.contains(n) || r.focus({ preventScroll: !0 });
    }, { defaultSelection: t });
  }, [t, e]), null;
};
const k7 = ik;
var C7 = k7;
const x7 = /(([0-5]{0,1}[0-9]{1}:)?[0-5]{0,1}[0-9]{1}:[0-5]{1}[0-9]{1})\b/i;
function E7() {
  const [t] = vn.useLexicalComposerContext();
  ce(() => {
    if (!t.hasNodes([Ri]))
      throw new Error("TimestampPlugin: TimestampNode not registered on editor");
  }, [t]), ce(() => {
    const n = t.registerNodeTransform(Z.TextNode, (r) => {
      const i = e(r.getTextContent());
      if (i) {
        const o = zc(i.text);
        let a;
        i.start === 0 ? [a, r] = r.splitText(i.end) : [, a, r] = r.splitText(i.start, i.end), a.replace(o);
      }
    });
    return () => {
      n();
    };
  }, [t]);
  const e = Oe((n) => {
    const r = x7.exec(n);
    if (r === null)
      return null;
    const i = r[0].slice(-1) === " ", o = r[0].length - (i ? 1 : 0), a = r.index, s = a + o;
    return {
      text: i ? r[0].slice(0, -1) : r[0],
      end: s,
      start: a
    };
  }, []);
  return null;
}
function T7(t) {
  if (typeof t != "string")
    throw new TypeError("Expected a string");
  return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const d2 = he.startTransition;
function _l(t) {
  if (typeof d2 == "function")
    return d2(t);
  t();
}
var S7 = Tt({ defaultClassName: "_1qtl0z94", variantClassNames: { active: { true: "_1qtl0z95" } }, defaultVariants: {}, compoundVariants: [] }), I7 = "_1qtl0z92", N7 = "_1qtl0z91", M7 = "_1qtl0z96", A7 = "_1qtl0z93", O7 = "_1qtl0z90";
function Ms() {
  return Ms = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Ms.apply(this, arguments);
}
function D7(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function ok(...t) {
  return (e) => t.forEach(
    (n) => D7(n, e)
  );
}
function Xi(...t) {
  return Oe(ok(...t), t);
}
const ak = /* @__PURE__ */ ze((t, e) => {
  const { children: n, ...r } = t, i = zn.toArray(n), o = i.find(R7);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? zn.count(a) > 1 ? zn.only(null) : /* @__PURE__ */ di(a) ? a.props.children : null : l);
    return /* @__PURE__ */ ko(oh, Ms({}, r, {
      ref: e
    }), /* @__PURE__ */ di(a) ? /* @__PURE__ */ Wo(a, void 0, s) : null);
  }
  return /* @__PURE__ */ ko(oh, Ms({}, r, {
    ref: e
  }), n);
});
ak.displayName = "Slot";
const oh = /* @__PURE__ */ ze((t, e) => {
  const { children: n, ...r } = t;
  return /* @__PURE__ */ di(n) ? /* @__PURE__ */ Wo(n, {
    ...L7(r, n.props),
    ref: ok(e, n.ref)
  }) : zn.count(n) > 1 ? zn.only(null) : null;
});
oh.displayName = "SlotClone";
const P7 = ({ children: t }) => /* @__PURE__ */ ko(X2, null, t);
function R7(t) {
  return /* @__PURE__ */ di(t) && t.type === P7;
}
function L7(t, e) {
  const n = {
    ...e
  };
  for (const r in e) {
    const i = t[r], o = e[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = {
      ...i,
      ...o
    } : r === "className" && (n[r] = [
      i,
      o
    ].filter(Boolean).join(" "));
  }
  return {
    ...t,
    ...n
  };
}
const $7 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], tl = $7.reduce((t, e) => {
  const n = /* @__PURE__ */ ze((r, i) => {
    const { asChild: o, ...a } = r, s = o ? ak : e;
    return ce(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ ko(s, Ms({}, a, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${e}`, {
    ...t,
    [e]: n
  };
}, {}), ah = Boolean(globalThis == null ? void 0 : globalThis.document) ? Ds : () => {
};
function F7(t, e) {
  return PC((n, r) => {
    const i = e[n][r];
    return i ?? n;
  }, t);
}
const nl = (t) => {
  const { present: e, children: n } = t, r = j7(e), i = typeof n == "function" ? n({
    present: r.isPresent
  }) : zn.only(n), o = Xi(r.ref, i.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Wo(i, {
    ref: o
  }) : null;
};
nl.displayName = "Presence";
function j7(t) {
  const [e, n] = Dt(), r = vt({}), i = vt(t), o = vt("none"), a = t ? "mounted" : "unmounted", [s, l] = F7(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ce(() => {
    const f = wl(r.current);
    o.current = s === "mounted" ? f : "none";
  }, [
    s
  ]), ah(() => {
    const f = r.current, c = i.current;
    if (c !== t) {
      const d = o.current, h = wl(f);
      t ? l("MOUNT") : h === "none" || (f == null ? void 0 : f.display) === "none" ? l("UNMOUNT") : l(c && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [
    t,
    l
  ]), ah(() => {
    if (e) {
      const f = (u) => {
        const h = wl(r.current).includes(u.animationName);
        u.target === e && h && J2(
          () => l("ANIMATION_END")
        );
      }, c = (u) => {
        u.target === e && (o.current = wl(r.current));
      };
      return e.addEventListener("animationstart", c), e.addEventListener("animationcancel", f), e.addEventListener("animationend", f), () => {
        e.removeEventListener("animationstart", c), e.removeEventListener("animationcancel", f), e.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [
    e,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Oe((f) => {
      f && (r.current = getComputedStyle(f)), n(f);
    }, [])
  };
}
function wl(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function z7(t, e = []) {
  let n = [];
  function r(o, a) {
    const s = /* @__PURE__ */ ui(a), l = n.length;
    n = [
      ...n,
      a
    ];
    function f(u) {
      const { scope: d, children: h, ...p } = u, m = (d == null ? void 0 : d[t][l]) || s, v = Yt(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ ko(m.Provider, {
        value: v
      }, h);
    }
    function c(u, d) {
      const h = (d == null ? void 0 : d[t][l]) || s, p = Ii(h);
      if (p)
        return p;
      if (a !== void 0)
        return a;
      throw new Error(`\`${u}\` must be used within \`${o}\``);
    }
    return f.displayName = o + "Provider", [
      f,
      c
    ];
  }
  const i = () => {
    const o = n.map((a) => /* @__PURE__ */ ui(a));
    return function(s) {
      const l = (s == null ? void 0 : s[t]) || o;
      return Yt(
        () => ({
          [`__scope${t}`]: {
            ...s,
            [t]: l
          }
        }),
        [
          s,
          l
        ]
      );
    };
  };
  return i.scopeName = t, [
    r,
    B7(i, ...e)
  ];
}
function B7(...t) {
  const e = t[0];
  if (t.length === 1)
    return e;
  const n = () => {
    const r = t.map(
      (i) => ({
        useScope: i(),
        scopeName: i.scopeName
      })
    );
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: f }) => {
        const u = l(o)[`__scope${f}`];
        return {
          ...s,
          ...u
        };
      }, {});
      return Yt(
        () => ({
          [`__scope${e.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = e.scopeName, n;
}
const W7 = /* @__PURE__ */ ui(void 0);
function U7(t) {
  const e = Ii(W7);
  return t || e || "ltr";
}
function H7(t, [e, n]) {
  return Math.min(n, Math.max(e, t));
}
function ci(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (t == null || t(i), n === !1 || !i.defaultPrevented)
      return e == null ? void 0 : e(i);
  };
}
function V7(t, e) {
  return T.useReducer((n, r) => e[n][r] ?? n, t);
}
const pg = "ScrollArea", [sk, tU] = z7(pg), [K7, bn] = sk(pg), lk = T.forwardRef((t, e) => {
  const {
    __scopeScrollArea: n,
    type: r = "hover",
    dir: i,
    autoScroll: o = "none",
    autoScrollThreshold: a = 16,
    scrollHideDelay: s = 600,
    alignToBottom: l = !1,
    ...f
  } = t, [c, u] = T.useState(null), [d, h] = T.useState(null), [p, m] = T.useState(null), [v, b] = T.useState(null), [k, _] = T.useState(null), [E, S] = T.useState(0), [C, N] = T.useState(0), [$, I] = T.useState(!1), [O, y] = T.useState(!1), A = Xi(e, (F) => u(F)), z = U7(i);
  return /* @__PURE__ */ g(K7, {
    scope: n,
    type: r,
    dir: z,
    autoScroll: o,
    autoScrollThreshold: a,
    scrollHideDelay: s,
    scrollArea: c,
    viewport: d,
    onViewportChange: h,
    content: p,
    onContentChange: m,
    scrollbarX: v,
    onScrollbarXChange: b,
    scrollbarXEnabled: $,
    onScrollbarXEnabledChange: I,
    scrollbarY: k,
    onScrollbarYChange: _,
    scrollbarYEnabled: O,
    onScrollbarYEnabledChange: y,
    onCornerWidthChange: S,
    onCornerHeightChange: N,
    alignToBottom: l,
    children: /* @__PURE__ */ g(tl.div, {
      dir: z,
      ...f,
      ref: A,
      style: {
        position: "relative",
        // Pass corner sizes as CSS vars to reduce re-renders of context consumers
        ["--radix-scroll-area-corner-width"]: E + "px",
        ["--radix-scroll-area-corner-height"]: C + "px",
        ...t.style
      }
    })
  });
});
lk.displayName = pg;
const fk = "ScrollAreaViewport", ck = T.forwardRef((t, e) => {
  const {
    __scopeScrollArea: n,
    children: r,
    ...i
  } = t, o = bn(fk, n), a = T.useRef(null), s = Xi(e, a, o.onViewportChange), l = T.useRef(!0);
  T.useEffect(() => {
    const d = o.viewport;
    if (d) {
      const h = () => {
        d.scrollHeight - d.scrollTop - d.offsetHeight > o.autoScrollThreshold ? l.current = !1 : l.current = !0;
      };
      return d.addEventListener("scroll", h), () => d.removeEventListener("scroll", h);
    }
  }, [o.viewport]);
  const f = T.useRef(0), c = rl(() => {
    if (o.autoScroll === "bottom" && o.viewport) {
      const d = o.viewport.scrollHeight;
      d !== f.current && l.current && (o.viewport.scrollTop = d), f.current = d;
    }
  }, 10), u = Oe(() => {
    if (o.autoScroll === "bottom" && o.viewport) {
      const d = o.viewport.scrollHeight;
      d !== f.current && l.current && (o.viewport.scrollTop = d), f.current = d;
    }
  }, [o]);
  return T.useEffect(() => u, [u]), Br(o.viewport, c), Br(o.content, u), /* @__PURE__ */ D(K, {
    children: [/* @__PURE__ */ g("style", {
      dangerouslySetInnerHTML: {
        __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
      }
    }), /* @__PURE__ */ g(tl.div, {
      "data-radix-scroll-area-viewport": "",
      ...i,
      ref: s,
      style: {
        /**
         * We don't support `visible` because the intention is to have at least one scrollbar
         * if this component is used and `visible` will behave like `auto` in that case
         * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
         *
         * We don't handle `auto` because the intention is for the native implementation
         * to be hidden if using this component. We just want to ensure the node is scrollable
         * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
         * the browser from having to work out whether to render native scrollbars or not,
         * we tell it to with the intention of hiding them in CSS.
         */
        overflowX: o.scrollbarXEnabled ? "scroll" : "hidden",
        overflowY: o.scrollbarYEnabled ? "scroll" : "hidden",
        ...t.style
      },
      children: /* @__PURE__ */ g("div", {
        ref: o.onContentChange,
        style: {
          minWidth: "100%",
          display: "table",
          marginTop: o.alignToBottom ? "auto" : "unset"
        },
        children: r
      })
    })]
  });
});
ck.displayName = fk;
const nr = "ScrollAreaScrollbar", uk = T.forwardRef((t, e) => {
  const {
    forceMount: n,
    ...r
  } = t, i = bn(nr, t.__scopeScrollArea), {
    onScrollbarXEnabledChange: o,
    onScrollbarYEnabledChange: a
  } = i, s = t.orientation === "horizontal";
  return T.useEffect(() => (s ? o(!0) : a(!0), () => {
    s ? o(!1) : a(!1);
  }), [s, o, a]), i.type === "hover" ? /* @__PURE__ */ g(Y7, {
    ...r,
    ref: e,
    forceMount: n
  }) : i.type === "scroll" ? /* @__PURE__ */ g(q7, {
    ...r,
    ref: e,
    forceMount: n
  }) : i.type === "auto" ? /* @__PURE__ */ g(dk, {
    ...r,
    ref: e,
    forceMount: n
  }) : i.type === "always" ? /* @__PURE__ */ g(mg, {
    ...r,
    ref: e
  }) : null;
});
uk.displayName = nr;
const Y7 = T.forwardRef((t, e) => {
  const {
    forceMount: n,
    ...r
  } = t, i = bn(nr, t.__scopeScrollArea), [o, a] = T.useState(!1);
  return T.useEffect(() => {
    const s = i.scrollArea;
    let l = 0;
    if (s) {
      const f = () => {
        window.clearTimeout(l), a(!0);
      }, c = () => {
        l = window.setTimeout(() => a(!1), i.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", f), s.addEventListener("pointerleave", c), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", f), s.removeEventListener("pointerleave", c);
      };
    }
  }, [i.scrollArea, i.scrollHideDelay]), /* @__PURE__ */ g(nl, {
    present: n || o,
    children: /* @__PURE__ */ g(dk, {
      "data-state": o ? "visible" : "hidden",
      ...r,
      ref: e
    })
  });
}), q7 = T.forwardRef((t, e) => {
  const {
    forceMount: n,
    ...r
  } = t, i = bn(nr, t.__scopeScrollArea), o = t.orientation === "horizontal", a = rl(() => l("SCROLL_END"), 100), [s, l] = V7("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return T.useEffect(() => {
    if (s === "idle") {
      const f = window.setTimeout(() => l("HIDE"), i.scrollHideDelay);
      return () => window.clearTimeout(f);
    }
  }, [s, i.scrollHideDelay, l]), T.useEffect(() => {
    const f = i.viewport, c = o ? "scrollLeft" : "scrollTop";
    if (f) {
      let u = f[c];
      const d = () => {
        const h = f[c];
        u !== h && (l("SCROLL"), a()), u = h;
      };
      return f.addEventListener("scroll", d), () => f.removeEventListener("scroll", d);
    }
  }, [i.viewport, o, l, a]), /* @__PURE__ */ g(nl, {
    present: n || s !== "hidden",
    children: /* @__PURE__ */ g(mg, {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...r,
      ref: e,
      onPointerEnter: ci(t.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: ci(t.onPointerLeave, () => l("POINTER_LEAVE"))
    })
  });
}), dk = T.forwardRef((t, e) => {
  const n = bn(nr, t.__scopeScrollArea), {
    forceMount: r,
    ...i
  } = t, [o, a] = T.useState(!1), s = t.orientation === "horizontal", l = rl(() => {
    if (n.viewport) {
      const f = n.viewport.offsetWidth < n.viewport.scrollWidth, c = n.viewport.offsetHeight < n.viewport.scrollHeight;
      a(s ? f : c);
    }
  }, 10);
  return Br(n.viewport, l), Br(n.content, l), /* @__PURE__ */ g(nl, {
    present: r || o,
    children: /* @__PURE__ */ g(mg, {
      "data-state": o ? "visible" : "hidden",
      ...i,
      ref: e
    })
  });
}), mg = T.forwardRef((t, e) => {
  const {
    orientation: n = "vertical",
    ...r
  } = t, i = bn(nr, t.__scopeScrollArea), o = T.useRef(null), a = T.useRef(0), [s, l] = T.useState({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  }), f = vk(s.viewport, s.content), c = {
    ...r,
    sizes: s,
    onSizesChange: l,
    hasThumb: Boolean(f > 0 && f < 1),
    onThumbChange: (d) => o.current = d,
    onThumbPointerUp: () => a.current = 0,
    onThumbPointerDown: (d) => a.current = d
  };
  function u(d, h) {
    return eF(d, a.current, s, h);
  }
  return n === "horizontal" ? /* @__PURE__ */ g(G7, {
    ...c,
    ref: e,
    onThumbPositionChange: () => {
      if (i.viewport && o.current) {
        const d = i.viewport.scrollLeft, h = h2(d, s, i.dir);
        o.current.style.transform = `translate3d(${h}px, 0, 0)`;
      }
    },
    onWheelScroll: (d) => {
      i.viewport && (i.viewport.scrollLeft = d);
    },
    onDragScroll: (d) => {
      i.viewport && (i.viewport.scrollLeft = u(d, i.dir));
    }
  }) : n === "vertical" ? /* @__PURE__ */ g(Q7, {
    ...c,
    ref: e,
    onThumbPositionChange: () => {
      if (i.viewport && o.current) {
        const d = i.viewport.scrollTop, h = h2(d, s);
        o.current.style.transform = `translate3d(0, ${h}px, 0)`;
      }
    },
    onWheelScroll: (d) => {
      i.viewport && (i.viewport.scrollTop = d);
    },
    onDragScroll: (d) => {
      i.viewport && (i.viewport.scrollTop = u(d));
    }
  }) : null;
}), G7 = T.forwardRef((t, e) => {
  const {
    sizes: n,
    onSizesChange: r,
    ...i
  } = t, o = bn(nr, t.__scopeScrollArea), [a, s] = T.useState(), l = T.useRef(null), f = Xi(e, l, o.onScrollbarXChange);
  return T.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ g(gk, {
    "data-orientation": "horizontal",
    ...i,
    ref: f,
    sizes: n,
    style: {
      bottom: 0,
      left: o.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
      right: o.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
      ["--radix-scroll-area-thumb-width"]: iu(n) + "px",
      ...t.style
    },
    onThumbPointerDown: (c) => t.onThumbPointerDown(c.x),
    onDragScroll: (c) => t.onDragScroll(c.x),
    onWheelScroll: (c, u) => {
      if (o.viewport) {
        const d = o.viewport.scrollLeft + c.deltaX;
        t.onWheelScroll(d), yk(d, u) && c.preventDefault();
      }
    },
    onResize: () => {
      l.current && o.viewport && a && r({
        content: o.viewport.scrollWidth,
        viewport: o.viewport.offsetWidth,
        scrollbar: {
          size: l.current.clientWidth,
          paddingStart: Qf(a.paddingLeft),
          paddingEnd: Qf(a.paddingRight)
        }
      });
    }
  });
}), Q7 = T.forwardRef((t, e) => {
  const {
    sizes: n,
    onSizesChange: r,
    ...i
  } = t, o = bn(nr, t.__scopeScrollArea), [a, s] = T.useState(), l = T.useRef(null), f = Xi(e, l, o.onScrollbarYChange);
  return T.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ g(gk, {
    "data-orientation": "vertical",
    ...i,
    ref: f,
    sizes: n,
    style: {
      top: 0,
      right: o.dir === "ltr" ? 0 : void 0,
      left: o.dir === "rtl" ? 0 : void 0,
      bottom: "var(--radix-scroll-area-corner-height)",
      ["--radix-scroll-area-thumb-height"]: iu(n) + "px",
      ...t.style
    },
    onThumbPointerDown: (c) => t.onThumbPointerDown(c.y),
    onDragScroll: (c) => t.onDragScroll(c.y),
    onWheelScroll: (c, u) => {
      if (o.viewport) {
        const d = o.viewport.scrollTop + c.deltaY;
        t.onWheelScroll(d), yk(d, u) && c.preventDefault();
      }
    },
    onResize: () => {
      l.current && o.viewport && a && r({
        content: o.viewport.scrollHeight,
        viewport: o.viewport.offsetHeight,
        scrollbar: {
          size: l.current.clientHeight,
          paddingStart: Qf(a.paddingTop),
          paddingEnd: Qf(a.paddingBottom)
        }
      });
    }
  });
}), [X7, hk] = sk(nr), gk = T.forwardRef((t, e) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: i,
    onThumbChange: o,
    onThumbPointerUp: a,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: f,
    onWheelScroll: c,
    onResize: u,
    ...d
  } = t, h = bn(nr, n), [p, m] = T.useState(null), v = Xi(e, (I) => m(I)), b = T.useRef(null), k = T.useRef(""), _ = h.viewport, E = r.content - r.viewport, S = Wt(c), C = Wt(l), N = rl(u, 10);
  function $(I) {
    if (b.current) {
      const O = I.clientX - b.current.left, y = I.clientY - b.current.top;
      f({
        x: O,
        y
      });
    }
  }
  return T.useEffect(() => {
    const I = (O) => {
      const y = O.target;
      (p == null ? void 0 : p.contains(y)) && S(O, E);
    };
    return document.addEventListener("wheel", I, {
      passive: !1
    }), () => document.removeEventListener("wheel", I, {
      passive: !1
    });
  }, [_, p, E, S]), T.useEffect(C, [r, C]), Br(p, N), Br(h.content, N), /* @__PURE__ */ g(X7, {
    scope: n,
    scrollbar: p,
    hasThumb: i,
    onThumbChange: Wt(o),
    onThumbPointerUp: Wt(a),
    onThumbPositionChange: C,
    onThumbPointerDown: Wt(s),
    children: /* @__PURE__ */ g(tl.div, {
      ...d,
      ref: v,
      style: {
        position: "absolute",
        ...d.style
      },
      onPointerDown: ci(t.onPointerDown, (I) => {
        I.button === 0 && (I.target.setPointerCapture(I.pointerId), b.current = p.getBoundingClientRect(), k.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", $(I));
      }),
      onPointerMove: ci(t.onPointerMove, $),
      onPointerUp: ci(t.onPointerUp, (I) => {
        const O = I.target;
        O.hasPointerCapture(I.pointerId) && O.releasePointerCapture(I.pointerId), document.body.style.webkitUserSelect = k.current, b.current = null;
      })
    })
  });
}), Gf = "ScrollAreaThumb", pk = T.forwardRef((t, e) => {
  const {
    forceMount: n,
    ...r
  } = t, i = hk(Gf, t.__scopeScrollArea);
  return /* @__PURE__ */ g(nl, {
    present: n || i.hasThumb,
    children: /* @__PURE__ */ g(J7, {
      ref: e,
      ...r
    })
  });
}), J7 = T.forwardRef((t, e) => {
  const {
    __scopeScrollArea: n,
    style: r,
    ...i
  } = t, o = bn(Gf, n), a = hk(Gf, n), {
    onThumbPositionChange: s
  } = a, l = Xi(e, (u) => a.onThumbChange(u)), f = T.useRef(), c = rl(() => {
    f.current && (f.current(), f.current = void 0);
  }, 100);
  return T.useEffect(() => {
    const u = o.viewport;
    if (u) {
      const d = () => {
        if (c(), !f.current) {
          const h = tF(u, s);
          f.current = h, s();
        }
      };
      return s(), u.addEventListener("scroll", d), () => u.removeEventListener("scroll", d);
    }
  }, [o.viewport, c, s]), /* @__PURE__ */ g(tl.div, {
    "data-state": a.hasThumb ? "visible" : "hidden",
    ...i,
    ref: l,
    style: {
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)",
      ...r
    },
    onPointerDownCapture: ci(t.onPointerDownCapture, (u) => {
      const h = u.target.getBoundingClientRect(), p = u.clientX - h.left, m = u.clientY - h.top;
      a.onThumbPointerDown({
        x: p,
        y: m
      });
    }),
    onPointerUp: ci(t.onPointerUp, a.onThumbPointerUp)
  });
});
pk.displayName = Gf;
const vg = "ScrollAreaCorner", mk = T.forwardRef((t, e) => {
  const n = bn(vg, t.__scopeScrollArea), r = Boolean(n.scrollbarX && n.scrollbarY);
  return n.type !== "scroll" && r ? /* @__PURE__ */ g(Z7, {
    ...t,
    ref: e
  }) : null;
});
mk.displayName = vg;
const Z7 = T.forwardRef((t, e) => {
  const {
    __scopeScrollArea: n,
    ...r
  } = t, i = bn(vg, n), [o, a] = T.useState(0), [s, l] = T.useState(0), f = Boolean(o && s);
  return Br(i.scrollbarX, () => {
    var u;
    const c = ((u = i.scrollbarX) == null ? void 0 : u.offsetHeight) || 0;
    i.onCornerHeightChange(c), l(c);
  }), Br(i.scrollbarY, () => {
    var u;
    const c = ((u = i.scrollbarY) == null ? void 0 : u.offsetWidth) || 0;
    i.onCornerWidthChange(c), a(c);
  }), f ? /* @__PURE__ */ g(tl.div, {
    ...r,
    ref: e,
    style: {
      width: o,
      height: s,
      position: "absolute",
      right: i.dir === "ltr" ? 0 : void 0,
      left: i.dir === "rtl" ? 0 : void 0,
      bottom: 0,
      ...t.style
    }
  }) : null;
});
function Qf(t) {
  return t ? parseInt(t, 10) : 0;
}
function vk(t, e) {
  const n = t / e;
  return isNaN(n) ? 0 : n;
}
function iu(t) {
  const e = vk(t.viewport, t.content), n = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, r = (t.scrollbar.size - n) * e;
  return Math.max(r, 18);
}
function eF(t, e, n, r = "ltr") {
  const i = iu(n), o = i / 2, a = e || o, s = i - a, l = n.scrollbar.paddingStart + a, f = n.scrollbar.size - n.scrollbar.paddingEnd - s, c = n.content - n.viewport, u = r === "ltr" ? [0, c] : [c * -1, 0];
  return bk([l, f], u)(t);
}
function h2(t, e, n = "ltr") {
  const r = iu(e), i = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = e.scrollbar.size - i, a = e.content - e.viewport, s = o - r, l = n === "ltr" ? [0, a] : [a * -1, 0], f = H7(t, l);
  return bk([0, a], [0, s])(f);
}
function bk(t, e) {
  return (n) => {
    if (t[0] === t[1] || e[0] === e[1])
      return e[0];
    const r = (e[1] - e[0]) / (t[1] - t[0]);
    return e[0] + r * (n - t[0]);
  };
}
function yk(t, e) {
  return t > 0 && t < e;
}
const tF = (t, e = () => {
}) => {
  let n = {
    left: t.scrollLeft,
    top: t.scrollTop
  }, r = 0;
  return function i() {
    const o = {
      left: t.scrollLeft,
      top: t.scrollTop
    }, a = n.left !== o.left, s = n.top !== o.top;
    (a || s) && e(), n = o, r = window.requestAnimationFrame(i);
  }(), () => window.cancelAnimationFrame(r);
};
function rl(t, e) {
  const n = Wt(t), r = T.useRef(0);
  return T.useEffect(() => () => window.clearTimeout(r.current), []), T.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, e);
  }, [n, e]);
}
function Br(t, e) {
  const n = Wt(e);
  ah(() => {
    let r = 0;
    if (t) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return i.observe(t), () => {
        window.cancelAnimationFrame(r), i.unobserve(t);
      };
    }
  }, [t, n]);
}
const nF = lk, rF = ck, iF = uk, oF = pk, aF = mk;
var sF = "ly3hvb4", lF = "ly3hvb0", fF = "ly3hvb2", cF = "ly3hvb3", uF = "ly3hvb1";
const dF = ze((t, e) => /* @__PURE__ */ g(nF, {
  ...t,
  ref: e,
  className: t.className ?? lF
})), hF = ze((t, e) => /* @__PURE__ */ g(rF, {
  ...t,
  ref: e,
  className: t.className ?? uF
})), gF = ze((t, e) => /* @__PURE__ */ g(iF, {
  ...t,
  ref: e,
  className: t.className ?? fF
})), pF = ze((t, e) => /* @__PURE__ */ g(oF, {
  ...t,
  ref: e,
  className: t.className ?? cF
})), mF = ze((t, e) => /* @__PURE__ */ g(aF, {
  ...t,
  ref: e,
  className: t.className ?? sF
}));
function Ji(t) {
  const {
    maxHeight: e,
    minHeight: n
  } = t;
  return /* @__PURE__ */ D(dF, {
    autoScroll: t.autoScroll,
    alignToBottom: t.alignToBottom,
    children: [/* @__PURE__ */ g(hF, {
      className: t.className,
      onScroll: t.onScroll,
      style: {
        maxHeight: e ?? "inherit",
        minHeight: n ?? "unset"
      },
      children: t.children
    }), /* @__PURE__ */ g(gF, {
      orientation: "vertical",
      children: /* @__PURE__ */ g(pF, {})
    }), /* @__PURE__ */ g(mF, {})]
  });
}
const _k = `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;`, vF = "\\b[A-Z][^\\s" + _k + "]", wk = {
  NAME: vF,
  PUNCTUATION: _k
}, bF = new RegExp("(^|[^#])((?:" + wk.NAME + "{" + 1 + ",})$)"), kk = wk.PUNCTUATION, bg = ["@", "\\uff20"].join(""), Ck = "[^" + bg + kk + "\\s]", yF = "(?:\\.[ |$]| |[" + kk + "]|)", _F = 75, wF = new RegExp("(^|\\s|\\()([" + bg + "]((?:" + Ck + yF + "){0," + _F + "}))$"), kF = 50, CF = new RegExp("(^|\\s|\\()([" + bg + "]((?:" + Ck + "){0," + kF + "}))$"), g2 = 25, md = /* @__PURE__ */ new Map(), xF = ({
  text: t = "",
  highlight: e = ""
}) => {
  if (!e.trim())
    return /* @__PURE__ */ g("span", {
      children: t
    });
  const n = new RegExp(`(${T7(e)})`, "gi"), r = t.split(n);
  return /* @__PURE__ */ g("span", {
    children: r.filter((i) => i).map((i, o) => n.test(i) ? /* @__PURE__ */ g("mark", {
      className: N7,
      children: i
    }, o) : /* @__PURE__ */ g("span", {
      children: i
    }, o))
  });
};
function EF(t, e, n) {
  const {
    mentionableUsers: r
  } = Eo(t), i = (Object.values(r ?? {}) ?? []).filter((o) => o.email && (o.name && o.name.toLowerCase().includes(e.toLowerCase()) || o.email.toLowerCase().includes(e.toLowerCase())));
  i == null || (i == null ? void 0 : i.length) === 0 ? n(null) : n(i);
}
function TF(t) {
  const e = _e();
  if (!e)
    return null;
  const [n, r] = Dt(null);
  return ce(() => {
    const i = md.get(t);
    if (i !== null) {
      if (i !== void 0) {
        r(i);
        return;
      }
      md.set(t, null), EF(e, t, (o) => {
        md.set(t, o), r(o);
      });
    }
  }, [t]), n;
}
function SF({
  index: t,
  active: e,
  onClick: n,
  onMouseEnter: r,
  result: i,
  query: o
}) {
  return /* @__PURE__ */ D("div", {
    "data-testid": "collabkit-mentions-typeahead-item",
    className: S7({
      active: e
    }),
    tabIndex: -1,
    role: "option",
    "aria-selected": e,
    id: "typeahead-item-" + t,
    onMouseEnter: r,
    onClick: n,
    children: [/* @__PURE__ */ g(ta.Provider, {
      value: i.id,
      children: /* @__PURE__ */ g(On, {})
    }), /* @__PURE__ */ g("div", {
      className: A7,
      children: /* @__PURE__ */ g("div", {
        className: M7,
        "data-testid": "collabkit-mentions-typeahead-item-name",
        children: /* @__PURE__ */ g(xF, {
          text: i.name || i.email || "",
          highlight: o
        })
      })
    })]
  }, i.id);
}
function IF({
  close: t,
  editor: e,
  resolution: n,
  onResultsChange: r
}) {
  const i = n.match, o = TF(i.matchingString), [a, s] = Dt(null), [l, f] = Dt(0), [c, u] = Dt({
    width: 0,
    height: 0
  }), d = Hc(), {
    reference: h,
    context: p
  } = jo({
    nodeId: d,
    placement: "bottom-start",
    open: ((o == null ? void 0 : o.length) ?? 0) > 0,
    whileElementsMounted: $o,
    middleware: [Lo(-8), Is(), U1({
      padding: 0,
      apply({
        availableWidth: _,
        availableHeight: E,
        elements: S
      }) {
        Object.assign(S.floating.style, {
          maxWidth: `${_}px`,
          maxHeight: `${E}px`
        }), u({
          width: _,
          height: E
        });
      }
    })]
  });
  ce(() => {
    const _ = e.getRootElement();
    _ !== null && (h(_), f(_.getBoundingClientRect().width));
  }, [e]);
  const m = _e(), v = Ii(Js), b = Oe(() => {
    if (o === null || a === null)
      return;
    const _ = o[a];
    t(), DF(e, _, i), (v == null ? void 0 : v.type) === "composer" && u0(m, {
      target: v
    });
  }, [t, i, e, o, a]), k = Oe((_) => {
    const E = e.getRootElement();
    E !== null && (E.setAttribute("aria-activedescendant", "typeahead-item-" + _), s(_));
  }, [e]);
  return ce(() => () => {
    const _ = e.getRootElement();
    _ !== null && _.removeAttribute("aria-activedescendant");
  }, [e]), Ds(() => {
    o === null ? s(null) : a === null && k(0);
  }, [o, a, k]), ce(() => Jn.mergeRegister(e.registerCommand(Z.KEY_ARROW_DOWN_COMMAND, (_) => {
    const E = _;
    return o !== null && a !== null && (a < g2 - 1 && a !== o.length - 1 && k(a + 1), E.preventDefault(), E.stopImmediatePropagation()), !0;
  }, Z.COMMAND_PRIORITY_LOW), e.registerCommand(Z.KEY_ARROW_UP_COMMAND, (_) => {
    const E = _;
    return o !== null && a !== null && (a !== 0 && k(a - 1), E.preventDefault(), E.stopImmediatePropagation()), !0;
  }, Z.COMMAND_PRIORITY_LOW), e.registerCommand(Z.KEY_ESCAPE_COMMAND, (_) => {
    const E = _;
    return o === null || a === null ? !1 : (E.preventDefault(), E.stopImmediatePropagation(), t(), !0);
  }, Z.COMMAND_PRIORITY_LOW), e.registerCommand(Z.KEY_TAB_COMMAND, (_) => {
    const E = _;
    return o === null || a === null ? !1 : (E.preventDefault(), E.stopImmediatePropagation(), b(), !0);
  }, Z.COMMAND_PRIORITY_LOW), e.registerCommand(S6, () => (t(), !0), Z.COMMAND_PRIORITY_LOW), e.registerCommand(Z.KEY_ENTER_COMMAND, (_) => o === null || a === null ? !1 : (_ !== null && (_.preventDefault(), _.stopImmediatePropagation()), b(), !0), Z.COMMAND_PRIORITY_HIGH)), [b, t, e, o, a, k]), ce(() => {
    r == null || r(o);
  }, [r, o]), o === null ? null : /* @__PURE__ */ g(ea, {
    id: "collabkit-floating-root",
    children: /* @__PURE__ */ g(q0, {
      context: p,
      children: /* @__PURE__ */ g(qt, {
        children: /* @__PURE__ */ g("div", {
          className: O7,
          "aria-label": "Suggested mentions",
          role: "listbox",
          ref: p.floating,
          style: {
            position: p.strategy,
            top: p.y ?? 0,
            left: p.x ?? 0,
            width: l,
            maxHeight: c.height > 0 ? c.height : "unset"
          },
          children: /* @__PURE__ */ g(Ji, {
            maxHeight: c.height > 0 ? c.height : "unset",
            children: /* @__PURE__ */ g("div", {
              className: I7,
              children: o.slice(0, g2).map((_, E) => /* @__PURE__ */ g(SF, {
                index: E,
                active: E === a,
                onClick: () => {
                  s(E), b();
                },
                onMouseEnter: () => {
                  s(E);
                },
                result: _,
                query: i.matchingString
              }, _.id))
            })
          })
        })
      })
    })
  });
}
function NF(t, e) {
  const n = bF.exec(t);
  if (n !== null) {
    const r = n[1], i = n[2];
    if (i != null && i.length >= e)
      return {
        leadOffset: n.index + r.length,
        matchingString: i,
        replaceableString: i
      };
  }
  return null;
}
function MF(t, e) {
  let n = wF.exec(t);
  if (n === null && (n = CF.exec(t)), n !== null) {
    const r = n[1], i = n[3];
    if (i.length >= e)
      return {
        leadOffset: n.index + r.length,
        matchingString: i,
        replaceableString: n[2]
      };
  }
  return null;
}
function p2(t) {
  const e = MF(t, 0);
  return e === null ? NF(t, 3) : e;
}
function AF(t) {
  const e = t.anchor;
  if (e.type !== "text")
    return null;
  const n = e.getNode();
  if (!n.isSimpleText())
    return null;
  const r = e.offset;
  return n.getTextContent().slice(0, r);
}
function m2(t, e) {
  const n = window.getSelection();
  if (n === null || !n.isCollapsed)
    return !1;
  const r = n.anchorNode;
  if (r === null)
    return !1;
  const i = t.leadOffset, o = n.anchorOffset;
  try {
    e.setStart(r, i), e.setEnd(r, o);
  } catch {
    return !1;
  }
  return !0;
}
function v2(t) {
  let e = null;
  return t.getEditorState().read(() => {
    const n = Z.$getSelection();
    Z.$isRangeSelection(n) && (e = AF(n));
  }), e;
}
function OF(t, e, n) {
  let r = n;
  for (let i = r; i <= e.length; i++)
    t.substr(-i) === e.substr(0, i) && (r = i);
  return r;
}
function DF(t, e, n) {
  t.update(() => {
    const r = Z.$getSelection();
    if (!Z.$isRangeSelection(r) || !r.isCollapsed())
      return;
    if (typeof e.name != "string" && !e.name && typeof e.email != "string" && !e.email) {
      console.error("CollabKit: Mention name or email must be a non-empty string");
      return;
    }
    const i = r.anchor;
    if (i.type !== "text")
      return;
    const o = i.getNode();
    if (!o.isSimpleText())
      return;
    const a = i.offset, s = o.getTextContent().slice(0, a), l = n.replaceableString.length, f = `@${e.name || e.email}`, c = OF(s, f, l), u = a - c;
    if (u < 0)
      return;
    let d;
    u === 0 ? [d] = o.splitText(a) : [, d] = o.splitText(u, a);
    const h = Fc(e.id, f);
    d.replace(h), h.select();
  });
}
function b2(t, e) {
  return e !== 0 ? !1 : t.getEditorState().read(() => {
    const n = Z.$getSelection();
    if (Z.$isRangeSelection(n)) {
      const o = n.anchor.getNode().getPreviousSibling();
      return Z.$isTextNode(o) && o.isTextEntity();
    }
    return !1;
  });
}
function PF(t) {
  const [e] = vn.useLexicalComposerContext(), [n, r] = Dt(null);
  ce(() => {
    if (!e.hasNodes([Pi]))
      throw new Error("MentionsPlugin: MentionNode not registered on editor");
  }, [e]);
  const i = Oe(() => {
    let f = document.createRange(), c = null;
    const u = f, d = v2(e);
    if (d === c || u === null)
      return !1;
    c = d;
    const h = p2(d ?? "");
    return h !== null && !b2(e, h.leadOffset) && m2(h, u) !== null ? (_l(() => r({
      match: h,
      range: u
    })), !1) : (_l(() => r(null)), !0);
  }, []);
  ce(() => {
    e.registerCommand(I6, i, Z.COMMAND_PRIORITY_LOW);
  }, [e]), ce(() => {
    let f = document.createRange(), c = null;
    const u = () => {
      const h = f, p = v2(e);
      if (p === c || h === null)
        return;
      c = p;
      const m = p2(p ?? "");
      if (m !== null && !b2(e, m.leadOffset) && m2(m, h) !== null) {
        _l(() => r({
          match: m,
          range: h
        }));
        return;
      }
      _l(() => r(null));
    }, d = e.registerUpdateListener(u);
    return () => {
      f = null, d();
    };
  }, [e]);
  const o = Oe(() => {
    r(null);
  }, []), [a, s] = Dt(null);
  ce(() => {
    var f;
    (f = t.onOpenChange) == null || f.call(t, n != null && a !== null);
  }, [n, t.onOpenChange, a !== null]);
  const l = n != null && e != null ? /* @__PURE__ */ g(IF, {
    onResultsChange: s,
    close: o,
    resolution: n,
    editor: e
  }) : null;
  return /* @__PURE__ */ g(ea, {
    id: "collabkit-floating-root",
    children: l
  });
}
function RF() {
  const [t] = vn.useLexicalComposerContext();
  return t.registerCommand(Z.PASTE_COMMAND, (e) => {
    var n;
    if (e.clipboardData !== null && typeof ((n = e.clipboardData) == null ? void 0 : n.getData) == "function") {
      const r = Z.$getSelection();
      Z.$isRangeSelection(r) && A0.$insertDataTransferForPlainText(e.clipboardData, r);
    }
    return !0;
  }, Z.COMMAND_PRIORITY_EDITOR), null;
}
function xk(t) {
  var c;
  const e = xe(), { eventId: n } = t, r = _e(), { workspaceId: i, userId: o } = ie(r);
  if (!i || !o)
    throw new Error("CollabKit: workspaceId and userId are required");
  const a = n !== "default" ? (c = r.workspaces[i].timeline[e]) == null ? void 0 : c[n] : null, s = Oe(
    (u) => {
      var d, h;
      (h = (d = r.callbacks) == null ? void 0 : d.onTimestampClick) == null || h.call(d, {
        timestamp: u,
        threadId: e,
        workspaceId: i,
        userId: o,
        event: a
      });
    },
    [e, i, o]
  ), l = Oe(
    (u) => {
      var d, h;
      (h = (d = r.callbacks) == null ? void 0 : d.onMentionClick) == null || h.call(d, {
        threadId: e,
        workspaceId: i,
        userId: o,
        event: a,
        mention: u
      });
    },
    [e, i, o]
  );
  return { onClick: Oe(
    (u) => {
      const { target: d } = u;
      if (d instanceof HTMLElement) {
        if (d.classList.contains("data-lexical-timestamp"))
          u.stopPropagation(), u.preventDefault(), s(d.innerText);
        else if (d.classList.contains("data-lexical-mention")) {
          u.stopPropagation(), u.preventDefault();
          const h = d.getAttribute("data-lexical-mention");
          if (h) {
            const p = JSON.parse(h);
            l(p);
          }
        } else if (d instanceof HTMLAnchorElement) {
          const { href: h } = d;
          if (h.match(/#T(.*)/))
            s(d.innerText);
          else if (h.match(/#@(.*)/)) {
            const [p, m] = h.match(/#@(.*)/) || [];
            if (!m)
              return;
            const v = r.profiles[m];
            v && l(v);
          }
        }
      }
    },
    [r]
  ) };
}
var y2 = Tt({ defaultClassName: "_1jc8iycf", variantClassNames: { type: { primary: "_1jc8iycg", secondary: "_1jc8iych" } }, defaultVariants: {}, compoundVariants: [] }), LF = "_1jc8iyci", $F = "_1jc8iyc7", FF = Tt({ defaultClassName: "_1jc8iyc8", variantClassNames: { disabled: { true: "_1jc8iyc9" } }, defaultVariants: {}, compoundVariants: [] }), jF = Tt({ defaultClassName: "_1jc8iycb", variantClassNames: { active: { true: "_1jc8iycc" }, hover: { true: "_1jc8iycd" }, disabled: { true: "_1jc8iyce" } }, defaultVariants: {}, compoundVariants: [] }), zF = { ltr: "_1jc8iyc0", rtl: "_1jc8iyc1", placeholder: "_1jc8iyc4", paragraph: "_1jc8iyc5", span: "_1jc8iyc6" }, BF = "_1jc8iyc4", WF = "_1jc8iyca", UF = "_1jc8iyc2";
function ou() {
  const t = Gt(), e = oa(), n = xe();
  return t.composers[n] || (t.composers[n] = {}), t.composers[n][e] || (t.composers[n][e] = l_()), t.composers[n][e];
}
function Ek() {
  return ie(_e()).userId;
}
function Zi() {
  const t = Ek();
  if (!t)
    throw new Error("UserContext not found");
  return t;
}
function HF(t) {
  const e = t.isTyping;
  return e == null ? [] : Object.keys(e).filter((r) => r !== t.userId && e[r] === !0).map((r) => {
    var i, o;
    return ((i = t.profiles[r]) == null ? void 0 : i.name) || ((o = t.profiles[r]) == null ? void 0 : o.email);
  }).filter((r) => typeof r == "string" && !!r);
}
const VF = function({
  names: e
}) {
  return e.length === 0 ? /* @__PURE__ */ g("div", {}) : e.length === 1 ? /* @__PURE__ */ D("div", {
    children: [/* @__PURE__ */ g("span", {
      children: e[0]
    }), " is typing…"]
  }) : e.length === 2 ? /* @__PURE__ */ D("div", {
    children: [/* @__PURE__ */ g("span", {
      children: e[0]
    }), " and ", /* @__PURE__ */ g("span", {
      children: e[1]
    }), " are typing…"]
  }) : e.length === 3 ? /* @__PURE__ */ D("div", {
    children: [/* @__PURE__ */ g("span", {
      children: e[0]
    }), ", ", /* @__PURE__ */ g("span", {
      children: e[1]
    }), " and ", /* @__PURE__ */ g("span", {
      children: e[2]
    }), " are typing…"]
  }) : /* @__PURE__ */ D("div", {
    children: [/* @__PURE__ */ g("span", {
      children: e[0]
    }), ", ", /* @__PURE__ */ g("span", {
      children: e[1]
    }), " and ", /* @__PURE__ */ D("span", {
      children: [e.length - 2, " others"]
    }), " ", "are typing…"]
  });
};
function KF(t) {
  const {
    isTyping: e
  } = ie(ou()), {
    profiles: n
  } = ie(_e()), r = Zi(), i = HF({
    userId: r,
    isTyping: e,
    profiles: n
  }), o = he.useRef(null);
  return (
    // <TransitionGroup style={{ flexBasis: '100%', height: 18 }}>
    //   {names.length
    //     ? [
    //         <CSSTransition key="" timeout={300} classNames={transitionClassNames} nodeRef={nodeRef}>
    //           <div ref={nodeRef} className={props.className}>
    //             <TypingIndicatorText names={names} />
    //           </div>
    //         </CSSTransition>,
    //       ]
    //     : []}
    // </TransitionGroup>
    /* @__PURE__ */ g("div", {
      "data-testid": "collabkit-typing-indicator",
      ref: o,
      className: t.className ?? UF,
      children: /* @__PURE__ */ g(VF, {
        names: i
      })
    })
  );
}
var YF = Tt({ defaultClassName: "_1uptb4c0", variantClassNames: { disabled: { true: "_1uptb4c1" }, active: { true: "_1uptb4c2" }, small: { true: "_1uptb4c3" } }, defaultVariants: {}, compoundVariants: [] }), qF = "var(--collabkit-icon-button-color, var(--collabkit-color-icon))";
const GF = {
  color: qF,
  weight: "bold",
  size: 16
}, Rn = ze(function(e, n) {
  const {
    active: r,
    color: i,
    size: o,
    weight: a,
    small: s,
    disabled: l,
    ...f
  } = e, c = e.className ?? YF({
    active: r,
    small: s,
    disabled: l
  }), u = {
    ...GF
  };
  return i && (u.color = e.color), o && (u.size = e.size), a && (u.weight = e.weight), l && (u.color = je.color.iconDisabled), /* @__PURE__ */ g("div", {
    ...f,
    className: c,
    ref: n,
    children: /* @__PURE__ */ g(N3.Provider, {
      value: u,
      children: e.children
    })
  });
});
function QF(t) {
  const [e] = vn.useLexicalComposerContext();
  return ce(() => {
    t.onMount(e.getEditorState(), e);
  }, [e]), null;
}
function XF(t) {
  const [e] = vn.useLexicalComposerContext();
  return Jn.mergeRegister(e.registerCommand(Z.KEY_ENTER_COMMAND, (n) => n == null ? !1 : (t.onKeyDown(n), !0), Z.COMMAND_PRIORITY_LOW), e.registerCommand(Z.KEY_ESCAPE_COMMAND, (n) => n == null ? !1 : (t.onKeyDown(n), !0), Z.COMMAND_PRIORITY_LOW)), null;
}
function JF() {
  const t = _e(), e = Fi();
  return hn(t, "focusedId", (n) => vc(n, e));
}
function ZF(t) {
  return /* @__PURE__ */ g("div", {
    className: t.className ?? LF,
    children: t.children
  });
}
function ej(t) {
  console.error(t);
}
const tj = {
  namespace: "Composer",
  theme: zF,
  nodes: [Pi, Ri, Zo, Bc],
  onError: ej
};
function aa(t) {
  const e = oa(), n = xe(), r = _t(), i = Zi(), {
    onClick: o
  } = xk({
    threadId: n,
    workspaceId: r,
    userId: i,
    eventId: e
  }), {
    isNewThread: a,
    initialBody: s,
    ...l
  } = t, f = {
    workspaceId: r,
    threadId: n,
    type: "composer",
    isNewThread: a ?? !1,
    eventId: e
  }, c = _e();
  return ce(() => {
    Qo(c, f);
  }, [f.eventId, f.threadId, f.workspaceId, f.isNewThread]), /* @__PURE__ */ g(ta.Provider, {
    value: i,
    children: /* @__PURE__ */ g(Js.Provider, {
      value: f,
      children: /* @__PURE__ */ g("div", {
        "data-testid": "collabkit-composer-root",
        className: WF,
        ...l,
        onClick: o
      })
    })
  });
}
function au(t) {
  const {
    events: e
  } = ke(), n = Fi();
  return ce(() => () => e.onBlur(null, {
    target: n
  }), [e.onBlur]), /* @__PURE__ */ g("div", {
    "data-testid": "collabkit-composer-content-editable",
    style: {
      display: "contents"
    },
    onBlur: (r) => e.onBlur(r, {
      target: n
    }),
    onFocus: (r) => e.onFocus(r, {
      target: n
    }),
    children: /* @__PURE__ */ g(T$.ContentEditable, {
      className: t.className ?? FF(),
      tabIndex: t.autoFocus ? 1 : 0
    })
  });
}
function nU(t) {
  const {
    events: e
  } = ke(), n = xe(), r = _t(), i = oa(), o = {
    type: "composerMentionsButton",
    threadId: n,
    workspaceId: r,
    eventId: i
  }, {
    isMentioning: a
  } = ie(ou());
  return /* @__PURE__ */ g(Rn, {
    "data-testid": "collabkit-composer-mentions-button",
    active: a,
    style: {
      zIndex: 999
    },
    weight: "regular",
    color: a ? je.color.icon : je.color.iconSecondary,
    className: t.className,
    onClick: (s) => {
      s.stopPropagation(), s.preventDefault(), e.onClick(s, {
        target: o
      });
    },
    children: /* @__PURE__ */ g(ZL, {})
  });
}
const sa = he.memo(function(e) {
  const n = Fi(), r = xe(), i = _t(), {
    events: o,
    store: a
  } = ke(), s = oa(), l = {
    ...tj,
    editorState: () => {
      Of.$convertFromMarkdownString(e.initialBody ?? "", T6), Z.$setSelection(null);
    }
  }, f = Oe((c, u) => {
    o.onComposerChange(n, u);
  }, [o.onComposerChange, n]);
  return /* @__PURE__ */ g("div", {
    style: {
      position: "relative"
    },
    children: /* @__PURE__ */ D(M$.LexicalComposer, {
      initialConfig: l,
      children: [/* @__PURE__ */ g(QF, {
        onMount: f
      }), /* @__PURE__ */ g(XF, {
        onKeyDown: (c) => o.onKeyDown(c)
      }), /* @__PURE__ */ g(RF, {}), /* @__PURE__ */ g(a7.PlainTextPlugin, {
        contentEditable: e.contentEditable ?? /* @__PURE__ */ g(au, {
          autoFocus: e.autoFocus
        }),
        placeholder: e.placeholder,
        ErrorBoundary: (c) => /* @__PURE__ */ g(K, {
          children: c.children
        })
      }), /* @__PURE__ */ g(y7.OnChangePlugin, {
        onChange: f
      }), e.autoFocus ? /* @__PURE__ */ g(C7.AutoFocusPlugin, {}) : /* @__PURE__ */ g(K, {}), /* @__PURE__ */ g(p7.HistoryPlugin, {}), /* @__PURE__ */ g(PF, {
        onOpenChange: (c) => {
          a.workspaces[i].composers[r][s].isMentioning = c;
        }
      }), /* @__PURE__ */ g(E7, {})]
    })
  });
});
function la(t) {
  const e = Fi(), {
    events: n
  } = ke(), r = JF();
  return /* @__PURE__ */ g("div", {
    "data-testid": "collabkit-composer-editor",
    className: t.className ?? `${jF({
      active: r
    })} ${$F}`,
    onClick: (i) => n.onClick(i, {
      target: e
    }),
    ...t
  });
}
function su(t) {
  return /* @__PURE__ */ g("span", {
    "data-testid": "collabkit-composer-placeholder",
    className: BF,
    ...t
  });
}
function lu() {
  const t = xe(), e = _t(), n = oa(), r = !!ig(), {
    events: i
  } = ke(), {
    hasText: o
  } = ie(ou());
  return o && r ? /* @__PURE__ */ D(ZF, {
    children: [/* @__PURE__ */ g("div", {
      style: {
        flex: 1
      }
    }), /* @__PURE__ */ g("button", {
      "data-testid": "collabkit-comment-cancel-button",
      onClick: (a) => i.onClick(a, {
        target: {
          type: "commentCancelButton",
          eventId: n,
          workspaceId: e,
          threadId: t
        }
      }),
      className: y2({
        type: "secondary"
      }),
      children: "Cancel"
    }), /* @__PURE__ */ g("button", {
      "data-testid": "collabkit-comment-save-button",
      onClick: (a) => {
        i.onClick(a, {
          target: {
            type: "commentSaveButton",
            eventId: n,
            workspaceId: e,
            threadId: t
          }
        });
      },
      className: y2({
        type: "primary"
      }),
      children: "Save"
    })]
  }) : null;
}
function Tk(t) {
  return /* @__PURE__ */ D(aa, {
    isNewThread: t.isNewThread,
    children: [/* @__PURE__ */ g(On, {}), /* @__PURE__ */ D(la, {
      children: [/* @__PURE__ */ g(sa, {
        autoFocus: t.autoFocus,
        placeholder: /* @__PURE__ */ g(su, {
          children: t.placeholder ?? "Write a comment"
        })
      }), /* @__PURE__ */ g(lu, {})]
    }), /* @__PURE__ */ g(KF, {})]
  });
}
function nj(t) {
  return /* @__PURE__ */ g("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ g("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.2785 2.00276C11.0001 2.30166 11.6558 2.73968 12.2082 3.29185L12.209 3.29268C13.3249 4.40863 13.9519 5.92217 13.9519 7.50035C13.9519 9.07852 13.3249 10.5921 12.209 11.708L9.00015 14.9169C8.73525 15.1818 8.37596 15.3306 8.00133 15.3306C7.62669 15.3306 7.26741 15.1818 7.00251 14.9169L3.79365 11.708C3.24109 11.1554 2.80278 10.4995 2.50374 9.77752C2.2047 9.05556 2.05078 8.28178 2.05078 7.50035C2.05078 6.71891 2.2047 5.94513 2.50374 5.22318C2.80221 4.5026 3.23942 3.84774 3.79049 3.29585L3.79366 3.29268C4.34622 2.74012 5.0022 2.30181 5.72415 2.00276C6.44611 1.70372 7.21989 1.5498 8.00133 1.5498C8.78276 1.5498 9.55655 1.70372 10.2785 2.00276ZM10.5 7.5C10.5 8.88071 9.38071 10 8 10C6.61929 10 5.5 8.88071 5.5 7.5C5.5 6.11929 6.61929 5 8 5C9.38071 5 10.5 6.11929 10.5 7.5Z",
      fill: t.fill
    })
  });
}
var rj = Tt({ defaultClassName: "d9gru80", variantClassNames: { placement: { left: "d9gru81", right: "d9gru82", "top-start": "d9gru83", "top-end": "d9gru84", "bottom-end": "d9gru85", "top-left": "d9gru86", "top-right": "d9gru87", "bottom-left": "d9gru88", "bottom-right": "d9gru89", "right-start": "d9gru8a", "right-end": "d9gru8b", "left-start": "d9gru8c", "left-end": "d9gru8d", "bottom-start": "d9gru8e", bottom: "d9gru8f", top: "d9gru8g" } }, defaultVariants: {}, compoundVariants: [] });
function ij({
  initialOpen: t = !1,
  placement: e = "top",
  open: n,
  onOpenChange: r
} = {}) {
  const [i, o] = T.useState(t), a = n ?? i, s = r ?? o, l = jo({
    placement: e,
    open: a,
    onOpenChange: s,
    whileElementsMounted: $o,
    middleware: [Lo(5), Is({
      fallbackAxisSideDirection: "start",
      crossAxis: e.includes("-")
    }), Ff({
      padding: 5
    })]
  }), f = l.context, c = k4(f, {
    move: !1,
    enabled: n == null
  }), u = oP(f, {
    enabled: n == null
  }), d = Vf(f), h = A4(f, {
    role: "tooltip"
  }), p = Kf([c, u, d, h]);
  return T.useMemo(() => ({
    open: a,
    setOpen: s,
    ...p,
    ...l
  }), [a, s, p, l]);
}
const Sk = T.createContext(null), Ik = () => {
  const t = T.useContext(Sk);
  if (t == null)
    throw new Error("Tooltip components must be wrapped in <Tooltip />");
  return t;
};
function yn({
  children: t,
  ...e
}) {
  const n = ij(e);
  return /* @__PURE__ */ g(Sk.Provider, {
    value: n,
    children: t
  });
}
const _n = T.forwardRef(function({
  children: e,
  asChild: n = !1,
  ...r
}, i) {
  const o = Ik(), a = e.ref, s = M4([o.refs.setReference, i, a]);
  return n && T.isValidElement(e) ? T.cloneElement(e, o.getReferenceProps({
    ref: s,
    ...r,
    ...e.props,
    "data-state": o.open ? "open" : "closed"
  })) : /* @__PURE__ */ g("div", {
    ref: s,
    "data-state": o.open ? "open" : "closed",
    ...o.getReferenceProps(r),
    style: {
      border: "none",
      background: "none",
      padding: 0
    },
    children: e
  });
}), wn = T.forwardRef(function(e, n) {
  const r = Ik(), i = M4([r.refs.setFloating, n]);
  return /* @__PURE__ */ g(ea, {
    id: "collabkit-floating-root",
    children: r.open && /* @__PURE__ */ g(qt, {
      children: /* @__PURE__ */ g("div", {
        ref: i,
        style: {
          position: r.strategy,
          top: r.y ?? 0,
          left: r.x ?? 0,
          visibility: r.x == null ? "hidden" : "visible",
          ...e.style
        },
        className: rj({
          placement: r.placement
        }),
        ...r.getFloatingProps(e)
      })
    })
  });
});
var oj = "_1trzxli3", aj = "_1trzxli4", sj = "_1trzxli2", lj = Tt({ defaultClassName: "_1trzxli0", variantClassNames: { type: { quick: "_1trzxli1" } }, defaultVariants: {}, compoundVariants: [] });
function Nk(t) {
  return /* @__PURE__ */ g("span", {
    className: t.className ?? aj,
    onClick: (e) => {
      var n;
      return (n = t.onClick) == null ? void 0 : n.call(t, e, t.emoji);
    },
    children: t.emoji.u.split("-").map((e) => String.fromCodePoint(parseInt(e, 16))).join("")
  });
}
const Xf = {
  popular: [
    {
      n: ["+1", "thumbsup", "thumbs up sign"],
      u: "1f44d",
      v: ["1f44d-1f3fb", "1f44d-1f3fc", "1f44d-1f3fd", "1f44d-1f3fe", "1f44d-1f3ff"],
      a: "0.6"
    },
    {
      n: ["heart", "heavy black heart"],
      u: "2764-fe0f",
      a: "0.6"
    },
    {
      n: ["joy", "face with tears of joy"],
      u: "1f602",
      a: "0.6"
    },
    {
      n: ["open mouth", "face with open mouth"],
      u: "1f62e",
      a: "1.0"
    },
    {
      n: ["pray", "person with folded hands"],
      u: "1f64f",
      v: ["1f64f-1f3fb", "1f64f-1f3fc", "1f64f-1f3fd", "1f64f-1f3fe", "1f64f-1f3ff"],
      a: "0.6"
    },
    {
      n: ["fire"],
      u: "1f525",
      a: "0.6"
    }
  ],
  smileys_people: [
    {
      n: ["grinning", "grinning face"],
      u: "1f600",
      a: "1.0"
    },
    {
      n: ["smiley", "smiling face with open mouth"],
      u: "1f603",
      a: "0.6"
    },
    {
      n: ["smile", "smiling face with open mouth and smiling eyes"],
      u: "1f604",
      a: "0.6"
    },
    {
      n: ["grin", "grinning face with smiling eyes"],
      u: "1f601",
      a: "0.6"
    },
    {
      n: ["laughing", "satisfied", "smiling face with open mouth and tightly-closed eyes"],
      u: "1f606",
      a: "0.6"
    },
    {
      n: ["sweat smile", "smiling face with open mouth and cold sweat"],
      u: "1f605",
      a: "0.6"
    },
    {
      n: ["rolling on the floor laughing"],
      u: "1f923",
      a: "3.0"
    },
    {
      n: ["joy", "face with tears of joy"],
      u: "1f602",
      a: "0.6"
    },
    {
      n: ["slightly smiling face"],
      u: "1f642",
      a: "1.0"
    },
    {
      n: ["upside-down face", "upside down face"],
      u: "1f643",
      a: "1.0"
    },
    {
      n: ["melting face"],
      u: "1fae0",
      a: "14.0"
    },
    {
      n: ["wink", "winking face"],
      u: "1f609",
      a: "0.6"
    },
    {
      n: ["blush", "smiling face with smiling eyes"],
      u: "1f60a",
      a: "0.6"
    },
    {
      n: ["innocent", "smiling face with halo"],
      u: "1f607",
      a: "1.0"
    },
    {
      n: ["smiling face with 3 hearts", "smiling face with smiling eyes and three hearts"],
      u: "1f970",
      a: "11.0"
    },
    {
      n: ["heart eyes", "smiling face with heart-shaped eyes"],
      u: "1f60d",
      a: "0.6"
    },
    {
      n: ["star-struck", "grinning face with star eyes"],
      u: "1f929",
      a: "5.0"
    },
    {
      n: ["kissing heart", "face throwing a kiss"],
      u: "1f618",
      a: "0.6"
    },
    {
      n: ["kissing", "kissing face"],
      u: "1f617",
      a: "1.0"
    },
    {
      n: ["relaxed", "white smiling face"],
      u: "263a-fe0f",
      a: "0.6"
    },
    {
      n: ["kissing closed eyes", "kissing face with closed eyes"],
      u: "1f61a",
      a: "0.6"
    },
    {
      n: ["kissing smiling eyes", "kissing face with smiling eyes"],
      u: "1f619",
      a: "1.0"
    },
    {
      n: ["smiling face with tear"],
      u: "1f972",
      a: "13.0"
    },
    {
      n: ["yum", "face savouring delicious food"],
      u: "1f60b",
      a: "0.6"
    },
    {
      n: ["stuck out tongue", "face with stuck-out tongue"],
      u: "1f61b",
      a: "1.0"
    },
    {
      n: ["stuck out tongue winking eye", "face with stuck-out tongue and winking eye"],
      u: "1f61c",
      a: "0.6"
    },
    {
      n: ["zany face", "grinning face with one large and one small eye"],
      u: "1f92a",
      a: "5.0"
    },
    {
      n: ["stuck out tongue closed eyes", "face with stuck-out tongue and tightly-closed eyes"],
      u: "1f61d",
      a: "0.6"
    },
    {
      n: ["money-mouth face", "money mouth face"],
      u: "1f911",
      a: "1.0"
    },
    {
      n: ["hugging face"],
      u: "1f917",
      a: "1.0"
    },
    {
      n: ["face with hand over mouth", "smiling face with smiling eyes and hand covering mouth"],
      u: "1f92d",
      a: "5.0"
    },
    {
      n: ["face with open eyes and hand over mouth"],
      u: "1fae2",
      a: "14.0"
    },
    {
      n: ["face with peeking eye"],
      u: "1fae3",
      a: "14.0"
    },
    {
      n: ["shushing face", "face with finger covering closed lips"],
      u: "1f92b",
      a: "5.0"
    },
    {
      n: ["thinking face"],
      u: "1f914",
      a: "1.0"
    },
    {
      n: ["saluting face"],
      u: "1fae1",
      a: "14.0"
    },
    {
      n: ["zipper-mouth face", "zipper mouth face"],
      u: "1f910",
      a: "1.0"
    },
    {
      n: ["face with raised eyebrow", "face with one eyebrow raised"],
      u: "1f928",
      a: "5.0"
    },
    {
      n: ["neutral face"],
      u: "1f610",
      a: "0.7"
    },
    {
      n: ["expressionless", "expressionless face"],
      u: "1f611",
      a: "1.0"
    },
    {
      n: ["no mouth", "face without mouth"],
      u: "1f636",
      a: "1.0"
    },
    {
      n: ["dotted line face"],
      u: "1fae5",
      a: "14.0"
    },
    {
      n: ["face in clouds"],
      u: "1f636-200d-1f32b-fe0f",
      a: "13.1"
    },
    {
      n: ["smirk", "smirking face"],
      u: "1f60f",
      a: "0.6"
    },
    {
      n: ["unamused", "unamused face"],
      u: "1f612",
      a: "0.6"
    },
    {
      n: ["face with rolling eyes"],
      u: "1f644",
      a: "1.0"
    },
    {
      n: ["grimacing", "grimacing face"],
      u: "1f62c",
      a: "1.0"
    },
    {
      n: ["face exhaling"],
      u: "1f62e-200d-1f4a8",
      a: "13.1"
    },
    {
      n: ["lying face"],
      u: "1f925",
      a: "3.0"
    },
    {
      n: ["relieved", "relieved face"],
      u: "1f60c",
      a: "0.6"
    },
    {
      n: ["pensive", "pensive face"],
      u: "1f614",
      a: "0.6"
    },
    {
      n: ["sleepy", "sleepy face"],
      u: "1f62a",
      a: "0.6"
    },
    {
      n: ["drooling face"],
      u: "1f924",
      a: "3.0"
    },
    {
      n: ["sleeping", "sleeping face"],
      u: "1f634",
      a: "1.0"
    },
    {
      n: ["mask", "face with medical mask"],
      u: "1f637",
      a: "0.6"
    },
    {
      n: ["face with thermometer"],
      u: "1f912",
      a: "1.0"
    },
    {
      n: ["face with head-bandage", "face with head bandage"],
      u: "1f915",
      a: "1.0"
    },
    {
      n: ["nauseated face"],
      u: "1f922",
      a: "3.0"
    },
    {
      n: ["face vomiting", "face with open mouth vomiting"],
      u: "1f92e",
      a: "5.0"
    },
    {
      n: ["sneezing face"],
      u: "1f927",
      a: "3.0"
    },
    {
      n: ["hot face", "overheated face"],
      u: "1f975",
      a: "11.0"
    },
    {
      n: ["cold face", "freezing face"],
      u: "1f976",
      a: "11.0"
    },
    {
      n: ["woozy face", "face with uneven eyes and wavy mouth"],
      u: "1f974",
      a: "11.0"
    },
    {
      n: ["dizzy face"],
      u: "1f635",
      a: "0.6"
    },
    {
      n: ["face with spiral eyes"],
      u: "1f635-200d-1f4ab",
      a: "13.1"
    },
    {
      n: ["exploding head", "shocked face with exploding head"],
      u: "1f92f",
      a: "5.0"
    },
    {
      n: ["face with cowboy hat"],
      u: "1f920",
      a: "3.0"
    },
    {
      n: ["partying face", "face with party horn and party hat"],
      u: "1f973",
      a: "11.0"
    },
    {
      n: ["disguised face"],
      u: "1f978",
      a: "13.0"
    },
    {
      n: ["sunglasses", "smiling face with sunglasses"],
      u: "1f60e",
      a: "1.0"
    },
    {
      n: ["nerd face"],
      u: "1f913",
      a: "1.0"
    },
    {
      n: ["face with monocle"],
      u: "1f9d0",
      a: "5.0"
    },
    {
      n: ["confused", "confused face"],
      u: "1f615",
      a: "1.0"
    },
    {
      n: ["face with diagonal mouth"],
      u: "1fae4",
      a: "14.0"
    },
    {
      n: ["worried", "worried face"],
      u: "1f61f",
      a: "1.0"
    },
    {
      n: ["slightly frowning face"],
      u: "1f641",
      a: "1.0"
    },
    {
      n: ["frowning face", "white frowning face"],
      u: "2639-fe0f",
      a: "0.7"
    },
    {
      n: ["open mouth", "face with open mouth"],
      u: "1f62e",
      a: "1.0"
    },
    {
      n: ["hushed", "hushed face"],
      u: "1f62f",
      a: "1.0"
    },
    {
      n: ["astonished", "astonished face"],
      u: "1f632",
      a: "0.6"
    },
    {
      n: ["flushed", "flushed face"],
      u: "1f633",
      a: "0.6"
    },
    {
      n: ["pleading face", "face with pleading eyes"],
      u: "1f97a",
      a: "11.0"
    },
    {
      n: ["face holding back tears"],
      u: "1f979",
      a: "14.0"
    },
    {
      n: ["frowning", "frowning face with open mouth"],
      u: "1f626",
      a: "1.0"
    },
    {
      n: ["anguished", "anguished face"],
      u: "1f627",
      a: "1.0"
    },
    {
      n: ["fearful", "fearful face"],
      u: "1f628",
      a: "0.6"
    },
    {
      n: ["cold sweat", "face with open mouth and cold sweat"],
      u: "1f630",
      a: "0.6"
    },
    {
      n: ["disappointed relieved", "disappointed but relieved face"],
      u: "1f625",
      a: "0.6"
    },
    {
      n: ["cry", "crying face"],
      u: "1f622",
      a: "0.6"
    },
    {
      n: ["sob", "loudly crying face"],
      u: "1f62d",
      a: "0.6"
    },
    {
      n: ["scream", "face screaming in fear"],
      u: "1f631",
      a: "0.6"
    },
    {
      n: ["confounded", "confounded face"],
      u: "1f616",
      a: "0.6"
    },
    {
      n: ["persevere", "persevering face"],
      u: "1f623",
      a: "0.6"
    },
    {
      n: ["disappointed", "disappointed face"],
      u: "1f61e",
      a: "0.6"
    },
    {
      n: ["sweat", "face with cold sweat"],
      u: "1f613",
      a: "0.6"
    },
    {
      n: ["weary", "weary face"],
      u: "1f629",
      a: "0.6"
    },
    {
      n: ["tired face"],
      u: "1f62b",
      a: "0.6"
    },
    {
      n: ["yawning face"],
      u: "1f971",
      a: "12.0"
    },
    {
      n: ["triumph", "face with look of triumph"],
      u: "1f624",
      a: "0.6"
    },
    {
      n: ["rage", "pouting face"],
      u: "1f621",
      a: "0.6"
    },
    {
      n: ["angry", "angry face"],
      u: "1f620",
      a: "0.6"
    },
    {
      n: ["face with symbols on mouth", "serious face with symbols covering mouth"],
      u: "1f92c",
      a: "5.0"
    },
    {
      n: ["smiling imp", "smiling face with horns"],
      u: "1f608",
      a: "1.0"
    },
    {
      n: ["imp"],
      u: "1f47f",
      a: "0.6"
    },
    {
      n: ["skull"],
      u: "1f480",
      a: "0.6"
    },
    {
      n: ["skull and crossbones"],
      u: "2620-fe0f",
      a: "1.0"
    },
    {
      n: ["poop", "shit", "hankey", "pile of poo"],
      u: "1f4a9",
      a: "0.6"
    },
    {
      n: ["clown face"],
      u: "1f921",
      a: "3.0"
    },
    {
      n: ["japanese ogre"],
      u: "1f479",
      a: "0.6"
    },
    {
      n: ["japanese goblin"],
      u: "1f47a",
      a: "0.6"
    },
    {
      n: ["ghost"],
      u: "1f47b",
      a: "0.6"
    },
    {
      n: ["alien", "extraterrestrial alien"],
      u: "1f47d",
      a: "0.6"
    },
    {
      n: ["alien monster", "space invader"],
      u: "1f47e",
      a: "0.6"
    },
    {
      n: ["robot face"],
      u: "1f916",
      a: "1.0"
    },
    {
      n: ["smiley cat", "smiling cat face with open mouth"],
      u: "1f63a",
      a: "0.6"
    },
    {
      n: ["smile cat", "grinning cat face with smiling eyes"],
      u: "1f638",
      a: "0.6"
    },
    {
      n: ["joy cat", "cat face with tears of joy"],
      u: "1f639",
      a: "0.6"
    },
    {
      n: ["heart eyes cat", "smiling cat face with heart-shaped eyes"],
      u: "1f63b",
      a: "0.6"
    },
    {
      n: ["smirk cat", "cat face with wry smile"],
      u: "1f63c",
      a: "0.6"
    },
    {
      n: ["kissing cat", "kissing cat face with closed eyes"],
      u: "1f63d",
      a: "0.6"
    },
    {
      n: ["scream cat", "weary cat face"],
      u: "1f640",
      a: "0.6"
    },
    {
      n: ["crying cat face"],
      u: "1f63f",
      a: "0.6"
    },
    {
      n: ["pouting cat", "pouting cat face"],
      u: "1f63e",
      a: "0.6"
    },
    {
      n: ["see no evil", "see-no-evil monkey"],
      u: "1f648",
      a: "0.6"
    },
    {
      n: ["hear no evil", "hear-no-evil monkey"],
      u: "1f649",
      a: "0.6"
    },
    {
      n: ["speak no evil", "speak-no-evil monkey"],
      u: "1f64a",
      a: "0.6"
    },
    {
      n: ["kiss", "kiss mark"],
      u: "1f48b",
      a: "0.6"
    },
    {
      n: ["love letter"],
      u: "1f48c",
      a: "0.6"
    },
    {
      n: ["cupid", "heart with arrow"],
      u: "1f498",
      a: "0.6"
    },
    {
      n: ["gift heart", "heart with ribbon"],
      u: "1f49d",
      a: "0.6"
    },
    {
      n: ["sparkling heart"],
      u: "1f496",
      a: "0.6"
    },
    {
      n: ["heartpulse", "growing heart"],
      u: "1f497",
      a: "0.6"
    },
    {
      n: ["heartbeat", "beating heart"],
      u: "1f493",
      a: "0.6"
    },
    {
      n: ["revolving hearts"],
      u: "1f49e",
      a: "0.6"
    },
    {
      n: ["two hearts"],
      u: "1f495",
      a: "0.6"
    },
    {
      n: ["heart decoration"],
      u: "1f49f",
      a: "0.6"
    },
    {
      n: ["heart exclamation", "heavy heart exclamation mark ornament"],
      u: "2763-fe0f",
      a: "1.0"
    },
    {
      n: ["broken heart"],
      u: "1f494",
      a: "0.6"
    },
    {
      n: ["heart on fire"],
      u: "2764-fe0f-200d-1f525",
      a: "13.1"
    },
    {
      n: ["mending heart"],
      u: "2764-fe0f-200d-1fa79",
      a: "13.1"
    },
    {
      n: ["heart", "heavy black heart"],
      u: "2764-fe0f",
      a: "0.6"
    },
    {
      n: ["orange heart"],
      u: "1f9e1",
      a: "5.0"
    },
    {
      n: ["yellow heart"],
      u: "1f49b",
      a: "0.6"
    },
    {
      n: ["green heart"],
      u: "1f49a",
      a: "0.6"
    },
    {
      n: ["blue heart"],
      u: "1f499",
      a: "0.6"
    },
    {
      n: ["purple heart"],
      u: "1f49c",
      a: "0.6"
    },
    {
      n: ["brown heart"],
      u: "1f90e",
      a: "12.0"
    },
    {
      n: ["black heart"],
      u: "1f5a4",
      a: "3.0"
    },
    {
      n: ["white heart"],
      u: "1f90d",
      a: "12.0"
    },
    {
      n: ["100", "hundred points symbol"],
      u: "1f4af",
      a: "0.6"
    },
    {
      n: ["anger", "anger symbol"],
      u: "1f4a2",
      a: "0.6"
    },
    {
      n: ["boom", "collision", "collision symbol"],
      u: "1f4a5",
      a: "0.6"
    },
    {
      n: ["dizzy", "dizzy symbol"],
      u: "1f4ab",
      a: "0.6"
    },
    {
      n: ["sweat drops", "splashing sweat symbol"],
      u: "1f4a6",
      a: "0.6"
    },
    {
      n: ["dash", "dash symbol"],
      u: "1f4a8",
      a: "0.6"
    },
    {
      n: ["hole"],
      u: "1f573-fe0f",
      a: "0.7"
    },
    {
      n: ["bomb"],
      u: "1f4a3",
      a: "0.6"
    },
    {
      n: ["speech balloon"],
      u: "1f4ac",
      a: "0.6"
    },
    {
      n: ["eye in speech bubble", "eye-in-speech-bubble"],
      u: "1f441-fe0f-200d-1f5e8-fe0f",
      a: "2.0"
    },
    {
      n: ["left speech bubble"],
      u: "1f5e8-fe0f",
      a: "2.0"
    },
    {
      n: ["right anger bubble"],
      u: "1f5ef-fe0f",
      a: "0.7"
    },
    {
      n: ["thought balloon"],
      u: "1f4ad",
      a: "1.0"
    },
    {
      n: ["zzz", "sleeping symbol"],
      u: "1f4a4",
      a: "0.6"
    },
    {
      n: ["wave", "waving hand sign"],
      u: "1f44b",
      v: ["1f44b-1f3fb", "1f44b-1f3fc", "1f44b-1f3fd", "1f44b-1f3fe", "1f44b-1f3ff"],
      a: "0.6"
    },
    {
      n: ["raised back of hand"],
      u: "1f91a",
      v: ["1f91a-1f3fb", "1f91a-1f3fc", "1f91a-1f3fd", "1f91a-1f3fe", "1f91a-1f3ff"],
      a: "3.0"
    },
    {
      n: ["hand with fingers splayed", "raised hand with fingers splayed"],
      u: "1f590-fe0f",
      v: ["1f590-1f3fb", "1f590-1f3fc", "1f590-1f3fd", "1f590-1f3fe", "1f590-1f3ff"],
      a: "0.7"
    },
    {
      n: ["hand", "raised hand"],
      u: "270b",
      v: ["270b-1f3fb", "270b-1f3fc", "270b-1f3fd", "270b-1f3fe", "270b-1f3ff"],
      a: "0.6"
    },
    {
      n: ["spock-hand", "raised hand with part between middle and ring fingers"],
      u: "1f596",
      v: ["1f596-1f3fb", "1f596-1f3fc", "1f596-1f3fd", "1f596-1f3fe", "1f596-1f3ff"],
      a: "1.0"
    },
    {
      n: ["rightwards hand"],
      u: "1faf1",
      v: ["1faf1-1f3fb", "1faf1-1f3fc", "1faf1-1f3fd", "1faf1-1f3fe", "1faf1-1f3ff"],
      a: "14.0"
    },
    {
      n: ["leftwards hand"],
      u: "1faf2",
      v: ["1faf2-1f3fb", "1faf2-1f3fc", "1faf2-1f3fd", "1faf2-1f3fe", "1faf2-1f3ff"],
      a: "14.0"
    },
    {
      n: ["palm down hand"],
      u: "1faf3",
      v: ["1faf3-1f3fb", "1faf3-1f3fc", "1faf3-1f3fd", "1faf3-1f3fe", "1faf3-1f3ff"],
      a: "14.0"
    },
    {
      n: ["palm up hand"],
      u: "1faf4",
      v: ["1faf4-1f3fb", "1faf4-1f3fc", "1faf4-1f3fd", "1faf4-1f3fe", "1faf4-1f3ff"],
      a: "14.0"
    },
    {
      n: ["ok hand", "ok hand sign"],
      u: "1f44c",
      v: ["1f44c-1f3fb", "1f44c-1f3fc", "1f44c-1f3fd", "1f44c-1f3fe", "1f44c-1f3ff"],
      a: "0.6"
    },
    {
      n: ["pinched fingers"],
      u: "1f90c",
      v: ["1f90c-1f3fb", "1f90c-1f3fc", "1f90c-1f3fd", "1f90c-1f3fe", "1f90c-1f3ff"],
      a: "13.0"
    },
    {
      n: ["pinching hand"],
      u: "1f90f",
      v: ["1f90f-1f3fb", "1f90f-1f3fc", "1f90f-1f3fd", "1f90f-1f3fe", "1f90f-1f3ff"],
      a: "12.0"
    },
    {
      n: ["v", "victory hand"],
      u: "270c-fe0f",
      v: ["270c-1f3fb", "270c-1f3fc", "270c-1f3fd", "270c-1f3fe", "270c-1f3ff"],
      a: "0.6"
    },
    {
      n: ["crossed fingers", "hand with index and middle fingers crossed"],
      u: "1f91e",
      v: ["1f91e-1f3fb", "1f91e-1f3fc", "1f91e-1f3fd", "1f91e-1f3fe", "1f91e-1f3ff"],
      a: "3.0"
    },
    {
      n: ["hand with index finger and thumb crossed"],
      u: "1faf0",
      v: ["1faf0-1f3fb", "1faf0-1f3fc", "1faf0-1f3fd", "1faf0-1f3fe", "1faf0-1f3ff"],
      a: "14.0"
    },
    {
      n: ["i love you hand sign"],
      u: "1f91f",
      v: ["1f91f-1f3fb", "1f91f-1f3fc", "1f91f-1f3fd", "1f91f-1f3fe", "1f91f-1f3ff"],
      a: "5.0"
    },
    {
      n: ["the horns", "sign of the horns"],
      u: "1f918",
      v: ["1f918-1f3fb", "1f918-1f3fc", "1f918-1f3fd", "1f918-1f3fe", "1f918-1f3ff"],
      a: "1.0"
    },
    {
      n: ["call me hand"],
      u: "1f919",
      v: ["1f919-1f3fb", "1f919-1f3fc", "1f919-1f3fd", "1f919-1f3fe", "1f919-1f3ff"],
      a: "3.0"
    },
    {
      n: ["point left", "white left pointing backhand index"],
      u: "1f448",
      v: ["1f448-1f3fb", "1f448-1f3fc", "1f448-1f3fd", "1f448-1f3fe", "1f448-1f3ff"],
      a: "0.6"
    },
    {
      n: ["point right", "white right pointing backhand index"],
      u: "1f449",
      v: ["1f449-1f3fb", "1f449-1f3fc", "1f449-1f3fd", "1f449-1f3fe", "1f449-1f3ff"],
      a: "0.6"
    },
    {
      n: ["point up 2", "white up pointing backhand index"],
      u: "1f446",
      v: ["1f446-1f3fb", "1f446-1f3fc", "1f446-1f3fd", "1f446-1f3fe", "1f446-1f3ff"],
      a: "0.6"
    },
    {
      n: ["middle finger", "reversed hand with middle finger extended"],
      u: "1f595",
      v: ["1f595-1f3fb", "1f595-1f3fc", "1f595-1f3fd", "1f595-1f3fe", "1f595-1f3ff"],
      a: "1.0"
    },
    {
      n: ["point down", "white down pointing backhand index"],
      u: "1f447",
      v: ["1f447-1f3fb", "1f447-1f3fc", "1f447-1f3fd", "1f447-1f3fe", "1f447-1f3ff"],
      a: "0.6"
    },
    {
      n: ["point up", "white up pointing index"],
      u: "261d-fe0f",
      v: ["261d-1f3fb", "261d-1f3fc", "261d-1f3fd", "261d-1f3fe", "261d-1f3ff"],
      a: "0.6"
    },
    {
      n: ["index pointing at the viewer"],
      u: "1faf5",
      v: ["1faf5-1f3fb", "1faf5-1f3fc", "1faf5-1f3fd", "1faf5-1f3fe", "1faf5-1f3ff"],
      a: "14.0"
    },
    {
      n: ["+1", "thumbsup", "thumbs up sign"],
      u: "1f44d",
      v: ["1f44d-1f3fb", "1f44d-1f3fc", "1f44d-1f3fd", "1f44d-1f3fe", "1f44d-1f3ff"],
      a: "0.6"
    },
    {
      n: ["-1", "thumbsdown", "thumbs down sign"],
      u: "1f44e",
      v: ["1f44e-1f3fb", "1f44e-1f3fc", "1f44e-1f3fd", "1f44e-1f3fe", "1f44e-1f3ff"],
      a: "0.6"
    },
    {
      n: ["fist", "raised fist"],
      u: "270a",
      v: ["270a-1f3fb", "270a-1f3fc", "270a-1f3fd", "270a-1f3fe", "270a-1f3ff"],
      a: "0.6"
    },
    {
      n: ["punch", "facepunch", "fisted hand sign"],
      u: "1f44a",
      v: ["1f44a-1f3fb", "1f44a-1f3fc", "1f44a-1f3fd", "1f44a-1f3fe", "1f44a-1f3ff"],
      a: "0.6"
    },
    {
      n: ["left-facing fist"],
      u: "1f91b",
      v: ["1f91b-1f3fb", "1f91b-1f3fc", "1f91b-1f3fd", "1f91b-1f3fe", "1f91b-1f3ff"],
      a: "3.0"
    },
    {
      n: ["right-facing fist"],
      u: "1f91c",
      v: ["1f91c-1f3fb", "1f91c-1f3fc", "1f91c-1f3fd", "1f91c-1f3fe", "1f91c-1f3ff"],
      a: "3.0"
    },
    {
      n: ["clap", "clapping hands sign"],
      u: "1f44f",
      v: ["1f44f-1f3fb", "1f44f-1f3fc", "1f44f-1f3fd", "1f44f-1f3fe", "1f44f-1f3ff"],
      a: "0.6"
    },
    {
      n: ["raised hands", "person raising both hands in celebration"],
      u: "1f64c",
      v: ["1f64c-1f3fb", "1f64c-1f3fc", "1f64c-1f3fd", "1f64c-1f3fe", "1f64c-1f3ff"],
      a: "0.6"
    },
    {
      n: ["heart hands"],
      u: "1faf6",
      v: ["1faf6-1f3fb", "1faf6-1f3fc", "1faf6-1f3fd", "1faf6-1f3fe", "1faf6-1f3ff"],
      a: "14.0"
    },
    {
      n: ["open hands", "open hands sign"],
      u: "1f450",
      v: ["1f450-1f3fb", "1f450-1f3fc", "1f450-1f3fd", "1f450-1f3fe", "1f450-1f3ff"],
      a: "0.6"
    },
    {
      n: ["palms up together"],
      u: "1f932",
      v: ["1f932-1f3fb", "1f932-1f3fc", "1f932-1f3fd", "1f932-1f3fe", "1f932-1f3ff"],
      a: "5.0"
    },
    {
      n: ["handshake"],
      u: "1f91d",
      v: [
        "1f91d-1f3fb",
        "1f91d-1f3fc",
        "1f91d-1f3fd",
        "1f91d-1f3fe",
        "1f91d-1f3ff",
        "1faf1-1f3fb-200d-1faf2-1f3fc",
        "1faf1-1f3fb-200d-1faf2-1f3fd",
        "1faf1-1f3fb-200d-1faf2-1f3fe",
        "1faf1-1f3fb-200d-1faf2-1f3ff",
        "1faf1-1f3fc-200d-1faf2-1f3fb",
        "1faf1-1f3fc-200d-1faf2-1f3fd",
        "1faf1-1f3fc-200d-1faf2-1f3fe",
        "1faf1-1f3fc-200d-1faf2-1f3ff",
        "1faf1-1f3fd-200d-1faf2-1f3fb",
        "1faf1-1f3fd-200d-1faf2-1f3fc",
        "1faf1-1f3fd-200d-1faf2-1f3fe",
        "1faf1-1f3fd-200d-1faf2-1f3ff",
        "1faf1-1f3fe-200d-1faf2-1f3fb",
        "1faf1-1f3fe-200d-1faf2-1f3fc",
        "1faf1-1f3fe-200d-1faf2-1f3fd",
        "1faf1-1f3fe-200d-1faf2-1f3ff",
        "1faf1-1f3ff-200d-1faf2-1f3fb",
        "1faf1-1f3ff-200d-1faf2-1f3fc",
        "1faf1-1f3ff-200d-1faf2-1f3fd",
        "1faf1-1f3ff-200d-1faf2-1f3fe"
      ],
      a: "3.0"
    },
    {
      n: ["pray", "person with folded hands"],
      u: "1f64f",
      v: ["1f64f-1f3fb", "1f64f-1f3fc", "1f64f-1f3fd", "1f64f-1f3fe", "1f64f-1f3ff"],
      a: "0.6"
    },
    {
      n: ["writing hand"],
      u: "270d-fe0f",
      v: ["270d-1f3fb", "270d-1f3fc", "270d-1f3fd", "270d-1f3fe", "270d-1f3ff"],
      a: "0.7"
    },
    {
      n: ["nail care", "nail polish"],
      u: "1f485",
      v: ["1f485-1f3fb", "1f485-1f3fc", "1f485-1f3fd", "1f485-1f3fe", "1f485-1f3ff"],
      a: "0.6"
    },
    {
      n: ["selfie"],
      u: "1f933",
      v: ["1f933-1f3fb", "1f933-1f3fc", "1f933-1f3fd", "1f933-1f3fe", "1f933-1f3ff"],
      a: "3.0"
    },
    {
      n: ["muscle", "flexed biceps"],
      u: "1f4aa",
      v: ["1f4aa-1f3fb", "1f4aa-1f3fc", "1f4aa-1f3fd", "1f4aa-1f3fe", "1f4aa-1f3ff"],
      a: "0.6"
    },
    {
      n: ["mechanical arm"],
      u: "1f9be",
      a: "12.0"
    },
    {
      n: ["mechanical leg"],
      u: "1f9bf",
      a: "12.0"
    },
    {
      n: ["leg"],
      u: "1f9b5",
      v: ["1f9b5-1f3fb", "1f9b5-1f3fc", "1f9b5-1f3fd", "1f9b5-1f3fe", "1f9b5-1f3ff"],
      a: "11.0"
    },
    {
      n: ["foot"],
      u: "1f9b6",
      v: ["1f9b6-1f3fb", "1f9b6-1f3fc", "1f9b6-1f3fd", "1f9b6-1f3fe", "1f9b6-1f3ff"],
      a: "11.0"
    },
    {
      n: ["ear"],
      u: "1f442",
      v: ["1f442-1f3fb", "1f442-1f3fc", "1f442-1f3fd", "1f442-1f3fe", "1f442-1f3ff"],
      a: "0.6"
    },
    {
      n: ["ear with hearing aid"],
      u: "1f9bb",
      v: ["1f9bb-1f3fb", "1f9bb-1f3fc", "1f9bb-1f3fd", "1f9bb-1f3fe", "1f9bb-1f3ff"],
      a: "12.0"
    },
    {
      n: ["nose"],
      u: "1f443",
      v: ["1f443-1f3fb", "1f443-1f3fc", "1f443-1f3fd", "1f443-1f3fe", "1f443-1f3ff"],
      a: "0.6"
    },
    {
      n: ["brain"],
      u: "1f9e0",
      a: "5.0"
    },
    {
      n: ["anatomical heart"],
      u: "1fac0",
      a: "13.0"
    },
    {
      n: ["lungs"],
      u: "1fac1",
      a: "13.0"
    },
    {
      n: ["tooth"],
      u: "1f9b7",
      a: "11.0"
    },
    {
      n: ["bone"],
      u: "1f9b4",
      a: "11.0"
    },
    {
      n: ["eyes"],
      u: "1f440",
      a: "0.6"
    },
    {
      n: ["eye"],
      u: "1f441-fe0f",
      a: "0.7"
    },
    {
      n: ["tongue"],
      u: "1f445",
      a: "0.6"
    },
    {
      n: ["lips", "mouth"],
      u: "1f444",
      a: "0.6"
    },
    {
      n: ["biting lip"],
      u: "1fae6",
      a: "14.0"
    },
    {
      n: ["baby"],
      u: "1f476",
      v: ["1f476-1f3fb", "1f476-1f3fc", "1f476-1f3fd", "1f476-1f3fe", "1f476-1f3ff"],
      a: "0.6"
    },
    {
      n: ["child"],
      u: "1f9d2",
      v: ["1f9d2-1f3fb", "1f9d2-1f3fc", "1f9d2-1f3fd", "1f9d2-1f3fe", "1f9d2-1f3ff"],
      a: "5.0"
    },
    {
      n: ["boy"],
      u: "1f466",
      v: ["1f466-1f3fb", "1f466-1f3fc", "1f466-1f3fd", "1f466-1f3fe", "1f466-1f3ff"],
      a: "0.6"
    },
    {
      n: ["girl"],
      u: "1f467",
      v: ["1f467-1f3fb", "1f467-1f3fc", "1f467-1f3fd", "1f467-1f3fe", "1f467-1f3ff"],
      a: "0.6"
    },
    {
      n: ["adult"],
      u: "1f9d1",
      v: ["1f9d1-1f3fb", "1f9d1-1f3fc", "1f9d1-1f3fd", "1f9d1-1f3fe", "1f9d1-1f3ff"],
      a: "5.0"
    },
    {
      n: ["person with blond hair"],
      u: "1f471",
      v: ["1f471-1f3fb", "1f471-1f3fc", "1f471-1f3fd", "1f471-1f3fe", "1f471-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man"],
      u: "1f468",
      v: ["1f468-1f3fb", "1f468-1f3fc", "1f468-1f3fd", "1f468-1f3fe", "1f468-1f3ff"],
      a: "0.6"
    },
    {
      n: ["bearded person"],
      u: "1f9d4",
      v: ["1f9d4-1f3fb", "1f9d4-1f3fc", "1f9d4-1f3fd", "1f9d4-1f3fe", "1f9d4-1f3ff"],
      a: "5.0"
    },
    {
      n: ["man: beard", "man with beard"],
      u: "1f9d4-200d-2642-fe0f",
      v: [
        "1f9d4-1f3fb-200d-2642-fe0f",
        "1f9d4-1f3fc-200d-2642-fe0f",
        "1f9d4-1f3fd-200d-2642-fe0f",
        "1f9d4-1f3fe-200d-2642-fe0f",
        "1f9d4-1f3ff-200d-2642-fe0f"
      ],
      a: "13.1"
    },
    {
      n: ["woman: beard", "woman with beard"],
      u: "1f9d4-200d-2640-fe0f",
      v: [
        "1f9d4-1f3fb-200d-2640-fe0f",
        "1f9d4-1f3fc-200d-2640-fe0f",
        "1f9d4-1f3fd-200d-2640-fe0f",
        "1f9d4-1f3fe-200d-2640-fe0f",
        "1f9d4-1f3ff-200d-2640-fe0f"
      ],
      a: "13.1"
    },
    {
      n: ["man: red hair", "red haired man"],
      u: "1f468-200d-1f9b0",
      v: [
        "1f468-1f3fb-200d-1f9b0",
        "1f468-1f3fc-200d-1f9b0",
        "1f468-1f3fd-200d-1f9b0",
        "1f468-1f3fe-200d-1f9b0",
        "1f468-1f3ff-200d-1f9b0"
      ],
      a: "11.0"
    },
    {
      n: ["man: curly hair", "curly haired man"],
      u: "1f468-200d-1f9b1",
      v: [
        "1f468-1f3fb-200d-1f9b1",
        "1f468-1f3fc-200d-1f9b1",
        "1f468-1f3fd-200d-1f9b1",
        "1f468-1f3fe-200d-1f9b1",
        "1f468-1f3ff-200d-1f9b1"
      ],
      a: "11.0"
    },
    {
      n: ["man: white hair", "white haired man"],
      u: "1f468-200d-1f9b3",
      v: [
        "1f468-1f3fb-200d-1f9b3",
        "1f468-1f3fc-200d-1f9b3",
        "1f468-1f3fd-200d-1f9b3",
        "1f468-1f3fe-200d-1f9b3",
        "1f468-1f3ff-200d-1f9b3"
      ],
      a: "11.0"
    },
    {
      n: ["bald man", "man: bald"],
      u: "1f468-200d-1f9b2",
      v: [
        "1f468-1f3fb-200d-1f9b2",
        "1f468-1f3fc-200d-1f9b2",
        "1f468-1f3fd-200d-1f9b2",
        "1f468-1f3fe-200d-1f9b2",
        "1f468-1f3ff-200d-1f9b2"
      ],
      a: "11.0"
    },
    {
      n: ["woman"],
      u: "1f469",
      v: ["1f469-1f3fb", "1f469-1f3fc", "1f469-1f3fd", "1f469-1f3fe", "1f469-1f3ff"],
      a: "0.6"
    },
    {
      n: ["woman: red hair", "red haired woman"],
      u: "1f469-200d-1f9b0",
      v: [
        "1f469-1f3fb-200d-1f9b0",
        "1f469-1f3fc-200d-1f9b0",
        "1f469-1f3fd-200d-1f9b0",
        "1f469-1f3fe-200d-1f9b0",
        "1f469-1f3ff-200d-1f9b0"
      ],
      a: "11.0"
    },
    {
      n: ["person: red hair", "red haired person"],
      u: "1f9d1-200d-1f9b0",
      v: [
        "1f9d1-1f3fb-200d-1f9b0",
        "1f9d1-1f3fc-200d-1f9b0",
        "1f9d1-1f3fd-200d-1f9b0",
        "1f9d1-1f3fe-200d-1f9b0",
        "1f9d1-1f3ff-200d-1f9b0"
      ],
      a: "12.1"
    },
    {
      n: ["woman: curly hair", "curly haired woman"],
      u: "1f469-200d-1f9b1",
      v: [
        "1f469-1f3fb-200d-1f9b1",
        "1f469-1f3fc-200d-1f9b1",
        "1f469-1f3fd-200d-1f9b1",
        "1f469-1f3fe-200d-1f9b1",
        "1f469-1f3ff-200d-1f9b1"
      ],
      a: "11.0"
    },
    {
      n: ["person: curly hair", "curly haired person"],
      u: "1f9d1-200d-1f9b1",
      v: [
        "1f9d1-1f3fb-200d-1f9b1",
        "1f9d1-1f3fc-200d-1f9b1",
        "1f9d1-1f3fd-200d-1f9b1",
        "1f9d1-1f3fe-200d-1f9b1",
        "1f9d1-1f3ff-200d-1f9b1"
      ],
      a: "12.1"
    },
    {
      n: ["woman: white hair", "white haired woman"],
      u: "1f469-200d-1f9b3",
      v: [
        "1f469-1f3fb-200d-1f9b3",
        "1f469-1f3fc-200d-1f9b3",
        "1f469-1f3fd-200d-1f9b3",
        "1f469-1f3fe-200d-1f9b3",
        "1f469-1f3ff-200d-1f9b3"
      ],
      a: "11.0"
    },
    {
      n: ["person: white hair", "white haired person"],
      u: "1f9d1-200d-1f9b3",
      v: [
        "1f9d1-1f3fb-200d-1f9b3",
        "1f9d1-1f3fc-200d-1f9b3",
        "1f9d1-1f3fd-200d-1f9b3",
        "1f9d1-1f3fe-200d-1f9b3",
        "1f9d1-1f3ff-200d-1f9b3"
      ],
      a: "12.1"
    },
    {
      n: ["bald woman", "woman: bald"],
      u: "1f469-200d-1f9b2",
      v: [
        "1f469-1f3fb-200d-1f9b2",
        "1f469-1f3fc-200d-1f9b2",
        "1f469-1f3fd-200d-1f9b2",
        "1f469-1f3fe-200d-1f9b2",
        "1f469-1f3ff-200d-1f9b2"
      ],
      a: "11.0"
    },
    {
      n: ["bald person", "person: bald"],
      u: "1f9d1-200d-1f9b2",
      v: [
        "1f9d1-1f3fb-200d-1f9b2",
        "1f9d1-1f3fc-200d-1f9b2",
        "1f9d1-1f3fd-200d-1f9b2",
        "1f9d1-1f3fe-200d-1f9b2",
        "1f9d1-1f3ff-200d-1f9b2"
      ],
      a: "12.1"
    },
    {
      n: ["woman: blond hair", "blond-haired-woman"],
      u: "1f471-200d-2640-fe0f",
      v: [
        "1f471-1f3fb-200d-2640-fe0f",
        "1f471-1f3fc-200d-2640-fe0f",
        "1f471-1f3fd-200d-2640-fe0f",
        "1f471-1f3fe-200d-2640-fe0f",
        "1f471-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["man: blond hair", "blond-haired-man"],
      u: "1f471-200d-2642-fe0f",
      v: [
        "1f471-1f3fb-200d-2642-fe0f",
        "1f471-1f3fc-200d-2642-fe0f",
        "1f471-1f3fd-200d-2642-fe0f",
        "1f471-1f3fe-200d-2642-fe0f",
        "1f471-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["older adult"],
      u: "1f9d3",
      v: ["1f9d3-1f3fb", "1f9d3-1f3fc", "1f9d3-1f3fd", "1f9d3-1f3fe", "1f9d3-1f3ff"],
      a: "5.0"
    },
    {
      n: ["older man"],
      u: "1f474",
      v: ["1f474-1f3fb", "1f474-1f3fc", "1f474-1f3fd", "1f474-1f3fe", "1f474-1f3ff"],
      a: "0.6"
    },
    {
      n: ["older woman"],
      u: "1f475",
      v: ["1f475-1f3fb", "1f475-1f3fc", "1f475-1f3fd", "1f475-1f3fe", "1f475-1f3ff"],
      a: "0.6"
    },
    {
      n: ["person frowning"],
      u: "1f64d",
      v: ["1f64d-1f3fb", "1f64d-1f3fc", "1f64d-1f3fd", "1f64d-1f3fe", "1f64d-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man frowning", "man-frowning"],
      u: "1f64d-200d-2642-fe0f",
      v: [
        "1f64d-1f3fb-200d-2642-fe0f",
        "1f64d-1f3fc-200d-2642-fe0f",
        "1f64d-1f3fd-200d-2642-fe0f",
        "1f64d-1f3fe-200d-2642-fe0f",
        "1f64d-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman frowning", "woman-frowning"],
      u: "1f64d-200d-2640-fe0f",
      v: [
        "1f64d-1f3fb-200d-2640-fe0f",
        "1f64d-1f3fc-200d-2640-fe0f",
        "1f64d-1f3fd-200d-2640-fe0f",
        "1f64d-1f3fe-200d-2640-fe0f",
        "1f64d-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["person with pouting face"],
      u: "1f64e",
      v: ["1f64e-1f3fb", "1f64e-1f3fc", "1f64e-1f3fd", "1f64e-1f3fe", "1f64e-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man pouting", "man-pouting"],
      u: "1f64e-200d-2642-fe0f",
      v: [
        "1f64e-1f3fb-200d-2642-fe0f",
        "1f64e-1f3fc-200d-2642-fe0f",
        "1f64e-1f3fd-200d-2642-fe0f",
        "1f64e-1f3fe-200d-2642-fe0f",
        "1f64e-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman pouting", "woman-pouting"],
      u: "1f64e-200d-2640-fe0f",
      v: [
        "1f64e-1f3fb-200d-2640-fe0f",
        "1f64e-1f3fc-200d-2640-fe0f",
        "1f64e-1f3fd-200d-2640-fe0f",
        "1f64e-1f3fe-200d-2640-fe0f",
        "1f64e-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["no good", "face with no good gesture"],
      u: "1f645",
      v: ["1f645-1f3fb", "1f645-1f3fc", "1f645-1f3fd", "1f645-1f3fe", "1f645-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man gesturing no", "man-gesturing-no"],
      u: "1f645-200d-2642-fe0f",
      v: [
        "1f645-1f3fb-200d-2642-fe0f",
        "1f645-1f3fc-200d-2642-fe0f",
        "1f645-1f3fd-200d-2642-fe0f",
        "1f645-1f3fe-200d-2642-fe0f",
        "1f645-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman gesturing no", "woman-gesturing-no"],
      u: "1f645-200d-2640-fe0f",
      v: [
        "1f645-1f3fb-200d-2640-fe0f",
        "1f645-1f3fc-200d-2640-fe0f",
        "1f645-1f3fd-200d-2640-fe0f",
        "1f645-1f3fe-200d-2640-fe0f",
        "1f645-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["ok woman", "face with ok gesture"],
      u: "1f646",
      v: ["1f646-1f3fb", "1f646-1f3fc", "1f646-1f3fd", "1f646-1f3fe", "1f646-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man gesturing ok", "man-gesturing-ok"],
      u: "1f646-200d-2642-fe0f",
      v: [
        "1f646-1f3fb-200d-2642-fe0f",
        "1f646-1f3fc-200d-2642-fe0f",
        "1f646-1f3fd-200d-2642-fe0f",
        "1f646-1f3fe-200d-2642-fe0f",
        "1f646-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman gesturing ok", "woman-gesturing-ok"],
      u: "1f646-200d-2640-fe0f",
      v: [
        "1f646-1f3fb-200d-2640-fe0f",
        "1f646-1f3fc-200d-2640-fe0f",
        "1f646-1f3fd-200d-2640-fe0f",
        "1f646-1f3fe-200d-2640-fe0f",
        "1f646-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["information desk person"],
      u: "1f481",
      v: ["1f481-1f3fb", "1f481-1f3fc", "1f481-1f3fd", "1f481-1f3fe", "1f481-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man tipping hand", "man-tipping-hand"],
      u: "1f481-200d-2642-fe0f",
      v: [
        "1f481-1f3fb-200d-2642-fe0f",
        "1f481-1f3fc-200d-2642-fe0f",
        "1f481-1f3fd-200d-2642-fe0f",
        "1f481-1f3fe-200d-2642-fe0f",
        "1f481-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman tipping hand", "woman-tipping-hand"],
      u: "1f481-200d-2640-fe0f",
      v: [
        "1f481-1f3fb-200d-2640-fe0f",
        "1f481-1f3fc-200d-2640-fe0f",
        "1f481-1f3fd-200d-2640-fe0f",
        "1f481-1f3fe-200d-2640-fe0f",
        "1f481-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["raising hand", "happy person raising one hand"],
      u: "1f64b",
      v: ["1f64b-1f3fb", "1f64b-1f3fc", "1f64b-1f3fd", "1f64b-1f3fe", "1f64b-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man raising hand", "man-raising-hand"],
      u: "1f64b-200d-2642-fe0f",
      v: [
        "1f64b-1f3fb-200d-2642-fe0f",
        "1f64b-1f3fc-200d-2642-fe0f",
        "1f64b-1f3fd-200d-2642-fe0f",
        "1f64b-1f3fe-200d-2642-fe0f",
        "1f64b-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman raising hand", "woman-raising-hand"],
      u: "1f64b-200d-2640-fe0f",
      v: [
        "1f64b-1f3fb-200d-2640-fe0f",
        "1f64b-1f3fc-200d-2640-fe0f",
        "1f64b-1f3fd-200d-2640-fe0f",
        "1f64b-1f3fe-200d-2640-fe0f",
        "1f64b-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["deaf person"],
      u: "1f9cf",
      v: ["1f9cf-1f3fb", "1f9cf-1f3fc", "1f9cf-1f3fd", "1f9cf-1f3fe", "1f9cf-1f3ff"],
      a: "12.0"
    },
    {
      n: ["deaf man"],
      u: "1f9cf-200d-2642-fe0f",
      v: [
        "1f9cf-1f3fb-200d-2642-fe0f",
        "1f9cf-1f3fc-200d-2642-fe0f",
        "1f9cf-1f3fd-200d-2642-fe0f",
        "1f9cf-1f3fe-200d-2642-fe0f",
        "1f9cf-1f3ff-200d-2642-fe0f"
      ],
      a: "12.0"
    },
    {
      n: ["deaf woman"],
      u: "1f9cf-200d-2640-fe0f",
      v: [
        "1f9cf-1f3fb-200d-2640-fe0f",
        "1f9cf-1f3fc-200d-2640-fe0f",
        "1f9cf-1f3fd-200d-2640-fe0f",
        "1f9cf-1f3fe-200d-2640-fe0f",
        "1f9cf-1f3ff-200d-2640-fe0f"
      ],
      a: "12.0"
    },
    {
      n: ["bow", "person bowing deeply"],
      u: "1f647",
      v: ["1f647-1f3fb", "1f647-1f3fc", "1f647-1f3fd", "1f647-1f3fe", "1f647-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man bowing", "man-bowing"],
      u: "1f647-200d-2642-fe0f",
      v: [
        "1f647-1f3fb-200d-2642-fe0f",
        "1f647-1f3fc-200d-2642-fe0f",
        "1f647-1f3fd-200d-2642-fe0f",
        "1f647-1f3fe-200d-2642-fe0f",
        "1f647-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman bowing", "woman-bowing"],
      u: "1f647-200d-2640-fe0f",
      v: [
        "1f647-1f3fb-200d-2640-fe0f",
        "1f647-1f3fc-200d-2640-fe0f",
        "1f647-1f3fd-200d-2640-fe0f",
        "1f647-1f3fe-200d-2640-fe0f",
        "1f647-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["face palm"],
      u: "1f926",
      v: ["1f926-1f3fb", "1f926-1f3fc", "1f926-1f3fd", "1f926-1f3fe", "1f926-1f3ff"],
      a: "3.0"
    },
    {
      n: ["man facepalming", "man-facepalming"],
      u: "1f926-200d-2642-fe0f",
      v: [
        "1f926-1f3fb-200d-2642-fe0f",
        "1f926-1f3fc-200d-2642-fe0f",
        "1f926-1f3fd-200d-2642-fe0f",
        "1f926-1f3fe-200d-2642-fe0f",
        "1f926-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman facepalming", "woman-facepalming"],
      u: "1f926-200d-2640-fe0f",
      v: [
        "1f926-1f3fb-200d-2640-fe0f",
        "1f926-1f3fc-200d-2640-fe0f",
        "1f926-1f3fd-200d-2640-fe0f",
        "1f926-1f3fe-200d-2640-fe0f",
        "1f926-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["shrug"],
      u: "1f937",
      v: ["1f937-1f3fb", "1f937-1f3fc", "1f937-1f3fd", "1f937-1f3fe", "1f937-1f3ff"],
      a: "3.0"
    },
    {
      n: ["man shrugging", "man-shrugging"],
      u: "1f937-200d-2642-fe0f",
      v: [
        "1f937-1f3fb-200d-2642-fe0f",
        "1f937-1f3fc-200d-2642-fe0f",
        "1f937-1f3fd-200d-2642-fe0f",
        "1f937-1f3fe-200d-2642-fe0f",
        "1f937-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman shrugging", "woman-shrugging"],
      u: "1f937-200d-2640-fe0f",
      v: [
        "1f937-1f3fb-200d-2640-fe0f",
        "1f937-1f3fc-200d-2640-fe0f",
        "1f937-1f3fd-200d-2640-fe0f",
        "1f937-1f3fe-200d-2640-fe0f",
        "1f937-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["health worker"],
      u: "1f9d1-200d-2695-fe0f",
      v: [
        "1f9d1-1f3fb-200d-2695-fe0f",
        "1f9d1-1f3fc-200d-2695-fe0f",
        "1f9d1-1f3fd-200d-2695-fe0f",
        "1f9d1-1f3fe-200d-2695-fe0f",
        "1f9d1-1f3ff-200d-2695-fe0f"
      ],
      a: "12.1"
    },
    {
      n: ["male-doctor", "man health worker"],
      u: "1f468-200d-2695-fe0f",
      v: [
        "1f468-1f3fb-200d-2695-fe0f",
        "1f468-1f3fc-200d-2695-fe0f",
        "1f468-1f3fd-200d-2695-fe0f",
        "1f468-1f3fe-200d-2695-fe0f",
        "1f468-1f3ff-200d-2695-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["female-doctor", "woman health worker"],
      u: "1f469-200d-2695-fe0f",
      v: [
        "1f469-1f3fb-200d-2695-fe0f",
        "1f469-1f3fc-200d-2695-fe0f",
        "1f469-1f3fd-200d-2695-fe0f",
        "1f469-1f3fe-200d-2695-fe0f",
        "1f469-1f3ff-200d-2695-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["student"],
      u: "1f9d1-200d-1f393",
      v: [
        "1f9d1-1f3fb-200d-1f393",
        "1f9d1-1f3fc-200d-1f393",
        "1f9d1-1f3fd-200d-1f393",
        "1f9d1-1f3fe-200d-1f393",
        "1f9d1-1f3ff-200d-1f393"
      ],
      a: "12.1"
    },
    {
      n: ["man student", "male-student"],
      u: "1f468-200d-1f393",
      v: [
        "1f468-1f3fb-200d-1f393",
        "1f468-1f3fc-200d-1f393",
        "1f468-1f3fd-200d-1f393",
        "1f468-1f3fe-200d-1f393",
        "1f468-1f3ff-200d-1f393"
      ],
      a: "4.0"
    },
    {
      n: ["woman student", "female-student"],
      u: "1f469-200d-1f393",
      v: [
        "1f469-1f3fb-200d-1f393",
        "1f469-1f3fc-200d-1f393",
        "1f469-1f3fd-200d-1f393",
        "1f469-1f3fe-200d-1f393",
        "1f469-1f3ff-200d-1f393"
      ],
      a: "4.0"
    },
    {
      n: ["teacher"],
      u: "1f9d1-200d-1f3eb",
      v: [
        "1f9d1-1f3fb-200d-1f3eb",
        "1f9d1-1f3fc-200d-1f3eb",
        "1f9d1-1f3fd-200d-1f3eb",
        "1f9d1-1f3fe-200d-1f3eb",
        "1f9d1-1f3ff-200d-1f3eb"
      ],
      a: "12.1"
    },
    {
      n: ["man teacher", "male-teacher"],
      u: "1f468-200d-1f3eb",
      v: [
        "1f468-1f3fb-200d-1f3eb",
        "1f468-1f3fc-200d-1f3eb",
        "1f468-1f3fd-200d-1f3eb",
        "1f468-1f3fe-200d-1f3eb",
        "1f468-1f3ff-200d-1f3eb"
      ],
      a: "4.0"
    },
    {
      n: ["woman teacher", "female-teacher"],
      u: "1f469-200d-1f3eb",
      v: [
        "1f469-1f3fb-200d-1f3eb",
        "1f469-1f3fc-200d-1f3eb",
        "1f469-1f3fd-200d-1f3eb",
        "1f469-1f3fe-200d-1f3eb",
        "1f469-1f3ff-200d-1f3eb"
      ],
      a: "4.0"
    },
    {
      n: ["judge"],
      u: "1f9d1-200d-2696-fe0f",
      v: [
        "1f9d1-1f3fb-200d-2696-fe0f",
        "1f9d1-1f3fc-200d-2696-fe0f",
        "1f9d1-1f3fd-200d-2696-fe0f",
        "1f9d1-1f3fe-200d-2696-fe0f",
        "1f9d1-1f3ff-200d-2696-fe0f"
      ],
      a: "12.1"
    },
    {
      n: ["man judge", "male-judge"],
      u: "1f468-200d-2696-fe0f",
      v: [
        "1f468-1f3fb-200d-2696-fe0f",
        "1f468-1f3fc-200d-2696-fe0f",
        "1f468-1f3fd-200d-2696-fe0f",
        "1f468-1f3fe-200d-2696-fe0f",
        "1f468-1f3ff-200d-2696-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman judge", "female-judge"],
      u: "1f469-200d-2696-fe0f",
      v: [
        "1f469-1f3fb-200d-2696-fe0f",
        "1f469-1f3fc-200d-2696-fe0f",
        "1f469-1f3fd-200d-2696-fe0f",
        "1f469-1f3fe-200d-2696-fe0f",
        "1f469-1f3ff-200d-2696-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["farmer"],
      u: "1f9d1-200d-1f33e",
      v: [
        "1f9d1-1f3fb-200d-1f33e",
        "1f9d1-1f3fc-200d-1f33e",
        "1f9d1-1f3fd-200d-1f33e",
        "1f9d1-1f3fe-200d-1f33e",
        "1f9d1-1f3ff-200d-1f33e"
      ],
      a: "12.1"
    },
    {
      n: ["man farmer", "male-farmer"],
      u: "1f468-200d-1f33e",
      v: [
        "1f468-1f3fb-200d-1f33e",
        "1f468-1f3fc-200d-1f33e",
        "1f468-1f3fd-200d-1f33e",
        "1f468-1f3fe-200d-1f33e",
        "1f468-1f3ff-200d-1f33e"
      ],
      a: "4.0"
    },
    {
      n: ["woman farmer", "female-farmer"],
      u: "1f469-200d-1f33e",
      v: [
        "1f469-1f3fb-200d-1f33e",
        "1f469-1f3fc-200d-1f33e",
        "1f469-1f3fd-200d-1f33e",
        "1f469-1f3fe-200d-1f33e",
        "1f469-1f3ff-200d-1f33e"
      ],
      a: "4.0"
    },
    {
      n: ["cook"],
      u: "1f9d1-200d-1f373",
      v: [
        "1f9d1-1f3fb-200d-1f373",
        "1f9d1-1f3fc-200d-1f373",
        "1f9d1-1f3fd-200d-1f373",
        "1f9d1-1f3fe-200d-1f373",
        "1f9d1-1f3ff-200d-1f373"
      ],
      a: "12.1"
    },
    {
      n: ["man cook", "male-cook"],
      u: "1f468-200d-1f373",
      v: [
        "1f468-1f3fb-200d-1f373",
        "1f468-1f3fc-200d-1f373",
        "1f468-1f3fd-200d-1f373",
        "1f468-1f3fe-200d-1f373",
        "1f468-1f3ff-200d-1f373"
      ],
      a: "4.0"
    },
    {
      n: ["woman cook", "female-cook"],
      u: "1f469-200d-1f373",
      v: [
        "1f469-1f3fb-200d-1f373",
        "1f469-1f3fc-200d-1f373",
        "1f469-1f3fd-200d-1f373",
        "1f469-1f3fe-200d-1f373",
        "1f469-1f3ff-200d-1f373"
      ],
      a: "4.0"
    },
    {
      n: ["mechanic"],
      u: "1f9d1-200d-1f527",
      v: [
        "1f9d1-1f3fb-200d-1f527",
        "1f9d1-1f3fc-200d-1f527",
        "1f9d1-1f3fd-200d-1f527",
        "1f9d1-1f3fe-200d-1f527",
        "1f9d1-1f3ff-200d-1f527"
      ],
      a: "12.1"
    },
    {
      n: ["man mechanic", "male-mechanic"],
      u: "1f468-200d-1f527",
      v: [
        "1f468-1f3fb-200d-1f527",
        "1f468-1f3fc-200d-1f527",
        "1f468-1f3fd-200d-1f527",
        "1f468-1f3fe-200d-1f527",
        "1f468-1f3ff-200d-1f527"
      ],
      a: "4.0"
    },
    {
      n: ["woman mechanic", "female-mechanic"],
      u: "1f469-200d-1f527",
      v: [
        "1f469-1f3fb-200d-1f527",
        "1f469-1f3fc-200d-1f527",
        "1f469-1f3fd-200d-1f527",
        "1f469-1f3fe-200d-1f527",
        "1f469-1f3ff-200d-1f527"
      ],
      a: "4.0"
    },
    {
      n: ["factory worker"],
      u: "1f9d1-200d-1f3ed",
      v: [
        "1f9d1-1f3fb-200d-1f3ed",
        "1f9d1-1f3fc-200d-1f3ed",
        "1f9d1-1f3fd-200d-1f3ed",
        "1f9d1-1f3fe-200d-1f3ed",
        "1f9d1-1f3ff-200d-1f3ed"
      ],
      a: "12.1"
    },
    {
      n: ["man factory worker", "male-factory-worker"],
      u: "1f468-200d-1f3ed",
      v: [
        "1f468-1f3fb-200d-1f3ed",
        "1f468-1f3fc-200d-1f3ed",
        "1f468-1f3fd-200d-1f3ed",
        "1f468-1f3fe-200d-1f3ed",
        "1f468-1f3ff-200d-1f3ed"
      ],
      a: "4.0"
    },
    {
      n: ["woman factory worker", "female-factory-worker"],
      u: "1f469-200d-1f3ed",
      v: [
        "1f469-1f3fb-200d-1f3ed",
        "1f469-1f3fc-200d-1f3ed",
        "1f469-1f3fd-200d-1f3ed",
        "1f469-1f3fe-200d-1f3ed",
        "1f469-1f3ff-200d-1f3ed"
      ],
      a: "4.0"
    },
    {
      n: ["office worker"],
      u: "1f9d1-200d-1f4bc",
      v: [
        "1f9d1-1f3fb-200d-1f4bc",
        "1f9d1-1f3fc-200d-1f4bc",
        "1f9d1-1f3fd-200d-1f4bc",
        "1f9d1-1f3fe-200d-1f4bc",
        "1f9d1-1f3ff-200d-1f4bc"
      ],
      a: "12.1"
    },
    {
      n: ["man office worker", "male-office-worker"],
      u: "1f468-200d-1f4bc",
      v: [
        "1f468-1f3fb-200d-1f4bc",
        "1f468-1f3fc-200d-1f4bc",
        "1f468-1f3fd-200d-1f4bc",
        "1f468-1f3fe-200d-1f4bc",
        "1f468-1f3ff-200d-1f4bc"
      ],
      a: "4.0"
    },
    {
      n: ["woman office worker", "female-office-worker"],
      u: "1f469-200d-1f4bc",
      v: [
        "1f469-1f3fb-200d-1f4bc",
        "1f469-1f3fc-200d-1f4bc",
        "1f469-1f3fd-200d-1f4bc",
        "1f469-1f3fe-200d-1f4bc",
        "1f469-1f3ff-200d-1f4bc"
      ],
      a: "4.0"
    },
    {
      n: ["scientist"],
      u: "1f9d1-200d-1f52c",
      v: [
        "1f9d1-1f3fb-200d-1f52c",
        "1f9d1-1f3fc-200d-1f52c",
        "1f9d1-1f3fd-200d-1f52c",
        "1f9d1-1f3fe-200d-1f52c",
        "1f9d1-1f3ff-200d-1f52c"
      ],
      a: "12.1"
    },
    {
      n: ["man scientist", "male-scientist"],
      u: "1f468-200d-1f52c",
      v: [
        "1f468-1f3fb-200d-1f52c",
        "1f468-1f3fc-200d-1f52c",
        "1f468-1f3fd-200d-1f52c",
        "1f468-1f3fe-200d-1f52c",
        "1f468-1f3ff-200d-1f52c"
      ],
      a: "4.0"
    },
    {
      n: ["woman scientist", "female-scientist"],
      u: "1f469-200d-1f52c",
      v: [
        "1f469-1f3fb-200d-1f52c",
        "1f469-1f3fc-200d-1f52c",
        "1f469-1f3fd-200d-1f52c",
        "1f469-1f3fe-200d-1f52c",
        "1f469-1f3ff-200d-1f52c"
      ],
      a: "4.0"
    },
    {
      n: ["technologist"],
      u: "1f9d1-200d-1f4bb",
      v: [
        "1f9d1-1f3fb-200d-1f4bb",
        "1f9d1-1f3fc-200d-1f4bb",
        "1f9d1-1f3fd-200d-1f4bb",
        "1f9d1-1f3fe-200d-1f4bb",
        "1f9d1-1f3ff-200d-1f4bb"
      ],
      a: "12.1"
    },
    {
      n: ["man technologist", "male-technologist"],
      u: "1f468-200d-1f4bb",
      v: [
        "1f468-1f3fb-200d-1f4bb",
        "1f468-1f3fc-200d-1f4bb",
        "1f468-1f3fd-200d-1f4bb",
        "1f468-1f3fe-200d-1f4bb",
        "1f468-1f3ff-200d-1f4bb"
      ],
      a: "4.0"
    },
    {
      n: ["woman technologist", "female-technologist"],
      u: "1f469-200d-1f4bb",
      v: [
        "1f469-1f3fb-200d-1f4bb",
        "1f469-1f3fc-200d-1f4bb",
        "1f469-1f3fd-200d-1f4bb",
        "1f469-1f3fe-200d-1f4bb",
        "1f469-1f3ff-200d-1f4bb"
      ],
      a: "4.0"
    },
    {
      n: ["singer"],
      u: "1f9d1-200d-1f3a4",
      v: [
        "1f9d1-1f3fb-200d-1f3a4",
        "1f9d1-1f3fc-200d-1f3a4",
        "1f9d1-1f3fd-200d-1f3a4",
        "1f9d1-1f3fe-200d-1f3a4",
        "1f9d1-1f3ff-200d-1f3a4"
      ],
      a: "12.1"
    },
    {
      n: ["man singer", "male-singer"],
      u: "1f468-200d-1f3a4",
      v: [
        "1f468-1f3fb-200d-1f3a4",
        "1f468-1f3fc-200d-1f3a4",
        "1f468-1f3fd-200d-1f3a4",
        "1f468-1f3fe-200d-1f3a4",
        "1f468-1f3ff-200d-1f3a4"
      ],
      a: "4.0"
    },
    {
      n: ["woman singer", "female-singer"],
      u: "1f469-200d-1f3a4",
      v: [
        "1f469-1f3fb-200d-1f3a4",
        "1f469-1f3fc-200d-1f3a4",
        "1f469-1f3fd-200d-1f3a4",
        "1f469-1f3fe-200d-1f3a4",
        "1f469-1f3ff-200d-1f3a4"
      ],
      a: "4.0"
    },
    {
      n: ["artist"],
      u: "1f9d1-200d-1f3a8",
      v: [
        "1f9d1-1f3fb-200d-1f3a8",
        "1f9d1-1f3fc-200d-1f3a8",
        "1f9d1-1f3fd-200d-1f3a8",
        "1f9d1-1f3fe-200d-1f3a8",
        "1f9d1-1f3ff-200d-1f3a8"
      ],
      a: "12.1"
    },
    {
      n: ["man artist", "male-artist"],
      u: "1f468-200d-1f3a8",
      v: [
        "1f468-1f3fb-200d-1f3a8",
        "1f468-1f3fc-200d-1f3a8",
        "1f468-1f3fd-200d-1f3a8",
        "1f468-1f3fe-200d-1f3a8",
        "1f468-1f3ff-200d-1f3a8"
      ],
      a: "4.0"
    },
    {
      n: ["woman artist", "female-artist"],
      u: "1f469-200d-1f3a8",
      v: [
        "1f469-1f3fb-200d-1f3a8",
        "1f469-1f3fc-200d-1f3a8",
        "1f469-1f3fd-200d-1f3a8",
        "1f469-1f3fe-200d-1f3a8",
        "1f469-1f3ff-200d-1f3a8"
      ],
      a: "4.0"
    },
    {
      n: ["pilot"],
      u: "1f9d1-200d-2708-fe0f",
      v: [
        "1f9d1-1f3fb-200d-2708-fe0f",
        "1f9d1-1f3fc-200d-2708-fe0f",
        "1f9d1-1f3fd-200d-2708-fe0f",
        "1f9d1-1f3fe-200d-2708-fe0f",
        "1f9d1-1f3ff-200d-2708-fe0f"
      ],
      a: "12.1"
    },
    {
      n: ["man pilot", "male-pilot"],
      u: "1f468-200d-2708-fe0f",
      v: [
        "1f468-1f3fb-200d-2708-fe0f",
        "1f468-1f3fc-200d-2708-fe0f",
        "1f468-1f3fd-200d-2708-fe0f",
        "1f468-1f3fe-200d-2708-fe0f",
        "1f468-1f3ff-200d-2708-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman pilot", "female-pilot"],
      u: "1f469-200d-2708-fe0f",
      v: [
        "1f469-1f3fb-200d-2708-fe0f",
        "1f469-1f3fc-200d-2708-fe0f",
        "1f469-1f3fd-200d-2708-fe0f",
        "1f469-1f3fe-200d-2708-fe0f",
        "1f469-1f3ff-200d-2708-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["astronaut"],
      u: "1f9d1-200d-1f680",
      v: [
        "1f9d1-1f3fb-200d-1f680",
        "1f9d1-1f3fc-200d-1f680",
        "1f9d1-1f3fd-200d-1f680",
        "1f9d1-1f3fe-200d-1f680",
        "1f9d1-1f3ff-200d-1f680"
      ],
      a: "12.1"
    },
    {
      n: ["man astronaut", "male-astronaut"],
      u: "1f468-200d-1f680",
      v: [
        "1f468-1f3fb-200d-1f680",
        "1f468-1f3fc-200d-1f680",
        "1f468-1f3fd-200d-1f680",
        "1f468-1f3fe-200d-1f680",
        "1f468-1f3ff-200d-1f680"
      ],
      a: "4.0"
    },
    {
      n: ["woman astronaut", "female-astronaut"],
      u: "1f469-200d-1f680",
      v: [
        "1f469-1f3fb-200d-1f680",
        "1f469-1f3fc-200d-1f680",
        "1f469-1f3fd-200d-1f680",
        "1f469-1f3fe-200d-1f680",
        "1f469-1f3ff-200d-1f680"
      ],
      a: "4.0"
    },
    {
      n: ["firefighter"],
      u: "1f9d1-200d-1f692",
      v: [
        "1f9d1-1f3fb-200d-1f692",
        "1f9d1-1f3fc-200d-1f692",
        "1f9d1-1f3fd-200d-1f692",
        "1f9d1-1f3fe-200d-1f692",
        "1f9d1-1f3ff-200d-1f692"
      ],
      a: "12.1"
    },
    {
      n: ["man firefighter", "male-firefighter"],
      u: "1f468-200d-1f692",
      v: [
        "1f468-1f3fb-200d-1f692",
        "1f468-1f3fc-200d-1f692",
        "1f468-1f3fd-200d-1f692",
        "1f468-1f3fe-200d-1f692",
        "1f468-1f3ff-200d-1f692"
      ],
      a: "4.0"
    },
    {
      n: ["woman firefighter", "female-firefighter"],
      u: "1f469-200d-1f692",
      v: [
        "1f469-1f3fb-200d-1f692",
        "1f469-1f3fc-200d-1f692",
        "1f469-1f3fd-200d-1f692",
        "1f469-1f3fe-200d-1f692",
        "1f469-1f3ff-200d-1f692"
      ],
      a: "4.0"
    },
    {
      n: ["cop", "police officer"],
      u: "1f46e",
      v: ["1f46e-1f3fb", "1f46e-1f3fc", "1f46e-1f3fd", "1f46e-1f3fe", "1f46e-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man police officer", "male-police-officer"],
      u: "1f46e-200d-2642-fe0f",
      v: [
        "1f46e-1f3fb-200d-2642-fe0f",
        "1f46e-1f3fc-200d-2642-fe0f",
        "1f46e-1f3fd-200d-2642-fe0f",
        "1f46e-1f3fe-200d-2642-fe0f",
        "1f46e-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman police officer", "female-police-officer"],
      u: "1f46e-200d-2640-fe0f",
      v: [
        "1f46e-1f3fb-200d-2640-fe0f",
        "1f46e-1f3fc-200d-2640-fe0f",
        "1f46e-1f3fd-200d-2640-fe0f",
        "1f46e-1f3fe-200d-2640-fe0f",
        "1f46e-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["detective", "sleuth or spy"],
      u: "1f575-fe0f",
      v: ["1f575-1f3fb", "1f575-1f3fc", "1f575-1f3fd", "1f575-1f3fe", "1f575-1f3ff"],
      a: "0.7"
    },
    {
      n: ["man detective", "male-detective"],
      u: "1f575-fe0f-200d-2642-fe0f",
      v: [
        "1f575-1f3fb-200d-2642-fe0f",
        "1f575-1f3fc-200d-2642-fe0f",
        "1f575-1f3fd-200d-2642-fe0f",
        "1f575-1f3fe-200d-2642-fe0f",
        "1f575-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman detective", "female-detective"],
      u: "1f575-fe0f-200d-2640-fe0f",
      v: [
        "1f575-1f3fb-200d-2640-fe0f",
        "1f575-1f3fc-200d-2640-fe0f",
        "1f575-1f3fd-200d-2640-fe0f",
        "1f575-1f3fe-200d-2640-fe0f",
        "1f575-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["guardsman"],
      u: "1f482",
      v: ["1f482-1f3fb", "1f482-1f3fc", "1f482-1f3fd", "1f482-1f3fe", "1f482-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man guard", "male-guard"],
      u: "1f482-200d-2642-fe0f",
      v: [
        "1f482-1f3fb-200d-2642-fe0f",
        "1f482-1f3fc-200d-2642-fe0f",
        "1f482-1f3fd-200d-2642-fe0f",
        "1f482-1f3fe-200d-2642-fe0f",
        "1f482-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman guard", "female-guard"],
      u: "1f482-200d-2640-fe0f",
      v: [
        "1f482-1f3fb-200d-2640-fe0f",
        "1f482-1f3fc-200d-2640-fe0f",
        "1f482-1f3fd-200d-2640-fe0f",
        "1f482-1f3fe-200d-2640-fe0f",
        "1f482-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["ninja"],
      u: "1f977",
      v: ["1f977-1f3fb", "1f977-1f3fc", "1f977-1f3fd", "1f977-1f3fe", "1f977-1f3ff"],
      a: "13.0"
    },
    {
      n: ["construction worker"],
      u: "1f477",
      v: ["1f477-1f3fb", "1f477-1f3fc", "1f477-1f3fd", "1f477-1f3fe", "1f477-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man construction worker", "male-construction-worker"],
      u: "1f477-200d-2642-fe0f",
      v: [
        "1f477-1f3fb-200d-2642-fe0f",
        "1f477-1f3fc-200d-2642-fe0f",
        "1f477-1f3fd-200d-2642-fe0f",
        "1f477-1f3fe-200d-2642-fe0f",
        "1f477-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman construction worker", "female-construction-worker"],
      u: "1f477-200d-2640-fe0f",
      v: [
        "1f477-1f3fb-200d-2640-fe0f",
        "1f477-1f3fc-200d-2640-fe0f",
        "1f477-1f3fd-200d-2640-fe0f",
        "1f477-1f3fe-200d-2640-fe0f",
        "1f477-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["person with crown"],
      u: "1fac5",
      v: ["1fac5-1f3fb", "1fac5-1f3fc", "1fac5-1f3fd", "1fac5-1f3fe", "1fac5-1f3ff"],
      a: "14.0"
    },
    {
      n: ["prince"],
      u: "1f934",
      v: ["1f934-1f3fb", "1f934-1f3fc", "1f934-1f3fd", "1f934-1f3fe", "1f934-1f3ff"],
      a: "3.0"
    },
    {
      n: ["princess"],
      u: "1f478",
      v: ["1f478-1f3fb", "1f478-1f3fc", "1f478-1f3fd", "1f478-1f3fe", "1f478-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man with turban"],
      u: "1f473",
      v: ["1f473-1f3fb", "1f473-1f3fc", "1f473-1f3fd", "1f473-1f3fe", "1f473-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man wearing turban", "man-wearing-turban"],
      u: "1f473-200d-2642-fe0f",
      v: [
        "1f473-1f3fb-200d-2642-fe0f",
        "1f473-1f3fc-200d-2642-fe0f",
        "1f473-1f3fd-200d-2642-fe0f",
        "1f473-1f3fe-200d-2642-fe0f",
        "1f473-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman wearing turban", "woman-wearing-turban"],
      u: "1f473-200d-2640-fe0f",
      v: [
        "1f473-1f3fb-200d-2640-fe0f",
        "1f473-1f3fc-200d-2640-fe0f",
        "1f473-1f3fd-200d-2640-fe0f",
        "1f473-1f3fe-200d-2640-fe0f",
        "1f473-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["man with gua pi mao"],
      u: "1f472",
      v: ["1f472-1f3fb", "1f472-1f3fc", "1f472-1f3fd", "1f472-1f3fe", "1f472-1f3ff"],
      a: "0.6"
    },
    {
      n: ["person with headscarf"],
      u: "1f9d5",
      v: ["1f9d5-1f3fb", "1f9d5-1f3fc", "1f9d5-1f3fd", "1f9d5-1f3fe", "1f9d5-1f3ff"],
      a: "5.0"
    },
    {
      n: ["man in tuxedo", "person in tuxedo"],
      u: "1f935",
      v: ["1f935-1f3fb", "1f935-1f3fc", "1f935-1f3fd", "1f935-1f3fe", "1f935-1f3ff"],
      a: "3.0"
    },
    {
      n: ["man in tuxedo"],
      u: "1f935-200d-2642-fe0f",
      v: [
        "1f935-1f3fb-200d-2642-fe0f",
        "1f935-1f3fc-200d-2642-fe0f",
        "1f935-1f3fd-200d-2642-fe0f",
        "1f935-1f3fe-200d-2642-fe0f",
        "1f935-1f3ff-200d-2642-fe0f"
      ],
      a: "13.0"
    },
    {
      n: ["woman in tuxedo"],
      u: "1f935-200d-2640-fe0f",
      v: [
        "1f935-1f3fb-200d-2640-fe0f",
        "1f935-1f3fc-200d-2640-fe0f",
        "1f935-1f3fd-200d-2640-fe0f",
        "1f935-1f3fe-200d-2640-fe0f",
        "1f935-1f3ff-200d-2640-fe0f"
      ],
      a: "13.0"
    },
    {
      n: ["bride with veil"],
      u: "1f470",
      v: ["1f470-1f3fb", "1f470-1f3fc", "1f470-1f3fd", "1f470-1f3fe", "1f470-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man with veil"],
      u: "1f470-200d-2642-fe0f",
      v: [
        "1f470-1f3fb-200d-2642-fe0f",
        "1f470-1f3fc-200d-2642-fe0f",
        "1f470-1f3fd-200d-2642-fe0f",
        "1f470-1f3fe-200d-2642-fe0f",
        "1f470-1f3ff-200d-2642-fe0f"
      ],
      a: "13.0"
    },
    {
      n: ["woman with veil"],
      u: "1f470-200d-2640-fe0f",
      v: [
        "1f470-1f3fb-200d-2640-fe0f",
        "1f470-1f3fc-200d-2640-fe0f",
        "1f470-1f3fd-200d-2640-fe0f",
        "1f470-1f3fe-200d-2640-fe0f",
        "1f470-1f3ff-200d-2640-fe0f"
      ],
      a: "13.0"
    },
    {
      n: ["pregnant woman"],
      u: "1f930",
      v: ["1f930-1f3fb", "1f930-1f3fc", "1f930-1f3fd", "1f930-1f3fe", "1f930-1f3ff"],
      a: "3.0"
    },
    {
      n: ["pregnant man"],
      u: "1fac3",
      v: ["1fac3-1f3fb", "1fac3-1f3fc", "1fac3-1f3fd", "1fac3-1f3fe", "1fac3-1f3ff"],
      a: "14.0"
    },
    {
      n: ["pregnant person"],
      u: "1fac4",
      v: ["1fac4-1f3fb", "1fac4-1f3fc", "1fac4-1f3fd", "1fac4-1f3fe", "1fac4-1f3ff"],
      a: "14.0"
    },
    {
      n: ["breast-feeding"],
      u: "1f931",
      v: ["1f931-1f3fb", "1f931-1f3fc", "1f931-1f3fd", "1f931-1f3fe", "1f931-1f3ff"],
      a: "5.0"
    },
    {
      n: ["woman feeding baby"],
      u: "1f469-200d-1f37c",
      v: [
        "1f469-1f3fb-200d-1f37c",
        "1f469-1f3fc-200d-1f37c",
        "1f469-1f3fd-200d-1f37c",
        "1f469-1f3fe-200d-1f37c",
        "1f469-1f3ff-200d-1f37c"
      ],
      a: "13.0"
    },
    {
      n: ["man feeding baby"],
      u: "1f468-200d-1f37c",
      v: [
        "1f468-1f3fb-200d-1f37c",
        "1f468-1f3fc-200d-1f37c",
        "1f468-1f3fd-200d-1f37c",
        "1f468-1f3fe-200d-1f37c",
        "1f468-1f3ff-200d-1f37c"
      ],
      a: "13.0"
    },
    {
      n: ["person feeding baby"],
      u: "1f9d1-200d-1f37c",
      v: [
        "1f9d1-1f3fb-200d-1f37c",
        "1f9d1-1f3fc-200d-1f37c",
        "1f9d1-1f3fd-200d-1f37c",
        "1f9d1-1f3fe-200d-1f37c",
        "1f9d1-1f3ff-200d-1f37c"
      ],
      a: "13.0"
    },
    {
      n: ["angel", "baby angel"],
      u: "1f47c",
      v: ["1f47c-1f3fb", "1f47c-1f3fc", "1f47c-1f3fd", "1f47c-1f3fe", "1f47c-1f3ff"],
      a: "0.6"
    },
    {
      n: ["santa", "father christmas"],
      u: "1f385",
      v: ["1f385-1f3fb", "1f385-1f3fc", "1f385-1f3fd", "1f385-1f3fe", "1f385-1f3ff"],
      a: "0.6"
    },
    {
      n: ["mrs claus", "mother christmas"],
      u: "1f936",
      v: ["1f936-1f3fb", "1f936-1f3fc", "1f936-1f3fd", "1f936-1f3fe", "1f936-1f3ff"],
      a: "3.0"
    },
    {
      n: ["mx claus"],
      u: "1f9d1-200d-1f384",
      v: [
        "1f9d1-1f3fb-200d-1f384",
        "1f9d1-1f3fc-200d-1f384",
        "1f9d1-1f3fd-200d-1f384",
        "1f9d1-1f3fe-200d-1f384",
        "1f9d1-1f3ff-200d-1f384"
      ],
      a: "13.0"
    },
    {
      n: ["superhero"],
      u: "1f9b8",
      v: ["1f9b8-1f3fb", "1f9b8-1f3fc", "1f9b8-1f3fd", "1f9b8-1f3fe", "1f9b8-1f3ff"],
      a: "11.0"
    },
    {
      n: ["man superhero", "male superhero"],
      u: "1f9b8-200d-2642-fe0f",
      v: [
        "1f9b8-1f3fb-200d-2642-fe0f",
        "1f9b8-1f3fc-200d-2642-fe0f",
        "1f9b8-1f3fd-200d-2642-fe0f",
        "1f9b8-1f3fe-200d-2642-fe0f",
        "1f9b8-1f3ff-200d-2642-fe0f"
      ],
      a: "11.0"
    },
    {
      n: ["woman superhero", "female superhero"],
      u: "1f9b8-200d-2640-fe0f",
      v: [
        "1f9b8-1f3fb-200d-2640-fe0f",
        "1f9b8-1f3fc-200d-2640-fe0f",
        "1f9b8-1f3fd-200d-2640-fe0f",
        "1f9b8-1f3fe-200d-2640-fe0f",
        "1f9b8-1f3ff-200d-2640-fe0f"
      ],
      a: "11.0"
    },
    {
      n: ["supervillain"],
      u: "1f9b9",
      v: ["1f9b9-1f3fb", "1f9b9-1f3fc", "1f9b9-1f3fd", "1f9b9-1f3fe", "1f9b9-1f3ff"],
      a: "11.0"
    },
    {
      n: ["man supervillain", "male supervillain"],
      u: "1f9b9-200d-2642-fe0f",
      v: [
        "1f9b9-1f3fb-200d-2642-fe0f",
        "1f9b9-1f3fc-200d-2642-fe0f",
        "1f9b9-1f3fd-200d-2642-fe0f",
        "1f9b9-1f3fe-200d-2642-fe0f",
        "1f9b9-1f3ff-200d-2642-fe0f"
      ],
      a: "11.0"
    },
    {
      n: ["woman supervillain", "female supervillain"],
      u: "1f9b9-200d-2640-fe0f",
      v: [
        "1f9b9-1f3fb-200d-2640-fe0f",
        "1f9b9-1f3fc-200d-2640-fe0f",
        "1f9b9-1f3fd-200d-2640-fe0f",
        "1f9b9-1f3fe-200d-2640-fe0f",
        "1f9b9-1f3ff-200d-2640-fe0f"
      ],
      a: "11.0"
    },
    {
      n: ["mage"],
      u: "1f9d9",
      v: ["1f9d9-1f3fb", "1f9d9-1f3fc", "1f9d9-1f3fd", "1f9d9-1f3fe", "1f9d9-1f3ff"],
      a: "5.0"
    },
    {
      n: ["man mage", "male mage"],
      u: "1f9d9-200d-2642-fe0f",
      v: [
        "1f9d9-1f3fb-200d-2642-fe0f",
        "1f9d9-1f3fc-200d-2642-fe0f",
        "1f9d9-1f3fd-200d-2642-fe0f",
        "1f9d9-1f3fe-200d-2642-fe0f",
        "1f9d9-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["woman mage", "female mage"],
      u: "1f9d9-200d-2640-fe0f",
      v: [
        "1f9d9-1f3fb-200d-2640-fe0f",
        "1f9d9-1f3fc-200d-2640-fe0f",
        "1f9d9-1f3fd-200d-2640-fe0f",
        "1f9d9-1f3fe-200d-2640-fe0f",
        "1f9d9-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["fairy"],
      u: "1f9da",
      v: ["1f9da-1f3fb", "1f9da-1f3fc", "1f9da-1f3fd", "1f9da-1f3fe", "1f9da-1f3ff"],
      a: "5.0"
    },
    {
      n: ["man fairy", "male fairy"],
      u: "1f9da-200d-2642-fe0f",
      v: [
        "1f9da-1f3fb-200d-2642-fe0f",
        "1f9da-1f3fc-200d-2642-fe0f",
        "1f9da-1f3fd-200d-2642-fe0f",
        "1f9da-1f3fe-200d-2642-fe0f",
        "1f9da-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["woman fairy", "female fairy"],
      u: "1f9da-200d-2640-fe0f",
      v: [
        "1f9da-1f3fb-200d-2640-fe0f",
        "1f9da-1f3fc-200d-2640-fe0f",
        "1f9da-1f3fd-200d-2640-fe0f",
        "1f9da-1f3fe-200d-2640-fe0f",
        "1f9da-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["vampire"],
      u: "1f9db",
      v: ["1f9db-1f3fb", "1f9db-1f3fc", "1f9db-1f3fd", "1f9db-1f3fe", "1f9db-1f3ff"],
      a: "5.0"
    },
    {
      n: ["man vampire", "male vampire"],
      u: "1f9db-200d-2642-fe0f",
      v: [
        "1f9db-1f3fb-200d-2642-fe0f",
        "1f9db-1f3fc-200d-2642-fe0f",
        "1f9db-1f3fd-200d-2642-fe0f",
        "1f9db-1f3fe-200d-2642-fe0f",
        "1f9db-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["woman vampire", "female vampire"],
      u: "1f9db-200d-2640-fe0f",
      v: [
        "1f9db-1f3fb-200d-2640-fe0f",
        "1f9db-1f3fc-200d-2640-fe0f",
        "1f9db-1f3fd-200d-2640-fe0f",
        "1f9db-1f3fe-200d-2640-fe0f",
        "1f9db-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["merperson"],
      u: "1f9dc",
      v: ["1f9dc-1f3fb", "1f9dc-1f3fc", "1f9dc-1f3fd", "1f9dc-1f3fe", "1f9dc-1f3ff"],
      a: "5.0"
    },
    {
      n: ["merman"],
      u: "1f9dc-200d-2642-fe0f",
      v: [
        "1f9dc-1f3fb-200d-2642-fe0f",
        "1f9dc-1f3fc-200d-2642-fe0f",
        "1f9dc-1f3fd-200d-2642-fe0f",
        "1f9dc-1f3fe-200d-2642-fe0f",
        "1f9dc-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["mermaid"],
      u: "1f9dc-200d-2640-fe0f",
      v: [
        "1f9dc-1f3fb-200d-2640-fe0f",
        "1f9dc-1f3fc-200d-2640-fe0f",
        "1f9dc-1f3fd-200d-2640-fe0f",
        "1f9dc-1f3fe-200d-2640-fe0f",
        "1f9dc-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["elf"],
      u: "1f9dd",
      v: ["1f9dd-1f3fb", "1f9dd-1f3fc", "1f9dd-1f3fd", "1f9dd-1f3fe", "1f9dd-1f3ff"],
      a: "5.0"
    },
    {
      n: ["man elf", "male elf"],
      u: "1f9dd-200d-2642-fe0f",
      v: [
        "1f9dd-1f3fb-200d-2642-fe0f",
        "1f9dd-1f3fc-200d-2642-fe0f",
        "1f9dd-1f3fd-200d-2642-fe0f",
        "1f9dd-1f3fe-200d-2642-fe0f",
        "1f9dd-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["woman elf", "female elf"],
      u: "1f9dd-200d-2640-fe0f",
      v: [
        "1f9dd-1f3fb-200d-2640-fe0f",
        "1f9dd-1f3fc-200d-2640-fe0f",
        "1f9dd-1f3fd-200d-2640-fe0f",
        "1f9dd-1f3fe-200d-2640-fe0f",
        "1f9dd-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["genie"],
      u: "1f9de",
      a: "5.0"
    },
    {
      n: ["man genie", "male genie"],
      u: "1f9de-200d-2642-fe0f",
      a: "5.0"
    },
    {
      n: ["woman genie", "female genie"],
      u: "1f9de-200d-2640-fe0f",
      a: "5.0"
    },
    {
      n: ["zombie"],
      u: "1f9df",
      a: "5.0"
    },
    {
      n: ["man zombie", "male zombie"],
      u: "1f9df-200d-2642-fe0f",
      a: "5.0"
    },
    {
      n: ["woman zombie", "female zombie"],
      u: "1f9df-200d-2640-fe0f",
      a: "5.0"
    },
    {
      n: ["troll"],
      u: "1f9cc",
      a: "14.0"
    },
    {
      n: ["massage", "face massage"],
      u: "1f486",
      v: ["1f486-1f3fb", "1f486-1f3fc", "1f486-1f3fd", "1f486-1f3fe", "1f486-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man getting massage", "man-getting-massage"],
      u: "1f486-200d-2642-fe0f",
      v: [
        "1f486-1f3fb-200d-2642-fe0f",
        "1f486-1f3fc-200d-2642-fe0f",
        "1f486-1f3fd-200d-2642-fe0f",
        "1f486-1f3fe-200d-2642-fe0f",
        "1f486-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman getting massage", "woman-getting-massage"],
      u: "1f486-200d-2640-fe0f",
      v: [
        "1f486-1f3fb-200d-2640-fe0f",
        "1f486-1f3fc-200d-2640-fe0f",
        "1f486-1f3fd-200d-2640-fe0f",
        "1f486-1f3fe-200d-2640-fe0f",
        "1f486-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["haircut"],
      u: "1f487",
      v: ["1f487-1f3fb", "1f487-1f3fc", "1f487-1f3fd", "1f487-1f3fe", "1f487-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man getting haircut", "man-getting-haircut"],
      u: "1f487-200d-2642-fe0f",
      v: [
        "1f487-1f3fb-200d-2642-fe0f",
        "1f487-1f3fc-200d-2642-fe0f",
        "1f487-1f3fd-200d-2642-fe0f",
        "1f487-1f3fe-200d-2642-fe0f",
        "1f487-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman getting haircut", "woman-getting-haircut"],
      u: "1f487-200d-2640-fe0f",
      v: [
        "1f487-1f3fb-200d-2640-fe0f",
        "1f487-1f3fc-200d-2640-fe0f",
        "1f487-1f3fd-200d-2640-fe0f",
        "1f487-1f3fe-200d-2640-fe0f",
        "1f487-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["walking", "pedestrian"],
      u: "1f6b6",
      v: ["1f6b6-1f3fb", "1f6b6-1f3fc", "1f6b6-1f3fd", "1f6b6-1f3fe", "1f6b6-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man walking", "man-walking"],
      u: "1f6b6-200d-2642-fe0f",
      v: [
        "1f6b6-1f3fb-200d-2642-fe0f",
        "1f6b6-1f3fc-200d-2642-fe0f",
        "1f6b6-1f3fd-200d-2642-fe0f",
        "1f6b6-1f3fe-200d-2642-fe0f",
        "1f6b6-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman walking", "woman-walking"],
      u: "1f6b6-200d-2640-fe0f",
      v: [
        "1f6b6-1f3fb-200d-2640-fe0f",
        "1f6b6-1f3fc-200d-2640-fe0f",
        "1f6b6-1f3fd-200d-2640-fe0f",
        "1f6b6-1f3fe-200d-2640-fe0f",
        "1f6b6-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["standing person"],
      u: "1f9cd",
      v: ["1f9cd-1f3fb", "1f9cd-1f3fc", "1f9cd-1f3fd", "1f9cd-1f3fe", "1f9cd-1f3ff"],
      a: "12.0"
    },
    {
      n: ["man standing"],
      u: "1f9cd-200d-2642-fe0f",
      v: [
        "1f9cd-1f3fb-200d-2642-fe0f",
        "1f9cd-1f3fc-200d-2642-fe0f",
        "1f9cd-1f3fd-200d-2642-fe0f",
        "1f9cd-1f3fe-200d-2642-fe0f",
        "1f9cd-1f3ff-200d-2642-fe0f"
      ],
      a: "12.0"
    },
    {
      n: ["woman standing"],
      u: "1f9cd-200d-2640-fe0f",
      v: [
        "1f9cd-1f3fb-200d-2640-fe0f",
        "1f9cd-1f3fc-200d-2640-fe0f",
        "1f9cd-1f3fd-200d-2640-fe0f",
        "1f9cd-1f3fe-200d-2640-fe0f",
        "1f9cd-1f3ff-200d-2640-fe0f"
      ],
      a: "12.0"
    },
    {
      n: ["kneeling person"],
      u: "1f9ce",
      v: ["1f9ce-1f3fb", "1f9ce-1f3fc", "1f9ce-1f3fd", "1f9ce-1f3fe", "1f9ce-1f3ff"],
      a: "12.0"
    },
    {
      n: ["man kneeling"],
      u: "1f9ce-200d-2642-fe0f",
      v: [
        "1f9ce-1f3fb-200d-2642-fe0f",
        "1f9ce-1f3fc-200d-2642-fe0f",
        "1f9ce-1f3fd-200d-2642-fe0f",
        "1f9ce-1f3fe-200d-2642-fe0f",
        "1f9ce-1f3ff-200d-2642-fe0f"
      ],
      a: "12.0"
    },
    {
      n: ["woman kneeling"],
      u: "1f9ce-200d-2640-fe0f",
      v: [
        "1f9ce-1f3fb-200d-2640-fe0f",
        "1f9ce-1f3fc-200d-2640-fe0f",
        "1f9ce-1f3fd-200d-2640-fe0f",
        "1f9ce-1f3fe-200d-2640-fe0f",
        "1f9ce-1f3ff-200d-2640-fe0f"
      ],
      a: "12.0"
    },
    {
      n: ["person with white cane", "person with probing cane"],
      u: "1f9d1-200d-1f9af",
      v: [
        "1f9d1-1f3fb-200d-1f9af",
        "1f9d1-1f3fc-200d-1f9af",
        "1f9d1-1f3fd-200d-1f9af",
        "1f9d1-1f3fe-200d-1f9af",
        "1f9d1-1f3ff-200d-1f9af"
      ],
      a: "12.1"
    },
    {
      n: ["man with white cane", "man with probing cane"],
      u: "1f468-200d-1f9af",
      v: [
        "1f468-1f3fb-200d-1f9af",
        "1f468-1f3fc-200d-1f9af",
        "1f468-1f3fd-200d-1f9af",
        "1f468-1f3fe-200d-1f9af",
        "1f468-1f3ff-200d-1f9af"
      ],
      a: "12.0"
    },
    {
      n: ["woman with white cane", "woman with probing cane"],
      u: "1f469-200d-1f9af",
      v: [
        "1f469-1f3fb-200d-1f9af",
        "1f469-1f3fc-200d-1f9af",
        "1f469-1f3fd-200d-1f9af",
        "1f469-1f3fe-200d-1f9af",
        "1f469-1f3ff-200d-1f9af"
      ],
      a: "12.0"
    },
    {
      n: ["person in motorized wheelchair"],
      u: "1f9d1-200d-1f9bc",
      v: [
        "1f9d1-1f3fb-200d-1f9bc",
        "1f9d1-1f3fc-200d-1f9bc",
        "1f9d1-1f3fd-200d-1f9bc",
        "1f9d1-1f3fe-200d-1f9bc",
        "1f9d1-1f3ff-200d-1f9bc"
      ],
      a: "12.1"
    },
    {
      n: ["man in motorized wheelchair"],
      u: "1f468-200d-1f9bc",
      v: [
        "1f468-1f3fb-200d-1f9bc",
        "1f468-1f3fc-200d-1f9bc",
        "1f468-1f3fd-200d-1f9bc",
        "1f468-1f3fe-200d-1f9bc",
        "1f468-1f3ff-200d-1f9bc"
      ],
      a: "12.0"
    },
    {
      n: ["woman in motorized wheelchair"],
      u: "1f469-200d-1f9bc",
      v: [
        "1f469-1f3fb-200d-1f9bc",
        "1f469-1f3fc-200d-1f9bc",
        "1f469-1f3fd-200d-1f9bc",
        "1f469-1f3fe-200d-1f9bc",
        "1f469-1f3ff-200d-1f9bc"
      ],
      a: "12.0"
    },
    {
      n: ["person in manual wheelchair"],
      u: "1f9d1-200d-1f9bd",
      v: [
        "1f9d1-1f3fb-200d-1f9bd",
        "1f9d1-1f3fc-200d-1f9bd",
        "1f9d1-1f3fd-200d-1f9bd",
        "1f9d1-1f3fe-200d-1f9bd",
        "1f9d1-1f3ff-200d-1f9bd"
      ],
      a: "12.1"
    },
    {
      n: ["man in manual wheelchair"],
      u: "1f468-200d-1f9bd",
      v: [
        "1f468-1f3fb-200d-1f9bd",
        "1f468-1f3fc-200d-1f9bd",
        "1f468-1f3fd-200d-1f9bd",
        "1f468-1f3fe-200d-1f9bd",
        "1f468-1f3ff-200d-1f9bd"
      ],
      a: "12.0"
    },
    {
      n: ["woman in manual wheelchair"],
      u: "1f469-200d-1f9bd",
      v: [
        "1f469-1f3fb-200d-1f9bd",
        "1f469-1f3fc-200d-1f9bd",
        "1f469-1f3fd-200d-1f9bd",
        "1f469-1f3fe-200d-1f9bd",
        "1f469-1f3ff-200d-1f9bd"
      ],
      a: "12.0"
    },
    {
      n: ["runner", "running"],
      u: "1f3c3",
      v: ["1f3c3-1f3fb", "1f3c3-1f3fc", "1f3c3-1f3fd", "1f3c3-1f3fe", "1f3c3-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man running", "man-running"],
      u: "1f3c3-200d-2642-fe0f",
      v: [
        "1f3c3-1f3fb-200d-2642-fe0f",
        "1f3c3-1f3fc-200d-2642-fe0f",
        "1f3c3-1f3fd-200d-2642-fe0f",
        "1f3c3-1f3fe-200d-2642-fe0f",
        "1f3c3-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman running", "woman-running"],
      u: "1f3c3-200d-2640-fe0f",
      v: [
        "1f3c3-1f3fb-200d-2640-fe0f",
        "1f3c3-1f3fc-200d-2640-fe0f",
        "1f3c3-1f3fd-200d-2640-fe0f",
        "1f3c3-1f3fe-200d-2640-fe0f",
        "1f3c3-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["dancer"],
      u: "1f483",
      v: ["1f483-1f3fb", "1f483-1f3fc", "1f483-1f3fd", "1f483-1f3fe", "1f483-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man dancing"],
      u: "1f57a",
      v: ["1f57a-1f3fb", "1f57a-1f3fc", "1f57a-1f3fd", "1f57a-1f3fe", "1f57a-1f3ff"],
      a: "3.0"
    },
    {
      n: ["person in suit levitating", "man in business suit levitating"],
      u: "1f574-fe0f",
      v: ["1f574-1f3fb", "1f574-1f3fc", "1f574-1f3fd", "1f574-1f3fe", "1f574-1f3ff"],
      a: "0.7"
    },
    {
      n: ["dancers", "woman with bunny ears"],
      u: "1f46f",
      a: "0.6"
    },
    {
      n: ["men with bunny ears", "men-with-bunny-ears-partying", "man-with-bunny-ears-partying"],
      u: "1f46f-200d-2642-fe0f",
      a: "4.0"
    },
    {
      n: [
        "women with bunny ears",
        "women-with-bunny-ears-partying",
        "woman-with-bunny-ears-partying"
      ],
      u: "1f46f-200d-2640-fe0f",
      a: "4.0"
    },
    {
      n: ["person in steamy room"],
      u: "1f9d6",
      v: ["1f9d6-1f3fb", "1f9d6-1f3fc", "1f9d6-1f3fd", "1f9d6-1f3fe", "1f9d6-1f3ff"],
      a: "5.0"
    },
    {
      n: ["man in steamy room"],
      u: "1f9d6-200d-2642-fe0f",
      v: [
        "1f9d6-1f3fb-200d-2642-fe0f",
        "1f9d6-1f3fc-200d-2642-fe0f",
        "1f9d6-1f3fd-200d-2642-fe0f",
        "1f9d6-1f3fe-200d-2642-fe0f",
        "1f9d6-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["woman in steamy room"],
      u: "1f9d6-200d-2640-fe0f",
      v: [
        "1f9d6-1f3fb-200d-2640-fe0f",
        "1f9d6-1f3fc-200d-2640-fe0f",
        "1f9d6-1f3fd-200d-2640-fe0f",
        "1f9d6-1f3fe-200d-2640-fe0f",
        "1f9d6-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["person climbing"],
      u: "1f9d7",
      v: ["1f9d7-1f3fb", "1f9d7-1f3fc", "1f9d7-1f3fd", "1f9d7-1f3fe", "1f9d7-1f3ff"],
      a: "5.0"
    },
    {
      n: ["man climbing"],
      u: "1f9d7-200d-2642-fe0f",
      v: [
        "1f9d7-1f3fb-200d-2642-fe0f",
        "1f9d7-1f3fc-200d-2642-fe0f",
        "1f9d7-1f3fd-200d-2642-fe0f",
        "1f9d7-1f3fe-200d-2642-fe0f",
        "1f9d7-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["woman climbing"],
      u: "1f9d7-200d-2640-fe0f",
      v: [
        "1f9d7-1f3fb-200d-2640-fe0f",
        "1f9d7-1f3fc-200d-2640-fe0f",
        "1f9d7-1f3fd-200d-2640-fe0f",
        "1f9d7-1f3fe-200d-2640-fe0f",
        "1f9d7-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["fencer"],
      u: "1f93a",
      a: "3.0"
    },
    {
      n: ["horse racing"],
      u: "1f3c7",
      v: ["1f3c7-1f3fb", "1f3c7-1f3fc", "1f3c7-1f3fd", "1f3c7-1f3fe", "1f3c7-1f3ff"],
      a: "1.0"
    },
    {
      n: ["skier"],
      u: "26f7-fe0f",
      a: "0.7"
    },
    {
      n: ["snowboarder"],
      u: "1f3c2",
      v: ["1f3c2-1f3fb", "1f3c2-1f3fc", "1f3c2-1f3fd", "1f3c2-1f3fe", "1f3c2-1f3ff"],
      a: "0.6"
    },
    {
      n: ["golfer", "person golfing"],
      u: "1f3cc-fe0f",
      v: ["1f3cc-1f3fb", "1f3cc-1f3fc", "1f3cc-1f3fd", "1f3cc-1f3fe", "1f3cc-1f3ff"],
      a: "0.7"
    },
    {
      n: ["man golfing", "man-golfing"],
      u: "1f3cc-fe0f-200d-2642-fe0f",
      v: [
        "1f3cc-1f3fb-200d-2642-fe0f",
        "1f3cc-1f3fc-200d-2642-fe0f",
        "1f3cc-1f3fd-200d-2642-fe0f",
        "1f3cc-1f3fe-200d-2642-fe0f",
        "1f3cc-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman golfing", "woman-golfing"],
      u: "1f3cc-fe0f-200d-2640-fe0f",
      v: [
        "1f3cc-1f3fb-200d-2640-fe0f",
        "1f3cc-1f3fc-200d-2640-fe0f",
        "1f3cc-1f3fd-200d-2640-fe0f",
        "1f3cc-1f3fe-200d-2640-fe0f",
        "1f3cc-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["surfer"],
      u: "1f3c4",
      v: ["1f3c4-1f3fb", "1f3c4-1f3fc", "1f3c4-1f3fd", "1f3c4-1f3fe", "1f3c4-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man surfing", "man-surfing"],
      u: "1f3c4-200d-2642-fe0f",
      v: [
        "1f3c4-1f3fb-200d-2642-fe0f",
        "1f3c4-1f3fc-200d-2642-fe0f",
        "1f3c4-1f3fd-200d-2642-fe0f",
        "1f3c4-1f3fe-200d-2642-fe0f",
        "1f3c4-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman surfing", "woman-surfing"],
      u: "1f3c4-200d-2640-fe0f",
      v: [
        "1f3c4-1f3fb-200d-2640-fe0f",
        "1f3c4-1f3fc-200d-2640-fe0f",
        "1f3c4-1f3fd-200d-2640-fe0f",
        "1f3c4-1f3fe-200d-2640-fe0f",
        "1f3c4-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["rowboat"],
      u: "1f6a3",
      v: ["1f6a3-1f3fb", "1f6a3-1f3fc", "1f6a3-1f3fd", "1f6a3-1f3fe", "1f6a3-1f3ff"],
      a: "1.0"
    },
    {
      n: ["man rowing boat", "man-rowing-boat"],
      u: "1f6a3-200d-2642-fe0f",
      v: [
        "1f6a3-1f3fb-200d-2642-fe0f",
        "1f6a3-1f3fc-200d-2642-fe0f",
        "1f6a3-1f3fd-200d-2642-fe0f",
        "1f6a3-1f3fe-200d-2642-fe0f",
        "1f6a3-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman rowing boat", "woman-rowing-boat"],
      u: "1f6a3-200d-2640-fe0f",
      v: [
        "1f6a3-1f3fb-200d-2640-fe0f",
        "1f6a3-1f3fc-200d-2640-fe0f",
        "1f6a3-1f3fd-200d-2640-fe0f",
        "1f6a3-1f3fe-200d-2640-fe0f",
        "1f6a3-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["swimmer"],
      u: "1f3ca",
      v: ["1f3ca-1f3fb", "1f3ca-1f3fc", "1f3ca-1f3fd", "1f3ca-1f3fe", "1f3ca-1f3ff"],
      a: "0.6"
    },
    {
      n: ["man swimming", "man-swimming"],
      u: "1f3ca-200d-2642-fe0f",
      v: [
        "1f3ca-1f3fb-200d-2642-fe0f",
        "1f3ca-1f3fc-200d-2642-fe0f",
        "1f3ca-1f3fd-200d-2642-fe0f",
        "1f3ca-1f3fe-200d-2642-fe0f",
        "1f3ca-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman swimming", "woman-swimming"],
      u: "1f3ca-200d-2640-fe0f",
      v: [
        "1f3ca-1f3fb-200d-2640-fe0f",
        "1f3ca-1f3fc-200d-2640-fe0f",
        "1f3ca-1f3fd-200d-2640-fe0f",
        "1f3ca-1f3fe-200d-2640-fe0f",
        "1f3ca-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["person with ball", "person bouncing ball"],
      u: "26f9-fe0f",
      v: ["26f9-1f3fb", "26f9-1f3fc", "26f9-1f3fd", "26f9-1f3fe", "26f9-1f3ff"],
      a: "0.7"
    },
    {
      n: ["man bouncing ball", "man-bouncing-ball"],
      u: "26f9-fe0f-200d-2642-fe0f",
      v: [
        "26f9-1f3fb-200d-2642-fe0f",
        "26f9-1f3fc-200d-2642-fe0f",
        "26f9-1f3fd-200d-2642-fe0f",
        "26f9-1f3fe-200d-2642-fe0f",
        "26f9-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman bouncing ball", "woman-bouncing-ball"],
      u: "26f9-fe0f-200d-2640-fe0f",
      v: [
        "26f9-1f3fb-200d-2640-fe0f",
        "26f9-1f3fc-200d-2640-fe0f",
        "26f9-1f3fd-200d-2640-fe0f",
        "26f9-1f3fe-200d-2640-fe0f",
        "26f9-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["weight lifter", "person lifting weights"],
      u: "1f3cb-fe0f",
      v: ["1f3cb-1f3fb", "1f3cb-1f3fc", "1f3cb-1f3fd", "1f3cb-1f3fe", "1f3cb-1f3ff"],
      a: "0.7"
    },
    {
      n: ["man lifting weights", "man-lifting-weights"],
      u: "1f3cb-fe0f-200d-2642-fe0f",
      v: [
        "1f3cb-1f3fb-200d-2642-fe0f",
        "1f3cb-1f3fc-200d-2642-fe0f",
        "1f3cb-1f3fd-200d-2642-fe0f",
        "1f3cb-1f3fe-200d-2642-fe0f",
        "1f3cb-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman lifting weights", "woman-lifting-weights"],
      u: "1f3cb-fe0f-200d-2640-fe0f",
      v: [
        "1f3cb-1f3fb-200d-2640-fe0f",
        "1f3cb-1f3fc-200d-2640-fe0f",
        "1f3cb-1f3fd-200d-2640-fe0f",
        "1f3cb-1f3fe-200d-2640-fe0f",
        "1f3cb-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["bicyclist"],
      u: "1f6b4",
      v: ["1f6b4-1f3fb", "1f6b4-1f3fc", "1f6b4-1f3fd", "1f6b4-1f3fe", "1f6b4-1f3ff"],
      a: "1.0"
    },
    {
      n: ["man biking", "man-biking"],
      u: "1f6b4-200d-2642-fe0f",
      v: [
        "1f6b4-1f3fb-200d-2642-fe0f",
        "1f6b4-1f3fc-200d-2642-fe0f",
        "1f6b4-1f3fd-200d-2642-fe0f",
        "1f6b4-1f3fe-200d-2642-fe0f",
        "1f6b4-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman biking", "woman-biking"],
      u: "1f6b4-200d-2640-fe0f",
      v: [
        "1f6b4-1f3fb-200d-2640-fe0f",
        "1f6b4-1f3fc-200d-2640-fe0f",
        "1f6b4-1f3fd-200d-2640-fe0f",
        "1f6b4-1f3fe-200d-2640-fe0f",
        "1f6b4-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["mountain bicyclist"],
      u: "1f6b5",
      v: ["1f6b5-1f3fb", "1f6b5-1f3fc", "1f6b5-1f3fd", "1f6b5-1f3fe", "1f6b5-1f3ff"],
      a: "1.0"
    },
    {
      n: ["man mountain biking", "man-mountain-biking"],
      u: "1f6b5-200d-2642-fe0f",
      v: [
        "1f6b5-1f3fb-200d-2642-fe0f",
        "1f6b5-1f3fc-200d-2642-fe0f",
        "1f6b5-1f3fd-200d-2642-fe0f",
        "1f6b5-1f3fe-200d-2642-fe0f",
        "1f6b5-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman mountain biking", "woman-mountain-biking"],
      u: "1f6b5-200d-2640-fe0f",
      v: [
        "1f6b5-1f3fb-200d-2640-fe0f",
        "1f6b5-1f3fc-200d-2640-fe0f",
        "1f6b5-1f3fd-200d-2640-fe0f",
        "1f6b5-1f3fe-200d-2640-fe0f",
        "1f6b5-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["person doing cartwheel"],
      u: "1f938",
      v: ["1f938-1f3fb", "1f938-1f3fc", "1f938-1f3fd", "1f938-1f3fe", "1f938-1f3ff"],
      a: "3.0"
    },
    {
      n: ["man cartwheeling", "man-cartwheeling"],
      u: "1f938-200d-2642-fe0f",
      v: [
        "1f938-1f3fb-200d-2642-fe0f",
        "1f938-1f3fc-200d-2642-fe0f",
        "1f938-1f3fd-200d-2642-fe0f",
        "1f938-1f3fe-200d-2642-fe0f",
        "1f938-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman cartwheeling", "woman-cartwheeling"],
      u: "1f938-200d-2640-fe0f",
      v: [
        "1f938-1f3fb-200d-2640-fe0f",
        "1f938-1f3fc-200d-2640-fe0f",
        "1f938-1f3fd-200d-2640-fe0f",
        "1f938-1f3fe-200d-2640-fe0f",
        "1f938-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["wrestlers"],
      u: "1f93c",
      a: "3.0"
    },
    {
      n: ["men wrestling", "man-wrestling"],
      u: "1f93c-200d-2642-fe0f",
      a: "4.0"
    },
    {
      n: ["women wrestling", "woman-wrestling"],
      u: "1f93c-200d-2640-fe0f",
      a: "4.0"
    },
    {
      n: ["water polo"],
      u: "1f93d",
      v: ["1f93d-1f3fb", "1f93d-1f3fc", "1f93d-1f3fd", "1f93d-1f3fe", "1f93d-1f3ff"],
      a: "3.0"
    },
    {
      n: ["man playing water polo", "man-playing-water-polo"],
      u: "1f93d-200d-2642-fe0f",
      v: [
        "1f93d-1f3fb-200d-2642-fe0f",
        "1f93d-1f3fc-200d-2642-fe0f",
        "1f93d-1f3fd-200d-2642-fe0f",
        "1f93d-1f3fe-200d-2642-fe0f",
        "1f93d-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman playing water polo", "woman-playing-water-polo"],
      u: "1f93d-200d-2640-fe0f",
      v: [
        "1f93d-1f3fb-200d-2640-fe0f",
        "1f93d-1f3fc-200d-2640-fe0f",
        "1f93d-1f3fd-200d-2640-fe0f",
        "1f93d-1f3fe-200d-2640-fe0f",
        "1f93d-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["handball"],
      u: "1f93e",
      v: ["1f93e-1f3fb", "1f93e-1f3fc", "1f93e-1f3fd", "1f93e-1f3fe", "1f93e-1f3ff"],
      a: "3.0"
    },
    {
      n: ["man playing handball", "man-playing-handball"],
      u: "1f93e-200d-2642-fe0f",
      v: [
        "1f93e-1f3fb-200d-2642-fe0f",
        "1f93e-1f3fc-200d-2642-fe0f",
        "1f93e-1f3fd-200d-2642-fe0f",
        "1f93e-1f3fe-200d-2642-fe0f",
        "1f93e-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman playing handball", "woman-playing-handball"],
      u: "1f93e-200d-2640-fe0f",
      v: [
        "1f93e-1f3fb-200d-2640-fe0f",
        "1f93e-1f3fc-200d-2640-fe0f",
        "1f93e-1f3fd-200d-2640-fe0f",
        "1f93e-1f3fe-200d-2640-fe0f",
        "1f93e-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["juggling"],
      u: "1f939",
      v: ["1f939-1f3fb", "1f939-1f3fc", "1f939-1f3fd", "1f939-1f3fe", "1f939-1f3ff"],
      a: "3.0"
    },
    {
      n: ["man juggling", "man-juggling"],
      u: "1f939-200d-2642-fe0f",
      v: [
        "1f939-1f3fb-200d-2642-fe0f",
        "1f939-1f3fc-200d-2642-fe0f",
        "1f939-1f3fd-200d-2642-fe0f",
        "1f939-1f3fe-200d-2642-fe0f",
        "1f939-1f3ff-200d-2642-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["woman juggling", "woman-juggling"],
      u: "1f939-200d-2640-fe0f",
      v: [
        "1f939-1f3fb-200d-2640-fe0f",
        "1f939-1f3fc-200d-2640-fe0f",
        "1f939-1f3fd-200d-2640-fe0f",
        "1f939-1f3fe-200d-2640-fe0f",
        "1f939-1f3ff-200d-2640-fe0f"
      ],
      a: "4.0"
    },
    {
      n: ["person in lotus position"],
      u: "1f9d8",
      v: ["1f9d8-1f3fb", "1f9d8-1f3fc", "1f9d8-1f3fd", "1f9d8-1f3fe", "1f9d8-1f3ff"],
      a: "5.0"
    },
    {
      n: ["man in lotus position"],
      u: "1f9d8-200d-2642-fe0f",
      v: [
        "1f9d8-1f3fb-200d-2642-fe0f",
        "1f9d8-1f3fc-200d-2642-fe0f",
        "1f9d8-1f3fd-200d-2642-fe0f",
        "1f9d8-1f3fe-200d-2642-fe0f",
        "1f9d8-1f3ff-200d-2642-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["woman in lotus position"],
      u: "1f9d8-200d-2640-fe0f",
      v: [
        "1f9d8-1f3fb-200d-2640-fe0f",
        "1f9d8-1f3fc-200d-2640-fe0f",
        "1f9d8-1f3fd-200d-2640-fe0f",
        "1f9d8-1f3fe-200d-2640-fe0f",
        "1f9d8-1f3ff-200d-2640-fe0f"
      ],
      a: "5.0"
    },
    {
      n: ["bath"],
      u: "1f6c0",
      v: ["1f6c0-1f3fb", "1f6c0-1f3fc", "1f6c0-1f3fd", "1f6c0-1f3fe", "1f6c0-1f3ff"],
      a: "0.6"
    },
    {
      n: ["sleeping accommodation"],
      u: "1f6cc",
      v: ["1f6cc-1f3fb", "1f6cc-1f3fc", "1f6cc-1f3fd", "1f6cc-1f3fe", "1f6cc-1f3ff"],
      a: "1.0"
    },
    {
      n: ["people holding hands"],
      u: "1f9d1-200d-1f91d-200d-1f9d1",
      v: [
        "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
        "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
        "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
        "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
        "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
        "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
        "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
        "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
        "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
        "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
        "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
        "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
        "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
        "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
        "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
        "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
        "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
        "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
        "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
        "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
        "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
        "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
        "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
        "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
        "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"
      ],
      a: "12.0"
    },
    {
      n: ["women holding hands", "two women holding hands"],
      u: "1f46d",
      v: [
        "1f46d-1f3fb",
        "1f46d-1f3fc",
        "1f46d-1f3fd",
        "1f46d-1f3fe",
        "1f46d-1f3ff",
        "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
        "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
        "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
        "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
        "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
        "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
        "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
        "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
        "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
        "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
        "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
        "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
        "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
        "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
        "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
        "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
        "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
        "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
        "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
        "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"
      ],
      a: "1.0"
    },
    {
      n: ["couple", "man and woman holding hands", "woman and man holding hands"],
      u: "1f46b",
      v: [
        "1f46b-1f3fb",
        "1f46b-1f3fc",
        "1f46b-1f3fd",
        "1f46b-1f3fe",
        "1f46b-1f3ff",
        "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
        "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
        "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
        "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
        "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
        "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
        "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
        "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
        "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
        "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
        "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
        "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
        "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
        "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
        "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
        "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
        "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
        "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
        "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
        "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"
      ],
      a: "0.6"
    },
    {
      n: ["men holding hands", "two men holding hands"],
      u: "1f46c",
      v: [
        "1f46c-1f3fb",
        "1f46c-1f3fc",
        "1f46c-1f3fd",
        "1f46c-1f3fe",
        "1f46c-1f3ff",
        "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
        "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
        "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
        "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
        "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
        "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
        "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
        "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
        "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
        "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
        "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
        "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
        "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
        "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
        "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
        "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
        "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
        "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
        "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
        "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"
      ],
      a: "1.0"
    },
    {
      n: ["kiss", "couplekiss"],
      u: "1f48f",
      v: [
        "1f48f-1f3fb",
        "1f48f-1f3fc",
        "1f48f-1f3fd",
        "1f48f-1f3fe",
        "1f48f-1f3ff",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"
      ],
      a: "0.6"
    },
    {
      n: ["woman-kiss-man", "kiss: woman, man"],
      u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
      v: [
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["man-kiss-man", "kiss: man, man"],
      u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
      v: [
        "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["woman-kiss-woman", "kiss: woman, woman"],
      u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
      v: [
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["couple with heart"],
      u: "1f491",
      v: [
        "1f491-1f3fb",
        "1f491-1f3fc",
        "1f491-1f3fd",
        "1f491-1f3fe",
        "1f491-1f3ff",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",
        "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",
        "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",
        "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",
        "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",
        "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"
      ],
      a: "0.6"
    },
    {
      n: ["woman-heart-man", "couple with heart: woman, man"],
      u: "1f469-200d-2764-fe0f-200d-1f468",
      v: [
        "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["man-heart-man", "couple with heart: man, man"],
      u: "1f468-200d-2764-fe0f-200d-1f468",
      v: [
        "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
        "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["woman-heart-woman", "couple with heart: woman, woman"],
      u: "1f469-200d-2764-fe0f-200d-1f469",
      v: [
        "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",
        "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",
        "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",
        "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
        "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",
        "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"
      ],
      a: "2.0"
    },
    {
      n: ["family"],
      u: "1f46a",
      a: "0.6"
    },
    {
      n: ["man-woman-boy", "family: man, woman, boy"],
      u: "1f468-200d-1f469-200d-1f466",
      a: "2.0"
    },
    {
      n: ["man-woman-girl", "family: man, woman, girl"],
      u: "1f468-200d-1f469-200d-1f467",
      a: "2.0"
    },
    {
      n: ["man-woman-girl-boy", "family: man, woman, girl, boy"],
      u: "1f468-200d-1f469-200d-1f467-200d-1f466",
      a: "2.0"
    },
    {
      n: ["man-woman-boy-boy", "family: man, woman, boy, boy"],
      u: "1f468-200d-1f469-200d-1f466-200d-1f466",
      a: "2.0"
    },
    {
      n: ["man-woman-girl-girl", "family: man, woman, girl, girl"],
      u: "1f468-200d-1f469-200d-1f467-200d-1f467",
      a: "2.0"
    },
    {
      n: ["man-man-boy", "family: man, man, boy"],
      u: "1f468-200d-1f468-200d-1f466",
      a: "2.0"
    },
    {
      n: ["man-man-girl", "family: man, man, girl"],
      u: "1f468-200d-1f468-200d-1f467",
      a: "2.0"
    },
    {
      n: ["man-man-girl-boy", "family: man, man, girl, boy"],
      u: "1f468-200d-1f468-200d-1f467-200d-1f466",
      a: "2.0"
    },
    {
      n: ["man-man-boy-boy", "family: man, man, boy, boy"],
      u: "1f468-200d-1f468-200d-1f466-200d-1f466",
      a: "2.0"
    },
    {
      n: ["man-man-girl-girl", "family: man, man, girl, girl"],
      u: "1f468-200d-1f468-200d-1f467-200d-1f467",
      a: "2.0"
    },
    {
      n: ["woman-woman-boy", "family: woman, woman, boy"],
      u: "1f469-200d-1f469-200d-1f466",
      a: "2.0"
    },
    {
      n: ["woman-woman-girl", "family: woman, woman, girl"],
      u: "1f469-200d-1f469-200d-1f467",
      a: "2.0"
    },
    {
      n: ["woman-woman-girl-boy", "family: woman, woman, girl, boy"],
      u: "1f469-200d-1f469-200d-1f467-200d-1f466",
      a: "2.0"
    },
    {
      n: ["woman-woman-boy-boy", "family: woman, woman, boy, boy"],
      u: "1f469-200d-1f469-200d-1f466-200d-1f466",
      a: "2.0"
    },
    {
      n: ["woman-woman-girl-girl", "family: woman, woman, girl, girl"],
      u: "1f469-200d-1f469-200d-1f467-200d-1f467",
      a: "2.0"
    },
    {
      n: ["man-boy", "family: man, boy"],
      u: "1f468-200d-1f466",
      a: "4.0"
    },
    {
      n: ["man-boy-boy", "family: man, boy, boy"],
      u: "1f468-200d-1f466-200d-1f466",
      a: "4.0"
    },
    {
      n: ["man-girl", "family: man, girl"],
      u: "1f468-200d-1f467",
      a: "4.0"
    },
    {
      n: ["man-girl-boy", "family: man, girl, boy"],
      u: "1f468-200d-1f467-200d-1f466",
      a: "4.0"
    },
    {
      n: ["man-girl-girl", "family: man, girl, girl"],
      u: "1f468-200d-1f467-200d-1f467",
      a: "4.0"
    },
    {
      n: ["woman-boy", "family: woman, boy"],
      u: "1f469-200d-1f466",
      a: "4.0"
    },
    {
      n: ["woman-boy-boy", "family: woman, boy, boy"],
      u: "1f469-200d-1f466-200d-1f466",
      a: "4.0"
    },
    {
      n: ["woman-girl", "family: woman, girl"],
      u: "1f469-200d-1f467",
      a: "4.0"
    },
    {
      n: ["woman-girl-boy", "family: woman, girl, boy"],
      u: "1f469-200d-1f467-200d-1f466",
      a: "4.0"
    },
    {
      n: ["woman-girl-girl", "family: woman, girl, girl"],
      u: "1f469-200d-1f467-200d-1f467",
      a: "4.0"
    },
    {
      n: ["speaking head", "speaking head in silhouette"],
      u: "1f5e3-fe0f",
      a: "0.7"
    },
    {
      n: ["bust in silhouette"],
      u: "1f464",
      a: "0.6"
    },
    {
      n: ["busts in silhouette"],
      u: "1f465",
      a: "1.0"
    },
    {
      n: ["people hugging"],
      u: "1fac2",
      a: "13.0"
    },
    {
      n: ["footprints"],
      u: "1f463",
      a: "0.6"
    }
  ],
  animals_nature: [
    {
      n: ["monkey face"],
      u: "1f435",
      a: "0.6"
    },
    {
      n: ["monkey"],
      u: "1f412",
      a: "0.6"
    },
    {
      n: ["gorilla"],
      u: "1f98d",
      a: "3.0"
    },
    {
      n: ["orangutan"],
      u: "1f9a7",
      a: "12.0"
    },
    {
      n: ["dog", "dog face"],
      u: "1f436",
      a: "0.6"
    },
    {
      n: ["dog", "dog2"],
      u: "1f415",
      a: "0.7"
    },
    {
      n: ["guide dog"],
      u: "1f9ae",
      a: "12.0"
    },
    {
      n: ["service dog"],
      u: "1f415-200d-1f9ba",
      a: "12.0"
    },
    {
      n: ["poodle"],
      u: "1f429",
      a: "0.6"
    },
    {
      n: ["wolf", "wolf face"],
      u: "1f43a",
      a: "0.6"
    },
    {
      n: ["fox face"],
      u: "1f98a",
      a: "3.0"
    },
    {
      n: ["raccoon"],
      u: "1f99d",
      a: "11.0"
    },
    {
      n: ["cat", "cat face"],
      u: "1f431",
      a: "0.6"
    },
    {
      n: ["cat", "cat2"],
      u: "1f408",
      a: "0.7"
    },
    {
      n: ["black cat"],
      u: "1f408-200d-2b1b",
      a: "13.0"
    },
    {
      n: ["lion face"],
      u: "1f981",
      a: "1.0"
    },
    {
      n: ["tiger", "tiger face"],
      u: "1f42f",
      a: "0.6"
    },
    {
      n: ["tiger", "tiger2"],
      u: "1f405",
      a: "1.0"
    },
    {
      n: ["leopard"],
      u: "1f406",
      a: "1.0"
    },
    {
      n: ["horse", "horse face"],
      u: "1f434",
      a: "0.6"
    },
    {
      n: ["horse", "racehorse"],
      u: "1f40e",
      a: "0.6"
    },
    {
      n: ["unicorn face"],
      u: "1f984",
      a: "1.0"
    },
    {
      n: ["zebra face"],
      u: "1f993",
      a: "5.0"
    },
    {
      n: ["deer"],
      u: "1f98c",
      a: "3.0"
    },
    {
      n: ["bison"],
      u: "1f9ac",
      a: "13.0"
    },
    {
      n: ["cow", "cow face"],
      u: "1f42e",
      a: "0.6"
    },
    {
      n: ["ox"],
      u: "1f402",
      a: "1.0"
    },
    {
      n: ["water buffalo"],
      u: "1f403",
      a: "1.0"
    },
    {
      n: ["cow", "cow2"],
      u: "1f404",
      a: "1.0"
    },
    {
      n: ["pig", "pig face"],
      u: "1f437",
      a: "0.6"
    },
    {
      n: ["pig", "pig2"],
      u: "1f416",
      a: "1.0"
    },
    {
      n: ["boar"],
      u: "1f417",
      a: "0.6"
    },
    {
      n: ["pig nose"],
      u: "1f43d",
      a: "0.6"
    },
    {
      n: ["ram"],
      u: "1f40f",
      a: "1.0"
    },
    {
      n: ["sheep"],
      u: "1f411",
      a: "0.6"
    },
    {
      n: ["goat"],
      u: "1f410",
      a: "1.0"
    },
    {
      n: ["dromedary camel"],
      u: "1f42a",
      a: "1.0"
    },
    {
      n: ["camel", "bactrian camel"],
      u: "1f42b",
      a: "0.6"
    },
    {
      n: ["llama"],
      u: "1f999",
      a: "11.0"
    },
    {
      n: ["giraffe face"],
      u: "1f992",
      a: "5.0"
    },
    {
      n: ["elephant"],
      u: "1f418",
      a: "0.6"
    },
    {
      n: ["mammoth"],
      u: "1f9a3",
      a: "13.0"
    },
    {
      n: ["rhinoceros"],
      u: "1f98f",
      a: "3.0"
    },
    {
      n: ["hippopotamus"],
      u: "1f99b",
      a: "11.0"
    },
    {
      n: ["mouse", "mouse face"],
      u: "1f42d",
      a: "0.6"
    },
    {
      n: ["mouse", "mouse2"],
      u: "1f401",
      a: "1.0"
    },
    {
      n: ["rat"],
      u: "1f400",
      a: "1.0"
    },
    {
      n: ["hamster", "hamster face"],
      u: "1f439",
      a: "0.6"
    },
    {
      n: ["rabbit", "rabbit face"],
      u: "1f430",
      a: "0.6"
    },
    {
      n: ["rabbit", "rabbit2"],
      u: "1f407",
      a: "1.0"
    },
    {
      n: ["chipmunk"],
      u: "1f43f-fe0f",
      a: "0.7"
    },
    {
      n: ["beaver"],
      u: "1f9ab",
      a: "13.0"
    },
    {
      n: ["hedgehog"],
      u: "1f994",
      a: "5.0"
    },
    {
      n: ["bat"],
      u: "1f987",
      a: "3.0"
    },
    {
      n: ["bear", "bear face"],
      u: "1f43b",
      a: "0.6"
    },
    {
      n: ["polar bear"],
      u: "1f43b-200d-2744-fe0f",
      a: "13.0"
    },
    {
      n: ["koala"],
      u: "1f428",
      a: "0.6"
    },
    {
      n: ["panda face"],
      u: "1f43c",
      a: "0.6"
    },
    {
      n: ["sloth"],
      u: "1f9a5",
      a: "12.0"
    },
    {
      n: ["otter"],
      u: "1f9a6",
      a: "12.0"
    },
    {
      n: ["skunk"],
      u: "1f9a8",
      a: "12.0"
    },
    {
      n: ["kangaroo"],
      u: "1f998",
      a: "11.0"
    },
    {
      n: ["badger"],
      u: "1f9a1",
      a: "11.0"
    },
    {
      n: ["feet", "paw prints"],
      u: "1f43e",
      a: "0.6"
    },
    {
      n: ["turkey"],
      u: "1f983",
      a: "1.0"
    },
    {
      n: ["chicken"],
      u: "1f414",
      a: "0.6"
    },
    {
      n: ["rooster"],
      u: "1f413",
      a: "1.0"
    },
    {
      n: ["hatching chick"],
      u: "1f423",
      a: "0.6"
    },
    {
      n: ["baby chick"],
      u: "1f424",
      a: "0.6"
    },
    {
      n: ["hatched chick", "front-facing baby chick"],
      u: "1f425",
      a: "0.6"
    },
    {
      n: ["bird"],
      u: "1f426",
      a: "0.6"
    },
    {
      n: ["penguin"],
      u: "1f427",
      a: "0.6"
    },
    {
      n: ["dove", "dove of peace"],
      u: "1f54a-fe0f",
      a: "0.7"
    },
    {
      n: ["eagle"],
      u: "1f985",
      a: "3.0"
    },
    {
      n: ["duck"],
      u: "1f986",
      a: "3.0"
    },
    {
      n: ["swan"],
      u: "1f9a2",
      a: "11.0"
    },
    {
      n: ["owl"],
      u: "1f989",
      a: "3.0"
    },
    {
      n: ["dodo"],
      u: "1f9a4",
      a: "13.0"
    },
    {
      n: ["feather"],
      u: "1fab6",
      a: "13.0"
    },
    {
      n: ["flamingo"],
      u: "1f9a9",
      a: "12.0"
    },
    {
      n: ["peacock"],
      u: "1f99a",
      a: "11.0"
    },
    {
      n: ["parrot"],
      u: "1f99c",
      a: "11.0"
    },
    {
      n: ["frog", "frog face"],
      u: "1f438",
      a: "0.6"
    },
    {
      n: ["crocodile"],
      u: "1f40a",
      a: "1.0"
    },
    {
      n: ["turtle"],
      u: "1f422",
      a: "0.6"
    },
    {
      n: ["lizard"],
      u: "1f98e",
      a: "3.0"
    },
    {
      n: ["snake"],
      u: "1f40d",
      a: "0.6"
    },
    {
      n: ["dragon face"],
      u: "1f432",
      a: "0.6"
    },
    {
      n: ["dragon"],
      u: "1f409",
      a: "1.0"
    },
    {
      n: ["sauropod"],
      u: "1f995",
      a: "5.0"
    },
    {
      n: ["t-rex"],
      u: "1f996",
      a: "5.0"
    },
    {
      n: ["whale", "spouting whale"],
      u: "1f433",
      a: "0.6"
    },
    {
      n: ["whale", "whale2"],
      u: "1f40b",
      a: "1.0"
    },
    {
      n: ["dolphin", "flipper"],
      u: "1f42c",
      a: "0.6"
    },
    {
      n: ["seal"],
      u: "1f9ad",
      a: "13.0"
    },
    {
      n: ["fish"],
      u: "1f41f",
      a: "0.6"
    },
    {
      n: ["tropical fish"],
      u: "1f420",
      a: "0.6"
    },
    {
      n: ["blowfish"],
      u: "1f421",
      a: "0.6"
    },
    {
      n: ["shark"],
      u: "1f988",
      a: "3.0"
    },
    {
      n: ["octopus"],
      u: "1f419",
      a: "0.6"
    },
    {
      n: ["shell", "spiral shell"],
      u: "1f41a",
      a: "0.6"
    },
    {
      n: ["coral"],
      u: "1fab8",
      a: "14.0"
    },
    {
      n: ["snail"],
      u: "1f40c",
      a: "0.6"
    },
    {
      n: ["butterfly"],
      u: "1f98b",
      a: "3.0"
    },
    {
      n: ["bug"],
      u: "1f41b",
      a: "0.6"
    },
    {
      n: ["ant"],
      u: "1f41c",
      a: "0.6"
    },
    {
      n: ["bee", "honeybee"],
      u: "1f41d",
      a: "0.6"
    },
    {
      n: ["beetle"],
      u: "1fab2",
      a: "13.0"
    },
    {
      n: ["ladybug", "lady beetle"],
      u: "1f41e",
      a: "0.6"
    },
    {
      n: ["cricket"],
      u: "1f997",
      a: "5.0"
    },
    {
      n: ["cockroach"],
      u: "1fab3",
      a: "13.0"
    },
    {
      n: ["spider"],
      u: "1f577-fe0f",
      a: "0.7"
    },
    {
      n: ["spider web"],
      u: "1f578-fe0f",
      a: "0.7"
    },
    {
      n: ["scorpion"],
      u: "1f982",
      a: "1.0"
    },
    {
      n: ["mosquito"],
      u: "1f99f",
      a: "11.0"
    },
    {
      n: ["fly"],
      u: "1fab0",
      a: "13.0"
    },
    {
      n: ["worm"],
      u: "1fab1",
      a: "13.0"
    },
    {
      n: ["microbe"],
      u: "1f9a0",
      a: "11.0"
    },
    {
      n: ["bouquet"],
      u: "1f490",
      a: "0.6"
    },
    {
      n: ["cherry blossom"],
      u: "1f338",
      a: "0.6"
    },
    {
      n: ["white flower"],
      u: "1f4ae",
      a: "0.6"
    },
    {
      n: ["lotus"],
      u: "1fab7",
      a: "14.0"
    },
    {
      n: ["rosette"],
      u: "1f3f5-fe0f",
      a: "0.7"
    },
    {
      n: ["rose"],
      u: "1f339",
      a: "0.6"
    },
    {
      n: ["wilted flower"],
      u: "1f940",
      a: "3.0"
    },
    {
      n: ["hibiscus"],
      u: "1f33a",
      a: "0.6"
    },
    {
      n: ["sunflower"],
      u: "1f33b",
      a: "0.6"
    },
    {
      n: ["blossom"],
      u: "1f33c",
      a: "0.6"
    },
    {
      n: ["tulip"],
      u: "1f337",
      a: "0.6"
    },
    {
      n: ["seedling"],
      u: "1f331",
      a: "0.6"
    },
    {
      n: ["potted plant"],
      u: "1fab4",
      a: "13.0"
    },
    {
      n: ["evergreen tree"],
      u: "1f332",
      a: "1.0"
    },
    {
      n: ["deciduous tree"],
      u: "1f333",
      a: "1.0"
    },
    {
      n: ["palm tree"],
      u: "1f334",
      a: "0.6"
    },
    {
      n: ["cactus"],
      u: "1f335",
      a: "0.6"
    },
    {
      n: ["ear of rice"],
      u: "1f33e",
      a: "0.6"
    },
    {
      n: ["herb"],
      u: "1f33f",
      a: "0.6"
    },
    {
      n: ["shamrock"],
      u: "2618-fe0f",
      a: "1.0"
    },
    {
      n: ["four leaf clover"],
      u: "1f340",
      a: "0.6"
    },
    {
      n: ["maple leaf"],
      u: "1f341",
      a: "0.6"
    },
    {
      n: ["fallen leaf"],
      u: "1f342",
      a: "0.6"
    },
    {
      n: ["leaves", "leaf fluttering in wind"],
      u: "1f343",
      a: "0.6"
    },
    {
      n: ["empty nest"],
      u: "1fab9",
      a: "14.0"
    },
    {
      n: ["nest with eggs"],
      u: "1faba",
      a: "14.0"
    }
  ],
  food_drink: [
    {
      n: ["grapes"],
      u: "1f347",
      a: "0.6"
    },
    {
      n: ["melon"],
      u: "1f348",
      a: "0.6"
    },
    {
      n: ["watermelon"],
      u: "1f349",
      a: "0.6"
    },
    {
      n: ["tangerine"],
      u: "1f34a",
      a: "0.6"
    },
    {
      n: ["lemon"],
      u: "1f34b",
      a: "1.0"
    },
    {
      n: ["banana"],
      u: "1f34c",
      a: "0.6"
    },
    {
      n: ["pineapple"],
      u: "1f34d",
      a: "0.6"
    },
    {
      n: ["mango"],
      u: "1f96d",
      a: "11.0"
    },
    {
      n: ["apple", "red apple"],
      u: "1f34e",
      a: "0.6"
    },
    {
      n: ["green apple"],
      u: "1f34f",
      a: "0.6"
    },
    {
      n: ["pear"],
      u: "1f350",
      a: "1.0"
    },
    {
      n: ["peach"],
      u: "1f351",
      a: "0.6"
    },
    {
      n: ["cherries"],
      u: "1f352",
      a: "0.6"
    },
    {
      n: ["strawberry"],
      u: "1f353",
      a: "0.6"
    },
    {
      n: ["blueberries"],
      u: "1fad0",
      a: "13.0"
    },
    {
      n: ["kiwifruit"],
      u: "1f95d",
      a: "3.0"
    },
    {
      n: ["tomato"],
      u: "1f345",
      a: "0.6"
    },
    {
      n: ["olive"],
      u: "1fad2",
      a: "13.0"
    },
    {
      n: ["coconut"],
      u: "1f965",
      a: "5.0"
    },
    {
      n: ["avocado"],
      u: "1f951",
      a: "3.0"
    },
    {
      n: ["eggplant", "aubergine"],
      u: "1f346",
      a: "0.6"
    },
    {
      n: ["potato"],
      u: "1f954",
      a: "3.0"
    },
    {
      n: ["carrot"],
      u: "1f955",
      a: "3.0"
    },
    {
      n: ["corn", "ear of maize"],
      u: "1f33d",
      a: "0.6"
    },
    {
      n: ["hot pepper"],
      u: "1f336-fe0f",
      a: "0.7"
    },
    {
      n: ["bell pepper"],
      u: "1fad1",
      a: "13.0"
    },
    {
      n: ["cucumber"],
      u: "1f952",
      a: "3.0"
    },
    {
      n: ["leafy green"],
      u: "1f96c",
      a: "11.0"
    },
    {
      n: ["broccoli"],
      u: "1f966",
      a: "5.0"
    },
    {
      n: ["garlic"],
      u: "1f9c4",
      a: "12.0"
    },
    {
      n: ["onion"],
      u: "1f9c5",
      a: "12.0"
    },
    {
      n: ["mushroom"],
      u: "1f344",
      a: "0.6"
    },
    {
      n: ["peanuts"],
      u: "1f95c",
      a: "3.0"
    },
    {
      n: ["beans"],
      u: "1fad8",
      a: "14.0"
    },
    {
      n: ["chestnut"],
      u: "1f330",
      a: "0.6"
    },
    {
      n: ["bread"],
      u: "1f35e",
      a: "0.6"
    },
    {
      n: ["croissant"],
      u: "1f950",
      a: "3.0"
    },
    {
      n: ["baguette bread"],
      u: "1f956",
      a: "3.0"
    },
    {
      n: ["flatbread"],
      u: "1fad3",
      a: "13.0"
    },
    {
      n: ["pretzel"],
      u: "1f968",
      a: "5.0"
    },
    {
      n: ["bagel"],
      u: "1f96f",
      a: "11.0"
    },
    {
      n: ["pancakes"],
      u: "1f95e",
      a: "3.0"
    },
    {
      n: ["waffle"],
      u: "1f9c7",
      a: "12.0"
    },
    {
      n: ["cheese wedge"],
      u: "1f9c0",
      a: "1.0"
    },
    {
      n: ["meat on bone"],
      u: "1f356",
      a: "0.6"
    },
    {
      n: ["poultry leg"],
      u: "1f357",
      a: "0.6"
    },
    {
      n: ["cut of meat"],
      u: "1f969",
      a: "5.0"
    },
    {
      n: ["bacon"],
      u: "1f953",
      a: "3.0"
    },
    {
      n: ["hamburger"],
      u: "1f354",
      a: "0.6"
    },
    {
      n: ["fries", "french fries"],
      u: "1f35f",
      a: "0.6"
    },
    {
      n: ["pizza", "slice of pizza"],
      u: "1f355",
      a: "0.6"
    },
    {
      n: ["hotdog", "hot dog"],
      u: "1f32d",
      a: "1.0"
    },
    {
      n: ["sandwich"],
      u: "1f96a",
      a: "5.0"
    },
    {
      n: ["taco"],
      u: "1f32e",
      a: "1.0"
    },
    {
      n: ["burrito"],
      u: "1f32f",
      a: "1.0"
    },
    {
      n: ["tamale"],
      u: "1fad4",
      a: "13.0"
    },
    {
      n: ["stuffed flatbread"],
      u: "1f959",
      a: "3.0"
    },
    {
      n: ["falafel"],
      u: "1f9c6",
      a: "12.0"
    },
    {
      n: ["egg"],
      u: "1f95a",
      a: "3.0"
    },
    {
      n: ["cooking", "fried egg"],
      u: "1f373",
      a: "0.6"
    },
    {
      n: ["shallow pan of food"],
      u: "1f958",
      a: "3.0"
    },
    {
      n: ["stew", "pot of food"],
      u: "1f372",
      a: "0.6"
    },
    {
      n: ["fondue"],
      u: "1fad5",
      a: "13.0"
    },
    {
      n: ["bowl with spoon"],
      u: "1f963",
      a: "5.0"
    },
    {
      n: ["green salad"],
      u: "1f957",
      a: "3.0"
    },
    {
      n: ["popcorn"],
      u: "1f37f",
      a: "1.0"
    },
    {
      n: ["butter"],
      u: "1f9c8",
      a: "12.0"
    },
    {
      n: ["salt", "salt shaker"],
      u: "1f9c2",
      a: "11.0"
    },
    {
      n: ["canned food"],
      u: "1f96b",
      a: "5.0"
    },
    {
      n: ["bento", "bento box"],
      u: "1f371",
      a: "0.6"
    },
    {
      n: ["rice cracker"],
      u: "1f358",
      a: "0.6"
    },
    {
      n: ["rice ball"],
      u: "1f359",
      a: "0.6"
    },
    {
      n: ["rice", "cooked rice"],
      u: "1f35a",
      a: "0.6"
    },
    {
      n: ["curry", "curry and rice"],
      u: "1f35b",
      a: "0.6"
    },
    {
      n: ["ramen", "steaming bowl"],
      u: "1f35c",
      a: "0.6"
    },
    {
      n: ["spaghetti"],
      u: "1f35d",
      a: "0.6"
    },
    {
      n: ["sweet potato", "roasted sweet potato"],
      u: "1f360",
      a: "0.6"
    },
    {
      n: ["oden"],
      u: "1f362",
      a: "0.6"
    },
    {
      n: ["sushi"],
      u: "1f363",
      a: "0.6"
    },
    {
      n: ["fried shrimp"],
      u: "1f364",
      a: "0.6"
    },
    {
      n: ["fish cake", "fish cake with swirl design"],
      u: "1f365",
      a: "0.6"
    },
    {
      n: ["moon cake"],
      u: "1f96e",
      a: "11.0"
    },
    {
      n: ["dango"],
      u: "1f361",
      a: "0.6"
    },
    {
      n: ["dumpling"],
      u: "1f95f",
      a: "5.0"
    },
    {
      n: ["fortune cookie"],
      u: "1f960",
      a: "5.0"
    },
    {
      n: ["takeout box"],
      u: "1f961",
      a: "5.0"
    },
    {
      n: ["crab"],
      u: "1f980",
      a: "1.0"
    },
    {
      n: ["lobster"],
      u: "1f99e",
      a: "11.0"
    },
    {
      n: ["shrimp"],
      u: "1f990",
      a: "3.0"
    },
    {
      n: ["squid"],
      u: "1f991",
      a: "3.0"
    },
    {
      n: ["oyster"],
      u: "1f9aa",
      a: "12.0"
    },
    {
      n: ["icecream", "soft ice cream"],
      u: "1f366",
      a: "0.6"
    },
    {
      n: ["shaved ice"],
      u: "1f367",
      a: "0.6"
    },
    {
      n: ["ice cream"],
      u: "1f368",
      a: "0.6"
    },
    {
      n: ["doughnut"],
      u: "1f369",
      a: "0.6"
    },
    {
      n: ["cookie"],
      u: "1f36a",
      a: "0.6"
    },
    {
      n: ["birthday", "birthday cake"],
      u: "1f382",
      a: "0.6"
    },
    {
      n: ["cake", "shortcake"],
      u: "1f370",
      a: "0.6"
    },
    {
      n: ["cupcake"],
      u: "1f9c1",
      a: "11.0"
    },
    {
      n: ["pie"],
      u: "1f967",
      a: "5.0"
    },
    {
      n: ["chocolate bar"],
      u: "1f36b",
      a: "0.6"
    },
    {
      n: ["candy"],
      u: "1f36c",
      a: "0.6"
    },
    {
      n: ["lollipop"],
      u: "1f36d",
      a: "0.6"
    },
    {
      n: ["custard"],
      u: "1f36e",
      a: "0.6"
    },
    {
      n: ["honey pot"],
      u: "1f36f",
      a: "0.6"
    },
    {
      n: ["baby bottle"],
      u: "1f37c",
      a: "1.0"
    },
    {
      n: ["glass of milk"],
      u: "1f95b",
      a: "3.0"
    },
    {
      n: ["coffee", "hot beverage"],
      u: "2615",
      a: "0.6"
    },
    {
      n: ["teapot"],
      u: "1fad6",
      a: "13.0"
    },
    {
      n: ["tea", "teacup without handle"],
      u: "1f375",
      a: "0.6"
    },
    {
      n: ["sake", "sake bottle and cup"],
      u: "1f376",
      a: "0.6"
    },
    {
      n: ["champagne", "bottle with popping cork"],
      u: "1f37e",
      a: "1.0"
    },
    {
      n: ["wine glass"],
      u: "1f377",
      a: "0.6"
    },
    {
      n: ["cocktail", "cocktail glass"],
      u: "1f378",
      a: "0.6"
    },
    {
      n: ["tropical drink"],
      u: "1f379",
      a: "0.6"
    },
    {
      n: ["beer", "beer mug"],
      u: "1f37a",
      a: "0.6"
    },
    {
      n: ["beers", "clinking beer mugs"],
      u: "1f37b",
      a: "0.6"
    },
    {
      n: ["clinking glasses"],
      u: "1f942",
      a: "3.0"
    },
    {
      n: ["tumbler glass"],
      u: "1f943",
      a: "3.0"
    },
    {
      n: ["pouring liquid"],
      u: "1fad7",
      a: "14.0"
    },
    {
      n: ["cup with straw"],
      u: "1f964",
      a: "5.0"
    },
    {
      n: ["bubble tea"],
      u: "1f9cb",
      a: "13.0"
    },
    {
      n: ["beverage box"],
      u: "1f9c3",
      a: "12.0"
    },
    {
      n: ["mate drink"],
      u: "1f9c9",
      a: "12.0"
    },
    {
      n: ["ice cube"],
      u: "1f9ca",
      a: "12.0"
    },
    {
      n: ["chopsticks"],
      u: "1f962",
      a: "5.0"
    },
    {
      n: ["knife fork plate", "fork and knife with plate"],
      u: "1f37d-fe0f",
      a: "0.7"
    },
    {
      n: ["fork and knife"],
      u: "1f374",
      a: "0.6"
    },
    {
      n: ["spoon"],
      u: "1f944",
      a: "3.0"
    },
    {
      n: ["hocho", "knife"],
      u: "1f52a",
      a: "0.6"
    },
    {
      n: ["jar"],
      u: "1fad9",
      a: "14.0"
    },
    {
      n: ["amphora"],
      u: "1f3fa",
      a: "1.0"
    }
  ],
  travel_places: [
    {
      n: ["earth africa", "earth globe europe-africa"],
      u: "1f30d",
      a: "0.7"
    },
    {
      n: ["earth americas", "earth globe americas"],
      u: "1f30e",
      a: "0.7"
    },
    {
      n: ["earth asia", "earth globe asia-australia"],
      u: "1f30f",
      a: "0.6"
    },
    {
      n: ["globe with meridians"],
      u: "1f310",
      a: "1.0"
    },
    {
      n: ["world map"],
      u: "1f5fa-fe0f",
      a: "0.7"
    },
    {
      n: ["japan", "silhouette of japan"],
      u: "1f5fe",
      a: "0.6"
    },
    {
      n: ["compass"],
      u: "1f9ed",
      a: "11.0"
    },
    {
      n: ["snow-capped mountain", "snow capped mountain"],
      u: "1f3d4-fe0f",
      a: "0.7"
    },
    {
      n: ["mountain"],
      u: "26f0-fe0f",
      a: "0.7"
    },
    {
      n: ["volcano"],
      u: "1f30b",
      a: "0.6"
    },
    {
      n: ["mount fuji"],
      u: "1f5fb",
      a: "0.6"
    },
    {
      n: ["camping"],
      u: "1f3d5-fe0f",
      a: "0.7"
    },
    {
      n: ["beach with umbrella"],
      u: "1f3d6-fe0f",
      a: "0.7"
    },
    {
      n: ["desert"],
      u: "1f3dc-fe0f",
      a: "0.7"
    },
    {
      n: ["desert island"],
      u: "1f3dd-fe0f",
      a: "0.7"
    },
    {
      n: ["national park"],
      u: "1f3de-fe0f",
      a: "0.7"
    },
    {
      n: ["stadium"],
      u: "1f3df-fe0f",
      a: "0.7"
    },
    {
      n: ["classical building"],
      u: "1f3db-fe0f",
      a: "0.7"
    },
    {
      n: ["building construction"],
      u: "1f3d7-fe0f",
      a: "0.7"
    },
    {
      n: ["brick", "bricks"],
      u: "1f9f1",
      a: "11.0"
    },
    {
      n: ["rock"],
      u: "1faa8",
      a: "13.0"
    },
    {
      n: ["wood"],
      u: "1fab5",
      a: "13.0"
    },
    {
      n: ["hut"],
      u: "1f6d6",
      a: "13.0"
    },
    {
      n: ["houses", "house buildings"],
      u: "1f3d8-fe0f",
      a: "0.7"
    },
    {
      n: ["derelict house", "derelict house building"],
      u: "1f3da-fe0f",
      a: "0.7"
    },
    {
      n: ["house", "house building"],
      u: "1f3e0",
      a: "0.6"
    },
    {
      n: ["house with garden"],
      u: "1f3e1",
      a: "0.6"
    },
    {
      n: ["office", "office building"],
      u: "1f3e2",
      a: "0.6"
    },
    {
      n: ["post office", "japanese post office"],
      u: "1f3e3",
      a: "0.6"
    },
    {
      n: ["european post office"],
      u: "1f3e4",
      a: "1.0"
    },
    {
      n: ["hospital"],
      u: "1f3e5",
      a: "0.6"
    },
    {
      n: ["bank"],
      u: "1f3e6",
      a: "0.6"
    },
    {
      n: ["hotel"],
      u: "1f3e8",
      a: "0.6"
    },
    {
      n: ["love hotel"],
      u: "1f3e9",
      a: "0.6"
    },
    {
      n: ["convenience store"],
      u: "1f3ea",
      a: "0.6"
    },
    {
      n: ["school"],
      u: "1f3eb",
      a: "0.6"
    },
    {
      n: ["department store"],
      u: "1f3ec",
      a: "0.6"
    },
    {
      n: ["factory"],
      u: "1f3ed",
      a: "0.6"
    },
    {
      n: ["japanese castle"],
      u: "1f3ef",
      a: "0.6"
    },
    {
      n: ["european castle"],
      u: "1f3f0",
      a: "0.6"
    },
    {
      n: ["wedding"],
      u: "1f492",
      a: "0.6"
    },
    {
      n: ["tokyo tower"],
      u: "1f5fc",
      a: "0.6"
    },
    {
      n: ["statue of liberty"],
      u: "1f5fd",
      a: "0.6"
    },
    {
      n: ["church"],
      u: "26ea",
      a: "0.6"
    },
    {
      n: ["mosque"],
      u: "1f54c",
      a: "1.0"
    },
    {
      n: ["hindu temple"],
      u: "1f6d5",
      a: "12.0"
    },
    {
      n: ["synagogue"],
      u: "1f54d",
      a: "1.0"
    },
    {
      n: ["shinto shrine"],
      u: "26e9-fe0f",
      a: "0.7"
    },
    {
      n: ["kaaba"],
      u: "1f54b",
      a: "1.0"
    },
    {
      n: ["fountain"],
      u: "26f2",
      a: "0.6"
    },
    {
      n: ["tent"],
      u: "26fa",
      a: "0.6"
    },
    {
      n: ["foggy"],
      u: "1f301",
      a: "0.6"
    },
    {
      n: ["night with stars"],
      u: "1f303",
      a: "0.6"
    },
    {
      n: ["cityscape"],
      u: "1f3d9-fe0f",
      a: "0.7"
    },
    {
      n: ["sunrise over mountains"],
      u: "1f304",
      a: "0.6"
    },
    {
      n: ["sunrise"],
      u: "1f305",
      a: "0.6"
    },
    {
      n: ["city sunset", "cityscape at dusk"],
      u: "1f306",
      a: "0.6"
    },
    {
      n: ["city sunrise", "sunset over buildings"],
      u: "1f307",
      a: "0.6"
    },
    {
      n: ["bridge at night"],
      u: "1f309",
      a: "0.6"
    },
    {
      n: ["hotsprings", "hot springs"],
      u: "2668-fe0f",
      a: "0.6"
    },
    {
      n: ["carousel horse"],
      u: "1f3a0",
      a: "0.6"
    },
    {
      n: ["playground slide"],
      u: "1f6dd",
      a: "14.0"
    },
    {
      n: ["ferris wheel"],
      u: "1f3a1",
      a: "0.6"
    },
    {
      n: ["roller coaster"],
      u: "1f3a2",
      a: "0.6"
    },
    {
      n: ["barber", "barber pole"],
      u: "1f488",
      a: "0.6"
    },
    {
      n: ["circus tent"],
      u: "1f3aa",
      a: "0.6"
    },
    {
      n: ["steam locomotive"],
      u: "1f682",
      a: "1.0"
    },
    {
      n: ["railway car"],
      u: "1f683",
      a: "0.6"
    },
    {
      n: ["high-speed train", "bullettrain side"],
      u: "1f684",
      a: "0.6"
    },
    {
      n: ["bullettrain front", "high-speed train with bullet nose"],
      u: "1f685",
      a: "0.6"
    },
    {
      n: ["train", "train2"],
      u: "1f686",
      a: "1.0"
    },
    {
      n: ["metro"],
      u: "1f687",
      a: "0.6"
    },
    {
      n: ["light rail"],
      u: "1f688",
      a: "1.0"
    },
    {
      n: ["station"],
      u: "1f689",
      a: "0.6"
    },
    {
      n: ["tram"],
      u: "1f68a",
      a: "1.0"
    },
    {
      n: ["monorail"],
      u: "1f69d",
      a: "1.0"
    },
    {
      n: ["mountain railway"],
      u: "1f69e",
      a: "1.0"
    },
    {
      n: ["train", "tram car"],
      u: "1f68b",
      a: "1.0"
    },
    {
      n: ["bus"],
      u: "1f68c",
      a: "0.6"
    },
    {
      n: ["oncoming bus"],
      u: "1f68d",
      a: "0.7"
    },
    {
      n: ["trolleybus"],
      u: "1f68e",
      a: "1.0"
    },
    {
      n: ["minibus"],
      u: "1f690",
      a: "1.0"
    },
    {
      n: ["ambulance"],
      u: "1f691",
      a: "0.6"
    },
    {
      n: ["fire engine"],
      u: "1f692",
      a: "0.6"
    },
    {
      n: ["police car"],
      u: "1f693",
      a: "0.6"
    },
    {
      n: ["oncoming police car"],
      u: "1f694",
      a: "0.7"
    },
    {
      n: ["taxi"],
      u: "1f695",
      a: "0.6"
    },
    {
      n: ["oncoming taxi"],
      u: "1f696",
      a: "1.0"
    },
    {
      n: ["car", "red car", "automobile"],
      u: "1f697",
      a: "0.6"
    },
    {
      n: ["oncoming automobile"],
      u: "1f698",
      a: "0.7"
    },
    {
      n: ["blue car", "recreational vehicle"],
      u: "1f699",
      a: "0.6"
    },
    {
      n: ["pickup truck"],
      u: "1f6fb",
      a: "13.0"
    },
    {
      n: ["truck", "delivery truck"],
      u: "1f69a",
      a: "0.6"
    },
    {
      n: ["articulated lorry"],
      u: "1f69b",
      a: "1.0"
    },
    {
      n: ["tractor"],
      u: "1f69c",
      a: "1.0"
    },
    {
      n: ["racing car"],
      u: "1f3ce-fe0f",
      a: "0.7"
    },
    {
      n: ["motorcycle", "racing motorcycle"],
      u: "1f3cd-fe0f",
      a: "0.7"
    },
    {
      n: ["motor scooter"],
      u: "1f6f5",
      a: "3.0"
    },
    {
      n: ["manual wheelchair"],
      u: "1f9bd",
      a: "12.0"
    },
    {
      n: ["motorized wheelchair"],
      u: "1f9bc",
      a: "12.0"
    },
    {
      n: ["auto rickshaw"],
      u: "1f6fa",
      a: "12.0"
    },
    {
      n: ["bike", "bicycle"],
      u: "1f6b2",
      a: "0.6"
    },
    {
      n: ["scooter"],
      u: "1f6f4",
      a: "3.0"
    },
    {
      n: ["skateboard"],
      u: "1f6f9",
      a: "11.0"
    },
    {
      n: ["roller skate"],
      u: "1f6fc",
      a: "13.0"
    },
    {
      n: ["busstop", "bus stop"],
      u: "1f68f",
      a: "0.6"
    },
    {
      n: ["motorway"],
      u: "1f6e3-fe0f",
      a: "0.7"
    },
    {
      n: ["railway track"],
      u: "1f6e4-fe0f",
      a: "0.7"
    },
    {
      n: ["oil drum"],
      u: "1f6e2-fe0f",
      a: "0.7"
    },
    {
      n: ["fuelpump", "fuel pump"],
      u: "26fd",
      a: "0.6"
    },
    {
      n: ["wheel"],
      u: "1f6de",
      a: "14.0"
    },
    {
      n: ["rotating light", "police cars revolving light"],
      u: "1f6a8",
      a: "0.6"
    },
    {
      n: ["traffic light", "horizontal traffic light"],
      u: "1f6a5",
      a: "0.6"
    },
    {
      n: ["vertical traffic light"],
      u: "1f6a6",
      a: "1.0"
    },
    {
      n: ["octagonal sign"],
      u: "1f6d1",
      a: "3.0"
    },
    {
      n: ["construction", "construction sign"],
      u: "1f6a7",
      a: "0.6"
    },
    {
      n: ["anchor"],
      u: "2693",
      a: "0.6"
    },
    {
      n: ["ring buoy"],
      u: "1f6df",
      a: "14.0"
    },
    {
      n: ["boat", "sailboat"],
      u: "26f5",
      a: "0.6"
    },
    {
      n: ["canoe"],
      u: "1f6f6",
      a: "3.0"
    },
    {
      n: ["speedboat"],
      u: "1f6a4",
      a: "0.6"
    },
    {
      n: ["passenger ship"],
      u: "1f6f3-fe0f",
      a: "0.7"
    },
    {
      n: ["ferry"],
      u: "26f4-fe0f",
      a: "0.7"
    },
    {
      n: ["motor boat"],
      u: "1f6e5-fe0f",
      a: "0.7"
    },
    {
      n: ["ship"],
      u: "1f6a2",
      a: "0.6"
    },
    {
      n: ["airplane"],
      u: "2708-fe0f",
      a: "0.6"
    },
    {
      n: ["small airplane"],
      u: "1f6e9-fe0f",
      a: "0.7"
    },
    {
      n: ["airplane departure"],
      u: "1f6eb",
      a: "1.0"
    },
    {
      n: ["airplane arriving"],
      u: "1f6ec",
      a: "1.0"
    },
    {
      n: ["parachute"],
      u: "1fa82",
      a: "12.0"
    },
    {
      n: ["seat"],
      u: "1f4ba",
      a: "0.6"
    },
    {
      n: ["helicopter"],
      u: "1f681",
      a: "1.0"
    },
    {
      n: ["suspension railway"],
      u: "1f69f",
      a: "1.0"
    },
    {
      n: ["mountain cableway"],
      u: "1f6a0",
      a: "1.0"
    },
    {
      n: ["aerial tramway"],
      u: "1f6a1",
      a: "1.0"
    },
    {
      n: ["satellite"],
      u: "1f6f0-fe0f",
      a: "0.7"
    },
    {
      n: ["rocket"],
      u: "1f680",
      a: "0.6"
    },
    {
      n: ["flying saucer"],
      u: "1f6f8",
      a: "5.0"
    },
    {
      n: ["bellhop bell"],
      u: "1f6ce-fe0f",
      a: "0.7"
    },
    {
      n: ["luggage"],
      u: "1f9f3",
      a: "11.0"
    },
    {
      n: ["hourglass"],
      u: "231b",
      a: "0.6"
    },
    {
      n: ["hourglass flowing sand", "hourglass with flowing sand"],
      u: "23f3",
      a: "0.6"
    },
    {
      n: ["watch"],
      u: "231a",
      a: "0.6"
    },
    {
      n: ["alarm clock"],
      u: "23f0",
      a: "0.6"
    },
    {
      n: ["stopwatch"],
      u: "23f1-fe0f",
      a: "1.0"
    },
    {
      n: ["timer clock"],
      u: "23f2-fe0f",
      a: "1.0"
    },
    {
      n: ["mantelpiece clock"],
      u: "1f570-fe0f",
      a: "0.7"
    },
    {
      n: ["clock12", "clock face twelve oclock"],
      u: "1f55b",
      a: "0.6"
    },
    {
      n: ["clock1230", "clock face twelve-thirty"],
      u: "1f567",
      a: "0.7"
    },
    {
      n: ["clock1", "clock face one oclock"],
      u: "1f550",
      a: "0.6"
    },
    {
      n: ["clock130", "clock face one-thirty"],
      u: "1f55c",
      a: "0.7"
    },
    {
      n: ["clock2", "clock face two oclock"],
      u: "1f551",
      a: "0.6"
    },
    {
      n: ["clock230", "clock face two-thirty"],
      u: "1f55d",
      a: "0.7"
    },
    {
      n: ["clock3", "clock face three oclock"],
      u: "1f552",
      a: "0.6"
    },
    {
      n: ["clock330", "clock face three-thirty"],
      u: "1f55e",
      a: "0.7"
    },
    {
      n: ["clock4", "clock face four oclock"],
      u: "1f553",
      a: "0.6"
    },
    {
      n: ["clock430", "clock face four-thirty"],
      u: "1f55f",
      a: "0.7"
    },
    {
      n: ["clock5", "clock face five oclock"],
      u: "1f554",
      a: "0.6"
    },
    {
      n: ["clock530", "clock face five-thirty"],
      u: "1f560",
      a: "0.7"
    },
    {
      n: ["clock6", "clock face six oclock"],
      u: "1f555",
      a: "0.6"
    },
    {
      n: ["clock630", "clock face six-thirty"],
      u: "1f561",
      a: "0.7"
    },
    {
      n: ["clock7", "clock face seven oclock"],
      u: "1f556",
      a: "0.6"
    },
    {
      n: ["clock730", "clock face seven-thirty"],
      u: "1f562",
      a: "0.7"
    },
    {
      n: ["clock8", "clock face eight oclock"],
      u: "1f557",
      a: "0.6"
    },
    {
      n: ["clock830", "clock face eight-thirty"],
      u: "1f563",
      a: "0.7"
    },
    {
      n: ["clock9", "clock face nine oclock"],
      u: "1f558",
      a: "0.6"
    },
    {
      n: ["clock930", "clock face nine-thirty"],
      u: "1f564",
      a: "0.7"
    },
    {
      n: ["clock10", "clock face ten oclock"],
      u: "1f559",
      a: "0.6"
    },
    {
      n: ["clock1030", "clock face ten-thirty"],
      u: "1f565",
      a: "0.7"
    },
    {
      n: ["clock11", "clock face eleven oclock"],
      u: "1f55a",
      a: "0.6"
    },
    {
      n: ["clock1130", "clock face eleven-thirty"],
      u: "1f566",
      a: "0.7"
    },
    {
      n: ["new moon", "new moon symbol"],
      u: "1f311",
      a: "0.6"
    },
    {
      n: ["waxing crescent moon", "waxing crescent moon symbol"],
      u: "1f312",
      a: "1.0"
    },
    {
      n: ["first quarter moon", "first quarter moon symbol"],
      u: "1f313",
      a: "0.6"
    },
    {
      n: ["moon", "waxing gibbous moon", "waxing gibbous moon symbol"],
      u: "1f314",
      a: "0.6"
    },
    {
      n: ["full moon", "full moon symbol"],
      u: "1f315",
      a: "0.6"
    },
    {
      n: ["waning gibbous moon", "waning gibbous moon symbol"],
      u: "1f316",
      a: "1.0"
    },
    {
      n: ["last quarter moon", "last quarter moon symbol"],
      u: "1f317",
      a: "1.0"
    },
    {
      n: ["waning crescent moon", "waning crescent moon symbol"],
      u: "1f318",
      a: "1.0"
    },
    {
      n: ["crescent moon"],
      u: "1f319",
      a: "0.6"
    },
    {
      n: ["new moon with face"],
      u: "1f31a",
      a: "1.0"
    },
    {
      n: ["first quarter moon with face"],
      u: "1f31b",
      a: "0.6"
    },
    {
      n: ["last quarter moon with face"],
      u: "1f31c",
      a: "0.7"
    },
    {
      n: ["thermometer"],
      u: "1f321-fe0f",
      a: "0.7"
    },
    {
      n: ["sunny", "black sun with rays"],
      u: "2600-fe0f",
      a: "0.6"
    },
    {
      n: ["full moon with face"],
      u: "1f31d",
      a: "1.0"
    },
    {
      n: ["sun with face"],
      u: "1f31e",
      a: "1.0"
    },
    {
      n: ["ringed planet"],
      u: "1fa90",
      a: "12.0"
    },
    {
      n: ["star", "white medium star"],
      u: "2b50",
      a: "0.6"
    },
    {
      n: ["star2", "glowing star"],
      u: "1f31f",
      a: "0.6"
    },
    {
      n: ["stars", "shooting star"],
      u: "1f320",
      a: "0.6"
    },
    {
      n: ["milky way"],
      u: "1f30c",
      a: "0.6"
    },
    {
      n: ["cloud"],
      u: "2601-fe0f",
      a: "0.6"
    },
    {
      n: ["partly sunny", "sun behind cloud"],
      u: "26c5",
      a: "0.6"
    },
    {
      n: ["thunder cloud and rain", "cloud with lightning and rain"],
      u: "26c8-fe0f",
      a: "0.7"
    },
    {
      n: ["mostly sunny", "sun small cloud", "sun behind small cloud"],
      u: "1f324-fe0f",
      a: "0.7"
    },
    {
      n: ["barely sunny", "sun behind cloud", "sun behind large cloud"],
      u: "1f325-fe0f",
      a: "0.7"
    },
    {
      n: ["partly sunny rain", "sun behind rain cloud"],
      u: "1f326-fe0f",
      a: "0.7"
    },
    {
      n: ["rain cloud", "cloud with rain"],
      u: "1f327-fe0f",
      a: "0.7"
    },
    {
      n: ["snow cloud", "cloud with snow"],
      u: "1f328-fe0f",
      a: "0.7"
    },
    {
      n: ["lightning", "lightning cloud", "cloud with lightning"],
      u: "1f329-fe0f",
      a: "0.7"
    },
    {
      n: ["tornado", "tornado cloud"],
      u: "1f32a-fe0f",
      a: "0.7"
    },
    {
      n: ["fog"],
      u: "1f32b-fe0f",
      a: "0.7"
    },
    {
      n: ["wind face", "wind blowing face"],
      u: "1f32c-fe0f",
      a: "0.7"
    },
    {
      n: ["cyclone"],
      u: "1f300",
      a: "0.6"
    },
    {
      n: ["rainbow"],
      u: "1f308",
      a: "0.6"
    },
    {
      n: ["closed umbrella"],
      u: "1f302",
      a: "0.6"
    },
    {
      n: ["umbrella"],
      u: "2602-fe0f",
      a: "0.7"
    },
    {
      n: ["umbrella with rain drops"],
      u: "2614",
      a: "0.6"
    },
    {
      n: ["umbrella on ground"],
      u: "26f1-fe0f",
      a: "0.7"
    },
    {
      n: ["zap", "high voltage sign"],
      u: "26a1",
      a: "0.6"
    },
    {
      n: ["snowflake"],
      u: "2744-fe0f",
      a: "0.6"
    },
    {
      n: ["snowman"],
      u: "2603-fe0f",
      a: "0.7"
    },
    {
      n: ["snowman without snow"],
      u: "26c4",
      a: "0.6"
    },
    {
      n: ["comet"],
      u: "2604-fe0f",
      a: "1.0"
    },
    {
      n: ["fire"],
      u: "1f525",
      a: "0.6"
    },
    {
      n: ["droplet"],
      u: "1f4a7",
      a: "0.6"
    },
    {
      n: ["ocean", "water wave"],
      u: "1f30a",
      a: "0.6"
    }
  ],
  activities: [
    {
      n: ["jack-o-lantern", "jack o lantern"],
      u: "1f383",
      a: "0.6"
    },
    {
      n: ["christmas tree"],
      u: "1f384",
      a: "0.6"
    },
    {
      n: ["fireworks"],
      u: "1f386",
      a: "0.6"
    },
    {
      n: ["sparkler", "firework sparkler"],
      u: "1f387",
      a: "0.6"
    },
    {
      n: ["firecracker"],
      u: "1f9e8",
      a: "11.0"
    },
    {
      n: ["sparkles"],
      u: "2728",
      a: "0.6"
    },
    {
      n: ["balloon"],
      u: "1f388",
      a: "0.6"
    },
    {
      n: ["tada", "party popper"],
      u: "1f389",
      a: "0.6"
    },
    {
      n: ["confetti ball"],
      u: "1f38a",
      a: "0.6"
    },
    {
      n: ["tanabata tree"],
      u: "1f38b",
      a: "0.6"
    },
    {
      n: ["bamboo", "pine decoration"],
      u: "1f38d",
      a: "0.6"
    },
    {
      n: ["dolls", "japanese dolls"],
      u: "1f38e",
      a: "0.6"
    },
    {
      n: ["flags", "carp streamer"],
      u: "1f38f",
      a: "0.6"
    },
    {
      n: ["wind chime"],
      u: "1f390",
      a: "0.6"
    },
    {
      n: ["rice scene", "moon viewing ceremony"],
      u: "1f391",
      a: "0.6"
    },
    {
      n: ["red envelope", "red gift envelope"],
      u: "1f9e7",
      a: "11.0"
    },
    {
      n: ["ribbon"],
      u: "1f380",
      a: "0.6"
    },
    {
      n: ["gift", "wrapped present"],
      u: "1f381",
      a: "0.6"
    },
    {
      n: ["reminder ribbon"],
      u: "1f397-fe0f",
      a: "0.7"
    },
    {
      n: ["admission tickets"],
      u: "1f39f-fe0f",
      a: "0.7"
    },
    {
      n: ["ticket"],
      u: "1f3ab",
      a: "0.6"
    },
    {
      n: ["medal", "military medal"],
      u: "1f396-fe0f",
      a: "0.7"
    },
    {
      n: ["trophy"],
      u: "1f3c6",
      a: "0.6"
    },
    {
      n: ["sports medal"],
      u: "1f3c5",
      a: "1.0"
    },
    {
      n: ["first place medal"],
      u: "1f947",
      a: "3.0"
    },
    {
      n: ["second place medal"],
      u: "1f948",
      a: "3.0"
    },
    {
      n: ["third place medal"],
      u: "1f949",
      a: "3.0"
    },
    {
      n: ["soccer", "soccer ball"],
      u: "26bd",
      a: "0.6"
    },
    {
      n: ["baseball"],
      u: "26be",
      a: "0.6"
    },
    {
      n: ["softball"],
      u: "1f94e",
      a: "11.0"
    },
    {
      n: ["basketball", "basketball and hoop"],
      u: "1f3c0",
      a: "0.6"
    },
    {
      n: ["volleyball"],
      u: "1f3d0",
      a: "1.0"
    },
    {
      n: ["football", "american football"],
      u: "1f3c8",
      a: "0.6"
    },
    {
      n: ["rugby football"],
      u: "1f3c9",
      a: "1.0"
    },
    {
      n: ["tennis", "tennis racquet and ball"],
      u: "1f3be",
      a: "0.6"
    },
    {
      n: ["flying disc"],
      u: "1f94f",
      a: "11.0"
    },
    {
      n: ["bowling"],
      u: "1f3b3",
      a: "0.6"
    },
    {
      n: ["cricket bat and ball"],
      u: "1f3cf",
      a: "1.0"
    },
    {
      n: ["field hockey stick and ball"],
      u: "1f3d1",
      a: "1.0"
    },
    {
      n: ["ice hockey stick and puck"],
      u: "1f3d2",
      a: "1.0"
    },
    {
      n: ["lacrosse", "lacrosse stick and ball"],
      u: "1f94d",
      a: "11.0"
    },
    {
      n: ["table tennis paddle and ball"],
      u: "1f3d3",
      a: "1.0"
    },
    {
      n: ["badminton racquet and shuttlecock"],
      u: "1f3f8",
      a: "1.0"
    },
    {
      n: ["boxing glove"],
      u: "1f94a",
      a: "3.0"
    },
    {
      n: ["martial arts uniform"],
      u: "1f94b",
      a: "3.0"
    },
    {
      n: ["goal net"],
      u: "1f945",
      a: "3.0"
    },
    {
      n: ["golf", "flag in hole"],
      u: "26f3",
      a: "0.6"
    },
    {
      n: ["ice skate"],
      u: "26f8-fe0f",
      a: "0.7"
    },
    {
      n: ["fishing pole and fish"],
      u: "1f3a3",
      a: "0.6"
    },
    {
      n: ["diving mask"],
      u: "1f93f",
      a: "12.0"
    },
    {
      n: ["running shirt with sash"],
      u: "1f3bd",
      a: "0.6"
    },
    {
      n: ["ski", "ski and ski boot"],
      u: "1f3bf",
      a: "0.6"
    },
    {
      n: ["sled"],
      u: "1f6f7",
      a: "5.0"
    },
    {
      n: ["curling stone"],
      u: "1f94c",
      a: "5.0"
    },
    {
      n: ["dart", "direct hit"],
      u: "1f3af",
      a: "0.6"
    },
    {
      n: ["yo-yo"],
      u: "1fa80",
      a: "12.0"
    },
    {
      n: ["kite"],
      u: "1fa81",
      a: "12.0"
    },
    {
      n: ["8ball", "billiards"],
      u: "1f3b1",
      a: "0.6"
    },
    {
      n: ["crystal ball"],
      u: "1f52e",
      a: "0.6"
    },
    {
      n: ["magic wand"],
      u: "1fa84",
      a: "13.0"
    },
    {
      n: ["nazar amulet"],
      u: "1f9ff",
      a: "11.0"
    },
    {
      n: ["hamsa"],
      u: "1faac",
      a: "14.0"
    },
    {
      n: ["video game"],
      u: "1f3ae",
      a: "0.6"
    },
    {
      n: ["joystick"],
      u: "1f579-fe0f",
      a: "0.7"
    },
    {
      n: ["slot machine"],
      u: "1f3b0",
      a: "0.6"
    },
    {
      n: ["game die"],
      u: "1f3b2",
      a: "0.6"
    },
    {
      n: ["jigsaw", "jigsaw puzzle piece"],
      u: "1f9e9",
      a: "11.0"
    },
    {
      n: ["teddy bear"],
      u: "1f9f8",
      a: "11.0"
    },
    {
      n: ["pinata"],
      u: "1fa85",
      a: "13.0"
    },
    {
      n: ["mirror ball"],
      u: "1faa9",
      a: "14.0"
    },
    {
      n: ["nesting dolls"],
      u: "1fa86",
      a: "13.0"
    },
    {
      n: ["spades", "black spade suit"],
      u: "2660-fe0f",
      a: "0.6"
    },
    {
      n: ["hearts", "black heart suit"],
      u: "2665-fe0f",
      a: "0.6"
    },
    {
      n: ["diamonds", "black diamond suit"],
      u: "2666-fe0f",
      a: "0.6"
    },
    {
      n: ["clubs", "black club suit"],
      u: "2663-fe0f",
      a: "0.6"
    },
    {
      n: ["chess pawn"],
      u: "265f-fe0f",
      a: "11.0"
    },
    {
      n: ["black joker", "playing card black joker"],
      u: "1f0cf",
      a: "0.6"
    },
    {
      n: ["mahjong", "mahjong tile red dragon"],
      u: "1f004",
      a: "0.6"
    },
    {
      n: ["flower playing cards"],
      u: "1f3b4",
      a: "0.6"
    },
    {
      n: ["performing arts"],
      u: "1f3ad",
      a: "0.6"
    },
    {
      n: ["framed picture", "frame with picture"],
      u: "1f5bc-fe0f",
      a: "0.7"
    },
    {
      n: ["art", "artist palette"],
      u: "1f3a8",
      a: "0.6"
    },
    {
      n: ["thread", "spool of thread"],
      u: "1f9f5",
      a: "11.0"
    },
    {
      n: ["sewing needle"],
      u: "1faa1",
      a: "13.0"
    },
    {
      n: ["yarn", "ball of yarn"],
      u: "1f9f6",
      a: "11.0"
    },
    {
      n: ["knot"],
      u: "1faa2",
      a: "13.0"
    }
  ],
  objects: [
    {
      n: ["eyeglasses"],
      u: "1f453",
      a: "0.6"
    },
    {
      n: ["sunglasses", "dark sunglasses"],
      u: "1f576-fe0f",
      a: "0.7"
    },
    {
      n: ["goggles"],
      u: "1f97d",
      a: "11.0"
    },
    {
      n: ["lab coat"],
      u: "1f97c",
      a: "11.0"
    },
    {
      n: ["safety vest"],
      u: "1f9ba",
      a: "12.0"
    },
    {
      n: ["necktie"],
      u: "1f454",
      a: "0.6"
    },
    {
      n: ["shirt", "tshirt", "t-shirt"],
      u: "1f455",
      a: "0.6"
    },
    {
      n: ["jeans"],
      u: "1f456",
      a: "0.6"
    },
    {
      n: ["scarf"],
      u: "1f9e3",
      a: "5.0"
    },
    {
      n: ["gloves"],
      u: "1f9e4",
      a: "5.0"
    },
    {
      n: ["coat"],
      u: "1f9e5",
      a: "5.0"
    },
    {
      n: ["socks"],
      u: "1f9e6",
      a: "5.0"
    },
    {
      n: ["dress"],
      u: "1f457",
      a: "0.6"
    },
    {
      n: ["kimono"],
      u: "1f458",
      a: "0.6"
    },
    {
      n: ["sari"],
      u: "1f97b",
      a: "12.0"
    },
    {
      n: ["one-piece swimsuit"],
      u: "1fa71",
      a: "12.0"
    },
    {
      n: ["briefs"],
      u: "1fa72",
      a: "12.0"
    },
    {
      n: ["shorts"],
      u: "1fa73",
      a: "12.0"
    },
    {
      n: ["bikini"],
      u: "1f459",
      a: "0.6"
    },
    {
      n: ["womans clothes"],
      u: "1f45a",
      a: "0.6"
    },
    {
      n: ["purse"],
      u: "1f45b",
      a: "0.6"
    },
    {
      n: ["handbag"],
      u: "1f45c",
      a: "0.6"
    },
    {
      n: ["pouch"],
      u: "1f45d",
      a: "0.6"
    },
    {
      n: ["shopping bags"],
      u: "1f6cd-fe0f",
      a: "0.7"
    },
    {
      n: ["school satchel"],
      u: "1f392",
      a: "0.6"
    },
    {
      n: ["thong sandal"],
      u: "1fa74",
      a: "13.0"
    },
    {
      n: ["shoe", "mans shoe"],
      u: "1f45e",
      a: "0.6"
    },
    {
      n: ["athletic shoe"],
      u: "1f45f",
      a: "0.6"
    },
    {
      n: ["hiking boot"],
      u: "1f97e",
      a: "11.0"
    },
    {
      n: ["flat shoe", "womans flat shoe"],
      u: "1f97f",
      a: "11.0"
    },
    {
      n: ["high heel", "high-heeled shoe"],
      u: "1f460",
      a: "0.6"
    },
    {
      n: ["sandal", "womans sandal"],
      u: "1f461",
      a: "0.6"
    },
    {
      n: ["ballet shoes"],
      u: "1fa70",
      a: "12.0"
    },
    {
      n: ["boot", "womans boots"],
      u: "1f462",
      a: "0.6"
    },
    {
      n: ["crown"],
      u: "1f451",
      a: "0.6"
    },
    {
      n: ["womans hat"],
      u: "1f452",
      a: "0.6"
    },
    {
      n: ["tophat", "top hat"],
      u: "1f3a9",
      a: "0.6"
    },
    {
      n: ["mortar board", "graduation cap"],
      u: "1f393",
      a: "0.6"
    },
    {
      n: ["billed cap"],
      u: "1f9e2",
      a: "5.0"
    },
    {
      n: ["military helmet"],
      u: "1fa96",
      a: "13.0"
    },
    {
      n: ["rescue worker’s helmet", "helmet with white cross"],
      u: "26d1-fe0f",
      a: "0.7"
    },
    {
      n: ["prayer beads"],
      u: "1f4ff",
      a: "1.0"
    },
    {
      n: ["lipstick"],
      u: "1f484",
      a: "0.6"
    },
    {
      n: ["ring"],
      u: "1f48d",
      a: "0.6"
    },
    {
      n: ["gem", "gem stone"],
      u: "1f48e",
      a: "0.6"
    },
    {
      n: ["mute", "speaker with cancellation stroke"],
      u: "1f507",
      a: "1.0"
    },
    {
      n: ["speaker"],
      u: "1f508",
      a: "0.7"
    },
    {
      n: ["sound", "speaker with one sound wave"],
      u: "1f509",
      a: "1.0"
    },
    {
      n: ["loud sound", "speaker with three sound waves"],
      u: "1f50a",
      a: "0.6"
    },
    {
      n: ["loudspeaker", "public address loudspeaker"],
      u: "1f4e2",
      a: "0.6"
    },
    {
      n: ["mega", "cheering megaphone"],
      u: "1f4e3",
      a: "0.6"
    },
    {
      n: ["postal horn"],
      u: "1f4ef",
      a: "1.0"
    },
    {
      n: ["bell"],
      u: "1f514",
      a: "0.6"
    },
    {
      n: ["no bell", "bell with cancellation stroke"],
      u: "1f515",
      a: "1.0"
    },
    {
      n: ["musical score"],
      u: "1f3bc",
      a: "0.6"
    },
    {
      n: ["musical note"],
      u: "1f3b5",
      a: "0.6"
    },
    {
      n: ["notes", "multiple musical notes"],
      u: "1f3b6",
      a: "0.6"
    },
    {
      n: ["studio microphone"],
      u: "1f399-fe0f",
      a: "0.7"
    },
    {
      n: ["level slider"],
      u: "1f39a-fe0f",
      a: "0.7"
    },
    {
      n: ["control knobs"],
      u: "1f39b-fe0f",
      a: "0.7"
    },
    {
      n: ["microphone"],
      u: "1f3a4",
      a: "0.6"
    },
    {
      n: ["headphone", "headphones"],
      u: "1f3a7",
      a: "0.6"
    },
    {
      n: ["radio"],
      u: "1f4fb",
      a: "0.6"
    },
    {
      n: ["saxophone"],
      u: "1f3b7",
      a: "0.6"
    },
    {
      n: ["accordion"],
      u: "1fa97",
      a: "13.0"
    },
    {
      n: ["guitar"],
      u: "1f3b8",
      a: "0.6"
    },
    {
      n: ["musical keyboard"],
      u: "1f3b9",
      a: "0.6"
    },
    {
      n: ["trumpet"],
      u: "1f3ba",
      a: "0.6"
    },
    {
      n: ["violin"],
      u: "1f3bb",
      a: "0.6"
    },
    {
      n: ["banjo"],
      u: "1fa95",
      a: "12.0"
    },
    {
      n: ["drum with drumsticks"],
      u: "1f941",
      a: "3.0"
    },
    {
      n: ["long drum"],
      u: "1fa98",
      a: "13.0"
    },
    {
      n: ["iphone", "mobile phone"],
      u: "1f4f1",
      a: "0.6"
    },
    {
      n: ["calling", "mobile phone with rightwards arrow at left"],
      u: "1f4f2",
      a: "0.6"
    },
    {
      n: ["phone", "telephone", "black telephone"],
      u: "260e-fe0f",
      a: "0.6"
    },
    {
      n: ["telephone receiver"],
      u: "1f4de",
      a: "0.6"
    },
    {
      n: ["pager"],
      u: "1f4df",
      a: "0.6"
    },
    {
      n: ["fax", "fax machine"],
      u: "1f4e0",
      a: "0.6"
    },
    {
      n: ["battery"],
      u: "1f50b",
      a: "0.6"
    },
    {
      n: ["low battery"],
      u: "1faab",
      a: "14.0"
    },
    {
      n: ["electric plug"],
      u: "1f50c",
      a: "0.6"
    },
    {
      n: ["computer", "personal computer"],
      u: "1f4bb",
      a: "0.6"
    },
    {
      n: ["desktop computer"],
      u: "1f5a5-fe0f",
      a: "0.7"
    },
    {
      n: ["printer"],
      u: "1f5a8-fe0f",
      a: "0.7"
    },
    {
      n: ["keyboard"],
      u: "2328-fe0f",
      a: "1.0"
    },
    {
      n: ["computer mouse", "three button mouse"],
      u: "1f5b1-fe0f",
      a: "0.7"
    },
    {
      n: ["trackball"],
      u: "1f5b2-fe0f",
      a: "0.7"
    },
    {
      n: ["minidisc"],
      u: "1f4bd",
      a: "0.6"
    },
    {
      n: ["floppy disk"],
      u: "1f4be",
      a: "0.6"
    },
    {
      n: ["cd", "optical disc"],
      u: "1f4bf",
      a: "0.6"
    },
    {
      n: ["dvd"],
      u: "1f4c0",
      a: "0.6"
    },
    {
      n: ["abacus"],
      u: "1f9ee",
      a: "11.0"
    },
    {
      n: ["movie camera"],
      u: "1f3a5",
      a: "0.6"
    },
    {
      n: ["film frames"],
      u: "1f39e-fe0f",
      a: "0.7"
    },
    {
      n: ["film projector"],
      u: "1f4fd-fe0f",
      a: "0.7"
    },
    {
      n: ["clapper", "clapper board"],
      u: "1f3ac",
      a: "0.6"
    },
    {
      n: ["tv", "television"],
      u: "1f4fa",
      a: "0.6"
    },
    {
      n: ["camera"],
      u: "1f4f7",
      a: "0.6"
    },
    {
      n: ["camera with flash"],
      u: "1f4f8",
      a: "1.0"
    },
    {
      n: ["video camera"],
      u: "1f4f9",
      a: "0.6"
    },
    {
      n: ["vhs", "videocassette"],
      u: "1f4fc",
      a: "0.6"
    },
    {
      n: ["mag", "left-pointing magnifying glass"],
      u: "1f50d",
      a: "0.6"
    },
    {
      n: ["mag right", "right-pointing magnifying glass"],
      u: "1f50e",
      a: "0.6"
    },
    {
      n: ["candle"],
      u: "1f56f-fe0f",
      a: "0.7"
    },
    {
      n: ["bulb", "electric light bulb"],
      u: "1f4a1",
      a: "0.6"
    },
    {
      n: ["flashlight", "electric torch"],
      u: "1f526",
      a: "0.6"
    },
    {
      n: ["lantern", "izakaya lantern"],
      u: "1f3ee",
      a: "0.6"
    },
    {
      n: ["diya lamp"],
      u: "1fa94",
      a: "12.0"
    },
    {
      n: ["notebook with decorative cover"],
      u: "1f4d4",
      a: "0.6"
    },
    {
      n: ["closed book"],
      u: "1f4d5",
      a: "0.6"
    },
    {
      n: ["book", "open book"],
      u: "1f4d6",
      a: "0.6"
    },
    {
      n: ["green book"],
      u: "1f4d7",
      a: "0.6"
    },
    {
      n: ["blue book"],
      u: "1f4d8",
      a: "0.6"
    },
    {
      n: ["orange book"],
      u: "1f4d9",
      a: "0.6"
    },
    {
      n: ["books"],
      u: "1f4da",
      a: "0.6"
    },
    {
      n: ["notebook"],
      u: "1f4d3",
      a: "0.6"
    },
    {
      n: ["ledger"],
      u: "1f4d2",
      a: "0.6"
    },
    {
      n: ["page with curl"],
      u: "1f4c3",
      a: "0.6"
    },
    {
      n: ["scroll"],
      u: "1f4dc",
      a: "0.6"
    },
    {
      n: ["page facing up"],
      u: "1f4c4",
      a: "0.6"
    },
    {
      n: ["newspaper"],
      u: "1f4f0",
      a: "0.6"
    },
    {
      n: ["rolled-up newspaper", "rolled up newspaper"],
      u: "1f5de-fe0f",
      a: "0.7"
    },
    {
      n: ["bookmark tabs"],
      u: "1f4d1",
      a: "0.6"
    },
    {
      n: ["bookmark"],
      u: "1f516",
      a: "0.6"
    },
    {
      n: ["label"],
      u: "1f3f7-fe0f",
      a: "0.7"
    },
    {
      n: ["moneybag", "money bag"],
      u: "1f4b0",
      a: "0.6"
    },
    {
      n: ["coin"],
      u: "1fa99",
      a: "13.0"
    },
    {
      n: ["yen", "banknote with yen sign"],
      u: "1f4b4",
      a: "0.6"
    },
    {
      n: ["dollar", "banknote with dollar sign"],
      u: "1f4b5",
      a: "0.6"
    },
    {
      n: ["euro", "banknote with euro sign"],
      u: "1f4b6",
      a: "1.0"
    },
    {
      n: ["pound", "banknote with pound sign"],
      u: "1f4b7",
      a: "1.0"
    },
    {
      n: ["money with wings"],
      u: "1f4b8",
      a: "0.6"
    },
    {
      n: ["credit card"],
      u: "1f4b3",
      a: "0.6"
    },
    {
      n: ["receipt"],
      u: "1f9fe",
      a: "11.0"
    },
    {
      n: ["chart", "chart with upwards trend and yen sign"],
      u: "1f4b9",
      a: "0.6"
    },
    {
      n: ["email", "envelope"],
      u: "2709-fe0f",
      a: "0.6"
    },
    {
      n: ["e-mail", "e-mail symbol"],
      u: "1f4e7",
      a: "0.6"
    },
    {
      n: ["incoming envelope"],
      u: "1f4e8",
      a: "0.6"
    },
    {
      n: ["envelope with arrow", "envelope with downwards arrow above"],
      u: "1f4e9",
      a: "0.6"
    },
    {
      n: ["outbox tray"],
      u: "1f4e4",
      a: "0.6"
    },
    {
      n: ["inbox tray"],
      u: "1f4e5",
      a: "0.6"
    },
    {
      n: ["package"],
      u: "1f4e6",
      a: "0.6"
    },
    {
      n: ["mailbox", "closed mailbox with raised flag"],
      u: "1f4eb",
      a: "0.6"
    },
    {
      n: ["mailbox closed", "closed mailbox with lowered flag"],
      u: "1f4ea",
      a: "0.6"
    },
    {
      n: ["mailbox with mail", "open mailbox with raised flag"],
      u: "1f4ec",
      a: "0.7"
    },
    {
      n: ["mailbox with no mail", "open mailbox with lowered flag"],
      u: "1f4ed",
      a: "0.7"
    },
    {
      n: ["postbox"],
      u: "1f4ee",
      a: "0.6"
    },
    {
      n: ["ballot box with ballot"],
      u: "1f5f3-fe0f",
      a: "0.7"
    },
    {
      n: ["pencil", "pencil2"],
      u: "270f-fe0f",
      a: "0.6"
    },
    {
      n: ["black nib"],
      u: "2712-fe0f",
      a: "0.6"
    },
    {
      n: ["fountain pen", "lower left fountain pen"],
      u: "1f58b-fe0f",
      a: "0.7"
    },
    {
      n: ["pen", "lower left ballpoint pen"],
      u: "1f58a-fe0f",
      a: "0.7"
    },
    {
      n: ["paintbrush", "lower left paintbrush"],
      u: "1f58c-fe0f",
      a: "0.7"
    },
    {
      n: ["crayon", "lower left crayon"],
      u: "1f58d-fe0f",
      a: "0.7"
    },
    {
      n: ["memo", "pencil"],
      u: "1f4dd",
      a: "0.6"
    },
    {
      n: ["briefcase"],
      u: "1f4bc",
      a: "0.6"
    },
    {
      n: ["file folder"],
      u: "1f4c1",
      a: "0.6"
    },
    {
      n: ["open file folder"],
      u: "1f4c2",
      a: "0.6"
    },
    {
      n: ["card index dividers"],
      u: "1f5c2-fe0f",
      a: "0.7"
    },
    {
      n: ["date", "calendar"],
      u: "1f4c5",
      a: "0.6"
    },
    {
      n: ["calendar", "tear-off calendar"],
      u: "1f4c6",
      a: "0.6"
    },
    {
      n: ["spiral notepad", "spiral note pad"],
      u: "1f5d2-fe0f",
      a: "0.7"
    },
    {
      n: ["spiral calendar", "spiral calendar pad"],
      u: "1f5d3-fe0f",
      a: "0.7"
    },
    {
      n: ["card index"],
      u: "1f4c7",
      a: "0.6"
    },
    {
      n: ["chart with upwards trend"],
      u: "1f4c8",
      a: "0.6"
    },
    {
      n: ["chart with downwards trend"],
      u: "1f4c9",
      a: "0.6"
    },
    {
      n: ["bar chart"],
      u: "1f4ca",
      a: "0.6"
    },
    {
      n: ["clipboard"],
      u: "1f4cb",
      a: "0.6"
    },
    {
      n: ["pushpin"],
      u: "1f4cc",
      a: "0.6"
    },
    {
      n: ["round pushpin"],
      u: "1f4cd",
      a: "0.6"
    },
    {
      n: ["paperclip"],
      u: "1f4ce",
      a: "0.6"
    },
    {
      n: ["linked paperclips"],
      u: "1f587-fe0f",
      a: "0.7"
    },
    {
      n: ["straight ruler"],
      u: "1f4cf",
      a: "0.6"
    },
    {
      n: ["triangular ruler"],
      u: "1f4d0",
      a: "0.6"
    },
    {
      n: ["scissors", "black scissors"],
      u: "2702-fe0f",
      a: "0.6"
    },
    {
      n: ["card file box"],
      u: "1f5c3-fe0f",
      a: "0.7"
    },
    {
      n: ["file cabinet"],
      u: "1f5c4-fe0f",
      a: "0.7"
    },
    {
      n: ["wastebasket"],
      u: "1f5d1-fe0f",
      a: "0.7"
    },
    {
      n: ["lock"],
      u: "1f512",
      a: "0.6"
    },
    {
      n: ["unlock", "open lock"],
      u: "1f513",
      a: "0.6"
    },
    {
      n: ["lock with ink pen"],
      u: "1f50f",
      a: "0.6"
    },
    {
      n: ["closed lock with key"],
      u: "1f510",
      a: "0.6"
    },
    {
      n: ["key"],
      u: "1f511",
      a: "0.6"
    },
    {
      n: ["old key"],
      u: "1f5dd-fe0f",
      a: "0.7"
    },
    {
      n: ["hammer"],
      u: "1f528",
      a: "0.6"
    },
    {
      n: ["axe"],
      u: "1fa93",
      a: "12.0"
    },
    {
      n: ["pick"],
      u: "26cf-fe0f",
      a: "0.7"
    },
    {
      n: ["hammer and pick"],
      u: "2692-fe0f",
      a: "1.0"
    },
    {
      n: ["hammer and wrench"],
      u: "1f6e0-fe0f",
      a: "0.7"
    },
    {
      n: ["dagger", "dagger knife"],
      u: "1f5e1-fe0f",
      a: "0.7"
    },
    {
      n: ["crossed swords"],
      u: "2694-fe0f",
      a: "1.0"
    },
    {
      n: ["gun", "pistol"],
      u: "1f52b",
      a: "0.6"
    },
    {
      n: ["boomerang"],
      u: "1fa83",
      a: "13.0"
    },
    {
      n: ["bow and arrow"],
      u: "1f3f9",
      a: "1.0"
    },
    {
      n: ["shield"],
      u: "1f6e1-fe0f",
      a: "0.7"
    },
    {
      n: ["carpentry saw"],
      u: "1fa9a",
      a: "13.0"
    },
    {
      n: ["wrench"],
      u: "1f527",
      a: "0.6"
    },
    {
      n: ["screwdriver"],
      u: "1fa9b",
      a: "13.0"
    },
    {
      n: ["nut and bolt"],
      u: "1f529",
      a: "0.6"
    },
    {
      n: ["gear"],
      u: "2699-fe0f",
      a: "1.0"
    },
    {
      n: ["clamp", "compression"],
      u: "1f5dc-fe0f",
      a: "0.7"
    },
    {
      n: ["scales", "balance scale"],
      u: "2696-fe0f",
      a: "1.0"
    },
    {
      n: ["probing cane"],
      u: "1f9af",
      a: "12.0"
    },
    {
      n: ["link", "link symbol"],
      u: "1f517",
      a: "0.6"
    },
    {
      n: ["chains"],
      u: "26d3-fe0f",
      a: "0.7"
    },
    {
      n: ["hook"],
      u: "1fa9d",
      a: "13.0"
    },
    {
      n: ["toolbox"],
      u: "1f9f0",
      a: "11.0"
    },
    {
      n: ["magnet"],
      u: "1f9f2",
      a: "11.0"
    },
    {
      n: ["ladder"],
      u: "1fa9c",
      a: "13.0"
    },
    {
      n: ["alembic"],
      u: "2697-fe0f",
      a: "1.0"
    },
    {
      n: ["test tube"],
      u: "1f9ea",
      a: "11.0"
    },
    {
      n: ["petri dish"],
      u: "1f9eb",
      a: "11.0"
    },
    {
      n: ["dna", "dna double helix"],
      u: "1f9ec",
      a: "11.0"
    },
    {
      n: ["microscope"],
      u: "1f52c",
      a: "1.0"
    },
    {
      n: ["telescope"],
      u: "1f52d",
      a: "1.0"
    },
    {
      n: ["satellite antenna"],
      u: "1f4e1",
      a: "0.6"
    },
    {
      n: ["syringe"],
      u: "1f489",
      a: "0.6"
    },
    {
      n: ["drop of blood"],
      u: "1fa78",
      a: "12.0"
    },
    {
      n: ["pill"],
      u: "1f48a",
      a: "0.6"
    },
    {
      n: ["adhesive bandage"],
      u: "1fa79",
      a: "12.0"
    },
    {
      n: ["crutch"],
      u: "1fa7c",
      a: "14.0"
    },
    {
      n: ["stethoscope"],
      u: "1fa7a",
      a: "12.0"
    },
    {
      n: ["x-ray"],
      u: "1fa7b",
      a: "14.0"
    },
    {
      n: ["door"],
      u: "1f6aa",
      a: "0.6"
    },
    {
      n: ["elevator"],
      u: "1f6d7",
      a: "13.0"
    },
    {
      n: ["mirror"],
      u: "1fa9e",
      a: "13.0"
    },
    {
      n: ["window"],
      u: "1fa9f",
      a: "13.0"
    },
    {
      n: ["bed"],
      u: "1f6cf-fe0f",
      a: "0.7"
    },
    {
      n: ["couch and lamp"],
      u: "1f6cb-fe0f",
      a: "0.7"
    },
    {
      n: ["chair"],
      u: "1fa91",
      a: "12.0"
    },
    {
      n: ["toilet"],
      u: "1f6bd",
      a: "0.6"
    },
    {
      n: ["plunger"],
      u: "1faa0",
      a: "13.0"
    },
    {
      n: ["shower"],
      u: "1f6bf",
      a: "1.0"
    },
    {
      n: ["bathtub"],
      u: "1f6c1",
      a: "1.0"
    },
    {
      n: ["mouse trap"],
      u: "1faa4",
      a: "13.0"
    },
    {
      n: ["razor"],
      u: "1fa92",
      a: "12.0"
    },
    {
      n: ["lotion bottle"],
      u: "1f9f4",
      a: "11.0"
    },
    {
      n: ["safety pin"],
      u: "1f9f7",
      a: "11.0"
    },
    {
      n: ["broom"],
      u: "1f9f9",
      a: "11.0"
    },
    {
      n: ["basket"],
      u: "1f9fa",
      a: "11.0"
    },
    {
      n: ["roll of paper"],
      u: "1f9fb",
      a: "11.0"
    },
    {
      n: ["bucket"],
      u: "1faa3",
      a: "13.0"
    },
    {
      n: ["soap", "bar of soap"],
      u: "1f9fc",
      a: "11.0"
    },
    {
      n: ["bubbles"],
      u: "1fae7",
      a: "14.0"
    },
    {
      n: ["toothbrush"],
      u: "1faa5",
      a: "13.0"
    },
    {
      n: ["sponge"],
      u: "1f9fd",
      a: "11.0"
    },
    {
      n: ["fire extinguisher"],
      u: "1f9ef",
      a: "11.0"
    },
    {
      n: ["shopping trolley"],
      u: "1f6d2",
      a: "3.0"
    },
    {
      n: ["smoking", "smoking symbol"],
      u: "1f6ac",
      a: "0.6"
    },
    {
      n: ["coffin"],
      u: "26b0-fe0f",
      a: "1.0"
    },
    {
      n: ["headstone"],
      u: "1faa6",
      a: "13.0"
    },
    {
      n: ["funeral urn"],
      u: "26b1-fe0f",
      a: "1.0"
    },
    {
      n: ["moyai"],
      u: "1f5ff",
      a: "0.6"
    },
    {
      n: ["placard"],
      u: "1faa7",
      a: "13.0"
    },
    {
      n: ["identification card"],
      u: "1faaa",
      a: "14.0"
    }
  ],
  symbols: [
    {
      n: ["atm", "automated teller machine"],
      u: "1f3e7",
      a: "0.6"
    },
    {
      n: ["put litter in its place", "put litter in its place symbol"],
      u: "1f6ae",
      a: "1.0"
    },
    {
      n: ["potable water", "potable water symbol"],
      u: "1f6b0",
      a: "1.0"
    },
    {
      n: ["wheelchair", "wheelchair symbol"],
      u: "267f",
      a: "0.6"
    },
    {
      n: ["mens", "mens symbol"],
      u: "1f6b9",
      a: "0.6"
    },
    {
      n: ["womens", "womens symbol"],
      u: "1f6ba",
      a: "0.6"
    },
    {
      n: ["restroom"],
      u: "1f6bb",
      a: "0.6"
    },
    {
      n: ["baby symbol"],
      u: "1f6bc",
      a: "0.6"
    },
    {
      n: ["wc", "water closet"],
      u: "1f6be",
      a: "0.6"
    },
    {
      n: ["passport control"],
      u: "1f6c2",
      a: "1.0"
    },
    {
      n: ["customs"],
      u: "1f6c3",
      a: "1.0"
    },
    {
      n: ["baggage claim"],
      u: "1f6c4",
      a: "1.0"
    },
    {
      n: ["left luggage"],
      u: "1f6c5",
      a: "1.0"
    },
    {
      n: ["warning", "warning sign"],
      u: "26a0-fe0f",
      a: "0.6"
    },
    {
      n: ["children crossing"],
      u: "1f6b8",
      a: "1.0"
    },
    {
      n: ["no entry"],
      u: "26d4",
      a: "0.6"
    },
    {
      n: ["no entry sign"],
      u: "1f6ab",
      a: "0.6"
    },
    {
      n: ["no bicycles"],
      u: "1f6b3",
      a: "1.0"
    },
    {
      n: ["no smoking", "no smoking symbol"],
      u: "1f6ad",
      a: "0.6"
    },
    {
      n: ["do not litter", "do not litter symbol"],
      u: "1f6af",
      a: "1.0"
    },
    {
      n: ["non-potable water", "non-potable water symbol"],
      u: "1f6b1",
      a: "1.0"
    },
    {
      n: ["no pedestrians"],
      u: "1f6b7",
      a: "1.0"
    },
    {
      n: ["no mobile phones"],
      u: "1f4f5",
      a: "1.0"
    },
    {
      n: ["underage", "no one under eighteen symbol"],
      u: "1f51e",
      a: "0.6"
    },
    {
      n: ["radioactive", "radioactive sign"],
      u: "2622-fe0f",
      a: "1.0"
    },
    {
      n: ["biohazard", "biohazard sign"],
      u: "2623-fe0f",
      a: "1.0"
    },
    {
      n: ["arrow up", "upwards black arrow"],
      u: "2b06-fe0f",
      a: "0.6"
    },
    {
      n: ["north east arrow", "arrow upper right"],
      u: "2197-fe0f",
      a: "0.6"
    },
    {
      n: ["arrow right", "black rightwards arrow"],
      u: "27a1-fe0f",
      a: "0.6"
    },
    {
      n: ["south east arrow", "arrow lower right"],
      u: "2198-fe0f",
      a: "0.6"
    },
    {
      n: ["arrow down", "downwards black arrow"],
      u: "2b07-fe0f",
      a: "0.6"
    },
    {
      n: ["south west arrow", "arrow lower left"],
      u: "2199-fe0f",
      a: "0.6"
    },
    {
      n: ["arrow left", "leftwards black arrow"],
      u: "2b05-fe0f",
      a: "0.6"
    },
    {
      n: ["north west arrow", "arrow upper left"],
      u: "2196-fe0f",
      a: "0.6"
    },
    {
      n: ["up down arrow", "arrow up down"],
      u: "2195-fe0f",
      a: "0.6"
    },
    {
      n: ["left right arrow"],
      u: "2194-fe0f",
      a: "0.6"
    },
    {
      n: ["leftwards arrow with hook"],
      u: "21a9-fe0f",
      a: "0.6"
    },
    {
      n: ["arrow right hook", "rightwards arrow with hook"],
      u: "21aa-fe0f",
      a: "0.6"
    },
    {
      n: ["arrow heading up", "arrow pointing rightwards then curving upwards"],
      u: "2934-fe0f",
      a: "0.6"
    },
    {
      n: ["arrow heading down", "arrow pointing rightwards then curving downwards"],
      u: "2935-fe0f",
      a: "0.6"
    },
    {
      n: ["arrows clockwise", "clockwise downwards and upwards open circle arrows"],
      u: "1f503",
      a: "0.6"
    },
    {
      n: ["arrows counterclockwise", "anticlockwise downwards and upwards open circle arrows"],
      u: "1f504",
      a: "1.0"
    },
    {
      n: ["back", "back with leftwards arrow above"],
      u: "1f519",
      a: "0.6"
    },
    {
      n: ["end", "end with leftwards arrow above"],
      u: "1f51a",
      a: "0.6"
    },
    {
      n: ["on", "on with exclamation mark with left right arrow above"],
      u: "1f51b",
      a: "0.6"
    },
    {
      n: ["soon", "soon with rightwards arrow above"],
      u: "1f51c",
      a: "0.6"
    },
    {
      n: ["top", "top with upwards arrow above"],
      u: "1f51d",
      a: "0.6"
    },
    {
      n: ["place of worship"],
      u: "1f6d0",
      a: "1.0"
    },
    {
      n: ["atom symbol"],
      u: "269b-fe0f",
      a: "1.0"
    },
    {
      n: ["om", "om symbol"],
      u: "1f549-fe0f",
      a: "0.7"
    },
    {
      n: ["star of david"],
      u: "2721-fe0f",
      a: "0.7"
    },
    {
      n: ["wheel of dharma"],
      u: "2638-fe0f",
      a: "0.7"
    },
    {
      n: ["yin yang"],
      u: "262f-fe0f",
      a: "0.7"
    },
    {
      n: ["latin cross"],
      u: "271d-fe0f",
      a: "0.7"
    },
    {
      n: ["orthodox cross"],
      u: "2626-fe0f",
      a: "1.0"
    },
    {
      n: ["star and crescent"],
      u: "262a-fe0f",
      a: "0.7"
    },
    {
      n: ["peace symbol"],
      u: "262e-fe0f",
      a: "1.0"
    },
    {
      n: ["menorah with nine branches"],
      u: "1f54e",
      a: "1.0"
    },
    {
      n: ["six pointed star", "six pointed star with middle dot"],
      u: "1f52f",
      a: "0.6"
    },
    {
      n: ["aries"],
      u: "2648",
      a: "0.6"
    },
    {
      n: ["taurus"],
      u: "2649",
      a: "0.6"
    },
    {
      n: ["gemini"],
      u: "264a",
      a: "0.6"
    },
    {
      n: ["cancer"],
      u: "264b",
      a: "0.6"
    },
    {
      n: ["leo"],
      u: "264c",
      a: "0.6"
    },
    {
      n: ["virgo"],
      u: "264d",
      a: "0.6"
    },
    {
      n: ["libra"],
      u: "264e",
      a: "0.6"
    },
    {
      n: ["scorpius"],
      u: "264f",
      a: "0.6"
    },
    {
      n: ["sagittarius"],
      u: "2650",
      a: "0.6"
    },
    {
      n: ["capricorn"],
      u: "2651",
      a: "0.6"
    },
    {
      n: ["aquarius"],
      u: "2652",
      a: "0.6"
    },
    {
      n: ["pisces"],
      u: "2653",
      a: "0.6"
    },
    {
      n: ["ophiuchus"],
      u: "26ce",
      a: "0.6"
    },
    {
      n: ["twisted rightwards arrows"],
      u: "1f500",
      a: "1.0"
    },
    {
      n: ["repeat", "clockwise rightwards and leftwards open circle arrows"],
      u: "1f501",
      a: "1.0"
    },
    {
      n: [
        "repeat one",
        "clockwise rightwards and leftwards open circle arrows with circled one overlay"
      ],
      u: "1f502",
      a: "1.0"
    },
    {
      n: ["arrow forward", "black right-pointing triangle"],
      u: "25b6-fe0f",
      a: "0.6"
    },
    {
      n: ["fast forward", "black right-pointing double triangle"],
      u: "23e9",
      a: "0.6"
    },
    {
      n: ["next track button", "black right pointing double triangle with vertical bar"],
      u: "23ed-fe0f",
      a: "0.7"
    },
    {
      n: ["play or pause button", "black right pointing triangle with double vertical bar"],
      u: "23ef-fe0f",
      a: "1.0"
    },
    {
      n: ["arrow backward", "black left-pointing triangle"],
      u: "25c0-fe0f",
      a: "0.6"
    },
    {
      n: ["rewind", "black left-pointing double triangle"],
      u: "23ea",
      a: "0.6"
    },
    {
      n: ["last track button", "black left pointing double triangle with vertical bar"],
      u: "23ee-fe0f",
      a: "0.7"
    },
    {
      n: ["arrow up small", "up-pointing small red triangle"],
      u: "1f53c",
      a: "0.6"
    },
    {
      n: ["arrow double up", "black up-pointing double triangle"],
      u: "23eb",
      a: "0.6"
    },
    {
      n: ["arrow down small", "down-pointing small red triangle"],
      u: "1f53d",
      a: "0.6"
    },
    {
      n: ["arrow double down", "black down-pointing double triangle"],
      u: "23ec",
      a: "0.6"
    },
    {
      n: ["pause button", "double vertical bar"],
      u: "23f8-fe0f",
      a: "0.7"
    },
    {
      n: ["stop button", "black square for stop"],
      u: "23f9-fe0f",
      a: "0.7"
    },
    {
      n: ["record button", "black circle for record"],
      u: "23fa-fe0f",
      a: "0.7"
    },
    {
      n: ["eject", "eject button"],
      u: "23cf-fe0f",
      a: "1.0"
    },
    {
      n: ["cinema"],
      u: "1f3a6",
      a: "0.6"
    },
    {
      n: ["low brightness", "low brightness symbol"],
      u: "1f505",
      a: "1.0"
    },
    {
      n: ["high brightness", "high brightness symbol"],
      u: "1f506",
      a: "1.0"
    },
    {
      n: ["signal strength", "antenna with bars"],
      u: "1f4f6",
      a: "0.6"
    },
    {
      n: ["vibration mode"],
      u: "1f4f3",
      a: "0.6"
    },
    {
      n: ["mobile phone off"],
      u: "1f4f4",
      a: "0.6"
    },
    {
      n: ["female sign"],
      u: "2640-fe0f",
      a: "4.0"
    },
    {
      n: ["male sign"],
      u: "2642-fe0f",
      a: "4.0"
    },
    {
      n: ["transgender symbol"],
      u: "26a7-fe0f",
      a: "13.0"
    },
    {
      n: ["heavy multiplication x"],
      u: "2716-fe0f",
      a: "0.6"
    },
    {
      n: ["heavy plus sign"],
      u: "2795",
      a: "0.6"
    },
    {
      n: ["heavy minus sign"],
      u: "2796",
      a: "0.6"
    },
    {
      n: ["heavy division sign"],
      u: "2797",
      a: "0.6"
    },
    {
      n: ["heavy equals sign"],
      u: "1f7f0",
      a: "14.0"
    },
    {
      n: ["infinity"],
      u: "267e-fe0f",
      a: "11.0"
    },
    {
      n: ["bangbang", "double exclamation mark"],
      u: "203c-fe0f",
      a: "0.6"
    },
    {
      n: ["interrobang", "exclamation question mark"],
      u: "2049-fe0f",
      a: "0.6"
    },
    {
      n: ["question", "black question mark ornament"],
      u: "2753",
      a: "0.6"
    },
    {
      n: ["grey question", "white question mark ornament"],
      u: "2754",
      a: "0.6"
    },
    {
      n: ["grey exclamation", "white exclamation mark ornament"],
      u: "2755",
      a: "0.6"
    },
    {
      n: ["exclamation", "heavy exclamation mark", "heavy exclamation mark symbol"],
      u: "2757",
      a: "0.6"
    },
    {
      n: ["wavy dash"],
      u: "3030-fe0f",
      a: "0.6"
    },
    {
      n: ["currency exchange"],
      u: "1f4b1",
      a: "0.6"
    },
    {
      n: ["heavy dollar sign"],
      u: "1f4b2",
      a: "0.6"
    },
    {
      n: ["medical symbol", "staff of aesculapius"],
      u: "2695-fe0f",
      a: "4.0"
    },
    {
      n: ["recycle", "black universal recycling symbol"],
      u: "267b-fe0f",
      a: "0.6"
    },
    {
      n: ["fleur-de-lis", "fleur de lis"],
      u: "269c-fe0f",
      a: "1.0"
    },
    {
      n: ["trident", "trident emblem"],
      u: "1f531",
      a: "0.6"
    },
    {
      n: ["name badge"],
      u: "1f4db",
      a: "0.6"
    },
    {
      n: ["beginner", "japanese symbol for beginner"],
      u: "1f530",
      a: "0.6"
    },
    {
      n: ["o", "heavy large circle"],
      u: "2b55",
      a: "0.6"
    },
    {
      n: ["white check mark", "white heavy check mark"],
      u: "2705",
      a: "0.6"
    },
    {
      n: ["ballot box with check"],
      u: "2611-fe0f",
      a: "0.6"
    },
    {
      n: ["heavy check mark"],
      u: "2714-fe0f",
      a: "0.6"
    },
    {
      n: ["x", "cross mark"],
      u: "274c",
      a: "0.6"
    },
    {
      n: ["negative squared cross mark"],
      u: "274e",
      a: "0.6"
    },
    {
      n: ["curly loop"],
      u: "27b0",
      a: "0.6"
    },
    {
      n: ["loop", "double curly loop"],
      u: "27bf",
      a: "1.0"
    },
    {
      n: ["part alternation mark"],
      u: "303d-fe0f",
      a: "0.6"
    },
    {
      n: ["eight spoked asterisk"],
      u: "2733-fe0f",
      a: "0.6"
    },
    {
      n: ["eight pointed black star"],
      u: "2734-fe0f",
      a: "0.6"
    },
    {
      n: ["sparkle"],
      u: "2747-fe0f",
      a: "0.6"
    },
    {
      n: ["copyright", "copyright sign"],
      u: "00a9-fe0f",
      a: "0.6"
    },
    {
      n: ["registered", "registered sign"],
      u: "00ae-fe0f",
      a: "0.6"
    },
    {
      n: ["tm", "trade mark sign"],
      u: "2122-fe0f",
      a: "0.6"
    },
    {
      n: ["hash", "hash key"],
      u: "0023-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["keycap: *", "keycap star"],
      u: "002a-fe0f-20e3",
      a: "2.0"
    },
    {
      n: ["zero", "keycap 0"],
      u: "0030-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["one", "keycap 1"],
      u: "0031-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["two", "keycap 2"],
      u: "0032-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["three", "keycap 3"],
      u: "0033-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["four", "keycap 4"],
      u: "0034-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["five", "keycap 5"],
      u: "0035-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["six", "keycap 6"],
      u: "0036-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["seven", "keycap 7"],
      u: "0037-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["eight", "keycap 8"],
      u: "0038-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["nine", "keycap 9"],
      u: "0039-fe0f-20e3",
      a: "0.6"
    },
    {
      n: ["keycap ten"],
      u: "1f51f",
      a: "0.6"
    },
    {
      n: ["capital abcd", "input symbol for latin capital letters"],
      u: "1f520",
      a: "0.6"
    },
    {
      n: ["abcd", "input symbol for latin small letters"],
      u: "1f521",
      a: "0.6"
    },
    {
      n: ["1234", "input symbol for numbers"],
      u: "1f522",
      a: "0.6"
    },
    {
      n: ["symbols", "input symbol for symbols"],
      u: "1f523",
      a: "0.6"
    },
    {
      n: ["abc", "input symbol for latin letters"],
      u: "1f524",
      a: "0.6"
    },
    {
      n: ["a", "negative squared latin capital letter a"],
      u: "1f170-fe0f",
      a: "0.6"
    },
    {
      n: ["ab", "negative squared ab"],
      u: "1f18e",
      a: "0.6"
    },
    {
      n: ["b", "negative squared latin capital letter b"],
      u: "1f171-fe0f",
      a: "0.6"
    },
    {
      n: ["cl", "squared cl"],
      u: "1f191",
      a: "0.6"
    },
    {
      n: ["cool", "squared cool"],
      u: "1f192",
      a: "0.6"
    },
    {
      n: ["free", "squared free"],
      u: "1f193",
      a: "0.6"
    },
    {
      n: ["information source"],
      u: "2139-fe0f",
      a: "0.6"
    },
    {
      n: ["id", "squared id"],
      u: "1f194",
      a: "0.6"
    },
    {
      n: ["m", "circled latin capital letter m"],
      u: "24c2-fe0f",
      a: "0.6"
    },
    {
      n: ["new", "squared new"],
      u: "1f195",
      a: "0.6"
    },
    {
      n: ["ng", "squared ng"],
      u: "1f196",
      a: "0.6"
    },
    {
      n: ["o2", "negative squared latin capital letter o"],
      u: "1f17e-fe0f",
      a: "0.6"
    },
    {
      n: ["ok", "squared ok"],
      u: "1f197",
      a: "0.6"
    },
    {
      n: ["parking", "negative squared latin capital letter p"],
      u: "1f17f-fe0f",
      a: "0.6"
    },
    {
      n: ["sos", "squared sos"],
      u: "1f198",
      a: "0.6"
    },
    {
      n: ["up", "squared up with exclamation mark"],
      u: "1f199",
      a: "0.6"
    },
    {
      n: ["vs", "squared vs"],
      u: "1f19a",
      a: "0.6"
    },
    {
      n: ["koko", "squared katakana koko"],
      u: "1f201",
      a: "0.6"
    },
    {
      n: ["sa", "squared katakana sa"],
      u: "1f202-fe0f",
      a: "0.6"
    },
    {
      n: ["u6708", "squared cjk unified ideograph-6708"],
      u: "1f237-fe0f",
      a: "0.6"
    },
    {
      n: ["u6709", "squared cjk unified ideograph-6709"],
      u: "1f236",
      a: "0.6"
    },
    {
      n: ["u6307", "squared cjk unified ideograph-6307"],
      u: "1f22f",
      a: "0.6"
    },
    {
      n: ["ideograph advantage", "circled ideograph advantage"],
      u: "1f250",
      a: "0.6"
    },
    {
      n: ["u5272", "squared cjk unified ideograph-5272"],
      u: "1f239",
      a: "0.6"
    },
    {
      n: ["u7121", "squared cjk unified ideograph-7121"],
      u: "1f21a",
      a: "0.6"
    },
    {
      n: ["u7981", "squared cjk unified ideograph-7981"],
      u: "1f232",
      a: "0.6"
    },
    {
      n: ["accept", "circled ideograph accept"],
      u: "1f251",
      a: "0.6"
    },
    {
      n: ["u7533", "squared cjk unified ideograph-7533"],
      u: "1f238",
      a: "0.6"
    },
    {
      n: ["u5408", "squared cjk unified ideograph-5408"],
      u: "1f234",
      a: "0.6"
    },
    {
      n: ["u7a7a", "squared cjk unified ideograph-7a7a"],
      u: "1f233",
      a: "0.6"
    },
    {
      n: ["congratulations", "circled ideograph congratulation"],
      u: "3297-fe0f",
      a: "0.6"
    },
    {
      n: ["secret", "circled ideograph secret"],
      u: "3299-fe0f",
      a: "0.6"
    },
    {
      n: ["u55b6", "squared cjk unified ideograph-55b6"],
      u: "1f23a",
      a: "0.6"
    },
    {
      n: ["u6e80", "squared cjk unified ideograph-6e80"],
      u: "1f235",
      a: "0.6"
    },
    {
      n: ["red circle", "large red circle"],
      u: "1f534",
      a: "0.6"
    },
    {
      n: ["large orange circle"],
      u: "1f7e0",
      a: "12.0"
    },
    {
      n: ["large yellow circle"],
      u: "1f7e1",
      a: "12.0"
    },
    {
      n: ["large green circle"],
      u: "1f7e2",
      a: "12.0"
    },
    {
      n: ["large blue circle"],
      u: "1f535",
      a: "0.6"
    },
    {
      n: ["large purple circle"],
      u: "1f7e3",
      a: "12.0"
    },
    {
      n: ["large brown circle"],
      u: "1f7e4",
      a: "12.0"
    },
    {
      n: ["black circle", "medium black circle"],
      u: "26ab",
      a: "0.6"
    },
    {
      n: ["white circle", "medium white circle"],
      u: "26aa",
      a: "0.6"
    },
    {
      n: ["large red square"],
      u: "1f7e5",
      a: "12.0"
    },
    {
      n: ["large orange square"],
      u: "1f7e7",
      a: "12.0"
    },
    {
      n: ["large yellow square"],
      u: "1f7e8",
      a: "12.0"
    },
    {
      n: ["large green square"],
      u: "1f7e9",
      a: "12.0"
    },
    {
      n: ["large blue square"],
      u: "1f7e6",
      a: "12.0"
    },
    {
      n: ["large purple square"],
      u: "1f7ea",
      a: "12.0"
    },
    {
      n: ["large brown square"],
      u: "1f7eb",
      a: "12.0"
    },
    {
      n: ["black large square"],
      u: "2b1b",
      a: "0.6"
    },
    {
      n: ["white large square"],
      u: "2b1c",
      a: "0.6"
    },
    {
      n: ["black medium square"],
      u: "25fc-fe0f",
      a: "0.6"
    },
    {
      n: ["white medium square"],
      u: "25fb-fe0f",
      a: "0.6"
    },
    {
      n: ["black medium small square"],
      u: "25fe",
      a: "0.6"
    },
    {
      n: ["white medium small square"],
      u: "25fd",
      a: "0.6"
    },
    {
      n: ["black small square"],
      u: "25aa-fe0f",
      a: "0.6"
    },
    {
      n: ["white small square"],
      u: "25ab-fe0f",
      a: "0.6"
    },
    {
      n: ["large orange diamond"],
      u: "1f536",
      a: "0.6"
    },
    {
      n: ["large blue diamond"],
      u: "1f537",
      a: "0.6"
    },
    {
      n: ["small orange diamond"],
      u: "1f538",
      a: "0.6"
    },
    {
      n: ["small blue diamond"],
      u: "1f539",
      a: "0.6"
    },
    {
      n: ["small red triangle", "up-pointing red triangle"],
      u: "1f53a",
      a: "0.6"
    },
    {
      n: ["small red triangle down", "down-pointing red triangle"],
      u: "1f53b",
      a: "0.6"
    },
    {
      n: ["diamond shape with a dot inside"],
      u: "1f4a0",
      a: "0.6"
    },
    {
      n: ["radio button"],
      u: "1f518",
      a: "0.6"
    },
    {
      n: ["white square button"],
      u: "1f533",
      a: "0.6"
    },
    {
      n: ["black square button"],
      u: "1f532",
      a: "0.6"
    }
  ],
  flags: [
    {
      n: ["chequered flag", "checkered flag"],
      u: "1f3c1",
      a: "0.6"
    },
    {
      n: ["triangular flag on post"],
      u: "1f6a9",
      a: "0.6"
    },
    {
      n: ["crossed flags"],
      u: "1f38c",
      a: "0.6"
    },
    {
      n: ["waving black flag"],
      u: "1f3f4",
      a: "1.0"
    },
    {
      n: ["white flag", "waving white flag"],
      u: "1f3f3-fe0f",
      a: "0.7"
    },
    {
      n: ["rainbow flag", "rainbow-flag"],
      u: "1f3f3-fe0f-200d-1f308",
      a: "4.0"
    },
    {
      n: ["transgender flag"],
      u: "1f3f3-fe0f-200d-26a7-fe0f",
      a: "13.0"
    },
    {
      n: ["pirate flag"],
      u: "1f3f4-200d-2620-fe0f",
      a: "11.0"
    },
    {
      n: ["flag-ac", "ascension island flag"],
      u: "1f1e6-1f1e8",
      a: "2.0"
    },
    {
      n: ["flag-ad", "andorra flag"],
      u: "1f1e6-1f1e9",
      a: "2.0"
    },
    {
      n: ["flag-ae", "united arab emirates flag"],
      u: "1f1e6-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-af", "afghanistan flag"],
      u: "1f1e6-1f1eb",
      a: "2.0"
    },
    {
      n: ["flag-ag", "antigua & barbuda flag"],
      u: "1f1e6-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-ai", "anguilla flag"],
      u: "1f1e6-1f1ee",
      a: "2.0"
    },
    {
      n: ["flag-al", "albania flag"],
      u: "1f1e6-1f1f1",
      a: "2.0"
    },
    {
      n: ["flag-am", "armenia flag"],
      u: "1f1e6-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-ao", "angola flag"],
      u: "1f1e6-1f1f4",
      a: "2.0"
    },
    {
      n: ["flag-aq", "antarctica flag"],
      u: "1f1e6-1f1f6",
      a: "2.0"
    },
    {
      n: ["flag-ar", "argentina flag"],
      u: "1f1e6-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-as", "american samoa flag"],
      u: "1f1e6-1f1f8",
      a: "2.0"
    },
    {
      n: ["flag-at", "austria flag"],
      u: "1f1e6-1f1f9",
      a: "2.0"
    },
    {
      n: ["flag-au", "australia flag"],
      u: "1f1e6-1f1fa",
      a: "2.0"
    },
    {
      n: ["flag-aw", "aruba flag"],
      u: "1f1e6-1f1fc",
      a: "2.0"
    },
    {
      n: ["flag-ax", "åland islands flag"],
      u: "1f1e6-1f1fd",
      a: "2.0"
    },
    {
      n: ["flag-az", "azerbaijan flag"],
      u: "1f1e6-1f1ff",
      a: "2.0"
    },
    {
      n: ["flag-ba", "bosnia & herzegovina flag"],
      u: "1f1e7-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-bb", "barbados flag"],
      u: "1f1e7-1f1e7",
      a: "2.0"
    },
    {
      n: ["flag-bd", "bangladesh flag"],
      u: "1f1e7-1f1e9",
      a: "2.0"
    },
    {
      n: ["flag-be", "belgium flag"],
      u: "1f1e7-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-bf", "burkina faso flag"],
      u: "1f1e7-1f1eb",
      a: "2.0"
    },
    {
      n: ["flag-bg", "bulgaria flag"],
      u: "1f1e7-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-bh", "bahrain flag"],
      u: "1f1e7-1f1ed",
      a: "2.0"
    },
    {
      n: ["flag-bi", "burundi flag"],
      u: "1f1e7-1f1ee",
      a: "2.0"
    },
    {
      n: ["flag-bj", "benin flag"],
      u: "1f1e7-1f1ef",
      a: "2.0"
    },
    {
      n: ["flag-bl", "st. barthélemy flag"],
      u: "1f1e7-1f1f1",
      a: "2.0"
    },
    {
      n: ["flag-bm", "bermuda flag"],
      u: "1f1e7-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-bn", "brunei flag"],
      u: "1f1e7-1f1f3",
      a: "2.0"
    },
    {
      n: ["flag-bo", "bolivia flag"],
      u: "1f1e7-1f1f4",
      a: "2.0"
    },
    {
      n: ["flag-bq", "caribbean netherlands flag"],
      u: "1f1e7-1f1f6",
      a: "2.0"
    },
    {
      n: ["flag-br", "brazil flag"],
      u: "1f1e7-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-bs", "bahamas flag"],
      u: "1f1e7-1f1f8",
      a: "2.0"
    },
    {
      n: ["flag-bt", "bhutan flag"],
      u: "1f1e7-1f1f9",
      a: "2.0"
    },
    {
      n: ["flag-bv", "bouvet island flag"],
      u: "1f1e7-1f1fb",
      a: "2.0"
    },
    {
      n: ["flag-bw", "botswana flag"],
      u: "1f1e7-1f1fc",
      a: "2.0"
    },
    {
      n: ["flag-by", "belarus flag"],
      u: "1f1e7-1f1fe",
      a: "2.0"
    },
    {
      n: ["flag-bz", "belize flag"],
      u: "1f1e7-1f1ff",
      a: "2.0"
    },
    {
      n: ["flag-ca", "canada flag"],
      u: "1f1e8-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-cc", "cocos (keeling) islands flag"],
      u: "1f1e8-1f1e8",
      a: "2.0"
    },
    {
      n: ["flag-cd", "congo - kinshasa flag"],
      u: "1f1e8-1f1e9",
      a: "2.0"
    },
    {
      n: ["flag-cf", "central african republic flag"],
      u: "1f1e8-1f1eb",
      a: "2.0"
    },
    {
      n: ["flag-cg", "congo - brazzaville flag"],
      u: "1f1e8-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-ch", "switzerland flag"],
      u: "1f1e8-1f1ed",
      a: "2.0"
    },
    {
      n: ["flag-ci", "côte d’ivoire flag"],
      u: "1f1e8-1f1ee",
      a: "2.0"
    },
    {
      n: ["flag-ck", "cook islands flag"],
      u: "1f1e8-1f1f0",
      a: "2.0"
    },
    {
      n: ["flag-cl", "chile flag"],
      u: "1f1e8-1f1f1",
      a: "2.0"
    },
    {
      n: ["flag-cm", "cameroon flag"],
      u: "1f1e8-1f1f2",
      a: "2.0"
    },
    {
      n: ["cn", "flag-cn", "china flag"],
      u: "1f1e8-1f1f3",
      a: "0.6"
    },
    {
      n: ["flag-co", "colombia flag"],
      u: "1f1e8-1f1f4",
      a: "2.0"
    },
    {
      n: ["flag-cp", "clipperton island flag"],
      u: "1f1e8-1f1f5",
      a: "2.0"
    },
    {
      n: ["flag-cr", "costa rica flag"],
      u: "1f1e8-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-cu", "cuba flag"],
      u: "1f1e8-1f1fa",
      a: "2.0"
    },
    {
      n: ["flag-cv", "cape verde flag"],
      u: "1f1e8-1f1fb",
      a: "2.0"
    },
    {
      n: ["flag-cw", "curaçao flag"],
      u: "1f1e8-1f1fc",
      a: "2.0"
    },
    {
      n: ["flag-cx", "christmas island flag"],
      u: "1f1e8-1f1fd",
      a: "2.0"
    },
    {
      n: ["flag-cy", "cyprus flag"],
      u: "1f1e8-1f1fe",
      a: "2.0"
    },
    {
      n: ["flag-cz", "czechia flag"],
      u: "1f1e8-1f1ff",
      a: "2.0"
    },
    {
      n: ["de", "flag-de", "germany flag"],
      u: "1f1e9-1f1ea",
      a: "0.6"
    },
    {
      n: ["flag-dg", "diego garcia flag"],
      u: "1f1e9-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-dj", "djibouti flag"],
      u: "1f1e9-1f1ef",
      a: "2.0"
    },
    {
      n: ["flag-dk", "denmark flag"],
      u: "1f1e9-1f1f0",
      a: "2.0"
    },
    {
      n: ["flag-dm", "dominica flag"],
      u: "1f1e9-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-do", "dominican republic flag"],
      u: "1f1e9-1f1f4",
      a: "2.0"
    },
    {
      n: ["flag-dz", "algeria flag"],
      u: "1f1e9-1f1ff",
      a: "2.0"
    },
    {
      n: ["flag-ea", "ceuta & melilla flag"],
      u: "1f1ea-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-ec", "ecuador flag"],
      u: "1f1ea-1f1e8",
      a: "2.0"
    },
    {
      n: ["flag-ee", "estonia flag"],
      u: "1f1ea-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-eg", "egypt flag"],
      u: "1f1ea-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-eh", "western sahara flag"],
      u: "1f1ea-1f1ed",
      a: "2.0"
    },
    {
      n: ["flag-er", "eritrea flag"],
      u: "1f1ea-1f1f7",
      a: "2.0"
    },
    {
      n: ["es", "flag-es", "spain flag"],
      u: "1f1ea-1f1f8",
      a: "0.6"
    },
    {
      n: ["flag-et", "ethiopia flag"],
      u: "1f1ea-1f1f9",
      a: "2.0"
    },
    {
      n: ["flag-eu", "european union flag"],
      u: "1f1ea-1f1fa",
      a: "2.0"
    },
    {
      n: ["flag-fi", "finland flag"],
      u: "1f1eb-1f1ee",
      a: "2.0"
    },
    {
      n: ["flag-fj", "fiji flag"],
      u: "1f1eb-1f1ef",
      a: "2.0"
    },
    {
      n: ["flag-fk", "falkland islands flag"],
      u: "1f1eb-1f1f0",
      a: "2.0"
    },
    {
      n: ["flag-fm", "micronesia flag"],
      u: "1f1eb-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-fo", "faroe islands flag"],
      u: "1f1eb-1f1f4",
      a: "2.0"
    },
    {
      n: ["fr", "flag-fr", "france flag"],
      u: "1f1eb-1f1f7",
      a: "0.6"
    },
    {
      n: ["flag-ga", "gabon flag"],
      u: "1f1ec-1f1e6",
      a: "2.0"
    },
    {
      n: ["gb", "uk", "flag-gb", "united kingdom flag"],
      u: "1f1ec-1f1e7",
      a: "0.6"
    },
    {
      n: ["flag-gd", "grenada flag"],
      u: "1f1ec-1f1e9",
      a: "2.0"
    },
    {
      n: ["flag-ge", "georgia flag"],
      u: "1f1ec-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-gf", "french guiana flag"],
      u: "1f1ec-1f1eb",
      a: "2.0"
    },
    {
      n: ["flag-gg", "guernsey flag"],
      u: "1f1ec-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-gh", "ghana flag"],
      u: "1f1ec-1f1ed",
      a: "2.0"
    },
    {
      n: ["flag-gi", "gibraltar flag"],
      u: "1f1ec-1f1ee",
      a: "2.0"
    },
    {
      n: ["flag-gl", "greenland flag"],
      u: "1f1ec-1f1f1",
      a: "2.0"
    },
    {
      n: ["flag-gm", "gambia flag"],
      u: "1f1ec-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-gn", "guinea flag"],
      u: "1f1ec-1f1f3",
      a: "2.0"
    },
    {
      n: ["flag-gp", "guadeloupe flag"],
      u: "1f1ec-1f1f5",
      a: "2.0"
    },
    {
      n: ["flag-gq", "equatorial guinea flag"],
      u: "1f1ec-1f1f6",
      a: "2.0"
    },
    {
      n: ["flag-gr", "greece flag"],
      u: "1f1ec-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-gs", "south georgia & south sandwich islands flag"],
      u: "1f1ec-1f1f8",
      a: "2.0"
    },
    {
      n: ["flag-gt", "guatemala flag"],
      u: "1f1ec-1f1f9",
      a: "2.0"
    },
    {
      n: ["flag-gu", "guam flag"],
      u: "1f1ec-1f1fa",
      a: "2.0"
    },
    {
      n: ["flag-gw", "guinea-bissau flag"],
      u: "1f1ec-1f1fc",
      a: "2.0"
    },
    {
      n: ["flag-gy", "guyana flag"],
      u: "1f1ec-1f1fe",
      a: "2.0"
    },
    {
      n: ["flag-hk", "hong kong sar china flag"],
      u: "1f1ed-1f1f0",
      a: "2.0"
    },
    {
      n: ["flag-hm", "heard & mcdonald islands flag"],
      u: "1f1ed-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-hn", "honduras flag"],
      u: "1f1ed-1f1f3",
      a: "2.0"
    },
    {
      n: ["flag-hr", "croatia flag"],
      u: "1f1ed-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-ht", "haiti flag"],
      u: "1f1ed-1f1f9",
      a: "2.0"
    },
    {
      n: ["flag-hu", "hungary flag"],
      u: "1f1ed-1f1fa",
      a: "2.0"
    },
    {
      n: ["flag-ic", "canary islands flag"],
      u: "1f1ee-1f1e8",
      a: "2.0"
    },
    {
      n: ["flag-id", "indonesia flag"],
      u: "1f1ee-1f1e9",
      a: "2.0"
    },
    {
      n: ["flag-ie", "ireland flag"],
      u: "1f1ee-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-il", "israel flag"],
      u: "1f1ee-1f1f1",
      a: "2.0"
    },
    {
      n: ["flag-im", "isle of man flag"],
      u: "1f1ee-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-in", "india flag"],
      u: "1f1ee-1f1f3",
      a: "2.0"
    },
    {
      n: ["flag-io", "british indian ocean territory flag"],
      u: "1f1ee-1f1f4",
      a: "2.0"
    },
    {
      n: ["flag-iq", "iraq flag"],
      u: "1f1ee-1f1f6",
      a: "2.0"
    },
    {
      n: ["flag-ir", "iran flag"],
      u: "1f1ee-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-is", "iceland flag"],
      u: "1f1ee-1f1f8",
      a: "2.0"
    },
    {
      n: ["it", "flag-it", "italy flag"],
      u: "1f1ee-1f1f9",
      a: "0.6"
    },
    {
      n: ["flag-je", "jersey flag"],
      u: "1f1ef-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-jm", "jamaica flag"],
      u: "1f1ef-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-jo", "jordan flag"],
      u: "1f1ef-1f1f4",
      a: "2.0"
    },
    {
      n: ["jp", "flag-jp", "japan flag"],
      u: "1f1ef-1f1f5",
      a: "0.6"
    },
    {
      n: ["flag-ke", "kenya flag"],
      u: "1f1f0-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-kg", "kyrgyzstan flag"],
      u: "1f1f0-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-kh", "cambodia flag"],
      u: "1f1f0-1f1ed",
      a: "2.0"
    },
    {
      n: ["flag-ki", "kiribati flag"],
      u: "1f1f0-1f1ee",
      a: "2.0"
    },
    {
      n: ["flag-km", "comoros flag"],
      u: "1f1f0-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-kn", "st. kitts & nevis flag"],
      u: "1f1f0-1f1f3",
      a: "2.0"
    },
    {
      n: ["flag-kp", "north korea flag"],
      u: "1f1f0-1f1f5",
      a: "2.0"
    },
    {
      n: ["kr", "flag-kr", "south korea flag"],
      u: "1f1f0-1f1f7",
      a: "0.6"
    },
    {
      n: ["flag-kw", "kuwait flag"],
      u: "1f1f0-1f1fc",
      a: "2.0"
    },
    {
      n: ["flag-ky", "cayman islands flag"],
      u: "1f1f0-1f1fe",
      a: "2.0"
    },
    {
      n: ["flag-kz", "kazakhstan flag"],
      u: "1f1f0-1f1ff",
      a: "2.0"
    },
    {
      n: ["flag-la", "laos flag"],
      u: "1f1f1-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-lb", "lebanon flag"],
      u: "1f1f1-1f1e7",
      a: "2.0"
    },
    {
      n: ["flag-lc", "st. lucia flag"],
      u: "1f1f1-1f1e8",
      a: "2.0"
    },
    {
      n: ["flag-li", "liechtenstein flag"],
      u: "1f1f1-1f1ee",
      a: "2.0"
    },
    {
      n: ["flag-lk", "sri lanka flag"],
      u: "1f1f1-1f1f0",
      a: "2.0"
    },
    {
      n: ["flag-lr", "liberia flag"],
      u: "1f1f1-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-ls", "lesotho flag"],
      u: "1f1f1-1f1f8",
      a: "2.0"
    },
    {
      n: ["flag-lt", "lithuania flag"],
      u: "1f1f1-1f1f9",
      a: "2.0"
    },
    {
      n: ["flag-lu", "luxembourg flag"],
      u: "1f1f1-1f1fa",
      a: "2.0"
    },
    {
      n: ["flag-lv", "latvia flag"],
      u: "1f1f1-1f1fb",
      a: "2.0"
    },
    {
      n: ["flag-ly", "libya flag"],
      u: "1f1f1-1f1fe",
      a: "2.0"
    },
    {
      n: ["flag-ma", "morocco flag"],
      u: "1f1f2-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-mc", "monaco flag"],
      u: "1f1f2-1f1e8",
      a: "2.0"
    },
    {
      n: ["flag-md", "moldova flag"],
      u: "1f1f2-1f1e9",
      a: "2.0"
    },
    {
      n: ["flag-me", "montenegro flag"],
      u: "1f1f2-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-mf", "st. martin flag"],
      u: "1f1f2-1f1eb",
      a: "2.0"
    },
    {
      n: ["flag-mg", "madagascar flag"],
      u: "1f1f2-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-mh", "marshall islands flag"],
      u: "1f1f2-1f1ed",
      a: "2.0"
    },
    {
      n: ["flag-mk", "north macedonia flag"],
      u: "1f1f2-1f1f0",
      a: "2.0"
    },
    {
      n: ["flag-ml", "mali flag"],
      u: "1f1f2-1f1f1",
      a: "2.0"
    },
    {
      n: ["flag-mm", "myanmar (burma) flag"],
      u: "1f1f2-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-mn", "mongolia flag"],
      u: "1f1f2-1f1f3",
      a: "2.0"
    },
    {
      n: ["flag-mo", "macao sar china flag"],
      u: "1f1f2-1f1f4",
      a: "2.0"
    },
    {
      n: ["flag-mp", "northern mariana islands flag"],
      u: "1f1f2-1f1f5",
      a: "2.0"
    },
    {
      n: ["flag-mq", "martinique flag"],
      u: "1f1f2-1f1f6",
      a: "2.0"
    },
    {
      n: ["flag-mr", "mauritania flag"],
      u: "1f1f2-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-ms", "montserrat flag"],
      u: "1f1f2-1f1f8",
      a: "2.0"
    },
    {
      n: ["flag-mt", "malta flag"],
      u: "1f1f2-1f1f9",
      a: "2.0"
    },
    {
      n: ["flag-mu", "mauritius flag"],
      u: "1f1f2-1f1fa",
      a: "2.0"
    },
    {
      n: ["flag-mv", "maldives flag"],
      u: "1f1f2-1f1fb",
      a: "2.0"
    },
    {
      n: ["flag-mw", "malawi flag"],
      u: "1f1f2-1f1fc",
      a: "2.0"
    },
    {
      n: ["flag-mx", "mexico flag"],
      u: "1f1f2-1f1fd",
      a: "2.0"
    },
    {
      n: ["flag-my", "malaysia flag"],
      u: "1f1f2-1f1fe",
      a: "2.0"
    },
    {
      n: ["flag-mz", "mozambique flag"],
      u: "1f1f2-1f1ff",
      a: "2.0"
    },
    {
      n: ["flag-na", "namibia flag"],
      u: "1f1f3-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-nc", "new caledonia flag"],
      u: "1f1f3-1f1e8",
      a: "2.0"
    },
    {
      n: ["flag-ne", "niger flag"],
      u: "1f1f3-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-nf", "norfolk island flag"],
      u: "1f1f3-1f1eb",
      a: "2.0"
    },
    {
      n: ["flag-ng", "nigeria flag"],
      u: "1f1f3-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-ni", "nicaragua flag"],
      u: "1f1f3-1f1ee",
      a: "2.0"
    },
    {
      n: ["flag-nl", "netherlands flag"],
      u: "1f1f3-1f1f1",
      a: "2.0"
    },
    {
      n: ["flag-no", "norway flag"],
      u: "1f1f3-1f1f4",
      a: "2.0"
    },
    {
      n: ["flag-np", "nepal flag"],
      u: "1f1f3-1f1f5",
      a: "2.0"
    },
    {
      n: ["flag-nr", "nauru flag"],
      u: "1f1f3-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-nu", "niue flag"],
      u: "1f1f3-1f1fa",
      a: "2.0"
    },
    {
      n: ["flag-nz", "new zealand flag"],
      u: "1f1f3-1f1ff",
      a: "2.0"
    },
    {
      n: ["flag-om", "oman flag"],
      u: "1f1f4-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-pa", "panama flag"],
      u: "1f1f5-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-pe", "peru flag"],
      u: "1f1f5-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-pf", "french polynesia flag"],
      u: "1f1f5-1f1eb",
      a: "2.0"
    },
    {
      n: ["flag-pg", "papua new guinea flag"],
      u: "1f1f5-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-ph", "philippines flag"],
      u: "1f1f5-1f1ed",
      a: "2.0"
    },
    {
      n: ["flag-pk", "pakistan flag"],
      u: "1f1f5-1f1f0",
      a: "2.0"
    },
    {
      n: ["flag-pl", "poland flag"],
      u: "1f1f5-1f1f1",
      a: "2.0"
    },
    {
      n: ["flag-pm", "st. pierre & miquelon flag"],
      u: "1f1f5-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-pn", "pitcairn islands flag"],
      u: "1f1f5-1f1f3",
      a: "2.0"
    },
    {
      n: ["flag-pr", "puerto rico flag"],
      u: "1f1f5-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-ps", "palestinian territories flag"],
      u: "1f1f5-1f1f8",
      a: "2.0"
    },
    {
      n: ["flag-pt", "portugal flag"],
      u: "1f1f5-1f1f9",
      a: "2.0"
    },
    {
      n: ["flag-pw", "palau flag"],
      u: "1f1f5-1f1fc",
      a: "2.0"
    },
    {
      n: ["flag-py", "paraguay flag"],
      u: "1f1f5-1f1fe",
      a: "2.0"
    },
    {
      n: ["flag-qa", "qatar flag"],
      u: "1f1f6-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-re", "réunion flag"],
      u: "1f1f7-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-ro", "romania flag"],
      u: "1f1f7-1f1f4",
      a: "2.0"
    },
    {
      n: ["flag-rs", "serbia flag"],
      u: "1f1f7-1f1f8",
      a: "2.0"
    },
    {
      n: ["ru", "flag-ru", "russia flag"],
      u: "1f1f7-1f1fa",
      a: "0.6"
    },
    {
      n: ["flag-rw", "rwanda flag"],
      u: "1f1f7-1f1fc",
      a: "2.0"
    },
    {
      n: ["flag-sa", "saudi arabia flag"],
      u: "1f1f8-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-sb", "solomon islands flag"],
      u: "1f1f8-1f1e7",
      a: "2.0"
    },
    {
      n: ["flag-sc", "seychelles flag"],
      u: "1f1f8-1f1e8",
      a: "2.0"
    },
    {
      n: ["flag-sd", "sudan flag"],
      u: "1f1f8-1f1e9",
      a: "2.0"
    },
    {
      n: ["flag-se", "sweden flag"],
      u: "1f1f8-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-sg", "singapore flag"],
      u: "1f1f8-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-sh", "st. helena flag"],
      u: "1f1f8-1f1ed",
      a: "2.0"
    },
    {
      n: ["flag-si", "slovenia flag"],
      u: "1f1f8-1f1ee",
      a: "2.0"
    },
    {
      n: ["flag-sj", "svalbard & jan mayen flag"],
      u: "1f1f8-1f1ef",
      a: "2.0"
    },
    {
      n: ["flag-sk", "slovakia flag"],
      u: "1f1f8-1f1f0",
      a: "2.0"
    },
    {
      n: ["flag-sl", "sierra leone flag"],
      u: "1f1f8-1f1f1",
      a: "2.0"
    },
    {
      n: ["flag-sm", "san marino flag"],
      u: "1f1f8-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-sn", "senegal flag"],
      u: "1f1f8-1f1f3",
      a: "2.0"
    },
    {
      n: ["flag-so", "somalia flag"],
      u: "1f1f8-1f1f4",
      a: "2.0"
    },
    {
      n: ["flag-sr", "suriname flag"],
      u: "1f1f8-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-ss", "south sudan flag"],
      u: "1f1f8-1f1f8",
      a: "2.0"
    },
    {
      n: ["flag-st", "são tomé & príncipe flag"],
      u: "1f1f8-1f1f9",
      a: "2.0"
    },
    {
      n: ["flag-sv", "el salvador flag"],
      u: "1f1f8-1f1fb",
      a: "2.0"
    },
    {
      n: ["flag-sx", "sint maarten flag"],
      u: "1f1f8-1f1fd",
      a: "2.0"
    },
    {
      n: ["flag-sy", "syria flag"],
      u: "1f1f8-1f1fe",
      a: "2.0"
    },
    {
      n: ["flag-sz", "eswatini flag"],
      u: "1f1f8-1f1ff",
      a: "2.0"
    },
    {
      n: ["flag-ta", "tristan da cunha flag"],
      u: "1f1f9-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-tc", "turks & caicos islands flag"],
      u: "1f1f9-1f1e8",
      a: "2.0"
    },
    {
      n: ["flag-td", "chad flag"],
      u: "1f1f9-1f1e9",
      a: "2.0"
    },
    {
      n: ["flag-tf", "french southern territories flag"],
      u: "1f1f9-1f1eb",
      a: "2.0"
    },
    {
      n: ["flag-tg", "togo flag"],
      u: "1f1f9-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-th", "thailand flag"],
      u: "1f1f9-1f1ed",
      a: "2.0"
    },
    {
      n: ["flag-tj", "tajikistan flag"],
      u: "1f1f9-1f1ef",
      a: "2.0"
    },
    {
      n: ["flag-tk", "tokelau flag"],
      u: "1f1f9-1f1f0",
      a: "2.0"
    },
    {
      n: ["flag-tl", "timor-leste flag"],
      u: "1f1f9-1f1f1",
      a: "2.0"
    },
    {
      n: ["flag-tm", "turkmenistan flag"],
      u: "1f1f9-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-tn", "tunisia flag"],
      u: "1f1f9-1f1f3",
      a: "2.0"
    },
    {
      n: ["flag-to", "tonga flag"],
      u: "1f1f9-1f1f4",
      a: "2.0"
    },
    {
      n: ["flag-tr", "turkey flag"],
      u: "1f1f9-1f1f7",
      a: "2.0"
    },
    {
      n: ["flag-tt", "trinidad & tobago flag"],
      u: "1f1f9-1f1f9",
      a: "2.0"
    },
    {
      n: ["flag-tv", "tuvalu flag"],
      u: "1f1f9-1f1fb",
      a: "2.0"
    },
    {
      n: ["flag-tw", "taiwan flag"],
      u: "1f1f9-1f1fc",
      a: "2.0"
    },
    {
      n: ["flag-tz", "tanzania flag"],
      u: "1f1f9-1f1ff",
      a: "2.0"
    },
    {
      n: ["flag-ua", "ukraine flag"],
      u: "1f1fa-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-ug", "uganda flag"],
      u: "1f1fa-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-um", "u.s. outlying islands flag"],
      u: "1f1fa-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-un", "united nations flag"],
      u: "1f1fa-1f1f3",
      a: "4.0"
    },
    {
      n: ["us", "flag-us", "united states flag"],
      u: "1f1fa-1f1f8",
      a: "0.6"
    },
    {
      n: ["flag-uy", "uruguay flag"],
      u: "1f1fa-1f1fe",
      a: "2.0"
    },
    {
      n: ["flag-uz", "uzbekistan flag"],
      u: "1f1fa-1f1ff",
      a: "2.0"
    },
    {
      n: ["flag-va", "vatican city flag"],
      u: "1f1fb-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-vc", "st. vincent & grenadines flag"],
      u: "1f1fb-1f1e8",
      a: "2.0"
    },
    {
      n: ["flag-ve", "venezuela flag"],
      u: "1f1fb-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-vg", "british virgin islands flag"],
      u: "1f1fb-1f1ec",
      a: "2.0"
    },
    {
      n: ["flag-vi", "u.s. virgin islands flag"],
      u: "1f1fb-1f1ee",
      a: "2.0"
    },
    {
      n: ["flag-vn", "vietnam flag"],
      u: "1f1fb-1f1f3",
      a: "2.0"
    },
    {
      n: ["flag-vu", "vanuatu flag"],
      u: "1f1fb-1f1fa",
      a: "2.0"
    },
    {
      n: ["flag-wf", "wallis & futuna flag"],
      u: "1f1fc-1f1eb",
      a: "2.0"
    },
    {
      n: ["flag-ws", "samoa flag"],
      u: "1f1fc-1f1f8",
      a: "2.0"
    },
    {
      n: ["flag-xk", "kosovo flag"],
      u: "1f1fd-1f1f0",
      a: "2.0"
    },
    {
      n: ["flag-ye", "yemen flag"],
      u: "1f1fe-1f1ea",
      a: "2.0"
    },
    {
      n: ["flag-yt", "mayotte flag"],
      u: "1f1fe-1f1f9",
      a: "2.0"
    },
    {
      n: ["flag-za", "south africa flag"],
      u: "1f1ff-1f1e6",
      a: "2.0"
    },
    {
      n: ["flag-zm", "zambia flag"],
      u: "1f1ff-1f1f2",
      a: "2.0"
    },
    {
      n: ["flag-zw", "zimbabwe flag"],
      u: "1f1ff-1f1fc",
      a: "2.0"
    },
    {
      n: ["england flag", "flag-england"],
      u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
      a: "5.0"
    },
    {
      n: ["scotland flag", "flag-scotland"],
      u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
      a: "5.0"
    },
    {
      n: ["wales flag", "flag-wales"],
      u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
      a: "5.0"
    }
  ]
}, vd = Object.keys(Xf).reduce((t, e) => (Xf[e].forEach((n) => {
  t[n.u] = n;
}), t), {}), fj = {
  popular: "Popular",
  smileys_people: "Smileys & People",
  animals_nature: "Animals & Nature",
  food_drink: "Food & Drink",
  travel_places: "Travel & Places",
  activities: "Activities",
  objects: "Objects",
  symbols: "Symbols",
  flags: "Flags"
};
function cj(t) {
  return /* @__PURE__ */ g("div", {
    className: oj,
    children: /* @__PURE__ */ g(uj, {
      onClick: t.onClick,
      emojis: t.emojis
    })
  });
}
function uj(t) {
  return /* @__PURE__ */ g("div", {
    className: sj,
    children: t.emojis.filter((e) => e.u).map((e, n) => /* @__PURE__ */ g(Nk, {
      onClick: t.onClick,
      emoji: e
    }, n))
  });
}
function dj(t) {
  return /* @__PURE__ */ g("div", {
    className: lj(),
    ...t,
    children: t.children
  });
}
const hj = he.memo(function(e) {
  return /* @__PURE__ */ g(dj, {
    children: /* @__PURE__ */ g(Ji, {
      children: Object.keys(Xf).filter((n) => n === "popular").map((n) => /* @__PURE__ */ g(cj, {
        onClick: e.onClick,
        title: fj[n],
        emojis: Xf[n]
      }, n))
    })
  });
});
function Mk(t) {
  const {
    target: e
  } = t, {
    events: n,
    store: r
  } = ke(), {
    reactingId: i
  } = ie(r), o = Uo(i, e), a = Oe((s) => {
    n.onReactionPickerOpenChange({
      target: e,
      open: s
    });
  }, [e, o]);
  return /* @__PURE__ */ D(Qc, {
    contentVisible: o,
    previewVisible: !1,
    onContentChange: a,
    onPreviewChange: () => {
    },
    placement: t.placement ?? "top-start",
    dismissOnClickOutside: !0,
    shouldFlipToKeepInView: !0,
    children: [/* @__PURE__ */ g(qc, {
      children: /* @__PURE__ */ g(Rn, {
        small: t.smallIconButton,
        onClick: (s) => {
          s.preventDefault(), s.stopPropagation(), a(!o);
        },
        children: /* @__PURE__ */ g(s$, {
          weight: "regular"
        })
      })
    }), /* @__PURE__ */ g(Q0, {
      children: /* @__PURE__ */ g(Gc, {
        children: /* @__PURE__ */ g(hj, {
          onClick: (s, l) => {
            n.onClick(s, {
              target: {
                ...e,
                type: "emoji",
                emoji: l
              }
            });
          }
        })
      })
    })]
  });
}
function fa() {
  var i;
  const t = pr(), e = xe(), r = (i = ie(Gt()).computed[e]) == null ? void 0 : i.canonicalEvents[t];
  if (!r)
    throw new Error(`Could not find snapshot for comment '${t}'`);
  return r;
}
const sh = /* @__PURE__ */ new Map(), kl = /* @__PURE__ */ new WeakMap();
let _2 = 0, gj;
function pj(t) {
  return t ? (kl.has(t) || (_2 += 1, kl.set(t, _2.toString())), kl.get(t)) : "0";
}
function mj(t) {
  return Object.keys(t).sort().filter((e) => t[e] !== void 0).map((e) => `${e}_${e === "root" ? pj(t.root) : t[e]}`).toString();
}
function vj(t) {
  let e = mj(t), n = sh.get(e);
  if (!n) {
    const r = /* @__PURE__ */ new Map();
    let i;
    const o = new IntersectionObserver((a) => {
      a.forEach((s) => {
        var l;
        const f = s.isIntersecting && i.some((c) => s.intersectionRatio >= c);
        t.trackVisibility && typeof s.isVisible > "u" && (s.isVisible = f), (l = r.get(s.target)) == null || l.forEach((c) => {
          c(f, s);
        });
      });
    }, t);
    i = o.thresholds || (Array.isArray(t.threshold) ? t.threshold : [t.threshold || 0]), n = {
      id: e,
      observer: o,
      elements: r
    }, sh.set(e, n);
  }
  return n;
}
function bj(t, e, n = {}, r = gj) {
  if (typeof window.IntersectionObserver > "u" && r !== void 0) {
    const l = t.getBoundingClientRect();
    return e(r, {
      isIntersecting: r,
      target: t,
      intersectionRatio: typeof n.threshold == "number" ? n.threshold : 0,
      time: 0,
      boundingClientRect: l,
      intersectionRect: l,
      rootBounds: l
    }), () => {
    };
  }
  const {
    id: i,
    observer: o,
    elements: a
  } = vj(n);
  let s = a.get(t) || [];
  return a.has(t) || a.set(t, s), s.push(e), o.observe(t), function() {
    s.splice(s.indexOf(e), 1), s.length === 0 && (a.delete(t), o.unobserve(t)), a.size === 0 && (o.disconnect(), sh.delete(i));
  };
}
function yj({
  threshold: t,
  delay: e,
  trackVisibility: n,
  rootMargin: r,
  root: i,
  triggerOnce: o,
  skip: a,
  initialInView: s,
  fallbackInView: l,
  onChange: f
} = {}) {
  var c;
  const [u, d] = T.useState(null), h = T.useRef(), [p, m] = T.useState({
    inView: !!s,
    entry: void 0
  });
  h.current = f, T.useEffect(
    () => {
      if (a || !u)
        return;
      let k = bj(u, (_, E) => {
        m({
          inView: _,
          entry: E
        }), h.current && h.current(_, E), E.isIntersecting && o && k && (k(), k = void 0);
      }, {
        root: i,
        rootMargin: r,
        threshold: t,
        // @ts-ignore
        trackVisibility: n,
        // @ts-ignore
        delay: e
      }, l);
      return () => {
        k && k();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(t) ? t.toString() : t,
      u,
      i,
      r,
      o,
      a,
      n,
      l,
      e
    ]
  );
  const v = (c = p.entry) == null ? void 0 : c.target;
  T.useEffect(() => {
    !u && v && !o && !a && m({
      inView: !!s,
      entry: void 0
    });
  }, [u, v, o, a, s]);
  const b = [d, p.inView, p.entry];
  return b.ref = b[0], b.inView = b[1], b.entry = b[2], b;
}
function Ak() {
  const [t, e] = Dt(() => window ? window.document.hasFocus() : !1);
  return ce(() => {
    if (!window)
      return;
    const n = () => e(!0), r = () => e(!1);
    return window.addEventListener("focus", n), window.addEventListener("blur", r), () => {
      window.removeEventListener("focus", n), window.removeEventListener("blur", r);
    };
  }, []), t;
}
function _j(t) {
  const {
    events: e
  } = ke(), n = Ak(), {
    ref: r,
    inView: i
  } = yj({
    threshold: 0
  });
  return ce(() => {
    n && i && e.onSeen({
      target: t
    });
  }, [n, i]), {
    ref: r
  };
}
function Ok(t) {
  const {
    store: e,
    threadId: n,
    workspaceId: r
  } = t;
  ce(() => {
    r && n && (bc(e, {
      workspaceId: r,
      threadId: n
    }), fi(e, {
      workspaceId: r,
      threadId: n
    }));
  }, [r, n]);
}
function Dk(t) {
  var a;
  const e = _e(), { workspaceId: n, workspaces: r, userId: i } = ie(e), o = n ? r[n] : null;
  return Ok({ store: e, threadId: t.threadId, workspaceId: n }), !i || !o ? 0 : ((a = o.computed[t.threadId]) == null ? void 0 : a.unreadCount) ?? 0;
}
var w2 = {}, wj = {
  get exports() {
    return w2;
  },
  set exports(t) {
    w2 = t;
  }
};
(function(t) {
  (function() {
    var e = function(n) {
      this._buildTables(n);
    };
    e.prototype._buildTables = function(n) {
      var r = {
        0: {}
      }, i = {}, o = 0;
      n.forEach(function(d) {
        for (var h = 0, p = 0; p < d.length; p++) {
          var m = d[p];
          r[h] && m in r[h] ? h = r[h][m] : (o++, r[h][m] = o, r[o] = {}, h = o, i[o] = []);
        }
        i[h].push(d);
      });
      var a = {}, s = [];
      for (var l in r[0]) {
        var o = r[0][l];
        a[o] = 0, s.push(o);
      }
      for (; s.length; ) {
        var f = s.shift();
        for (var l in r[f]) {
          var c = r[f][l];
          s.push(c);
          for (var o = a[f]; o > 0 && !(l in r[o]); )
            o = a[o];
          if (l in r[o]) {
            var u = r[o][l];
            a[c] = u, i[c] = i[c].concat(i[u]);
          } else
            a[c] = 0;
        }
      }
      this.gotoFn = r, this.output = i, this.failure = a;
    }, e.prototype.search = function(n) {
      for (var r = 0, i = [], o = 0; o < n.length; o++) {
        for (var a = n[o]; r > 0 && !(a in this.gotoFn[r]); )
          r = this.failure[r];
        if (a in this.gotoFn[r] && (r = this.gotoFn[r][a], this.output[r].length)) {
          var s = this.output[r];
          i.push([o, s]);
        }
      }
      return i;
    }, t.exports = e;
  })();
})(wj);
var kj = {}, zo = {}, Cj = Bt && Bt.__spreadArray || function(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = e.length, o; r < i; r++)
      (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
};
Object.defineProperty(zo, "__esModule", { value: !0 });
zo.isTraversal = void 0;
var k2 = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/, xj = /\\([\da-f]{1,6}\s?|(\s)|.)/gi, Ej = /* @__PURE__ */ new Map([
  ["~", "element"],
  ["^", "start"],
  ["$", "end"],
  ["*", "any"],
  ["!", "not"],
  ["|", "hyphen"]
]), Jf = {
  ">": "child",
  "<": "parent",
  "~": "sibling",
  "+": "adjacent"
}, C2 = {
  "#": ["id", "equals"],
  ".": ["class", "element"]
}, Tj = /* @__PURE__ */ new Set([
  "has",
  "not",
  "matches",
  "is",
  "where",
  "host",
  "host-context"
]), Sj = new Set(Cj([
  "descendant"
], Object.keys(Jf).map(function(t) {
  return Jf[t];
}), !0)), Ij = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "align",
  "alink",
  "axis",
  "bgcolor",
  "charset",
  "checked",
  "clear",
  "codetype",
  "color",
  "compact",
  "declare",
  "defer",
  "dir",
  "direction",
  "disabled",
  "enctype",
  "face",
  "frame",
  "hreflang",
  "http-equiv",
  "lang",
  "language",
  "link",
  "media",
  "method",
  "multiple",
  "nohref",
  "noresize",
  "noshade",
  "nowrap",
  "readonly",
  "rel",
  "rev",
  "rules",
  "scope",
  "scrolling",
  "selected",
  "shape",
  "target",
  "text",
  "type",
  "valign",
  "valuetype",
  "vlink"
]);
function Pk(t) {
  return Sj.has(t.type);
}
zo.isTraversal = Pk;
var Nj = /* @__PURE__ */ new Set(["contains", "icontains"]), bd = /* @__PURE__ */ new Set(['"', "'"]);
function Mj(t, e, n) {
  var r = parseInt(e, 16) - 65536;
  return r !== r || n ? e : r < 0 ? (
    // BMP codepoint
    String.fromCharCode(r + 65536)
  ) : (
    // Supplemental Plane codepoint (surrogate pair)
    String.fromCharCode(r >> 10 | 55296, r & 1023 | 56320)
  );
}
function Cl(t) {
  return t.replace(xj, Mj);
}
function yd(t) {
  return t === " " || t === `
` || t === "	" || t === "\f" || t === "\r";
}
function Aj(t, e) {
  var n = [], r = Rk(n, "" + t, e, 0);
  if (r < t.length)
    throw new Error("Unmatched selector: " + t.slice(r));
  return n;
}
zo.default = Aj;
function Rk(t, e, n, r) {
  var i, o;
  n === void 0 && (n = {});
  var a = [], s = !1;
  function l(X) {
    var B = e.slice(r + X).match(k2);
    if (!B)
      throw new Error("Expected name, found " + e.slice(r));
    var G = B[0];
    return r += X + G.length, Cl(G);
  }
  function f(X) {
    for (; yd(e.charAt(r + X)); )
      X++;
    r += X;
  }
  function c(X) {
    for (var B = 0; e.charAt(--X) === "\\"; )
      B++;
    return (B & 1) === 1;
  }
  function u() {
    if (a.length > 0 && Pk(a[a.length - 1]))
      throw new Error("Did not expect successive traversals.");
  }
  for (f(0); e !== ""; ) {
    var d = e.charAt(r);
    if (yd(d))
      s = !0, f(1);
    else if (d in Jf)
      u(), a.push({ type: Jf[d] }), s = !1, f(1);
    else if (d === ",") {
      if (a.length === 0)
        throw new Error("Empty sub-selector");
      t.push(a), a = [], s = !1, f(1);
    } else if (e.startsWith("/*", r)) {
      var h = e.indexOf("*/", r + 2);
      if (h < 0)
        throw new Error("Comment was not terminated");
      r = h + 2;
    } else if (s && (u(), a.push({ type: "descendant" }), s = !1), d in C2) {
      var p = C2[d], m = p[0], v = p[1];
      a.push({
        type: "attribute",
        name: m,
        action: v,
        value: l(1),
        namespace: null,
        // TODO: Add quirksMode option, which makes `ignoreCase` `true` for HTML.
        ignoreCase: n.xmlMode ? null : !1
      });
    } else if (d === "[") {
      f(1);
      var b = null;
      e.charAt(r) === "|" && (b = "", r += 1), e.startsWith("*|", r) && (b = "*", r += 2);
      var k = l(0);
      b === null && e.charAt(r) === "|" && e.charAt(r + 1) !== "=" && (b = k, k = l(1)), ((i = n.lowerCaseAttributeNames) !== null && i !== void 0 ? i : !n.xmlMode) && (k = k.toLowerCase()), f(0);
      var v = "exists", _ = Ej.get(e.charAt(r));
      if (_) {
        if (v = _, e.charAt(r + 1) !== "=")
          throw new Error("Expected `=`");
        f(2);
      } else
        e.charAt(r) === "=" && (v = "equals", f(1));
      var E = "", S = null;
      if (v !== "exists") {
        if (bd.has(e.charAt(r))) {
          for (var C = e.charAt(r), N = r + 1; N < e.length && (e.charAt(N) !== C || c(N)); )
            N += 1;
          if (e.charAt(N) !== C)
            throw new Error("Attribute value didn't end");
          E = Cl(e.slice(r + 1, N)), r = N + 1;
        } else {
          for (var $ = r; r < e.length && (!yd(e.charAt(r)) && e.charAt(r) !== "]" || c(r)); )
            r += 1;
          E = Cl(e.slice($, r));
        }
        f(0);
        var I = e.charAt(r);
        I === "s" || I === "S" ? (S = !1, f(1)) : (I === "i" || I === "I") && (S = !0, f(1));
      }
      if (n.xmlMode || (S ?? (S = Ij.has(k))), e.charAt(r) !== "]")
        throw new Error("Attribute selector didn't terminate");
      r += 1;
      var O = {
        type: "attribute",
        name: k,
        action: v,
        value: E,
        namespace: b,
        ignoreCase: S
      };
      a.push(O);
    } else if (d === ":") {
      if (e.charAt(r + 1) === ":") {
        a.push({
          type: "pseudo-element",
          name: l(2).toLowerCase()
        });
        continue;
      }
      var y = l(1).toLowerCase(), A = null;
      if (e.charAt(r) === "(")
        if (Tj.has(y)) {
          if (bd.has(e.charAt(r + 1)))
            throw new Error("Pseudo-selector " + y + " cannot be quoted");
          if (A = [], r = Rk(A, e, n, r + 1), e.charAt(r) !== ")")
            throw new Error("Missing closing parenthesis in :" + y + " (" + e + ")");
          r += 1;
        } else {
          r += 1;
          for (var z = r, F = 1; F > 0 && r < e.length; r++)
            e.charAt(r) === "(" && !c(r) ? F++ : e.charAt(r) === ")" && !c(r) && F--;
          if (F)
            throw new Error("Parenthesis not matched");
          if (A = e.slice(z, r - 1), Nj.has(y)) {
            var P = A.charAt(0);
            P === A.slice(-1) && bd.has(P) && (A = A.slice(1, -1)), A = Cl(A);
          }
        }
      a.push({ type: "pseudo", name: y, data: A });
    } else {
      var b = null, L = void 0;
      if (d === "*")
        r += 1, L = "*";
      else if (k2.test(e.slice(r)))
        e.charAt(r) === "|" && (b = "", r += 1), L = l(0);
      else
        return a.length && a[a.length - 1].type === "descendant" && a.pop(), x2(t, a), r;
      e.charAt(r) === "|" && (b = L, e.charAt(r + 1) === "*" ? (L = "*", r += 2) : L = l(1)), L === "*" ? a.push({ type: "universal", namespace: b }) : (((o = n.lowerCaseTags) !== null && o !== void 0 ? o : !n.xmlMode) && (L = L.toLowerCase()), a.push({ type: "tag", name: L, namespace: b }));
    }
  }
  return x2(t, a), r;
}
function x2(t, e) {
  if (t.length > 0 && e.length === 0)
    throw new Error("Empty sub-selector");
  t.push(e);
}
var yg = {}, E2 = Bt && Bt.__spreadArray || function(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = e.length, o; r < i; r++)
      (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
};
Object.defineProperty(yg, "__esModule", { value: !0 });
var lh = {
  equals: "",
  element: "~",
  start: "^",
  end: "$",
  any: "*",
  not: "!",
  hyphen: "|"
}, Oj = new Set(E2(E2([], Object.keys(lh).map(function(t) {
  return lh[t];
}).filter(Boolean), !0), [
  ":",
  "[",
  "]",
  " ",
  "\\",
  "(",
  ")",
  "'"
], !1));
function Lk(t) {
  return t.map(Dj).join(", ");
}
yg.default = Lk;
function Dj(t) {
  return t.map(Pj).join("");
}
function Pj(t) {
  switch (t.type) {
    case "child":
      return " > ";
    case "parent":
      return " < ";
    case "sibling":
      return " ~ ";
    case "adjacent":
      return " + ";
    case "descendant":
      return " ";
    case "universal":
      return $k(t.namespace) + "*";
    case "tag":
      return T2(t);
    case "pseudo-element":
      return "::" + $n(t.name);
    case "pseudo":
      return t.data === null ? ":" + $n(t.name) : typeof t.data == "string" ? ":" + $n(t.name) + "(" + $n(t.data) + ")" : ":" + $n(t.name) + "(" + Lk(t.data) + ")";
    case "attribute": {
      if (t.name === "id" && t.action === "equals" && !t.ignoreCase && !t.namespace)
        return "#" + $n(t.value);
      if (t.name === "class" && t.action === "element" && !t.ignoreCase && !t.namespace)
        return "." + $n(t.value);
      var e = T2(t);
      return t.action === "exists" ? "[" + e + "]" : "[" + e + lh[t.action] + "='" + $n(t.value) + "'" + (t.ignoreCase ? "i" : t.ignoreCase === !1 ? "s" : "") + "]";
    }
  }
}
function T2(t) {
  return "" + $k(t.namespace) + $n(t.name);
}
function $k(t) {
  return t !== null ? (t === "*" ? "*" : $n(t)) + "|" : "";
}
function $n(t) {
  return t.split("").map(function(e) {
    return Oj.has(e) ? "\\" + e : e;
  }).join("");
}
(function(t) {
  var e = Bt && Bt.__createBinding || (Object.create ? function(a, s, l, f) {
    f === void 0 && (f = l), Object.defineProperty(a, f, { enumerable: !0, get: function() {
      return s[l];
    } });
  } : function(a, s, l, f) {
    f === void 0 && (f = l), a[f] = s[l];
  }), n = Bt && Bt.__exportStar || function(a, s) {
    for (var l in a)
      l !== "default" && !Object.prototype.hasOwnProperty.call(s, l) && e(s, a, l);
  }, r = Bt && Bt.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.stringify = t.parse = void 0, n(zo, t);
  var i = zo;
  Object.defineProperty(t, "parse", { enumerable: !0, get: function() {
    return r(i).default;
  } });
  var o = yg;
  Object.defineProperty(t, "stringify", { enumerable: !0, get: function() {
    return r(o).default;
  } });
})(kj);
function xl() {
}
function S2() {
  return typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : Rj();
}
function Rj() {
  return {
    add: xl,
    delete: xl,
    get: xl,
    set: xl,
    has: function(t) {
      return !1;
    }
  };
}
var Lj = Object.prototype.hasOwnProperty, fh = function(t, e) {
  return Lj.call(t, e);
};
function _d(t, e) {
  for (var n in e)
    fh(e, n) && (t[n] = e[n]);
  return t;
}
var $j = /^[ \t]*(?:\r\n|\r|\n)/, Fj = /(?:\r\n|\r|\n)[ \t]*$/, jj = /^(?:[\r\n]|$)/, zj = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, Bj = /^[ \t]*[\r\n][ \t\r\n]*$/;
function I2(t, e, n) {
  var r = 0, i = t[0].match(zj);
  i && (r = i[1].length);
  var o = "(\\r\\n|\\r|\\n).{0," + r + "}", a = new RegExp(o, "g");
  e && (t = t.slice(1));
  var s = n.newline, l = n.trimLeadingNewline, f = n.trimTrailingNewline, c = typeof s == "string", u = t.length, d = t.map(function(h, p) {
    return h = h.replace(a, "$1"), p === 0 && l && (h = h.replace($j, "")), p === u - 1 && f && (h = h.replace(Fj, "")), c && (h = h.replace(/\r\n|\n|\r/g, function(m) {
      return s;
    })), h;
  });
  return d;
}
function Wj(t, e) {
  for (var n = "", r = 0, i = t.length; r < i; r++)
    n += t[r], r < i - 1 && (n += e[r]);
  return n;
}
function Uj(t) {
  return fh(t, "raw") && fh(t, "length");
}
function Fk(t) {
  var e = S2(), n = S2();
  function r(o) {
    for (var a = [], s = 1; s < arguments.length; s++)
      a[s - 1] = arguments[s];
    if (Uj(o)) {
      var l = o, f = (a[0] === r || a[0] === Jr) && Bj.test(l[0]) && jj.test(l[1]), c = f ? n : e, u = c.get(l);
      if (u || (u = I2(l, f, t), c.set(l, u)), a.length === 0)
        return u[0];
      var d = Wj(u, f ? a.slice(1) : a);
      return d;
    } else
      return Fk(_d(_d({}, t), o || {}));
  }
  var i = _d(r, {
    string: function(o) {
      return I2([o], !1, t)[0];
    }
  });
  return i;
}
var Jr = Fk({
  trimLeadingNewline: !0,
  trimTrailingNewline: !0
});
if (typeof module < "u")
  try {
    module.exports = Jr, Object.defineProperty(Jr, "__esModule", { value: !0 }), Jr.default = Jr, Jr.outdent = Jr;
  } catch {
  }
var Hj = {
  ":-moz-any-link": !0,
  ":-moz-full-screen": !0,
  ":-moz-placeholder": !0,
  ":-moz-read-only": !0,
  ":-moz-read-write": !0,
  ":-ms-fullscreen": !0,
  ":-ms-input-placeholder": !0,
  ":-webkit-any-link": !0,
  ":-webkit-full-screen": !0,
  "::-moz-placeholder": !0,
  "::-moz-progress-bar": !0,
  "::-moz-range-progress": !0,
  "::-moz-range-thumb": !0,
  "::-moz-range-track": !0,
  "::-moz-selection": !0,
  "::-ms-backdrop": !0,
  "::-ms-browse": !0,
  "::-ms-check": !0,
  "::-ms-clear": !0,
  "::-ms-fill": !0,
  "::-ms-fill-lower": !0,
  "::-ms-fill-upper": !0,
  "::-ms-reveal": !0,
  "::-ms-thumb": !0,
  "::-ms-ticks-after": !0,
  "::-ms-ticks-before": !0,
  "::-ms-tooltip": !0,
  "::-ms-track": !0,
  "::-ms-value": !0,
  "::-webkit-backdrop": !0,
  "::-webkit-input-placeholder": !0,
  "::-webkit-progress-bar": !0,
  "::-webkit-progress-inner-value": !0,
  "::-webkit-progress-value": !0,
  "::-webkit-resizer": !0,
  "::-webkit-scrollbar-button": !0,
  "::-webkit-scrollbar-corner": !0,
  "::-webkit-scrollbar-thumb": !0,
  "::-webkit-scrollbar-track-piece": !0,
  "::-webkit-scrollbar-track": !0,
  "::-webkit-scrollbar": !0,
  "::-webkit-slider-runnable-track": !0,
  "::-webkit-slider-thumb": !0,
  "::after": !0,
  "::backdrop": !0,
  "::before": !0,
  "::cue": !0,
  "::first-letter": !0,
  "::first-line": !0,
  "::grammar-error": !0,
  "::placeholder": !0,
  "::selection": !0,
  "::spelling-error": !0,
  ":active": !0,
  ":after": !0,
  ":any-link": !0,
  ":before": !0,
  ":blank": !0,
  ":checked": !0,
  ":default": !0,
  ":defined": !0,
  ":disabled": !0,
  ":empty": !0,
  ":enabled": !0,
  ":first": !0,
  ":first-child": !0,
  ":first-letter": !0,
  ":first-line": !0,
  ":first-of-type": !0,
  ":focus": !0,
  ":focus-visible": !0,
  ":focus-within": !0,
  ":fullscreen": !0,
  ":hover": !0,
  ":in-range": !0,
  ":indeterminate": !0,
  ":invalid": !0,
  ":last-child": !0,
  ":last-of-type": !0,
  ":left": !0,
  ":link": !0,
  ":only-child": !0,
  ":only-of-type": !0,
  ":optional": !0,
  ":out-of-range": !0,
  ":placeholder-shown": !0,
  ":read-only": !0,
  ":read-write": !0,
  ":required": !0,
  ":right": !0,
  ":root": !0,
  ":scope": !0,
  ":target": !0,
  ":valid": !0,
  ":visited": !0
}, Vj = Object.keys(Hj);
[...Vj];
var ch = {}, Kj = {
  get exports() {
    return ch;
  },
  set exports(t) {
    ch = t;
  }
}, wd, N2;
function Yj() {
  return N2 || (N2 = 1, wd = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  }), wd;
}
var kd, M2;
function jk() {
  if (M2)
    return kd;
  M2 = 1;
  const t = Yj(), e = {};
  for (const i of Object.keys(t))
    e[t[i]] = i;
  const n = {
    rgb: { channels: 3, labels: "rgb" },
    hsl: { channels: 3, labels: "hsl" },
    hsv: { channels: 3, labels: "hsv" },
    hwb: { channels: 3, labels: "hwb" },
    cmyk: { channels: 4, labels: "cmyk" },
    xyz: { channels: 3, labels: "xyz" },
    lab: { channels: 3, labels: "lab" },
    lch: { channels: 3, labels: "lch" },
    hex: { channels: 1, labels: ["hex"] },
    keyword: { channels: 1, labels: ["keyword"] },
    ansi16: { channels: 1, labels: ["ansi16"] },
    ansi256: { channels: 1, labels: ["ansi256"] },
    hcg: { channels: 3, labels: ["h", "c", "g"] },
    apple: { channels: 3, labels: ["r16", "g16", "b16"] },
    gray: { channels: 1, labels: ["gray"] }
  };
  kd = n;
  for (const i of Object.keys(n)) {
    if (!("channels" in n[i]))
      throw new Error("missing channels property: " + i);
    if (!("labels" in n[i]))
      throw new Error("missing channel labels property: " + i);
    if (n[i].labels.length !== n[i].channels)
      throw new Error("channel and label counts mismatch: " + i);
    const { channels: o, labels: a } = n[i];
    delete n[i].channels, delete n[i].labels, Object.defineProperty(n[i], "channels", { value: o }), Object.defineProperty(n[i], "labels", { value: a });
  }
  n.rgb.hsl = function(i) {
    const o = i[0] / 255, a = i[1] / 255, s = i[2] / 255, l = Math.min(o, a, s), f = Math.max(o, a, s), c = f - l;
    let u, d;
    f === l ? u = 0 : o === f ? u = (a - s) / c : a === f ? u = 2 + (s - o) / c : s === f && (u = 4 + (o - a) / c), u = Math.min(u * 60, 360), u < 0 && (u += 360);
    const h = (l + f) / 2;
    return f === l ? d = 0 : h <= 0.5 ? d = c / (f + l) : d = c / (2 - f - l), [u, d * 100, h * 100];
  }, n.rgb.hsv = function(i) {
    let o, a, s, l, f;
    const c = i[0] / 255, u = i[1] / 255, d = i[2] / 255, h = Math.max(c, u, d), p = h - Math.min(c, u, d), m = function(v) {
      return (h - v) / 6 / p + 1 / 2;
    };
    return p === 0 ? (l = 0, f = 0) : (f = p / h, o = m(c), a = m(u), s = m(d), c === h ? l = s - a : u === h ? l = 1 / 3 + o - s : d === h && (l = 2 / 3 + a - o), l < 0 ? l += 1 : l > 1 && (l -= 1)), [
      l * 360,
      f * 100,
      h * 100
    ];
  }, n.rgb.hwb = function(i) {
    const o = i[0], a = i[1];
    let s = i[2];
    const l = n.rgb.hsl(i)[0], f = 1 / 255 * Math.min(o, Math.min(a, s));
    return s = 1 - 1 / 255 * Math.max(o, Math.max(a, s)), [l, f * 100, s * 100];
  }, n.rgb.cmyk = function(i) {
    const o = i[0] / 255, a = i[1] / 255, s = i[2] / 255, l = Math.min(1 - o, 1 - a, 1 - s), f = (1 - o - l) / (1 - l) || 0, c = (1 - a - l) / (1 - l) || 0, u = (1 - s - l) / (1 - l) || 0;
    return [f * 100, c * 100, u * 100, l * 100];
  };
  function r(i, o) {
    return (i[0] - o[0]) ** 2 + (i[1] - o[1]) ** 2 + (i[2] - o[2]) ** 2;
  }
  return n.rgb.keyword = function(i) {
    const o = e[i];
    if (o)
      return o;
    let a = 1 / 0, s;
    for (const l of Object.keys(t)) {
      const f = t[l], c = r(i, f);
      c < a && (a = c, s = l);
    }
    return s;
  }, n.keyword.rgb = function(i) {
    return t[i];
  }, n.rgb.xyz = function(i) {
    let o = i[0] / 255, a = i[1] / 255, s = i[2] / 255;
    o = o > 0.04045 ? ((o + 0.055) / 1.055) ** 2.4 : o / 12.92, a = a > 0.04045 ? ((a + 0.055) / 1.055) ** 2.4 : a / 12.92, s = s > 0.04045 ? ((s + 0.055) / 1.055) ** 2.4 : s / 12.92;
    const l = o * 0.4124 + a * 0.3576 + s * 0.1805, f = o * 0.2126 + a * 0.7152 + s * 0.0722, c = o * 0.0193 + a * 0.1192 + s * 0.9505;
    return [l * 100, f * 100, c * 100];
  }, n.rgb.lab = function(i) {
    const o = n.rgb.xyz(i);
    let a = o[0], s = o[1], l = o[2];
    a /= 95.047, s /= 100, l /= 108.883, a = a > 8856e-6 ? a ** (1 / 3) : 7.787 * a + 16 / 116, s = s > 8856e-6 ? s ** (1 / 3) : 7.787 * s + 16 / 116, l = l > 8856e-6 ? l ** (1 / 3) : 7.787 * l + 16 / 116;
    const f = 116 * s - 16, c = 500 * (a - s), u = 200 * (s - l);
    return [f, c, u];
  }, n.hsl.rgb = function(i) {
    const o = i[0] / 360, a = i[1] / 100, s = i[2] / 100;
    let l, f, c;
    if (a === 0)
      return c = s * 255, [c, c, c];
    s < 0.5 ? l = s * (1 + a) : l = s + a - s * a;
    const u = 2 * s - l, d = [0, 0, 0];
    for (let h = 0; h < 3; h++)
      f = o + 1 / 3 * -(h - 1), f < 0 && f++, f > 1 && f--, 6 * f < 1 ? c = u + (l - u) * 6 * f : 2 * f < 1 ? c = l : 3 * f < 2 ? c = u + (l - u) * (2 / 3 - f) * 6 : c = u, d[h] = c * 255;
    return d;
  }, n.hsl.hsv = function(i) {
    const o = i[0];
    let a = i[1] / 100, s = i[2] / 100, l = a;
    const f = Math.max(s, 0.01);
    s *= 2, a *= s <= 1 ? s : 2 - s, l *= f <= 1 ? f : 2 - f;
    const c = (s + a) / 2, u = s === 0 ? 2 * l / (f + l) : 2 * a / (s + a);
    return [o, u * 100, c * 100];
  }, n.hsv.rgb = function(i) {
    const o = i[0] / 60, a = i[1] / 100;
    let s = i[2] / 100;
    const l = Math.floor(o) % 6, f = o - Math.floor(o), c = 255 * s * (1 - a), u = 255 * s * (1 - a * f), d = 255 * s * (1 - a * (1 - f));
    switch (s *= 255, l) {
      case 0:
        return [s, d, c];
      case 1:
        return [u, s, c];
      case 2:
        return [c, s, d];
      case 3:
        return [c, u, s];
      case 4:
        return [d, c, s];
      case 5:
        return [s, c, u];
    }
  }, n.hsv.hsl = function(i) {
    const o = i[0], a = i[1] / 100, s = i[2] / 100, l = Math.max(s, 0.01);
    let f, c;
    c = (2 - a) * s;
    const u = (2 - a) * l;
    return f = a * l, f /= u <= 1 ? u : 2 - u, f = f || 0, c /= 2, [o, f * 100, c * 100];
  }, n.hwb.rgb = function(i) {
    const o = i[0] / 360;
    let a = i[1] / 100, s = i[2] / 100;
    const l = a + s;
    let f;
    l > 1 && (a /= l, s /= l);
    const c = Math.floor(6 * o), u = 1 - s;
    f = 6 * o - c, c & 1 && (f = 1 - f);
    const d = a + f * (u - a);
    let h, p, m;
    switch (c) {
      default:
      case 6:
      case 0:
        h = u, p = d, m = a;
        break;
      case 1:
        h = d, p = u, m = a;
        break;
      case 2:
        h = a, p = u, m = d;
        break;
      case 3:
        h = a, p = d, m = u;
        break;
      case 4:
        h = d, p = a, m = u;
        break;
      case 5:
        h = u, p = a, m = d;
        break;
    }
    return [h * 255, p * 255, m * 255];
  }, n.cmyk.rgb = function(i) {
    const o = i[0] / 100, a = i[1] / 100, s = i[2] / 100, l = i[3] / 100, f = 1 - Math.min(1, o * (1 - l) + l), c = 1 - Math.min(1, a * (1 - l) + l), u = 1 - Math.min(1, s * (1 - l) + l);
    return [f * 255, c * 255, u * 255];
  }, n.xyz.rgb = function(i) {
    const o = i[0] / 100, a = i[1] / 100, s = i[2] / 100;
    let l, f, c;
    return l = o * 3.2406 + a * -1.5372 + s * -0.4986, f = o * -0.9689 + a * 1.8758 + s * 0.0415, c = o * 0.0557 + a * -0.204 + s * 1.057, l = l > 31308e-7 ? 1.055 * l ** (1 / 2.4) - 0.055 : l * 12.92, f = f > 31308e-7 ? 1.055 * f ** (1 / 2.4) - 0.055 : f * 12.92, c = c > 31308e-7 ? 1.055 * c ** (1 / 2.4) - 0.055 : c * 12.92, l = Math.min(Math.max(0, l), 1), f = Math.min(Math.max(0, f), 1), c = Math.min(Math.max(0, c), 1), [l * 255, f * 255, c * 255];
  }, n.xyz.lab = function(i) {
    let o = i[0], a = i[1], s = i[2];
    o /= 95.047, a /= 100, s /= 108.883, o = o > 8856e-6 ? o ** (1 / 3) : 7.787 * o + 16 / 116, a = a > 8856e-6 ? a ** (1 / 3) : 7.787 * a + 16 / 116, s = s > 8856e-6 ? s ** (1 / 3) : 7.787 * s + 16 / 116;
    const l = 116 * a - 16, f = 500 * (o - a), c = 200 * (a - s);
    return [l, f, c];
  }, n.lab.xyz = function(i) {
    const o = i[0], a = i[1], s = i[2];
    let l, f, c;
    f = (o + 16) / 116, l = a / 500 + f, c = f - s / 200;
    const u = f ** 3, d = l ** 3, h = c ** 3;
    return f = u > 8856e-6 ? u : (f - 16 / 116) / 7.787, l = d > 8856e-6 ? d : (l - 16 / 116) / 7.787, c = h > 8856e-6 ? h : (c - 16 / 116) / 7.787, l *= 95.047, f *= 100, c *= 108.883, [l, f, c];
  }, n.lab.lch = function(i) {
    const o = i[0], a = i[1], s = i[2];
    let l;
    l = Math.atan2(s, a) * 360 / 2 / Math.PI, l < 0 && (l += 360);
    const c = Math.sqrt(a * a + s * s);
    return [o, c, l];
  }, n.lch.lab = function(i) {
    const o = i[0], a = i[1], l = i[2] / 360 * 2 * Math.PI, f = a * Math.cos(l), c = a * Math.sin(l);
    return [o, f, c];
  }, n.rgb.ansi16 = function(i, o = null) {
    const [a, s, l] = i;
    let f = o === null ? n.rgb.hsv(i)[2] : o;
    if (f = Math.round(f / 50), f === 0)
      return 30;
    let c = 30 + (Math.round(l / 255) << 2 | Math.round(s / 255) << 1 | Math.round(a / 255));
    return f === 2 && (c += 60), c;
  }, n.hsv.ansi16 = function(i) {
    return n.rgb.ansi16(n.hsv.rgb(i), i[2]);
  }, n.rgb.ansi256 = function(i) {
    const o = i[0], a = i[1], s = i[2];
    return o === a && a === s ? o < 8 ? 16 : o > 248 ? 231 : Math.round((o - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(o / 255 * 5) + 6 * Math.round(a / 255 * 5) + Math.round(s / 255 * 5);
  }, n.ansi16.rgb = function(i) {
    let o = i % 10;
    if (o === 0 || o === 7)
      return i > 50 && (o += 3.5), o = o / 10.5 * 255, [o, o, o];
    const a = (~~(i > 50) + 1) * 0.5, s = (o & 1) * a * 255, l = (o >> 1 & 1) * a * 255, f = (o >> 2 & 1) * a * 255;
    return [s, l, f];
  }, n.ansi256.rgb = function(i) {
    if (i >= 232) {
      const f = (i - 232) * 10 + 8;
      return [f, f, f];
    }
    i -= 16;
    let o;
    const a = Math.floor(i / 36) / 5 * 255, s = Math.floor((o = i % 36) / 6) / 5 * 255, l = o % 6 / 5 * 255;
    return [a, s, l];
  }, n.rgb.hex = function(i) {
    const a = (((Math.round(i[0]) & 255) << 16) + ((Math.round(i[1]) & 255) << 8) + (Math.round(i[2]) & 255)).toString(16).toUpperCase();
    return "000000".substring(a.length) + a;
  }, n.hex.rgb = function(i) {
    const o = i.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!o)
      return [0, 0, 0];
    let a = o[0];
    o[0].length === 3 && (a = a.split("").map((u) => u + u).join(""));
    const s = parseInt(a, 16), l = s >> 16 & 255, f = s >> 8 & 255, c = s & 255;
    return [l, f, c];
  }, n.rgb.hcg = function(i) {
    const o = i[0] / 255, a = i[1] / 255, s = i[2] / 255, l = Math.max(Math.max(o, a), s), f = Math.min(Math.min(o, a), s), c = l - f;
    let u, d;
    return c < 1 ? u = f / (1 - c) : u = 0, c <= 0 ? d = 0 : l === o ? d = (a - s) / c % 6 : l === a ? d = 2 + (s - o) / c : d = 4 + (o - a) / c, d /= 6, d %= 1, [d * 360, c * 100, u * 100];
  }, n.hsl.hcg = function(i) {
    const o = i[1] / 100, a = i[2] / 100, s = a < 0.5 ? 2 * o * a : 2 * o * (1 - a);
    let l = 0;
    return s < 1 && (l = (a - 0.5 * s) / (1 - s)), [i[0], s * 100, l * 100];
  }, n.hsv.hcg = function(i) {
    const o = i[1] / 100, a = i[2] / 100, s = o * a;
    let l = 0;
    return s < 1 && (l = (a - s) / (1 - s)), [i[0], s * 100, l * 100];
  }, n.hcg.rgb = function(i) {
    const o = i[0] / 360, a = i[1] / 100, s = i[2] / 100;
    if (a === 0)
      return [s * 255, s * 255, s * 255];
    const l = [0, 0, 0], f = o % 1 * 6, c = f % 1, u = 1 - c;
    let d = 0;
    switch (Math.floor(f)) {
      case 0:
        l[0] = 1, l[1] = c, l[2] = 0;
        break;
      case 1:
        l[0] = u, l[1] = 1, l[2] = 0;
        break;
      case 2:
        l[0] = 0, l[1] = 1, l[2] = c;
        break;
      case 3:
        l[0] = 0, l[1] = u, l[2] = 1;
        break;
      case 4:
        l[0] = c, l[1] = 0, l[2] = 1;
        break;
      default:
        l[0] = 1, l[1] = 0, l[2] = u;
    }
    return d = (1 - a) * s, [
      (a * l[0] + d) * 255,
      (a * l[1] + d) * 255,
      (a * l[2] + d) * 255
    ];
  }, n.hcg.hsv = function(i) {
    const o = i[1] / 100, a = i[2] / 100, s = o + a * (1 - o);
    let l = 0;
    return s > 0 && (l = o / s), [i[0], l * 100, s * 100];
  }, n.hcg.hsl = function(i) {
    const o = i[1] / 100, s = i[2] / 100 * (1 - o) + 0.5 * o;
    let l = 0;
    return s > 0 && s < 0.5 ? l = o / (2 * s) : s >= 0.5 && s < 1 && (l = o / (2 * (1 - s))), [i[0], l * 100, s * 100];
  }, n.hcg.hwb = function(i) {
    const o = i[1] / 100, a = i[2] / 100, s = o + a * (1 - o);
    return [i[0], (s - o) * 100, (1 - s) * 100];
  }, n.hwb.hcg = function(i) {
    const o = i[1] / 100, s = 1 - i[2] / 100, l = s - o;
    let f = 0;
    return l < 1 && (f = (s - l) / (1 - l)), [i[0], l * 100, f * 100];
  }, n.apple.rgb = function(i) {
    return [i[0] / 65535 * 255, i[1] / 65535 * 255, i[2] / 65535 * 255];
  }, n.rgb.apple = function(i) {
    return [i[0] / 255 * 65535, i[1] / 255 * 65535, i[2] / 255 * 65535];
  }, n.gray.rgb = function(i) {
    return [i[0] / 100 * 255, i[0] / 100 * 255, i[0] / 100 * 255];
  }, n.gray.hsl = function(i) {
    return [0, 0, i[0]];
  }, n.gray.hsv = n.gray.hsl, n.gray.hwb = function(i) {
    return [0, 100, i[0]];
  }, n.gray.cmyk = function(i) {
    return [0, 0, 0, i[0]];
  }, n.gray.lab = function(i) {
    return [i[0], 0, 0];
  }, n.gray.hex = function(i) {
    const o = Math.round(i[0] / 100 * 255) & 255, s = ((o << 16) + (o << 8) + o).toString(16).toUpperCase();
    return "000000".substring(s.length) + s;
  }, n.rgb.gray = function(i) {
    return [(i[0] + i[1] + i[2]) / 3 / 255 * 100];
  }, kd;
}
var Cd, A2;
function qj() {
  if (A2)
    return Cd;
  A2 = 1;
  const t = jk();
  function e() {
    const o = {}, a = Object.keys(t);
    for (let s = a.length, l = 0; l < s; l++)
      o[a[l]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
      };
    return o;
  }
  function n(o) {
    const a = e(), s = [o];
    for (a[o].distance = 0; s.length; ) {
      const l = s.pop(), f = Object.keys(t[l]);
      for (let c = f.length, u = 0; u < c; u++) {
        const d = f[u], h = a[d];
        h.distance === -1 && (h.distance = a[l].distance + 1, h.parent = l, s.unshift(d));
      }
    }
    return a;
  }
  function r(o, a) {
    return function(s) {
      return a(o(s));
    };
  }
  function i(o, a) {
    const s = [a[o].parent, o];
    let l = t[a[o].parent][o], f = a[o].parent;
    for (; a[f].parent; )
      s.unshift(a[f].parent), l = r(t[a[f].parent][f], l), f = a[f].parent;
    return l.conversion = s, l;
  }
  return Cd = function(o) {
    const a = n(o), s = {}, l = Object.keys(a);
    for (let f = l.length, c = 0; c < f; c++) {
      const u = l[c];
      a[u].parent !== null && (s[u] = i(u, a));
    }
    return s;
  }, Cd;
}
var xd, O2;
function Gj() {
  if (O2)
    return xd;
  O2 = 1;
  const t = jk(), e = qj(), n = {}, r = Object.keys(t);
  function i(a) {
    const s = function(...l) {
      const f = l[0];
      return f == null ? f : (f.length > 1 && (l = f), a(l));
    };
    return "conversion" in a && (s.conversion = a.conversion), s;
  }
  function o(a) {
    const s = function(...l) {
      const f = l[0];
      if (f == null)
        return f;
      f.length > 1 && (l = f);
      const c = a(l);
      if (typeof c == "object")
        for (let u = c.length, d = 0; d < u; d++)
          c[d] = Math.round(c[d]);
      return c;
    };
    return "conversion" in a && (s.conversion = a.conversion), s;
  }
  return r.forEach((a) => {
    n[a] = {}, Object.defineProperty(n[a], "channels", { value: t[a].channels }), Object.defineProperty(n[a], "labels", { value: t[a].labels });
    const s = e(a);
    Object.keys(s).forEach((f) => {
      const c = s[f];
      n[a][f] = o(c), n[a][f].raw = i(c);
    });
  }), xd = n, xd;
}
(function(t) {
  const e = (c, u) => (...d) => `\x1B[${c(...d) + u}m`, n = (c, u) => (...d) => {
    const h = c(...d);
    return `\x1B[${38 + u};5;${h}m`;
  }, r = (c, u) => (...d) => {
    const h = c(...d);
    return `\x1B[${38 + u};2;${h[0]};${h[1]};${h[2]}m`;
  }, i = (c) => c, o = (c, u, d) => [c, u, d], a = (c, u, d) => {
    Object.defineProperty(c, u, {
      get: () => {
        const h = d();
        return Object.defineProperty(c, u, {
          value: h,
          enumerable: !0,
          configurable: !0
        }), h;
      },
      enumerable: !0,
      configurable: !0
    });
  };
  let s;
  const l = (c, u, d, h) => {
    s === void 0 && (s = Gj());
    const p = h ? 10 : 0, m = {};
    for (const [v, b] of Object.entries(s)) {
      const k = v === "ansi16" ? "ansi" : v;
      v === u ? m[k] = c(d, p) : typeof b == "object" && (m[k] = c(b[u], p));
    }
    return m;
  };
  function f() {
    const c = /* @__PURE__ */ new Map(), u = {
      modifier: {
        reset: [0, 0],
        // 21 isn't widely supported and 22 does the same thing
        bold: [1, 22],
        dim: [2, 22],
        italic: [3, 23],
        underline: [4, 24],
        inverse: [7, 27],
        hidden: [8, 28],
        strikethrough: [9, 29]
      },
      color: {
        black: [30, 39],
        red: [31, 39],
        green: [32, 39],
        yellow: [33, 39],
        blue: [34, 39],
        magenta: [35, 39],
        cyan: [36, 39],
        white: [37, 39],
        // Bright color
        blackBright: [90, 39],
        redBright: [91, 39],
        greenBright: [92, 39],
        yellowBright: [93, 39],
        blueBright: [94, 39],
        magentaBright: [95, 39],
        cyanBright: [96, 39],
        whiteBright: [97, 39]
      },
      bgColor: {
        bgBlack: [40, 49],
        bgRed: [41, 49],
        bgGreen: [42, 49],
        bgYellow: [43, 49],
        bgBlue: [44, 49],
        bgMagenta: [45, 49],
        bgCyan: [46, 49],
        bgWhite: [47, 49],
        // Bright color
        bgBlackBright: [100, 49],
        bgRedBright: [101, 49],
        bgGreenBright: [102, 49],
        bgYellowBright: [103, 49],
        bgBlueBright: [104, 49],
        bgMagentaBright: [105, 49],
        bgCyanBright: [106, 49],
        bgWhiteBright: [107, 49]
      }
    };
    u.color.gray = u.color.blackBright, u.bgColor.bgGray = u.bgColor.bgBlackBright, u.color.grey = u.color.blackBright, u.bgColor.bgGrey = u.bgColor.bgBlackBright;
    for (const [d, h] of Object.entries(u)) {
      for (const [p, m] of Object.entries(h))
        u[p] = {
          open: `\x1B[${m[0]}m`,
          close: `\x1B[${m[1]}m`
        }, h[p] = u[p], c.set(m[0], m[1]);
      Object.defineProperty(u, d, {
        value: h,
        enumerable: !1
      });
    }
    return Object.defineProperty(u, "codes", {
      value: c,
      enumerable: !1
    }), u.color.close = "\x1B[39m", u.bgColor.close = "\x1B[49m", a(u.color, "ansi", () => l(e, "ansi16", i, !1)), a(u.color, "ansi256", () => l(n, "ansi256", i, !1)), a(u.color, "ansi16m", () => l(r, "rgb", o, !1)), a(u.bgColor, "ansi", () => l(e, "ansi16", i, !0)), a(u.bgColor, "ansi256", () => l(n, "ansi256", i, !0)), a(u.bgColor, "ansi16m", () => l(r, "rgb", o, !0)), u;
  }
  Object.defineProperty(t, "exports", {
    enumerable: !0,
    get: f
  });
})(Kj);
var Qj = {
  stdout: !1,
  stderr: !1
};
const Xj = (t, e, n) => {
  let r = t.indexOf(e);
  if (r === -1)
    return t;
  const i = e.length;
  let o = 0, a = "";
  do
    a += t.substr(o, r - o) + e + n, o = r + i, r = t.indexOf(e, o);
  while (r !== -1);
  return a += t.substr(o), a;
}, Jj = (t, e, n, r) => {
  let i = 0, o = "";
  do {
    const a = t[r - 1] === "\r";
    o += t.substr(i, (a ? r - 1 : r) - i) + e + (a ? `\r
` : `
`) + n, i = r + 1, r = t.indexOf(`
`, i);
  } while (r !== -1);
  return o += t.substr(i), o;
};
var Zj = {
  stringReplaceAll: Xj,
  stringEncaseCRLFWithFirstIndex: Jj
}, Ed, D2;
function ez() {
  if (D2)
    return Ed;
  D2 = 1;
  const t = /(?:\\(u(?:[a-f\d]{4}|\{[a-f\d]{1,6}\})|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi, e = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g, n = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/, r = /\\(u(?:[a-f\d]{4}|{[a-f\d]{1,6}})|x[a-f\d]{2}|.)|([^\\])/gi, i = /* @__PURE__ */ new Map([
    ["n", `
`],
    ["r", "\r"],
    ["t", "	"],
    ["b", "\b"],
    ["f", "\f"],
    ["v", "\v"],
    ["0", "\0"],
    ["\\", "\\"],
    ["e", "\x1B"],
    ["a", "\x07"]
  ]);
  function o(f) {
    const c = f[0] === "u", u = f[1] === "{";
    return c && !u && f.length === 5 || f[0] === "x" && f.length === 3 ? String.fromCharCode(parseInt(f.slice(1), 16)) : c && u ? String.fromCodePoint(parseInt(f.slice(2, -1), 16)) : i.get(f) || f;
  }
  function a(f, c) {
    const u = [], d = c.trim().split(/\s*,\s*/g);
    let h;
    for (const p of d) {
      const m = Number(p);
      if (!Number.isNaN(m))
        u.push(m);
      else if (h = p.match(n))
        u.push(h[2].replace(r, (v, b, k) => b ? o(b) : k));
      else
        throw new Error(`Invalid Chalk template style argument: ${p} (in style '${f}')`);
    }
    return u;
  }
  function s(f) {
    e.lastIndex = 0;
    const c = [];
    let u;
    for (; (u = e.exec(f)) !== null; ) {
      const d = u[1];
      if (u[2]) {
        const h = a(d, u[2]);
        c.push([d].concat(h));
      } else
        c.push([d]);
    }
    return c;
  }
  function l(f, c) {
    const u = {};
    for (const h of c)
      for (const p of h.styles)
        u[p[0]] = h.inverse ? null : p.slice(1);
    let d = f;
    for (const [h, p] of Object.entries(u))
      if (Array.isArray(p)) {
        if (!(h in d))
          throw new Error(`Unknown Chalk style: ${h}`);
        d = p.length > 0 ? d[h](...p) : d[h];
      }
    return d;
  }
  return Ed = (f, c) => {
    const u = [], d = [];
    let h = [];
    if (c.replace(t, (p, m, v, b, k, _) => {
      if (m)
        h.push(o(m));
      else if (b) {
        const E = h.join("");
        h = [], d.push(u.length === 0 ? E : l(f, u)(E)), u.push({ inverse: v, styles: s(b) });
      } else if (k) {
        if (u.length === 0)
          throw new Error("Found extraneous } in Chalk template literal");
        d.push(l(f, u)(h.join(""))), h = [], u.pop();
      } else
        h.push(_);
    }), d.push(h.join("")), u.length > 0) {
      const p = `Chalk template literal is missing ${u.length} closing bracket${u.length === 1 ? "" : "s"} (\`}\`)`;
      throw new Error(p);
    }
    return d.join("");
  }, Ed;
}
const As = ch, { stdout: uh, stderr: dh } = Qj, {
  stringReplaceAll: tz,
  stringEncaseCRLFWithFirstIndex: nz
} = Zj, { isArray: Zf } = Array, zk = [
  "ansi",
  "ansi",
  "ansi256",
  "ansi16m"
], ca = /* @__PURE__ */ Object.create(null), rz = (t, e = {}) => {
  if (e.level && !(Number.isInteger(e.level) && e.level >= 0 && e.level <= 3))
    throw new Error("The `level` option should be an integer from 0 to 3");
  const n = uh ? uh.level : 0;
  t.level = e.level === void 0 ? n : e.level;
};
class iz {
  constructor(e) {
    return Bk(e);
  }
}
const Bk = (t) => {
  const e = {};
  return rz(e, t), e.template = (...n) => Uk(e.template, ...n), Object.setPrototypeOf(e, fu.prototype), Object.setPrototypeOf(e.template, e), e.template.constructor = () => {
    throw new Error("`chalk.constructor()` is deprecated. Use `new chalk.Instance()` instead.");
  }, e.template.Instance = iz, e.template;
};
function fu(t) {
  return Bk(t);
}
for (const [t, e] of Object.entries(As))
  ca[t] = {
    get() {
      const n = cu(this, _g(e.open, e.close, this._styler), this._isEmpty);
      return Object.defineProperty(this, t, { value: n }), n;
    }
  };
ca.visible = {
  get() {
    const t = cu(this, this._styler, !0);
    return Object.defineProperty(this, "visible", { value: t }), t;
  }
};
const Wk = ["rgb", "hex", "keyword", "hsl", "hsv", "hwb", "ansi", "ansi256"];
for (const t of Wk)
  ca[t] = {
    get() {
      const { level: e } = this;
      return function(...n) {
        const r = _g(As.color[zk[e]][t](...n), As.color.close, this._styler);
        return cu(this, r, this._isEmpty);
      };
    }
  };
for (const t of Wk) {
  const e = "bg" + t[0].toUpperCase() + t.slice(1);
  ca[e] = {
    get() {
      const { level: n } = this;
      return function(...r) {
        const i = _g(As.bgColor[zk[n]][t](...r), As.bgColor.close, this._styler);
        return cu(this, i, this._isEmpty);
      };
    }
  };
}
const oz = Object.defineProperties(() => {
}, {
  ...ca,
  level: {
    enumerable: !0,
    get() {
      return this._generator.level;
    },
    set(t) {
      this._generator.level = t;
    }
  }
}), _g = (t, e, n) => {
  let r, i;
  return n === void 0 ? (r = t, i = e) : (r = n.openAll + t, i = e + n.closeAll), {
    open: t,
    close: e,
    openAll: r,
    closeAll: i,
    parent: n
  };
}, cu = (t, e, n) => {
  const r = (...i) => Zf(i[0]) && Zf(i[0].raw) ? P2(r, Uk(r, ...i)) : P2(r, i.length === 1 ? "" + i[0] : i.join(" "));
  return Object.setPrototypeOf(r, oz), r._generator = t, r._styler = e, r._isEmpty = n, r;
}, P2 = (t, e) => {
  if (t.level <= 0 || !e)
    return t._isEmpty ? "" : e;
  let n = t._styler;
  if (n === void 0)
    return e;
  const { openAll: r, closeAll: i } = n;
  if (e.indexOf("\x1B") !== -1)
    for (; n !== void 0; )
      e = tz(e, n.close, n.open), n = n.parent;
  const o = e.indexOf(`
`);
  return o !== -1 && (e = nz(e, i, r, o)), r + e + i;
};
let Td;
const Uk = (t, ...e) => {
  const [n] = e;
  if (!Zf(n) || !Zf(n.raw))
    return e.join(" ");
  const r = e.slice(1), i = [n.raw[0]];
  for (let o = 1; o < n.length; o++)
    i.push(
      String(r[o - 1]).replace(/[{}\\]/g, "\\$&"),
      String(n.raw[o])
    );
  return Td === void 0 && (Td = ez()), Td(t, i.join(""));
};
Object.defineProperties(fu.prototype, ca);
const wg = fu();
wg.supportsColor = uh;
wg.stderr = fu({ level: dh ? dh.level : 0 });
wg.stderr.supportsColor = dh;
var az = function(e) {
  return sz(e) && !lz(e);
};
function sz(t) {
  return !!t && typeof t == "object";
}
function lz(t) {
  var e = Object.prototype.toString.call(t);
  return e === "[object RegExp]" || e === "[object Date]" || uz(t);
}
var fz = typeof Symbol == "function" && Symbol.for, cz = fz ? Symbol.for("react.element") : 60103;
function uz(t) {
  return t.$$typeof === cz;
}
function dz(t) {
  return Array.isArray(t) ? [] : {};
}
function Os(t, e) {
  return e.clone !== !1 && e.isMergeableObject(t) ? Bo(dz(t), t, e) : t;
}
function hz(t, e, n) {
  return t.concat(e).map(function(r) {
    return Os(r, n);
  });
}
function gz(t, e) {
  if (!e.customMerge)
    return Bo;
  var n = e.customMerge(t);
  return typeof n == "function" ? n : Bo;
}
function pz(t) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t).filter(function(e) {
    return t.propertyIsEnumerable(e);
  }) : [];
}
function R2(t) {
  return Object.keys(t).concat(pz(t));
}
function Hk(t, e) {
  try {
    return e in t;
  } catch {
    return !1;
  }
}
function mz(t, e) {
  return Hk(t, e) && !(Object.hasOwnProperty.call(t, e) && Object.propertyIsEnumerable.call(t, e));
}
function vz(t, e, n) {
  var r = {};
  return n.isMergeableObject(t) && R2(t).forEach(function(i) {
    r[i] = Os(t[i], n);
  }), R2(e).forEach(function(i) {
    mz(t, i) || (Hk(t, i) && n.isMergeableObject(e[i]) ? r[i] = gz(i, n)(t[i], e[i], n) : r[i] = Os(e[i], n));
  }), r;
}
function Bo(t, e, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || hz, n.isMergeableObject = n.isMergeableObject || az, n.cloneUnlessOtherwiseSpecified = Os;
  var r = Array.isArray(e), i = Array.isArray(t), o = r === i;
  return o ? r ? n.arrayMerge(t, e, n) : vz(t, e, n) : Os(e, n);
}
Bo.all = function(e, n) {
  if (!Array.isArray(e))
    throw new Error("first argument should be an array");
  return e.reduce(function(r, i) {
    return Bo(r, i, n);
  }, {});
};
var bz = Bo, yz = bz;
const _z = yz;
function L2() {
  for (var t = "", e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return n.reverse().forEach((i) => {
    if (t === "")
      t = String(i);
    else {
      if (typeof i != "string" || !/^var\(--.*\)$/.test(i))
        throw new Error("Invalid variable name: ".concat(i));
      t = i.replace(/\)$/, ", ".concat(t, ")"));
    }
  }), t;
}
const Vk = he.createContext(!1);
function Kk() {
  return he.useContext(Vk);
}
const Yk = he.createContext(null);
function wz() {
  const t = he.useContext(Yk);
  if (!t)
    throw new Error("useTreeContext: no treeId");
  return t;
}
function uu({
  commentId: t,
  indent: e = !1,
  ...n
}) {
  var S, C, N;
  const r = xe(), i = _t(), o = og(), a = Zi(), s = _e(), l = Yt(() => ({
    type: "comment",
    workspaceId: i,
    threadId: r,
    eventId: t,
    treeId: o
  }), [i, r, t, o]), f = vt(null), {
    ref: c
  } = _j(l), u = P4([f, c]), {
    onClick: d
  } = xk({
    workspaceId: i,
    threadId: r,
    userId: a,
    eventId: t
  }), h = Oe(($) => !!($ && $.type === "comment" && $.eventId === l.eventId && $.treeId === l.treeId), [l]), p = hn(s, "editingId", h), m = (N = (C = (S = ie(s.workspaces[i].computed)) == null ? void 0 : S[r]) == null ? void 0 : C.canonicalEvents) == null ? void 0 : N[t], v = (m == null ? void 0 : m.createdById) ?? null, {
    profiles: b
  } = ie(s), _ = !!(v ? b[v] : null), {
    events: E
  } = ke();
  return _ && v ? /* @__PURE__ */ g(Js.Provider, {
    value: l,
    children: /* @__PURE__ */ g(rg.Provider, {
      value: t,
      children: /* @__PURE__ */ g(Yk.Provider, {
        value: o,
        children: /* @__PURE__ */ g(Vk.Provider, {
          value: p,
          children: /* @__PURE__ */ g(ta.Provider, {
            value: v,
            children: /* @__PURE__ */ g("div", {
              "data-testid": "collabkit-comment-root",
              className: `${n.className ?? I3({
                indent: e
              })}`,
              onMouseOver: ($) => E.onMouseEnter($, {
                target: l
              }),
              onMouseEnter: ($) => E.onMouseEnter($, {
                target: l
              }),
              onMouseLeave: ($) => E.onMouseLeave($, {
                target: l
              }),
              onClick: d,
              ref: u,
              style: n.style,
              children: n.children
            })
          })
        })
      })
    })
  }) : null;
}
function rU(t) {
  const e = xe();
  return Dk({
    threadId: e
  }) > 0 ? /* @__PURE__ */ g("div", {
    className: XL,
    ...t
  }) : null;
}
function kz() {
  const {
    events: t
  } = ke(), e = xe(), n = _t(), i = {
    type: "commentReplyButton",
    eventId: pr(),
    threadId: e,
    workspaceId: n
  };
  return /* @__PURE__ */ D(yn, {
    children: [/* @__PURE__ */ g(_n, {
      children: /* @__PURE__ */ g(Rn, {
        onClick: (o) => t.onClick(o, {
          target: i
        }),
        "data-testid": "collabkit-comment-actions-reply-button",
        children: /* @__PURE__ */ g(fg, {
          weight: "regular"
        })
      })
    }), /* @__PURE__ */ g(wn, {
      children: "Reply"
    })]
  });
}
function qk() {
  const t = xe(), {
    computed: e
  } = ie(Gt());
  return Math.max(0, Object.keys(e[t].messageEvents).length - 1);
}
function Gk(t) {
  const {
    events: e
  } = ke(), n = xe(), r = _t(), i = pr(), o = qk(), a = {
    type: "commentSeeAllRepliesButton",
    workspaceId: r,
    threadId: n,
    eventId: i
  };
  return /* @__PURE__ */ D("div", {
    className: E3,
    onClick: (s) => e.onClick(s, {
      target: a
    }),
    ...t,
    children: [/* @__PURE__ */ g(fg, {
      weight: "regular",
      className: T3,
      color: je.color.textSecondary
    }), /* @__PURE__ */ g("span", {
      className: S3,
      children: o === 0 ? /* @__PURE__ */ g(K, {
        children: "Reply"
      }) : /* @__PURE__ */ D(K, {
        children: [o, " ", o === 1 ? "reply" : "replies"]
      })
    })]
  });
}
function Cz(t) {
  const e = qk();
  return e === 0 ? null : /* @__PURE__ */ D("div", {
    className: E3,
    ...t,
    children: [/* @__PURE__ */ g(fg, {
      weight: "regular",
      className: T3,
      color: je.color.textDisabled
    }), /* @__PURE__ */ D("span", {
      className: S3,
      children: [e, " ", e === 1 ? "reply" : "replies"]
    })]
  });
}
function xz(t) {
  const e = xe(), n = pr(), r = _t(), {
    events: i
  } = ke(), {
    attachments: o
  } = fa(), a = o ? Object.keys(o).find((d) => o[d].type === "pin") : null, s = a ? {
    id: a,
    ...o[a]
  } : null, l = _e(), f = Yt(() => s ? {
    type: "commentPin",
    threadId: e,
    eventId: n,
    workspaceId: r,
    objectId: s.objectId,
    id: s.id
  } : null, [s]), c = hn(l, "selectedId", (d) => ((d == null ? void 0 : d.type) === "pin" || (d == null ? void 0 : d.type) === "commentPin") && d.id === a), u = Oe((d) => {
    f && i.onClick(d, {
      target: f
    });
  }, [f]);
  return s ? /* @__PURE__ */ D(yn, {
    children: [/* @__PURE__ */ g(_n, {
      children: /* @__PURE__ */ g("span", {
        onClick: u,
        ...t,
        className: GL({
          isSelected: c
        }),
        children: /* @__PURE__ */ g(nj, {
          fill: c ? L2(je.comment.pin.active.color, je.color.attentionBlue) : L2(je.comment.pin.color, je.color.textPrimary)
        })
      })
    }), /* @__PURE__ */ g(wn, {
      children: "View annotation"
    })]
  }) : null;
}
function du() {
  const {
    body: t
  } = fa(), {
    callbacks: e
  } = ie(ke().store), n = !!(e != null && e.onMentionClick) || !!(e != null && e.onTimestampClick);
  return /* @__PURE__ */ g(OL, {
    className: n ? YL : qL,
    body: t
  });
}
function Qk({
  children: t
}) {
  return Kk() ? null : /* @__PURE__ */ g(K, {
    children: t
  });
}
function Xk({
  children: t
}) {
  return Kk() ? /* @__PURE__ */ g(K, {
    children: t
  }) : null;
}
function hu({
  ...t
}) {
  return /* @__PURE__ */ g("div", {
    "data-testid": "collabkit-comment-body",
    className: zL,
    ...t,
    children: t.children
  });
}
function Ez(t, e) {
  const n = /* @__PURE__ */ new Set();
  for (const r of t) {
    const i = e[r];
    i && n.add(i.name || i.email || "Anonymous");
  }
  return [...n];
}
function Tz({
  emojiU: t,
  count: e,
  userIds: n,
  disabled: r
}) {
  const {
    events: i,
    store: o
  } = ke(), {
    profiles: a
  } = ie(o), s = _t(), l = xe(), f = pr(), c = {
    type: "emoji",
    emoji: vd[t],
    workspaceId: s,
    threadId: l,
    eventId: f
  };
  return vd[t] ? /* @__PURE__ */ D(yn, {
    placement: "bottom-start",
    children: [/* @__PURE__ */ g(_n, {
      children: /* @__PURE__ */ D("div", {
        className: WL({
          disabled: !!r
        }),
        onClick: (d) => r ? null : i.onClick(d, {
          target: c
        }),
        children: [/* @__PURE__ */ g(Nk, {
          className: UL,
          emoji: vd[t]
        }), /* @__PURE__ */ g("span", {
          className: HL,
          children: e
        })]
      }, t)
    }), /* @__PURE__ */ g(wn, {
      className: VL,
      children: Ez(n, a).map((d, h) => /* @__PURE__ */ g("span", {
        children: d
      }, h))
    })]
  }) : null;
}
function Jk(t) {
  const e = Zk();
  return e ? /* @__PURE__ */ g("div", {
    "data-testid": "collabkit-comment-reactions",
    className: x3,
    ...t,
    children: e.map(({
      emojiU: n,
      count: r,
      userIds: i
    }) => /* @__PURE__ */ g(Tz, {
      emojiU: n,
      count: r,
      userIds: i,
      disabled: t.disabled
    }, n))
  }) : null;
}
function Zk() {
  var i;
  const t = xe(), e = pr(), n = (i = ie(Gt()).computed[t].reactions) == null ? void 0 : i[e], r = Object.keys(n || {});
  return n && r.length > 0 && Object.values(n).find((o) => o.count > 0) ? r.map((o) => ({
    emojiU: o,
    ...n[o]
  })) : [];
}
function kg(t) {
  return Zk().length > 0 ? /* @__PURE__ */ g("div", {
    "data-testid": "collabkit-comment-reactions",
    className: x3,
    ...t,
    children: t.children ?? /* @__PURE__ */ D(K, {
      children: [/* @__PURE__ */ g(Jk, {}), /* @__PURE__ */ g(Iz, {})]
    })
  }) : null;
}
function Sz(t) {
  const {
    body: e
  } = fa();
  return /* @__PURE__ */ g(aa, {
    "data-testid": "collabkit-comment-composer-root",
    className: BL,
    ...t,
    children: /* @__PURE__ */ D(la, {
      children: [/* @__PURE__ */ g(sa, {
        autoFocus: !0,
        initialBody: e,
        placeholder: /* @__PURE__ */ g("span", {})
      }), /* @__PURE__ */ g(lu, {})]
    })
  });
}
function gu(t) {
  const {
    createdAt: e
  } = fa();
  return /* @__PURE__ */ g(DL, {
    "data-testid": "collabkit-comment-timestamp",
    ...t,
    className: t.className ?? QL,
    timestamp: +e
  });
}
const iU = On, pu = j4;
function eC(t) {
  const {
    events: e
  } = ke(), n = pr(), r = xe(), i = _t(), o = Zi(), {
    createdById: a
  } = fa(), s = wz(), l = ie(Gt().isResolved)[r], f = Oe((d, h) => {
    e.onClick(d, {
      target: h === "reopenThreadButton" ? {
        type: h,
        threadId: r,
        workspaceId: i
      } : {
        type: h,
        eventId: n,
        threadId: r,
        workspaceId: i,
        treeId: s
      }
    });
  }, [n, r, i]), c = a === o, u = Yt(() => [c && /* @__PURE__ */ g(pd, {
    label: "Edit",
    targetType: "commentEditButton",
    "data-testid": "collabkit-comment-menu-edit-button"
  }), c && /* @__PURE__ */ g(pd, {
    label: "Delete",
    targetType: "commentDeleteButton",
    "data-testid": "collabkit-comment-menu-delete-button"
  }), l && /* @__PURE__ */ g(pd, {
    label: "Re-open",
    targetType: "reopenThreadButton",
    "data-testid": "collabkit-comment-menu-re-open-button"
  })].filter(Boolean), [l, c]);
  return u.length === 0 ? null : /* @__PURE__ */ g(U3, {
    "data-testid": "collabkit-comment-menu",
    className: t.className,
    onItemClick: f,
    context: {
      type: "comment",
      workspaceId: i,
      threadId: r,
      eventId: n,
      treeId: s
    },
    items: u,
    children: /* @__PURE__ */ g(Rn, {
      children: /* @__PURE__ */ g(o$, {
        size: 16
      })
    })
  });
}
function tC(t) {
  const e = Fi();
  return hn(_e(), "hoveringId", (r) => vc(r, e)) ? /* @__PURE__ */ g("div", {
    className: jL,
    ...t
  }) : null;
}
function Iz() {
  const t = pr(), e = xe(), n = _t(), r = og();
  return /* @__PURE__ */ D(yn, {
    children: [/* @__PURE__ */ g(_n, {
      children: /* @__PURE__ */ g(Mk, {
        target: {
          type: "commentReactionsListAddEmojiButton",
          eventId: t,
          threadId: e,
          workspaceId: n,
          treeId: r
        },
        smallIconButton: !0,
        placement: "bottom"
      })
    }), /* @__PURE__ */ g(wn, {
      children: "React"
    })]
  });
}
function nC() {
  const t = pr(), e = xe(), n = _t(), r = og();
  return /* @__PURE__ */ D(yn, {
    children: [/* @__PURE__ */ g(_n, {
      children: /* @__PURE__ */ g(Mk, {
        target: {
          type: "commentActionsEmojiButton",
          eventId: t,
          threadId: e,
          workspaceId: n,
          treeId: r
        },
        placement: "top-end"
      })
    }), /* @__PURE__ */ g(wn, {
      children: "React"
    })]
  });
}
function Cg(t) {
  return /* @__PURE__ */ g("div", {
    className: KL,
    ...t
  });
}
function rC(t) {
  const {
    events: e
  } = ke(), n = _t(), i = {
    threadId: xe(),
    workspaceId: n,
    type: "resolveThreadButton"
  };
  return /* @__PURE__ */ D(yn, {
    children: [/* @__PURE__ */ g(_n, {
      children: /* @__PURE__ */ g(Rn, {
        className: t.className,
        style: t.style,
        weight: "regular",
        onPointerDown: (o) => e.onClick(o, {
          target: i
        }),
        children: /* @__PURE__ */ g(lg, {
          size: 16,
          weight: "regular"
        })
      })
    }), /* @__PURE__ */ g(wn, {
      children: "Resolve"
    })]
  });
}
function Nz(t) {
  return /* @__PURE__ */ D(uu, {
    commentId: t.commentId,
    children: [/* @__PURE__ */ g(On, {}), /* @__PURE__ */ D("div", {
      style: {
        display: "flex",
        flexDirection: "column"
      },
      children: [/* @__PURE__ */ D(Qk, {
        children: [/* @__PURE__ */ D(Cg, {
          children: [/* @__PURE__ */ g(pu, {}), /* @__PURE__ */ g(gu, {})]
        }), /* @__PURE__ */ D(tC, {
          children: [/* @__PURE__ */ g(nC, {}), /* @__PURE__ */ g(eC, {})]
        }), /* @__PURE__ */ g(hu, {
          children: /* @__PURE__ */ g(du, {})
        }), /* @__PURE__ */ g(kg, {})]
      }), /* @__PURE__ */ g(Xk, {
        children: /* @__PURE__ */ g(Sz, {})
      })]
    })]
  });
}
var iC = Tt({ defaultClassName: "_1ecgpvg0", variantClassNames: { pointerEvents: { none: "_1ecgpvg1", all: "_1ecgpvg2" }, isSelected: { true: "_1ecgpvg3", false: "_1ecgpvg4" } }, defaultVariants: {}, compoundVariants: [] }), oC = "_1ecgpvg7", Mz = Tt({ defaultClassName: "_1ecgpvg5", variantClassNames: { isSelected: { true: "_1ecgpvg6" } }, defaultVariants: {}, compoundVariants: [] }), Az = "_1ecgpvg9", xg = "_1ecgpvg8";
function Eg(t) {
  const {
    target: e,
    targetMatchFn: n = (h) => vc(h, t.target)
  } = t, {
    store: r,
    events: i
  } = ke(), o = hn(r, "viewingId", n), a = hn(r, "previewingId", n), s = Wt((h) => {
    e && i.onPopoverContentChange({
      target: e,
      open: h
    });
  }), l = Wt((h) => {
    e && i.onPopoverPreviewChange({
      target: e,
      open: h
    });
  }), f = Wt(() => {
    e && i.onPopoverContentChange({
      target: e,
      open: !0
    });
  }), c = Wt(() => {
    e && i.onPopoverContentChange({
      target: e,
      open: !1
    });
  }), u = Wt(() => {
    e && i.onPopoverPreviewChange({
      target: e,
      open: !0
    });
  }), d = Wt(() => {
    e && i.onPopoverPreviewChange({
      target: e,
      open: !1
    });
  });
  return {
    contentVisible: o,
    previewVisible: a,
    onContentChange: s,
    onPreviewChange: l,
    showContent: f,
    hideContent: c,
    showPreview: u,
    hidePreview: d
  };
}
var Oz = "_8otv880";
var Dz = "_1cqqzoj1", Pz = "_1cqqzoj0", Rz = "_1cqqzoj2";
function Lz() {
  return /* @__PURE__ */ D("div", {
    className: Pz,
    children: [/* @__PURE__ */ g("div", {
      className: Dz
    }), /* @__PURE__ */ g("span", {
      className: Rz,
      children: "New"
    })]
  });
}
function $z() {
  const t = xe(), e = ie(Gt());
  return e == null ? void 0 : e.seen[t];
}
function Fz() {
  const t = Zi(), e = xe(), { messageEvents: n } = ie(Gt().computed)[e] ?? {}, r = $z(), [i, o] = Dt(null), a = Ak();
  return ce(() => {
    var s;
    if (t && n)
      if (!a && !i) {
        const l = ((s = n.find((f) => f.createdById !== t && f.id > r)) == null ? void 0 : s.id) ?? null;
        l && o(l);
      } else
        (i ? n.find((f) => f.id > i && f.createdById === t) : null) && o(null);
  }, [i, a, r, t, n == null ? void 0 : n.length]), i;
}
const jz = RC(function(e) {
  return /* @__PURE__ */ g(Nz, {
    commentId: e.commentId
  });
});
function aC() {
  const t = xe(), e = Gt(), {
    computed: n
  } = ie(e), {
    hasFetchedAllProfiles: r,
    messageEvents: i
  } = n[t] ?? {};
  return r ? i : [];
}
function sC(t) {
  const {
    children: e,
    ...n
  } = t, r = Fz(), o = aC().map((a) => /* @__PURE__ */ D("div", {
    style: {
      minHeight: DM
    },
    children: [r === a.id && /* @__PURE__ */ g(Lz, {}), t.renderComment ? t.renderComment({
      commentId: a.id
    }) : /* @__PURE__ */ g(jz, {
      commentId: a.id
    })]
  }, a.id));
  return /* @__PURE__ */ g("div", {
    className: Oz,
    ...n,
    children: o
  });
}
function zz({
  pin: t,
  isSelected: e
}) {
  const n = _e(), r = Hc(), {
    update: i,
    reference: o,
    floating: a,
    strategy: s,
    x: l,
    y: f
  } = jo({
    placement: "top-start",
    nodeId: r,
    middleware: [Lo(({
      rects: h
    }) => ({
      crossAxis: h.reference.width * t.x,
      mainAxis: -(h.reference.height * t.y + h.floating.height)
    }))],
    whileElementsMounted: (h, p, m) => $o(h, p, m, {
      animationFrame: !0
    })
  }), {
    dragPinObjectId: c
  } = ie(n);
  ce(() => {
    c == t.objectId && n.dragPinUpdate.push(i);
  }, [c]);
  const {
    commentables: u
  } = ie(n);
  ce(() => {
    const h = n.commentables[t.objectId];
    h && o(h.element);
  });
  const d = Yt(() => {
    const {
      x: h,
      y: p,
      createdById: m,
      ...v
    } = t;
    return {
      type: "pin",
      ...v
    };
  }, [t.id, t.objectId, t.eventId, t.workspaceId, t.threadId]);
  return ce(() => {
    if (typeof l == "number" && typeof f == "number") {
      const h = n.visiblePinPositions.findIndex((p) => p[0] === t.id);
      h !== -1 ? n.visiblePinPositions[h] = [t.id, l, f] : n.visiblePinPositions.push([t.id, l, f]);
    }
    return () => {
      const h = n.visiblePinPositions.findIndex((p) => p[0] === t.id);
      h !== -1 && n.visiblePinPositions.splice(h, 1);
    };
  }, [l, f, t.id]), u[t.objectId] ? /* @__PURE__ */ g(Js.Provider, {
    value: d,
    children: /* @__PURE__ */ g(W0, {
      id: r,
      children: /* @__PURE__ */ g(Qz, {
        isSelected: e,
        pointerEvents: "all",
        ref: a,
        style: {
          position: s,
          top: f ?? 0,
          left: l ?? 0
        },
        pin: t
      })
    })
  }) : null;
}
function Bz({
  pin: t
}) {
  const {
    events: e
  } = ke();
  return /* @__PURE__ */ g(qt, {
    children: /* @__PURE__ */ g(tr.Provider, {
      value: t.threadId,
      children: /* @__PURE__ */ g("div", {
        className: xg,
        onClick: (n) => e.onClick(n, {
          target: {
            type: "pinThreadPreview",
            threadId: t.threadId,
            workspaceId: t.workspaceId,
            objectId: t.objectId,
            eventId: t.eventId,
            id: t.id
          }
        }),
        children: /* @__PURE__ */ g(uu, {
          commentId: t.eventId,
          className: Az,
          children: /* @__PURE__ */ D("div", {
            style: {
              display: "flex",
              flexDirection: "column"
            },
            children: [/* @__PURE__ */ D(Cg, {
              children: [/* @__PURE__ */ g(pu, {}), /* @__PURE__ */ g(gu, {})]
            }), /* @__PURE__ */ g(hu, {
              children: /* @__PURE__ */ g(du, {})
            }), /* @__PURE__ */ g(kg, {
              children: /* @__PURE__ */ g(Jk, {
                disabled: !0
              })
            }), /* @__PURE__ */ g(Gk, {
              onClick: () => {
              }
            })]
          })
        })
      })
    })
  });
}
function lC(t = 1) {
  var l;
  const {
    visiblePinPositions: e,
    selectedId: n,
    pins: r
  } = ie(_e()), i = e.slice().sort((f, c) => f[2] === c[2] ? f[2] - c[2] : f[1] - c[1]), o = (n == null ? void 0 : n.type) === "pin" || (n == null ? void 0 : n.type) === "commentPin" ? i.findIndex((f) => f[0] === n.id) : -2, a = (l = i[o + t]) == null ? void 0 : l[0];
  return r.open.find((f) => f.id === a);
}
function Wz() {
  const {
    events: t
  } = ke(), e = lC(1);
  return /* @__PURE__ */ D(yn, {
    children: [/* @__PURE__ */ g(_n, {
      children: /* @__PURE__ */ g(Rn, {
        weight: "regular",
        "data-testid": "collabkit-pin-next-thread-button",
        disabled: !e,
        onClick: (n) => e ? t.onClick(n, {
          target: {
            type: "pinNextThreadIconButton",
            id: e.id,
            objectId: e.objectId,
            workspaceId: e.workspaceId,
            threadId: e.threadId,
            eventId: e.eventId
          }
        }) : null,
        children: /* @__PURE__ */ g(u$, {})
      })
    }), /* @__PURE__ */ g(wn, {
      children: "Next"
    })]
  });
}
function Uz() {
  const {
    events: t
  } = ke(), e = lC(-1);
  return /* @__PURE__ */ D(yn, {
    children: [/* @__PURE__ */ g(_n, {
      children: /* @__PURE__ */ g(Rn, {
        weight: "regular",
        "data-testid": "collabkit-pin-prev-thread-button",
        disabled: !e,
        onClick: (n) => e ? t.onClick(n, {
          target: {
            type: "pinPrevThreadIconButton",
            id: e.id,
            objectId: e.objectId,
            workspaceId: e.workspaceId,
            threadId: e.threadId,
            eventId: e.eventId
          }
        }) : null,
        children: /* @__PURE__ */ g(h$, {})
      })
    }), /* @__PURE__ */ g(wn, {
      children: "Previous"
    })]
  });
}
function Hz() {
  const {
    events: t
  } = ke(), e = _t(), n = xe();
  return /* @__PURE__ */ D(yn, {
    children: [/* @__PURE__ */ g(_n, {
      children: /* @__PURE__ */ g(Rn, {
        weight: "regular",
        "data-testid": "collabkit-pin-resolve-thread-button",
        onClick: (r) => t.onClick(r, {
          target: {
            type: "pinThreadResolveIconButton",
            workspaceId: e,
            threadId: n
          }
        }),
        children: /* @__PURE__ */ g(lg, {})
      })
    }), /* @__PURE__ */ g(wn, {
      children: "Resolve"
    })]
  });
}
function Vz() {
  const {
    events: t
  } = ke();
  return /* @__PURE__ */ D(yn, {
    children: [/* @__PURE__ */ g(_n, {
      children: /* @__PURE__ */ g(Rn, {
        weight: "regular",
        "data-testid": "collabkit-pin-close-thread-button",
        onClick: (e) => t.onClick(e, {
          target: {
            type: "pinThreadCloseIconButton"
          }
        }),
        children: /* @__PURE__ */ g(F3, {})
      })
    }), /* @__PURE__ */ g(wn, {
      children: "Close"
    })]
  });
}
function Kz(t) {
  const [e, n] = Dt("unset"), [r, i] = Dt(0);
  return Ds(() => {
    if (!t.current)
      return;
    const o = Math.round(window.innerHeight * 0.88);
    t.current.getBoundingClientRect().height > o && n(o), i(1);
    const s = new ResizeObserver((l) => {
      for (let f of l)
        if (f.contentBoxSize) {
          const c = Array.isArray(f.contentBoxSize) ? f.contentBoxSize[0] : f.contentBoxSize, u = Math.round(window.innerHeight * 0.88);
          c.blockSize > u && n(u);
        }
    });
    return s.observe(t.current), () => s.disconnect();
  }, []), {
    height: e,
    opacity: r
  };
}
function Yz({
  pin: t
}) {
  const e = _e(), n = vt(null), r = vt(null);
  ce(() => {
    fi(e, t);
  }, [e]);
  const {
    height: i,
    opacity: o
  } = Kz(n);
  return /* @__PURE__ */ g("div", {
    className: xg,
    ref: n,
    style: {
      height: i,
      opacity: o
    },
    children: /* @__PURE__ */ D(tr.Provider, {
      value: t.threadId,
      children: [/* @__PURE__ */ D("div", {
        style: {
          paddingTop: 6,
          fontSize: je.text.base.fontSize,
          paddingBottom: 6,
          paddingLeft: 8,
          paddingRight: 8,
          display: "flex",
          flex: 1,
          borderBottom: `1px solid ${je.color.border}`
        },
        children: [/* @__PURE__ */ g(Uz, {}), /* @__PURE__ */ g(Wz, {}), /* @__PURE__ */ g(Hz, {}), /* @__PURE__ */ g("div", {
          style: {
            flex: 1
          }
        }), /* @__PURE__ */ g(Vz, {})]
      }), /* @__PURE__ */ g(Ji, {
        autoScroll: "bottom",
        children: /* @__PURE__ */ g("div", {
          ref: r,
          children: /* @__PURE__ */ g(sC, {})
        })
      }), /* @__PURE__ */ g(Tk, {
        autoFocus: !0
      })]
    })
  });
}
function qz({
  pin: t
}) {
  return /* @__PURE__ */ g("div", {
    className: xg,
    children: /* @__PURE__ */ g(tr.Provider, {
      value: t.threadId,
      children: /* @__PURE__ */ g(aa, {
        className: "",
        isNewThread: !0,
        children: /* @__PURE__ */ g(la, {
          style: {
            borderRadius: 12,
            padding: je.space[1]
          },
          children: /* @__PURE__ */ g(sa, {
            autoFocus: !0,
            placeholder: /* @__PURE__ */ g(su, {
              children: "Add a comment"
            })
          })
        })
      })
    })
  });
}
const Gz = ze(function(e, n) {
  return /* @__PURE__ */ D("div", {
    onPointerDown: e.onPointerDown,
    ref: n,
    children: [/* @__PURE__ */ g(fC, {
      isSelected: e.isSelected
    }), /* @__PURE__ */ g("div", {
      className: oC,
      children: /* @__PURE__ */ g(On, {})
    })]
  });
});
function fC({
  isSelected: t
}) {
  return /* @__PURE__ */ g("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ g("path", {
      className: Mz({
        isSelected: t
      }),
      d: "M3.23745 32.6988H16.8494C21.0529 32.6988 25.0843 31.029 28.0566 28.0566C31.029 25.0843 32.6988 21.0529 32.6988 16.8494V16.8494C32.6988 14.768 32.2888 12.707 31.4923 10.7841C30.6958 8.86116 29.5284 7.11393 28.0566 5.64218C26.5849 4.17043 24.8376 3.00297 22.9147 2.20646C20.9918 1.40996 18.9308 1 16.8494 1H16.8494C14.768 1 12.707 1.40996 10.7841 2.20646C8.86115 3.00297 7.11392 4.17042 5.64217 5.64217C4.17042 7.11392 3.00297 8.86114 2.20646 10.7841C1.40996 12.707 1 14.768 1 16.8494L1 30.4613C1 31.0548 1.23573 31.6239 1.65533 32.0435C2.07494 32.4631 2.64404 32.6988 3.23745 32.6988Z",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}
const Qz = ze(function(e, n) {
  const {
    isSelected: r,
    pin: i,
    pointerEvents: o
  } = e, {
    events: a,
    store: s
  } = ke(), {
    isFigmaStyle: l
  } = ie(s), f = Fi(), c = hn(s, "editingId", (v) => (v == null ? void 0 : v.type) === "comment" && v.eventId === i.eventId), u = Oe((v) => a.onClick(v, {
    target: f
  }), [a, f]), d = Eg({
    target: f,
    targetMatchFn: (v) => !!(v && v.type === "pin" && v.id === i.id)
  }), h = !c && Wa(i, "pending") && i.pending, p = h ? null : /* @__PURE__ */ g(Bz, {
    pin: i
  }), m = h ? /* @__PURE__ */ g(qz, {
    pin: i
  }) : /* @__PURE__ */ g(Yz, {
    pin: i
  });
  return i ? /* @__PURE__ */ g(Xc, {
    profileId: i.createdById,
    children: /* @__PURE__ */ g("div", {
      className: `collabkit ${iC({
        pointerEvents: o,
        isSelected: r
      })}`,
      ref: n,
      style: e.style,
      "data-testid": "collabkit-pin-marker",
      children: /* @__PURE__ */ g("div", {
        children: /* @__PURE__ */ D(Qc, {
          ...d,
          dismissOnClickOutside: !0,
          shouldFlipToKeepInView: !0,
          children: [/* @__PURE__ */ g(qc, {
            children: /* @__PURE__ */ g(Gz, {
              onPointerDown: u,
              isSelected: r
            })
          }), /* @__PURE__ */ g(wP, {
            children: p
          }), /* @__PURE__ */ g(Gc, {
            children: l ? m : p
          })]
        })
      })
    })
  }) : null;
}), Xz = ze(function(e, n) {
  const r = Zi();
  return /* @__PURE__ */ g(Xc, {
    profileId: r,
    children: /* @__PURE__ */ D("div", {
      className: `collabkit ${iC({
        pointerEvents: "none"
      })}`,
      "data-testid": "collabkit-pin-marker",
      ref: n,
      children: [/* @__PURE__ */ g(fC, {
        isSelected: e.isSelected
      }), /* @__PURE__ */ g("div", {
        className: oC,
        children: /* @__PURE__ */ g(On, {})
      })]
    })
  });
});
function Jz(t) {
  const e = _e(), n = vt(t);
  return Oe(
    (i) => {
      n.current !== t && (delete e.commentables[n.current], n.current = t), i ? e.commentables[t] = { objectId: t, element: mc(i) } : delete e.commentables[t];
    },
    [e, t]
  );
}
function $2(t, e) {
  const n = document.elementFromPoint(e.clientX, e.clientY);
  return n == null ? null : Object.values(t.commentables).find((i) => i.element && (i.element === n || i.element.contains(n))) ?? null;
}
function oU({
  children: t,
  objectId: e
}) {
  const n = Jz(e);
  return /* @__PURE__ */ g("div", {
    ref: n,
    children: t
  });
}
function Zz(t) {
  const e = vt(null), n = vt(null), r = _e(), {
    events: i
  } = ke(), {
    uiState: o,
    workspaceId: a,
    pins: s,
    selectedId: l,
    pinsVisible: f
  } = ie(r), c = Xs();
  ce(() => {
    c && Y6(r);
  }, [c]);
  const u = Oe((p) => {
    if (!e.current || !n.current)
      return;
    e.current.style.transform = `translate(${p.clientX}px, ${p.clientY}px)`, r.clientX = p.clientX, r.clientY = p.clientY;
    const m = $2(r, p);
    if (m && m.element) {
      const {
        element: v
      } = m;
      e.current.style.opacity = "1.0";
      const {
        left: b,
        top: k,
        width: _,
        height: E
      } = v.getBoundingClientRect();
      n.current.style.left = `${b}px`, n.current.style.top = `${k}px`, n.current.style.width = `${_}px`, n.current.style.height = `${E}px`, n.current.style.display = "block";
    } else
      e.current.style.opacity = "0.4", n.current.style.display = "none";
  }, [e, r]), d = Oe((p) => {
    const m = $2(r, p);
    if (m && m.element && a) {
      const {
        x: v,
        y: b,
        width: k,
        height: _
      } = m.element.getBoundingClientRect();
      i.onClick(p, {
        target: {
          type: "overlay",
          objectId: m.objectId,
          x: (p.clientX - v) / k,
          y: (p.clientY - b) / _
        }
      });
    }
  }, [i.onClick, a]);
  if (ce(() => {
    if (o === "selecting")
      return document.body.classList.add(yv), document.addEventListener("pointermove", u), document.addEventListener("pointerdown", d), () => {
        document.body.classList.remove(yv), document.removeEventListener("pointermove", u), document.removeEventListener("pointerdown", d);
      };
  }, [o, d]), !c || o !== "selecting" && s.open.length === 0)
    return null;
  const h = f && s.open.map((p) => /* @__PURE__ */ g(zz, {
    pin: p,
    isSelected: ((l == null ? void 0 : l.type) === "pin" || (l == null ? void 0 : l.type) === "commentPin") && l.id === p.id
  }, p.id));
  return /* @__PURE__ */ g(ea, {
    id: "collabkit-floating-root",
    children: /* @__PURE__ */ g(b4, {
      children: /* @__PURE__ */ D(qt, {
        children: [o === "selecting" && /* @__PURE__ */ g("div", {
          ref: n,
          className: mP
        }), o === "selecting" && /* @__PURE__ */ g(Xz, {
          isSelected: !1,
          ref: e
        }), h]
      })
    })
  });
}
function eB(t) {
  return /* @__PURE__ */ g(fD, {
    store: t.store,
    children: /* @__PURE__ */ g(gP, {
      renderAvatar: t.renderAvatar,
      children: /* @__PURE__ */ g(hP, {
        theme: t.theme,
        children: /* @__PURE__ */ g(b4, {
          children: t.children
        })
      })
    })
  });
}
function tB({
  children: t,
  theme: e,
  renderAvatar: n,
  ...r
}) {
  const i = nB(r);
  return ce(() => {
    i && t4(i, r);
  }, [i, r]), i ? /* @__PURE__ */ D(eB, {
    store: i,
    theme: e,
    renderAvatar: n,
    children: [t, /* @__PURE__ */ g(Zz, {})]
  }) : null;
}
function aU(t) {
  return console.warn("CollabKit.Provider is deprecated, please use CollabKitProvider instead"), /* @__PURE__ */ g(tB, {
    ...t
  });
}
function nB(t) {
  const [e, n] = Dt(null);
  return ce(() => {
    const r = wM(t);
    return Z6(r), n(r), () => {
      e4(r);
    };
  }, [t.appId, "token" in t ? t.token : t.apiKey]), e;
}
var Tg = "_6tp0mr2", rB = "_6tp0mr1", iB = "_6tp0mr0";
var F2 = Tt({ defaultClassName: "_1g3jo0q1", variantClassNames: { hover: { true: "_1g3jo0q2" } }, defaultVariants: {}, compoundVariants: [] }), oB = "_1g3jo0q0";
const j2 = 4;
function aB(t) {
  const {
    hover: e,
    ...n
  } = t, r = t.users.slice(0, j2 - 1), i = t.users.length > 4 ? t.users.length - j2 : 0;
  return /* @__PURE__ */ D("div", {
    className: oB,
    ...n,
    children: [r.map((o, a) => o ? /* @__PURE__ */ g("div", {
      className: F2({
        hover: !!e
      }),
      style: {
        zIndex: 999 - a
      },
      children: /* @__PURE__ */ g(Xc, {
        profileId: o.id,
        children: /* @__PURE__ */ g(On, {
          size: t.size
        })
      })
    }, o.id) : null), i > 0 ? /* @__PURE__ */ g("div", {
      className: F2({
        hover: !!e
      }),
      style: {
        zIndex: 999 - r.length
      },
      children: /* @__PURE__ */ g(xP, {
        size: t.size,
        number: i
      })
    }) : null]
  });
}
function sB(t, e, n) {
  return n.indexOf(t) === e;
}
function lB() {
  var n;
  const t = xe(), e = Gt();
  return (n = e.timeline)[t] ?? (n[t] = {}), e.timeline[t];
}
function fB() {
  const t = ie(lB()), {
    profiles: e
  } = ie(ke().store);
  return Object.keys(t).map((r) => t[r].createdById).filter(sB).map((r) => e[r]).filter((r) => !!r);
}
function cB(t) {
  const e = fB();
  return e ? /* @__PURE__ */ g(aB, {
    users: e,
    ...t
  }) : null;
}
var uB = "fpxoy61", dB = "var(--collabkit-inbox-item-facepile-avatar-size, var(--collabkit-avatar-size))", hB = "fpxoy65", gB = "fpxoy63", pB = Tt({ defaultClassName: "fpxoy67", variantClassNames: { selected: { true: "fpxoy68" } }, defaultVariants: {}, compoundVariants: [] }), mB = "fpxoy64";
function vB(t) {
  const e = xe();
  return Dk({
    threadId: e
  }) > 0 ? /* @__PURE__ */ g("div", {
    className: mB,
    ...t
  }) : null;
}
function bB(t) {
  const { workspaceId: e, threadId: n, info: r, defaultSubscribers: i } = t, o = _e();
  ce(() => {
    if (!e)
      return;
    let a = (r == null ? void 0 : r.url) ?? window.location.href.toString();
    o.workspaces[e].pendingThreadInfo[n] = {
      url: a,
      defaultSubscribers: i,
      ...r != null && r.name ? { name: r.name } : null,
      ...r != null && r.meta ? { meta: r.meta } : null
    };
  }, [r == null ? void 0 : r.name, r == null ? void 0 : r.url, e, n, i == null ? void 0 : i.toString()]);
}
function yB(t) {
  const {
    threadId: e,
    info: n,
    defaultSubscribers: r
  } = t, i = _e(), {
    userId: o,
    workspaceId: a
  } = ie(i);
  return Ok({
    store: i,
    threadId: e,
    workspaceId: a
  }), bB({
    threadId: e,
    workspaceId: a,
    info: n,
    defaultSubscribers: r
  }), {
    userId: o,
    workspaceId: a
  };
}
const _B = /* @__PURE__ */ D("div", {
  "data-testid": "collabkit-thread-empty-state",
  className: Tg,
  children: [/* @__PURE__ */ g(sg, {
    weight: "thin",
    size: 32
  }), /* @__PURE__ */ g("span", {
    children: "No comments yet"
  })]
});
function sU() {
  return _B;
}
function wB({
  threadId: t,
  info: e,
  defaultSubscribers: n,
  showHeader: r,
  autoFocus: i,
  hideComposer: o,
  placeholder: a,
  ...s
}) {
  const {
    userId: l
  } = yB({
    threadId: t,
    info: e,
    defaultSubscribers: n,
    showHeader: r,
    autoFocus: i,
    hideComposer: o,
    placeholder: a
  });
  return /* @__PURE__ */ g(qt, {
    children: /* @__PURE__ */ g(tr.Provider, {
      value: t,
      children: /* @__PURE__ */ g(ta.Provider, {
        value: l,
        children: /* @__PURE__ */ g("div", {
          "data-testid": "collabkit-thread-root",
          className: iB,
          ...s
        })
      })
    })
  });
}
function kB(t) {
  return /* @__PURE__ */ g("div", {
    "data-testid": "collabkit-thread-header",
    className: rB,
    ...t
  });
}
function lU(t) {
  return Xs() ? /* @__PURE__ */ D(wB, {
    ...t,
    children: [t.showHeader && /* @__PURE__ */ g(kB, {
      children: "Comments"
    }), /* @__PURE__ */ g(Ji, {
      autoScroll: "bottom",
      children: /* @__PURE__ */ g(sC, {})
    }), t.hideComposer ? null : /* @__PURE__ */ g(Tk, {
      autoFocus: t.autoFocus,
      placeholder: t.placeholder
    })]
  }) : null;
}
function CB(t) {
  const e = _e(), n = Xs(), { workspaceId: r, workspaces: i } = ie(e), o = r ? i[r] : null, [a, s] = Dt(0);
  return ce(() => {
    if (!n || !r || !o)
      return;
    let l = 0;
    for (const f in o == null ? void 0 : o.timeline) {
      if (bc(e, { workspaceId: r, threadId: f }), t != null && t.threadIds && !t.threadIds.includes(f) || o.isResolved[f])
        continue;
      o.computed[f].unreadCount > 0 && l++;
    }
    s(l);
  }, [
    n,
    o,
    o == null ? void 0 : o.timeline,
    // new events
    (o && Object.keys(o == null ? void 0 : o.timeline), // seenUntilId changed
    o != null && o.seen ? Object.values(o == null ? void 0 : o.seen) : null),
    t == null ? void 0 : t.threadIds
  ]), a;
}
var xB = "_1jyufpx1", EB = "_1jyufpx0";
function Sg(t) {
  const e = t.statusFilter ?? "open", n = _e(), {
    workspaceId: r,
    workspaces: i
  } = ie(n), o = r ? i[r] : null, a = o == null ? void 0 : o.inbox, s = Xs();
  if (ce(() => {
    s && j0(n);
  }, [s]), !a || !s)
    return [];
  const f = (t.threadIds ?? Object.keys(a)).filter((c) => {
    var u;
    if (!c || e === "open" && !o.isOpen[c])
      return !1;
    if (t.commentFilter) {
      const d = (u = a[c]) == null ? void 0 : u.body;
      if (!t.commentFilter(d))
        return !1;
    }
    return !0;
  });
  return f.sort((c, u) => {
    var p, m;
    const d = +((p = a[c]) == null ? void 0 : p.createdAt), h = +((m = a[u]) == null ? void 0 : m.createdAt);
    return t.direction === "asc" ? d - h : h - d;
  }), f;
}
var TB = "_1ttpqqz2";
Tt({ defaultClassName: "_1ttpqqz3", variantClassNames: { active: { true: "_1ttpqqz4" } }, defaultVariants: {}, compoundVariants: [] });
var SB = "_1ttpqqz0", IB = "_1ttpqqz1";
function NB() {
  const {
    store: t,
    events: e
  } = ke(), n = Ek(), r = ag();
  return {
    onClick: Oe((o) => {
      var s, l;
      if (!n || !r)
        return;
      (l = (s = t.callbacks) == null ? void 0 : s.onInboxCloseButtonClick) == null || l.call(s, {
        userId: n,
        workspaceId: r
      });
      const a = {
        type: "hideSidebarButton",
        workspaceId: r
      };
      e.onClick(o, {
        target: a
      });
    }, [n, r])
  };
}
function Ig() {
  const t = _e(), {
    isSidebarOpen: e
  } = ie(t);
  return e;
}
function Ng(t) {
  const {
    onClick: e
  } = NB();
  return /* @__PURE__ */ D(yn, {
    children: [/* @__PURE__ */ g(_n, {
      children: /* @__PURE__ */ g(Rn, {
        "data-testid": "sidebar-close-button",
        onClick: e,
        style: t.style,
        children: t.children ?? /* @__PURE__ */ g(F3, {
          size: 16
        })
      })
    }), /* @__PURE__ */ g(wn, {
      children: "Close"
    })]
  });
}
function Mg(t) {
  return /* @__PURE__ */ g("div", {
    className: TB,
    ...t,
    "data-testid": "collabkit-sidebar-header",
    children: t.children
  });
}
function Ag(t) {
  return /* @__PURE__ */ g("div", {
    className: IB,
    ...t,
    "data-testid": "collabkit-sidebar-title",
    children: t.children
  });
}
function Og(t) {
  return /* @__PURE__ */ g(qt, {
    children: /* @__PURE__ */ g("div", {
      "data-testid": "collabkit-sidebar-root",
      className: SB,
      ...t
    })
  });
}
function fU(t) {
  return Ig() ? /* @__PURE__ */ g(Og, {
    ...t
  }) : null;
}
function mu({
  children: t
}) {
  return Xs() ? /* @__PURE__ */ g(K, {
    children: t
  }) : null;
}
function cU(t) {
  return /* @__PURE__ */ D("div", {
    className: Tg,
    ...t,
    children: [/* @__PURE__ */ g(sg, {
      weight: "thin",
      size: 32
    }), /* @__PURE__ */ g("span", {
      children: "No comments yet"
    })]
  });
}
function MB({
  threadId: t,
  ...e
}) {
  const n = _t(), r = _e(), i = ie(Gt()), {
    events: o
  } = ke(), a = hn(r, "selectedId", (f) => !!(f && (f.type === "thread" || f.type === "pin" || f.type === "commentPin") && f.threadId === t)), s = i == null ? void 0 : i.timeline[t], l = Object.keys(s ?? {})[0];
  return l ? /* @__PURE__ */ g(tr.Provider, {
    value: t,
    children: /* @__PURE__ */ D("div", {
      className: pB({
        selected: a
      }),
      onClick: (f) => o.onClick(f, {
        target: {
          type: "inboxItem",
          threadId: t,
          workspaceId: n
        }
      }),
      ...e,
      children: [/* @__PURE__ */ D("div", {
        className: hB,
        children: [/* @__PURE__ */ g(vB, {}), /* @__PURE__ */ g(cB, {
          size: dB
        }), /* @__PURE__ */ g("div", {
          style: {
            flex: 1
          }
        }), /* @__PURE__ */ g(rC, {})]
      }), /* @__PURE__ */ D(uu, {
        commentId: l,
        className: uB,
        children: [/* @__PURE__ */ D("div", {
          className: gB,
          children: [/* @__PURE__ */ g(pu, {}), /* @__PURE__ */ g(gu, {})]
        }), /* @__PURE__ */ g(hu, {
          children: /* @__PURE__ */ g(du, {})
        }), /* @__PURE__ */ g(Cz, {})]
      })]
    })
  }, t) : null;
}
function cC(t) {
  const e = Sg(t);
  return /* @__PURE__ */ g(K, {
    children: e.map((n) => /* @__PURE__ */ g(MB, {
      threadId: n
    }, n))
  });
}
function uC(t) {
  return /* @__PURE__ */ g(qt, {
    children: /* @__PURE__ */ g("div", {
      className: EB,
      ...t
    })
  });
}
function AB({
  commentFilter: t,
  direction: e,
  statusFilter: n,
  threadIds: r,
  ...i
}) {
  return /* @__PURE__ */ g(uC, {
    ...i,
    children: /* @__PURE__ */ g(cC, {
      commentFilter: t,
      direction: e,
      statusFilter: n,
      threadIds: r
    })
  });
}
function uU() {
  return Ig() ? /* @__PURE__ */ g(L4, {
    children: /* @__PURE__ */ g(Og, {
      children: /* @__PURE__ */ D(uC, {
        children: [/* @__PURE__ */ D(Mg, {
          children: [/* @__PURE__ */ g(Ag, {
            children: "Comments"
          }), /* @__PURE__ */ g("div", {
            style: {
              flex: 1
            }
          }), /* @__PURE__ */ g(Ng, {})]
        }), /* @__PURE__ */ g(Ji, {
          children: /* @__PURE__ */ g(cC, {})
        })]
      })
    })
  }) : null;
}
function dU() {
  const e = Eg({
    target: {
      type: "popoverInbox"
    }
  });
  return /* @__PURE__ */ g(mu, {
    children: /* @__PURE__ */ D(Qc, {
      ...e,
      placement: "bottom",
      children: [/* @__PURE__ */ g(qc, {
        children: /* @__PURE__ */ g("button", {
          children: "Comments"
        })
      }), /* @__PURE__ */ g(Q0, {
        children: /* @__PURE__ */ g(Gc, {
          children: /* @__PURE__ */ g("div", {
            className: xB,
            children: /* @__PURE__ */ g(AB, {})
          })
        })
      })]
    })
  });
}
var dC = "_1gdiiw50 _6t5ivp0 _6t5ivp1";
const hC = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjMzMzMgMy4zMzMzM0MxOC4zMzMzIDIuNDE2NjcgMTcuNTgzMyAxLjY2NjY3IDE2LjY2NjcgMS42NjY2N0gzLjMzMzMyQzIuNDE2NjYgMS42NjY2NyAxLjY2NjY2IDIuNDE2NjcgMS42NjY2NiAzLjMzMzMzVjEzLjMzMzNDMS42NjY2NiAxNC4yNSAyLjQxNjY2IDE1IDMuMzMzMzIgMTVIMTVMMTguMzMzMyAxOC4zMzMzVjMuMzMzMzNaIiBmaWxsPSIjNkE3Mjc4Ii8+Cjwvc3ZnPgo=", gC = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy4yMjc2IDEuNjY2NzVIMy4zMzMzMkMyLjQxNjY2IDEuNjY2NzUgMS42NjY2NiAyLjQxNjc1IDEuNjY2NjYgMy4zMzM0MVYxMy4zMzM0QzEuNjY2NjYgMTQuMjUwMSAyLjQxNjY2IDE1LjAwMDEgMy4zMzMzMiAxNS4wMDAxSDE1TDE4LjMzMzMgMTguMzMzNFY2Ljc3MjM5QzE3LjkxNjMgNi45MTk3OSAxNy40Njc1IDcgMTcgN0MxNC43OTA5IDcgMTMgNS4yMDkxNCAxMyAzQzEzIDIuNTMyNTIgMTMuMDgwMiAyLjA4Mzc2IDEzLjIyNzYgMS42NjY3NVoiIGZpbGw9IiM2QTcyNzgiLz4KPGNpcmNsZSBjeD0iMTciIGN5PSIzIiByPSIzIiBmaWxsPSIjRTUzRDAwIi8+Cjwvc3ZnPgo=";
function OB() {
  const { events: t } = ke();
  return {
    onClick: (e) => {
      const n = {
        type: "toggleSidebarButton"
      };
      e.button === 0 ? t.onClick(e, { target: n }) : console.error("[CollabKit] Workspace ID not found");
    }
  };
}
function pC() {
  const t = CB(), e = t > 0, {
    onClick: n
  } = OB();
  return {
    onClick: n,
    hasUnread: e,
    unreadCount: t
  };
}
function hU(t) {
  const {
    onClick: e,
    hasUnread: n
  } = pC();
  return /* @__PURE__ */ g(qt, {
    children: /* @__PURE__ */ g("button", {
      className: dC,
      onClick: e,
      children: t.children ? t.children : /* @__PURE__ */ D(K, {
        children: [n ? /* @__PURE__ */ g("img", {
          src: gC
        }) : /* @__PURE__ */ g("img", {
          src: hC
        }), "All comments"]
      })
    })
  });
}
function gU() {
  const t = xe();
  return ie(Gt()).isResolved[t] ?? !1;
}
function pU() {
  const t = _e(), e = xe(), n = _t();
  return Oe(() => {
    Pf(t, {
      workspaceId: n,
      threadId: e
    });
  }, [t, n, e]);
}
function mU() {
  var s, l;
  const { events: t, store: e } = ke(), n = xe(), r = Zi(), i = ig() ?? "default", { workspaces: o } = ie(e);
  return {
    canSend: !!((l = (s = o[r]) == null ? void 0 : s.composers[n]) != null && l[i].enabled),
    send: () => {
      t.onSend(r, n);
    }
  };
}
function vU() {
  var n;
  const t = xe(), {
    computed: e
  } = ie(Gt());
  return ((n = e[t]) == null ? void 0 : n.replyCount) ?? 0;
}
var DB = Tt({ defaultClassName: "_6t5ivp0", variantClassNames: { type: { primary: "_6t5ivp1", secondary: "_6t5ivp2" }, disabled: { true: "_6t5ivp3" } }, defaultVariants: {}, compoundVariants: [] });
function PB(t) {
  return /* @__PURE__ */ g("div", {
    className: t.className ?? DB({
      type: t.type,
      disabled: t.disabled
    }),
    role: "button",
    onClick: t.onClick,
    children: t.children
  });
}
var RB = "tg57697", LB = "tg5769d", Dg = "tg5769a _1jc8iyc8", Pg = "tg57698 _1jc8iycb", $B = "tg5769b", mC = "tg57699 _1jc8iyc4", FB = "tg57694", jB = "tg57692", zB = "tg5769h", BB = "tg57693", WB = "tg57695 _1jc8iyca", UB = Tt({ defaultClassName: "tg5769e", variantClassNames: { isSelected: { true: "tg5769f", false: "tg5769g" } }, defaultVariants: {}, compoundVariants: [] }), HB = "tg57696 _1jc8iyca", vC = "tg5769c", VB = "tg57690";
const bC = he.createContext(null);
function vu() {
  const t = KB();
  if (!t)
    throw new Error("useChannelContext must be used within a ChannelContext");
  return t;
}
function KB() {
  return he.useContext(bC);
}
var bu = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return r.map((o) => "".concat(o)).join(" ".concat(e, " ")).replace(/calc/g, "");
}, z2 = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return "calc(".concat(bu("+", ...n), ")");
}, B2 = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return "calc(".concat(bu("-", ...n), ")");
}, hh = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return "calc(".concat(bu("*", ...n), ")");
}, W2 = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return "calc(".concat(bu("/", ...n), ")");
}, U2 = (t) => hh(t, -1), Zt = Object.assign((t) => ({
  add: function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return Zt(z2(t, ...r));
  },
  subtract: function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return Zt(B2(t, ...r));
  },
  multiply: function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return Zt(hh(t, ...r));
  },
  divide: function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return Zt(W2(t, ...r));
  },
  negate: () => Zt(U2(t)),
  toString: () => t.toString()
}), {
  add: z2,
  subtract: B2,
  multiply: hh,
  divide: W2,
  negate: U2
});
function YB(t) {
  const {
    attachments: e
  } = ie(t), n = e ? Object.keys(e).find((r) => e[r].type === "pin") : null;
  return n ? {
    id: n,
    ...e[n]
  } : null;
}
const qB = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4yMDgyIDQuMjkxODVDMTEuNjU1OCAzLjczOTY4IDExLjAwMDEgMy4zMDE2NiAxMC4yNzg1IDMuMDAyNzZDOS41NTY1NSAyLjcwMzcyIDguNzgyNzYgMi41NDk4IDguMDAxMzMgMi41NDk4QzcuMjE5ODkgMi41NDk4IDYuNDQ2MTEgMi43MDM3MiA1LjcyNDE1IDMuMDAyNzZDNS4wMDIyIDMuMzAxODEgNC4zNDYyMiAzLjc0MDEyIDMuNzkzNjYgNC4yOTI2OEwzLjc5MDQ5IDQuMjk1ODVDMy4yMzk0MiA0Ljg0Nzc0IDIuODAyMjEgNS41MDI2IDIuNTAzNzQgNi4yMjMxOEMyLjIwNDcgNi45NDUxMyAyLjA1MDc4IDcuNzE4OTEgMi4wNTA3OCA4LjUwMDM1QzIuMDUwNzggOS4yODE3OCAyLjIwNDcgMTAuMDU1NiAyLjUwMzc0IDEwLjc3NzVDMi44MDI3OCAxMS40OTk1IDMuMjQxMDkgMTIuMTU1NCAzLjc5MzY1IDEyLjcwOEw3LjAwMjUxIDE1LjkxNjlDNy4yNjc0MSAxNi4xODE4IDcuNjI2NjkgMTYuMzMwNiA4LjAwMTMzIDE2LjMzMDZDOC4zNzU5NiAxNi4zMzA2IDguNzM1MjUgMTYuMTgxOCA5LjAwMDE1IDE1LjkxNjlMMTIuMjA5IDEyLjcwOEMxMy4zMjQ5IDExLjU5MjEgMTMuOTUxOSAxMC4wNzg1IDEzLjk1MTkgOC41MDAzNUMxMy45NTE5IDYuOTIyMTcgMTMuMzI0OSA1LjQwODYzIDEyLjIwOSA0LjI5MjY4TDEyLjIwODIgNC4yOTE4NVoiIGZpbGw9IiM4ODg4ODgiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjUgNS41SDcuNVY4SDVWOUg3LjVWMTEuNUg4LjVWOUgxMVY4SDguNVY1LjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K", Sd = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4yMDgyIDQuMjkxODVDMTEuNjU1OCAzLjczOTY4IDExLjAwMDEgMy4zMDE2NiAxMC4yNzg1IDMuMDAyNzZDOS41NTY1NSAyLjcwMzcyIDguNzgyNzYgMi41NDk4IDguMDAxMzMgMi41NDk4QzcuMjE5ODkgMi41NDk4IDYuNDQ2MTEgMi43MDM3MiA1LjcyNDE1IDMuMDAyNzZDNS4wMDIyIDMuMzAxODEgNC4zNDYyMiAzLjc0MDEyIDMuNzkzNjYgNC4yOTI2OEwzLjc5MDQ5IDQuMjk1ODVDMy4yMzk0MiA0Ljg0Nzc0IDIuODAyMjEgNS41MDI2IDIuNTAzNzQgNi4yMjMxOEMyLjIwNDcgNi45NDUxMyAyLjA1MDc4IDcuNzE4OTEgMi4wNTA3OCA4LjUwMDM1QzIuMDUwNzggOS4yODE3OCAyLjIwNDcgMTAuMDU1NiAyLjUwMzc0IDEwLjc3NzVDMi44MDI3OCAxMS40OTk1IDMuMjQxMDkgMTIuMTU1NCAzLjc5MzY1IDEyLjcwOEw3LjAwMjUxIDE1LjkxNjlDNy4yNjc0MSAxNi4xODE4IDcuNjI2NjkgMTYuMzMwNiA4LjAwMTMzIDE2LjMzMDZDOC4zNzU5NiAxNi4zMzA2IDguNzM1MjUgMTYuMTgxOCA5LjAwMDE1IDE1LjkxNjlMMTIuMjA5IDEyLjcwOEMxMy4zMjQ5IDExLjU5MjEgMTMuOTUxOSAxMC4wNzg1IDEzLjk1MTkgOC41MDAzNUMxMy45NTE5IDYuOTIyMTcgMTMuMzI0OSA1LjQwODYzIDEyLjIwOSA0LjI5MjY4TDEyLjIwODIgNC4yOTE4NVoiIGZpbGw9IiMzNDk0RkEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjUgNS41SDcuNVY4SDVWOUg3LjVWMTEuNUg4LjVWOUgxMVY4SDguNVY1LjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K", GB = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4yMDgyIDQuMjkxODVDMTEuNjU1OCAzLjczOTY4IDExLjAwMDEgMy4zMDE2NiAxMC4yNzg1IDMuMDAyNzZDOS41NTY1NSAyLjcwMzcyIDguNzgyNzYgMi41NDk4IDguMDAxMzMgMi41NDk4QzcuMjE5ODkgMi41NDk4IDYuNDQ2MTEgMi43MDM3MiA1LjcyNDE1IDMuMDAyNzZDNS4wMDIyIDMuMzAxODEgNC4zNDYyMiAzLjc0MDEyIDMuNzkzNjYgNC4yOTI2OEwzLjc5MDQ5IDQuMjk1ODVDMy4yMzk0MiA0Ljg0Nzc0IDIuODAyMjEgNS41MDI2IDIuNTAzNzQgNi4yMjMxOEMyLjIwNDcgNi45NDUxMyAyLjA1MDc4IDcuNzE4OTEgMi4wNTA3OCA4LjUwMDM1QzIuMDUwNzggOS4yODE3OCAyLjIwNDcgMTAuMDU1NiAyLjUwMzc0IDEwLjc3NzVDMi44MDI3OCAxMS40OTk1IDMuMjQxMDkgMTIuMTU1NCAzLjc5MzY1IDEyLjcwOEw3LjAwMjUxIDE1LjkxNjlDNy4yNjc0MSAxNi4xODE4IDcuNjI2NjkgMTYuMzMwNiA4LjAwMTMzIDE2LjMzMDZDOC4zNzU5NiAxNi4zMzA2IDguNzM1MjUgMTYuMTgxOCA5LjAwMDE1IDE1LjkxNjlMMTIuMjA5IDEyLjcwOEMxMy4zMjQ5IDExLjU5MjEgMTMuOTUxOSAxMC4wNzg1IDEzLjk1MTkgOC41MDAzNUMxMy45NTE5IDYuOTIyMTcgMTMuMzI0OSA1LjQwODYzIDEyLjIwOSA0LjI5MjY4TDEyLjIwODIgNC4yOTE4NVoiIGZpbGw9IiMyMjIyMjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljc2OTAxIDEwLjk3NDdMMTAuNDc2MSAxMC4yNjc1TDguNzA4NjEgOC41MDAwNEwxMC40NzYyIDYuNzMyNDZMOS43NjkwOCA2LjAyNTM2TDguMDAxNTEgNy43OTI5M0w2LjIzMzQ3IDYuMDI0OUw1LjUyNjM3IDYuNzMyMDFMNy4yOTQ0IDguNTAwMDRMNS41MjY0NCAxMC4yNjhMNi4yMzM1NSAxMC45NzUxTDguMDAxNSA5LjIwNzE1TDkuNzY5MDEgMTAuOTc0N1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=", QB = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4yMDgyIDQuMjkxODVDMTEuNjU1OCAzLjczOTY4IDExLjAwMDEgMy4zMDE2NiAxMC4yNzg1IDMuMDAyNzZDOS41NTY1NSAyLjcwMzcyIDguNzgyNzYgMi41NDk4IDguMDAxMzMgMi41NDk4QzcuMjE5ODkgMi41NDk4IDYuNDQ2MTEgMi43MDM3MiA1LjcyNDE1IDMuMDAyNzZDNS4wMDIyIDMuMzAxODEgNC4zNDYyMiAzLjc0MDEyIDMuNzkzNjYgNC4yOTI2OEwzLjc5MDQ5IDQuMjk1ODVDMy4yMzk0MiA0Ljg0Nzc0IDIuODAyMjEgNS41MDI2IDIuNTAzNzQgNi4yMjMxOEMyLjIwNDcgNi45NDUxMyAyLjA1MDc4IDcuNzE4OTEgMi4wNTA3OCA4LjUwMDM1QzIuMDUwNzggOS4yODE3OCAyLjIwNDcgMTAuMDU1NiAyLjUwMzc0IDEwLjc3NzVDMi44MDI3OCAxMS40OTk1IDMuMjQxMDkgMTIuMTU1NCAzLjc5MzY1IDEyLjcwOEw3LjAwMjUxIDE1LjkxNjlDNy4yNjc0MSAxNi4xODE4IDcuNjI2NjkgMTYuMzMwNiA4LjAwMTMzIDE2LjMzMDZDOC4zNzU5NiAxNi4zMzA2IDguNzM1MjUgMTYuMTgxOCA5LjAwMDE1IDE1LjkxNjlMMTIuMjA5IDEyLjcwOEMxMy4zMjQ5IDExLjU5MjEgMTMuOTUxOSAxMC4wNzg1IDEzLjk1MTkgOC41MDAzNUMxMy45NTE5IDYuOTIyMTcgMTMuMzI0OSA1LjQwODYzIDEyLjIwOSA0LjI5MjY4TDEyLjIwODIgNC4yOTE4NVoiIGZpbGw9IiMzNDk0RkEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljc2OTAxIDEwLjk3NDdMMTAuNDc2MSAxMC4yNjc1TDguNzA4NjEgOC41MDAwNEwxMC40NzYyIDYuNzMyNDZMOS43NjkwOCA2LjAyNTM2TDguMDAxNTEgNy43OTI5M0w2LjIzMzQ3IDYuMDI0OUw1LjUyNjM3IDYuNzMyMDFMNy4yOTQ0IDguNTAwMDRMNS41MjY0NCAxMC4yNjhMNi4yMzM1NSAxMC45NzUxTDguMDAxNSA5LjIwNzE1TDkuNzY5MDEgMTAuOTc0N1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
function yC() {
  return /* @__PURE__ */ D("div", {
    className: Tg,
    children: [/* @__PURE__ */ g(sg, {
      weight: "thin",
      size: 32
    }), /* @__PURE__ */ g("span", {
      children: "No comments yet"
    })]
  });
}
function _C() {
  const t = _e(), e = xe();
  return hn(t, "selectedId", (n) => ((n == null ? void 0 : n.type) === "thread" || (n == null ? void 0 : n.type) === "pin" || (n == null ? void 0 : n.type) === "comment" || (n == null ? void 0 : n.type) === "channel" || (n == null ? void 0 : n.type) === "commentPin") && n.threadId === e);
}
function Rg(t) {
  const {
    resolvedVisible: e,
    channelScrollTop: n
  } = ie(_e());
  return {
    resolvedVisible: e[t] ?? !1,
    channelScrollTop: n[t] ?? 0
  };
}
function wC(t) {
  const e = vu(), n = _e(), r = Sg({
    statusFilter: "all",
    direction: "asc"
  }), i = r.map((o) => /* @__PURE__ */ g(tr.Provider, {
    value: o,
    children: /* @__PURE__ */ g(kC, {})
  }, `inboxThread-${o}`));
  return r.length === 0 ? /* @__PURE__ */ g(yC, {}) : /* @__PURE__ */ g(Ji, {
    alignToBottom: !1,
    autoScroll: "bottom",
    onScroll: (o) => {
      n.channelScrollTop[e] = o.target.scrollTop;
    },
    children: /* @__PURE__ */ g("div", {
      className: vC,
      ...t,
      children: i
    })
  });
}
function XB(t) {
  const e = _C(), n = aC(), r = xe(), i = ie(Gt()), {
    isResolved: o
  } = i.computed[r], a = n.map((s, l) => !e && l > 0 ? null : /* @__PURE__ */ D(uu, {
    commentId: s.id,
    indent: l > 0,
    className: `${I3({
      indent: l > 0
    })}`,
    children: [/* @__PURE__ */ g(On, {}), /* @__PURE__ */ D("div", {
      style: {
        display: "flex",
        flexDirection: "column"
      },
      children: [/* @__PURE__ */ D(Qk, {
        children: [/* @__PURE__ */ D(Cg, {
          children: [/* @__PURE__ */ g(pu, {}), /* @__PURE__ */ g(gu, {}), l === 0 && o && /* @__PURE__ */ g(lg, {
            size: 14,
            className: zB
          })]
        }), /* @__PURE__ */ D(tC, {
          children: [/* @__PURE__ */ g(nC, {}), l == 0 && /* @__PURE__ */ g(kz, {}), l == 0 && !o && /* @__PURE__ */ g(rC, {}), /* @__PURE__ */ g(eC, {})]
        }), /* @__PURE__ */ D(hu, {
          children: [/* @__PURE__ */ g(xz, {}), /* @__PURE__ */ g(du, {})]
        }), /* @__PURE__ */ g(kg, {}), l == 0 && !e && /* @__PURE__ */ g(Gk, {})]
      }), /* @__PURE__ */ g(Xk, {
        children: /* @__PURE__ */ g(JB, {})
      })]
    })]
  }, `comment-${s.id}-${l}`));
  return /* @__PURE__ */ D("div", {
    className: LB,
    ...t,
    children: [/* @__PURE__ */ g("div", {
      style: {
        flex: 1
      }
    }), a]
  });
}
function JB(t) {
  const {
    body: e
  } = fa();
  return /* @__PURE__ */ g(aa, {
    "data-testid": "collabkit-comment-composer-root",
    className: RB,
    ...t,
    children: /* @__PURE__ */ D(la, {
      className: Pg,
      children: [/* @__PURE__ */ g($g, {}), /* @__PURE__ */ g(sa, {
        autoFocus: !0,
        initialBody: e,
        placeholder: /* @__PURE__ */ g("span", {}),
        contentEditable: /* @__PURE__ */ g(au, {
          className: Dg
        })
      }), /* @__PURE__ */ g("div", {}), /* @__PURE__ */ g(lu, {})]
    })
  });
}
function kC() {
  const {
    events: t
  } = ke(), e = xe(), n = vu(), r = _t(), i = ie(Gt()), o = i.timeline[e], {
    isResolved: a
  } = i.computed[e], s = vt(null), l = _C(), f = Oe((m) => {
    t.onClick(m, {
      target: {
        type: "thread",
        threadId: e,
        workspaceId: r
      }
    });
  }, [e, r, n]), {
    resolvedVisible: c
  } = Rg(n);
  if (!o || a && !c)
    return null;
  const d = Object.keys(o)[0];
  if (!d || !o[d])
    return null;
  const p = /* @__PURE__ */ D(aa, {
    className: HB,
    "data-testid": "collabkit-channel-composer-root",
    children: [/* @__PURE__ */ g(On, {}), /* @__PURE__ */ D(la, {
      className: Pg,
      children: [/* @__PURE__ */ g($g, {}), /* @__PURE__ */ g(sa, {
        autoFocus: !0,
        contentEditable: /* @__PURE__ */ g(au, {
          className: Dg
        }),
        placeholder: /* @__PURE__ */ g(su, {
          className: mC,
          children: "Reply"
        })
      }), /* @__PURE__ */ g(lu, {})]
    })]
  });
  return /* @__PURE__ */ g(tr.Provider, {
    value: e,
    children: /* @__PURE__ */ D("div", {
      className: UB({
        isSelected: l
      }),
      onClick: f,
      ref: s,
      children: [/* @__PURE__ */ g(XB, {}), l ? /* @__PURE__ */ g("div", {
        style: {
          paddingLeft: `${Zt.multiply(je.space[1], 9)}`,
          paddingBottom: je.space[2]
        },
        children: p
      }) : null]
    })
  }, `channelThread-${e}`);
}
function Lg(t) {
  const e = _e(), {
    workspaceId: n
  } = ie(e), {
    channelId: r,
    ...i
  } = t;
  return n ? /* @__PURE__ */ g(bC.Provider, {
    value: "default",
    children: /* @__PURE__ */ g("div", {
      className: BB,
      ...i,
      children: t.children
    })
  }) : null;
}
function ZB(t) {
  const {
    events: e
  } = ke(), n = vu(), {
    resolvedVisible: r
  } = Rg(n), i = Oe((a, s) => {
    e.onClick(a, {
      target: {
        type: s,
        channelId: n
      }
    });
  }, [n]), o = [/* @__PURE__ */ g(_$, {
    checked: r,
    label: "Show resolved comments",
    targetType: "channelToggleShowResolved"
  })];
  return /* @__PURE__ */ g(U3, {
    className: t.className,
    onItemClick: i,
    items: o,
    children: /* @__PURE__ */ g(Rn, {
      size: 16,
      weight: "light",
      color: je.color.textPrimary,
      children: /* @__PURE__ */ g(p$, {})
    })
  });
}
function CC(t) {
  const e = vu(), {
    channelScrollTop: n
  } = Rg(e);
  return /* @__PURE__ */ g("div", {
    className: FB,
    style: {
      borderBottom: n === 0 ? "none" : void 0
    },
    ...t,
    children: /* @__PURE__ */ g(ZB, {})
  });
}
function eW(t) {
  const e = Sg({
    statusFilter: "open",
    direction: "asc"
  }), n = e.map((r) => /* @__PURE__ */ g(tr.Provider, {
    value: r,
    children: /* @__PURE__ */ g(kC, {})
  }, `inboxThread-${r}`));
  return e.length === 0 ? /* @__PURE__ */ g(yC, {}) : /* @__PURE__ */ g("div", {
    className: vC,
    ...t,
    children: n
  });
}
const tW = {
  "pin-default": /* @__PURE__ */ g("img", {
    src: GB
  }),
  "pin-hover": /* @__PURE__ */ g("img", {
    src: QB
  }),
  "pin-selecting": /* @__PURE__ */ g("img", {
    src: Sd
  }),
  "empty-default": /* @__PURE__ */ g("img", {
    src: qB
  }),
  "empty-hover": /* @__PURE__ */ g("img", {
    src: Sd
  }),
  "empty-selecting": /* @__PURE__ */ g("img", {
    src: Sd
  })
}, nW = {
  "pin-default": "Remove pin",
  "pin-hover": "Remove pin",
  "pin-selecting": "Remove pin",
  "empty-default": "Annotate",
  "empty-hover": "Annotate",
  "empty-selecting": null
};
function $g(t) {
  const {
    events: e,
    store: n
  } = ke(), {
    uiState: r
  } = ie(n), i = _t(), o = oa(), a = xe(), s = YB(ou()), l = vt(null), f = Fi(), c = hn(n, "hoveringId", (v) => (v == null ? void 0 : v.type) === "composerPinButton" && v.eventId === o && v.threadId === a && v.workspaceId === i), u = hn(n, "composerId", (v) => (v == null ? void 0 : v.type) === "composer" && v.eventId === o && v.threadId === a && v.workspaceId === i), d = (s ? "pin" : "empty") + "-" + (u && r === "selecting" ? "selecting" : c ? "hover" : "default"), h = he.cloneElement(tW[d], {
    style: {
      position: "relative",
      top: "0px",
      width: "16px",
      height: "16px"
    }
  });
  if (f.type !== "composer")
    return null;
  const p = s ? {
    type: "composerPin",
    workspaceId: i,
    threadId: a,
    eventId: o,
    objectId: s.objectId,
    pinId: s.id
  } : {
    type: "composerPinButton",
    workspaceId: i,
    threadId: a,
    eventId: o
  }, m = nW[d];
  return /* @__PURE__ */ g("div", {
    ref: l,
    onMouseEnter: (v) => e.onMouseEnter(v, {
      target: p
    }),
    onMouseLeave: (v) => e.onMouseLeave(v, {
      target: p
    }),
    className: $B,
    onClick: (v) => e.onClick(v, {
      target: p
    }),
    "data-testid": "collabkit-composer-pin-button",
    ...t,
    children: /* @__PURE__ */ D(yn, {
      children: [/* @__PURE__ */ g(_n, {
        children: h
      }), m && /* @__PURE__ */ g(wn, {
        children: m
      })]
    })
  });
}
function Fg() {
  const t = _e(), {
    workspaceId: e,
    nextThreadId: n
  } = ie(t);
  return ce(() => {
    if (!e) {
      console.warn("ChannelNewThreadComposer: appId or workspaceId is missing");
      return;
    }
    j0(t);
  }, [e]), n ? /* @__PURE__ */ g(tr.Provider, {
    value: n,
    children: /* @__PURE__ */ D(aa, {
      className: WB,
      isNewThread: !0,
      children: [/* @__PURE__ */ g(On, {}), /* @__PURE__ */ D(la, {
        className: Pg,
        children: [/* @__PURE__ */ g($g, {}), /* @__PURE__ */ g(sa, {
          autoFocus: !1,
          contentEditable: /* @__PURE__ */ g(au, {
            className: Dg
          }),
          placeholder: /* @__PURE__ */ g(su, {
            className: mC,
            children: "Add a comment"
          })
        })]
      })]
    })
  }) : null;
}
function bU(t) {
  return /* @__PURE__ */ g(qt, {
    children: /* @__PURE__ */ g(mu, {
      children: /* @__PURE__ */ g("div", {
        className: VB,
        ...t,
        children: /* @__PURE__ */ D(Lg, {
          channelId: "default",
          children: [/* @__PURE__ */ g(CC, {}), /* @__PURE__ */ g(wC, {}), /* @__PURE__ */ g(Fg, {})]
        })
      })
    })
  });
}
function yU() {
  const e = Eg({
    target: {
      type: "popoverChannel"
    }
  });
  return /* @__PURE__ */ g(mu, {
    children: /* @__PURE__ */ D(Qc, {
      ...e,
      placement: "bottom",
      children: [/* @__PURE__ */ g(qc, {
        children: /* @__PURE__ */ g("button", {
          children: "Comments"
        })
      }), /* @__PURE__ */ g(Q0, {
        children: /* @__PURE__ */ g(Gc, {
          children: /* @__PURE__ */ g("div", {
            className: jB,
            children: /* @__PURE__ */ D(Lg, {
              channelId: "default",
              children: [/* @__PURE__ */ D(Mg, {
                children: [/* @__PURE__ */ g(Ag, {
                  children: "Comments (channel)"
                }), /* @__PURE__ */ g("div", {
                  style: {
                    flex: 1
                  }
                }), /* @__PURE__ */ g(Ng, {})]
              }), /* @__PURE__ */ g(Ji, {
                autoScroll: "bottom",
                alignToBottom: !0,
                children: /* @__PURE__ */ g(eW, {})
              }), /* @__PURE__ */ g(Fg, {})]
            })
          })
        })
      })]
    })
  });
}
function rW() {
  const {
    events: t
  } = ke(), {
    workspaceId: e
  } = ie(_e());
  return {
    onClick: (n) => {
      if (!e)
        return;
      const r = {
        type: "pinCommentButton",
        workspaceId: e
      };
      t.onClick(n, {
        target: r
      });
    }
  };
}
function _U(t) {
  const {
    onClick: e
  } = rW();
  return /* @__PURE__ */ g(qt, {
    children: /* @__PURE__ */ g(PB, {
      ...t,
      type: "primary",
      onClick: e,
      children: t.children ?? "Add Comment"
    })
  });
}
function wU(t, e) {
  return class extends he.Component {
    constructor() {
      super(...arguments);
      pa(this, "state", {
        error: void 0
      });
    }
    static getDerivedStateFromError(r) {
      return {
        error: r
      };
    }
    componentDidCatch(r, i) {
      e && e(r, i);
    }
    render() {
      return t(this.props, this.state.error);
    }
  };
}
function iW(t) {
  const {
    defaultOpen: e
  } = t, n = _e();
  ce(() => {
    e && Qa(n);
  }, [n, e]);
}
var oW = "_14sh7z10";
function kU(t) {
  const {
    defaultOpen: e,
    ...n
  } = t;
  return iW(t), Ig() ? /* @__PURE__ */ g("div", {
    className: oW,
    ...n,
    children: /* @__PURE__ */ g(qt, {
      children: /* @__PURE__ */ g(mu, {
        children: /* @__PURE__ */ g(Og, {
          children: /* @__PURE__ */ D(Lg, {
            channelId: "default",
            children: [/* @__PURE__ */ D(Mg, {
              children: [/* @__PURE__ */ g(Ag, {
                children: "Comments"
              }), /* @__PURE__ */ g("div", {
                style: {
                  flex: 1
                }
              }), /* @__PURE__ */ g(Ng, {})]
            }), /* @__PURE__ */ g(CC, {}), /* @__PURE__ */ g(wC, {}), /* @__PURE__ */ g(Fg, {})]
          })
        })
      })
    })
  }) : null;
}
function CU(t) {
  const {
    onClick: e,
    hasUnread: n
  } = pC();
  return /* @__PURE__ */ g(qt, {
    children: /* @__PURE__ */ g("button", {
      className: dC,
      ...t,
      "data-testid": "collabkit-sidebar-comments-toggle-button",
      onClick: e,
      children: t.children ?? /* @__PURE__ */ D(K, {
        children: [n ? /* @__PURE__ */ g("img", {
          src: gC
        }) : /* @__PURE__ */ g("img", {
          src: hC
        }), "Comments"]
      })
    })
  });
}
function xU() {
  const t = _e(), {
    selectedId: e,
    composerId: n,
    focusedId: r
  } = ie(t);
  return /* @__PURE__ */ D("code", {
    children: [JSON.stringify(e == null ? void 0 : e.type, null, 2), JSON.stringify(n == null ? void 0 : n.type, null, 2), JSON.stringify(r == null ? void 0 : r.type, null, 2)]
  });
}
const aW = {
  avatar: {
    size: "24px",
    fontSize: "12px",
    colors: {
      amber: "hsla(41, 95%, 69%, 1)",
      blue: "hsla(211, 93%, 64%, 1)",
      brown: "hsla(28, 34%, 56%, 1)",
      crimson: "hsla(342, 69%, 64%, 1)",
      cyan: "hsla(192, 53%, 52%, 1)",
      grass: "hsla(124, 28%, 55%, 1)",
      green: "hsla(146, 31%, 51%, 1)",
      indigo: "hsla(225, 68%, 61%, 1)",
      lime: "hsla(74, 77%, 66%, 1)",
      mint: "hsla(162, 68%, 81%, 1)",
      orange: "hsla(23, 90%, 62%, 1)",
      pink: "hsla(325, 58%, 61%, 1)",
      plum: "hsla(291, 40%, 57%, 1)",
      purple: "hsla(268, 47%, 60%, 1)",
      red: "hsla(2, 71%, 65%, 1)",
      sky: "hsla(194, 96%, 81%, 1)",
      teal: "hsla(173, 40%, 48%, 1)",
      tomato: "hsla(11, 70%, 60%, 1)",
      violet: "hsla(246, 53%, 63%, 1)",
      yellow: "hsla(52, 100%, 74%, 1)"
    }
  }
}, sW = {
  iconButton: {
    background: "initial",
    color: "initial",
    width: "initial",
    height: "initial",
    borderRadius: "initial",
    active: {
      background: "initial"
    },
    hover: {
      background: "initial"
    },
    small: {
      width: "initial",
      height: "initial"
    }
  },
  buttonGroup: {
    gap: "initial",
    padding: "initial"
  },
  button: {
    fontSize: "initial",
    lineHeight: "initial",
    fontWeight: "initial",
    letterSpacing: "initial",
    borderRadius: "initial",
    padding: "initial",
    primary: {
      color: "initial",
      background: "initial",
      letterSpacing: "initial",
      fontWeight: "initial",
      fontSize: "initial",
      lineHeight: "initial",
      active: {
        color: "initial",
        background: "initial"
      },
      hover: {
        color: "initial",
        background: "initial"
      },
      // these are unused atm
      disabled: {
        color: "initial",
        background: "initial"
      }
    },
    secondary: {
      color: "initial",
      background: "initial",
      fontWeight: "initial",
      letterSpacing: "initial",
      fontSize: "initial",
      lineHeight: "initial",
      active: {
        color: "initial",
        background: "initial"
      },
      hover: {
        color: "initial",
        background: "initial"
      },
      // these are unused atm
      disabled: {
        color: "initial",
        background: "initial"
      }
    },
    disabled: {
      color: "initial",
      background: "initial"
    }
  }
}, lW = "#DDDDDD", fW = "#F6F6F6", cW = "#FFFFFF", uW = "#EEEEEE", dW = "#3494FA", hW = "rgba(0, 0, 0, 0.04)", gW = "#E55D59", H2 = "#222222", V2 = "#A0A0A0", K2 = "#888888", pW = {
  color: {
    background: cW,
    backgroundMedium: uW,
    surface: fW,
    surfaceOverlay: hW,
    textPrimary: H2,
    textSecondary: K2,
    textDisabled: V2,
    border: lW,
    attention: gW,
    attentionBlue: dW,
    icon: H2,
    iconSecondary: K2,
    iconDisabled: V2
  }
}, mW = {
  comment: {
    paddingLeft: "initial",
    paddingRight: "initial",
    paddingTop: "initial",
    paddingBottom: "initial",
    // indent: 'initial',
    gap: "initial",
    hover: {
      background: "initial"
    },
    header: {
      gap: "initial",
      nameAndTimestamp: {
        gap: "initial",
        flexDirection: "initial"
      },
      profile: {
        gap: "initial"
      }
    },
    actions: {
      gap: "initial"
    },
    body: {
      color: "initial",
      fontSize: "initial",
      lineHeight: "initial",
      letterSpacing: "initial",
      fontWeight: "initial"
    },
    pin: {
      background: "initial",
      color: "initial",
      active: {
        background: "initial",
        color: "initial"
      }
    },
    timestamp: {
      color: "initial",
      fontSize: "initial",
      lineHeight: "initial",
      letterSpacing: "initial",
      fontWeight: "initial"
    },
    replyCountButton: {
      padding: "initial",
      borderRadius: "initial",
      background: "initial",
      border: "initial",
      hover: {
        background: "initial",
        border: "initial"
      },
      text: {
        color: "initial",
        fontSize: "initial",
        lineHeight: "initial",
        letterSpacing: "initial",
        fontWeight: "initial"
      },
      icon: {
        color: "initial",
        fontSize: "initial",
        lineHeight: "initial",
        letterSpacing: "initial",
        fontWeight: "initial"
      }
    }
  }
}, vW = {
  commentList: {
    gap: "initial",
    padding: "initial"
  }
}, bW = {
  composer: {
    border: "initial",
    padding: "initial",
    gap: "initial",
    typingIndicator: {
      color: "initial",
      fontSize: "initial",
      lineHeight: "initial",
      fontWeight: "initial",
      letterSpacing: "initial"
    },
    input: {
      caretColor: "initial",
      color: "initial",
      fontSize: "initial",
      lineHeight: "initial",
      letterSpacing: "initial",
      fontWeight: "initial",
      padding: "initial",
      background: "initial",
      border: "initial",
      borderRadius: "initial",
      hover: {
        background: "initial",
        border: "initial"
      },
      active: {
        background: "initial",
        border: "initial"
      },
      disabled: {
        background: "initial",
        border: "initial",
        color: "initial"
      },
      placeholder: {
        color: "initial"
      }
    }
  }
}, yW = {
  facepile: {
    overlap: "initial",
    avatar: {
      borderSize: "initial",
      borderColor: "initial",
      hover: {
        borderColor: "initial"
      }
    }
  }
}, _W = {
  inbox: {
    gap: "initial",
    width: "initial",
    background: "initial",
    header: {
      color: "initial",
      fontSize: "initial",
      fontWeight: "initial",
      lineHeight: "initial",
      letterSpacing: "initial"
    },
    item: {
      gap: "initial",
      paddingTop: "initial",
      paddingBottom: "initial",
      paddingLeft: "initial",
      paddingRight: "initial",
      background: "initial",
      borderBottom: "initial",
      hover: {
        background: "initial"
      },
      active: {
        background: "initial"
      },
      facepile: {
        avatar: {
          size: "initial"
        }
      },
      replyCount: {
        letterSpacing: "initial",
        fontWeight: "initial",
        color: "initial",
        fontSize: "initial",
        lineHeight: "initial"
      },
      timestamp: {
        fontWeight: "initial",
        fontSize: "initial",
        lineHeight: "initial",
        letterSpacing: "initial",
        color: "initial"
      },
      unreadDot: {
        width: "initial",
        height: "initial",
        borderRadius: "initial",
        background: "initial"
      }
    }
  }
}, wW = {
  mentions: {
    pill: {
      fontWeight: "initial",
      fontSize: "initial",
      lineHeight: "initial",
      letterSpacing: "initial",
      color: "initial",
      background: "transparent",
      borderRadius: "0px",
      padding: "0"
    },
    typeahead: {
      background: "initial",
      border: "initial",
      borderRadius: "6px",
      boxShadow: "initial",
      padding: "0",
      item: {
        fontSize: "initial",
        fontWeight: "initial",
        letterSpacing: "initial",
        lineHeight: "initial",
        padding: "initial",
        color: "initial",
        gap: "initial",
        mark: {
          color: "inherit",
          fontWeight: "initial",
          background: "transparent",
          borderRadius: "0"
        },
        active: {
          background: "initial",
          color: "initial"
        },
        nameAndEmailWrapper: {
          gap: "initial",
          flexDirection: "column"
        },
        name: {
          color: "initial",
          fontSize: "initial",
          lineHeight: "intial",
          fontWeight: "initial",
          letterSpacing: "initial"
        },
        email: {
          display: "inline",
          color: "initial",
          fontSize: "initial",
          lineHeight: "initial",
          fontWeight: "initial",
          letterSpacing: "initial"
        }
      }
    }
  }
}, kW = {
  menu: {
    background: "initial",
    border: "initial",
    borderRadius: "initial",
    boxShadow: "initial",
    item: {
      color: "initial",
      fontSize: "initial",
      fontWeight: "initial",
      letterSpacing: "initial",
      lineHeight: "initial",
      active: {
        color: "initial",
        background: "initial"
      },
      hover: {
        color: "initial",
        background: "initial"
      }
    }
  }
}, CW = {
  newIndicator: {
    color: "initial",
    fontSize: "initial",
    fontWeight: "initial",
    lineHeight: "initial",
    letterSpacing: "initial",
    inlay: {
      background: "initial"
    },
    line: {
      background: "initial"
    },
    padding: "initial",
    margin: "initial"
  }
}, xW = {
  profile: {
    gap: "initial",
    avatar: {
      borderRadius: "50%",
      fontSize: "initial",
      color: "initial",
      background: "hsl(0, 0%, 60%)",
      fontWeight: "initial"
    },
    name: {
      color: "initial",
      fontSize: "initial",
      fontWeight: "initial",
      lineHeight: "initial",
      letterSpacing: "initial"
    }
  }
}, EW = {
  pin: {
    background: "initial",
    borderColor: "initial",
    active: {
      background: "initial",
      borderColor: "initial"
    }
  }
}, TW = {
  scrollbar: {
    thumb: {
      background: "initial",
      width: "initial",
      borderRadius: "initial"
    },
    padding: "initial",
    background: "initial",
    hover: {
      background: "initial"
    },
    borderRadius: "initial"
  }
}, SW = {
  shadow: {
    standard: "0px 1px 2px rgba(0, 0, 0, 0.1)",
    high: "0px -12px 24px rgba(0, 0, 0, 0.02), 0px 12px 24px rgba(0, 0, 0, 0.06)"
  }
}, IW = {
  sidebar: {
    boxShadow: "initial",
    background: "initial",
    borderLeft: "initial",
    width: "initial",
    title: {
      fontSize: "initial",
      lineHeight: "initial",
      letterSpacing: "initial",
      color: "initial",
      fontWeight: "initial",
      paddingTop: "initial",
      paddingBottom: "initial",
      borderBottom: "initial",
      borderBottomColor: "initial"
    },
    unreadDot: {
      background: "initial"
    }
  }
}, NW = {
  space: {
    0: "0px",
    1: "4px",
    2: Zt.multiply(je.space[1], 2),
    3: Zt.multiply(je.space[1], 3),
    4: Zt.multiply(je.space[1], 4),
    5: Zt.multiply(je.space[1], 5),
    6: Zt.multiply(je.space[1], 6),
    7: Zt.multiply(je.space[1], 7),
    8: Zt.multiply(je.space[1], 8)
  }
}, MW = {
  text: {
    tiny: { fontSize: "9px", lineHeight: "11px", letterSpacing: "0px" },
    small: { fontSize: "11px", lineHeight: "13px", letterSpacing: "0px" },
    base: { fontSize: "13px", lineHeight: "18px", letterSpacing: "0px" },
    large: { fontSize: "14px", lineHeight: "17px", letterSpacing: "0px" }
  },
  fontWeight: {
    regular: "400",
    medium: "500",
    bold: "700"
  },
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
}, AW = {
  thread: {
    background: "initial",
    border: "initial",
    borderRadius: "initial",
    boxShadow: "initial",
    header: {
      color: "initial",
      fontSize: "initial",
      fontWeight: "initial",
      lineHeight: "initial",
      letterSpacing: "initial"
    }
  }
}, OW = {
  zIndex: {
    floating: "100"
  }
}, xC = {
  ...CW,
  ...pW,
  ...vW,
  ...MW,
  ...NW,
  ...sW,
  ...aW,
  ...mW,
  ...bW,
  ...yW,
  ..._W,
  ...wW,
  ...kW,
  ...EW,
  ...xW,
  ...TW,
  ...SW,
  ...IW,
  ...AW,
  ...OW
}, DW = xC, PW = "#4D4D4D", Y2 = "#2C2C2C", RW = "#222222", LW = "#4DA0F9", $W = "rgba(255, 255, 255, 0.06)", FW = "#E56865", q2 = "#FFFFFF", G2 = "#999999", Q2 = "#BBBBBB", jW = _z(xC, {
  color: {
    background: RW,
    backgroundMedium: Y2,
    surface: Y2,
    surfaceOverlay: $W,
    textPrimary: q2,
    textSecondary: Q2,
    textDisabled: G2,
    border: PW,
    attention: FW,
    attentionBlue: LW,
    icon: q2,
    iconSecondary: Q2,
    iconDisabled: G2
  },
  avatar: {
    colors: {
      amber: "hsla(41, 95%, 66%, 1)",
      blue: "hsla(211, 94%, 62%, 1)",
      brown: "hsla(28, 36%, 54%, 1)",
      crimson: "hsla(342, 70%, 62%, 1)",
      cyan: "hsla(192, 55%, 50%, 1)",
      grass: "hsla(124, 30%, 53%, 1)",
      green: "hsla(146, 34%, 49%, 1)",
      indigo: "hsla(225, 70%, 59%, 1)",
      lime: "hsla(74, 78%, 64%, 1)",
      mint: "hsla(162, 71%, 78%, 1)",
      orange: "hsla(23, 90%, 60%, 1)",
      pink: "hsla(325, 60%, 59%, 1)",
      plum: "hsla(291, 43%, 55%, 1)",
      purple: "hsla(268, 50%, 58%, 1)",
      red: "hsla(2, 73%, 62%, 1)",
      sky: "hsla(194, 96%, 78%, 1)",
      teal: "hsla(173, 45%, 46%, 1)",
      tomato: "hsla(11, 71%, 58%, 1)",
      violet: "hsla(11, 71%, 58%, 1)",
      yellow: "hsla(52, 100%, 71%, 1)"
    }
  }
}), EU = {
  LightTheme: DW,
  DarkTheme: jW
};
export {
  PB as Button,
  wU as Catch,
  bU as Channel,
  CC as ChannelFilters,
  Fg as ChannelNewThreadComposer,
  Lg as ChannelRoot,
  wC as ChannelScrollableThreadList,
  kC as ChannelThread,
  eW as ChannelThreadList,
  eB as CollabKitContextProvider,
  tB as CollabKitProvider,
  Nz as Comment,
  tC as CommentActions,
  nC as CommentActionsEmojiButton,
  kz as CommentActionsReplyButton,
  hu as CommentBody,
  iU as CommentCreatorAvatar,
  pu as CommentCreatorName,
  Sz as CommentEditor,
  Cg as CommentHeader,
  Qk as CommentHideIfEditing,
  sC as CommentList,
  du as CommentMarkdown,
  eC as CommentMenu,
  xz as CommentPin,
  kg as CommentReactions,
  Jk as CommentReactionsList,
  Iz as CommentReactionsListAddEmojiButton,
  Cz as CommentReplyCount,
  Gk as CommentReplyCountButton,
  uu as CommentRoot,
  Xk as CommentShowIfEditing,
  rC as CommentThreadResolveIconButton,
  gu as CommentTimestamp,
  rU as CommentUnreadDot,
  oU as Commentable,
  Tk as Composer,
  lu as ComposerButtons,
  au as ComposerContentEditable,
  la as ComposerEditor,
  sa as ComposerInput,
  nU as ComposerMentionsButton,
  su as ComposerPlaceholder,
  aa as ComposerRoot,
  KF as ComposerTypingIndicator,
  xU as Debug,
  AB as Inbox,
  hU as InboxButton,
  cU as InboxEmptyState,
  MB as InboxItem,
  cC as InboxItemList,
  uC as InboxRoot,
  OL as Markdown,
  _U as PinCommentButton,
  Gz as PinIcon,
  fC as PinIconSVG,
  Qz as PinMarker,
  yU as PopoverChannel,
  Gc as PopoverContent,
  dU as PopoverInbox,
  Q0 as PopoverPortal,
  wP as PopoverPreview,
  Qc as PopoverRoot,
  qc as PopoverTrigger,
  XW as Profile,
  On as ProfileAvatar,
  ta as ProfileContext,
  j4 as ProfileName,
  xP as ProfileNumberedAvatarPlaceholder,
  Xc as ProfileProvider,
  aU as Provider,
  L4 as Root,
  zz as SavedPin,
  Ji as Scrollable,
  fU as Sidebar,
  Ng as SidebarCloseButton,
  kU as SidebarComments,
  Mg as SidebarHeader,
  uU as SidebarInbox,
  Og as SidebarRoot,
  Ag as SidebarTitle,
  O4 as ThemeContext,
  hP as ThemeProvider,
  qt as ThemeWrapper,
  EU as Themes,
  lU as Thread,
  sU as ThreadEmptyState,
  cB as ThreadFacepile,
  kB as ThreadHeader,
  wB as ThreadRoot,
  vB as ThreadUnreadDot,
  CU as ToggleSidebarCommentsButton,
  yn as Tooltip,
  wn as TooltipContent,
  _n as TooltipTrigger,
  QW as actions,
  wM as createCollabKitStore,
  $2 as findCommentableElement,
  Jz as useCommentableRef,
  mU as useComposer,
  Sg as useInbox,
  Xs as useIsAuthenticated,
  gU as useIsResolved,
  rW as usePinCommentButton,
  G0 as usePopoverContext,
  vU as useReplyCount,
  pU as useResolveThread,
  pC as useSidebarCommentsButton,
  yB as useThread,
  fB as useThreadUsers,
  ij as useTooltip,
  Ik as useTooltipContext,
  Dk as useUnreadCount,
  CB as useUnreadThreadsCount
};
